import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  Upload: any;
};

export type AcceptUserInviteInput = {
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  inviteToken: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
};

export type AddJobPhaseCostsInput = {
  additionalCosts?: InputMaybe<Array<AddJobPhaseCostsInputAdditionalCosts>>;
  date: Scalars['Date'];
  employees?: InputMaybe<Array<AddJobPhaseCostsInputEmployees>>;
  equipmentPieces?: InputMaybe<Array<AddJobPhaseCostsInputEquipmentPieces>>;
  jobPhaseId: Scalars['ID'];
  materialNeeded?: InputMaybe<Scalars['Float']>;
  transferTrucks?: InputMaybe<Array<AddJobPhaseCostsInputTransferTrucks>>;
};

export type AddJobPhaseCostsInputAdditionalCosts = {
  feeAmount: Scalars['Float'];
  id: Scalars['ID'];
};

export type AddJobPhaseCostsInputEmployees = {
  id: Scalars['ID'];
  timeOnjob: Scalars['Float'];
  timeTravel: Scalars['Float'];
};

export type AddJobPhaseCostsInputEquipmentPieces = {
  id: Scalars['ID'];
  quantity: Scalars['Int'];
  timeOnjob: Scalars['Float'];
  timeTravel: Scalars['Float'];
};

export type AddJobPhaseCostsInputTransferTrucks = {
  hours: Scalars['Float'];
  id: Scalars['ID'];
};

export type AddJobPhaseScheduleBlock = {
  blockLength: Scalars['Float'];
  scheduledAt: Scalars['DateTime'];
  showTravelFrom: Scalars['Boolean'];
  showTravelTo: Scalars['Boolean'];
};

export type AddOrganizationDataUploadInput = {
  path: Scalars['String'];
  type: OrganizationDataUploadType | `${OrganizationDataUploadType}`;
};

export type AddProposalAddressInput = {
  addressCity?: InputMaybe<Scalars['String']>;
  addressCountry?: InputMaybe<Scalars['String']>;
  addressLine1: Scalars['String'];
  addressLine2?: InputMaybe<Scalars['String']>;
  addressState?: InputMaybe<Scalars['String']>;
  addressZip?: InputMaybe<Scalars['String']>;
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  proposalStageId: Scalars['ID'];
};

export type AddProposalEquipmentPieceInput = {
  id: Scalars['ID'];
  quantity: Scalars['Int'];
};

export type AddTruckToProposalProductInput = {
  costOverride?: InputMaybe<Scalars['Float']>;
  proposalProductId: Scalars['ID'];
  quantity: Scalars['Float'];
  rate?: InputMaybe<Scalars['Float']>;
  totalHaulingHoursOverride?: InputMaybe<Scalars['Float']>;
  transferTruckId: Scalars['ID'];
  truckingProductionRate: Scalars['Float'];
};

export type AdditionalCost = {
  __typename?: 'AdditionalCost';
  cost: Scalars['Int'];
  feeAmount: Scalars['Float'];
  feeType: AdditionalCostFeeType | `${AdditionalCostFeeType}`;
  id: Scalars['ID'];
  name: Scalars['String'];
  /** @deprecated No longer supported */
  pivot?: Maybe<ProductAdditionalCostPivot>;
};

export enum AdditionalCostFeeType {
  /** Flat */
  FLAT = 'FLAT',
  /** Job cost */
  JOB_COST = 'JOB_COST',
  /** Job length */
  JOB_LENGTH = 'JOB_LENGTH',
  /** Job size */
  JOB_SIZE = 'JOB_SIZE',
  /** Materials */
  MATERIALS = 'MATERIALS'
}

/** A paginated list of AdditionalCost items. */
export type AdditionalCostPaginator = {
  __typename?: 'AdditionalCostPaginator';
  /** A list of AdditionalCost items. */
  data: Array<AdditionalCost>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type CancelProposalResponse = {
  __typename?: 'CancelProposalResponse';
  newProposal?: Maybe<Proposal>;
  proposal: Proposal;
};

export type Company = {
  __typename?: 'Company';
  addCompanyInfo?: Maybe<Scalars['Boolean']>;
  addressCity?: Maybe<Scalars['String']>;
  addressCountry?: Maybe<Scalars['String']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  addressState?: Maybe<Scalars['String']>;
  addressZip?: Maybe<Scalars['String']>;
  contacts: Array<Contact>;
  email: Scalars['String'];
  id: Scalars['ID'];
  jobsCount?: Maybe<Scalars['Int']>;
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  notificationTypes?: Maybe<NotificationTypeOptions>;
  phone?: Maybe<Scalars['String']>;
  primaryContact?: Maybe<Contact>;
  projectFilesFolderId?: Maybe<Scalars['ID']>;
  proposalsCount?: Maybe<Scalars['Int']>;
  status: CompanyStatus | `${CompanyStatus}`;
  website?: Maybe<Scalars['String']>;
};

export type CompanyContactHasMany = {
  create: Array<InputMaybe<CreateCompanyContactInput>>;
};

/** A paginated list of Company items. */
export type CompanyPaginator = {
  __typename?: 'CompanyPaginator';
  /** A list of Company items. */
  data: Array<Company>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum CompanyStatus {
  /** Customer */
  CUSTOMER = 'CUSTOMER',
  /** Proposal requested */
  PROPOSAL_REQUESTED = 'PROPOSAL_REQUESTED',
  /** Proposal sent */
  PROPOSAL_SENT = 'PROPOSAL_SENT',
  /** Prospect */
  PROSPECT = 'PROSPECT'
}

export type ConnectPlantTransferTruckInput = {
  id: Scalars['ID'];
  rateHourly?: InputMaybe<Scalars['Int']>;
  rateTon?: InputMaybe<Scalars['Int']>;
  tonnage: Scalars['Int'];
};

export type Contact = {
  __typename?: 'Contact';
  SMSNotifications?: Maybe<Scalars['Boolean']>;
  SMSNotificationsReadOnly?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  primary: Scalars['Boolean'];
  role?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type CreateAdditionalCostInput = {
  cost: Scalars['Int'];
  feeAmount: Scalars['Float'];
  feeType: AdditionalCostFeeType | `${AdditionalCostFeeType}`;
  name: Scalars['String'];
};

export type CreateCompanyContactInput = {
  SMSNotifications: Scalars['Boolean'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  primary: Scalars['Boolean'];
  role?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type CreateCompanyInput = {
  addCompanyInfo?: InputMaybe<Scalars['Boolean']>;
  addressCity?: InputMaybe<Scalars['String']>;
  addressCountry?: InputMaybe<Scalars['String']>;
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  addressState?: InputMaybe<Scalars['String']>;
  addressZip?: InputMaybe<Scalars['String']>;
  contacts: CompanyContactHasMany;
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notificationTypes?: InputMaybe<NotificationTypeInput>;
  phone?: InputMaybe<Scalars['String']>;
  primaryContact: CreateCompanyContactInput;
  projectFilesFolderId?: InputMaybe<Scalars['ID']>;
  status: CompanyStatus | `${CompanyStatus}`;
};

export type CreateCrewInput = {
  color: Scalars['String'];
  displayName?: InputMaybe<Scalars['String']>;
  employees?: InputMaybe<UpsertEmployeeCrewBelongsToMany>;
  foremanUserId?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  rate: Scalars['Int'];
};

export type CreateCustomEventInput = {
  blocks: Array<CustomEventBlockInput>;
  color?: InputMaybe<Scalars['String']>;
  crewId?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  userIDs?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type CreateEmployeeForUserInviteInput = {
  rate: Scalars['Int'];
};

export type CreateEmployeeInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  rate: Scalars['Int'];
  userId?: InputMaybe<Scalars['ID']>;
};

export type CreateEquipmentPieceInput = {
  chargeType: EquipmentPieceChargeType | `${EquipmentPieceChargeType}`;
  fuelSurcharge: Scalars['Int'];
  name: Scalars['String'];
  rate: Scalars['Int'];
  usePercentage: Scalars['Int'];
};

export type CreateNotificationTriggerInput = {
  active: Scalars['Boolean'];
  additionalRecipientTypes?: InputMaybe<Array<NotificationTriggerAdditionalRecipientTypes | `${NotificationTriggerAdditionalRecipientTypes}`>>;
  additionalRecipients?: InputMaybe<SyncNotificationAdditionalRecipientsHasMany>;
  content: Scalars['String'];
  delay: Scalars['Int'];
  emailSubject: Scalars['String'];
  event: NotificationTriggerEvent | `${NotificationTriggerEvent}`;
  isEmail?: InputMaybe<Scalars['Boolean']>;
  isSMS?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  sendToAllRecipients: Scalars['Boolean'];
  sendToContact: Scalars['Boolean'];
  sendToUser: Scalars['Boolean'];
  smsContent?: InputMaybe<Scalars['String']>;
  type: NotificationTriggerType | `${NotificationTriggerType}`;
};

export type CreateOpportunityInput = {
  addressCity: Scalars['String'];
  addressCountry: Scalars['String'];
  addressLine1: Scalars['String'];
  addressLine2?: InputMaybe<Scalars['String']>;
  addressState: Scalars['String'];
  addressZip: Scalars['String'];
  companyId: Scalars['ID'];
  contactId: Scalars['ID'];
  dueAt?: InputMaybe<Scalars['Date']>;
  estimatedOpportunityValue?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<CreateOpportunityProductBelongsToMany>;
  projectFilesFolderId?: InputMaybe<Scalars['ID']>;
  source?: InputMaybe<OpportunitySource | `${OpportunitySource}`>;
  userId: Scalars['ID'];
};

export type CreateOpportunityProductBelongsToMany = {
  connect: Array<CreateOpportunityProductInput>;
};

export type CreateOpportunityProductInput = {
  id: Scalars['ID'];
};

export type CreateOrganizationAddressInput = {
  city: Scalars['String'];
  country: Scalars['String'];
  isPrimary: Scalars['Boolean'];
  latitude?: InputMaybe<Scalars['String']>;
  line1: Scalars['String'];
  line2?: InputMaybe<Scalars['String']>;
  longitude?: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
  zip: Scalars['String'];
};

export type CreateOrganizationApiKey = {
  __typename?: 'CreateOrganizationApiKey';
  success: Scalars['Boolean'];
};

export type CreateOrganizationProductTypeInput = {
  indirectPercentage?: InputMaybe<Scalars['Int']>;
  markupPercentage?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  overheadPercentage?: InputMaybe<Scalars['Int']>;
  type: ProductType | `${ProductType}`;
};

export type CreatePlantInput = {
  addressCity: Scalars['String'];
  addressCountry: Scalars['String'];
  addressLine1: Scalars['String'];
  addressLine2?: InputMaybe<Scalars['String']>;
  addressState: Scalars['String'];
  addressZip: Scalars['String'];
  latitude?: InputMaybe<Scalars['String']>;
  longitude?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  phone: Scalars['String'];
  products: CreatePlantProductBelongsToMany;
};

export type CreatePlantProductBelongsToMany = {
  create: Array<CreatePlantProductInput>;
};

export type CreatePlantProductInput = {
  rate: Scalars['Int'];
  type: Scalars['String'];
};

export type CreatePlantTransferTruckBelongsToMany = {
  connect: Array<ConnectPlantTransferTruckInput>;
};

export type CreateProductAdditionalCostBelongsToMany = {
  connect: Array<CreateProductAdditionalCostInput>;
};

export type CreateProductAdditionalCostInput = {
  id: Scalars['ID'];
  type?: InputMaybe<ProductAdditionalCostType | `${ProductAdditionalCostType}`>;
};

export type CreateProductEquipmentBelongsToMany = {
  connect: Array<CreateProductEquipmentInput>;
};

export type CreateProductEquipmentInput = {
  id: Scalars['ID'];
  quantity: Scalars['Int'];
};

export type CreateProductInput = {
  additionalCosts?: InputMaybe<CreateProductAdditionalCostBelongsToMany>;
  areaCoverage?: InputMaybe<Scalars['Float']>;
  /** Json encoded string of attributes */
  attributes?: InputMaybe<ProductAttributesInput>;
  costMaterial?: InputMaybe<Scalars['Int']>;
  costMinimumProduct?: InputMaybe<Scalars['Int']>;
  costMinimumProposal?: InputMaybe<Scalars['Int']>;
  crewId?: InputMaybe<Scalars['ID']>;
  dailyUnitsComplete?: InputMaybe<Scalars['Int']>;
  equipmentPieces?: InputMaybe<CreateProductEquipmentBelongsToMany>;
  externalProductName?: InputMaybe<Scalars['String']>;
  indirectPercentage?: InputMaybe<Scalars['Int']>;
  labourCostType?: InputMaybe<ProductLabourCostType | `${ProductLabourCostType}`>;
  markupPercentage?: InputMaybe<Scalars['Int']>;
  measurementJob: ProductMeasurementJob | `${ProductMeasurementJob}`;
  measurementMaterial?: InputMaybe<ProductMeasurementMaterial | `${ProductMeasurementMaterial}`>;
  name: Scalars['String'];
  organizationProductTypeId: Scalars['ID'];
  overheadPercentage?: InputMaybe<Scalars['Int']>;
  plantProductId?: InputMaybe<Scalars['ID']>;
  productionRateType?: InputMaybe<ProductProductionRateType | `${ProductProductionRateType}`>;
  statementOfWork?: InputMaybe<Scalars['String']>;
  subcontracted: Scalars['Boolean'];
  unitPrice?: InputMaybe<Scalars['Int']>;
  unitPriceProduct: Scalars['Boolean'];
};

export type CreateTimeBucketInput = {
  name: Scalars['String'];
};

export type CreateTimeEntryInput = {
  clockInLatitude?: InputMaybe<Scalars['Float']>;
  clockInLongitude?: InputMaybe<Scalars['Float']>;
  clockOutLatitude?: InputMaybe<Scalars['Float']>;
  clockOutLongitude?: InputMaybe<Scalars['Float']>;
  endTime?: InputMaybe<Scalars['DateTime']>;
  forDate: Scalars['Date'];
  jobPhaseId?: InputMaybe<Scalars['ID']>;
  notes?: InputMaybe<Scalars['String']>;
  startTime: Scalars['DateTime'];
  timeBucketId?: InputMaybe<Scalars['ID']>;
  userId: Scalars['ID'];
  uuid: Scalars['String'];
};

export type CreateTransferTruckInput = {
  defaultRateHourly: Scalars['Int'];
  defaultRateTon: Scalars['Int'];
  defaultTonnage: Scalars['Int'];
  name: Scalars['String'];
};

export type Crew = {
  __typename?: 'Crew';
  color: Scalars['String'];
  displayName?: Maybe<Scalars['String']>;
  employees?: Maybe<Array<Employee>>;
  foremanUser?: Maybe<User>;
  id: Scalars['ID'];
  name: Scalars['String'];
  organization: Organization;
  rate: Scalars['Int'];
};

/** A paginated list of Crew items. */
export type CrewPaginator = {
  __typename?: 'CrewPaginator';
  /** A list of Crew items. */
  data: Array<Crew>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type CustomEvent = {
  __typename?: 'CustomEvent';
  color?: Maybe<Scalars['String']>;
  crew?: Maybe<Crew>;
  customEventBlocks?: Maybe<Array<Maybe<CustomEventBlock>>>;
  customEventsToUsers?: Maybe<Array<Maybe<CustomEventsToUsers>>>;
  endsAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  startsAt?: Maybe<Scalars['DateTime']>;
};

export type CustomEventBlock = {
  __typename?: 'CustomEventBlock';
  blockLength?: Maybe<Scalars['Float']>;
  customEvent?: Maybe<CustomEvent>;
  endsAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
};

export type CustomEventBlockInput = {
  blockLength?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['ID']>;
  scheduledAt?: InputMaybe<Scalars['DateTime']>;
};

export type CustomEventsToUsers = {
  __typename?: 'CustomEventsToUsers';
  user?: Maybe<User>;
};

export type CustomPaginatorInfo = {
  __typename?: 'CustomPaginatorInfo';
  count: Scalars['Int'];
  currentPage: Scalars['Int'];
  firstItem?: Maybe<Scalars['Int']>;
  hasMorePages: Scalars['Boolean'];
  lastItem?: Maybe<Scalars['Int']>;
  lastPage: Scalars['Int'];
  perPage: Scalars['Int'];
  total: Scalars['Int'];
};

export type DashboardDataByMonth = {
  __typename?: 'DashboardDataByMonth';
  closedBids: Scalars['Int'];
  closedRate: Scalars['Float'];
  closedRevenue: Scalars['Float'];
  sentBids: Scalars['Int'];
};

export type DashboardMapData = {
  __typename?: 'DashboardMapData';
  latitude?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['String']>;
  status: JobStatus | `${JobStatus}`;
};

export type DateWithMaterialAmount = {
  __typename?: 'DateWithMaterialAmount';
  JobPhaseAmountScheduledInDay: Scalars['Float'];
  date: Scalars['String'];
  jobPhaseMaterialNeededInDay: Scalars['Float'];
  material: Scalars['String'];
};

export type DateWithTotals = {
  __typename?: 'DateWithTotals';
  date: Scalars['String'];
  overallTotal: Scalars['String'];
};

export type DefaultDashboardStats = {
  __typename?: 'DefaultDashboardStats';
  currentMonth: DashboardDataByMonth;
  jobScheduleByAmount: Array<DateWithTotals>;
  lastYear: YearlyDashboardData;
  materialNeededByDay?: Maybe<Array<DateWithMaterialAmount>>;
  persons: Array<Maybe<PersonSales>>;
  previousMonth: DashboardDataByMonth;
};

export enum DeleteOpenProposalAction {
  /** Cancel */
  CANCEL = 'CANCEL',
  /** Reassign */
  REASSIGN = 'REASSIGN',
  /** Unassign */
  UNASSIGN = 'UNASSIGN'
}

export type DeleteOrganizationApiKey = {
  __typename?: 'DeleteOrganizationApiKey';
  success: Scalars['Boolean'];
};

export type DuplicateProposalResponse = {
  __typename?: 'DuplicateProposalResponse';
  newProposal?: Maybe<Proposal>;
  proposal: Proposal;
};

export type Employee = {
  __typename?: 'Employee';
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  name: Scalars['String'];
  organizationId: Scalars['ID'];
  rate: Scalars['Int'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']>;
};

/** A paginated list of Employee items. */
export type EmployeePaginator = {
  __typename?: 'EmployeePaginator';
  /** A list of Employee items. */
  data: Array<Employee>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type EquipmentPiece = {
  __typename?: 'EquipmentPiece';
  chargeType: EquipmentPieceChargeType | `${EquipmentPieceChargeType}`;
  fuelSurcharge: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['String'];
  /** @deprecated No longer supported */
  pivot?: Maybe<ProductEquipmentPivot>;
  rate: Scalars['Int'];
  usePercentage: Scalars['Int'];
};

export enum EquipmentPieceChargeType {
  /** Hourly */
  HOURLY = 'HOURLY',
  /** Mileage */
  MILEAGE = 'MILEAGE'
}

/** A paginated list of EquipmentPiece items. */
export type EquipmentPiecePaginator = {
  __typename?: 'EquipmentPiecePaginator';
  /** A list of EquipmentPiece items. */
  data: Array<EquipmentPiece>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type FinishRegistrationInput = {
  email: Scalars['String'];
  password: Scalars['String'];
  token: Scalars['String'];
};

export type GenerateUploadCompanyLogoUrl = {
  __typename?: 'GenerateUploadCompanyLogoUrl';
  method: Scalars['String'];
  path: Scalars['String'];
  url: Scalars['String'];
};

export type GenerateUploadOrganizationDataUploadUrl = {
  __typename?: 'GenerateUploadOrganizationDataUploadUrl';
  method: Scalars['String'];
  path: Scalars['String'];
  url: Scalars['String'];
};

export type GenerateUploadOrganizationDocumentUrl = {
  __typename?: 'GenerateUploadOrganizationDocumentUrl';
  method: Scalars['String'];
  path: Scalars['String'];
  url: Scalars['String'];
};

export type GenerateUploadOrganizationLogoUrl = {
  __typename?: 'GenerateUploadOrganizationLogoUrl';
  method: Scalars['String'];
  path: Scalars['String'];
  url: Scalars['String'];
};

export type GenerateUploadProposalFileUrl = {
  __typename?: 'GenerateUploadProposalFileUrl';
  method: Scalars['String'];
  path: Scalars['String'];
  url: Scalars['String'];
};

export type GenerateUploadUrl = {
  __typename?: 'GenerateUploadUrl';
  contentDisposition?: Maybe<Scalars['String']>;
  contentType: Scalars['String'];
  method: Scalars['String'];
  path: Scalars['String'];
  url: Scalars['String'];
};

export type GetCompaniesResponse = {
  __typename?: 'GetCompaniesResponse';
  data: Array<Company>;
  paginatorInfo: CustomPaginatorInfo;
};

export enum GetCompaniesSortKey {
  ADDRESS = 'ADDRESS',
  CONTACT = 'CONTACT',
  ID = 'ID',
  NAME = 'NAME',
  STATUS = 'STATUS'
}

export type GetJobBillingStatusesResponse = {
  __typename?: 'GetJobBillingStatusesResponse';
  statuses?: Maybe<Array<JobBillingStatus | `${JobBillingStatus}`>>;
};

export type GetJobPhasesResponse = {
  __typename?: 'GetJobPhasesResponse';
  data: Array<JobPhase>;
  paginatorInfo: CustomPaginatorInfo;
};

export type GetJobsResponse = {
  __typename?: 'GetJobsResponse';
  data: Array<Job>;
  paginatorInfo: CustomPaginatorInfo;
};

export enum GetJobsSortKey {
  COMPANY = 'COMPANY',
  ID = 'ID',
  START = 'START',
  STATUS = 'STATUS'
}

export type GetOpportunitiesResponse = {
  __typename?: 'GetOpportunitiesResponse';
  data: Array<Opportunity>;
  paginatorInfo: CustomPaginatorInfo;
};

export enum GetOpportunitiesSortKey {
  ADDRESS = 'ADDRESS',
  COMPANY = 'COMPANY',
  CONTACT = 'CONTACT',
  DUEAT = 'DUEAT',
  ID = 'ID',
  NAME = 'NAME',
  STATUS = 'STATUS'
}

export type GetProposalsResponse = {
  __typename?: 'GetProposalsResponse';
  data: Array<Proposal>;
  paginatorInfo: CustomPaginatorInfo;
};

export enum GetProposalsSortKey {
  COMPANY = 'COMPANY',
  CREATED = 'CREATED',
  ID = 'ID',
  SENT = 'SENT',
  STATUS = 'STATUS',
  TOTAL = 'TOTAL'
}

export type GetTimeEntriesResponse = {
  __typename?: 'GetTimeEntriesResponse';
  data: Array<TimeEntry>;
  paginatorInfo: PaginatorInfo;
};

export enum GetTimeEntriesSortKey {
  DATE = 'DATE',
  END = 'END',
  HOURS = 'HOURS',
  JOB_PHASE = 'JOB_PHASE',
  START = 'START',
  USER = 'USER'
}

export type InviteUserInput = {
  addressCity?: InputMaybe<Scalars['String']>;
  addressCountry?: InputMaybe<Scalars['String']>;
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  addressState?: InputMaybe<Scalars['String']>;
  addressZip?: InputMaybe<Scalars['String']>;
  avatar?: InputMaybe<Scalars['Upload']>;
  email: Scalars['String'];
  employee?: InputMaybe<CreateEmployeeForUserInviteInput>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  role: UserRole | `${UserRole}`;
};

export type ItemsQuickbooksDetailInput = {
  itemAmount?: InputMaybe<Scalars['Int']>;
  itemsDescription?: InputMaybe<Scalars['String']>;
  itemsName?: InputMaybe<Scalars['String']>;
};

export type Job = {
  __typename?: 'Job';
  actualCostAdditional: Scalars['String'];
  actualCostDirect: Scalars['String'];
  actualCostEquipment: Scalars['String'];
  actualCostIndirect: Scalars['String'];
  actualCostLabour: Scalars['String'];
  actualCostMaterial: Scalars['String'];
  actualCostOverhead: Scalars['String'];
  actualCostTotal: Scalars['String'];
  actualCostTransferTruck: Scalars['String'];
  actualGrossMargin: Scalars['String'];
  actualGrossMarginPercentage: Scalars['Int'];
  actualNetMargin: Scalars['String'];
  actualNetMarginPercentage: Scalars['Int'];
  actualOperatingMargin: Scalars['String'];
  actualOperatingMarginPercentage: Scalars['Int'];
  actualOverallTotal: Scalars['String'];
  actualProfit: Scalars['String'];
  actualProfitPercentage: Scalars['Int'];
  address: ProposalAddress;
  billingStatus?: Maybe<JobBillingStatus | `${JobBillingStatus}`>;
  changeOrders?: Maybe<Array<Proposal>>;
  company: Company;
  contact: Contact;
  datePushedToQuickbooks?: Maybe<Scalars['DateTime']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['String'];
  foremanUser?: Maybe<User>;
  id: Scalars['ID'];
  jobPhases?: Maybe<Array<Maybe<JobPhase>>>;
  mayShowTaxNotification?: Maybe<Scalars['Boolean']>;
  notes?: Maybe<Scalars['String']>;
  projectFilesFolderId?: Maybe<Scalars['ID']>;
  proposal?: Maybe<Proposal>;
  proposalId: Scalars['ID'];
  proposalStage?: Maybe<ProposalStage>;
  proposedCostAdditional: Scalars['String'];
  proposedCostDirect: Scalars['String'];
  proposedCostEquipment: Scalars['String'];
  proposedCostIndirect: Scalars['String'];
  proposedCostLabour: Scalars['String'];
  proposedCostMaterial: Scalars['String'];
  proposedCostOverhead: Scalars['String'];
  proposedCostTotal: Scalars['String'];
  proposedCostTransferTruck: Scalars['String'];
  proposedGrossMargin: Scalars['String'];
  proposedGrossMarginPercentage: Scalars['Int'];
  proposedNetMargin: Scalars['String'];
  proposedNetMarginPercentage: Scalars['Int'];
  proposedOperatingMargin: Scalars['String'];
  proposedOperatingMarginPercentage: Scalars['Int'];
  proposedOverallTotal: Scalars['String'];
  proposedProfit: Scalars['String'];
  proposedProfitPercentage: Scalars['Int'];
  shouldPushTaxesToQuickbooks?: Maybe<Scalars['Boolean']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status: JobStatus | `${JobStatus}`;
  user?: Maybe<User>;
  userId: Scalars['ID'];
};

export enum JobBillingStatus {
  /** Billed */
  BILLED = 'BILLED',
  /** Paid */
  PAID = 'PAID',
  /** Partial billed */
  PARTIAL_BILLED = 'PARTIAL_BILLED',
  /** Partial paid */
  PARTIAL_PAID = 'PARTIAL_PAID',
  /** Pending billing */
  PENDING_BILLING = 'PENDING_BILLING',
  /** Ready to bill */
  READY_TO_BILL = 'READY_TO_BILL'
}

export type JobPhase = {
  __typename?: 'JobPhase';
  actualCostAdditional: Scalars['String'];
  actualCostDirect: Scalars['String'];
  actualCostEquipment: Scalars['String'];
  actualCostIndirect: Scalars['String'];
  actualCostLabour: Scalars['String'];
  actualCostMaterial: Scalars['String'];
  actualCostOverhead: Scalars['String'];
  actualCostTotal: Scalars['String'];
  actualCostTransferTruck: Scalars['String'];
  actualEmployeeHours: Scalars['String'];
  actualGrossMargin: Scalars['String'];
  actualGrossMarginPercentage: Scalars['Int'];
  actualMaterialNeeded: Scalars['String'];
  actualNetMargin: Scalars['String'];
  actualNetMarginPercentage: Scalars['Int'];
  actualOperatingMargin: Scalars['String'];
  actualOperatingMarginPercentage: Scalars['Int'];
  actualOverallTotal: Scalars['String'];
  actualProfit: Scalars['String'];
  actualProfitPercentage: Scalars['Int'];
  address: Scalars['String'];
  applicableStatuses?: Maybe<Array<Scalars['String']>>;
  costItems: Array<JobPhaseCostItem>;
  crew?: Maybe<Crew>;
  crewId?: Maybe<Scalars['ID']>;
  defaultAdditionalCosts: Array<AdditionalCost>;
  defaultEmployees: Array<Employee>;
  defaultEquipmentPieces: Array<EquipmentPiece>;
  employees: Array<JobPhaseEmployee>;
  endsAt?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['String'];
  files?: Maybe<Array<JobPhaseFile>>;
  foremanUser?: Maybe<User>;
  id: Scalars['ID'];
  job: Job;
  jobDuration: Scalars['Float'];
  jobPhasePlant?: Maybe<JobPhasePlant>;
  jobSize: Scalars['Int'];
  notes?: Maybe<Scalars['String']>;
  organization: Organization;
  organizationProductType?: Maybe<OrganizationProductType>;
  organizationProductTypeName?: Maybe<Scalars['String']>;
  productName: Scalars['String'];
  proposal: Proposal;
  proposalProduct: ProposalProduct;
  proposalStage: ProposalStage;
  proposedCostAdditional: Scalars['String'];
  proposedCostDirect: Scalars['String'];
  proposedCostEquipment: Scalars['String'];
  proposedCostIndirect: Scalars['String'];
  proposedCostLabour: Scalars['String'];
  proposedCostMaterial: Scalars['String'];
  proposedCostOverhead: Scalars['String'];
  proposedCostTotal: Scalars['String'];
  proposedCostTransferTruck: Scalars['String'];
  proposedEmployeeHours: Scalars['String'];
  proposedGrossMargin: Scalars['String'];
  proposedGrossMarginPercentage: Scalars['Int'];
  proposedMaterialNeeded: Scalars['String'];
  proposedNetMargin: Scalars['String'];
  proposedNetMarginPercentage: Scalars['Int'];
  proposedOperatingMargin: Scalars['String'];
  proposedOperatingMarginPercentage: Scalars['Int'];
  proposedOverallTotal: Scalars['String'];
  proposedProfit: Scalars['String'];
  proposedProfitPercentage: Scalars['Int'];
  scheduleBlocks: Array<JobPhaseScheduleBlock>;
  scheduledBlockForDate?: Maybe<Array<JobPhaseScheduleBlock>>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status: JobPhaseStatus | `${JobPhaseStatus}`;
  /** In Hours */
  travelTimeEstimate?: Maybe<Scalars['Float']>;
  users?: Maybe<Array<User>>;
  usersColor?: Maybe<Scalars['String']>;
  workOrderCrews?: Maybe<Array<Maybe<WorkOrderCrew>>>;
  workOrderEquipmentPieces?: Maybe<Array<Maybe<WorkOrderEquipmentPiece>>>;
  workOrderTransferTrucks?: Maybe<Array<Maybe<WorkOrderTransferTruck>>>;
};

export type JobPhaseAdditionalCost = {
  __typename?: 'JobPhaseAdditionalCost';
  additionalCostId?: Maybe<Scalars['ID']>;
  cost: Scalars['Int'];
  costTotal: Scalars['Int'];
  feeAmount: Scalars['Float'];
  feeType: AdditionalCostFeeType | `${AdditionalCostFeeType}`;
  id: Scalars['ID'];
  jobPhaseCostItem: JobPhaseCostItem;
  name: Scalars['String'];
};

export type JobPhaseCostItem = {
  __typename?: 'JobPhaseCostItem';
  additionalCosts?: Maybe<Array<JobPhaseAdditionalCost>>;
  costAdditional: Scalars['Float'];
  costEquipment: Scalars['Float'];
  costLabour: Scalars['Float'];
  costMaterial: Scalars['Float'];
  costTransferTruck: Scalars['Float'];
  date: Scalars['DateTime'];
  employees?: Maybe<Array<JobPhaseEmployee>>;
  equipmentPieces?: Maybe<Array<JobPhaseEquipmentPiece>>;
  id: Scalars['ID'];
  jobPhase: JobPhase;
  material?: Maybe<JobPhaseMaterial>;
  plantId?: Maybe<Scalars['ID']>;
  plantProductId?: Maybe<Scalars['ID']>;
  transferTrucks?: Maybe<Array<JobPhaseTransferTruck>>;
  user?: Maybe<User>;
};

export type JobPhaseEmployee = {
  __typename?: 'JobPhaseEmployee';
  employeeId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  rate: Scalars['Int'];
  timeOnjob: Scalars['Float'];
  timeTravel: Scalars['Float'];
};

export type JobPhaseEquipmentPiece = {
  __typename?: 'JobPhaseEquipmentPiece';
  equipmentPieceId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  quantity: Scalars['Int'];
  rate: Scalars['Int'];
  timeOnjob: Scalars['Float'];
  timeTravel: Scalars['Float'];
};

export type JobPhaseFile = {
  __typename?: 'JobPhaseFile';
  createdAt: Scalars['DateTime'];
  filename: Scalars['String'];
  id: Scalars['ID'];
  thumbnail?: Maybe<Scalars['String']>;
};

export type JobPhaseMaterial = {
  __typename?: 'JobPhaseMaterial';
  costMaterial: Scalars['Int'];
  id: Scalars['ID'];
  jobPhaseCostItem: JobPhaseCostItem;
  materialNeeded: Scalars['Float'];
  name: Scalars['String'];
  organizationProductTypeName?: Maybe<Scalars['String']>;
  type: ProductType | `${ProductType}`;
};

export type JobPhasePlant = {
  __typename?: 'JobPhasePlant';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  plant?: Maybe<Plant>;
  plantProduct?: Maybe<PlantProduct>;
  type?: Maybe<Scalars['String']>;
};

export type JobPhaseScheduleBlock = {
  __typename?: 'JobPhaseScheduleBlock';
  /** In Hours */
  blockLength: Scalars['Float'];
  crew?: Maybe<Crew>;
  endsAt: Scalars['DateTime'];
  estimatedMaterial?: Maybe<Scalars['Float']>;
  estimatedMaterialOverride?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  job: Job;
  jobPhase: JobPhase;
  scheduledAt: Scalars['DateTime'];
  showTravelFrom: Scalars['Boolean'];
  showTravelTo: Scalars['Boolean'];
  /** In Hours */
  travelTime: Scalars['Float'];
};

export enum JobPhaseStatus {
  /** Complete */
  COMPLETE = 'COMPLETE',
  /** In progress */
  IN_PROGRESS = 'IN_PROGRESS',
  /** Job costing */
  JOB_COSTING = 'JOB_COSTING',
  /** Scheduled */
  SCHEDULED = 'SCHEDULED',
  /** To be scheduled */
  TO_BE_SCHEDULED = 'TO_BE_SCHEDULED'
}

export type JobPhaseTransferTruck = {
  __typename?: 'JobPhaseTransferTruck';
  hours: Scalars['Float'];
  id: Scalars['ID'];
  name: Scalars['String'];
  plantTransferTruckId?: Maybe<Scalars['ID']>;
  rateHourly: Scalars['Int'];
  rateTon: Scalars['Int'];
  tonnage: Scalars['Int'];
  transferTruckId?: Maybe<Scalars['ID']>;
};

export enum JobStatus {
  /** Complete */
  COMPLETE = 'COMPLETE',
  /** In progress */
  IN_PROGRESS = 'IN_PROGRESS',
  /** Job costing */
  JOB_COSTING = 'JOB_COSTING',
  /** Scheduled */
  SCHEDULED = 'SCHEDULED',
  /** To be scheduled */
  TO_BE_SCHEDULED = 'TO_BE_SCHEDULED'
}

export type LoginAppUser = {
  __typename?: 'LoginAppUser';
  token?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type LoginInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type ModelsPlantProductType = {
  __typename?: 'ModelsPlantProductType';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type MonthlySummary = {
  __typename?: 'MonthlySummary';
  month: Scalars['Int'];
  total: Scalars['Float'];
  year: Scalars['Int'];
};

export type Mutation = {
  __typename?: 'Mutation';
  CreateOrganizationApiKey: CreateOrganizationApiKey;
  DeleteOrganizationApiKey: DeleteOrganizationApiKey;
  acceptUserInvite?: Maybe<User>;
  addJobPhaseCosts: JobPhaseCostItem;
  addJobPhaseFile: JobPhase;
  addOrganizationDataUpload: OrganizationDataUpload;
  addOrganizationDocument: Organization;
  addProductToProposalStage: Proposal;
  addProjectFile: ProjectFile;
  addProposalAdditionalCost: Proposal;
  addProposalAdditionalCosts: Proposal;
  addProposalAddress: Proposal;
  addProposalCrew: Proposal;
  addProposalCrews: Proposal;
  addProposalEquipmentPiece: Proposal;
  addProposalEquipmentPieces: Proposal;
  addProposalFile: ProposalProduct;
  addProposalStage?: Maybe<ProposalStage>;
  addTruckToProposalProduct?: Maybe<Proposal>;
  appLogin?: Maybe<LoginAppUser>;
  appLogout?: Maybe<Scalars['Boolean']>;
  archiveCompany: Scalars['Boolean'];
  cancelOpportunity: Opportunity;
  cancelProposal: CancelProposalResponse;
  closeProposal: Proposal;
  createAdditionalCost: AdditionalCost;
  createCompany: Company;
  createCrew: Crew;
  createCustomEvent?: Maybe<CustomEvent>;
  createEmployee: Employee;
  createEquipmentPiece: EquipmentPiece;
  createJobInvoiceOnLinkedService?: Maybe<Scalars['Boolean']>;
  createNotificationTrigger?: Maybe<NotificationTrigger>;
  createOpportunity: Opportunity;
  createOpportunityStatus: OrganizationOpportunityStatus;
  createOrganizationAddress?: Maybe<OrganizationAddress>;
  createOrganizationProductType: OrganizationProductType;
  createPlant?: Maybe<Plant>;
  createPlantProductType?: Maybe<ModelsPlantProductType>;
  createProduct: Product;
  createProjectFileFolder: ProjectFile;
  createProposal: Proposal;
  createProposalFromOpportunity: Proposal;
  createTimeBucket: TimeBucket;
  createTimeEntry: TimeEntry;
  createTransferTruck?: Maybe<TransferTruck>;
  deleteAdditionalCost?: Maybe<Scalars['Boolean']>;
  deleteCrew?: Maybe<Scalars['Boolean']>;
  deleteCustomEvent: CustomEvent;
  deleteEmployee?: Maybe<Scalars['Boolean']>;
  deleteEquipmentPiece?: Maybe<Scalars['Boolean']>;
  deleteJobPhaseCost: Scalars['Boolean'];
  deleteJobPhaseFile?: Maybe<Scalars['Boolean']>;
  deleteNotificationTrigger?: Maybe<Scalars['Boolean']>;
  deleteOpportunity?: Maybe<Opportunity>;
  deleteOrganizationAddress?: Maybe<Scalars['Boolean']>;
  deleteOrganizationDocument: Scalars['Boolean'];
  deleteOrganizationProductType?: Maybe<Scalars['Boolean']>;
  deleteOrganizationUser: Scalars['Boolean'];
  deletePlant?: Maybe<Scalars['Boolean']>;
  deleteProduct?: Maybe<Scalars['Boolean']>;
  deleteProjectFile: ProjectFile;
  deleteProposal?: Maybe<Proposal>;
  deleteProposalFile: Scalars['Boolean'];
  deleteProposalMapImage: Scalars['Boolean'];
  deleteProposalProduct: ProposalStage;
  deleteProposalRecipient: Scalars['Boolean'];
  deleteProposalStage: Proposal;
  deleteTimeBucket: TimeBucket;
  deleteTimeEntry?: Maybe<TimeEntry>;
  deleteTransferTruck?: Maybe<Scalars['Boolean']>;
  deleteUserInvite?: Maybe<Scalars['Boolean']>;
  duplicateProduct: Product;
  duplicateProposal?: Maybe<DuplicateProposalResponse>;
  finalizeLinkedServiceAccount?: Maybe<Scalars['Boolean']>;
  finishRegistration?: Maybe<User>;
  generateOrganizationDataUploadUrl: GenerateUploadOrganizationDocumentUrl;
  generateReport: Scalars['String'];
  generateUploadCompanyLogoUrl: GenerateUploadCompanyLogoUrl;
  generateUploadJobPhaseCostItemFileUrl: GenerateUploadProposalFileUrl;
  generateUploadOrganizationDocumentUrl: GenerateUploadOrganizationDocumentUrl;
  generateUploadOrganizationLogoUrl: GenerateUploadOrganizationLogoUrl;
  generateUploadProjectFileUrl: GenerateUploadUrl;
  generateUploadProposalFileUrl: GenerateUploadProposalFileUrl;
  getLinkedServiceAuthUrl?: Maybe<Scalars['String']>;
  inviteUser?: Maybe<Scalars['Boolean']>;
  login?: Maybe<User>;
  logout?: Maybe<Scalars['Boolean']>;
  mergeCompany: Company;
  previewProposal?: Maybe<Scalars['String']>;
  register?: Maybe<Scalars['Boolean']>;
  removeTruckFromProposalProduct?: Maybe<Proposal>;
  requestPasswordReset?: Maybe<Scalars['Boolean']>;
  resendUserInvite?: Maybe<Scalars['Boolean']>;
  resendVerificationEmail?: Maybe<Scalars['Boolean']>;
  resetPassword?: Maybe<Scalars['Boolean']>;
  saveQuickbooksIncomeAccount?: Maybe<Scalars['Boolean']>;
  saveQuickbooksIntegration: Scalars['Boolean'];
  scheduleCustomEventBlock: CustomEvent;
  scheduleJobPhase: Job;
  scheduleJobPhaseBlock: Job;
  sendOrganizationEmailTemplatePreview: Scalars['Boolean'];
  sendProposal: Scalars['Boolean'];
  sendProposalToSpecificRecipients: Array<ProposalRecipient>;
  setProposalToDraft: Proposal;
  setProposalToWon: Proposal;
  signProposal: PublicProposal;
  toggleProposalProductOptionality: ProposalProduct;
  unlinkService?: Maybe<Scalars['Boolean']>;
  unscheduleCustomEvent: CustomEvent;
  unscheduleJobPhase: Job;
  updateAdditionalCost: AdditionalCost;
  updateCompany?: Maybe<Company>;
  updateCompanyNotes: Company;
  updateCompanyProjectFileFolderId: Company;
  updateCrew: Crew;
  updateCustomEvent?: Maybe<CustomEvent>;
  updateEmployee: Employee;
  updateEquipmentPiece: EquipmentPiece;
  updateJobBillingStatus: Job;
  updateJobNotes?: Maybe<Job>;
  updateJobPhaseNotes: JobPhase;
  updateJobPhaseStatus: JobPhase;
  updateJobProjectFileFolderId: Job;
  updateJobProjectManager: Job;
  updateNotificationTrigger?: Maybe<NotificationTrigger>;
  updateOpportunity: Opportunity;
  updateOrganization: Organization;
  updateOrganizationAddress?: Maybe<OrganizationAddress>;
  updateOrganizationAddressPrimary?: Maybe<Scalars['Boolean']>;
  updateOrganizationConversionFactorOverride: OrganizationConversionFactorOverride;
  updateOrganizationEmailTemplate?: Maybe<Scalars['Boolean']>;
  updateOrganizationProductType?: Maybe<OrganizationProductType>;
  updateOrganizationProposalContent: OrganizationProposalContent;
  updateOrganizationProposalDefaults: ProposalDefault;
  updateOrganizationProposalSentEmailText: Organization;
  updateOrganizationSalesTaxes: Organization;
  updateOrganizationSettings: Scalars['Boolean'];
  updateOrganizationUser?: Maybe<User>;
  updatePlant?: Maybe<Plant>;
  updateProduct: Product;
  updateProposal: Proposal;
  updateProposalAddress?: Maybe<ProposalAddress>;
  updateProposalInfo: Proposal;
  updateProposalPlantProduct: Proposal;
  updateProposalProduct: Proposal;
  updateProposalSalesTaxes: Proposal;
  updateProposalStage: ProposalStage;
  updateProposalStagesOrdering: Proposal;
  updateRolesWithPermissions?: Maybe<RolesWithPermissions>;
  updateStageProductsOrdering: ProposalStage;
  updateTimeBucket: TimeBucket;
  updateTimeEntry: TimeEntry;
  updateTransferTruck?: Maybe<TransferTruck>;
  updateWorkOrderItems?: Maybe<JobPhase>;
  validateRegistrationToken?: Maybe<Scalars['Boolean']>;
};


export type MutationCreateOrganizationApiKeyArgs = {
  description: Scalars['String'];
};


export type MutationDeleteOrganizationApiKeyArgs = {
  id: Scalars['ID'];
};


export type MutationAcceptUserInviteArgs = {
  input: AcceptUserInviteInput;
};


export type MutationAddJobPhaseCostsArgs = {
  input: AddJobPhaseCostsInput;
};


export type MutationAddJobPhaseFileArgs = {
  jobPhaseId: Scalars['ID'];
  path: Scalars['String'];
};


export type MutationAddOrganizationDataUploadArgs = {
  input: AddOrganizationDataUploadInput;
};


export type MutationAddOrganizationDocumentArgs = {
  name: Scalars['String'];
  path: Scalars['String'];
};


export type MutationAddProductToProposalStageArgs = {
  productId: Scalars['ID'];
  proposalStageId: Scalars['ID'];
};


export type MutationAddProjectFileArgs = {
  name: Scalars['String'];
  parentFolderId?: InputMaybe<Scalars['ID']>;
  path: Scalars['String'];
};


export type MutationAddProposalAdditionalCostArgs = {
  additionalCostId: Scalars['ID'];
  proposalProductId: Scalars['ID'];
};


export type MutationAddProposalAdditionalCostsArgs = {
  additionalCosts: Array<Scalars['ID']>;
  proposalProductId: Scalars['ID'];
};


export type MutationAddProposalAddressArgs = {
  input: AddProposalAddressInput;
};


export type MutationAddProposalCrewArgs = {
  crewId: Scalars['ID'];
  proposalProductId: Scalars['ID'];
};


export type MutationAddProposalCrewsArgs = {
  crewIds: Array<Scalars['ID']>;
  proposalProductId: Scalars['ID'];
};


export type MutationAddProposalEquipmentPieceArgs = {
  equipmentPieceId: Scalars['ID'];
  proposalProductId: Scalars['ID'];
  quantity: Scalars['Int'];
};


export type MutationAddProposalEquipmentPiecesArgs = {
  equipmentPieces: Array<AddProposalEquipmentPieceInput>;
  proposalProductId: Scalars['ID'];
};


export type MutationAddProposalFileArgs = {
  path: Scalars['String'];
  proposalProductId: Scalars['ID'];
};


export type MutationAddProposalStageArgs = {
  proposalId: Scalars['ID'];
};


export type MutationAddTruckToProposalProductArgs = {
  input: AddTruckToProposalProductInput;
};


export type MutationAppLoginArgs = {
  input: LoginInput;
};


export type MutationArchiveCompanyArgs = {
  id: Scalars['ID'];
};


export type MutationCancelOpportunityArgs = {
  id: Scalars['ID'];
};


export type MutationCancelProposalArgs = {
  duplicate: Scalars['Boolean'];
  id: Scalars['ID'];
  maintainCurrentId?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCloseProposalArgs = {
  id: Scalars['ID'];
};


export type MutationCreateAdditionalCostArgs = {
  input: CreateAdditionalCostInput;
};


export type MutationCreateCompanyArgs = {
  input: CreateCompanyInput;
};


export type MutationCreateCrewArgs = {
  input: CreateCrewInput;
};


export type MutationCreateCustomEventArgs = {
  input?: InputMaybe<CreateCustomEventInput>;
};


export type MutationCreateEmployeeArgs = {
  input: CreateEmployeeInput;
};


export type MutationCreateEquipmentPieceArgs = {
  input: CreateEquipmentPieceInput;
};


export type MutationCreateJobInvoiceOnLinkedServiceArgs = {
  jobId: Scalars['ID'];
  service: OrganizationLinkedServiceName;
};


export type MutationCreateNotificationTriggerArgs = {
  input: CreateNotificationTriggerInput;
};


export type MutationCreateOpportunityArgs = {
  input: CreateOpportunityInput;
};


export type MutationCreateOpportunityStatusArgs = {
  name: Scalars['String'];
};


export type MutationCreateOrganizationAddressArgs = {
  input: CreateOrganizationAddressInput;
};


export type MutationCreateOrganizationProductTypeArgs = {
  input: CreateOrganizationProductTypeInput;
};


export type MutationCreatePlantArgs = {
  input: CreatePlantInput;
};


export type MutationCreatePlantProductTypeArgs = {
  name: Scalars['String'];
};


export type MutationCreateProductArgs = {
  input: CreateProductInput;
};


export type MutationCreateProjectFileFolderArgs = {
  name: Scalars['String'];
  parentFolderId?: InputMaybe<Scalars['ID']>;
};


export type MutationCreateProposalArgs = {
  companyId: Scalars['ID'];
  contactId: Scalars['ID'];
  source?: InputMaybe<ProposalSource>;
};


export type MutationCreateProposalFromOpportunityArgs = {
  id: Scalars['ID'];
};


export type MutationCreateTimeBucketArgs = {
  input: CreateTimeBucketInput;
};


export type MutationCreateTimeEntryArgs = {
  input: CreateTimeEntryInput;
};


export type MutationCreateTransferTruckArgs = {
  input: CreateTransferTruckInput;
};


export type MutationDeleteAdditionalCostArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCrewArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCustomEventArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteEmployeeArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteEquipmentPieceArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteJobPhaseCostArgs = {
  date: Scalars['Date'];
  jobPhaseId: Scalars['ID'];
};


export type MutationDeleteJobPhaseFileArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteNotificationTriggerArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteOpportunityArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteOrganizationAddressArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteOrganizationDocumentArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteOrganizationProductTypeArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteOrganizationUserArgs = {
  id: Scalars['ID'];
  openProposalAction: DeleteOpenProposalAction;
  reassignJobPhaseForemanUserId?: InputMaybe<Scalars['ID']>;
  reassignJobUserId?: InputMaybe<Scalars['ID']>;
  reassignUserId?: InputMaybe<Scalars['ID']>;
};


export type MutationDeletePlantArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteProductArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteProjectFileArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteProposalArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteProposalFileArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteProposalMapImageArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteProposalProductArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteProposalRecipientArgs = {
  email: Scalars['String'];
  proposalId: Scalars['ID'];
};


export type MutationDeleteProposalStageArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteTimeBucketArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteTimeEntryArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteTransferTruckArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUserInviteArgs = {
  id: Scalars['ID'];
};


export type MutationDuplicateProductArgs = {
  id: Scalars['ID'];
};


export type MutationDuplicateProposalArgs = {
  changeOrderJobId?: InputMaybe<Scalars['ID']>;
  createNewVersion?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isChangeOrder?: InputMaybe<Scalars['Boolean']>;
  startNewProposal?: InputMaybe<Scalars['Boolean']>;
};


export type MutationFinalizeLinkedServiceAccountArgs = {
  code?: InputMaybe<Scalars['String']>;
  realmId?: InputMaybe<Scalars['String']>;
  service: OrganizationLinkedServiceName;
  state?: InputMaybe<Scalars['String']>;
};


export type MutationFinishRegistrationArgs = {
  input: FinishRegistrationInput;
};


export type MutationGenerateOrganizationDataUploadUrlArgs = {
  contentType: Scalars['String'];
  filename: Scalars['String'];
};


export type MutationGenerateReportArgs = {
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
  type: ReportType;
};


export type MutationGenerateUploadCompanyLogoUrlArgs = {
  contentType: Scalars['String'];
  filename: Scalars['String'];
};


export type MutationGenerateUploadJobPhaseCostItemFileUrlArgs = {
  contentType: Scalars['String'];
  filename: Scalars['String'];
  jobPhaseId: Scalars['ID'];
};


export type MutationGenerateUploadOrganizationDocumentUrlArgs = {
  contentType: Scalars['String'];
  filename: Scalars['String'];
};


export type MutationGenerateUploadOrganizationLogoUrlArgs = {
  contentType: Scalars['String'];
  filename: Scalars['String'];
};


export type MutationGenerateUploadProjectFileUrlArgs = {
  contentType?: InputMaybe<Scalars['String']>;
  filename: Scalars['String'];
};


export type MutationGenerateUploadProposalFileUrlArgs = {
  contentType: Scalars['String'];
  filename: Scalars['String'];
  proposalProductId: Scalars['ID'];
};


export type MutationGetLinkedServiceAuthUrlArgs = {
  service: OrganizationLinkedServiceName;
};


export type MutationInviteUserArgs = {
  input: InviteUserInput;
};


export type MutationLoginArgs = {
  input: LoginInput;
};


export type MutationMergeCompanyArgs = {
  sourceCompany: Scalars['ID'];
  targetCompany: Scalars['ID'];
};


export type MutationPreviewProposalArgs = {
  acceptanceOverride?: InputMaybe<Scalars['String']>;
  attachments?: InputMaybe<Array<Scalars['ID']>>;
  clientEmailOverride?: InputMaybe<Scalars['String']>;
  emailBodyOverride?: InputMaybe<Scalars['String']>;
  emailSubjectOverride?: InputMaybe<Scalars['String']>;
  forceSend?: InputMaybe<Scalars['Boolean']>;
  layout: ProposalLayout;
  proposalId: Scalars['ID'];
  removeIndividualLineItemPricing?: InputMaybe<Scalars['Boolean']>;
  removeUnitPriceAndQuantity?: InputMaybe<Scalars['Boolean']>;
};


export type MutationRegisterArgs = {
  input: RegisterInput;
};


export type MutationRemoveTruckFromProposalProductArgs = {
  id: Scalars['ID'];
};


export type MutationRequestPasswordResetArgs = {
  input: RequestPasswordResetInput;
};


export type MutationResendUserInviteArgs = {
  id: Scalars['ID'];
};


export type MutationResendVerificationEmailArgs = {
  input: ResendVerificationEmailInput;
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationSaveQuickbooksIncomeAccountArgs = {
  id: Scalars['ID'];
};


export type MutationSaveQuickbooksIntegrationArgs = {
  input: QuickbooksIntegrationInput;
};


export type MutationScheduleCustomEventBlockArgs = {
  input: ScheduleCustomEventBlockInput;
};


export type MutationScheduleJobPhaseArgs = {
  blocks: Array<InputMaybe<AddJobPhaseScheduleBlock>>;
  crewId?: InputMaybe<Scalars['ID']>;
  jobPhaseId: Scalars['ID'];
  travelTimeEstimate?: InputMaybe<Scalars['Float']>;
  userIDs?: InputMaybe<Array<Scalars['ID']>>;
  usersColor?: InputMaybe<Scalars['String']>;
};


export type MutationScheduleJobPhaseBlockArgs = {
  input: ScheduleJobPhaseBlockInput;
};


export type MutationSendOrganizationEmailTemplatePreviewArgs = {
  html: Scalars['String'];
};


export type MutationSendProposalArgs = {
  acceptanceOverride?: InputMaybe<Scalars['String']>;
  attachments?: InputMaybe<Array<Scalars['ID']>>;
  clientEmailOverride?: InputMaybe<Scalars['String']>;
  emailBodyOverride?: InputMaybe<Scalars['String']>;
  emailSubjectOverride?: InputMaybe<Scalars['String']>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  forceSend?: InputMaybe<Scalars['Boolean']>;
  layout: ProposalLayout;
  proposalId: Scalars['ID'];
  proposalNotes?: InputMaybe<Scalars['String']>;
  removeIndividualLineItemPricing?: InputMaybe<Scalars['Boolean']>;
  removeUnitPriceAndQuantity?: InputMaybe<Scalars['Boolean']>;
};


export type MutationSendProposalToSpecificRecipientsArgs = {
  clientEmailOverride?: InputMaybe<Scalars['String']>;
  emailBodyOverride?: InputMaybe<Scalars['String']>;
  emailSubjectOverride?: InputMaybe<Scalars['String']>;
  emails: Array<Scalars['String']>;
  forceSend?: InputMaybe<Scalars['Boolean']>;
  proposalId: Scalars['ID'];
  removeIndividualLineItemPricing?: InputMaybe<Scalars['Boolean']>;
  removeUnitPriceAndQuantity?: InputMaybe<Scalars['Boolean']>;
};


export type MutationSetProposalToDraftArgs = {
  id: Scalars['ID'];
};


export type MutationSetProposalToWonArgs = {
  forceSend?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};


export type MutationSignProposalArgs = {
  email: Scalars['String'];
  removeProducts?: InputMaybe<Array<Scalars['String']>>;
  signature: Scalars['String'];
  signeeInitials: Scalars['String'];
  signeeName: Scalars['String'];
  signeeTitle: Scalars['String'];
  uuid: Scalars['String'];
};


export type MutationToggleProposalProductOptionalityArgs = {
  id: Scalars['ID'];
  isOptional: Scalars['Boolean'];
};


export type MutationUnlinkServiceArgs = {
  service: OrganizationLinkedServiceName;
};


export type MutationUnscheduleCustomEventArgs = {
  id: Scalars['ID'];
};


export type MutationUnscheduleJobPhaseArgs = {
  jobPhaseId: Scalars['ID'];
};


export type MutationUpdateAdditionalCostArgs = {
  input: UpdateAdditionalCostInput;
};


export type MutationUpdateCompanyArgs = {
  input: UpdateCompanyInput;
};


export type MutationUpdateCompanyNotesArgs = {
  input: UpdateCompanyNotesInput;
};


export type MutationUpdateCompanyProjectFileFolderIdArgs = {
  id: Scalars['ID'];
  projectFilesFolderId?: InputMaybe<Scalars['ID']>;
};


export type MutationUpdateCrewArgs = {
  input: UpdateCrewInput;
};


export type MutationUpdateCustomEventArgs = {
  input?: InputMaybe<UpdateCustomEventInput>;
};


export type MutationUpdateEmployeeArgs = {
  input: UpdateEmployeeInput;
};


export type MutationUpdateEquipmentPieceArgs = {
  input: UpdateEquipmentPieceInput;
};


export type MutationUpdateJobBillingStatusArgs = {
  billingStatus: JobBillingStatus;
  id: Scalars['ID'];
};


export type MutationUpdateJobNotesArgs = {
  id: Scalars['ID'];
  notes: Scalars['String'];
};


export type MutationUpdateJobPhaseNotesArgs = {
  input: UpdateJobPhaseNotesInput;
};


export type MutationUpdateJobPhaseStatusArgs = {
  id: Scalars['ID'];
  status: JobPhaseStatus;
};


export type MutationUpdateJobProjectFileFolderIdArgs = {
  id: Scalars['ID'];
  projectFilesFolderId?: InputMaybe<Scalars['ID']>;
};


export type MutationUpdateJobProjectManagerArgs = {
  id: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationUpdateNotificationTriggerArgs = {
  input: UpdateNotificationTriggerInput;
};


export type MutationUpdateOpportunityArgs = {
  input: UpdateOpportunityInput;
};


export type MutationUpdateOrganizationArgs = {
  input: UpdateOrganizationInput;
};


export type MutationUpdateOrganizationAddressArgs = {
  input: UpdateOrganizationAddressInput;
};


export type MutationUpdateOrganizationAddressPrimaryArgs = {
  id: Scalars['ID'];
};


export type MutationUpdateOrganizationConversionFactorOverrideArgs = {
  input: UpdateOrganizationConversionFactorOverrideInput;
};


export type MutationUpdateOrganizationEmailTemplateArgs = {
  html?: InputMaybe<Scalars['String']>;
  type: OrganizationEmailTemplateType;
};


export type MutationUpdateOrganizationProductTypeArgs = {
  input: UpdateOrganizationProductTypeInput;
};


export type MutationUpdateOrganizationProposalContentArgs = {
  content: Scalars['String'];
  type: ProposalContentType;
};


export type MutationUpdateOrganizationProposalDefaultsArgs = {
  input: UpdateOrganizationProposalDefaultsInput;
};


export type MutationUpdateOrganizationProposalSentEmailTextArgs = {
  id: Scalars['ID'];
  text: Scalars['String'];
};


export type MutationUpdateOrganizationSalesTaxesArgs = {
  input: UpdateOrganizationSalesTaxesInput;
};


export type MutationUpdateOrganizationSettingsArgs = {
  settings: Array<UpdateOrganizationSettingsInput>;
};


export type MutationUpdateOrganizationUserArgs = {
  input: UpdateOrganizationUserInput;
};


export type MutationUpdatePlantArgs = {
  input: UpdatePlantInput;
};


export type MutationUpdateProductArgs = {
  input: UpdateProductInput;
};


export type MutationUpdateProposalArgs = {
  companyId: Scalars['ID'];
  contactId: Scalars['ID'];
  id: Scalars['ID'];
  source?: InputMaybe<ProposalSource>;
};


export type MutationUpdateProposalAddressArgs = {
  input: UpdateProposalAddress;
};


export type MutationUpdateProposalInfoArgs = {
  input?: InputMaybe<UpdateProposalInfoInput>;
};


export type MutationUpdateProposalPlantProductArgs = {
  plantProductId: Scalars['ID'];
  proposalProductId: Scalars['ID'];
};


export type MutationUpdateProposalProductArgs = {
  input: UpdateProposalProductInput;
};


export type MutationUpdateProposalSalesTaxesArgs = {
  input?: InputMaybe<UpdateProposalSalesTaxesInput>;
};


export type MutationUpdateProposalStageArgs = {
  addressOverride?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  mapData?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateProposalStagesOrderingArgs = {
  input: UpdateProposalStagesOrdering;
};


export type MutationUpdateRolesWithPermissionsArgs = {
  input?: InputMaybe<UpdateRolesWithPermissionsInput>;
};


export type MutationUpdateStageProductsOrderingArgs = {
  input: UpdateProposalProductsOrderingInput;
};


export type MutationUpdateTimeBucketArgs = {
  input: UpdateTimeBucketInput;
};


export type MutationUpdateTimeEntryArgs = {
  input: UpdateTimeEntryInput;
};


export type MutationUpdateTransferTruckArgs = {
  input: UpdateTransferTruckInput;
};


export type MutationUpdateWorkOrderItemsArgs = {
  input: UpdateWorkOrderItemsInput;
};


export type MutationValidateRegistrationTokenArgs = {
  input: ValidateRegistrationTokenInput;
};

export type NotificationTrigger = {
  __typename?: 'NotificationTrigger';
  active: Scalars['Boolean'];
  additionalRecipientTypes?: Maybe<Array<NotificationTriggerAdditionalRecipientTypes | `${NotificationTriggerAdditionalRecipientTypes}`>>;
  additionalRecipients: Array<NotificationTriggerRecipient>;
  content: Scalars['String'];
  delay: Scalars['Int'];
  emailSubject?: Maybe<Scalars['String']>;
  event: NotificationTriggerEvent | `${NotificationTriggerEvent}`;
  id: Scalars['ID'];
  isEmail?: Maybe<Scalars['Boolean']>;
  isSMS?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  organization: Organization;
  sendToAllRecipients: Scalars['Boolean'];
  sendToContact: Scalars['Boolean'];
  sendToUser: Scalars['Boolean'];
  smsContent?: Maybe<Scalars['String']>;
  type: NotificationTriggerType | `${NotificationTriggerType}`;
};

export enum NotificationTriggerAdditionalRecipientTypes {
  /** Foreman */
  FOREMAN = 'FOREMAN'
}

export enum NotificationTriggerEvent {
  /** Before job phase starts */
  BEFORE_JOB_PHASE_STARTS = 'BEFORE_JOB_PHASE_STARTS',
  /** Before job starts */
  BEFORE_JOB_STARTS = 'BEFORE_JOB_STARTS',
  /** Contact created */
  CONTACT_CREATED = 'CONTACT_CREATED',
  /** Contact updated */
  CONTACT_UPDATED = 'CONTACT_UPDATED',
  /** Job completed */
  JOB_COMPLETED = 'JOB_COMPLETED',
  /** Job created */
  JOB_CREATED = 'JOB_CREATED',
  /** Job phase completed */
  JOB_PHASE_COMPLETED = 'JOB_PHASE_COMPLETED',
  /** Job phase rescheduled */
  JOB_PHASE_RESCHEDULED = 'JOB_PHASE_RESCHEDULED',
  /** Job phase scheduled */
  JOB_PHASE_SCHEDULED = 'JOB_PHASE_SCHEDULED',
  /** Job rescheduled */
  JOB_RESCHEDULED = 'JOB_RESCHEDULED',
  /** Job scheduled */
  JOB_SCHEDULED = 'JOB_SCHEDULED',
  /** Job started */
  JOB_STARTED = 'JOB_STARTED',
  /** Opportunity created */
  OPPORTUNITY_CREATED = 'OPPORTUNITY_CREATED',
  /** Proposal canceled */
  PROPOSAL_CANCELED = 'PROPOSAL_CANCELED',
  /** Proposal draft not sent */
  PROPOSAL_DRAFT_NOT_SENT = 'PROPOSAL_DRAFT_NOT_SENT',
  /** Proposal email clicked */
  PROPOSAL_EMAIL_CLICKED = 'PROPOSAL_EMAIL_CLICKED',
  /** Proposal email opened */
  PROPOSAL_EMAIL_OPENED = 'PROPOSAL_EMAIL_OPENED',
  /** Proposal lost */
  PROPOSAL_LOST = 'PROPOSAL_LOST',
  /** Proposal reassigned */
  PROPOSAL_REASSIGNED = 'PROPOSAL_REASSIGNED',
  /** Proposal sent */
  PROPOSAL_SENT = 'PROPOSAL_SENT',
  /** Proposal sent not viewed */
  PROPOSAL_SENT_NOT_VIEWED = 'PROPOSAL_SENT_NOT_VIEWED',
  /** Proposal started */
  PROPOSAL_STARTED = 'PROPOSAL_STARTED',
  /** Proposal status changed */
  PROPOSAL_STATUS_CHANGED = 'PROPOSAL_STATUS_CHANGED',
  /** Proposal viewed not signed */
  PROPOSAL_VIEWED_NOT_SIGNED = 'PROPOSAL_VIEWED_NOT_SIGNED',
  /** Proposal won */
  PROPOSAL_WON = 'PROPOSAL_WON'
}

export type NotificationTriggerRecipient = {
  __typename?: 'NotificationTriggerRecipient';
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
};

export enum NotificationTriggerType {
  /** Contact */
  CONTACT = 'CONTACT',
  /** Job */
  JOB = 'JOB',
  /** Job phase */
  JOB_PHASE = 'JOB_PHASE',
  /** Opportunity */
  OPPORTUNITY = 'OPPORTUNITY',
  /** Proposal */
  PROPOSAL = 'PROPOSAL'
}

export type NotificationTypeInput = {
  CONTACT?: InputMaybe<Scalars['Boolean']>;
  JOB?: InputMaybe<Scalars['Boolean']>;
  JOB_PHASE?: InputMaybe<Scalars['Boolean']>;
  OPPORTUNITY?: InputMaybe<Scalars['Boolean']>;
  PROPOSAL?: InputMaybe<Scalars['Boolean']>;
};

export type NotificationTypeOptions = {
  __typename?: 'NotificationTypeOptions';
  CONTACT?: Maybe<Scalars['Boolean']>;
  JOB?: Maybe<Scalars['Boolean']>;
  JOB_PHASE?: Maybe<Scalars['Boolean']>;
  OPPORTUNITY?: Maybe<Scalars['Boolean']>;
  PROPOSAL?: Maybe<Scalars['Boolean']>;
};

export type Opportunity = {
  __typename?: 'Opportunity';
  addressCity: Scalars['String'];
  addressCountry: Scalars['String'];
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  addressState: Scalars['String'];
  addressZip: Scalars['String'];
  company: Company;
  companyId: Scalars['ID'];
  contact: Contact;
  contactId: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  dueAt?: Maybe<Scalars['Date']>;
  estimatedOpportunityValue?: Maybe<Scalars['Float']>;
  externalId: Scalars['ID'];
  id: Scalars['ID'];
  name: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  products?: Maybe<Array<OrganizationProductType>>;
  projectFilesFolderId?: Maybe<Scalars['ID']>;
  source?: Maybe<OpportunitySource | `${OpportunitySource}`>;
  status: Scalars['String'];
  statusId: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']>;
};

export enum OpportunitySource {
  /** Advertisements */
  ADVERTISEMENTS = 'ADVERTISEMENTS',
  /** Channel sales */
  CHANNEL_SALES = 'CHANNEL_SALES',
  /** Existing relationship */
  EXISTING_RELATIONSHIP = 'EXISTING_RELATIONSHIP',
  /** Expo lead */
  EXPO_LEAD = 'EXPO_LEAD',
  /** External sales */
  EXTERNAL_SALES = 'EXTERNAL_SALES',
  /** Internal sales */
  INTERNAL_SALES = 'INTERNAL_SALES',
  /** Online */
  ONLINE = 'ONLINE',
  /** Other */
  OTHER = 'OTHER',
  /** Referral */
  REFERRAL = 'REFERRAL',
  /** Repeat customer */
  REPEAT_CUSTOMER = 'REPEAT_CUSTOMER',
  /** Social media */
  SOCIAL_MEDIA = 'SOCIAL_MEDIA',
  /** Trade shows */
  TRADE_SHOWS = 'TRADE_SHOWS',
  /** Website lead */
  WEBSITE_LEAD = 'WEBSITE_LEAD',
  /** Website request */
  WEBSITE_REQUEST = 'WEBSITE_REQUEST'
}

export enum OpportunityStatus {
  /** Canceled */
  CANCELED = 'CANCELED',
  /** Closed lost */
  CLOSED_LOST = 'CLOSED_LOST',
  /** Closed won */
  CLOSED_WON = 'CLOSED_WON',
  /** Open */
  OPEN = 'OPEN',
  /** Proposal created */
  PROPOSAL_CREATED = 'PROPOSAL_CREATED',
  /** Unassigned */
  UNASSIGNED = 'UNASSIGNED'
}

/** Allows ordering a list of records. */
export type OrderByClause = {
  /** The column that is used for ordering. */
  column: Scalars['String'];
  /** The direction that is used for ordering. */
  order: SortOrder | `${SortOrder}`;
};

/** Aggregate functions when ordering by a relation without specifying a column. */
export enum OrderByRelationAggregateFunction {
  /** Amount of items. */
  COUNT = 'COUNT'
}

/** Aggregate functions when ordering by a relation that may specify a column. */
export enum OrderByRelationWithColumnAggregateFunction {
  /** Average. */
  AVG = 'AVG',
  /** Amount of items. */
  COUNT = 'COUNT',
  /** Maximum. */
  MAX = 'MAX',
  /** Minimum. */
  MIN = 'MIN',
  /** Sum. */
  SUM = 'SUM'
}

export type Organization = {
  __typename?: 'Organization';
  conversionFactorOverride?: Maybe<OrganizationConversionFactorOverride>;
  documents?: Maybe<Array<OrganizationDocument>>;
  email?: Maybe<Scalars['String']>;
  emailTemplate: OrganizationEmailTemplateType | `${OrganizationEmailTemplateType}`;
  failingPayment: Scalars['Boolean'];
  id: Scalars['ID'];
  linkedServices?: Maybe<Array<OrganizationLinkedService>>;
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  onTrial?: Maybe<Scalars['Boolean']>;
  phone?: Maybe<Scalars['String']>;
  proposalDefaults: ProposalDefault;
  proposalSentEmailText?: Maybe<Scalars['String']>;
  salesTaxes?: Maybe<Array<OrganizationSalesTax>>;
  subscribed: Scalars['Boolean'];
  subscription?: Maybe<StripeSubscription>;
  timezone?: Maybe<Scalars['String']>;
  trialEndsAt?: Maybe<Scalars['DateTime']>;
};

export type OrganizationAddress = {
  __typename?: 'OrganizationAddress';
  city: Scalars['String'];
  country: Scalars['String'];
  id: Scalars['ID'];
  isPrimary: Scalars['Boolean'];
  latitude: Scalars['String'];
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  longitude: Scalars['String'];
  state: Scalars['String'];
  zip: Scalars['String'];
};

/** A paginated list of OrganizationAddress items. */
export type OrganizationAddressPaginator = {
  __typename?: 'OrganizationAddressPaginator';
  /** A list of OrganizationAddress items. */
  data: Array<OrganizationAddress>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type OrganizationApiKey = {
  __typename?: 'OrganizationApiKey';
  api_key: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['ID'];
  is_active: Scalars['Boolean'];
  organizationId: Scalars['String'];
};

export type OrganizationConversionFactorOverride = {
  __typename?: 'OrganizationConversionFactorOverride';
  asphaltTonConversionFactorOverride: Scalars['String'];
  excavateOutTonConversionFactorOverride: Scalars['String'];
  id: Scalars['ID'];
  organization: Organization;
};

export type OrganizationDataUpload = {
  __typename?: 'OrganizationDataUpload';
  createdAt: Scalars['DateTime'];
  error?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  organization: Organization;
  path: Scalars['String'];
  startedAt?: Maybe<Scalars['DateTime']>;
  status: OrganizationDataUploadStatus | `${OrganizationDataUploadStatus}`;
  type: OrganizationDataUploadType | `${OrganizationDataUploadType}`;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
};

/** A paginated list of OrganizationDataUpload items. */
export type OrganizationDataUploadPaginator = {
  __typename?: 'OrganizationDataUploadPaginator';
  /** A list of OrganizationDataUpload items. */
  data: Array<OrganizationDataUpload>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum OrganizationDataUploadStatus {
  /** Errored */
  ERRORED = 'ERRORED',
  /** Finished */
  FINISHED = 'FINISHED',
  /** Processing */
  PROCESSING = 'PROCESSING',
  /** Queued */
  QUEUED = 'QUEUED'
}

export enum OrganizationDataUploadType {
  /** Additional costs */
  ADDITIONAL_COSTS = 'ADDITIONAL_COSTS',
  /** Companies */
  COMPANIES = 'COMPANIES',
  /** Contacts */
  CONTACTS = 'CONTACTS',
  /** Crews */
  CREWS = 'CREWS',
  /** Equipment pieces */
  EQUIPMENT_PIECES = 'EQUIPMENT_PIECES',
  /** Plants */
  PLANTS = 'PLANTS',
  /** Transfer trucks */
  TRANSFER_TRUCKS = 'TRANSFER_TRUCKS'
}

export type OrganizationDocument = {
  __typename?: 'OrganizationDocument';
  id: Scalars['ID'];
  name: Scalars['String'];
  organization: Organization;
  path: Scalars['String'];
  thumbnailPath?: Maybe<Scalars['String']>;
};

export type OrganizationEmailTemplate = {
  __typename?: 'OrganizationEmailTemplate';
  html: Scalars['String'];
  id: Scalars['ID'];
  organization?: Maybe<Organization>;
  type: OrganizationEmailTemplateType | `${OrganizationEmailTemplateType}`;
};

export enum OrganizationEmailTemplateType {
  /** Custom */
  CUSTOM = 'CUSTOM',
  /** Default */
  DEFAULT = 'DEFAULT'
}

export type OrganizationLinkedService = {
  __typename?: 'OrganizationLinkedService';
  active: Scalars['Boolean'];
  expired: Scalars['Boolean'];
  id: Scalars['ID'];
  service: OrganizationLinkedServiceName | `${OrganizationLinkedServiceName}`;
  type: OrganizationLinkedServiceType | `${OrganizationLinkedServiceType}`;
};

export enum OrganizationLinkedServiceName {
  /** Quickbooks */
  QUICKBOOKS = 'QUICKBOOKS',
  /** Quickbooks desktop */
  QUICKBOOKS_DESKTOP = 'QUICKBOOKS_DESKTOP'
}

export enum OrganizationLinkedServiceType {
  /** Accounting */
  ACCOUNTING = 'ACCOUNTING'
}

export type OrganizationOpportunityStatus = {
  __typename?: 'OrganizationOpportunityStatus';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type OrganizationProductType = {
  __typename?: 'OrganizationProductType';
  id: Scalars['ID'];
  indirectPercentage?: Maybe<Scalars['Int']>;
  markupPercentage?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  overheadPercentage?: Maybe<Scalars['Int']>;
  type: ProductType | `${ProductType}`;
};

export type OrganizationProposalContent = {
  __typename?: 'OrganizationProposalContent';
  content: Scalars['String'];
  id: Scalars['ID'];
  type: ProposalContentType | `${ProposalContentType}`;
};

export type OrganizationSalesTax = {
  __typename?: 'OrganizationSalesTax';
  id: Scalars['ID'];
  isDefault: Scalars['Boolean'];
  name: Scalars['String'];
  percentage: Scalars['Float'];
  quickbooksDesktopTaxCodeId?: Maybe<Scalars['ID']>;
  quickbooksTaxCodeId?: Maybe<Scalars['ID']>;
};

export type OrganizationSetting = {
  __typename?: 'OrganizationSetting';
  key: Scalars['String'];
  value: Scalars['String'];
};

/** Information about pagination using a Relay style cursor connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** Number of nodes in the current page. */
  count: Scalars['Int'];
  /** Index of the current page. */
  currentPage: Scalars['Int'];
  /** The cursor to continue paginating forwards. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** Index of the last available page. */
  lastPage: Scalars['Int'];
  /** The cursor to continue paginating backwards. */
  startCursor?: Maybe<Scalars['String']>;
  /** Total number of nodes in the paginated connection. */
  total: Scalars['Int'];
};

/** Information about pagination using a fully featured paginator. */
export type PaginatorInfo = {
  __typename?: 'PaginatorInfo';
  /** Number of items in the current page. */
  count: Scalars['Int'];
  /** Index of the current page. */
  currentPage: Scalars['Int'];
  /** Index of the first item in the current page. */
  firstItem?: Maybe<Scalars['Int']>;
  /** Are there more pages after this one? */
  hasMorePages: Scalars['Boolean'];
  /** Index of the last item in the current page. */
  lastItem?: Maybe<Scalars['Int']>;
  /** Index of the last available page. */
  lastPage: Scalars['Int'];
  /** Number of items per page. */
  perPage: Scalars['Int'];
  /** Number of total available items. */
  total: Scalars['Int'];
};

export type PersonSales = {
  __typename?: 'PersonSales';
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  proposalsWonCount: Scalars['Int'];
  proposalsWonPercentage: Scalars['Float'];
  proposalsWonSum?: Maybe<Scalars['String']>;
  sentProposalsCount: Scalars['Int'];
  winRate?: Maybe<Scalars['Float']>;
};

export type Plant = {
  __typename?: 'Plant';
  addressCity: Scalars['String'];
  addressCountry: Scalars['String'];
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  addressState: Scalars['String'];
  addressZip: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  phone: Scalars['String'];
  products: Array<PlantProduct>;
};

/** A paginated list of Plant items. */
export type PlantPaginator = {
  __typename?: 'PlantPaginator';
  /** A list of Plant items. */
  data: Array<Plant>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type PlantProduct = {
  __typename?: 'PlantProduct';
  id: Scalars['ID'];
  rate: Scalars['Int'];
  type: Scalars['String'];
};

export enum PlantProductType {
  /** Asphalt */
  ASPHALT = 'ASPHALT',
  /** Asphalt 1 2 apwa spec */
  ASPHALT_1_2_APWA_SPEC = 'ASPHALT_1_2_APWA_SPEC',
  /** Asphalt 3 4 apwa spec */
  ASPHALT_3_4_APWA_SPEC = 'ASPHALT_3_4_APWA_SPEC',
  /** Asphalt commercial mix 1 2 */
  ASPHALT_COMMERCIAL_MIX_1_2 = 'ASPHALT_COMMERCIAL_MIX_1_2',
  /** Asphalt commercial mix 3 4 */
  ASPHALT_COMMERCIAL_MIX_3_4 = 'ASPHALT_COMMERCIAL_MIX_3_4',
  /** Base course */
  BASE_COURSE = 'BASE_COURSE',
  /** Binder course */
  BINDER_COURSE = 'BINDER_COURSE',
  /** Chip washed standard 3 8 */
  CHIP_WASHED_STANDARD_3_8 = 'CHIP_WASHED_STANDARD_3_8',
  /** Concrete flatwork */
  CONCRETE_FLATWORK = 'CONCRETE_FLATWORK',
  /** Concrete walls */
  CONCRETE_WALLS = 'CONCRETE_WALLS',
  /** Crushed concrete 1 apwa */
  CRUSHED_CONCRETE_1_APWA = 'CRUSHED_CONCRETE_1_APWA',
  /** Debris */
  DEBRIS = 'DEBRIS',
  /** Fine course */
  FINE_COURSE = 'FINE_COURSE',
  /** Fine gravel */
  FINE_GRAVEL = 'FINE_GRAVEL',
  /** Rip rap 12 max */
  RIP_RAP_12_MAX = 'RIP_RAP_12_MAX',
  /** Road base */
  ROAD_BASE = 'ROAD_BASE',
  /** Road base 1 */
  ROAD_BASE_1 = 'ROAD_BASE_1',
  /** Road base 1 2 */
  ROAD_BASE_1_2 = 'ROAD_BASE_1_2',
  /** Road base 1 2 apwa spec */
  ROAD_BASE_1_2_APWA_SPEC = 'ROAD_BASE_1_2_APWA_SPEC',
  /** Road base 1 apwa spec */
  ROAD_BASE_1_APWA_SPEC = 'ROAD_BASE_1_APWA_SPEC',
  /** Road base 3 4 */
  ROAD_BASE_3_4 = 'ROAD_BASE_3_4',
  /** Road base 3 4 apwa spec */
  ROAD_BASE_3_4_APWA_SPEC = 'ROAD_BASE_3_4_APWA_SPEC',
  /** Rock unwashed 1 1 2 maximum */
  ROCK_UNWASHED_1_1_2_MAXIMUM = 'ROCK_UNWASHED_1_1_2_MAXIMUM',
  /** Rock unwashed 3 4 or 1 maximum */
  ROCK_UNWASHED_3_4_OR_1_MAXIMUM = 'ROCK_UNWASHED_3_4_OR_1_MAXIMUM',
  /** Slurry sand type 1 */
  SLURRY_SAND_TYPE_1 = 'SLURRY_SAND_TYPE_1',
  /** Slurry sand type 2 */
  SLURRY_SAND_TYPE_2 = 'SLURRY_SAND_TYPE_2',
  /** Slurry sand type 3 */
  SLURRY_SAND_TYPE_3 = 'SLURRY_SAND_TYPE_3',
  /** Top course */
  TOP_COURSE = 'TOP_COURSE'
}

export type PlantTransferTruck = {
  __typename?: 'PlantTransferTruck';
  id: Scalars['ID'];
  rateHourly?: Maybe<Scalars['Int']>;
  rateTon?: Maybe<Scalars['Int']>;
  tonnage?: Maybe<Scalars['Int']>;
  transferTruck: TransferTruck;
};

export type PreviewSubscriptionChangeResponse = {
  __typename?: 'PreviewSubscriptionChangeResponse';
  totalOnRenewal: Scalars['Int'];
  totalToday: Scalars['Int'];
};

export type Product = {
  __typename?: 'Product';
  /** @deprecated Use productEquipmentPieces instead with Apollo Caching */
  additionalCosts: Array<AdditionalCost>;
  /** Area Coverage */
  areaCoverage?: Maybe<Scalars['Float']>;
  attributes?: Maybe<ProductAttributes>;
  costMaterial?: Maybe<Scalars['Int']>;
  costMinimumProduct?: Maybe<Scalars['Int']>;
  costMinimumProposal?: Maybe<Scalars['Int']>;
  crew?: Maybe<Crew>;
  dailyUnitsComplete?: Maybe<Scalars['Int']>;
  /** @deprecated Use productEquipmentPieces instead with Apollo Caching */
  equipmentPieces: Array<EquipmentPiece>;
  externalProductName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  indirectPercentage?: Maybe<Scalars['Int']>;
  labourCostType?: Maybe<ProductLabourCostType | `${ProductLabourCostType}`>;
  markupPercentage?: Maybe<Scalars['Int']>;
  measurementJob?: Maybe<ProductMeasurementJob | `${ProductMeasurementJob}`>;
  measurementMaterial?: Maybe<ProductMeasurementMaterial | `${ProductMeasurementMaterial}`>;
  name: Scalars['String'];
  organizationProductType: OrganizationProductType;
  overheadPercentage?: Maybe<Scalars['Int']>;
  plant?: Maybe<Plant>;
  plantProductId?: Maybe<Scalars['String']>;
  productAdditionalCosts?: Maybe<Array<ProductAdditionalCost>>;
  productEquipmentPieces?: Maybe<Array<ProductEquipmentPiece>>;
  productionRateType?: Maybe<ProductProductionRateType | `${ProductProductionRateType}`>;
  statementOfWork?: Maybe<Scalars['String']>;
  subcontracted: Scalars['Boolean'];
  type: ProductType | `${ProductType}`;
  unitPrice?: Maybe<Scalars['Int']>;
  unitPriceProduct: Scalars['Boolean'];
};

export type ProductAdditionalCost = {
  __typename?: 'ProductAdditionalCost';
  additionalCost: AdditionalCost;
  id: Scalars['ID'];
  type?: Maybe<ProductAdditionalCostType | `${ProductAdditionalCostType}`>;
};

export type ProductAdditionalCostPivot = {
  __typename?: 'ProductAdditionalCostPivot';
  type?: Maybe<ProductAdditionalCostType | `${ProductAdditionalCostType}`>;
};

export enum ProductAdditionalCostType {
  /** Additive */
  ADDITIVE = 'ADDITIVE',
  /** Cement */
  CEMENT = 'CEMENT',
  /** Emulsion oil */
  EMULSION_OIL = 'EMULSION_OIL',
  /** Water */
  WATER = 'WATER'
}

export type ProductAttributeAsphalt = {
  __typename?: 'ProductAttributeAsphalt';
  applicationRate?: Maybe<Scalars['Float']>;
};

export type ProductAttributeConcreteColumn = {
  __typename?: 'ProductAttributeConcreteColumn';
  diameter?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
};

export type ProductAttributeConcreteCurbOrGutter = {
  __typename?: 'ProductAttributeConcreteCurbOrGutter';
  curbHeight?: Maybe<Scalars['Float']>;
  curbWidth?: Maybe<Scalars['Float']>;
  gutterHeight?: Maybe<Scalars['Float']>;
  gutterWidth?: Maybe<Scalars['Float']>;
};

export type ProductAttributeConcreteFlatwork = {
  __typename?: 'ProductAttributeConcreteFlatwork';
  applicationRate?: Maybe<Scalars['Float']>;
};

export type ProductAttributeConcreteFooting = {
  __typename?: 'ProductAttributeConcreteFooting';
  depth?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

export type ProductAttributeConcreteWall = {
  __typename?: 'ProductAttributeConcreteWall';
  height?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
};

export type ProductAttributeConcreteWaterway = {
  __typename?: 'ProductAttributeConcreteWaterway';
  curbHeight?: Maybe<Scalars['Float']>;
  curbWidth?: Maybe<Scalars['Float']>;
  gutterHeight?: Maybe<Scalars['Float']>;
  gutterWidth?: Maybe<Scalars['Float']>;
};

export type ProductAttributeCrackSeal = {
  __typename?: 'ProductAttributeCrackSeal';
  crackDepth?: Maybe<Scalars['Float']>;
  crackWidth?: Maybe<Scalars['Float']>;
  overbandThickness?: Maybe<Scalars['Float']>;
  overbandWidth?: Maybe<Scalars['Float']>;
  poundsPerBlock?: Maybe<Scalars['Float']>;
  poundsPerGallon?: Maybe<Scalars['Float']>;
};

export type ProductAttributeCurbWall = {
  __typename?: 'ProductAttributeCurbWall';
  curbHeight?: Maybe<Scalars['Float']>;
  curbWidth?: Maybe<Scalars['Float']>;
  gutterHeight?: Maybe<Scalars['Float']>;
  gutterWidth?: Maybe<Scalars['Float']>;
};

export type ProductAttributeExcavateOut = {
  __typename?: 'ProductAttributeExcavateOut';
  applicationRate?: Maybe<Scalars['Float']>;
};

export type ProductAttributeGrading = {
  __typename?: 'ProductAttributeGrading';
  applicationRate?: Maybe<Scalars['Float']>;
  poundsPerCubicYard?: Maybe<Scalars['Float']>;
};

export type ProductAttributeMastic = {
  __typename?: 'ProductAttributeMastic';
  crackDepth?: Maybe<Scalars['Float']>;
  crackWidth?: Maybe<Scalars['Float']>;
  overbandThickness?: Maybe<Scalars['Float']>;
  overbandWidth?: Maybe<Scalars['Float']>;
  poundsPerBlock?: Maybe<Scalars['Float']>;
  poundsPerGallon?: Maybe<Scalars['Float']>;
};

export type ProductAttributeMicrosurfacing = {
  __typename?: 'ProductAttributeMicrosurfacing';
  applicationRate?: Maybe<Scalars['Float']>;
};

export type ProductAttributeSealCoat = {
  __typename?: 'ProductAttributeSealCoat';
  applicationRate?: Maybe<Scalars['Float']>;
};

export type ProductAttributeSlurrySeal = {
  __typename?: 'ProductAttributeSlurrySeal';
  applicationRate?: Maybe<Scalars['Float']>;
};

export type ProductAttributeStriping = {
  __typename?: 'ProductAttributeStriping';
  applicationRate?: Maybe<Scalars['Float']>;
  lineWidth?: Maybe<Scalars['Float']>;
};

export type ProductAttributes = ProductAttributeAsphalt | ProductAttributeConcreteColumn | ProductAttributeConcreteCurbOrGutter | ProductAttributeConcreteFlatwork | ProductAttributeConcreteFooting | ProductAttributeConcreteWall | ProductAttributeConcreteWaterway | ProductAttributeCrackSeal | ProductAttributeCurbWall | ProductAttributeExcavateOut | ProductAttributeGrading | ProductAttributeMastic | ProductAttributeMicrosurfacing | ProductAttributeSealCoat | ProductAttributeSlurrySeal | ProductAttributeStriping;

export type ProductAttributesInput = {
  applicationRate?: InputMaybe<Scalars['Float']>;
  crackDepth?: InputMaybe<Scalars['Float']>;
  crackWidth?: InputMaybe<Scalars['Float']>;
  curbHeight?: InputMaybe<Scalars['Float']>;
  curbWidth?: InputMaybe<Scalars['Float']>;
  depth?: InputMaybe<Scalars['Float']>;
  diameter?: InputMaybe<Scalars['Float']>;
  gutterHeight?: InputMaybe<Scalars['Float']>;
  gutterWidth?: InputMaybe<Scalars['Float']>;
  height?: InputMaybe<Scalars['Float']>;
  lineWidth?: InputMaybe<Scalars['Float']>;
  overbandThickness?: InputMaybe<Scalars['Float']>;
  overbandWidth?: InputMaybe<Scalars['Float']>;
  poundsPerBlock?: InputMaybe<Scalars['Float']>;
  poundsPerCubicYard?: InputMaybe<Scalars['Float']>;
  poundsPerGallon?: InputMaybe<Scalars['Float']>;
  transferTruckLoadTime?: InputMaybe<Scalars['Float']>;
  transferTruckUnloadTime?: InputMaybe<Scalars['Float']>;
  width?: InputMaybe<Scalars['Float']>;
};

export type ProductEquipmentPiece = {
  __typename?: 'ProductEquipmentPiece';
  equipmentPiece: EquipmentPiece;
  id: Scalars['ID'];
  quantity: Scalars['Int'];
};

export type ProductEquipmentPivot = {
  __typename?: 'ProductEquipmentPivot';
  quantity: Scalars['Int'];
};

export enum ProductLabourCostType {
  /** Job */
  JOB = 'JOB',
  /** Per man hour */
  PER_MAN_HOUR = 'PER_MAN_HOUR',
  /** Per unit complete */
  PER_UNIT_COMPLETE = 'PER_UNIT_COMPLETE'
}

export type ProductMaterialUsed = {
  __typename?: 'ProductMaterialUsed';
  jobSizeComplete?: Maybe<Scalars['String']>;
  productMaterialUsed: Scalars['String'];
  productType: Scalars['String'];
  proposalJobSize: Scalars['String'];
  proposalMaterialNeeded?: Maybe<Scalars['String']>;
};

export enum ProductMeasurementJob {
  /** Linear foot */
  LINEAR_FOOT = 'LINEAR_FOOT',
  /** Square foot */
  SQUARE_FOOT = 'SQUARE_FOOT',
  /** Square yard */
  SQUARE_YARD = 'SQUARE_YARD',
  /** Unit */
  UNIT = 'UNIT'
}

export enum ProductMeasurementMaterial {
  /** Block */
  BLOCK = 'BLOCK',
  /** Gallon */
  GALLON = 'GALLON',
  /** Pound */
  POUND = 'POUND',
  /** Ton */
  TON = 'TON',
  /** Unit */
  UNIT = 'UNIT',
  /** Yard */
  YARD = 'YARD'
}

/** A paginated list of Product items. */
export type ProductPaginator = {
  __typename?: 'ProductPaginator';
  /** A list of Product items. */
  data: Array<Product>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum ProductProductionRateType {
  /** Sq ft sq yd per hour */
  SQ_FT_SQ_YD_PER_HOUR = 'SQ_FT_SQ_YD_PER_HOUR',
  /** Tons per hour */
  TONS_PER_HOUR = 'TONS_PER_HOUR'
}

export type ProductSales = {
  __typename?: 'ProductSales';
  actualProfitPercentage: Scalars['Float'];
  name: Scalars['String'];
  proposedProfitPercentage: Scalars['Float'];
  sumOverallTotal: Scalars['Float'];
};

export type ProductStats = {
  __typename?: 'ProductStats';
  materialUsed?: Maybe<Array<ProductMaterialUsed>>;
  productTypeUsedPercentages?: Maybe<Array<ProductTypeUsed>>;
  products: Array<Maybe<ProductSales>>;
};

export enum ProductType {
  /** Asphalt */
  ASPHALT = 'ASPHALT',
  /** Concrete column */
  CONCRETE_COLUMN = 'CONCRETE_COLUMN',
  /** Concrete curb or gutter */
  CONCRETE_CURB_OR_GUTTER = 'CONCRETE_CURB_OR_GUTTER',
  /** Concrete flatwork */
  CONCRETE_FLATWORK = 'CONCRETE_FLATWORK',
  /** Concrete footing */
  CONCRETE_FOOTING = 'CONCRETE_FOOTING',
  /** Concrete wall */
  CONCRETE_WALL = 'CONCRETE_WALL',
  /** Concrete waterway */
  CONCRETE_WATERWAY = 'CONCRETE_WATERWAY',
  /** Crack seal */
  CRACK_SEAL = 'CRACK_SEAL',
  /** Curb wall */
  CURB_WALL = 'CURB_WALL',
  /** Excavate out */
  EXCAVATE_OUT = 'EXCAVATE_OUT',
  /** Generic */
  GENERIC = 'GENERIC',
  /** Grading */
  GRADING = 'GRADING',
  /** Mastic */
  MASTIC = 'MASTIC',
  /** Microsurfacing */
  MICROSURFACING = 'MICROSURFACING',
  /** Sealcoat */
  SEALCOAT = 'SEALCOAT',
  /** Slurry seal */
  SLURRY_SEAL = 'SLURRY_SEAL',
  /** Striping */
  STRIPING = 'STRIPING'
}

export type ProductTypeUsed = {
  __typename?: 'ProductTypeUsed';
  equipmentUsedPercentage?: Maybe<Scalars['Float']>;
  labourUsedPercentage?: Maybe<Scalars['Float']>;
  materialUsedPercentage?: Maybe<Scalars['Float']>;
  productType: Scalars['String'];
};

export type ProjectFile = {
  __typename?: 'ProjectFile';
  children?: Maybe<Array<ProjectFile>>;
  fileSizeBytes?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  parentFolderId?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  type: ProjectFileType | `${ProjectFileType}`;
};

export enum ProjectFileType {
  /** File */
  FILE = 'FILE',
  /** Folder */
  FOLDER = 'FOLDER'
}

export type Proposal = {
  __typename?: 'Proposal';
  acceptanceOverride?: Maybe<Scalars['String']>;
  activeVersion: Scalars['Boolean'];
  addresses: Array<Maybe<ProposalAddress>>;
  attachments?: Maybe<Array<OrganizationDocument>>;
  changeOrderJobId?: Maybe<Scalars['String']>;
  changeOrders?: Maybe<Array<Proposal>>;
  clientEmailOverride?: Maybe<Scalars['String']>;
  company: Company;
  contact: Contact;
  contactId: Scalars['ID'];
  costAdditional: Scalars['String'];
  costDirect: Scalars['String'];
  costEquipment: Scalars['String'];
  costIndirect: Scalars['String'];
  costLabour: Scalars['String'];
  costMaterial: Scalars['String'];
  costOverhead: Scalars['String'];
  costTaxes: Scalars['String'];
  costTotal: Scalars['String'];
  createdAt: Scalars['DateTime'];
  emailBodyOverride?: Maybe<Scalars['String']>;
  emailBodyOverrideParsed?: Maybe<Scalars['String']>;
  emailSubjectOverride?: Maybe<Scalars['String']>;
  events: Array<ProposalEvent>;
  externalId: Scalars['String'];
  grossMargin: Scalars['String'];
  grossMarginPercentage: Scalars['Int'];
  id: Scalars['ID'];
  isChangeOrder: Scalars['Boolean'];
  isSendable: Scalars['Boolean'];
  layout?: Maybe<ProposalLayout | `${ProposalLayout}`>;
  netMargin: Scalars['String'];
  netMarginPercentage: Scalars['Int'];
  operatingMargin: Scalars['String'];
  operatingMarginPercentage: Scalars['Int'];
  overallTotal: Scalars['String'];
  overallTotalAfterTaxes: Scalars['String'];
  profit: Scalars['String'];
  profitPercentage: Scalars['Int'];
  projectFilesFolderId?: Maybe<Scalars['ID']>;
  proposalNotes?: Maybe<Scalars['String']>;
  recipients: Array<ProposalRecipient>;
  removeIndividualLineItemPricing?: Maybe<Scalars['Boolean']>;
  removeUnitPriceAndQuantity?: Maybe<Scalars['Boolean']>;
  salesTaxes?: Maybe<Array<ProposalSalesTax>>;
  sentAt?: Maybe<Scalars['DateTime']>;
  signedAt?: Maybe<Scalars['DateTime']>;
  signedInitials?: Maybe<Scalars['String']>;
  signedName?: Maybe<Scalars['String']>;
  source?: Maybe<ProposalSource | `${ProposalSource}`>;
  stages: Array<ProposalStage>;
  status: ProposalStatus | `${ProposalStatus}`;
  statusChanges: Array<ProposalStatusChange>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']>;
  uuid: Scalars['String'];
  version: Scalars['String'];
  versions?: Maybe<Array<Proposal>>;
  wonAt?: Maybe<Scalars['DateTime']>;
};

export type ProposalAdditionalCost = {
  __typename?: 'ProposalAdditionalCost';
  additionalCostId?: Maybe<Scalars['ID']>;
  cost: Scalars['Int'];
  costOverride?: Maybe<Scalars['Int']>;
  costTotal?: Maybe<Scalars['String']>;
  feeAmount: Scalars['Float'];
  feeAmountOverride?: Maybe<Scalars['Float']>;
  feeType: AdditionalCostFeeType | `${AdditionalCostFeeType}`;
  id: Scalars['ID'];
  name: Scalars['String'];
  quantity?: Maybe<Scalars['Float']>;
  quantityOverride?: Maybe<Scalars['Float']>;
  showOnProposal: Scalars['Boolean'];
};

export type ProposalAddress = {
  __typename?: 'ProposalAddress';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  latitude: Scalars['String'];
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  longitude: Scalars['String'];
  mapImage?: Maybe<Scalars['String']>;
  organizationAddressId?: Maybe<Scalars['ID']>;
  state?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type ProposalContent = {
  __typename?: 'ProposalContent';
  content: Scalars['String'];
  contentOverride: Scalars['String'];
  type: ProposalContentType | `${ProposalContentType}`;
};

export enum ProposalContentType {
  /** Acceptance */
  ACCEPTANCE = 'ACCEPTANCE',
  /** Invoice details */
  INVOICE_DETAILS = 'INVOICE_DETAILS',
  /** Project summary */
  PROJECT_SUMMARY = 'PROJECT_SUMMARY',
  /** Statement of work */
  STATEMENT_OF_WORK = 'STATEMENT_OF_WORK',
  /** Terms */
  TERMS = 'TERMS',
  /** Title page */
  TITLE_PAGE = 'TITLE_PAGE'
}

export type ProposalCrew = {
  __typename?: 'ProposalCrew';
  cost: Scalars['String'];
  crewId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  rate: Scalars['Int'];
  rateOverride?: Maybe<Scalars['Int']>;
  timeOnjob: Scalars['Int'];
  timeOnjobOverride?: Maybe<Scalars['Int']>;
  timeTravel: Scalars['Int'];
  timeTravelOverride?: Maybe<Scalars['Int']>;
};

export type ProposalDefault = {
  __typename?: 'ProposalDefault';
  autoSave?: Maybe<Scalars['Boolean']>;
  color?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  layout: ProposalLayout | `${ProposalLayout}`;
  removeIndividualLineItemPricing: Scalars['Boolean'];
  removeUnitPriceAndQuantity: Scalars['Boolean'];
};

export type ProposalEquipmentPiece = {
  __typename?: 'ProposalEquipmentPiece';
  chargeType: EquipmentPieceChargeType | `${EquipmentPieceChargeType}`;
  cost: Scalars['String'];
  equipmentPieceId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  quantity: Scalars['Int'];
  quantityOverride?: Maybe<Scalars['Int']>;
  rate: Scalars['Int'];
  rateOverride?: Maybe<Scalars['Int']>;
  timeOnjob: Scalars['Int'];
  timeOnjobOverride?: Maybe<Scalars['Int']>;
  timeTravel: Scalars['Int'];
  timeTravelOverride?: Maybe<Scalars['Int']>;
  usePercentage: Scalars['Int'];
};

export type ProposalEvent = {
  __typename?: 'ProposalEvent';
  action: ProposalEventAction | `${ProposalEventAction}`;
  createdAt: Scalars['DateTime'];
};

export enum ProposalEventAction {
  /** Email clicked */
  EMAIL_CLICKED = 'EMAIL_CLICKED',
  /** Email opened */
  EMAIL_OPENED = 'EMAIL_OPENED',
  /** Resent */
  RESENT = 'RESENT',
  /** Sent */
  SENT = 'SENT',
  /** Viewed */
  VIEWED = 'VIEWED'
}

export type ProposalFile = {
  __typename?: 'ProposalFile';
  createdAt: Scalars['DateTime'];
  filename: Scalars['String'];
  id: Scalars['ID'];
  thumbnail?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export enum ProposalLayout {
  /** Branded */
  BRANDED = 'BRANDED',
  /** Full */
  FULL = 'FULL',
  /** Simple */
  SIMPLE = 'SIMPLE'
}

export type ProposalMaterial = {
  __typename?: 'ProposalMaterial';
  areaCoverage?: Maybe<Scalars['Float']>;
  attributes?: Maybe<ProductAttributes>;
  attributesOverride?: Maybe<ProductAttributes>;
  costMaterial?: Maybe<Scalars['Int']>;
  costMaterialOverride?: Maybe<Scalars['Int']>;
  costMinimumProduct?: Maybe<Scalars['Int']>;
  costMinimumProposal?: Maybe<Scalars['Int']>;
  dailyUnitsComplete?: Maybe<Scalars['String']>;
  dailyUnitsCompleteOverride?: Maybe<Scalars['String']>;
  externalProductName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  indirectPercentage?: Maybe<Scalars['Int']>;
  indirectPercentageOverride?: Maybe<Scalars['Int']>;
  labourCostType?: Maybe<ProductLabourCostType | `${ProductLabourCostType}`>;
  markupPercentage?: Maybe<Scalars['Int']>;
  markupPercentageOverride?: Maybe<Scalars['Int']>;
  materialNeeded?: Maybe<Scalars['Float']>;
  materialNeededOverride?: Maybe<Scalars['Float']>;
  measurementJob?: Maybe<ProductMeasurementJob | `${ProductMeasurementJob}`>;
  measurementMaterial?: Maybe<ProductMeasurementMaterial | `${ProductMeasurementMaterial}`>;
  name: Scalars['String'];
  organizationProductTypeName?: Maybe<Scalars['String']>;
  overheadPercentage?: Maybe<Scalars['Int']>;
  overheadPercentageOverride?: Maybe<Scalars['Int']>;
  productId: Scalars['ID'];
  productionRateType?: Maybe<ProductProductionRateType | `${ProductProductionRateType}`>;
  proposalId: Scalars['ID'];
  proposalProductId: Scalars['ID'];
  proposalStageId: Scalars['ID'];
  statementOfWork?: Maybe<Scalars['String']>;
  statementOfWorkOverride?: Maybe<Scalars['String']>;
  subcontracted: Scalars['Boolean'];
  tonConversionFactor?: Maybe<Scalars['Float']>;
  tonConversionFactorOverride?: Maybe<Scalars['Float']>;
  type: Scalars['String'];
  unitPrice?: Maybe<Scalars['Int']>;
  unitPriceOverride?: Maybe<Scalars['Int']>;
  unitPriceProduct: Scalars['Boolean'];
};

export type ProposalPlant = {
  __typename?: 'ProposalPlant';
  addressCity: Scalars['String'];
  addressCountry: Scalars['String'];
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  addressState: Scalars['String'];
  addressZip: Scalars['String'];
  distanceMeters?: Maybe<Scalars['Int']>;
  distanceSeconds?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  phone: Scalars['String'];
  plantId: Scalars['ID'];
  rateOnWeight: Scalars['Boolean'];
  roundTripSeconds?: Maybe<Scalars['Int']>;
};

export type ProposalPlantProduct = {
  __typename?: 'ProposalPlantProduct';
  id: Scalars['ID'];
  plant: ProposalPlant;
  plantProductId: Scalars['ID'];
  rate: Scalars['Int'];
  rateOverride?: Maybe<Scalars['Int']>;
  type: Scalars['String'];
};

export type ProposalProduct = {
  __typename?: 'ProposalProduct';
  additionalCosts?: Maybe<Array<Maybe<ProposalAdditionalCost>>>;
  costAdditional: Scalars['String'];
  costDirect: Scalars['String'];
  costEquipment: Scalars['String'];
  costIndirect: Scalars['String'];
  costLabour: Scalars['String'];
  costMaterial: Scalars['String'];
  costOverhead: Scalars['String'];
  costTotal: Scalars['String'];
  costTransferTruck: Scalars['String'];
  crews?: Maybe<Array<ProposalCrew>>;
  equipmentPieces?: Maybe<Array<ProposalEquipmentPiece>>;
  externalProductName?: Maybe<Scalars['String']>;
  files?: Maybe<Array<ProposalFile>>;
  grossMargin: Scalars['String'];
  grossMarginPercentage: Scalars['Int'];
  id: Scalars['ID'];
  isOptional: Scalars['Boolean'];
  /** In Hours */
  jobDuration: Scalars['Float'];
  jobDurationDaysOverride?: Maybe<Scalars['Float']>;
  jobDurationOverride?: Maybe<Scalars['Float']>;
  jobSize: Scalars['Int'];
  mapData?: Maybe<Scalars['String']>;
  mapImage?: Maybe<Scalars['String']>;
  mapImageDirty: Scalars['Boolean'];
  material: ProposalMaterial;
  measurementJob?: Maybe<ProductMeasurementJob | `${ProductMeasurementJob}`>;
  measurementMaterial?: Maybe<ProductMeasurementMaterial | `${ProductMeasurementMaterial}`>;
  netMargin: Scalars['String'];
  netMarginPercentage: Scalars['Int'];
  notes?: Maybe<Scalars['String']>;
  operatingMargin: Scalars['String'];
  operatingMarginPercentage: Scalars['Int'];
  ordering: Scalars['Int'];
  overallTotal: Scalars['String'];
  overallTotalOverride?: Maybe<Scalars['String']>;
  plantProduct?: Maybe<ProposalPlantProduct>;
  productName?: Maybe<Scalars['String']>;
  profit: Scalars['String'];
  profitPercentage: Scalars['Int'];
  profitPercentageOverride?: Maybe<Scalars['Int']>;
  roundTripTravelTimeHours?: Maybe<Scalars['Float']>;
  statementOfWork?: Maybe<Scalars['String']>;
  subcontractorCost?: Maybe<Scalars['String']>;
  subcontractorName?: Maybe<Scalars['String']>;
  subcontractorProposalId?: Maybe<Scalars['String']>;
  /** In Hours */
  transferTruckLoadTimeBuffer?: Maybe<Scalars['Float']>;
  /** In Hours */
  transferTruckRoundTripTime?: Maybe<Scalars['Float']>;
  /** In Hours */
  transferTruckRoundTripTimeOverride?: Maybe<Scalars['Float']>;
  /** In Hours */
  transferTruckUnloadTimeBuffer?: Maybe<Scalars['Float']>;
  transferTrucks?: Maybe<Array<Maybe<ProposalTransferTruck>>>;
};

export type ProposalRecipient = {
  __typename?: 'ProposalRecipient';
  contactId?: Maybe<Scalars['ID']>;
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  id: Scalars['ID'];
};

export type ProposalSalesTax = {
  __typename?: 'ProposalSalesTax';
  id: Scalars['ID'];
  name: Scalars['String'];
  organizationSalesTaxId: Scalars['ID'];
  percentage: Scalars['Float'];
};

export enum ProposalSource {
  /** Advertisements */
  ADVERTISEMENTS = 'ADVERTISEMENTS',
  /** Channel sales */
  CHANNEL_SALES = 'CHANNEL_SALES',
  /** Existing relationship */
  EXISTING_RELATIONSHIP = 'EXISTING_RELATIONSHIP',
  /** Expo lead */
  EXPO_LEAD = 'EXPO_LEAD',
  /** External sales */
  EXTERNAL_SALES = 'EXTERNAL_SALES',
  /** Internal sales */
  INTERNAL_SALES = 'INTERNAL_SALES',
  /** Online */
  ONLINE = 'ONLINE',
  /** Other */
  OTHER = 'OTHER',
  /** Referral */
  REFERRAL = 'REFERRAL',
  /** Repeat customer */
  REPEAT_CUSTOMER = 'REPEAT_CUSTOMER',
  /** Social media */
  SOCIAL_MEDIA = 'SOCIAL_MEDIA',
  /** Trade shows */
  TRADE_SHOWS = 'TRADE_SHOWS',
  /** Website lead */
  WEBSITE_LEAD = 'WEBSITE_LEAD',
  /** Website request */
  WEBSITE_REQUEST = 'WEBSITE_REQUEST'
}

export type ProposalStage = {
  __typename?: 'ProposalStage';
  address?: Maybe<ProposalAddress>;
  addressOverride?: Maybe<Scalars['String']>;
  costAdditional: Scalars['String'];
  costDirect: Scalars['String'];
  costEquipment: Scalars['String'];
  costIndirect: Scalars['String'];
  costLabour: Scalars['String'];
  costMaterial: Scalars['String'];
  costOverhead: Scalars['String'];
  costTotal: Scalars['String'];
  distanceMeters?: Maybe<Scalars['Int']>;
  distanceSeconds?: Maybe<Scalars['Int']>;
  grossMargin: Scalars['String'];
  grossMarginPercentage: Scalars['Int'];
  id: Scalars['ID'];
  mapData?: Maybe<Scalars['String']>;
  mapImage?: Maybe<Scalars['String']>;
  mapImageDirty: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  netMargin: Scalars['String'];
  netMarginPercentage: Scalars['Int'];
  operatingMargin: Scalars['String'];
  operatingMarginPercentage: Scalars['Int'];
  ordering: Scalars['Int'];
  overallTotal?: Maybe<Scalars['String']>;
  profit: Scalars['String'];
  profitPercentage: Scalars['Int'];
  proposalProducts?: Maybe<Array<ProposalProduct>>;
  roundTripTravelTimeHours?: Maybe<Scalars['Float']>;
};

export type ProposalStageOrderingInput = {
  id: Scalars['ID'];
  ordering: Scalars['Int'];
};

export enum ProposalStatus {
  /** Canceled */
  CANCELED = 'CANCELED',
  /** Change order */
  CHANGE_ORDER = 'CHANGE_ORDER',
  /** Closed lost */
  CLOSED_LOST = 'CLOSED_LOST',
  /** Closed won */
  CLOSED_WON = 'CLOSED_WON',
  /** Draft */
  DRAFT = 'DRAFT',
  /** New version */
  NEW_VERSION = 'NEW_VERSION',
  /** Open */
  OPEN = 'OPEN',
  /** Sent */
  SENT = 'SENT'
}

export type ProposalStatusChange = {
  __typename?: 'ProposalStatusChange';
  changeAt: Scalars['DateTime'];
  changedBy?: Maybe<User>;
  status: ProposalStatus | `${ProposalStatus}`;
};

export type ProposalTransferTruck = {
  __typename?: 'ProposalTransferTruck';
  cost: Scalars['Int'];
  costOverride?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  plantTransferTruckId?: Maybe<Scalars['ID']>;
  quantity: Scalars['Float'];
  rateHourly: Scalars['Int'];
  rateHourlyOverride?: Maybe<Scalars['Int']>;
  rateTon: Scalars['Int'];
  rateTonOverride?: Maybe<Scalars['Int']>;
  tonnage: Scalars['Int'];
  totalHaulingHours: Scalars['Int'];
  totalHaulingHoursOverride?: Maybe<Scalars['Int']>;
  transferTruckId: Scalars['ID'];
  truckingProductionRate?: Maybe<Scalars['Float']>;
  trucksNeeded?: Maybe<Scalars['Float']>;
};

export type PublicCompany = {
  __typename?: 'PublicCompany';
  addressCity?: Maybe<Scalars['String']>;
  addressCountry?: Maybe<Scalars['String']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  addressState?: Maybe<Scalars['String']>;
  addressZip?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

export type PublicCompanyOrg = {
  __typename?: 'PublicCompanyOrg';
  company: PublicCompany;
  organization: PublicOrganization;
};

export type PublicContact = {
  __typename?: 'PublicContact';
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type PublicOrganization = {
  __typename?: 'PublicOrganization';
  address?: Maybe<OrganizationAddress>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  proposalDefaults: ProposalDefault;
};

export type PublicProposal = {
  __typename?: 'PublicProposal';
  acceptanceOverride?: Maybe<Scalars['String']>;
  attachments?: Maybe<Array<OrganizationDocument>>;
  company: PublicCompany;
  contact: PublicContact;
  content: Array<Maybe<ProposalContent>>;
  costTaxes: Scalars['String'];
  externalId: Scalars['String'];
  id: Scalars['ID'];
  layout: ProposalLayout | `${ProposalLayout}`;
  organization: PublicOrganization;
  overallTotal: Scalars['String'];
  overallTotalAfterTaxes: Scalars['String'];
  proposalPDF?: Maybe<Scalars['String']>;
  removeIndividualLineItemPricing?: Maybe<Scalars['Boolean']>;
  removeUnitPriceAndQuantity?: Maybe<Scalars['Boolean']>;
  salesTaxes?: Maybe<Array<ProposalSalesTax>>;
  signedAt?: Maybe<Scalars['DateTime']>;
  signeeInitials?: Maybe<Scalars['String']>;
  signeeName?: Maybe<Scalars['String']>;
  signeeTitle?: Maybe<Scalars['String']>;
  stages: Array<PublicProposalStage>;
  status: ProposalStatus | `${ProposalStatus}`;
  user: PublicUser;
};

export type PublicProposalAddress = {
  __typename?: 'PublicProposalAddress';
  city: Scalars['String'];
  country: Scalars['String'];
  id: Scalars['ID'];
  latitude: Scalars['String'];
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  longitude: Scalars['String'];
  state: Scalars['String'];
  zip: Scalars['String'];
};

export type PublicProposalOrganization = {
  __typename?: 'PublicProposalOrganization';
  estimatorEmail: Scalars['String'];
  id: Scalars['ID'];
  logo?: Maybe<Scalars['String']>;
};

export type PublicProposalProduct = {
  __typename?: 'PublicProposalProduct';
  additionalCosts?: Maybe<Array<Maybe<ProposalAdditionalCost>>>;
  files?: Maybe<Array<ProposalFile>>;
  id: Scalars['ID'];
  isOptional: Scalars['Boolean'];
  jobDuration: Scalars['Float'];
  jobSize: Scalars['Int'];
  mapImage?: Maybe<Scalars['String']>;
  material: ProposalMaterial;
  ordering: Scalars['Int'];
  overallTotal: Scalars['String'];
  overallTotalOverride?: Maybe<Scalars['String']>;
  statementOfWork?: Maybe<Scalars['String']>;
};

export type PublicProposalResponse = PublicProposal | PublicProposalOrganization;

export type PublicProposalStage = {
  __typename?: 'PublicProposalStage';
  address?: Maybe<PublicProposalAddress>;
  addressOverride?: Maybe<Scalars['String']>;
  content: Array<Maybe<ProposalContent>>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  ordering: Scalars['Int'];
  overallTotal: Scalars['String'];
  proposalProducts?: Maybe<Array<PublicProposalProduct>>;
};

export type PublicUser = {
  __typename?: 'PublicUser';
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  GetOrganizationApiKeys: Array<OrganizationApiKey>;
  getAdditionalCost?: Maybe<AdditionalCost>;
  getAdditionalCosts?: Maybe<AdditionalCostPaginator>;
  getAllCrews: Array<Crew>;
  getArchivedCompanies?: Maybe<CompanyPaginator>;
  getCheckoutUrl: Scalars['String'];
  getCompanies: GetCompaniesResponse;
  getCompany?: Maybe<Company>;
  getCompanyContacts?: Maybe<Array<Contact>>;
  getCrew?: Maybe<Crew>;
  getCrews?: Maybe<CrewPaginator>;
  getCurrentMonthStats: DashboardDataByMonth;
  getCustomEvent?: Maybe<CustomEvent>;
  getCustomEventBlocks: Array<CustomEventBlock>;
  getDashboardMapData: Array<Maybe<Job>>;
  getEmployee?: Maybe<Employee>;
  getEmployees?: Maybe<EmployeePaginator>;
  getEquipmentPiece?: Maybe<EquipmentPiece>;
  getEquipmentPieces?: Maybe<EquipmentPiecePaginator>;
  getJob: Job;
  getJobBillingStatuses: GetJobBillingStatusesResponse;
  getJobPhase: JobPhase;
  getJobPhaseCostItem?: Maybe<JobPhaseCostItem>;
  getJobPhaseCosts?: Maybe<JobPhaseCostItem>;
  getJobPhases: GetJobPhasesResponse;
  getJobScheduleByAmountStats: Array<DateWithTotals>;
  getJobSchedules: Array<JobPhaseScheduleBlock>;
  getJobs: GetJobsResponse;
  getLastYearStats: YearlyDashboardData;
  getManageSubscriptionUrl: Scalars['String'];
  getMaterialNeededByDayStats?: Maybe<Array<DateWithMaterialAmount>>;
  getNotificationTrigger: NotificationTrigger;
  getNotificationTriggers?: Maybe<Array<NotificationTrigger>>;
  getOpportunities: GetOpportunitiesResponse;
  getOpportunity?: Maybe<Opportunity>;
  getOpportunityStatuses: Array<OrganizationOpportunityStatus>;
  getOrganizationAddress?: Maybe<OrganizationAddress>;
  getOrganizationAddresses?: Maybe<OrganizationAddressPaginator>;
  getOrganizationDataUploads?: Maybe<OrganizationDataUploadPaginator>;
  getOrganizationEmailTemplate?: Maybe<OrganizationEmailTemplate>;
  getOrganizationEmailTemplates?: Maybe<Array<OrganizationEmailTemplate>>;
  getOrganizationProductType: OrganizationProductType;
  getOrganizationProductTypes: Array<OrganizationProductType>;
  getOrganizationProposalContent?: Maybe<Array<OrganizationProposalContent>>;
  getOrganizationSettings: Array<OrganizationSetting>;
  getOrganizationUser?: Maybe<User>;
  getOrganizationUsers?: Maybe<UserPaginator>;
  getPersonsStats: Array<Maybe<PersonSales>>;
  getPlant: Plant;
  getPlantProductTypes?: Maybe<Array<ModelsPlantProductType>>;
  getPlantTransferTrucks: Array<PlantTransferTruck>;
  getPlants?: Maybe<PlantPaginator>;
  getPreviousMonthStats: DashboardDataByMonth;
  getProduct?: Maybe<Product>;
  getProductStats: ProductStats;
  getProducts?: Maybe<ProductPaginator>;
  getProjectFile: ProjectFile;
  getProjectFiles: Array<ProjectFile>;
  getProposal: Proposal;
  getProposalProductMapData?: Maybe<Scalars['String']>;
  getProposals: GetProposalsResponse;
  getPublicProposal: PublicProposalResponse;
  getPublicProposalCompanyOrg?: Maybe<PublicCompanyOrg>;
  getQuickbooksIncomeAccounts?: Maybe<Array<QuickbooksIncomeAccount>>;
  getQuickbooksTaxCodes?: Maybe<Array<QuickbooksTaxCode>>;
  getQuickbooksTaxRates?: Maybe<Array<QuickbooksTaxRate>>;
  getRolesWithPermissions?: Maybe<RolesWithPermissions>;
  getTimeBucket?: Maybe<TimeBucket>;
  getTimeBuckets: Array<TimeBucket>;
  getTimeEntries: GetTimeEntriesResponse;
  getTransferTruck?: Maybe<TransferTruck>;
  getTransferTrucks: Array<TransferTruck>;
  getUserOrganization: Organization;
  getYearToDateStats: YearToDateStats;
  isCompanySearchable?: Maybe<Scalars['Boolean']>;
  isJobSearchable?: Maybe<Scalars['Boolean']>;
  isOpportunitySearchable?: Maybe<Scalars['Boolean']>;
  isProposalSearchable?: Maybe<Scalars['Boolean']>;
  me?: Maybe<User>;
  previewSubscriptionChange?: Maybe<PreviewSubscriptionChangeResponse>;
  timeEntry?: Maybe<TimeEntry>;
  validateLogin?: Maybe<Scalars['Boolean']>;
  validateUserInviteToken: Scalars['Boolean'];
};


export type QueryGetAdditionalCostArgs = {
  id: Scalars['ID'];
};


export type QueryGetAdditionalCostsArgs = {
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortDirection>;
};


export type QueryGetArchivedCompaniesArgs = {
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryGetCompaniesArgs = {
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  searchByName?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<GetCompaniesSortKey>;
};


export type QueryGetCompanyArgs = {
  id: Scalars['ID'];
};


export type QueryGetCompanyContactsArgs = {
  id: Scalars['ID'];
};


export type QueryGetCrewArgs = {
  id: Scalars['ID'];
};


export type QueryGetCrewsArgs = {
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortDirection>;
};


export type QueryGetCustomEventArgs = {
  id: Scalars['ID'];
};


export type QueryGetCustomEventBlocksArgs = {
  crewId?: InputMaybe<Scalars['ID']>;
  customEventIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateUntil?: InputMaybe<Scalars['DateTime']>;
};


export type QueryGetEmployeeArgs = {
  id: Scalars['ID'];
};


export type QueryGetEmployeesArgs = {
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortDirection>;
};


export type QueryGetEquipmentPieceArgs = {
  id: Scalars['ID'];
};


export type QueryGetEquipmentPiecesArgs = {
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortDirection>;
};


export type QueryGetJobArgs = {
  id: Scalars['ID'];
};


export type QueryGetJobPhaseArgs = {
  id: Scalars['ID'];
};


export type QueryGetJobPhaseCostItemArgs = {
  date: Scalars['Date'];
  jobPhaseId: Scalars['ID'];
};


export type QueryGetJobPhaseCostsArgs = {
  id: Scalars['ID'];
};


export type QueryGetJobPhasesArgs = {
  billingStatuses?: InputMaybe<Array<JobBillingStatus>>;
  companyId?: InputMaybe<Scalars['ID']>;
  crewId?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['DateTime']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  first: Scalars['Int'];
  foremanUserId?: InputMaybe<Scalars['ID']>;
  organizationProductTypeId?: InputMaybe<Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  searchByName?: InputMaybe<Scalars['Boolean']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<GetJobsSortKey>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryGetJobSchedulesArgs = {
  crewId?: InputMaybe<Scalars['ID']>;
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateUntil?: InputMaybe<Scalars['DateTime']>;
  jobIds?: InputMaybe<Array<Scalars['ID']>>;
  jobPhaseId?: InputMaybe<Scalars['ID']>;
};


export type QueryGetJobsArgs = {
  billingStatuses?: InputMaybe<Array<JobBillingStatus>>;
  companyId?: InputMaybe<Scalars['ID']>;
  first: Scalars['Int'];
  jobIds?: InputMaybe<Array<Scalars['ID']>>;
  multipleCompanyIDs?: InputMaybe<Array<Scalars['ID']>>;
  multipleUserIDs?: InputMaybe<Array<Scalars['ID']>>;
  organizationProductTypeIds?: InputMaybe<Array<Scalars['ID']>>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<GetJobsSortKey>;
  statuses?: InputMaybe<Array<JobStatus>>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryGetNotificationTriggerArgs = {
  id: Scalars['ID'];
};


export type QueryGetOpportunitiesArgs = {
  companyId?: InputMaybe<Scalars['ID']>;
  contactName?: InputMaybe<Scalars['String']>;
  dueAt?: InputMaybe<Scalars['Date']>;
  first: Scalars['Int'];
  multipleCompanyIDs?: InputMaybe<Array<Scalars['ID']>>;
  multipleUserIDs?: InputMaybe<Array<Scalars['ID']>>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<GetOpportunitiesSortKey>;
  statuses?: InputMaybe<Array<Scalars['String']>>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryGetOpportunityArgs = {
  id: Scalars['ID'];
};


export type QueryGetOrganizationAddressArgs = {
  id: Scalars['ID'];
};


export type QueryGetOrganizationAddressesArgs = {
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryGetOrganizationDataUploadsArgs = {
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryGetOrganizationEmailTemplateArgs = {
  type: OrganizationEmailTemplateType;
};


export type QueryGetOrganizationProductTypeArgs = {
  id: Scalars['ID'];
};


export type QueryGetOrganizationUserArgs = {
  id: Scalars['ID'];
};


export type QueryGetOrganizationUsersArgs = {
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  roles?: InputMaybe<Array<InputMaybe<UserRole>>>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<UserStatus>;
};


export type QueryGetPlantArgs = {
  id: Scalars['ID'];
};


export type QueryGetPlantTransferTrucksArgs = {
  plantId: Scalars['ID'];
};


export type QueryGetPlantsArgs = {
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetProductArgs = {
  id: Scalars['ID'];
};


export type QueryGetProductsArgs = {
  first: Scalars['Int'];
  orderBy?: InputMaybe<Array<QueryGetProductsOrderByOrderByClause>>;
  organizationProductTypeId?: InputMaybe<Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<ProductType>;
};


export type QueryGetProjectFileArgs = {
  id: Scalars['ID'];
};


export type QueryGetProposalArgs = {
  id: Scalars['ID'];
};


export type QueryGetProposalProductMapDataArgs = {
  proposalProductId: Scalars['ID'];
  token: Scalars['String'];
};


export type QueryGetProposalsArgs = {
  companyId?: InputMaybe<Scalars['ID']>;
  first: Scalars['Int'];
  multipleCompanyIDs?: InputMaybe<Array<Scalars['ID']>>;
  multipleUserIDs?: InputMaybe<Array<Scalars['ID']>>;
  organizationProductTypeIds?: InputMaybe<Array<Scalars['ID']>>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<GetProposalsSortKey>;
  statuses?: InputMaybe<Array<ProposalStatus>>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryGetPublicProposalArgs = {
  email?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
  uuid: Scalars['String'];
};


export type QueryGetPublicProposalCompanyOrgArgs = {
  uuid: Scalars['String'];
};


export type QueryGetTimeBucketArgs = {
  id: Scalars['ID'];
};


export type QueryGetTimeEntriesArgs = {
  first: Scalars['Int'];
  forDate?: InputMaybe<Scalars['Date']>;
  forDateEnd?: InputMaybe<Scalars['Date']>;
  forDateStart?: InputMaybe<Scalars['Date']>;
  jobPhaseId?: InputMaybe<Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<GetTimeEntriesSortKey>;
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryGetTransferTruckArgs = {
  id: Scalars['ID'];
};


export type QueryIsCompanySearchableArgs = {
  id: Scalars['ID'];
};


export type QueryIsJobSearchableArgs = {
  id: Scalars['ID'];
};


export type QueryIsOpportunitySearchableArgs = {
  id: Scalars['ID'];
};


export type QueryIsProposalSearchableArgs = {
  id: Scalars['ID'];
};


export type QueryPreviewSubscriptionChangeArgs = {
  email?: InputMaybe<Scalars['String']>;
  quantityChange: Scalars['Int'];
};


export type QueryTimeEntryArgs = {
  id: Scalars['ID'];
};


export type QueryValidateLoginArgs = {
  input: ValidateLoginInput;
};


export type QueryValidateUserInviteTokenArgs = {
  email: Scalars['String'];
  inviteToken: Scalars['String'];
};

/** Allowed column names for Query.getProducts.orderBy. */
export enum QueryGetProductsOrderByColumn {
  NAME = 'NAME'
}

/** Order by clause for Query.getProducts.orderBy. */
export type QueryGetProductsOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryGetProductsOrderByColumn | `${QueryGetProductsOrderByColumn}`;
  /** The direction that is used for ordering. */
  order: SortOrder | `${SortOrder}`;
};

export type QuickbooksIncomeAccount = {
  __typename?: 'QuickbooksIncomeAccount';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type QuickbooksIntegrationInput = {
  data: Scalars['String'];
  jobId: Scalars['ID'];
};

export type QuickbooksTaxCode = {
  __typename?: 'QuickbooksTaxCode';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type QuickbooksTaxRate = {
  __typename?: 'QuickbooksTaxRate';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  rateValue?: Maybe<Scalars['Float']>;
};

export type RegisterInput = {
  companyName: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone: Scalars['String'];
  token: Scalars['String'];
};

export enum ReportType {
  /** Additional cost details */
  ADDITIONAL_COST_DETAILS = 'ADDITIONAL_COST_DETAILS',
  /** Company or client details */
  COMPANY_OR_CLIENT_DETAILS = 'COMPANY_OR_CLIENT_DETAILS',
  /** Contact details */
  CONTACT_DETAILS = 'CONTACT_DETAILS',
  /** Crew details */
  CREW_DETAILS = 'CREW_DETAILS',
  /** Equipment cost details */
  EQUIPMENT_COST_DETAILS = 'EQUIPMENT_COST_DETAILS',
  /** Jobs by contact */
  JOBS_BY_CONTACT = 'JOBS_BY_CONTACT',
  /** Job cost by product type */
  JOB_COST_BY_PRODUCT_TYPE = 'JOB_COST_BY_PRODUCT_TYPE',
  /** Job details */
  JOB_DETAILS = 'JOB_DETAILS',
  /** Product details */
  PRODUCT_DETAILS = 'PRODUCT_DETAILS',
  /** Proposal details */
  PROPOSAL_DETAILS = 'PROPOSAL_DETAILS',
  /** Sales by contact */
  SALES_BY_CONTACT = 'SALES_BY_CONTACT',
  /** Sales by product summary */
  SALES_BY_PRODUCT_SUMMARY = 'SALES_BY_PRODUCT_SUMMARY',
  /** Sales by proposal source */
  SALES_BY_PROPOSAL_SOURCE = 'SALES_BY_PROPOSAL_SOURCE',
  /** Time entries */
  TIME_ENTRIES = 'TIME_ENTRIES'
}

export type RequestPasswordResetInput = {
  email: Scalars['String'];
};

export type ResendVerificationEmailInput = {
  email: Scalars['String'];
};

export type ResetPasswordInput = {
  email: Scalars['String'];
  password: Scalars['String'];
  token: Scalars['String'];
};

export type RolesWithPermissions = {
  __typename?: 'RolesWithPermissions';
  admin?: Maybe<Array<Maybe<UserPermissions | `${UserPermissions}`>>>;
  employee?: Maybe<Array<Maybe<UserPermissions | `${UserPermissions}`>>>;
  foreman?: Maybe<Array<Maybe<UserPermissions | `${UserPermissions}`>>>;
  officeManager?: Maybe<Array<Maybe<UserPermissions | `${UserPermissions}`>>>;
  salesperson?: Maybe<Array<Maybe<UserPermissions | `${UserPermissions}`>>>;
  subcontractor?: Maybe<Array<Maybe<UserPermissions | `${UserPermissions}`>>>;
};

export type SaveQuickbooksIntegrationInput = {
  customerBillingAddressCity?: InputMaybe<Scalars['String']>;
  customerBillingAddressCountry?: InputMaybe<Scalars['String']>;
  customerBillingAddressLine1?: InputMaybe<Scalars['String']>;
  customerBillingAddressLine2?: InputMaybe<Scalars['String']>;
  customerBillingAddressState?: InputMaybe<Scalars['String']>;
  customerBillingAddressZip?: InputMaybe<Scalars['String']>;
  customerEmail?: InputMaybe<Scalars['String']>;
  customerName?: InputMaybe<Scalars['String']>;
  customerPhone?: InputMaybe<Scalars['String']>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  items?: InputMaybe<Array<InputMaybe<ItemsQuickbooksDetailInput>>>;
  jobName?: InputMaybe<Scalars['String']>;
  shipAddressAddressCity?: InputMaybe<Scalars['String']>;
  shipAddressAddressLine1?: InputMaybe<Scalars['String']>;
  shipAddressAddressLine2?: InputMaybe<Scalars['String']>;
  shipAddressAddressState?: InputMaybe<Scalars['String']>;
  shipAddressAddressZip?: InputMaybe<Scalars['String']>;
  taxReference?: InputMaybe<Scalars['String']>;
  totalAmountItems?: InputMaybe<Scalars['Int']>;
};

export type ScheduleCustomEventBlockInput = {
  blockId: Scalars['ID'];
  blockLength: Scalars['Float'];
  scheduledAt: Scalars['DateTime'];
};

export type ScheduleJobPhaseBlockInput = {
  blockId: Scalars['ID'];
  blockLength: Scalars['Float'];
  scheduledAt: Scalars['DateTime'];
  showTravelFrom: Scalars['Boolean'];
  showTravelTo: Scalars['Boolean'];
  travelTimeEstimate?: InputMaybe<Scalars['Float']>;
};

/** Information about pagination using a simple paginator. */
export type SimplePaginatorInfo = {
  __typename?: 'SimplePaginatorInfo';
  /** Number of items in the current page. */
  count: Scalars['Int'];
  /** Index of the current page. */
  currentPage: Scalars['Int'];
  /** Index of the first item in the current page. */
  firstItem?: Maybe<Scalars['Int']>;
  /** Are there more pages after this one? */
  hasMorePages: Scalars['Boolean'];
  /** Index of the last item in the current page. */
  lastItem?: Maybe<Scalars['Int']>;
  /** Number of items per page. */
  perPage: Scalars['Int'];
};

export enum SortDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}

/** Directions for ordering a list of records. */
export enum SortOrder {
  /** Sort records in ascending order. */
  ASC = 'ASC',
  /** Sort records in descending order. */
  DESC = 'DESC'
}

export type StageProposalProductOrderingInput = {
  id: Scalars['ID'];
  ordering: Scalars['Int'];
};

export type StripeSubscription = {
  __typename?: 'StripeSubscription';
  endsAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  quantity?: Maybe<Scalars['Int']>;
  renewsAt?: Maybe<Scalars['DateTime']>;
  stripeId: Scalars['String'];
  stripePrice?: Maybe<Scalars['String']>;
  stripeStatus: Scalars['String'];
  trialEndsAt?: Maybe<Scalars['DateTime']>;
};

export type SyncNotificationAdditionalRecipientsHasMany = {
  sync: Array<Scalars['ID']>;
};

export type TimeBucket = {
  __typename?: 'TimeBucket';
  id: Scalars['ID'];
  name: Scalars['String'];
  organizationId: Scalars['ID'];
};

export type TimeEntry = {
  __typename?: 'TimeEntry';
  clockInLatitude?: Maybe<Scalars['Float']>;
  clockInLongitude?: Maybe<Scalars['Float']>;
  clockOutLatitude?: Maybe<Scalars['Float']>;
  clockOutLongitude?: Maybe<Scalars['Float']>;
  endTime?: Maybe<Scalars['DateTime']>;
  forDate: Scalars['Date'];
  id: Scalars['ID'];
  jobPhase?: Maybe<JobPhase>;
  notes?: Maybe<Scalars['String']>;
  organizationId: Scalars['ID'];
  startTime: Scalars['DateTime'];
  timeBucket?: Maybe<TimeBucket>;
  timeTrackedSeconds?: Maybe<Scalars['Int']>;
  timeTrackedSecondsOverride?: Maybe<Scalars['Int']>;
  user: User;
  uuid: Scalars['String'];
};

export type TransferTruck = {
  __typename?: 'TransferTruck';
  defaultRateHourly: Scalars['Int'];
  defaultRateTon: Scalars['Int'];
  defaultTonnage: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** Specify if you want to include or exclude trashed results from a query. */
export enum Trashed {
  /** Only return trashed results. */
  ONLY = 'ONLY',
  /** Return both trashed and non-trashed results. */
  WITH = 'WITH',
  /** Only return non-trashed results. */
  WITHOUT = 'WITHOUT'
}

export type UpdateAdditionalCostInput = {
  cost: Scalars['Int'];
  feeAmount: Scalars['Float'];
  feeType: AdditionalCostFeeType | `${AdditionalCostFeeType}`;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateCompanyInput = {
  addCompanyInfo?: InputMaybe<Scalars['Boolean']>;
  addressCity?: InputMaybe<Scalars['String']>;
  addressCountry?: InputMaybe<Scalars['String']>;
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  addressState?: InputMaybe<Scalars['String']>;
  addressZip?: InputMaybe<Scalars['String']>;
  contacts: UpsertCompanyContactHasMany;
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notificationTypes?: InputMaybe<NotificationTypeInput>;
  phone?: InputMaybe<Scalars['String']>;
  primaryContact: UpsertCompanyContactInput;
  projectFilesFolderId?: InputMaybe<Scalars['ID']>;
  status: CompanyStatus | `${CompanyStatus}`;
};

export type UpdateCompanyNotesInput = {
  id: Scalars['ID'];
  notes: Scalars['String'];
};

export type UpdateCrewInput = {
  color: Scalars['String'];
  displayName?: InputMaybe<Scalars['String']>;
  employees?: InputMaybe<UpsertEmployeeCrewBelongsToMany>;
  foremanUserId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  rate: Scalars['Int'];
};

export type UpdateCustomEventInput = {
  blocks: Array<CustomEventBlockInput>;
  color?: InputMaybe<Scalars['String']>;
  crewId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  userIDs?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type UpdateEmployeeInput = {
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  rate: Scalars['Int'];
  userId?: InputMaybe<Scalars['ID']>;
};

export type UpdateEquipmentPieceInput = {
  chargeType: EquipmentPieceChargeType | `${EquipmentPieceChargeType}`;
  fuelSurcharge: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['String'];
  rate: Scalars['Int'];
  usePercentage: Scalars['Int'];
};

export type UpdateJobPhaseNotesInput = {
  id: Scalars['ID'];
  notes?: InputMaybe<Scalars['String']>;
};

export type UpdateNotificationTriggerInput = {
  active: Scalars['Boolean'];
  additionalRecipientTypes?: InputMaybe<Array<NotificationTriggerAdditionalRecipientTypes | `${NotificationTriggerAdditionalRecipientTypes}`>>;
  additionalRecipients?: InputMaybe<SyncNotificationAdditionalRecipientsHasMany>;
  content: Scalars['String'];
  delay: Scalars['Int'];
  emailSubject: Scalars['String'];
  event: NotificationTriggerEvent | `${NotificationTriggerEvent}`;
  id: Scalars['ID'];
  isEmail?: InputMaybe<Scalars['Boolean']>;
  isSMS?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  sendToAllRecipients: Scalars['Boolean'];
  sendToContact: Scalars['Boolean'];
  sendToUser: Scalars['Boolean'];
  smsContent?: InputMaybe<Scalars['String']>;
  type: NotificationTriggerType | `${NotificationTriggerType}`;
};

export type UpdateOpportunityInput = {
  addressCity: Scalars['String'];
  addressCountry: Scalars['String'];
  addressLine1: Scalars['String'];
  addressLine2?: InputMaybe<Scalars['String']>;
  addressState: Scalars['String'];
  addressZip: Scalars['String'];
  companyId: Scalars['ID'];
  contactId: Scalars['ID'];
  dueAt?: InputMaybe<Scalars['Date']>;
  estimatedOpportunityValue?: InputMaybe<Scalars['Float']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<UpsertOpportunityProductBelongsToMany>;
  projectFilesFolderId?: InputMaybe<Scalars['ID']>;
  source?: InputMaybe<OpportunitySource | `${OpportunitySource}`>;
  statusId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type UpdateOrganizationAddressInput = {
  city: Scalars['String'];
  country: Scalars['String'];
  id: Scalars['ID'];
  isPrimary: Scalars['Boolean'];
  latitude?: InputMaybe<Scalars['String']>;
  line1: Scalars['String'];
  line2?: InputMaybe<Scalars['String']>;
  longitude?: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
  zip: Scalars['String'];
};

export type UpdateOrganizationConversionFactorOverrideInput = {
  asphaltTonConversionFactorOverride: Scalars['String'];
  excavateOutTonConversionFactorOverride: Scalars['String'];
  id: Scalars['ID'];
};

export type UpdateOrganizationInput = {
  email: Scalars['String'];
  id: Scalars['ID'];
  logo?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  phone: Scalars['String'];
  timezone: Scalars['String'];
};

export type UpdateOrganizationProductTypeInput = {
  id: Scalars['ID'];
  indirectPercentage?: InputMaybe<Scalars['Int']>;
  markupPercentage?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  overheadPercentage?: InputMaybe<Scalars['Int']>;
};

export type UpdateOrganizationProposalDefaultsInput = {
  autoSave?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  layout?: InputMaybe<ProposalLayout | `${ProposalLayout}`>;
  removeIndividualLineItemPricing?: InputMaybe<Scalars['Boolean']>;
  removeUnitPriceAndQuantity?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateOrganizationSalesTaxesInput = {
  /** organization id */
  id: Scalars['ID'];
  salesTaxes: UpsertOrganizationSalesTaxHasMany;
};

export type UpdateOrganizationSettingsInput = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type UpdateOrganizationUserInput = {
  addressCity?: InputMaybe<Scalars['String']>;
  addressCountry?: InputMaybe<Scalars['String']>;
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  addressState?: InputMaybe<Scalars['String']>;
  addressZip?: InputMaybe<Scalars['String']>;
  autoAssign: Scalars['Boolean'];
  avatar?: InputMaybe<Scalars['Upload']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<UserRole | `${UserRole}`>;
  userId: Scalars['ID'];
};

export type UpdatePlantInput = {
  addressCity: Scalars['String'];
  addressCountry: Scalars['String'];
  addressLine1: Scalars['String'];
  addressLine2?: InputMaybe<Scalars['String']>;
  addressState: Scalars['String'];
  addressZip: Scalars['String'];
  id: Scalars['ID'];
  latitude?: InputMaybe<Scalars['String']>;
  longitude?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  phone: Scalars['String'];
  products: UpsertPlantProductBelongsToMany;
};

export type UpdateProductInput = {
  additionalCosts?: InputMaybe<UpsertProductAdditionalCostBelongsToMany>;
  areaCoverage?: InputMaybe<Scalars['Float']>;
  /** Json encoded string of attributes */
  attributes?: InputMaybe<ProductAttributesInput>;
  costMaterial?: InputMaybe<Scalars['Int']>;
  costMinimumProduct?: InputMaybe<Scalars['Int']>;
  costMinimumProposal?: InputMaybe<Scalars['Int']>;
  crewId?: InputMaybe<Scalars['ID']>;
  dailyUnitsComplete?: InputMaybe<Scalars['Int']>;
  equipmentPieces?: InputMaybe<UpsertProductEquipmentBelongsToMany>;
  externalProductName?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  indirectPercentage?: InputMaybe<Scalars['Int']>;
  labourCostType?: InputMaybe<ProductLabourCostType | `${ProductLabourCostType}`>;
  markupPercentage?: InputMaybe<Scalars['Int']>;
  measurementJob: ProductMeasurementJob | `${ProductMeasurementJob}`;
  measurementMaterial?: InputMaybe<ProductMeasurementMaterial | `${ProductMeasurementMaterial}`>;
  name: Scalars['String'];
  overheadPercentage?: InputMaybe<Scalars['Int']>;
  plantProductId?: InputMaybe<Scalars['ID']>;
  productionRateType?: InputMaybe<ProductProductionRateType | `${ProductProductionRateType}`>;
  statementOfWork?: InputMaybe<Scalars['String']>;
  subcontracted: Scalars['Boolean'];
  unitPrice?: InputMaybe<Scalars['Float']>;
  unitPriceProduct: Scalars['Boolean'];
};

export type UpdateProposalAdditionalCostInput = {
  cost?: InputMaybe<Scalars['Int']>;
  feeAmount?: InputMaybe<Scalars['Float']>;
  id: Scalars['ID'];
  quantity?: InputMaybe<Scalars['Float']>;
  showOnProposal?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateProposalAddress = {
  addressCity?: InputMaybe<Scalars['String']>;
  addressCountry?: InputMaybe<Scalars['String']>;
  addressLine1: Scalars['String'];
  addressLine2?: InputMaybe<Scalars['String']>;
  addressState?: InputMaybe<Scalars['String']>;
  addressZip?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type UpdateProposalCrewInput = {
  id: Scalars['ID'];
  rate?: InputMaybe<Scalars['Int']>;
  timeOnjob?: InputMaybe<Scalars['Int']>;
  timeTravel?: InputMaybe<Scalars['Int']>;
};

export type UpdateProposalEquipmentPieceInput = {
  id: Scalars['ID'];
  quantity?: InputMaybe<Scalars['Int']>;
  rate?: InputMaybe<Scalars['Int']>;
  timeOnJob?: InputMaybe<Scalars['Int']>;
  timeTravel?: InputMaybe<Scalars['Int']>;
};

export type UpdateProposalInfoInput = {
  contactId: Scalars['ID'];
  id: Scalars['ID'];
  layout: ProposalLayout | `${ProposalLayout}`;
  projectFilesFolderId?: InputMaybe<Scalars['ID']>;
  proposalNotes?: InputMaybe<Scalars['String']>;
  removeIndividualLineItemPricing?: InputMaybe<Scalars['Boolean']>;
  removeUnitPriceAndQuantity?: InputMaybe<Scalars['Boolean']>;
  source?: InputMaybe<ProposalSource | `${ProposalSource}`>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type UpdateProposalMaterialInput = {
  attributes?: InputMaybe<ProductAttributesInput>;
  costMaterial?: InputMaybe<Scalars['Int']>;
  dailyUnitsComplete?: InputMaybe<Scalars['String']>;
  indirectPercentage?: InputMaybe<Scalars['Int']>;
  markup?: InputMaybe<Scalars['Int']>;
  materialNeeded?: InputMaybe<Scalars['Float']>;
  overheadPercentage?: InputMaybe<Scalars['Int']>;
  statementOfWork?: InputMaybe<Scalars['String']>;
  tonConversionFactor?: InputMaybe<Scalars['Float']>;
  unitPrice?: InputMaybe<Scalars['Int']>;
};

export type UpdateProposalPlantInput = {
  rateOnWeight: Scalars['Boolean'];
};

export type UpdateProposalProductInput = {
  additionalCosts: Array<UpdateProposalAdditionalCostInput>;
  crews: Array<UpdateProposalCrewInput>;
  equipmentPieces: Array<UpdateProposalEquipmentPieceInput>;
  id: Scalars['ID'];
  jobDurationDaysOverride?: InputMaybe<Scalars['Float']>;
  jobDurationOverride?: InputMaybe<Scalars['Float']>;
  jobSize: Scalars['Int'];
  mapData?: InputMaybe<Scalars['String']>;
  material: UpdateProposalMaterialInput;
  notes?: InputMaybe<Scalars['String']>;
  overallTotalOverride?: InputMaybe<Scalars['Int']>;
  plant?: InputMaybe<UpdateProposalPlantInput>;
  profitPercentageOverride?: InputMaybe<Scalars['Int']>;
  roundTripTravelTimeHours?: InputMaybe<Scalars['Float']>;
  subcontractorCost?: InputMaybe<Scalars['Int']>;
  subcontractorName?: InputMaybe<Scalars['String']>;
  subcontractorProposalId?: InputMaybe<Scalars['String']>;
  /** In Hours */
  transferTruckLoadTimeBuffer?: InputMaybe<Scalars['Float']>;
  /** In Hours */
  transferTruckRoundTripTime?: InputMaybe<Scalars['Float']>;
  /** In Hours */
  transferTruckUnloadTimeBuffer?: InputMaybe<Scalars['Float']>;
  transferTrucks: Array<UpsertProposalTransferTrucksInput>;
};

export type UpdateProposalProductsHasMany = {
  update: Array<StageProposalProductOrderingInput>;
};

export type UpdateProposalProductsOrderingInput = {
  id: Scalars['ID'];
  proposalProducts: UpdateProposalProductsHasMany;
};

export type UpdateProposalSalesTaxesInput = {
  id: Scalars['ID'];
  salesTaxes: Array<Scalars['ID']>;
};

export type UpdateProposalStagesHasMany = {
  update: Array<ProposalStageOrderingInput>;
};

export type UpdateProposalStagesOrdering = {
  id: Scalars['ID'];
  stages: UpdateProposalStagesHasMany;
};

export type UpdateRolesWithPermissionsInput = {
  employee?: InputMaybe<Array<InputMaybe<UserPermissions | `${UserPermissions}`>>>;
  foreman?: InputMaybe<Array<InputMaybe<UserPermissions | `${UserPermissions}`>>>;
  officeManager?: InputMaybe<Array<InputMaybe<UserPermissions | `${UserPermissions}`>>>;
  salesperson?: InputMaybe<Array<InputMaybe<UserPermissions | `${UserPermissions}`>>>;
  subcontractor?: InputMaybe<Array<InputMaybe<UserPermissions | `${UserPermissions}`>>>;
};

export type UpdateTimeBucketInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateTimeEntryInput = {
  clockOutLatitude?: InputMaybe<Scalars['Float']>;
  clockOutLongitude?: InputMaybe<Scalars['Float']>;
  endTime?: InputMaybe<Scalars['DateTime']>;
  forDate?: InputMaybe<Scalars['Date']>;
  jobPhaseId?: InputMaybe<Scalars['ID']>;
  notes?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['DateTime']>;
  timeBucketId?: InputMaybe<Scalars['ID']>;
  uuid: Scalars['String'];
};

export type UpdateTransferTruckInput = {
  defaultRateHourly: Scalars['Int'];
  defaultRateTon: Scalars['Int'];
  defaultTonnage: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type UpdateWorkOrderItemsInput = {
  additionalCosts?: InputMaybe<Array<UpdateWorkOrderItemsInputAdditionalCosts>>;
  crews?: InputMaybe<Array<UpdateWorkOrderItemsInputCrews>>;
  equipmentPieces?: InputMaybe<Array<UpdateWorkOrderItemsInputEquipmentPieces>>;
  jobPhaseId: Scalars['ID'];
  plantId?: InputMaybe<Scalars['ID']>;
  plantProductId?: InputMaybe<Scalars['ID']>;
  schedules?: InputMaybe<Array<InputMaybe<UpdateWorkOrderItemsSchedules>>>;
  transferTrucks?: InputMaybe<Array<UpdateWorkOrderItemsInputTransferTruck>>;
};

export type UpdateWorkOrderItemsInputAdditionalCosts = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateWorkOrderItemsInputCrews = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateWorkOrderItemsInputEquipmentPieces = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateWorkOrderItemsInputTransferTruck = {
  id: Scalars['ID'];
  quantity?: InputMaybe<Scalars['Float']>;
};

export type UpdateWorkOrderItemsSchedules = {
  estimatedMaterialOverride: Scalars['Float'];
  id: Scalars['ID'];
};

export type UpsertCompanyContactHasMany = {
  upsert: Array<UpsertCompanyContactInput>;
};

export type UpsertCompanyContactInput = {
  SMSNotifications: Scalars['Boolean'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  lastName: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  primary: Scalars['Boolean'];
  role?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpsertEmployeeCrewBelongsToMany = {
  sync: Array<UpsertEmployeeCrewInput>;
};

export type UpsertEmployeeCrewInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type UpsertOpportunityProductBelongsToMany = {
  sync: Array<UpsertOpportunityProductInput>;
};

export type UpsertOpportunityProductInput = {
  id: Scalars['ID'];
};

export type UpsertOrganizationSalesTaxHasMany = {
  upsert: Array<InputMaybe<UpsertOrganizationSalesTaxInput>>;
};

export type UpsertOrganizationSalesTaxInput = {
  id?: InputMaybe<Scalars['ID']>;
  isDefault: Scalars['Boolean'];
  name: Scalars['String'];
  percentage: Scalars['Float'];
  quickbooksDesktopTaxCodeId?: InputMaybe<Scalars['ID']>;
  quickbooksTaxCodeId?: InputMaybe<Scalars['ID']>;
};

export type UpsertPlantProductBelongsToMany = {
  upsert: Array<UpsertPlantProductInput>;
};

export type UpsertPlantProductInput = {
  id?: InputMaybe<Scalars['ID']>;
  rate: Scalars['Float'];
  type: Scalars['String'];
};

export type UpsertPlantTransferTruckHasMany = {
  upsert: Array<UpsertPlantTransferTruckInput>;
};

export type UpsertPlantTransferTruckInput = {
  id?: InputMaybe<Scalars['ID']>;
  rateHourly?: InputMaybe<Scalars['Int']>;
  rateTon?: InputMaybe<Scalars['Int']>;
  tonnage: Scalars['Int'];
  transferTruckId: Scalars['ID'];
};

export type UpsertProductAdditionalCostBelongsToMany = {
  sync: Array<UpsertProductAdditionalCostInput>;
};

export type UpsertProductAdditionalCostInput = {
  id?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<ProductAdditionalCostType | `${ProductAdditionalCostType}`>;
};

export type UpsertProductEquipmentBelongsToMany = {
  sync: Array<UpsertProductEquipmentInput>;
};

export type UpsertProductEquipmentInput = {
  id?: InputMaybe<Scalars['ID']>;
  quantity: Scalars['Int'];
};

export type UpsertProposalTransferTrucksInput = {
  plantTransferTruckId: Scalars['ID'];
  quantity: Scalars['Int'];
  rate?: InputMaybe<Scalars['Int']>;
};

export type User = {
  __typename?: 'User';
  addressCity?: Maybe<Scalars['String']>;
  addressCountry?: Maybe<Scalars['String']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  addressState?: Maybe<Scalars['String']>;
  addressZip?: Maybe<Scalars['String']>;
  autoAssign: Scalars['Boolean'];
  avatar?: Maybe<Scalars['String']>;
  crewsCount: Scalars['Int'];
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  hasEmployee: Scalars['Boolean'];
  id: Scalars['ID'];
  inviteToken?: Maybe<Scalars['String']>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  invitedBy?: Maybe<User>;
  jobPhasesCount: Scalars['Int'];
  jobsCount: Scalars['Int'];
  lastName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organization: Organization;
  permissions: Array<UserPermissions | `${UserPermissions}`>;
  phone?: Maybe<Scalars['String']>;
  proposalCount: Scalars['Int'];
  roles: Array<UserRole | `${UserRole}`>;
  status: UserStatus | `${UserStatus}`;
};

/** A paginated list of User items. */
export type UserPaginator = {
  __typename?: 'UserPaginator';
  /** A list of User items. */
  data: Array<User>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export enum UserPermissions {
  /** Add items to schedule */
  ADD_ITEMS_TO_SCHEDULE = 'ADD_ITEMS_TO_SCHEDULE',
  /** Add manual time */
  ADD_MANUAL_TIME = 'ADD_MANUAL_TIME',
  /** Do data imports */
  DO_DATA_IMPORTS = 'DO_DATA_IMPORTS',
  /** Generate reports */
  GENERATE_REPORTS = 'GENERATE_REPORTS',
  /** Input job info costs */
  INPUT_JOB_INFO_COSTS = 'INPUT_JOB_INFO_COSTS',
  /** Manage companies */
  MANAGE_COMPANIES = 'MANAGE_COMPANIES',
  /** Manage email settings */
  MANAGE_EMAIL_SETTINGS = 'MANAGE_EMAIL_SETTINGS',
  /** Manage employees */
  MANAGE_EMPLOYEES = 'MANAGE_EMPLOYEES',
  /** Manage knowledge base */
  MANAGE_KNOWLEDGE_BASE = 'MANAGE_KNOWLEDGE_BASE',
  /** Manage linked services */
  MANAGE_LINKED_SERVICES = 'MANAGE_LINKED_SERVICES',
  /** Manage notification triggers */
  MANAGE_NOTIFICATION_TRIGGERS = 'MANAGE_NOTIFICATION_TRIGGERS',
  /** Manage opportunities */
  MANAGE_OPPORTUNITIES = 'MANAGE_OPPORTUNITIES',
  /** Manage organization info */
  MANAGE_ORGANIZATION_INFO = 'MANAGE_ORGANIZATION_INFO',
  /** Manage product settings */
  MANAGE_PRODUCT_SETTINGS = 'MANAGE_PRODUCT_SETTINGS',
  /** Manage proposals */
  MANAGE_PROPOSALS = 'MANAGE_PROPOSALS',
  /** Manage proposal settings */
  MANAGE_PROPOSAL_SETTINGS = 'MANAGE_PROPOSAL_SETTINGS',
  /** Manage schedule */
  MANAGE_SCHEDULE = 'MANAGE_SCHEDULE',
  /** Manage subscription */
  MANAGE_SUBSCRIPTION = 'MANAGE_SUBSCRIPTION',
  /** Manage time tracking */
  MANAGE_TIME_TRACKING = 'MANAGE_TIME_TRACKING',
  /** Manage users */
  MANAGE_USERS = 'MANAGE_USERS',
  /** Push job to quickbooks */
  PUSH_JOB_TO_QUICKBOOKS = 'PUSH_JOB_TO_QUICKBOOKS',
  /** View all jobs */
  VIEW_ALL_JOBS = 'VIEW_ALL_JOBS',
  /** View all proposals */
  VIEW_ALL_PROPOSALS = 'VIEW_ALL_PROPOSALS',
  /** View assigned jobs */
  VIEW_ASSIGNED_JOBS = 'VIEW_ASSIGNED_JOBS',
  /** View companies */
  VIEW_COMPANIES = 'VIEW_COMPANIES',
  /** View crew jobs */
  VIEW_CREW_JOBS = 'VIEW_CREW_JOBS',
  /** View dashboard */
  VIEW_DASHBOARD = 'VIEW_DASHBOARD',
  /** View job financial summaries */
  VIEW_JOB_FINANCIAL_SUMMARIES = 'VIEW_JOB_FINANCIAL_SUMMARIES',
  /** View job info */
  VIEW_JOB_INFO = 'VIEW_JOB_INFO',
  /** View maps */
  VIEW_MAPS = 'VIEW_MAPS',
  /** View only assigned proposals */
  VIEW_ONLY_ASSIGNED_PROPOSALS = 'VIEW_ONLY_ASSIGNED_PROPOSALS',
  /** View opportunities */
  VIEW_OPPORTUNITIES = 'VIEW_OPPORTUNITIES',
  /** View schedule */
  VIEW_SCHEDULE = 'VIEW_SCHEDULE',
  /** View time tracking */
  VIEW_TIME_TRACKING = 'VIEW_TIME_TRACKING',
  /** View work order */
  VIEW_WORK_ORDER = 'VIEW_WORK_ORDER'
}

export enum UserRole {
  /** Admin */
  ADMIN = 'ADMIN',
  /** Employee */
  EMPLOYEE = 'EMPLOYEE',
  /** Foreman */
  FOREMAN = 'FOREMAN',
  /** Office manager */
  OFFICE_MANAGER = 'OFFICE_MANAGER',
  /** Sales person */
  SALES_PERSON = 'SALES_PERSON',
  /** Subcontractor */
  SUBCONTRACTOR = 'SUBCONTRACTOR'
}

export enum UserStatus {
  /** Active */
  ACTIVE = 'ACTIVE',
  /** Invited */
  INVITED = 'INVITED'
}

export type ValidateLoginInput = {
  email: Scalars['String'];
};

export type ValidateRegistrationTokenInput = {
  email: Scalars['String'];
  token: Scalars['String'];
};

export type WorkOrderCrew = {
  __typename?: 'WorkOrderCrew';
  crewId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type WorkOrderEquipmentPiece = {
  __typename?: 'WorkOrderEquipmentPiece';
  equipmentPieceId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type WorkOrderTransferTruck = {
  __typename?: 'WorkOrderTransferTruck';
  id: Scalars['ID'];
  name: Scalars['String'];
  quantity?: Maybe<Scalars['Float']>;
  rateHourly: Scalars['Int'];
  rateTon: Scalars['Int'];
  tonnage: Scalars['Int'];
  transferTruckId?: Maybe<Scalars['ID']>;
};

export type YearToDateStats = {
  __typename?: 'YearToDateStats';
  yearToDateCloseRate: Scalars['Float'];
  yearToDateJobAmountCompleted?: Maybe<Scalars['String']>;
  yearToDateNetMarginCalculated?: Maybe<Scalars['Float']>;
  yearToDateTotalAmountProposed?: Maybe<Scalars['String']>;
  yearToDateTotalSalesWon?: Maybe<Scalars['String']>;
};

export type YearlyDashboardData = {
  __typename?: 'YearlyDashboardData';
  closedBids?: Maybe<Array<Maybe<MonthlySummary>>>;
  closedRate?: Maybe<Array<Maybe<MonthlySummary>>>;
  closedRevenue?: Maybe<Array<Maybe<MonthlySummary>>>;
  sentBids?: Maybe<Array<Maybe<MonthlySummary>>>;
};

export type CreateOrganizationApiKeyMutationVariables = Exact<{
  description: Scalars['String'];
}>;


export type CreateOrganizationApiKeyMutation = { __typename?: 'Mutation', CreateOrganizationApiKey: { __typename?: 'CreateOrganizationApiKey', success: boolean } };

export type DeleteOrganizationApiKeyMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteOrganizationApiKeyMutation = { __typename?: 'Mutation', DeleteOrganizationApiKey: { __typename?: 'DeleteOrganizationApiKey', success: boolean } };

export type AcceptUserInviteMutationVariables = Exact<{
  input: AcceptUserInviteInput;
}>;


export type AcceptUserInviteMutation = { __typename?: 'Mutation', acceptUserInvite?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null };

export type AddJobPhaseCostsMutationVariables = Exact<{
  input: AddJobPhaseCostsInput;
}>;


export type AddJobPhaseCostsMutation = { __typename?: 'Mutation', addJobPhaseCosts: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string }, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, name?: string | null, type?: string | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null } } | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType } | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null } };

export type AddJobPhaseFileMutationVariables = Exact<{
  jobPhaseId: Scalars['ID'];
  path: Scalars['String'];
}>;


export type AddJobPhaseFileMutation = { __typename?: 'Mutation', addJobPhaseFile: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType } | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null } }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType } | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, name?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, rate: number, type: string } | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: number | null, costMaterialOverride?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId: string, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, quantity: number, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null }, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }> | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null } }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string }, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, name?: string | null, type?: string | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null } };

export type AddOrganizationDataUploadMutationVariables = Exact<{
  input: AddOrganizationDataUploadInput;
}>;


export type AddOrganizationDataUploadMutation = { __typename?: 'Mutation', addOrganizationDataUpload: { __typename?: 'OrganizationDataUpload', createdAt: any, error?: string | null, id: string, path: string, startedAt?: any | null, status: OrganizationDataUploadStatus, type: OrganizationDataUploadType, updatedAt: any, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null }, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } };

export type AddOrganizationDocumentMutationVariables = Exact<{
  name: Scalars['String'];
  path: Scalars['String'];
}>;


export type AddOrganizationDocumentMutation = { __typename?: 'Mutation', addOrganizationDocument: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } };

export type AddProductToProposalStageMutationVariables = Exact<{
  productId: Scalars['ID'];
  proposalStageId: Scalars['ID'];
}>;


export type AddProductToProposalStageMutation = { __typename?: 'Mutation', addProductToProposalStage: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }> | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null } };

export type AddProjectFileMutationVariables = Exact<{
  name: Scalars['String'];
  parentFolderId?: InputMaybe<Scalars['ID']>;
  path: Scalars['String'];
}>;


export type AddProjectFileMutation = { __typename?: 'Mutation', addProjectFile: { __typename?: 'ProjectFile', fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType, children?: Array<{ __typename?: 'ProjectFile', fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType, children?: Array<{ __typename?: 'ProjectFile', fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType }> | null }> | null } };

export type AddProposalAdditionalCostMutationVariables = Exact<{
  additionalCostId: Scalars['ID'];
  proposalProductId: Scalars['ID'];
}>;


export type AddProposalAdditionalCostMutation = { __typename?: 'Mutation', addProposalAdditionalCost: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }> | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null } };

export type AddProposalAdditionalCostsMutationVariables = Exact<{
  additionalCosts: Array<Scalars['ID']> | Scalars['ID'];
  proposalProductId: Scalars['ID'];
}>;


export type AddProposalAdditionalCostsMutation = { __typename?: 'Mutation', addProposalAdditionalCosts: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }> | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null } };

export type AddProposalAddressMutationVariables = Exact<{
  input: AddProposalAddressInput;
}>;


export type AddProposalAddressMutation = { __typename?: 'Mutation', addProposalAddress: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }> | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null } };

export type AddProposalCrewMutationVariables = Exact<{
  crewId: Scalars['ID'];
  proposalProductId: Scalars['ID'];
}>;


export type AddProposalCrewMutation = { __typename?: 'Mutation', addProposalCrew: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }> | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null } };

export type AddProposalCrewsMutationVariables = Exact<{
  crewIds: Array<Scalars['ID']> | Scalars['ID'];
  proposalProductId: Scalars['ID'];
}>;


export type AddProposalCrewsMutation = { __typename?: 'Mutation', addProposalCrews: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }> | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null } };

export type AddProposalEquipmentPieceMutationVariables = Exact<{
  equipmentPieceId: Scalars['ID'];
  proposalProductId: Scalars['ID'];
  quantity: Scalars['Int'];
}>;


export type AddProposalEquipmentPieceMutation = { __typename?: 'Mutation', addProposalEquipmentPiece: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }> | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null } };

export type AddProposalEquipmentPiecesMutationVariables = Exact<{
  equipmentPieces: Array<AddProposalEquipmentPieceInput> | AddProposalEquipmentPieceInput;
  proposalProductId: Scalars['ID'];
}>;


export type AddProposalEquipmentPiecesMutation = { __typename?: 'Mutation', addProposalEquipmentPieces: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }> | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null } };

export type AddProposalFileMutationVariables = Exact<{
  path: Scalars['String'];
  proposalProductId: Scalars['ID'];
}>;


export type AddProposalFileMutation = { __typename?: 'Mutation', addProposalFile: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: number | null, costMaterialOverride?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId: string, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, quantity: number, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null } };

export type AddProposalStageMutationVariables = Exact<{
  proposalId: Scalars['ID'];
}>;


export type AddProposalStageMutation = { __typename?: 'Mutation', addProposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: number | null, costMaterialOverride?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId: string, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, quantity: number, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null }> | null } | null };

export type AddTruckToProposalProductMutationVariables = Exact<{
  input: AddTruckToProposalProductInput;
}>;


export type AddTruckToProposalProductMutation = { __typename?: 'Mutation', addTruckToProposalProduct?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }> | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null } | null };

export type AppLoginMutationVariables = Exact<{
  input: LoginInput;
}>;


export type AppLoginMutation = { __typename?: 'Mutation', appLogin?: { __typename?: 'LoginAppUser', token?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } | null };

export type AppLogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type AppLogoutMutation = { __typename?: 'Mutation', appLogout?: boolean | null };

export type ArchiveCompanyMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ArchiveCompanyMutation = { __typename?: 'Mutation', archiveCompany: boolean };

export type CancelOpportunityMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CancelOpportunityMutation = { __typename?: 'Mutation', cancelOpportunity: { __typename?: 'Opportunity', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, companyId: string, contactId: string, createdAt: any, dueAt?: any | null, estimatedOpportunityValue?: number | null, externalId: string, id: string, name: string, notes?: string | null, projectFilesFolderId?: string | null, source?: OpportunitySource | null, status: string, statusId: string, updatedAt: any, userId?: string | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, products?: Array<{ __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } };

export type CancelProposalMutationVariables = Exact<{
  duplicate: Scalars['Boolean'];
  id: Scalars['ID'];
  maintainCurrentId?: InputMaybe<Scalars['Boolean']>;
}>;


export type CancelProposalMutation = { __typename?: 'Mutation', cancelProposal: { __typename?: 'CancelProposalResponse', newProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: number | null, costMaterialOverride?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId: string, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, quantity: number, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null }> | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null }> | null } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null } } };

export type CloseProposalMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CloseProposalMutation = { __typename?: 'Mutation', closeProposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }> | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null } };

export type CreateAdditionalCostMutationVariables = Exact<{
  input: CreateAdditionalCostInput;
}>;


export type CreateAdditionalCostMutation = { __typename?: 'Mutation', createAdditionalCost: { __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string } };

export type CreateCompanyMutationVariables = Exact<{
  input: CreateCompanyInput;
}>;


export type CreateCompanyMutation = { __typename?: 'Mutation', createCompany: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null } };

export type CreateCrewMutationVariables = Exact<{
  input: CreateCrewInput;
}>;


export type CreateCrewMutation = { __typename?: 'Mutation', createCrew: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } };

export type CreateCustomEventMutationVariables = Exact<{
  input?: InputMaybe<CreateCustomEventInput>;
}>;


export type CreateCustomEventMutation = { __typename?: 'Mutation', createCustomEvent?: { __typename?: 'CustomEvent', color?: string | null, endsAt?: any | null, id?: string | null, name?: string | null, notes?: string | null, startsAt?: any | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, customEventBlocks?: Array<{ __typename?: 'CustomEventBlock', blockLength?: number | null, endsAt?: any | null, id?: string | null, scheduledAt?: any | null, customEvent?: { __typename?: 'CustomEvent', color?: string | null, endsAt?: any | null, id?: string | null, name?: string | null, notes?: string | null, startsAt?: any | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, customEventBlocks?: Array<{ __typename?: 'CustomEventBlock', blockLength?: number | null, endsAt?: any | null, id?: string | null, scheduledAt?: any | null } | null> | null, customEventsToUsers?: Array<{ __typename?: 'CustomEventsToUsers', user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null } | null> | null } | null } | null> | null } | null };

export type CreateEmployeeMutationVariables = Exact<{
  input: CreateEmployeeInput;
}>;


export type CreateEmployeeMutation = { __typename?: 'Mutation', createEmployee: { __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } };

export type CreateEquipmentPieceMutationVariables = Exact<{
  input: CreateEquipmentPieceInput;
}>;


export type CreateEquipmentPieceMutation = { __typename?: 'Mutation', createEquipmentPiece: { __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number } };

export type CreateJobInvoiceOnLinkedServiceMutationVariables = Exact<{
  jobId: Scalars['ID'];
  service: OrganizationLinkedServiceName;
}>;


export type CreateJobInvoiceOnLinkedServiceMutation = { __typename?: 'Mutation', createJobInvoiceOnLinkedService?: boolean | null };

export type CreateNotificationTriggerMutationVariables = Exact<{
  input: CreateNotificationTriggerInput;
}>;


export type CreateNotificationTriggerMutation = { __typename?: 'Mutation', createNotificationTrigger?: { __typename?: 'NotificationTrigger', active: boolean, additionalRecipientTypes?: Array<NotificationTriggerAdditionalRecipientTypes> | null, content: string, delay: number, emailSubject?: string | null, event: NotificationTriggerEvent, id: string, isEmail?: boolean | null, isSMS?: boolean | null, name: string, sendToAllRecipients: boolean, sendToContact: boolean, sendToUser: boolean, smsContent?: string | null, type: NotificationTriggerType, additionalRecipients: Array<{ __typename?: 'NotificationTriggerRecipient', email: string, firstName: string, id: string, lastName: string }>, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } } | null };

export type CreateOpportunityMutationVariables = Exact<{
  input: CreateOpportunityInput;
}>;


export type CreateOpportunityMutation = { __typename?: 'Mutation', createOpportunity: { __typename?: 'Opportunity', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, companyId: string, contactId: string, createdAt: any, dueAt?: any | null, estimatedOpportunityValue?: number | null, externalId: string, id: string, name: string, notes?: string | null, projectFilesFolderId?: string | null, source?: OpportunitySource | null, status: string, statusId: string, updatedAt: any, userId?: string | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, products?: Array<{ __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } };

export type CreateOpportunityStatusMutationVariables = Exact<{
  name: Scalars['String'];
}>;


export type CreateOpportunityStatusMutation = { __typename?: 'Mutation', createOpportunityStatus: { __typename?: 'OrganizationOpportunityStatus', id: string, name: string } };

export type CreateOrganizationAddressMutationVariables = Exact<{
  input: CreateOrganizationAddressInput;
}>;


export type CreateOrganizationAddressMutation = { __typename?: 'Mutation', createOrganizationAddress?: { __typename?: 'OrganizationAddress', city: string, country: string, id: string, isPrimary: boolean, latitude: string, line1: string, line2?: string | null, longitude: string, state: string, zip: string } | null };

export type CreateOrganizationProductTypeMutationVariables = Exact<{
  input: CreateOrganizationProductTypeInput;
}>;


export type CreateOrganizationProductTypeMutation = { __typename?: 'Mutation', createOrganizationProductType: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } };

export type CreatePlantMutationVariables = Exact<{
  input: CreatePlantInput;
}>;


export type CreatePlantMutation = { __typename?: 'Mutation', createPlant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, rate: number, type: string }> } | null };

export type CreatePlantProductTypeMutationVariables = Exact<{
  name: Scalars['String'];
}>;


export type CreatePlantProductTypeMutation = { __typename?: 'Mutation', createPlantProductType?: { __typename?: 'ModelsPlantProductType', id: string, name: string } | null };

export type CreateProductMutationVariables = Exact<{
  input: CreateProductInput;
}>;


export type CreateProductMutation = { __typename?: 'Mutation', createProduct: { __typename?: 'Product', areaCoverage?: number | null, costMaterial?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: number | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, overheadPercentage?: number | null, plantProductId?: string | null, productionRateType?: ProductProductionRateType | null, statementOfWork?: string | null, subcontracted: boolean, type: ProductType, unitPrice?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organizationProductType: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType }, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, rate: number, type: string }> } | null, productAdditionalCosts?: Array<{ __typename?: 'ProductAdditionalCost', id: string, type?: ProductAdditionalCostType | null, additionalCost: { __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string } }> | null, productEquipmentPieces?: Array<{ __typename?: 'ProductEquipmentPiece', id: string, quantity: number, equipmentPiece: { __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number } }> | null } };

export type CreateProjectFileFolderMutationVariables = Exact<{
  name: Scalars['String'];
  parentFolderId?: InputMaybe<Scalars['ID']>;
}>;


export type CreateProjectFileFolderMutation = { __typename?: 'Mutation', createProjectFileFolder: { __typename?: 'ProjectFile', fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType, children?: Array<{ __typename?: 'ProjectFile', fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType, children?: Array<{ __typename?: 'ProjectFile', fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType }> | null }> | null } };

export type CreateProposalMutationVariables = Exact<{
  companyId: Scalars['ID'];
  contactId: Scalars['ID'];
  source?: InputMaybe<ProposalSource>;
}>;


export type CreateProposalMutation = { __typename?: 'Mutation', createProposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }> | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null } };

export type CreateProposalFromOpportunityMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CreateProposalFromOpportunityMutation = { __typename?: 'Mutation', createProposalFromOpportunity: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }> | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null } };

export type CreateTimeBucketMutationVariables = Exact<{
  input: CreateTimeBucketInput;
}>;


export type CreateTimeBucketMutation = { __typename?: 'Mutation', createTimeBucket: { __typename?: 'TimeBucket', id: string, name: string, organizationId: string } };

export type CreateTimeEntryMutationVariables = Exact<{
  input: CreateTimeEntryInput;
}>;


export type CreateTimeEntryMutation = { __typename?: 'Mutation', createTimeEntry: { __typename?: 'TimeEntry', clockInLatitude?: number | null, clockInLongitude?: number | null, clockOutLatitude?: number | null, clockOutLongitude?: number | null, endTime?: any | null, forDate: any, id: string, notes?: string | null, organizationId: string, startTime: any, timeTrackedSeconds?: number | null, timeTrackedSecondsOverride?: number | null, uuid: string, jobPhase?: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null } }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string }, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, name?: string | null, type?: string | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null } } | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }> } | null, timeBucket?: { __typename?: 'TimeBucket', id: string, name: string, organizationId: string } | null, user: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } } };

export type CreateTransferTruckMutationVariables = Exact<{
  input: CreateTransferTruckInput;
}>;


export type CreateTransferTruckMutation = { __typename?: 'Mutation', createTransferTruck?: { __typename?: 'TransferTruck', defaultRateHourly: number, defaultRateTon: number, defaultTonnage: number, id: string, name: string } | null };

export type DeleteAdditionalCostMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteAdditionalCostMutation = { __typename?: 'Mutation', deleteAdditionalCost?: boolean | null };

export type DeleteCrewMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteCrewMutation = { __typename?: 'Mutation', deleteCrew?: boolean | null };

export type DeleteCustomEventMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteCustomEventMutation = { __typename?: 'Mutation', deleteCustomEvent: { __typename?: 'CustomEvent', color?: string | null, endsAt?: any | null, id?: string | null, name?: string | null, notes?: string | null, startsAt?: any | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, customEventBlocks?: Array<{ __typename?: 'CustomEventBlock', blockLength?: number | null, endsAt?: any | null, id?: string | null, scheduledAt?: any | null, customEvent?: { __typename?: 'CustomEvent', color?: string | null, endsAt?: any | null, id?: string | null, name?: string | null, notes?: string | null, startsAt?: any | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, customEventBlocks?: Array<{ __typename?: 'CustomEventBlock', blockLength?: number | null, endsAt?: any | null, id?: string | null, scheduledAt?: any | null } | null> | null, customEventsToUsers?: Array<{ __typename?: 'CustomEventsToUsers', user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null } | null> | null } | null } | null> | null } };

export type DeleteEmployeeMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteEmployeeMutation = { __typename?: 'Mutation', deleteEmployee?: boolean | null };

export type DeleteEquipmentPieceMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteEquipmentPieceMutation = { __typename?: 'Mutation', deleteEquipmentPiece?: boolean | null };

export type DeleteJobPhaseCostMutationVariables = Exact<{
  date: Scalars['Date'];
  jobPhaseId: Scalars['ID'];
}>;


export type DeleteJobPhaseCostMutation = { __typename?: 'Mutation', deleteJobPhaseCost: boolean };

export type DeleteJobPhaseFileMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteJobPhaseFileMutation = { __typename?: 'Mutation', deleteJobPhaseFile?: boolean | null };

export type DeleteNotificationTriggerMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteNotificationTriggerMutation = { __typename?: 'Mutation', deleteNotificationTrigger?: boolean | null };

export type DeleteOpportunityMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteOpportunityMutation = { __typename?: 'Mutation', deleteOpportunity?: { __typename?: 'Opportunity', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, companyId: string, contactId: string, createdAt: any, dueAt?: any | null, estimatedOpportunityValue?: number | null, externalId: string, id: string, name: string, notes?: string | null, projectFilesFolderId?: string | null, source?: OpportunitySource | null, status: string, statusId: string, updatedAt: any, userId?: string | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, products?: Array<{ __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } | null };

export type DeleteOrganizationAddressMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteOrganizationAddressMutation = { __typename?: 'Mutation', deleteOrganizationAddress?: boolean | null };

export type DeleteOrganizationDocumentMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteOrganizationDocumentMutation = { __typename?: 'Mutation', deleteOrganizationDocument: boolean };

export type DeleteOrganizationProductTypeMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteOrganizationProductTypeMutation = { __typename?: 'Mutation', deleteOrganizationProductType?: boolean | null };

export type DeleteOrganizationUserMutationVariables = Exact<{
  id: Scalars['ID'];
  openProposalAction: DeleteOpenProposalAction;
  reassignJobPhaseForemanUserId?: InputMaybe<Scalars['ID']>;
  reassignJobUserId?: InputMaybe<Scalars['ID']>;
  reassignUserId?: InputMaybe<Scalars['ID']>;
}>;


export type DeleteOrganizationUserMutation = { __typename?: 'Mutation', deleteOrganizationUser: boolean };

export type DeletePlantMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeletePlantMutation = { __typename?: 'Mutation', deletePlant?: boolean | null };

export type DeleteProductMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteProductMutation = { __typename?: 'Mutation', deleteProduct?: boolean | null };

export type DeleteProjectFileMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteProjectFileMutation = { __typename?: 'Mutation', deleteProjectFile: { __typename?: 'ProjectFile', fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType, children?: Array<{ __typename?: 'ProjectFile', fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType, children?: Array<{ __typename?: 'ProjectFile', fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType }> | null }> | null } };

export type DeleteProposalMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteProposalMutation = { __typename?: 'Mutation', deleteProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }> | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null } | null };

export type DeleteProposalFileMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteProposalFileMutation = { __typename?: 'Mutation', deleteProposalFile: boolean };

export type DeleteProposalMapImageMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteProposalMapImageMutation = { __typename?: 'Mutation', deleteProposalMapImage: boolean };

export type DeleteProposalProductMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteProposalProductMutation = { __typename?: 'Mutation', deleteProposalProduct: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: number | null, costMaterialOverride?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId: string, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, quantity: number, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null }> | null } };

export type DeleteProposalRecipientMutationVariables = Exact<{
  email: Scalars['String'];
  proposalId: Scalars['ID'];
}>;


export type DeleteProposalRecipientMutation = { __typename?: 'Mutation', deleteProposalRecipient: boolean };

export type DeleteProposalStageMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteProposalStageMutation = { __typename?: 'Mutation', deleteProposalStage: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }> | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null } };

export type DeleteTimeBucketMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteTimeBucketMutation = { __typename?: 'Mutation', deleteTimeBucket: { __typename?: 'TimeBucket', id: string, name: string, organizationId: string } };

export type DeleteTimeEntryMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteTimeEntryMutation = { __typename?: 'Mutation', deleteTimeEntry?: { __typename?: 'TimeEntry', clockInLatitude?: number | null, clockInLongitude?: number | null, clockOutLatitude?: number | null, clockOutLongitude?: number | null, endTime?: any | null, forDate: any, id: string, notes?: string | null, organizationId: string, startTime: any, timeTrackedSeconds?: number | null, timeTrackedSecondsOverride?: number | null, uuid: string, jobPhase?: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null } }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string }, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, name?: string | null, type?: string | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null } } | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }> } | null, timeBucket?: { __typename?: 'TimeBucket', id: string, name: string, organizationId: string } | null, user: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } } | null };

export type DeleteTransferTruckMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteTransferTruckMutation = { __typename?: 'Mutation', deleteTransferTruck?: boolean | null };

export type DeleteUserInviteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteUserInviteMutation = { __typename?: 'Mutation', deleteUserInvite?: boolean | null };

export type DuplicateProductMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DuplicateProductMutation = { __typename?: 'Mutation', duplicateProduct: { __typename?: 'Product', areaCoverage?: number | null, costMaterial?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: number | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, overheadPercentage?: number | null, plantProductId?: string | null, productionRateType?: ProductProductionRateType | null, statementOfWork?: string | null, subcontracted: boolean, type: ProductType, unitPrice?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organizationProductType: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType }, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, rate: number, type: string }> } | null, productAdditionalCosts?: Array<{ __typename?: 'ProductAdditionalCost', id: string, type?: ProductAdditionalCostType | null, additionalCost: { __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string } }> | null, productEquipmentPieces?: Array<{ __typename?: 'ProductEquipmentPiece', id: string, quantity: number, equipmentPiece: { __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number } }> | null } };

export type DuplicateProposalMutationVariables = Exact<{
  changeOrderJobId?: InputMaybe<Scalars['ID']>;
  createNewVersion?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isChangeOrder?: InputMaybe<Scalars['Boolean']>;
  startNewProposal?: InputMaybe<Scalars['Boolean']>;
}>;


export type DuplicateProposalMutation = { __typename?: 'Mutation', duplicateProposal?: { __typename?: 'DuplicateProposalResponse', newProposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: number | null, costMaterialOverride?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId: string, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, quantity: number, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null }> | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null }> | null } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null } } | null };

export type FinalizeLinkedServiceAccountMutationVariables = Exact<{
  code?: InputMaybe<Scalars['String']>;
  realmId?: InputMaybe<Scalars['String']>;
  service: OrganizationLinkedServiceName;
  state?: InputMaybe<Scalars['String']>;
}>;


export type FinalizeLinkedServiceAccountMutation = { __typename?: 'Mutation', finalizeLinkedServiceAccount?: boolean | null };

export type FinishRegistrationMutationVariables = Exact<{
  input: FinishRegistrationInput;
}>;


export type FinishRegistrationMutation = { __typename?: 'Mutation', finishRegistration?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null };

export type GenerateOrganizationDataUploadUrlMutationVariables = Exact<{
  contentType: Scalars['String'];
  filename: Scalars['String'];
}>;


export type GenerateOrganizationDataUploadUrlMutation = { __typename?: 'Mutation', generateOrganizationDataUploadUrl: { __typename?: 'GenerateUploadOrganizationDocumentUrl', method: string, path: string, url: string } };

export type GenerateReportMutationVariables = Exact<{
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
  type: ReportType;
}>;


export type GenerateReportMutation = { __typename?: 'Mutation', generateReport: string };

export type GenerateUploadCompanyLogoUrlMutationVariables = Exact<{
  contentType: Scalars['String'];
  filename: Scalars['String'];
}>;


export type GenerateUploadCompanyLogoUrlMutation = { __typename?: 'Mutation', generateUploadCompanyLogoUrl: { __typename?: 'GenerateUploadCompanyLogoUrl', method: string, path: string, url: string } };

export type GenerateUploadJobPhaseCostItemFileUrlMutationVariables = Exact<{
  contentType: Scalars['String'];
  filename: Scalars['String'];
  jobPhaseId: Scalars['ID'];
}>;


export type GenerateUploadJobPhaseCostItemFileUrlMutation = { __typename?: 'Mutation', generateUploadJobPhaseCostItemFileUrl: { __typename?: 'GenerateUploadProposalFileUrl', method: string, path: string, url: string } };

export type GenerateUploadOrganizationDocumentUrlMutationVariables = Exact<{
  contentType: Scalars['String'];
  filename: Scalars['String'];
}>;


export type GenerateUploadOrganizationDocumentUrlMutation = { __typename?: 'Mutation', generateUploadOrganizationDocumentUrl: { __typename?: 'GenerateUploadOrganizationDocumentUrl', method: string, path: string, url: string } };

export type GenerateUploadOrganizationLogoUrlMutationVariables = Exact<{
  contentType: Scalars['String'];
  filename: Scalars['String'];
}>;


export type GenerateUploadOrganizationLogoUrlMutation = { __typename?: 'Mutation', generateUploadOrganizationLogoUrl: { __typename?: 'GenerateUploadOrganizationLogoUrl', method: string, path: string, url: string } };

export type GenerateUploadProjectFileUrlMutationVariables = Exact<{
  contentType?: InputMaybe<Scalars['String']>;
  filename: Scalars['String'];
}>;


export type GenerateUploadProjectFileUrlMutation = { __typename?: 'Mutation', generateUploadProjectFileUrl: { __typename?: 'GenerateUploadUrl', contentDisposition?: string | null, contentType: string, method: string, path: string, url: string } };

export type GenerateUploadProposalFileUrlMutationVariables = Exact<{
  contentType: Scalars['String'];
  filename: Scalars['String'];
  proposalProductId: Scalars['ID'];
}>;


export type GenerateUploadProposalFileUrlMutation = { __typename?: 'Mutation', generateUploadProposalFileUrl: { __typename?: 'GenerateUploadProposalFileUrl', method: string, path: string, url: string } };

export type GetLinkedServiceAuthUrlMutationVariables = Exact<{
  service: OrganizationLinkedServiceName;
}>;


export type GetLinkedServiceAuthUrlMutation = { __typename?: 'Mutation', getLinkedServiceAuthUrl?: string | null };

export type InviteUserMutationVariables = Exact<{
  input: InviteUserInput;
}>;


export type InviteUserMutation = { __typename?: 'Mutation', inviteUser?: boolean | null };

export type LoginMutationVariables = Exact<{
  input: LoginInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', login?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout?: boolean | null };

export type MergeCompanyMutationVariables = Exact<{
  sourceCompany: Scalars['ID'];
  targetCompany: Scalars['ID'];
}>;


export type MergeCompanyMutation = { __typename?: 'Mutation', mergeCompany: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null } };

export type PreviewProposalMutationVariables = Exact<{
  acceptanceOverride?: InputMaybe<Scalars['String']>;
  attachments?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  clientEmailOverride?: InputMaybe<Scalars['String']>;
  emailBodyOverride?: InputMaybe<Scalars['String']>;
  emailSubjectOverride?: InputMaybe<Scalars['String']>;
  forceSend?: InputMaybe<Scalars['Boolean']>;
  layout: ProposalLayout;
  proposalId: Scalars['ID'];
  removeIndividualLineItemPricing?: InputMaybe<Scalars['Boolean']>;
  removeUnitPriceAndQuantity?: InputMaybe<Scalars['Boolean']>;
}>;


export type PreviewProposalMutation = { __typename?: 'Mutation', previewProposal?: string | null };

export type RegisterMutationVariables = Exact<{
  input: RegisterInput;
}>;


export type RegisterMutation = { __typename?: 'Mutation', register?: boolean | null };

export type RemoveTruckFromProposalProductMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveTruckFromProposalProductMutation = { __typename?: 'Mutation', removeTruckFromProposalProduct?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }> | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null } | null };

export type RequestPasswordResetMutationVariables = Exact<{
  input: RequestPasswordResetInput;
}>;


export type RequestPasswordResetMutation = { __typename?: 'Mutation', requestPasswordReset?: boolean | null };

export type ResendUserInviteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ResendUserInviteMutation = { __typename?: 'Mutation', resendUserInvite?: boolean | null };

export type ResendVerificationEmailMutationVariables = Exact<{
  input: ResendVerificationEmailInput;
}>;


export type ResendVerificationEmailMutation = { __typename?: 'Mutation', resendVerificationEmail?: boolean | null };

export type ResetPasswordMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword?: boolean | null };

export type SaveQuickbooksIncomeAccountMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SaveQuickbooksIncomeAccountMutation = { __typename?: 'Mutation', saveQuickbooksIncomeAccount?: boolean | null };

export type SaveQuickbooksIntegrationMutationVariables = Exact<{
  input: QuickbooksIntegrationInput;
}>;


export type SaveQuickbooksIntegrationMutation = { __typename?: 'Mutation', saveQuickbooksIntegration: boolean };

export type ScheduleCustomEventBlockMutationVariables = Exact<{
  input: ScheduleCustomEventBlockInput;
}>;


export type ScheduleCustomEventBlockMutation = { __typename?: 'Mutation', scheduleCustomEventBlock: { __typename?: 'CustomEvent', color?: string | null, endsAt?: any | null, id?: string | null, name?: string | null, notes?: string | null, startsAt?: any | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, customEventBlocks?: Array<{ __typename?: 'CustomEventBlock', blockLength?: number | null, endsAt?: any | null, id?: string | null, scheduledAt?: any | null, customEvent?: { __typename?: 'CustomEvent', color?: string | null, endsAt?: any | null, id?: string | null, name?: string | null, notes?: string | null, startsAt?: any | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, customEventBlocks?: Array<{ __typename?: 'CustomEventBlock', blockLength?: number | null, endsAt?: any | null, id?: string | null, scheduledAt?: any | null } | null> | null, customEventsToUsers?: Array<{ __typename?: 'CustomEventsToUsers', user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null } | null> | null } | null } | null> | null } };

export type ScheduleJobPhaseMutationVariables = Exact<{
  blocks: Array<InputMaybe<AddJobPhaseScheduleBlock>> | InputMaybe<AddJobPhaseScheduleBlock>;
  crewId?: InputMaybe<Scalars['ID']>;
  jobPhaseId: Scalars['ID'];
  travelTimeEstimate?: InputMaybe<Scalars['Float']>;
  userIDs?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  usersColor?: InputMaybe<Scalars['String']>;
}>;


export type ScheduleJobPhaseMutation = { __typename?: 'Mutation', scheduleJobPhase: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }> | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null } }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string }, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, name?: string | null, type?: string | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null } } | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, name?: string | null, type?: string | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }> | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null } } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null } };

export type ScheduleJobPhaseBlockMutationVariables = Exact<{
  input: ScheduleJobPhaseBlockInput;
}>;


export type ScheduleJobPhaseBlockMutation = { __typename?: 'Mutation', scheduleJobPhaseBlock: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }> | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null } }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string }, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, name?: string | null, type?: string | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null } } | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, name?: string | null, type?: string | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }> | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null } } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null } };

export type SendOrganizationEmailTemplatePreviewMutationVariables = Exact<{
  html: Scalars['String'];
}>;


export type SendOrganizationEmailTemplatePreviewMutation = { __typename?: 'Mutation', sendOrganizationEmailTemplatePreview: boolean };

export type SendProposalMutationVariables = Exact<{
  acceptanceOverride?: InputMaybe<Scalars['String']>;
  attachments?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  clientEmailOverride?: InputMaybe<Scalars['String']>;
  emailBodyOverride?: InputMaybe<Scalars['String']>;
  emailSubjectOverride?: InputMaybe<Scalars['String']>;
  emails?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  forceSend?: InputMaybe<Scalars['Boolean']>;
  layout: ProposalLayout;
  proposalId: Scalars['ID'];
  proposalNotes?: InputMaybe<Scalars['String']>;
  removeIndividualLineItemPricing?: InputMaybe<Scalars['Boolean']>;
  removeUnitPriceAndQuantity?: InputMaybe<Scalars['Boolean']>;
}>;


export type SendProposalMutation = { __typename?: 'Mutation', sendProposal: boolean };

export type SendProposalToSpecificRecipientsMutationVariables = Exact<{
  clientEmailOverride?: InputMaybe<Scalars['String']>;
  emailBodyOverride?: InputMaybe<Scalars['String']>;
  emailSubjectOverride?: InputMaybe<Scalars['String']>;
  emails: Array<Scalars['String']> | Scalars['String'];
  forceSend?: InputMaybe<Scalars['Boolean']>;
  proposalId: Scalars['ID'];
  removeIndividualLineItemPricing?: InputMaybe<Scalars['Boolean']>;
  removeUnitPriceAndQuantity?: InputMaybe<Scalars['Boolean']>;
}>;


export type SendProposalToSpecificRecipientsMutation = { __typename?: 'Mutation', sendProposalToSpecificRecipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }> };

export type SetProposalToDraftMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SetProposalToDraftMutation = { __typename?: 'Mutation', setProposalToDraft: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }> | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null } };

export type SetProposalToWonMutationVariables = Exact<{
  forceSend?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
}>;


export type SetProposalToWonMutation = { __typename?: 'Mutation', setProposalToWon: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }> | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null } };

export type SignProposalMutationVariables = Exact<{
  email: Scalars['String'];
  removeProducts?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  signature: Scalars['String'];
  signeeInitials: Scalars['String'];
  signeeName: Scalars['String'];
  signeeTitle: Scalars['String'];
  uuid: Scalars['String'];
}>;


export type SignProposalMutation = { __typename?: 'Mutation', signProposal: { __typename?: 'PublicProposal', acceptanceOverride?: string | null, costTaxes: string, externalId: string, id: string, layout: ProposalLayout, overallTotal: string, overallTotalAfterTaxes: string, proposalPDF?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, signedAt?: any | null, signeeInitials?: string | null, signeeName?: string | null, signeeTitle?: string | null, status: ProposalStatus, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, company: { __typename?: 'PublicCompany', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, name: string, phone?: string | null, website?: string | null }, contact: { __typename?: 'PublicContact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, title?: string | null }, content: Array<{ __typename?: 'ProposalContent', content: string, contentOverride: string, type: ProposalContentType } | null>, organization: { __typename?: 'PublicOrganization', email?: string | null, id: string, logo?: string | null, name: string, phone?: string | null, address?: { __typename?: 'OrganizationAddress', city: string, country: string, id: string, isPrimary: boolean, latitude: string, line1: string, line2?: string | null, longitude: string, state: string, zip: string } | null }, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'PublicProposalStage', addressOverride?: string | null, id: string, name?: string | null, ordering: number, overallTotal: string, address?: { __typename?: 'PublicProposalAddress', city: string, country: string, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, state: string, zip: string } | null, content: Array<{ __typename?: 'ProposalContent', content: string, contentOverride: string, type: ProposalContentType } | null>, proposalProducts?: Array<{ __typename?: 'PublicProposalProduct', id: string, isOptional: boolean, jobDuration: number, jobSize: number, mapImage?: string | null, ordering: number, overallTotal: string, overallTotalOverride?: string | null, statementOfWork?: string | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: number | null, costMaterialOverride?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId: string, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null } }> | null }>, user: { __typename?: 'PublicUser', email: string, firstName?: string | null, id: string, lastName?: string | null, phone?: string | null } } };

export type ToggleProposalProductOptionalityMutationVariables = Exact<{
  id: Scalars['ID'];
  isOptional: Scalars['Boolean'];
}>;


export type ToggleProposalProductOptionalityMutation = { __typename?: 'Mutation', toggleProposalProductOptionality: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: number | null, costMaterialOverride?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId: string, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, quantity: number, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null } };

export type UnlinkServiceMutationVariables = Exact<{
  service: OrganizationLinkedServiceName;
}>;


export type UnlinkServiceMutation = { __typename?: 'Mutation', unlinkService?: boolean | null };

export type UnscheduleCustomEventMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UnscheduleCustomEventMutation = { __typename?: 'Mutation', unscheduleCustomEvent: { __typename?: 'CustomEvent', color?: string | null, endsAt?: any | null, id?: string | null, name?: string | null, notes?: string | null, startsAt?: any | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, customEventBlocks?: Array<{ __typename?: 'CustomEventBlock', blockLength?: number | null, endsAt?: any | null, id?: string | null, scheduledAt?: any | null, customEvent?: { __typename?: 'CustomEvent', color?: string | null, endsAt?: any | null, id?: string | null, name?: string | null, notes?: string | null, startsAt?: any | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, customEventBlocks?: Array<{ __typename?: 'CustomEventBlock', blockLength?: number | null, endsAt?: any | null, id?: string | null, scheduledAt?: any | null } | null> | null, customEventsToUsers?: Array<{ __typename?: 'CustomEventsToUsers', user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null } | null> | null } | null } | null> | null } };

export type UnscheduleJobPhaseMutationVariables = Exact<{
  jobPhaseId: Scalars['ID'];
}>;


export type UnscheduleJobPhaseMutation = { __typename?: 'Mutation', unscheduleJobPhase: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }> | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null } }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string }, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, name?: string | null, type?: string | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null } } | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, name?: string | null, type?: string | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }> | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null } } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null } };

export type UpdateAdditionalCostMutationVariables = Exact<{
  input: UpdateAdditionalCostInput;
}>;


export type UpdateAdditionalCostMutation = { __typename?: 'Mutation', updateAdditionalCost: { __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string } };

export type UpdateCompanyMutationVariables = Exact<{
  input: UpdateCompanyInput;
}>;


export type UpdateCompanyMutation = { __typename?: 'Mutation', updateCompany?: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null } | null };

export type UpdateCompanyNotesMutationVariables = Exact<{
  input: UpdateCompanyNotesInput;
}>;


export type UpdateCompanyNotesMutation = { __typename?: 'Mutation', updateCompanyNotes: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null } };

export type UpdateCompanyProjectFileFolderIdMutationVariables = Exact<{
  id: Scalars['ID'];
  projectFilesFolderId?: InputMaybe<Scalars['ID']>;
}>;


export type UpdateCompanyProjectFileFolderIdMutation = { __typename?: 'Mutation', updateCompanyProjectFileFolderId: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null } };

export type UpdateCrewMutationVariables = Exact<{
  input: UpdateCrewInput;
}>;


export type UpdateCrewMutation = { __typename?: 'Mutation', updateCrew: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } };

export type UpdateCustomEventMutationVariables = Exact<{
  input?: InputMaybe<UpdateCustomEventInput>;
}>;


export type UpdateCustomEventMutation = { __typename?: 'Mutation', updateCustomEvent?: { __typename?: 'CustomEvent', color?: string | null, endsAt?: any | null, id?: string | null, name?: string | null, notes?: string | null, startsAt?: any | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, customEventBlocks?: Array<{ __typename?: 'CustomEventBlock', blockLength?: number | null, endsAt?: any | null, id?: string | null, scheduledAt?: any | null, customEvent?: { __typename?: 'CustomEvent', color?: string | null, endsAt?: any | null, id?: string | null, name?: string | null, notes?: string | null, startsAt?: any | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, customEventBlocks?: Array<{ __typename?: 'CustomEventBlock', blockLength?: number | null, endsAt?: any | null, id?: string | null, scheduledAt?: any | null } | null> | null, customEventsToUsers?: Array<{ __typename?: 'CustomEventsToUsers', user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null } | null> | null } | null } | null> | null } | null };

export type UpdateEmployeeMutationVariables = Exact<{
  input: UpdateEmployeeInput;
}>;


export type UpdateEmployeeMutation = { __typename?: 'Mutation', updateEmployee: { __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } };

export type UpdateEquipmentPieceMutationVariables = Exact<{
  input: UpdateEquipmentPieceInput;
}>;


export type UpdateEquipmentPieceMutation = { __typename?: 'Mutation', updateEquipmentPiece: { __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number } };

export type UpdateJobBillingStatusMutationVariables = Exact<{
  billingStatus: JobBillingStatus;
  id: Scalars['ID'];
}>;


export type UpdateJobBillingStatusMutation = { __typename?: 'Mutation', updateJobBillingStatus: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }> | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null } }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string }, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, name?: string | null, type?: string | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null } } | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, name?: string | null, type?: string | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }> | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null } } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null } };

export type UpdateJobNotesMutationVariables = Exact<{
  id: Scalars['ID'];
  notes: Scalars['String'];
}>;


export type UpdateJobNotesMutation = { __typename?: 'Mutation', updateJobNotes?: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }> | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null } }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string }, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, name?: string | null, type?: string | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null } } | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, name?: string | null, type?: string | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }> | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null } } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null } | null };

export type UpdateJobPhaseNotesMutationVariables = Exact<{
  input: UpdateJobPhaseNotesInput;
}>;


export type UpdateJobPhaseNotesMutation = { __typename?: 'Mutation', updateJobPhaseNotes: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType } | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null } }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType } | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, name?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, rate: number, type: string } | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: number | null, costMaterialOverride?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId: string, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, quantity: number, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null }, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }> | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null } }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string }, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, name?: string | null, type?: string | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null } };

export type UpdateJobPhaseStatusMutationVariables = Exact<{
  id: Scalars['ID'];
  status: JobPhaseStatus;
}>;


export type UpdateJobPhaseStatusMutation = { __typename?: 'Mutation', updateJobPhaseStatus: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType } | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null } }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType } | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, name?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, rate: number, type: string } | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: number | null, costMaterialOverride?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId: string, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, quantity: number, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null }, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }> | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null } }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string }, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, name?: string | null, type?: string | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null } };

export type UpdateJobProjectFileFolderIdMutationVariables = Exact<{
  id: Scalars['ID'];
  projectFilesFolderId?: InputMaybe<Scalars['ID']>;
}>;


export type UpdateJobProjectFileFolderIdMutation = { __typename?: 'Mutation', updateJobProjectFileFolderId: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }> | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null } }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string }, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, name?: string | null, type?: string | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null } } | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, name?: string | null, type?: string | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }> | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null } } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null } };

export type UpdateJobProjectManagerMutationVariables = Exact<{
  id: Scalars['ID'];
  userId: Scalars['ID'];
}>;


export type UpdateJobProjectManagerMutation = { __typename?: 'Mutation', updateJobProjectManager: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }> | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null } }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string }, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, name?: string | null, type?: string | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null } } | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, name?: string | null, type?: string | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }> | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null } } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null } };

export type UpdateNotificationTriggerMutationVariables = Exact<{
  input: UpdateNotificationTriggerInput;
}>;


export type UpdateNotificationTriggerMutation = { __typename?: 'Mutation', updateNotificationTrigger?: { __typename?: 'NotificationTrigger', active: boolean, additionalRecipientTypes?: Array<NotificationTriggerAdditionalRecipientTypes> | null, content: string, delay: number, emailSubject?: string | null, event: NotificationTriggerEvent, id: string, isEmail?: boolean | null, isSMS?: boolean | null, name: string, sendToAllRecipients: boolean, sendToContact: boolean, sendToUser: boolean, smsContent?: string | null, type: NotificationTriggerType, additionalRecipients: Array<{ __typename?: 'NotificationTriggerRecipient', email: string, firstName: string, id: string, lastName: string }>, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } } | null };

export type UpdateOpportunityMutationVariables = Exact<{
  input: UpdateOpportunityInput;
}>;


export type UpdateOpportunityMutation = { __typename?: 'Mutation', updateOpportunity: { __typename?: 'Opportunity', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, companyId: string, contactId: string, createdAt: any, dueAt?: any | null, estimatedOpportunityValue?: number | null, externalId: string, id: string, name: string, notes?: string | null, projectFilesFolderId?: string | null, source?: OpportunitySource | null, status: string, statusId: string, updatedAt: any, userId?: string | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, products?: Array<{ __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } };

export type UpdateOrganizationMutationVariables = Exact<{
  input: UpdateOrganizationInput;
}>;


export type UpdateOrganizationMutation = { __typename?: 'Mutation', updateOrganization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } };

export type UpdateOrganizationAddressMutationVariables = Exact<{
  input: UpdateOrganizationAddressInput;
}>;


export type UpdateOrganizationAddressMutation = { __typename?: 'Mutation', updateOrganizationAddress?: { __typename?: 'OrganizationAddress', city: string, country: string, id: string, isPrimary: boolean, latitude: string, line1: string, line2?: string | null, longitude: string, state: string, zip: string } | null };

export type UpdateOrganizationAddressPrimaryMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UpdateOrganizationAddressPrimaryMutation = { __typename?: 'Mutation', updateOrganizationAddressPrimary?: boolean | null };

export type UpdateOrganizationConversionFactorOverrideMutationVariables = Exact<{
  input: UpdateOrganizationConversionFactorOverrideInput;
}>;


export type UpdateOrganizationConversionFactorOverrideMutation = { __typename?: 'Mutation', updateOrganizationConversionFactorOverride: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } } };

export type UpdateOrganizationEmailTemplateMutationVariables = Exact<{
  html?: InputMaybe<Scalars['String']>;
  type: OrganizationEmailTemplateType;
}>;


export type UpdateOrganizationEmailTemplateMutation = { __typename?: 'Mutation', updateOrganizationEmailTemplate?: boolean | null };

export type UpdateOrganizationProductTypeMutationVariables = Exact<{
  input: UpdateOrganizationProductTypeInput;
}>;


export type UpdateOrganizationProductTypeMutation = { __typename?: 'Mutation', updateOrganizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null };

export type UpdateOrganizationProposalContentMutationVariables = Exact<{
  content: Scalars['String'];
  type: ProposalContentType;
}>;


export type UpdateOrganizationProposalContentMutation = { __typename?: 'Mutation', updateOrganizationProposalContent: { __typename?: 'OrganizationProposalContent', content: string, id: string, type: ProposalContentType } };

export type UpdateOrganizationProposalDefaultsMutationVariables = Exact<{
  input: UpdateOrganizationProposalDefaultsInput;
}>;


export type UpdateOrganizationProposalDefaultsMutation = { __typename?: 'Mutation', updateOrganizationProposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean } };

export type UpdateOrganizationProposalSentEmailTextMutationVariables = Exact<{
  id: Scalars['ID'];
  text: Scalars['String'];
}>;


export type UpdateOrganizationProposalSentEmailTextMutation = { __typename?: 'Mutation', updateOrganizationProposalSentEmailText: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } };

export type UpdateOrganizationSalesTaxesMutationVariables = Exact<{
  input: UpdateOrganizationSalesTaxesInput;
}>;


export type UpdateOrganizationSalesTaxesMutation = { __typename?: 'Mutation', updateOrganizationSalesTaxes: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } };

export type UpdateOrganizationSettingsMutationVariables = Exact<{
  settings: Array<UpdateOrganizationSettingsInput> | UpdateOrganizationSettingsInput;
}>;


export type UpdateOrganizationSettingsMutation = { __typename?: 'Mutation', updateOrganizationSettings: boolean };

export type UpdateOrganizationUserMutationVariables = Exact<{
  input: UpdateOrganizationUserInput;
}>;


export type UpdateOrganizationUserMutation = { __typename?: 'Mutation', updateOrganizationUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null };

export type UpdatePlantMutationVariables = Exact<{
  input: UpdatePlantInput;
}>;


export type UpdatePlantMutation = { __typename?: 'Mutation', updatePlant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, rate: number, type: string }> } | null };

export type UpdateProductMutationVariables = Exact<{
  input: UpdateProductInput;
}>;


export type UpdateProductMutation = { __typename?: 'Mutation', updateProduct: { __typename?: 'Product', areaCoverage?: number | null, costMaterial?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: number | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, overheadPercentage?: number | null, plantProductId?: string | null, productionRateType?: ProductProductionRateType | null, statementOfWork?: string | null, subcontracted: boolean, type: ProductType, unitPrice?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organizationProductType: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType }, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, rate: number, type: string }> } | null, productAdditionalCosts?: Array<{ __typename?: 'ProductAdditionalCost', id: string, type?: ProductAdditionalCostType | null, additionalCost: { __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string } }> | null, productEquipmentPieces?: Array<{ __typename?: 'ProductEquipmentPiece', id: string, quantity: number, equipmentPiece: { __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number } }> | null } };

export type UpdateProposalMutationVariables = Exact<{
  companyId: Scalars['ID'];
  contactId: Scalars['ID'];
  id: Scalars['ID'];
  source?: InputMaybe<ProposalSource>;
}>;


export type UpdateProposalMutation = { __typename?: 'Mutation', updateProposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }> | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null } };

export type UpdateProposalAddressMutationVariables = Exact<{
  input: UpdateProposalAddress;
}>;


export type UpdateProposalAddressMutation = { __typename?: 'Mutation', updateProposalAddress?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null };

export type UpdateProposalInfoMutationVariables = Exact<{
  input?: InputMaybe<UpdateProposalInfoInput>;
}>;


export type UpdateProposalInfoMutation = { __typename?: 'Mutation', updateProposalInfo: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }> | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null } };

export type UpdateProposalPlantProductMutationVariables = Exact<{
  plantProductId: Scalars['ID'];
  proposalProductId: Scalars['ID'];
}>;


export type UpdateProposalPlantProductMutation = { __typename?: 'Mutation', updateProposalPlantProduct: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }> | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null } };

export type UpdateProposalProductMutationVariables = Exact<{
  input: UpdateProposalProductInput;
}>;


export type UpdateProposalProductMutation = { __typename?: 'Mutation', updateProposalProduct: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }> | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null } };

export type UpdateProposalSalesTaxesMutationVariables = Exact<{
  input?: InputMaybe<UpdateProposalSalesTaxesInput>;
}>;


export type UpdateProposalSalesTaxesMutation = { __typename?: 'Mutation', updateProposalSalesTaxes: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }> | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null } };

export type UpdateProposalStageMutationVariables = Exact<{
  addressOverride?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  mapData?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
}>;


export type UpdateProposalStageMutation = { __typename?: 'Mutation', updateProposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: number | null, costMaterialOverride?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId: string, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, quantity: number, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null }> | null } };

export type UpdateProposalStagesOrderingMutationVariables = Exact<{
  input: UpdateProposalStagesOrdering;
}>;


export type UpdateProposalStagesOrderingMutation = { __typename?: 'Mutation', updateProposalStagesOrdering: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }> | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null } };

export type UpdateRolesWithPermissionsMutationVariables = Exact<{
  input?: InputMaybe<UpdateRolesWithPermissionsInput>;
}>;


export type UpdateRolesWithPermissionsMutation = { __typename?: 'Mutation', updateRolesWithPermissions?: { __typename?: 'RolesWithPermissions', admin?: Array<UserPermissions | null> | null, employee?: Array<UserPermissions | null> | null, foreman?: Array<UserPermissions | null> | null, officeManager?: Array<UserPermissions | null> | null, salesperson?: Array<UserPermissions | null> | null, subcontractor?: Array<UserPermissions | null> | null } | null };

export type UpdateStageProductsOrderingMutationVariables = Exact<{
  input: UpdateProposalProductsOrderingInput;
}>;


export type UpdateStageProductsOrderingMutation = { __typename?: 'Mutation', updateStageProductsOrdering: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: number | null, costMaterialOverride?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId: string, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, quantity: number, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null }> | null } };

export type UpdateTimeBucketMutationVariables = Exact<{
  input: UpdateTimeBucketInput;
}>;


export type UpdateTimeBucketMutation = { __typename?: 'Mutation', updateTimeBucket: { __typename?: 'TimeBucket', id: string, name: string, organizationId: string } };

export type UpdateTimeEntryMutationVariables = Exact<{
  input: UpdateTimeEntryInput;
}>;


export type UpdateTimeEntryMutation = { __typename?: 'Mutation', updateTimeEntry: { __typename?: 'TimeEntry', clockInLatitude?: number | null, clockInLongitude?: number | null, clockOutLatitude?: number | null, clockOutLongitude?: number | null, endTime?: any | null, forDate: any, id: string, notes?: string | null, organizationId: string, startTime: any, timeTrackedSeconds?: number | null, timeTrackedSecondsOverride?: number | null, uuid: string, jobPhase?: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null } }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string }, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, name?: string | null, type?: string | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null } } | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }> } | null, timeBucket?: { __typename?: 'TimeBucket', id: string, name: string, organizationId: string } | null, user: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } } };

export type UpdateTransferTruckMutationVariables = Exact<{
  input: UpdateTransferTruckInput;
}>;


export type UpdateTransferTruckMutation = { __typename?: 'Mutation', updateTransferTruck?: { __typename?: 'TransferTruck', defaultRateHourly: number, defaultRateTon: number, defaultTonnage: number, id: string, name: string } | null };

export type UpdateWorkOrderItemsMutationVariables = Exact<{
  input: UpdateWorkOrderItemsInput;
}>;


export type UpdateWorkOrderItemsMutation = { __typename?: 'Mutation', updateWorkOrderItems?: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType } | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null } }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType } | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, name?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, rate: number, type: string } | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: number | null, costMaterialOverride?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId: string, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, quantity: number, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null }, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }> | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null } }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string }, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, name?: string | null, type?: string | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null } | null };

export type ValidateRegistrationTokenMutationVariables = Exact<{
  input: ValidateRegistrationTokenInput;
}>;


export type ValidateRegistrationTokenMutation = { __typename?: 'Mutation', validateRegistrationToken?: boolean | null };

export type GetOrganizationApiKeysQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationApiKeysQuery = { __typename?: 'Query', GetOrganizationApiKeys: Array<{ __typename?: 'OrganizationApiKey', api_key: string, description: string, id: string, is_active: boolean, organizationId: string }> };

export type GetAdditionalCostQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetAdditionalCostQuery = { __typename?: 'Query', getAdditionalCost?: { __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string } | null };

export type GetAdditionalCostsQueryVariables = Exact<{
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortDirection>;
}>;


export type GetAdditionalCostsQuery = { __typename?: 'Query', getAdditionalCosts?: { __typename?: 'AdditionalCostPaginator', data: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type GetAllCrewsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllCrewsQuery = { __typename?: 'Query', getAllCrews: Array<{ __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> };

export type GetArchivedCompaniesQueryVariables = Exact<{
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
}>;


export type GetArchivedCompaniesQuery = { __typename?: 'Query', getArchivedCompanies?: { __typename?: 'CompanyPaginator', data: Array<{ __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type GetCheckoutUrlQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCheckoutUrlQuery = { __typename?: 'Query', getCheckoutUrl: string };

export type GetCompaniesQueryVariables = Exact<{
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  searchByName?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<GetCompaniesSortKey>;
}>;


export type GetCompaniesQuery = { __typename?: 'Query', getCompanies: { __typename?: 'GetCompaniesResponse', data: Array<{ __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }>, paginatorInfo: { __typename?: 'CustomPaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type GetCompanyQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCompanyQuery = { __typename?: 'Query', getCompany?: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null } | null };

export type GetCompanyContactsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCompanyContactsQuery = { __typename?: 'Query', getCompanyContacts?: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }> | null };

export type GetCrewQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCrewQuery = { __typename?: 'Query', getCrew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null };

export type GetCrewsQueryVariables = Exact<{
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortDirection>;
}>;


export type GetCrewsQuery = { __typename?: 'Query', getCrews?: { __typename?: 'CrewPaginator', data: Array<{ __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type GetCurrentMonthStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentMonthStatsQuery = { __typename?: 'Query', getCurrentMonthStats: { __typename?: 'DashboardDataByMonth', closedBids: number, closedRate: number, closedRevenue: number, sentBids: number } };

export type GetCustomEventQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCustomEventQuery = { __typename?: 'Query', getCustomEvent?: { __typename?: 'CustomEvent', color?: string | null, endsAt?: any | null, id?: string | null, name?: string | null, notes?: string | null, startsAt?: any | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, customEventBlocks?: Array<{ __typename?: 'CustomEventBlock', blockLength?: number | null, endsAt?: any | null, id?: string | null, scheduledAt?: any | null, customEvent?: { __typename?: 'CustomEvent', color?: string | null, endsAt?: any | null, id?: string | null, name?: string | null, notes?: string | null, startsAt?: any | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, customEventBlocks?: Array<{ __typename?: 'CustomEventBlock', blockLength?: number | null, endsAt?: any | null, id?: string | null, scheduledAt?: any | null } | null> | null, customEventsToUsers?: Array<{ __typename?: 'CustomEventsToUsers', user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null } | null> | null } | null } | null> | null } | null };

export type GetCustomEventBlocksQueryVariables = Exact<{
  crewId?: InputMaybe<Scalars['ID']>;
  customEventIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateUntil?: InputMaybe<Scalars['DateTime']>;
}>;


export type GetCustomEventBlocksQuery = { __typename?: 'Query', getCustomEventBlocks: Array<{ __typename?: 'CustomEventBlock', blockLength?: number | null, endsAt?: any | null, id?: string | null, scheduledAt?: any | null, customEvent?: { __typename?: 'CustomEvent', color?: string | null, endsAt?: any | null, id?: string | null, name?: string | null, notes?: string | null, startsAt?: any | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, customEventBlocks?: Array<{ __typename?: 'CustomEventBlock', blockLength?: number | null, endsAt?: any | null, id?: string | null, scheduledAt?: any | null, customEvent?: { __typename?: 'CustomEvent', color?: string | null, endsAt?: any | null, id?: string | null, name?: string | null, notes?: string | null, startsAt?: any | null } | null } | null> | null } | null }> };

export type GetDashboardMapDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDashboardMapDataQuery = { __typename?: 'Query', getDashboardMapData: Array<{ __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }> | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null } }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string }, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, name?: string | null, type?: string | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null } } | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, name?: string | null, type?: string | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }> | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null } } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null } | null> };

export type GetEmployeeQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetEmployeeQuery = { __typename?: 'Query', getEmployee?: { __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } | null };

export type GetEmployeesQueryVariables = Exact<{
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortDirection>;
}>;


export type GetEmployeesQuery = { __typename?: 'Query', getEmployees?: { __typename?: 'EmployeePaginator', data: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type GetEquipmentPieceQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetEquipmentPieceQuery = { __typename?: 'Query', getEquipmentPiece?: { __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number } | null };

export type GetEquipmentPiecesQueryVariables = Exact<{
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortDirection>;
}>;


export type GetEquipmentPiecesQuery = { __typename?: 'Query', getEquipmentPieces?: { __typename?: 'EquipmentPiecePaginator', data: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type GetJobQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetJobQuery = { __typename?: 'Query', getJob: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }> | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null } }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string }, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, name?: string | null, type?: string | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null } } | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, name?: string | null, type?: string | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }> | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null } } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null } };

export type GetJobBillingStatusesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetJobBillingStatusesQuery = { __typename?: 'Query', getJobBillingStatuses: { __typename?: 'GetJobBillingStatusesResponse', statuses?: Array<JobBillingStatus> | null } };

export type GetJobPhaseQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetJobPhaseQuery = { __typename?: 'Query', getJobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType } | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null } }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType } | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, name?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, rate: number, type: string } | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: number | null, costMaterialOverride?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId: string, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, quantity: number, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null }, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }> | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null } }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string }, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, name?: string | null, type?: string | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null } };

export type GetJobPhaseCostItemQueryVariables = Exact<{
  date: Scalars['Date'];
  jobPhaseId: Scalars['ID'];
}>;


export type GetJobPhaseCostItemQuery = { __typename?: 'Query', getJobPhaseCostItem?: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string }, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, name?: string | null, type?: string | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null } } | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType } | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null } | null };

export type GetJobPhaseCostsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetJobPhaseCostsQuery = { __typename?: 'Query', getJobPhaseCosts?: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string }, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, name?: string | null, type?: string | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null } } | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType } | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null } | null };

export type GetJobPhasesQueryVariables = Exact<{
  billingStatuses?: InputMaybe<Array<JobBillingStatus> | JobBillingStatus>;
  companyId?: InputMaybe<Scalars['ID']>;
  crewId?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['DateTime']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  first: Scalars['Int'];
  foremanUserId?: InputMaybe<Scalars['ID']>;
  organizationProductTypeId?: InputMaybe<Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  searchByName?: InputMaybe<Scalars['Boolean']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<GetJobsSortKey>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['ID']>;
}>;


export type GetJobPhasesQuery = { __typename?: 'Query', getJobPhases: { __typename?: 'GetJobPhasesResponse', data: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null } }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string }, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, name?: string | null, type?: string | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null } } | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string }, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, name?: string | null, type?: string | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }> | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, name?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, rate: number, type: string }> } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, rate: number, type: string } | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: number | null, costMaterialOverride?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId: string, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, quantity: number, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null }, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null }>, paginatorInfo: { __typename?: 'CustomPaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type GetJobScheduleByAmountStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetJobScheduleByAmountStatsQuery = { __typename?: 'Query', getJobScheduleByAmountStats: Array<{ __typename?: 'DateWithTotals', date: string, overallTotal: string }> };

export type GetJobSchedulesQueryVariables = Exact<{
  crewId?: InputMaybe<Scalars['ID']>;
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateUntil?: InputMaybe<Scalars['DateTime']>;
  jobIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  jobPhaseId?: InputMaybe<Scalars['ID']>;
}>;


export type GetJobSchedulesQuery = { __typename?: 'Query', getJobSchedules: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType } | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, name?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, rate: number, type: string } | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: number | null, costMaterialOverride?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId: string, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, quantity: number, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null }, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }> | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null } | null> | null }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string }, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, name?: string | null, type?: string | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null } }> };

export type GetJobsQueryVariables = Exact<{
  billingStatuses?: InputMaybe<Array<JobBillingStatus> | JobBillingStatus>;
  companyId?: InputMaybe<Scalars['ID']>;
  first: Scalars['Int'];
  jobIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  multipleCompanyIDs?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  multipleUserIDs?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  organizationProductTypeIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<GetJobsSortKey>;
  statuses?: InputMaybe<Array<JobStatus> | JobStatus>;
  userId?: InputMaybe<Scalars['ID']>;
}>;


export type GetJobsQuery = { __typename?: 'Query', getJobs: { __typename?: 'GetJobsResponse', data: Array<{ __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType } | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, name?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, rate: number, type: string } | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: number | null, costMaterialOverride?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId: string, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, quantity: number, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null }, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }> | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }>, paginatorInfo: { __typename?: 'CustomPaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type GetLastYearStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLastYearStatsQuery = { __typename?: 'Query', getLastYearStats: { __typename?: 'YearlyDashboardData', closedBids?: Array<{ __typename?: 'MonthlySummary', month: number, total: number, year: number } | null> | null, closedRate?: Array<{ __typename?: 'MonthlySummary', month: number, total: number, year: number } | null> | null, closedRevenue?: Array<{ __typename?: 'MonthlySummary', month: number, total: number, year: number } | null> | null, sentBids?: Array<{ __typename?: 'MonthlySummary', month: number, total: number, year: number } | null> | null } };

export type GetManageSubscriptionUrlQueryVariables = Exact<{ [key: string]: never; }>;


export type GetManageSubscriptionUrlQuery = { __typename?: 'Query', getManageSubscriptionUrl: string };

export type GetMaterialNeededByDayStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMaterialNeededByDayStatsQuery = { __typename?: 'Query', getMaterialNeededByDayStats?: Array<{ __typename?: 'DateWithMaterialAmount', JobPhaseAmountScheduledInDay: number, date: string, jobPhaseMaterialNeededInDay: number, material: string }> | null };

export type GetNotificationTriggerQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetNotificationTriggerQuery = { __typename?: 'Query', getNotificationTrigger: { __typename?: 'NotificationTrigger', active: boolean, additionalRecipientTypes?: Array<NotificationTriggerAdditionalRecipientTypes> | null, content: string, delay: number, emailSubject?: string | null, event: NotificationTriggerEvent, id: string, isEmail?: boolean | null, isSMS?: boolean | null, name: string, sendToAllRecipients: boolean, sendToContact: boolean, sendToUser: boolean, smsContent?: string | null, type: NotificationTriggerType, additionalRecipients: Array<{ __typename?: 'NotificationTriggerRecipient', email: string, firstName: string, id: string, lastName: string }>, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } } };

export type GetNotificationTriggersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNotificationTriggersQuery = { __typename?: 'Query', getNotificationTriggers?: Array<{ __typename?: 'NotificationTrigger', active: boolean, additionalRecipientTypes?: Array<NotificationTriggerAdditionalRecipientTypes> | null, content: string, delay: number, emailSubject?: string | null, event: NotificationTriggerEvent, id: string, isEmail?: boolean | null, isSMS?: boolean | null, name: string, sendToAllRecipients: boolean, sendToContact: boolean, sendToUser: boolean, smsContent?: string | null, type: NotificationTriggerType, additionalRecipients: Array<{ __typename?: 'NotificationTriggerRecipient', email: string, firstName: string, id: string, lastName: string }>, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } }> | null };

export type GetOpportunitiesQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  contactName?: InputMaybe<Scalars['String']>;
  dueAt?: InputMaybe<Scalars['Date']>;
  first: Scalars['Int'];
  multipleCompanyIDs?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  multipleUserIDs?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<GetOpportunitiesSortKey>;
  statuses?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
}>;


export type GetOpportunitiesQuery = { __typename?: 'Query', getOpportunities: { __typename?: 'GetOpportunitiesResponse', data: Array<{ __typename?: 'Opportunity', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, companyId: string, contactId: string, createdAt: any, dueAt?: any | null, estimatedOpportunityValue?: number | null, externalId: string, id: string, name: string, notes?: string | null, projectFilesFolderId?: string | null, source?: OpportunitySource | null, status: string, statusId: string, updatedAt: any, userId?: string | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, products?: Array<{ __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null }>, paginatorInfo: { __typename?: 'CustomPaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type GetOpportunityQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetOpportunityQuery = { __typename?: 'Query', getOpportunity?: { __typename?: 'Opportunity', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, companyId: string, contactId: string, createdAt: any, dueAt?: any | null, estimatedOpportunityValue?: number | null, externalId: string, id: string, name: string, notes?: string | null, projectFilesFolderId?: string | null, source?: OpportunitySource | null, status: string, statusId: string, updatedAt: any, userId?: string | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, products?: Array<{ __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } | null };

export type GetOpportunityStatusesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOpportunityStatusesQuery = { __typename?: 'Query', getOpportunityStatuses: Array<{ __typename?: 'OrganizationOpportunityStatus', id: string, name: string }> };

export type GetOrganizationAddressQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetOrganizationAddressQuery = { __typename?: 'Query', getOrganizationAddress?: { __typename?: 'OrganizationAddress', city: string, country: string, id: string, isPrimary: boolean, latitude: string, line1: string, line2?: string | null, longitude: string, state: string, zip: string } | null };

export type GetOrganizationAddressesQueryVariables = Exact<{
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
}>;


export type GetOrganizationAddressesQuery = { __typename?: 'Query', getOrganizationAddresses?: { __typename?: 'OrganizationAddressPaginator', data: Array<{ __typename?: 'OrganizationAddress', city: string, country: string, id: string, isPrimary: boolean, latitude: string, line1: string, line2?: string | null, longitude: string, state: string, zip: string }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type GetOrganizationDataUploadsQueryVariables = Exact<{
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
}>;


export type GetOrganizationDataUploadsQuery = { __typename?: 'Query', getOrganizationDataUploads?: { __typename?: 'OrganizationDataUploadPaginator', data: Array<{ __typename?: 'OrganizationDataUpload', createdAt: any, error?: string | null, id: string, path: string, startedAt?: any | null, status: OrganizationDataUploadStatus, type: OrganizationDataUploadType, updatedAt: any, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null }, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type GetOrganizationEmailTemplateQueryVariables = Exact<{
  type: OrganizationEmailTemplateType;
}>;


export type GetOrganizationEmailTemplateQuery = { __typename?: 'Query', getOrganizationEmailTemplate?: { __typename?: 'OrganizationEmailTemplate', html: string, id: string, type: OrganizationEmailTemplateType, organization?: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } | null } | null };

export type GetOrganizationEmailTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationEmailTemplatesQuery = { __typename?: 'Query', getOrganizationEmailTemplates?: Array<{ __typename?: 'OrganizationEmailTemplate', html: string, id: string, type: OrganizationEmailTemplateType, organization?: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } | null }> | null };

export type GetOrganizationProductTypeQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetOrganizationProductTypeQuery = { __typename?: 'Query', getOrganizationProductType: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } };

export type GetOrganizationProductTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationProductTypesQuery = { __typename?: 'Query', getOrganizationProductTypes: Array<{ __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType }> };

export type GetOrganizationProposalContentQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationProposalContentQuery = { __typename?: 'Query', getOrganizationProposalContent?: Array<{ __typename?: 'OrganizationProposalContent', content: string, id: string, type: ProposalContentType }> | null };

export type GetOrganizationSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationSettingsQuery = { __typename?: 'Query', getOrganizationSettings: Array<{ __typename?: 'OrganizationSetting', key: string, value: string }> };

export type GetOrganizationUserQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetOrganizationUserQuery = { __typename?: 'Query', getOrganizationUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null };

export type GetOrganizationUsersQueryVariables = Exact<{
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  roles?: InputMaybe<Array<InputMaybe<UserRole>> | InputMaybe<UserRole>>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<UserStatus>;
}>;


export type GetOrganizationUsersQuery = { __typename?: 'Query', getOrganizationUsers?: { __typename?: 'UserPaginator', data: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type GetPersonsStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPersonsStatsQuery = { __typename?: 'Query', getPersonsStats: Array<{ __typename?: 'PersonSales', firstName: string, lastName: string, proposalsWonCount: number, proposalsWonPercentage: number, proposalsWonSum?: string | null, sentProposalsCount: number, winRate?: number | null } | null> };

export type GetPlantQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetPlantQuery = { __typename?: 'Query', getPlant: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, rate: number, type: string }> } };

export type GetPlantProductTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPlantProductTypesQuery = { __typename?: 'Query', getPlantProductTypes?: Array<{ __typename?: 'ModelsPlantProductType', id: string, name: string }> | null };

export type GetPlantTransferTrucksQueryVariables = Exact<{
  plantId: Scalars['ID'];
}>;


export type GetPlantTransferTrucksQuery = { __typename?: 'Query', getPlantTransferTrucks: Array<{ __typename?: 'PlantTransferTruck', id: string, rateHourly?: number | null, rateTon?: number | null, tonnage?: number | null, transferTruck: { __typename?: 'TransferTruck', defaultRateHourly: number, defaultRateTon: number, defaultTonnage: number, id: string, name: string } }> };

export type GetPlantsQueryVariables = Exact<{
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetPlantsQuery = { __typename?: 'Query', getPlants?: { __typename?: 'PlantPaginator', data: Array<{ __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, rate: number, type: string }> }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type GetPreviousMonthStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPreviousMonthStatsQuery = { __typename?: 'Query', getPreviousMonthStats: { __typename?: 'DashboardDataByMonth', closedBids: number, closedRate: number, closedRevenue: number, sentBids: number } };

export type GetProductQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetProductQuery = { __typename?: 'Query', getProduct?: { __typename?: 'Product', areaCoverage?: number | null, costMaterial?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: number | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, overheadPercentage?: number | null, plantProductId?: string | null, productionRateType?: ProductProductionRateType | null, statementOfWork?: string | null, subcontracted: boolean, type: ProductType, unitPrice?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organizationProductType: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType }, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, rate: number, type: string }> } | null, productAdditionalCosts?: Array<{ __typename?: 'ProductAdditionalCost', id: string, type?: ProductAdditionalCostType | null, additionalCost: { __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string } }> | null, productEquipmentPieces?: Array<{ __typename?: 'ProductEquipmentPiece', id: string, quantity: number, equipmentPiece: { __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number } }> | null } | null };

export type GetProductStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProductStatsQuery = { __typename?: 'Query', getProductStats: { __typename?: 'ProductStats', materialUsed?: Array<{ __typename?: 'ProductMaterialUsed', jobSizeComplete?: string | null, productMaterialUsed: string, productType: string, proposalJobSize: string, proposalMaterialNeeded?: string | null }> | null, productTypeUsedPercentages?: Array<{ __typename?: 'ProductTypeUsed', equipmentUsedPercentage?: number | null, labourUsedPercentage?: number | null, materialUsedPercentage?: number | null, productType: string }> | null, products: Array<{ __typename?: 'ProductSales', actualProfitPercentage: number, name: string, proposedProfitPercentage: number, sumOverallTotal: number } | null> } };

export type GetProductsQueryVariables = Exact<{
  first: Scalars['Int'];
  orderBy?: InputMaybe<Array<QueryGetProductsOrderByOrderByClause> | QueryGetProductsOrderByOrderByClause>;
  organizationProductTypeId?: InputMaybe<Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<ProductType>;
}>;


export type GetProductsQuery = { __typename?: 'Query', getProducts?: { __typename?: 'ProductPaginator', data: Array<{ __typename?: 'Product', areaCoverage?: number | null, costMaterial?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: number | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, overheadPercentage?: number | null, plantProductId?: string | null, productionRateType?: ProductProductionRateType | null, statementOfWork?: string | null, subcontracted: boolean, type: ProductType, unitPrice?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, organizationProductType: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType }, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string, products: Array<{ __typename?: 'PlantProduct', id: string, rate: number, type: string }> } | null, productAdditionalCosts?: Array<{ __typename?: 'ProductAdditionalCost', id: string, type?: ProductAdditionalCostType | null, additionalCost: { __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string } }> | null, productEquipmentPieces?: Array<{ __typename?: 'ProductEquipmentPiece', id: string, quantity: number, equipmentPiece: { __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number } }> | null }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type GetProjectFileQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetProjectFileQuery = { __typename?: 'Query', getProjectFile: { __typename?: 'ProjectFile', fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType, children?: Array<{ __typename?: 'ProjectFile', fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType, children?: Array<{ __typename?: 'ProjectFile', fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType }> | null }> | null } };

export type GetProjectFilesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProjectFilesQuery = { __typename?: 'Query', getProjectFiles: Array<{ __typename?: 'ProjectFile', fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType, children?: Array<{ __typename?: 'ProjectFile', fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType, children?: Array<{ __typename?: 'ProjectFile', fileSizeBytes?: string | null, id: string, name: string, parentFolderId?: string | null, path?: string | null, type: ProjectFileType }> | null }> | null }> };

export type GetProposalQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetProposalQuery = { __typename?: 'Query', getProposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }> | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null } };

export type GetProposalProductMapDataQueryVariables = Exact<{
  proposalProductId: Scalars['ID'];
  token: Scalars['String'];
}>;


export type GetProposalProductMapDataQuery = { __typename?: 'Query', getProposalProductMapData?: string | null };

export type GetProposalsQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  first: Scalars['Int'];
  multipleCompanyIDs?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  multipleUserIDs?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  organizationProductTypeIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<GetProposalsSortKey>;
  statuses?: InputMaybe<Array<ProposalStatus> | ProposalStatus>;
  userId?: InputMaybe<Scalars['ID']>;
}>;


export type GetProposalsQuery = { __typename?: 'Query', getProposals: { __typename?: 'GetProposalsResponse', data: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null }> | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: number | null, costMaterialOverride?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId: string, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, quantity: number, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null }> | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus, changedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null }> | null }>, paginatorInfo: { __typename?: 'CustomPaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type GetPublicProposalQueryVariables = Exact<{
  email?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
  uuid: Scalars['String'];
}>;


export type GetPublicProposalQuery = { __typename?: 'Query', getPublicProposal: { __typename: 'PublicProposal', acceptanceOverride?: string | null, costTaxes: string, externalId: string, id: string, layout: ProposalLayout, overallTotal: string, overallTotalAfterTaxes: string, proposalPDF?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, signedAt?: any | null, signeeInitials?: string | null, signeeName?: string | null, signeeTitle?: string | null, status: ProposalStatus, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } }> | null, company: { __typename?: 'PublicCompany', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, name: string, phone?: string | null, website?: string | null }, contact: { __typename?: 'PublicContact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, title?: string | null }, content: Array<{ __typename?: 'ProposalContent', content: string, contentOverride: string, type: ProposalContentType } | null>, organization: { __typename?: 'PublicOrganization', email?: string | null, id: string, logo?: string | null, name: string, phone?: string | null, address?: { __typename?: 'OrganizationAddress', city: string, country: string, id: string, isPrimary: boolean, latitude: string, line1: string, line2?: string | null, longitude: string, state: string, zip: string } | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean } }, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'PublicProposalStage', addressOverride?: string | null, id: string, name?: string | null, ordering: number, overallTotal: string, address?: { __typename?: 'PublicProposalAddress', city: string, country: string, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, state: string, zip: string } | null, content: Array<{ __typename?: 'ProposalContent', content: string, contentOverride: string, type: ProposalContentType } | null>, proposalProducts?: Array<{ __typename?: 'PublicProposalProduct', id: string, isOptional: boolean, jobDuration: number, jobSize: number, mapImage?: string | null, ordering: number, overallTotal: string, overallTotalOverride?: string | null, statementOfWork?: string | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: number | null, costMaterialOverride?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId: string, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null } }> | null }>, user: { __typename?: 'PublicUser', email: string, firstName?: string | null, id: string, lastName?: string | null, phone?: string | null } } | { __typename: 'PublicProposalOrganization', estimatorEmail: string, id: string, logo?: string | null } };

export type GetPublicProposalCompanyOrgQueryVariables = Exact<{
  uuid: Scalars['String'];
}>;


export type GetPublicProposalCompanyOrgQuery = { __typename?: 'Query', getPublicProposalCompanyOrg?: { __typename?: 'PublicCompanyOrg', company: { __typename?: 'PublicCompany', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, name: string, phone?: string | null, website?: string | null }, organization: { __typename?: 'PublicOrganization', email?: string | null, id: string, logo?: string | null, name: string, phone?: string | null, address?: { __typename?: 'OrganizationAddress', city: string, country: string, id: string, isPrimary: boolean, latitude: string, line1: string, line2?: string | null, longitude: string, state: string, zip: string } | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean } } } | null };

export type GetQuickbooksIncomeAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQuickbooksIncomeAccountsQuery = { __typename?: 'Query', getQuickbooksIncomeAccounts?: Array<{ __typename?: 'QuickbooksIncomeAccount', id: string, name: string }> | null };

export type GetQuickbooksTaxCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQuickbooksTaxCodesQuery = { __typename?: 'Query', getQuickbooksTaxCodes?: Array<{ __typename?: 'QuickbooksTaxCode', description?: string | null, id: string, name: string }> | null };

export type GetQuickbooksTaxRatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQuickbooksTaxRatesQuery = { __typename?: 'Query', getQuickbooksTaxRates?: Array<{ __typename?: 'QuickbooksTaxRate', description?: string | null, id: string, name: string, rateValue?: number | null }> | null };

export type GetRolesWithPermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRolesWithPermissionsQuery = { __typename?: 'Query', getRolesWithPermissions?: { __typename?: 'RolesWithPermissions', admin?: Array<UserPermissions | null> | null, employee?: Array<UserPermissions | null> | null, foreman?: Array<UserPermissions | null> | null, officeManager?: Array<UserPermissions | null> | null, salesperson?: Array<UserPermissions | null> | null, subcontractor?: Array<UserPermissions | null> | null } | null };

export type GetTimeBucketQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetTimeBucketQuery = { __typename?: 'Query', getTimeBucket?: { __typename?: 'TimeBucket', id: string, name: string, organizationId: string } | null };

export type GetTimeBucketsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTimeBucketsQuery = { __typename?: 'Query', getTimeBuckets: Array<{ __typename?: 'TimeBucket', id: string, name: string, organizationId: string }> };

export type GetTimeEntriesQueryVariables = Exact<{
  first: Scalars['Int'];
  forDate?: InputMaybe<Scalars['Date']>;
  forDateEnd?: InputMaybe<Scalars['Date']>;
  forDateStart?: InputMaybe<Scalars['Date']>;
  jobPhaseId?: InputMaybe<Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<GetTimeEntriesSortKey>;
  userId?: InputMaybe<Scalars['ID']>;
}>;


export type GetTimeEntriesQuery = { __typename?: 'Query', getTimeEntries: { __typename?: 'GetTimeEntriesResponse', data: Array<{ __typename?: 'TimeEntry', clockInLatitude?: number | null, clockInLongitude?: number | null, clockOutLatitude?: number | null, clockOutLongitude?: number | null, endTime?: any | null, forDate: any, id: string, notes?: string | null, organizationId: string, startTime: any, timeTrackedSeconds?: number | null, timeTrackedSecondsOverride?: number | null, uuid: string, jobPhase?: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType } | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null }, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } | null> | null, proposal?: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null } | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null }, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, name?: string | null, type?: string | null, plant?: { __typename?: 'Plant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, id: string, name: string, phone: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string, rate: number, type: string } | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null, addresses: Array<{ __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null>, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, changeOrders?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null, company: { __typename?: 'Company', addCompanyInfo?: boolean | null, addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, jobsCount?: number | null, logo?: string | null, name: string, notes?: string | null, phone?: string | null, projectFilesFolderId?: string | null, proposalsCount?: number | null, status: CompanyStatus, website?: string | null }, contact: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, createdAt: any, email: string, id: string }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, organizationSalesTaxId: string, percentage: number }> | null, stages: Array<{ __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, versions?: Array<{ __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }> | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', additionalCostId?: string | null, cost: number, costOverride?: number | null, costTotal?: string | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, crewId?: string | null, id: string, name: string, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', chargeType: EquipmentPieceChargeType, cost: string, equipmentPieceId?: string | null, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null, usePercentage: number }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: number | null, costMaterialOverride?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, externalProductName?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId: string, productionRateType?: ProductProductionRateType | null, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, subcontracted: boolean, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, type: string, unitPrice?: number | null, unitPriceOverride?: number | null, unitPriceProduct: boolean, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', diameter?: number | null, height?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', depth?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', cost: number, costOverride?: number | null, id: string, name: string, plantTransferTruckId?: string | null, quantity: number, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, transferTruckId: string, truckingProductionRate?: number | null, trucksNeeded?: number | null } | null> | null }, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }> | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string }, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null } }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null } | null, timeBucket?: { __typename?: 'TimeBucket', id: string, name: string, organizationId: string } | null, user: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type GetTransferTruckQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetTransferTruckQuery = { __typename?: 'Query', getTransferTruck?: { __typename?: 'TransferTruck', defaultRateHourly: number, defaultRateTon: number, defaultTonnage: number, id: string, name: string } | null };

export type GetTransferTrucksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTransferTrucksQuery = { __typename?: 'Query', getTransferTrucks: Array<{ __typename?: 'TransferTruck', defaultRateHourly: number, defaultRateTon: number, defaultTonnage: number, id: string, name: string }> };

export type GetUserOrganizationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserOrganizationQuery = { __typename?: 'Query', getUserOrganization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } };

export type GetYearToDateStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetYearToDateStatsQuery = { __typename?: 'Query', getYearToDateStats: { __typename?: 'YearToDateStats', yearToDateCloseRate: number, yearToDateJobAmountCompleted?: string | null, yearToDateNetMarginCalculated?: number | null, yearToDateTotalAmountProposed?: string | null, yearToDateTotalSalesWon?: string | null } };

export type IsCompanySearchableQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IsCompanySearchableQuery = { __typename?: 'Query', isCompanySearchable?: boolean | null };

export type IsJobSearchableQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IsJobSearchableQuery = { __typename?: 'Query', isJobSearchable?: boolean | null };

export type IsOpportunitySearchableQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IsOpportunitySearchableQuery = { __typename?: 'Query', isOpportunitySearchable?: boolean | null };

export type IsProposalSearchableQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type IsProposalSearchableQuery = { __typename?: 'Query', isProposalSearchable?: boolean | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null, conversionFactorOverride?: { __typename?: 'OrganizationConversionFactorOverride', asphaltTonConversionFactorOverride: string, excavateOutTonConversionFactorOverride: string, id: string } | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string, thumbnailPath?: string | null }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, proposalDefaults: { __typename?: 'ProposalDefault', autoSave?: boolean | null, color?: string | null, id: string, layout: ProposalLayout, removeIndividualLineItemPricing: boolean, removeUnitPriceAndQuantity: boolean }, salesTaxes?: Array<{ __typename?: 'OrganizationSalesTax', id: string, isDefault: boolean, name: string, percentage: number, quickbooksDesktopTaxCodeId?: string | null, quickbooksTaxCodeId?: string | null }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null };

export type PreviewSubscriptionChangeQueryVariables = Exact<{
  email?: InputMaybe<Scalars['String']>;
  quantityChange: Scalars['Int'];
}>;


export type PreviewSubscriptionChangeQuery = { __typename?: 'Query', previewSubscriptionChange?: { __typename?: 'PreviewSubscriptionChangeResponse', totalOnRenewal: number, totalToday: number } | null };

export type TimeEntryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TimeEntryQuery = { __typename?: 'Query', timeEntry?: { __typename?: 'TimeEntry', clockInLatitude?: number | null, clockInLongitude?: number | null, clockOutLatitude?: number | null, clockOutLongitude?: number | null, endTime?: any | null, forDate: any, id: string, notes?: string | null, organizationId: string, startTime: any, timeTrackedSeconds?: number | null, timeTrackedSecondsOverride?: number | null, uuid: string, jobPhase?: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null } }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, externalId: string, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }>, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, organizationId: string, rate: number, userId?: string | null }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualCostTransferTruck: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, billingStatus?: JobBillingStatus | null, datePushedToQuickbooks?: any | null, endsAt?: any | null, externalId: string, id: string, mayShowTaxNotification?: boolean | null, notes?: string | null, projectFilesFolderId?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedCostTransferTruck: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, shouldPushTaxesToQuickbooks?: boolean | null, startsAt?: any | null, status: JobStatus, userId: string }, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, name?: string | null, type?: string | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', acceptanceOverride?: string | null, activeVersion: boolean, changeOrderJobId?: string | null, clientEmailOverride?: string | null, contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTaxes: string, costTotal: string, createdAt: any, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, emailSubjectOverride?: string | null, externalId: string, grossMargin: string, grossMarginPercentage: number, id: string, isChangeOrder: boolean, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalAfterTaxes: string, profit: string, profitPercentage: number, projectFilesFolderId?: string | null, proposalNotes?: string | null, removeIndividualLineItemPricing?: boolean | null, removeUnitPriceAndQuantity?: boolean | null, sentAt?: any | null, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string, version: string, wonAt?: any | null }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, externalProductName?: string | null, grossMargin: string, grossMarginPercentage: number, id: string, isOptional: boolean, jobDuration: number, jobDurationDaysOverride?: number | null, jobDurationOverride?: number | null, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal: string, overallTotalOverride?: string | null, productName?: string | null, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, roundTripTravelTimeHours?: number | null, statementOfWork?: string | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null }, proposalStage: { __typename?: 'ProposalStage', addressOverride?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, ordering: number, overallTotal?: string | null, profit: string, profitPercentage: number, roundTripTravelTimeHours?: number | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }>, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, estimatedMaterial?: number | null, estimatedMaterialOverride?: number | null, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> | null, users?: Array<{ __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus }> | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, name: string, quantity?: number | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null } | null> | null }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', costAdditional: number, costEquipment: number, costLabour: number, costMaterial: number, costTransferTruck: number, date: any, id: string, plantId?: string | null, plantProductId?: string | null } } | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number, transferTruckId?: string | null }> | null, user?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, proposalSentEmailText?: string | null, subscribed: boolean, timezone?: string | null, trialEndsAt?: any | null } } | null }> } | null, timeBucket?: { __typename?: 'TimeBucket', id: string, name: string, organizationId: string } | null, user: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, hasEmployee: boolean, id: string, inviteToken?: string | null, invitedAt?: any | null, jobPhasesCount: number, jobsCount: number, lastName?: string | null, name: string, permissions: Array<UserPermissions>, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } } | null };

export type ValidateLoginQueryVariables = Exact<{
  input: ValidateLoginInput;
}>;


export type ValidateLoginQuery = { __typename?: 'Query', validateLogin?: boolean | null };

export type ValidateUserInviteTokenQueryVariables = Exact<{
  email: Scalars['String'];
  inviteToken: Scalars['String'];
}>;


export type ValidateUserInviteTokenQuery = { __typename?: 'Query', validateUserInviteToken: boolean };

export type CompanyFragmentFragment = { __typename?: 'Company', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, addCompanyInfo?: boolean | null, projectFilesFolderId?: string | null, email: string, id: string, jobsCount?: number | null, name: string, notes?: string | null, phone?: string | null, proposalsCount?: number | null, website?: string | null, logo?: string | null, status: CompanyStatus, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null };

export type CustomEventFragmentFragment = { __typename?: 'CustomEvent', color?: string | null, endsAt?: any | null, id?: string | null, name?: string | null, notes?: string | null, startsAt?: any | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string } | null, customEventBlocks?: Array<{ __typename?: 'CustomEventBlock', blockLength?: number | null, endsAt?: any | null, id?: string | null, scheduledAt?: any | null } | null> | null, customEventsToUsers?: Array<{ __typename?: 'CustomEventsToUsers', user?: { __typename?: 'User', id: string } | null } | null> | null };

export type JobPhaseFragmentFragment = { __typename?: 'JobPhase', id: string, externalId: string, actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualCostTransferTruck: string, address: string, applicableStatuses?: Array<string> | null, productName: string, endsAt?: any | null, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, proposedCostTransferTruck: string, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, transferTruckId?: string | null, quantity?: number | null, name: string, tonnage: number, rateTon: number, rateHourly: number } | null> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, name?: string | null, type?: string | null, plant?: { __typename?: 'Plant', id: string, addressLine1: string, addressLine2?: string | null, addressCity: string, addressState: string, addressZip: string, addressCountry: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string } | null } | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', date: any, costMaterial: number, costEquipment: number, costLabour: number, costAdditional: number, costTransferTruck: number, id: string, plantId?: string | null, plantProductId?: string | null, user?: { __typename?: 'User', name: string } | null, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', id: string, plantId?: string | null, plantProductId?: string | null } } | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', id: string, plantId?: string | null, plantProductId?: string | null, date: any, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', id: string }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType } | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number }> | null } }> | null, jobPhase: { __typename?: 'JobPhase', endsAt?: any | null, id: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, rate: number }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, id: string, inviteToken?: string | null, invitedAt?: any | null, lastName?: string | null, name: string, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, productName?: string | null, profit: string, profitPercentage: number, costTransferTruck: string, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, material: { __typename?: 'ProposalMaterial', id: string, productId: string, name: string }, crews?: Array<{ __typename?: 'ProposalCrew', cost: string }> | null, plantProduct?: { __typename?: 'ProposalPlantProduct', type: string, plantProductId: string, plant: { __typename?: 'ProposalPlant', name: string, addressLine1: string, addressLine2?: string | null, addressCity: string, addressState: string, addressZip: string, addressCountry: string } } | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', estimatedMaterialOverride?: number | null, estimatedMaterial?: number | null, blockLength: number, endsAt: any, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> }, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, rate: number }>, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', name: string, cost: number, id: string, feeAmount: number, feeType: AdditionalCostFeeType }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, foremanUser?: { __typename?: 'User', id: string, name: string, phone?: string | null } | null, job: { __typename?: 'Job', externalId: string, actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, endsAt?: any | null, id: string, notes?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobStatus, billingStatus?: JobBillingStatus | null, userId: string, company: { __typename?: 'Company', id: string, name: string, phone?: string | null }, contact: { __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, title?: string | null } }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, id: string, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, profit: string, profitPercentage: number, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementMaterial?: ProductMeasurementMaterial | null, measurementJob?: ProductMeasurementJob | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, productName?: string | null, profit: string, profitPercentage: number, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, statementOfWork?: string | null, material: { __typename?: 'ProposalMaterial', id: string, name: string, externalProductName?: string | null, materialNeeded?: number | null, materialNeededOverride?: number | null, productId: string }, plantProduct?: { __typename?: 'ProposalPlantProduct', type: string, plantProductId: string, plant: { __typename?: 'ProposalPlant', plantId: string, addressLine1: string, addressLine2?: string | null, addressCity: string, addressState: string, addressZip: string, addressCountry: string } } | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', id: string, equipmentPieceId?: string | null, name: string, rate: number, timeTravel: number, timeTravelOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null }> | null, crews?: Array<{ __typename?: 'ProposalCrew', id: string, crewId?: string | null, name: string, rate: number, timeOnjob: number, timeOnjobOverride?: number | null }> | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', id: string, additionalCostId?: string | null, name: string, cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, quantity?: number | null, quantityOverride?: number | null } | null> | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, transferTruckId: string, name: string, tonnage: number, quantity: number, trucksNeeded?: number | null } | null> | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', estimatedMaterialOverride?: number | null, estimatedMaterial?: number | null, blockLength: number, endsAt: any, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean }>, organization: { __typename?: 'Organization', id: string, name: string, logo?: string | null }, crew?: { __typename?: 'Crew', id: string, color: string, displayName?: string | null } | null, users?: Array<{ __typename?: 'User', id: string }> | null, proposalStage: { __typename?: 'ProposalStage', name?: string | null } };

export type NotificationTriggerFragmentFragment = { __typename?: 'NotificationTrigger', id: string, name: string, active: boolean, delay: number, event: NotificationTriggerEvent, type: NotificationTriggerType, content: string, sendToUser: boolean, sendToAllRecipients: boolean, sendToContact: boolean, additionalRecipientTypes?: Array<NotificationTriggerAdditionalRecipientTypes> | null, isEmail?: boolean | null, isSMS?: boolean | null, smsContent?: string | null, emailSubject?: string | null, additionalRecipients: Array<{ __typename?: 'NotificationTriggerRecipient', id: string, firstName: string, lastName: string }> };

export type BitumioOrganizationEmailTemplateFragment = { __typename?: 'OrganizationEmailTemplate', type: OrganizationEmailTemplateType, html: string };

export type UpdatedProductFragment = { __typename?: 'Product', id: string };

export type BitumioProposalFragment = { __typename?: 'Proposal', id: string, uuid: string, activeVersion: boolean, contactId: string, status: ProposalStatus, source?: ProposalSource | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, externalId: string, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, profit: string, profitPercentage: number, proposalNotes?: string | null, createdAt: any, removeUnitPriceAndQuantity?: boolean | null, removeIndividualLineItemPricing?: boolean | null, isChangeOrder: boolean, userId?: string | null, costTaxes: string, overallTotalAfterTaxes: string, acceptanceOverride?: string | null, version: string, changeOrderJobId?: string | null, projectFilesFolderId?: string | null, clientEmailOverride?: string | null, emailSubjectOverride?: string | null, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, company: { __typename?: 'Company', id: string, name: string, contacts: Array<{ __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }> }, contact: { __typename?: 'Contact', firstName: string, lastName: string, email?: string | null }, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, email: string, id: string }>, stages: Array<{ __typename?: 'ProposalStage', id: string, name?: string | null, mapData?: string | null, mapImage?: string | null, overallTotal?: string | null, distanceSeconds?: number | null, roundTripTravelTimeHours?: number | null, addressOverride?: string | null, ordering: number, proposalProducts?: Array<{ __typename?: 'ProposalProduct', notes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, jobDurationOverride?: number | null, jobDurationDaysOverride?: number | null, roundTripTravelTimeHours?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalOverride?: string | null, ordering: number, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, isOptional: boolean, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, costTotal?: string | null, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, id: string, name: string, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', chargeType: EquipmentPieceChargeType, cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: number | null, costMaterialOverride?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId: string, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, name: string, type: string, productionRateType?: ProductProductionRateType | null, subcontracted: boolean, unitPriceProduct: boolean, unitPrice?: number | null, unitPriceOverride?: number | null, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, name: string, plantTransferTruckId?: string | null, quantity: number, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, transferTruckId: string, trucksNeeded?: number | null, truckingProductionRate?: number | null, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, cost: number, costOverride?: number | null } | null> | null }> | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null }>, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, percentage: number, organizationSalesTaxId: string }> | null, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string }> | null, changeOrders?: Array<{ __typename?: 'Proposal', id: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, changeOrderJobId?: string | null }> | null, versions?: Array<{ __typename?: 'Proposal', id: string, version: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, activeVersion: boolean }> | null };

export type BitumioProposalStageFragment = { __typename?: 'ProposalStage', id: string, name?: string | null, mapData?: string | null, mapImage?: string | null, overallTotal?: string | null, distanceSeconds?: number | null, roundTripTravelTimeHours?: number | null, addressOverride?: string | null, ordering: number, proposalProducts?: Array<{ __typename?: 'ProposalProduct', notes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, jobDurationOverride?: number | null, jobDurationDaysOverride?: number | null, roundTripTravelTimeHours?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalOverride?: string | null, ordering: number, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, isOptional: boolean, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, costTotal?: string | null, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, id: string, name: string, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', chargeType: EquipmentPieceChargeType, cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: number | null, costMaterialOverride?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId: string, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, name: string, type: string, productionRateType?: ProductProductionRateType | null, subcontracted: boolean, unitPriceProduct: boolean, unitPrice?: number | null, unitPriceOverride?: number | null, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, name: string, plantTransferTruckId?: string | null, quantity: number, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, transferTruckId: string, trucksNeeded?: number | null, truckingProductionRate?: number | null, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, cost: number, costOverride?: number | null } | null> | null }> | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null };

export type CustomAddProductToProposalStageMutationVariables = Exact<{
  proposalStageId: Scalars['ID'];
  productId: Scalars['ID'];
}>;


export type CustomAddProductToProposalStageMutation = { __typename?: 'Mutation', addProductToProposalStage: { __typename?: 'Proposal', id: string, uuid: string, activeVersion: boolean, contactId: string, status: ProposalStatus, source?: ProposalSource | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, externalId: string, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, profit: string, profitPercentage: number, proposalNotes?: string | null, createdAt: any, removeUnitPriceAndQuantity?: boolean | null, removeIndividualLineItemPricing?: boolean | null, isChangeOrder: boolean, userId?: string | null, costTaxes: string, overallTotalAfterTaxes: string, acceptanceOverride?: string | null, version: string, changeOrderJobId?: string | null, projectFilesFolderId?: string | null, clientEmailOverride?: string | null, emailSubjectOverride?: string | null, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, company: { __typename?: 'Company', id: string, name: string, contacts: Array<{ __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }> }, contact: { __typename?: 'Contact', firstName: string, lastName: string, email?: string | null }, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, email: string, id: string }>, stages: Array<{ __typename?: 'ProposalStage', id: string, name?: string | null, mapData?: string | null, mapImage?: string | null, overallTotal?: string | null, distanceSeconds?: number | null, roundTripTravelTimeHours?: number | null, addressOverride?: string | null, ordering: number, proposalProducts?: Array<{ __typename?: 'ProposalProduct', notes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, jobDurationOverride?: number | null, jobDurationDaysOverride?: number | null, roundTripTravelTimeHours?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalOverride?: string | null, ordering: number, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, isOptional: boolean, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, costTotal?: string | null, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, id: string, name: string, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', chargeType: EquipmentPieceChargeType, cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: number | null, costMaterialOverride?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId: string, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, name: string, type: string, productionRateType?: ProductProductionRateType | null, subcontracted: boolean, unitPriceProduct: boolean, unitPrice?: number | null, unitPriceOverride?: number | null, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, name: string, plantTransferTruckId?: string | null, quantity: number, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, transferTruckId: string, trucksNeeded?: number | null, truckingProductionRate?: number | null, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, cost: number, costOverride?: number | null } | null> | null }> | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null }>, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, percentage: number, organizationSalesTaxId: string }> | null, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string }> | null, changeOrders?: Array<{ __typename?: 'Proposal', id: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, changeOrderJobId?: string | null }> | null, versions?: Array<{ __typename?: 'Proposal', id: string, version: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, activeVersion: boolean }> | null } };

export type CustomAddProposalAddressMutationVariables = Exact<{
  input: AddProposalAddressInput;
}>;


export type CustomAddProposalAddressMutation = { __typename?: 'Mutation', addProposalAddress: { __typename?: 'Proposal', id: string, uuid: string, activeVersion: boolean, contactId: string, status: ProposalStatus, source?: ProposalSource | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, externalId: string, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, profit: string, profitPercentage: number, proposalNotes?: string | null, createdAt: any, removeUnitPriceAndQuantity?: boolean | null, removeIndividualLineItemPricing?: boolean | null, isChangeOrder: boolean, userId?: string | null, costTaxes: string, overallTotalAfterTaxes: string, acceptanceOverride?: string | null, version: string, changeOrderJobId?: string | null, projectFilesFolderId?: string | null, clientEmailOverride?: string | null, emailSubjectOverride?: string | null, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, company: { __typename?: 'Company', id: string, name: string, contacts: Array<{ __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }> }, contact: { __typename?: 'Contact', firstName: string, lastName: string, email?: string | null }, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, email: string, id: string }>, stages: Array<{ __typename?: 'ProposalStage', id: string, name?: string | null, mapData?: string | null, mapImage?: string | null, overallTotal?: string | null, distanceSeconds?: number | null, roundTripTravelTimeHours?: number | null, addressOverride?: string | null, ordering: number, proposalProducts?: Array<{ __typename?: 'ProposalProduct', notes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, jobDurationOverride?: number | null, jobDurationDaysOverride?: number | null, roundTripTravelTimeHours?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalOverride?: string | null, ordering: number, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, isOptional: boolean, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, costTotal?: string | null, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, id: string, name: string, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', chargeType: EquipmentPieceChargeType, cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: number | null, costMaterialOverride?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId: string, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, name: string, type: string, productionRateType?: ProductProductionRateType | null, subcontracted: boolean, unitPriceProduct: boolean, unitPrice?: number | null, unitPriceOverride?: number | null, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, name: string, plantTransferTruckId?: string | null, quantity: number, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, transferTruckId: string, trucksNeeded?: number | null, truckingProductionRate?: number | null, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, cost: number, costOverride?: number | null } | null> | null }> | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null }>, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, percentage: number, organizationSalesTaxId: string }> | null, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string }> | null, changeOrders?: Array<{ __typename?: 'Proposal', id: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, changeOrderJobId?: string | null }> | null, versions?: Array<{ __typename?: 'Proposal', id: string, version: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, activeVersion: boolean }> | null } };

export type CustomAddProposalEquipmentPieceMutationVariables = Exact<{
  equipmentPieceId: Scalars['ID'];
  proposalProductId: Scalars['ID'];
  quantity: Scalars['Int'];
}>;


export type CustomAddProposalEquipmentPieceMutation = { __typename?: 'Mutation', addProposalEquipmentPiece: { __typename?: 'Proposal', id: string, uuid: string, activeVersion: boolean, contactId: string, status: ProposalStatus, source?: ProposalSource | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, externalId: string, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, profit: string, profitPercentage: number, proposalNotes?: string | null, createdAt: any, removeUnitPriceAndQuantity?: boolean | null, removeIndividualLineItemPricing?: boolean | null, isChangeOrder: boolean, userId?: string | null, costTaxes: string, overallTotalAfterTaxes: string, acceptanceOverride?: string | null, version: string, changeOrderJobId?: string | null, projectFilesFolderId?: string | null, clientEmailOverride?: string | null, emailSubjectOverride?: string | null, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, company: { __typename?: 'Company', id: string, name: string, contacts: Array<{ __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }> }, contact: { __typename?: 'Contact', firstName: string, lastName: string, email?: string | null }, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, email: string, id: string }>, stages: Array<{ __typename?: 'ProposalStage', id: string, name?: string | null, mapData?: string | null, mapImage?: string | null, overallTotal?: string | null, distanceSeconds?: number | null, roundTripTravelTimeHours?: number | null, addressOverride?: string | null, ordering: number, proposalProducts?: Array<{ __typename?: 'ProposalProduct', notes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, jobDurationOverride?: number | null, jobDurationDaysOverride?: number | null, roundTripTravelTimeHours?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalOverride?: string | null, ordering: number, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, isOptional: boolean, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, costTotal?: string | null, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, id: string, name: string, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', chargeType: EquipmentPieceChargeType, cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: number | null, costMaterialOverride?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId: string, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, name: string, type: string, productionRateType?: ProductProductionRateType | null, subcontracted: boolean, unitPriceProduct: boolean, unitPrice?: number | null, unitPriceOverride?: number | null, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, name: string, plantTransferTruckId?: string | null, quantity: number, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, transferTruckId: string, trucksNeeded?: number | null, truckingProductionRate?: number | null, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, cost: number, costOverride?: number | null } | null> | null }> | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null }>, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, percentage: number, organizationSalesTaxId: string }> | null, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string }> | null, changeOrders?: Array<{ __typename?: 'Proposal', id: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, changeOrderJobId?: string | null }> | null, versions?: Array<{ __typename?: 'Proposal', id: string, version: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, activeVersion: boolean }> | null } };

export type CustomAddProposalStageMutationVariables = Exact<{
  proposalId: Scalars['ID'];
}>;


export type CustomAddProposalStageMutation = { __typename?: 'Mutation', addProposalStage?: { __typename?: 'ProposalStage', id: string, name?: string | null, mapData?: string | null, mapImage?: string | null, overallTotal?: string | null, distanceSeconds?: number | null, roundTripTravelTimeHours?: number | null, addressOverride?: string | null, ordering: number, proposalProducts?: Array<{ __typename?: 'ProposalProduct', notes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, jobDurationOverride?: number | null, jobDurationDaysOverride?: number | null, roundTripTravelTimeHours?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalOverride?: string | null, ordering: number, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, isOptional: boolean, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, costTotal?: string | null, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, id: string, name: string, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', chargeType: EquipmentPieceChargeType, cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: number | null, costMaterialOverride?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId: string, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, name: string, type: string, productionRateType?: ProductProductionRateType | null, subcontracted: boolean, unitPriceProduct: boolean, unitPrice?: number | null, unitPriceOverride?: number | null, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, name: string, plantTransferTruckId?: string | null, quantity: number, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, transferTruckId: string, trucksNeeded?: number | null, truckingProductionRate?: number | null, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, cost: number, costOverride?: number | null } | null> | null }> | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null } | null };

export type CustomCancelOpportunityMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomCancelOpportunityMutation = { __typename?: 'Mutation', cancelOpportunity: { __typename?: 'Opportunity', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, companyId: string, contactId: string, createdAt: any, dueAt?: any | null, id: string, name: string, notes?: string | null, source?: OpportunitySource | null, status: string, updatedAt: any, userId?: string | null, company: { __typename?: 'Company', name: string }, contact: { __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string }, products?: Array<{ __typename?: 'OrganizationProductType', id: string, name: string }> | null, user?: { __typename?: 'User', firstName?: string | null, id: string, lastName?: string | null } | null } };

export type CustomCancelProposalMutationVariables = Exact<{
  duplicate: Scalars['Boolean'];
  id: Scalars['ID'];
  maintainCurrentId?: InputMaybe<Scalars['Boolean']>;
}>;


export type CustomCancelProposalMutation = { __typename?: 'Mutation', cancelProposal: { __typename?: 'CancelProposalResponse', newProposal?: { __typename?: 'Proposal', id: string, uuid: string, activeVersion: boolean, contactId: string, status: ProposalStatus, source?: ProposalSource | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, externalId: string, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, profit: string, profitPercentage: number, proposalNotes?: string | null, createdAt: any, removeUnitPriceAndQuantity?: boolean | null, removeIndividualLineItemPricing?: boolean | null, isChangeOrder: boolean, userId?: string | null, costTaxes: string, overallTotalAfterTaxes: string, acceptanceOverride?: string | null, version: string, changeOrderJobId?: string | null, projectFilesFolderId?: string | null, clientEmailOverride?: string | null, emailSubjectOverride?: string | null, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, company: { __typename?: 'Company', id: string, name: string, contacts: Array<{ __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }> }, contact: { __typename?: 'Contact', firstName: string, lastName: string, email?: string | null }, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, email: string, id: string }>, stages: Array<{ __typename?: 'ProposalStage', id: string, name?: string | null, mapData?: string | null, mapImage?: string | null, overallTotal?: string | null, distanceSeconds?: number | null, roundTripTravelTimeHours?: number | null, addressOverride?: string | null, ordering: number, proposalProducts?: Array<{ __typename?: 'ProposalProduct', notes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, jobDurationOverride?: number | null, jobDurationDaysOverride?: number | null, roundTripTravelTimeHours?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalOverride?: string | null, ordering: number, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, isOptional: boolean, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, costTotal?: string | null, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, id: string, name: string, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', chargeType: EquipmentPieceChargeType, cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: number | null, costMaterialOverride?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId: string, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, name: string, type: string, productionRateType?: ProductProductionRateType | null, subcontracted: boolean, unitPriceProduct: boolean, unitPrice?: number | null, unitPriceOverride?: number | null, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, name: string, plantTransferTruckId?: string | null, quantity: number, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, transferTruckId: string, trucksNeeded?: number | null, truckingProductionRate?: number | null, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, cost: number, costOverride?: number | null } | null> | null }> | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null }>, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, percentage: number, organizationSalesTaxId: string }> | null, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string }> | null, changeOrders?: Array<{ __typename?: 'Proposal', id: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, changeOrderJobId?: string | null }> | null, versions?: Array<{ __typename?: 'Proposal', id: string, version: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, activeVersion: boolean }> | null } | null, proposal: { __typename?: 'Proposal', id: string, uuid: string, activeVersion: boolean, contactId: string, status: ProposalStatus, source?: ProposalSource | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, externalId: string, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, profit: string, profitPercentage: number, proposalNotes?: string | null, createdAt: any, removeUnitPriceAndQuantity?: boolean | null, removeIndividualLineItemPricing?: boolean | null, isChangeOrder: boolean, userId?: string | null, costTaxes: string, overallTotalAfterTaxes: string, acceptanceOverride?: string | null, version: string, changeOrderJobId?: string | null, projectFilesFolderId?: string | null, clientEmailOverride?: string | null, emailSubjectOverride?: string | null, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, company: { __typename?: 'Company', id: string, name: string, contacts: Array<{ __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }> }, contact: { __typename?: 'Contact', firstName: string, lastName: string, email?: string | null }, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, email: string, id: string }>, stages: Array<{ __typename?: 'ProposalStage', id: string, name?: string | null, mapData?: string | null, mapImage?: string | null, overallTotal?: string | null, distanceSeconds?: number | null, roundTripTravelTimeHours?: number | null, addressOverride?: string | null, ordering: number, proposalProducts?: Array<{ __typename?: 'ProposalProduct', notes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, jobDurationOverride?: number | null, jobDurationDaysOverride?: number | null, roundTripTravelTimeHours?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalOverride?: string | null, ordering: number, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, isOptional: boolean, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, costTotal?: string | null, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, id: string, name: string, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', chargeType: EquipmentPieceChargeType, cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: number | null, costMaterialOverride?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId: string, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, name: string, type: string, productionRateType?: ProductProductionRateType | null, subcontracted: boolean, unitPriceProduct: boolean, unitPrice?: number | null, unitPriceOverride?: number | null, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, name: string, plantTransferTruckId?: string | null, quantity: number, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, transferTruckId: string, trucksNeeded?: number | null, truckingProductionRate?: number | null, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, cost: number, costOverride?: number | null } | null> | null }> | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null }>, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, percentage: number, organizationSalesTaxId: string }> | null, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string }> | null, changeOrders?: Array<{ __typename?: 'Proposal', id: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, changeOrderJobId?: string | null }> | null, versions?: Array<{ __typename?: 'Proposal', id: string, version: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, activeVersion: boolean }> | null } } };

export type CustomCloseProposalMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomCloseProposalMutation = { __typename?: 'Mutation', closeProposal: { __typename?: 'Proposal', id: string, uuid: string, activeVersion: boolean, contactId: string, status: ProposalStatus, source?: ProposalSource | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, externalId: string, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, profit: string, profitPercentage: number, proposalNotes?: string | null, createdAt: any, removeUnitPriceAndQuantity?: boolean | null, removeIndividualLineItemPricing?: boolean | null, isChangeOrder: boolean, userId?: string | null, costTaxes: string, overallTotalAfterTaxes: string, acceptanceOverride?: string | null, version: string, changeOrderJobId?: string | null, projectFilesFolderId?: string | null, clientEmailOverride?: string | null, emailSubjectOverride?: string | null, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, company: { __typename?: 'Company', id: string, name: string, contacts: Array<{ __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }> }, contact: { __typename?: 'Contact', firstName: string, lastName: string, email?: string | null }, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, email: string, id: string }>, stages: Array<{ __typename?: 'ProposalStage', id: string, name?: string | null, mapData?: string | null, mapImage?: string | null, overallTotal?: string | null, distanceSeconds?: number | null, roundTripTravelTimeHours?: number | null, addressOverride?: string | null, ordering: number, proposalProducts?: Array<{ __typename?: 'ProposalProduct', notes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, jobDurationOverride?: number | null, jobDurationDaysOverride?: number | null, roundTripTravelTimeHours?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalOverride?: string | null, ordering: number, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, isOptional: boolean, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, costTotal?: string | null, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, id: string, name: string, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', chargeType: EquipmentPieceChargeType, cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: number | null, costMaterialOverride?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId: string, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, name: string, type: string, productionRateType?: ProductProductionRateType | null, subcontracted: boolean, unitPriceProduct: boolean, unitPrice?: number | null, unitPriceOverride?: number | null, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, name: string, plantTransferTruckId?: string | null, quantity: number, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, transferTruckId: string, trucksNeeded?: number | null, truckingProductionRate?: number | null, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, cost: number, costOverride?: number | null } | null> | null }> | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null }>, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, percentage: number, organizationSalesTaxId: string }> | null, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string }> | null, changeOrders?: Array<{ __typename?: 'Proposal', id: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, changeOrderJobId?: string | null }> | null, versions?: Array<{ __typename?: 'Proposal', id: string, version: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, activeVersion: boolean }> | null } };

export type CustomCreateCustomEventMutationVariables = Exact<{
  input?: InputMaybe<CreateCustomEventInput>;
}>;


export type CustomCreateCustomEventMutation = { __typename?: 'Mutation', createCustomEvent?: { __typename?: 'CustomEvent', color?: string | null, endsAt?: any | null, id?: string | null, name?: string | null, notes?: string | null, startsAt?: any | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string } | null, customEventBlocks?: Array<{ __typename?: 'CustomEventBlock', blockLength?: number | null, endsAt?: any | null, id?: string | null, scheduledAt?: any | null } | null> | null, customEventsToUsers?: Array<{ __typename?: 'CustomEventsToUsers', user?: { __typename?: 'User', id: string } | null } | null> | null } | null };

export type CustomCreateNotificationTriggerMutationVariables = Exact<{
  input: CreateNotificationTriggerInput;
}>;


export type CustomCreateNotificationTriggerMutation = { __typename?: 'Mutation', createNotificationTrigger?: { __typename?: 'NotificationTrigger', id: string, name: string, active: boolean, delay: number, event: NotificationTriggerEvent, type: NotificationTriggerType, content: string, sendToUser: boolean, sendToAllRecipients: boolean, sendToContact: boolean, additionalRecipientTypes?: Array<NotificationTriggerAdditionalRecipientTypes> | null, isEmail?: boolean | null, isSMS?: boolean | null, smsContent?: string | null, emailSubject?: string | null, additionalRecipients: Array<{ __typename?: 'NotificationTriggerRecipient', id: string, firstName: string, lastName: string }> } | null };

export type CustomCreateProductMutationVariables = Exact<{
  input: CreateProductInput;
}>;


export type CustomCreateProductMutation = { __typename?: 'Mutation', createProduct: { __typename?: 'Product', id: string } };

export type CustomCreateProposalMutationVariables = Exact<{
  companyId: Scalars['ID'];
  contactId: Scalars['ID'];
  source?: InputMaybe<ProposalSource>;
}>;


export type CustomCreateProposalMutation = { __typename?: 'Mutation', createProposal: { __typename?: 'Proposal', id: string, uuid: string, activeVersion: boolean, contactId: string, status: ProposalStatus, source?: ProposalSource | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, externalId: string, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, profit: string, profitPercentage: number, proposalNotes?: string | null, createdAt: any, removeUnitPriceAndQuantity?: boolean | null, removeIndividualLineItemPricing?: boolean | null, isChangeOrder: boolean, userId?: string | null, costTaxes: string, overallTotalAfterTaxes: string, acceptanceOverride?: string | null, version: string, changeOrderJobId?: string | null, projectFilesFolderId?: string | null, clientEmailOverride?: string | null, emailSubjectOverride?: string | null, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, company: { __typename?: 'Company', id: string, name: string, contacts: Array<{ __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }> }, contact: { __typename?: 'Contact', firstName: string, lastName: string, email?: string | null }, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, email: string, id: string }>, stages: Array<{ __typename?: 'ProposalStage', id: string, name?: string | null, mapData?: string | null, mapImage?: string | null, overallTotal?: string | null, distanceSeconds?: number | null, roundTripTravelTimeHours?: number | null, addressOverride?: string | null, ordering: number, proposalProducts?: Array<{ __typename?: 'ProposalProduct', notes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, jobDurationOverride?: number | null, jobDurationDaysOverride?: number | null, roundTripTravelTimeHours?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalOverride?: string | null, ordering: number, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, isOptional: boolean, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, costTotal?: string | null, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, id: string, name: string, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', chargeType: EquipmentPieceChargeType, cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: number | null, costMaterialOverride?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId: string, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, name: string, type: string, productionRateType?: ProductProductionRateType | null, subcontracted: boolean, unitPriceProduct: boolean, unitPrice?: number | null, unitPriceOverride?: number | null, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, name: string, plantTransferTruckId?: string | null, quantity: number, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, transferTruckId: string, trucksNeeded?: number | null, truckingProductionRate?: number | null, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, cost: number, costOverride?: number | null } | null> | null }> | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null }>, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, percentage: number, organizationSalesTaxId: string }> | null, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string }> | null, changeOrders?: Array<{ __typename?: 'Proposal', id: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, changeOrderJobId?: string | null }> | null, versions?: Array<{ __typename?: 'Proposal', id: string, version: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, activeVersion: boolean }> | null } };

export type CustomCreateProposalFromOpportunityMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomCreateProposalFromOpportunityMutation = { __typename?: 'Mutation', createProposalFromOpportunity: { __typename?: 'Proposal', id: string } };

export type CustomDeleteCustomEventMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomDeleteCustomEventMutation = { __typename?: 'Mutation', deleteCustomEvent: { __typename?: 'CustomEvent', color?: string | null, endsAt?: any | null, id?: string | null, name?: string | null, notes?: string | null, startsAt?: any | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string } | null, customEventBlocks?: Array<{ __typename?: 'CustomEventBlock', blockLength?: number | null, endsAt?: any | null, id?: string | null, scheduledAt?: any | null } | null> | null, customEventsToUsers?: Array<{ __typename?: 'CustomEventsToUsers', user?: { __typename?: 'User', id: string } | null } | null> | null } };

export type CustomDeleteProposalMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomDeleteProposalMutation = { __typename?: 'Mutation', deleteProposal?: { __typename?: 'Proposal', id: string, uuid: string, activeVersion: boolean, contactId: string, status: ProposalStatus, source?: ProposalSource | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, externalId: string, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, profit: string, profitPercentage: number, proposalNotes?: string | null, createdAt: any, removeUnitPriceAndQuantity?: boolean | null, removeIndividualLineItemPricing?: boolean | null, isChangeOrder: boolean, userId?: string | null, costTaxes: string, overallTotalAfterTaxes: string, acceptanceOverride?: string | null, version: string, changeOrderJobId?: string | null, projectFilesFolderId?: string | null, clientEmailOverride?: string | null, emailSubjectOverride?: string | null, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, company: { __typename?: 'Company', id: string, name: string, contacts: Array<{ __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }> }, contact: { __typename?: 'Contact', firstName: string, lastName: string, email?: string | null }, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, email: string, id: string }>, stages: Array<{ __typename?: 'ProposalStage', id: string, name?: string | null, mapData?: string | null, mapImage?: string | null, overallTotal?: string | null, distanceSeconds?: number | null, roundTripTravelTimeHours?: number | null, addressOverride?: string | null, ordering: number, proposalProducts?: Array<{ __typename?: 'ProposalProduct', notes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, jobDurationOverride?: number | null, jobDurationDaysOverride?: number | null, roundTripTravelTimeHours?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalOverride?: string | null, ordering: number, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, isOptional: boolean, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, costTotal?: string | null, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, id: string, name: string, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', chargeType: EquipmentPieceChargeType, cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: number | null, costMaterialOverride?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId: string, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, name: string, type: string, productionRateType?: ProductProductionRateType | null, subcontracted: boolean, unitPriceProduct: boolean, unitPrice?: number | null, unitPriceOverride?: number | null, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, name: string, plantTransferTruckId?: string | null, quantity: number, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, transferTruckId: string, trucksNeeded?: number | null, truckingProductionRate?: number | null, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, cost: number, costOverride?: number | null } | null> | null }> | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null }>, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, percentage: number, organizationSalesTaxId: string }> | null, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string }> | null, changeOrders?: Array<{ __typename?: 'Proposal', id: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, changeOrderJobId?: string | null }> | null, versions?: Array<{ __typename?: 'Proposal', id: string, version: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, activeVersion: boolean }> | null } | null };

export type CustomDeleteProposalProductMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomDeleteProposalProductMutation = { __typename?: 'Mutation', deleteProposalProduct: { __typename?: 'ProposalStage', id: string, name?: string | null, mapData?: string | null, mapImage?: string | null, overallTotal?: string | null, distanceSeconds?: number | null, roundTripTravelTimeHours?: number | null, addressOverride?: string | null, ordering: number, proposalProducts?: Array<{ __typename?: 'ProposalProduct', notes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, jobDurationOverride?: number | null, jobDurationDaysOverride?: number | null, roundTripTravelTimeHours?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalOverride?: string | null, ordering: number, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, isOptional: boolean, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, costTotal?: string | null, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, id: string, name: string, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', chargeType: EquipmentPieceChargeType, cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: number | null, costMaterialOverride?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId: string, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, name: string, type: string, productionRateType?: ProductProductionRateType | null, subcontracted: boolean, unitPriceProduct: boolean, unitPrice?: number | null, unitPriceOverride?: number | null, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, name: string, plantTransferTruckId?: string | null, quantity: number, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, transferTruckId: string, trucksNeeded?: number | null, truckingProductionRate?: number | null, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, cost: number, costOverride?: number | null } | null> | null }> | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null } };

export type CustomDeleteProposalStageMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomDeleteProposalStageMutation = { __typename?: 'Mutation', deleteProposalStage: { __typename?: 'Proposal', id: string, uuid: string, activeVersion: boolean, contactId: string, status: ProposalStatus, source?: ProposalSource | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, externalId: string, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, profit: string, profitPercentage: number, proposalNotes?: string | null, createdAt: any, removeUnitPriceAndQuantity?: boolean | null, removeIndividualLineItemPricing?: boolean | null, isChangeOrder: boolean, userId?: string | null, costTaxes: string, overallTotalAfterTaxes: string, acceptanceOverride?: string | null, version: string, changeOrderJobId?: string | null, projectFilesFolderId?: string | null, clientEmailOverride?: string | null, emailSubjectOverride?: string | null, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, company: { __typename?: 'Company', id: string, name: string, contacts: Array<{ __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }> }, contact: { __typename?: 'Contact', firstName: string, lastName: string, email?: string | null }, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, email: string, id: string }>, stages: Array<{ __typename?: 'ProposalStage', id: string, name?: string | null, mapData?: string | null, mapImage?: string | null, overallTotal?: string | null, distanceSeconds?: number | null, roundTripTravelTimeHours?: number | null, addressOverride?: string | null, ordering: number, proposalProducts?: Array<{ __typename?: 'ProposalProduct', notes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, jobDurationOverride?: number | null, jobDurationDaysOverride?: number | null, roundTripTravelTimeHours?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalOverride?: string | null, ordering: number, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, isOptional: boolean, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, costTotal?: string | null, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, id: string, name: string, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', chargeType: EquipmentPieceChargeType, cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: number | null, costMaterialOverride?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId: string, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, name: string, type: string, productionRateType?: ProductProductionRateType | null, subcontracted: boolean, unitPriceProduct: boolean, unitPrice?: number | null, unitPriceOverride?: number | null, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, name: string, plantTransferTruckId?: string | null, quantity: number, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, transferTruckId: string, trucksNeeded?: number | null, truckingProductionRate?: number | null, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, cost: number, costOverride?: number | null } | null> | null }> | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null }>, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, percentage: number, organizationSalesTaxId: string }> | null, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string }> | null, changeOrders?: Array<{ __typename?: 'Proposal', id: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, changeOrderJobId?: string | null }> | null, versions?: Array<{ __typename?: 'Proposal', id: string, version: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, activeVersion: boolean }> | null } };

export type CustomDuplicateProductMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomDuplicateProductMutation = { __typename?: 'Mutation', duplicateProduct: { __typename?: 'Product', id: string } };

export type CustomDuplicateProposalMutationVariables = Exact<{
  id: Scalars['ID'];
  isChangeOrder?: InputMaybe<Scalars['Boolean']>;
  startNewProposal?: InputMaybe<Scalars['Boolean']>;
  createNewVersion?: InputMaybe<Scalars['Boolean']>;
  changeOrderJobId?: InputMaybe<Scalars['ID']>;
}>;


export type CustomDuplicateProposalMutation = { __typename?: 'Mutation', duplicateProposal?: { __typename?: 'DuplicateProposalResponse', newProposal?: { __typename?: 'Proposal', id: string, uuid: string, activeVersion: boolean, contactId: string, status: ProposalStatus, source?: ProposalSource | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, externalId: string, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, profit: string, profitPercentage: number, proposalNotes?: string | null, createdAt: any, removeUnitPriceAndQuantity?: boolean | null, removeIndividualLineItemPricing?: boolean | null, isChangeOrder: boolean, userId?: string | null, costTaxes: string, overallTotalAfterTaxes: string, acceptanceOverride?: string | null, version: string, changeOrderJobId?: string | null, projectFilesFolderId?: string | null, clientEmailOverride?: string | null, emailSubjectOverride?: string | null, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, company: { __typename?: 'Company', id: string, name: string, contacts: Array<{ __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }> }, contact: { __typename?: 'Contact', firstName: string, lastName: string, email?: string | null }, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, email: string, id: string }>, stages: Array<{ __typename?: 'ProposalStage', id: string, name?: string | null, mapData?: string | null, mapImage?: string | null, overallTotal?: string | null, distanceSeconds?: number | null, roundTripTravelTimeHours?: number | null, addressOverride?: string | null, ordering: number, proposalProducts?: Array<{ __typename?: 'ProposalProduct', notes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, jobDurationOverride?: number | null, jobDurationDaysOverride?: number | null, roundTripTravelTimeHours?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalOverride?: string | null, ordering: number, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, isOptional: boolean, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, costTotal?: string | null, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, id: string, name: string, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', chargeType: EquipmentPieceChargeType, cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: number | null, costMaterialOverride?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId: string, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, name: string, type: string, productionRateType?: ProductProductionRateType | null, subcontracted: boolean, unitPriceProduct: boolean, unitPrice?: number | null, unitPriceOverride?: number | null, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, name: string, plantTransferTruckId?: string | null, quantity: number, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, transferTruckId: string, trucksNeeded?: number | null, truckingProductionRate?: number | null, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, cost: number, costOverride?: number | null } | null> | null }> | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null }>, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, percentage: number, organizationSalesTaxId: string }> | null, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string }> | null, changeOrders?: Array<{ __typename?: 'Proposal', id: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, changeOrderJobId?: string | null }> | null, versions?: Array<{ __typename?: 'Proposal', id: string, version: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, activeVersion: boolean }> | null } | null, proposal: { __typename?: 'Proposal', id: string, uuid: string, activeVersion: boolean, contactId: string, status: ProposalStatus, source?: ProposalSource | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, externalId: string, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, profit: string, profitPercentage: number, proposalNotes?: string | null, createdAt: any, removeUnitPriceAndQuantity?: boolean | null, removeIndividualLineItemPricing?: boolean | null, isChangeOrder: boolean, userId?: string | null, costTaxes: string, overallTotalAfterTaxes: string, acceptanceOverride?: string | null, version: string, changeOrderJobId?: string | null, projectFilesFolderId?: string | null, clientEmailOverride?: string | null, emailSubjectOverride?: string | null, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, company: { __typename?: 'Company', id: string, name: string, contacts: Array<{ __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }> }, contact: { __typename?: 'Contact', firstName: string, lastName: string, email?: string | null }, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, email: string, id: string }>, stages: Array<{ __typename?: 'ProposalStage', id: string, name?: string | null, mapData?: string | null, mapImage?: string | null, overallTotal?: string | null, distanceSeconds?: number | null, roundTripTravelTimeHours?: number | null, addressOverride?: string | null, ordering: number, proposalProducts?: Array<{ __typename?: 'ProposalProduct', notes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, jobDurationOverride?: number | null, jobDurationDaysOverride?: number | null, roundTripTravelTimeHours?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalOverride?: string | null, ordering: number, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, isOptional: boolean, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, costTotal?: string | null, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, id: string, name: string, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', chargeType: EquipmentPieceChargeType, cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: number | null, costMaterialOverride?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId: string, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, name: string, type: string, productionRateType?: ProductProductionRateType | null, subcontracted: boolean, unitPriceProduct: boolean, unitPrice?: number | null, unitPriceOverride?: number | null, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, name: string, plantTransferTruckId?: string | null, quantity: number, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, transferTruckId: string, trucksNeeded?: number | null, truckingProductionRate?: number | null, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, cost: number, costOverride?: number | null } | null> | null }> | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null }>, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, percentage: number, organizationSalesTaxId: string }> | null, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string }> | null, changeOrders?: Array<{ __typename?: 'Proposal', id: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, changeOrderJobId?: string | null }> | null, versions?: Array<{ __typename?: 'Proposal', id: string, version: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, activeVersion: boolean }> | null } } | null };

export type CustomScheduleCustomEventBlockMutationVariables = Exact<{
  input: ScheduleCustomEventBlockInput;
}>;


export type CustomScheduleCustomEventBlockMutation = { __typename?: 'Mutation', scheduleCustomEventBlock: { __typename?: 'CustomEvent', color?: string | null, endsAt?: any | null, id?: string | null, name?: string | null, notes?: string | null, startsAt?: any | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string } | null, customEventBlocks?: Array<{ __typename?: 'CustomEventBlock', blockLength?: number | null, endsAt?: any | null, id?: string | null, scheduledAt?: any | null } | null> | null, customEventsToUsers?: Array<{ __typename?: 'CustomEventsToUsers', user?: { __typename?: 'User', id: string } | null } | null> | null } };

export type CustomScheduleJobPhaseMutationVariables = Exact<{
  blocks: Array<InputMaybe<AddJobPhaseScheduleBlock>> | InputMaybe<AddJobPhaseScheduleBlock>;
  crewId?: InputMaybe<Scalars['ID']>;
  jobPhaseId: Scalars['ID'];
  travelTimeEstimate?: InputMaybe<Scalars['Float']>;
  userIDs?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  usersColor?: InputMaybe<Scalars['String']>;
}>;


export type CustomScheduleJobPhaseMutation = { __typename?: 'Mutation', scheduleJobPhase: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, endsAt?: any | null, id: string, notes?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobStatus, userId: string, foremanUser?: { __typename?: 'User', id: string, organization: { __typename?: 'Organization', id: string } } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null } | null> | null } };

export type CustomScheduleJobPhaseBlockMutationVariables = Exact<{
  input: ScheduleJobPhaseBlockInput;
}>;


export type CustomScheduleJobPhaseBlockMutation = { __typename?: 'Mutation', scheduleJobPhaseBlock: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, endsAt?: any | null, id: string, notes?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobStatus, userId: string, foremanUser?: { __typename?: 'User', id: string, organization: { __typename?: 'Organization', id: string } } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null } | null> | null } };

export type CustomSendProposalToSpecificRecipientsMutationVariables = Exact<{
  emails: Array<Scalars['String']> | Scalars['String'];
  proposalId: Scalars['ID'];
}>;


export type CustomSendProposalToSpecificRecipientsMutation = { __typename?: 'Mutation', sendProposalToSpecificRecipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, email: string, id: string }> };

export type CustomSetProposalToDraftMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomSetProposalToDraftMutation = { __typename?: 'Mutation', setProposalToDraft: { __typename?: 'Proposal', id: string, uuid: string, activeVersion: boolean, contactId: string, status: ProposalStatus, source?: ProposalSource | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, externalId: string, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, profit: string, profitPercentage: number, proposalNotes?: string | null, createdAt: any, removeUnitPriceAndQuantity?: boolean | null, removeIndividualLineItemPricing?: boolean | null, isChangeOrder: boolean, userId?: string | null, costTaxes: string, overallTotalAfterTaxes: string, acceptanceOverride?: string | null, version: string, changeOrderJobId?: string | null, projectFilesFolderId?: string | null, clientEmailOverride?: string | null, emailSubjectOverride?: string | null, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, company: { __typename?: 'Company', id: string, name: string, contacts: Array<{ __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }> }, contact: { __typename?: 'Contact', firstName: string, lastName: string, email?: string | null }, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, email: string, id: string }>, stages: Array<{ __typename?: 'ProposalStage', id: string, name?: string | null, mapData?: string | null, mapImage?: string | null, overallTotal?: string | null, distanceSeconds?: number | null, roundTripTravelTimeHours?: number | null, addressOverride?: string | null, ordering: number, proposalProducts?: Array<{ __typename?: 'ProposalProduct', notes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, jobDurationOverride?: number | null, jobDurationDaysOverride?: number | null, roundTripTravelTimeHours?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalOverride?: string | null, ordering: number, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, isOptional: boolean, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, costTotal?: string | null, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, id: string, name: string, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', chargeType: EquipmentPieceChargeType, cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: number | null, costMaterialOverride?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId: string, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, name: string, type: string, productionRateType?: ProductProductionRateType | null, subcontracted: boolean, unitPriceProduct: boolean, unitPrice?: number | null, unitPriceOverride?: number | null, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, name: string, plantTransferTruckId?: string | null, quantity: number, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, transferTruckId: string, trucksNeeded?: number | null, truckingProductionRate?: number | null, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, cost: number, costOverride?: number | null } | null> | null }> | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null }>, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, percentage: number, organizationSalesTaxId: string }> | null, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string }> | null, changeOrders?: Array<{ __typename?: 'Proposal', id: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, changeOrderJobId?: string | null }> | null, versions?: Array<{ __typename?: 'Proposal', id: string, version: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, activeVersion: boolean }> | null } };

export type CustomSetProposalToWonMutationVariables = Exact<{
  id: Scalars['ID'];
  forceSend?: InputMaybe<Scalars['Boolean']>;
}>;


export type CustomSetProposalToWonMutation = { __typename?: 'Mutation', setProposalToWon: { __typename?: 'Proposal', id: string, uuid: string, activeVersion: boolean, contactId: string, status: ProposalStatus, source?: ProposalSource | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, externalId: string, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, profit: string, profitPercentage: number, proposalNotes?: string | null, createdAt: any, removeUnitPriceAndQuantity?: boolean | null, removeIndividualLineItemPricing?: boolean | null, isChangeOrder: boolean, userId?: string | null, costTaxes: string, overallTotalAfterTaxes: string, acceptanceOverride?: string | null, version: string, changeOrderJobId?: string | null, projectFilesFolderId?: string | null, clientEmailOverride?: string | null, emailSubjectOverride?: string | null, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, company: { __typename?: 'Company', id: string, name: string, contacts: Array<{ __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }> }, contact: { __typename?: 'Contact', firstName: string, lastName: string, email?: string | null }, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, email: string, id: string }>, stages: Array<{ __typename?: 'ProposalStage', id: string, name?: string | null, mapData?: string | null, mapImage?: string | null, overallTotal?: string | null, distanceSeconds?: number | null, roundTripTravelTimeHours?: number | null, addressOverride?: string | null, ordering: number, proposalProducts?: Array<{ __typename?: 'ProposalProduct', notes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, jobDurationOverride?: number | null, jobDurationDaysOverride?: number | null, roundTripTravelTimeHours?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalOverride?: string | null, ordering: number, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, isOptional: boolean, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, costTotal?: string | null, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, id: string, name: string, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', chargeType: EquipmentPieceChargeType, cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: number | null, costMaterialOverride?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId: string, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, name: string, type: string, productionRateType?: ProductProductionRateType | null, subcontracted: boolean, unitPriceProduct: boolean, unitPrice?: number | null, unitPriceOverride?: number | null, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, name: string, plantTransferTruckId?: string | null, quantity: number, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, transferTruckId: string, trucksNeeded?: number | null, truckingProductionRate?: number | null, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, cost: number, costOverride?: number | null } | null> | null }> | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null }>, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, percentage: number, organizationSalesTaxId: string }> | null, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string }> | null, changeOrders?: Array<{ __typename?: 'Proposal', id: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, changeOrderJobId?: string | null }> | null, versions?: Array<{ __typename?: 'Proposal', id: string, version: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, activeVersion: boolean }> | null } };

export type CustomUnscheduleCustomEventMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomUnscheduleCustomEventMutation = { __typename?: 'Mutation', unscheduleCustomEvent: { __typename?: 'CustomEvent', color?: string | null, endsAt?: any | null, id?: string | null, name?: string | null, notes?: string | null, startsAt?: any | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string } | null, customEventBlocks?: Array<{ __typename?: 'CustomEventBlock', blockLength?: number | null, endsAt?: any | null, id?: string | null, scheduledAt?: any | null } | null> | null, customEventsToUsers?: Array<{ __typename?: 'CustomEventsToUsers', user?: { __typename?: 'User', id: string } | null } | null> | null } };

export type CustomUnscheduleJobPhaseMutationVariables = Exact<{
  jobPhaseId: Scalars['ID'];
}>;


export type CustomUnscheduleJobPhaseMutation = { __typename?: 'Mutation', unscheduleJobPhase: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, endsAt?: any | null, id: string, notes?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobStatus, userId: string, foremanUser?: { __typename?: 'User', id: string, organization: { __typename?: 'Organization', id: string } } | null, jobPhases?: Array<{ __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null } | null> | null } };

export type CustomUpdateCustomEventMutationVariables = Exact<{
  input?: InputMaybe<UpdateCustomEventInput>;
}>;


export type CustomUpdateCustomEventMutation = { __typename?: 'Mutation', updateCustomEvent?: { __typename?: 'CustomEvent', color?: string | null, endsAt?: any | null, id?: string | null, name?: string | null, notes?: string | null, startsAt?: any | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string } | null, customEventBlocks?: Array<{ __typename?: 'CustomEventBlock', blockLength?: number | null, endsAt?: any | null, id?: string | null, scheduledAt?: any | null } | null> | null, customEventsToUsers?: Array<{ __typename?: 'CustomEventsToUsers', user?: { __typename?: 'User', id: string } | null } | null> | null } | null };

export type CustomUpdateJobNotesMutationVariables = Exact<{
  id: Scalars['ID'];
  notes: Scalars['String'];
}>;


export type CustomUpdateJobNotesMutation = { __typename?: 'Mutation', updateJobNotes?: { __typename?: 'Job', id: string, notes?: string | null } | null };

export type CustomUpdateJobPhaseNotesMutationVariables = Exact<{
  input: UpdateJobPhaseNotesInput;
}>;


export type CustomUpdateJobPhaseNotesMutation = { __typename?: 'Mutation', updateJobPhaseNotes: { __typename?: 'JobPhase', id: string, externalId: string, actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualCostTransferTruck: string, address: string, applicableStatuses?: Array<string> | null, productName: string, endsAt?: any | null, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, proposedCostTransferTruck: string, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, transferTruckId?: string | null, quantity?: number | null, name: string, tonnage: number, rateTon: number, rateHourly: number } | null> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, name?: string | null, type?: string | null, plant?: { __typename?: 'Plant', id: string, addressLine1: string, addressLine2?: string | null, addressCity: string, addressState: string, addressZip: string, addressCountry: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string } | null } | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', date: any, costMaterial: number, costEquipment: number, costLabour: number, costAdditional: number, costTransferTruck: number, id: string, plantId?: string | null, plantProductId?: string | null, user?: { __typename?: 'User', name: string } | null, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', id: string, plantId?: string | null, plantProductId?: string | null } } | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', id: string, plantId?: string | null, plantProductId?: string | null, date: any, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', id: string }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType } | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number }> | null } }> | null, jobPhase: { __typename?: 'JobPhase', endsAt?: any | null, id: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, rate: number }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, id: string, inviteToken?: string | null, invitedAt?: any | null, lastName?: string | null, name: string, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, productName?: string | null, profit: string, profitPercentage: number, costTransferTruck: string, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, material: { __typename?: 'ProposalMaterial', id: string, productId: string, name: string }, crews?: Array<{ __typename?: 'ProposalCrew', cost: string }> | null, plantProduct?: { __typename?: 'ProposalPlantProduct', type: string, plantProductId: string, plant: { __typename?: 'ProposalPlant', name: string, addressLine1: string, addressLine2?: string | null, addressCity: string, addressState: string, addressZip: string, addressCountry: string } } | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', estimatedMaterialOverride?: number | null, estimatedMaterial?: number | null, blockLength: number, endsAt: any, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> }, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, rate: number }>, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', name: string, cost: number, id: string, feeAmount: number, feeType: AdditionalCostFeeType }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, foremanUser?: { __typename?: 'User', id: string, name: string, phone?: string | null } | null, job: { __typename?: 'Job', externalId: string, actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, endsAt?: any | null, id: string, notes?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobStatus, billingStatus?: JobBillingStatus | null, userId: string, company: { __typename?: 'Company', id: string, name: string, phone?: string | null }, contact: { __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, title?: string | null } }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, id: string, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, profit: string, profitPercentage: number, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementMaterial?: ProductMeasurementMaterial | null, measurementJob?: ProductMeasurementJob | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, productName?: string | null, profit: string, profitPercentage: number, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, statementOfWork?: string | null, material: { __typename?: 'ProposalMaterial', id: string, name: string, externalProductName?: string | null, materialNeeded?: number | null, materialNeededOverride?: number | null, productId: string }, plantProduct?: { __typename?: 'ProposalPlantProduct', type: string, plantProductId: string, plant: { __typename?: 'ProposalPlant', plantId: string, addressLine1: string, addressLine2?: string | null, addressCity: string, addressState: string, addressZip: string, addressCountry: string } } | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', id: string, equipmentPieceId?: string | null, name: string, rate: number, timeTravel: number, timeTravelOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null }> | null, crews?: Array<{ __typename?: 'ProposalCrew', id: string, crewId?: string | null, name: string, rate: number, timeOnjob: number, timeOnjobOverride?: number | null }> | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', id: string, additionalCostId?: string | null, name: string, cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, quantity?: number | null, quantityOverride?: number | null } | null> | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, transferTruckId: string, name: string, tonnage: number, quantity: number, trucksNeeded?: number | null } | null> | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', estimatedMaterialOverride?: number | null, estimatedMaterial?: number | null, blockLength: number, endsAt: any, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean }>, organization: { __typename?: 'Organization', id: string, name: string, logo?: string | null }, crew?: { __typename?: 'Crew', id: string, color: string, displayName?: string | null } | null, users?: Array<{ __typename?: 'User', id: string }> | null, proposalStage: { __typename?: 'ProposalStage', name?: string | null } } };

export type CustomUpdateJobProjectManagerMutationVariables = Exact<{
  id: Scalars['ID'];
  userId: Scalars['ID'];
}>;


export type CustomUpdateJobProjectManagerMutation = { __typename?: 'Mutation', updateJobProjectManager: { __typename?: 'Job', id: string, userId: string } };

export type CustomUpdateNotificationTriggerMutationVariables = Exact<{
  input: UpdateNotificationTriggerInput;
}>;


export type CustomUpdateNotificationTriggerMutation = { __typename?: 'Mutation', updateNotificationTrigger?: { __typename?: 'NotificationTrigger', id: string, name: string, active: boolean, delay: number, event: NotificationTriggerEvent, type: NotificationTriggerType, content: string, sendToUser: boolean, sendToAllRecipients: boolean, sendToContact: boolean, additionalRecipientTypes?: Array<NotificationTriggerAdditionalRecipientTypes> | null, isEmail?: boolean | null, isSMS?: boolean | null, smsContent?: string | null, emailSubject?: string | null, additionalRecipients: Array<{ __typename?: 'NotificationTriggerRecipient', id: string, firstName: string, lastName: string }> } | null };

export type CustomUpdateProposalMutationVariables = Exact<{
  id: Scalars['ID'];
  companyId: Scalars['ID'];
  contactId: Scalars['ID'];
  source?: InputMaybe<ProposalSource>;
}>;


export type CustomUpdateProposalMutation = { __typename?: 'Mutation', updateProposal: { __typename?: 'Proposal', id: string, uuid: string, activeVersion: boolean, contactId: string, status: ProposalStatus, source?: ProposalSource | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, externalId: string, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, profit: string, profitPercentage: number, proposalNotes?: string | null, createdAt: any, removeUnitPriceAndQuantity?: boolean | null, removeIndividualLineItemPricing?: boolean | null, isChangeOrder: boolean, userId?: string | null, costTaxes: string, overallTotalAfterTaxes: string, acceptanceOverride?: string | null, version: string, changeOrderJobId?: string | null, projectFilesFolderId?: string | null, clientEmailOverride?: string | null, emailSubjectOverride?: string | null, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, company: { __typename?: 'Company', id: string, name: string, contacts: Array<{ __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }> }, contact: { __typename?: 'Contact', firstName: string, lastName: string, email?: string | null }, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, email: string, id: string }>, stages: Array<{ __typename?: 'ProposalStage', id: string, name?: string | null, mapData?: string | null, mapImage?: string | null, overallTotal?: string | null, distanceSeconds?: number | null, roundTripTravelTimeHours?: number | null, addressOverride?: string | null, ordering: number, proposalProducts?: Array<{ __typename?: 'ProposalProduct', notes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, jobDurationOverride?: number | null, jobDurationDaysOverride?: number | null, roundTripTravelTimeHours?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalOverride?: string | null, ordering: number, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, isOptional: boolean, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, costTotal?: string | null, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, id: string, name: string, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', chargeType: EquipmentPieceChargeType, cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: number | null, costMaterialOverride?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId: string, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, name: string, type: string, productionRateType?: ProductProductionRateType | null, subcontracted: boolean, unitPriceProduct: boolean, unitPrice?: number | null, unitPriceOverride?: number | null, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, name: string, plantTransferTruckId?: string | null, quantity: number, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, transferTruckId: string, trucksNeeded?: number | null, truckingProductionRate?: number | null, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, cost: number, costOverride?: number | null } | null> | null }> | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null }>, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, percentage: number, organizationSalesTaxId: string }> | null, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string }> | null, changeOrders?: Array<{ __typename?: 'Proposal', id: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, changeOrderJobId?: string | null }> | null, versions?: Array<{ __typename?: 'Proposal', id: string, version: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, activeVersion: boolean }> | null } };

export type CustomUpdateProposalInfoMutationVariables = Exact<{
  input?: InputMaybe<UpdateProposalInfoInput>;
}>;


export type CustomUpdateProposalInfoMutation = { __typename?: 'Mutation', updateProposalInfo: { __typename?: 'Proposal', id: string, uuid: string, activeVersion: boolean, contactId: string, status: ProposalStatus, source?: ProposalSource | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, externalId: string, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, profit: string, profitPercentage: number, proposalNotes?: string | null, createdAt: any, removeUnitPriceAndQuantity?: boolean | null, removeIndividualLineItemPricing?: boolean | null, isChangeOrder: boolean, userId?: string | null, costTaxes: string, overallTotalAfterTaxes: string, acceptanceOverride?: string | null, version: string, changeOrderJobId?: string | null, projectFilesFolderId?: string | null, clientEmailOverride?: string | null, emailSubjectOverride?: string | null, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, company: { __typename?: 'Company', id: string, name: string, contacts: Array<{ __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }> }, contact: { __typename?: 'Contact', firstName: string, lastName: string, email?: string | null }, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, email: string, id: string }>, stages: Array<{ __typename?: 'ProposalStage', id: string, name?: string | null, mapData?: string | null, mapImage?: string | null, overallTotal?: string | null, distanceSeconds?: number | null, roundTripTravelTimeHours?: number | null, addressOverride?: string | null, ordering: number, proposalProducts?: Array<{ __typename?: 'ProposalProduct', notes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, jobDurationOverride?: number | null, jobDurationDaysOverride?: number | null, roundTripTravelTimeHours?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalOverride?: string | null, ordering: number, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, isOptional: boolean, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, costTotal?: string | null, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, id: string, name: string, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', chargeType: EquipmentPieceChargeType, cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: number | null, costMaterialOverride?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId: string, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, name: string, type: string, productionRateType?: ProductProductionRateType | null, subcontracted: boolean, unitPriceProduct: boolean, unitPrice?: number | null, unitPriceOverride?: number | null, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, name: string, plantTransferTruckId?: string | null, quantity: number, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, transferTruckId: string, trucksNeeded?: number | null, truckingProductionRate?: number | null, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, cost: number, costOverride?: number | null } | null> | null }> | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null }>, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, percentage: number, organizationSalesTaxId: string }> | null, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string }> | null, changeOrders?: Array<{ __typename?: 'Proposal', id: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, changeOrderJobId?: string | null }> | null, versions?: Array<{ __typename?: 'Proposal', id: string, version: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, activeVersion: boolean }> | null } };

export type CustomUpdateProposalPlantProductMutationVariables = Exact<{
  plantProductId: Scalars['ID'];
  proposalProductId: Scalars['ID'];
}>;


export type CustomUpdateProposalPlantProductMutation = { __typename?: 'Mutation', updateProposalPlantProduct: { __typename?: 'Proposal', id: string, uuid: string, activeVersion: boolean, contactId: string, status: ProposalStatus, source?: ProposalSource | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, externalId: string, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, profit: string, profitPercentage: number, proposalNotes?: string | null, createdAt: any, removeUnitPriceAndQuantity?: boolean | null, removeIndividualLineItemPricing?: boolean | null, isChangeOrder: boolean, userId?: string | null, costTaxes: string, overallTotalAfterTaxes: string, acceptanceOverride?: string | null, version: string, changeOrderJobId?: string | null, projectFilesFolderId?: string | null, clientEmailOverride?: string | null, emailSubjectOverride?: string | null, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, company: { __typename?: 'Company', id: string, name: string, contacts: Array<{ __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }> }, contact: { __typename?: 'Contact', firstName: string, lastName: string, email?: string | null }, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, email: string, id: string }>, stages: Array<{ __typename?: 'ProposalStage', id: string, name?: string | null, mapData?: string | null, mapImage?: string | null, overallTotal?: string | null, distanceSeconds?: number | null, roundTripTravelTimeHours?: number | null, addressOverride?: string | null, ordering: number, proposalProducts?: Array<{ __typename?: 'ProposalProduct', notes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, jobDurationOverride?: number | null, jobDurationDaysOverride?: number | null, roundTripTravelTimeHours?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalOverride?: string | null, ordering: number, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, isOptional: boolean, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, costTotal?: string | null, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, id: string, name: string, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', chargeType: EquipmentPieceChargeType, cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: number | null, costMaterialOverride?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId: string, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, name: string, type: string, productionRateType?: ProductProductionRateType | null, subcontracted: boolean, unitPriceProduct: boolean, unitPrice?: number | null, unitPriceOverride?: number | null, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, name: string, plantTransferTruckId?: string | null, quantity: number, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, transferTruckId: string, trucksNeeded?: number | null, truckingProductionRate?: number | null, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, cost: number, costOverride?: number | null } | null> | null }> | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null }>, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, percentage: number, organizationSalesTaxId: string }> | null, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string }> | null, changeOrders?: Array<{ __typename?: 'Proposal', id: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, changeOrderJobId?: string | null }> | null, versions?: Array<{ __typename?: 'Proposal', id: string, version: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, activeVersion: boolean }> | null } };

export type CustomUpdateProposalProductMutationVariables = Exact<{
  input: UpdateProposalProductInput;
}>;


export type CustomUpdateProposalProductMutation = { __typename?: 'Mutation', updateProposalProduct: { __typename?: 'Proposal', id: string, uuid: string, activeVersion: boolean, contactId: string, status: ProposalStatus, source?: ProposalSource | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, externalId: string, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, profit: string, profitPercentage: number, proposalNotes?: string | null, createdAt: any, removeUnitPriceAndQuantity?: boolean | null, removeIndividualLineItemPricing?: boolean | null, isChangeOrder: boolean, userId?: string | null, costTaxes: string, overallTotalAfterTaxes: string, acceptanceOverride?: string | null, version: string, changeOrderJobId?: string | null, projectFilesFolderId?: string | null, clientEmailOverride?: string | null, emailSubjectOverride?: string | null, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, company: { __typename?: 'Company', id: string, name: string, contacts: Array<{ __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }> }, contact: { __typename?: 'Contact', firstName: string, lastName: string, email?: string | null }, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, email: string, id: string }>, stages: Array<{ __typename?: 'ProposalStage', id: string, name?: string | null, mapData?: string | null, mapImage?: string | null, overallTotal?: string | null, distanceSeconds?: number | null, roundTripTravelTimeHours?: number | null, addressOverride?: string | null, ordering: number, proposalProducts?: Array<{ __typename?: 'ProposalProduct', notes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, jobDurationOverride?: number | null, jobDurationDaysOverride?: number | null, roundTripTravelTimeHours?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalOverride?: string | null, ordering: number, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, isOptional: boolean, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, costTotal?: string | null, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, id: string, name: string, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', chargeType: EquipmentPieceChargeType, cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: number | null, costMaterialOverride?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId: string, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, name: string, type: string, productionRateType?: ProductProductionRateType | null, subcontracted: boolean, unitPriceProduct: boolean, unitPrice?: number | null, unitPriceOverride?: number | null, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, name: string, plantTransferTruckId?: string | null, quantity: number, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, transferTruckId: string, trucksNeeded?: number | null, truckingProductionRate?: number | null, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, cost: number, costOverride?: number | null } | null> | null }> | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null }>, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, percentage: number, organizationSalesTaxId: string }> | null, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string }> | null, changeOrders?: Array<{ __typename?: 'Proposal', id: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, changeOrderJobId?: string | null }> | null, versions?: Array<{ __typename?: 'Proposal', id: string, version: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, activeVersion: boolean }> | null } };

export type CustomUpdateProposalStageMutationVariables = Exact<{
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  mapData?: InputMaybe<Scalars['String']>;
  addressOverride?: InputMaybe<Scalars['String']>;
}>;


export type CustomUpdateProposalStageMutation = { __typename?: 'Mutation', updateProposalStage: { __typename?: 'ProposalStage', id: string, name?: string | null, mapData?: string | null, mapImage?: string | null, overallTotal?: string | null, distanceSeconds?: number | null, roundTripTravelTimeHours?: number | null, addressOverride?: string | null, ordering: number, proposalProducts?: Array<{ __typename?: 'ProposalProduct', notes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, jobDurationOverride?: number | null, jobDurationDaysOverride?: number | null, roundTripTravelTimeHours?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalOverride?: string | null, ordering: number, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, isOptional: boolean, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, costTotal?: string | null, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, id: string, name: string, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', chargeType: EquipmentPieceChargeType, cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: number | null, costMaterialOverride?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId: string, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, name: string, type: string, productionRateType?: ProductProductionRateType | null, subcontracted: boolean, unitPriceProduct: boolean, unitPrice?: number | null, unitPriceOverride?: number | null, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, name: string, plantTransferTruckId?: string | null, quantity: number, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, transferTruckId: string, trucksNeeded?: number | null, truckingProductionRate?: number | null, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, cost: number, costOverride?: number | null } | null> | null }> | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null } };

export type CustomGetAllCrewsQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomGetAllCrewsQuery = { __typename?: 'Query', getAllCrews: Array<{ __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number, employees?: Array<{ __typename?: 'Employee', id: string }> | null, foremanUser?: { __typename?: 'User', id: string, name: string } | null, organization: { __typename?: 'Organization', id: string } }> };

export type CustomGetCompaniesQueryVariables = Exact<{
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<GetCompaniesSortKey>;
}>;


export type CustomGetCompaniesQuery = { __typename?: 'Query', getCompanies: { __typename?: 'GetCompaniesResponse', data: Array<{ __typename?: 'Company', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, addCompanyInfo?: boolean | null, projectFilesFolderId?: string | null, email: string, id: string, jobsCount?: number | null, name: string, notes?: string | null, phone?: string | null, proposalsCount?: number | null, website?: string | null, logo?: string | null, status: CompanyStatus, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null }>, paginatorInfo: { __typename?: 'CustomPaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type CustomGetCompaniesForFilterQueryVariables = Exact<{
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<GetCompaniesSortKey>;
}>;


export type CustomGetCompaniesForFilterQuery = { __typename?: 'Query', getCompanies: { __typename?: 'GetCompaniesResponse', data: Array<{ __typename?: 'Company', id: string, name: string }>, paginatorInfo: { __typename?: 'CustomPaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type CustomGetCompanyQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomGetCompanyQuery = { __typename?: 'Query', getCompany?: { __typename?: 'Company', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, addCompanyInfo?: boolean | null, projectFilesFolderId?: string | null, email: string, id: string, jobsCount?: number | null, name: string, notes?: string | null, phone?: string | null, proposalsCount?: number | null, website?: string | null, logo?: string | null, status: CompanyStatus, contacts: Array<{ __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }>, primaryContact?: { __typename?: 'Contact', SMSNotifications?: boolean | null, SMSNotificationsReadOnly?: boolean | null, email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null } | null, notificationTypes?: { __typename?: 'NotificationTypeOptions', CONTACT?: boolean | null, JOB?: boolean | null, JOB_PHASE?: boolean | null, OPPORTUNITY?: boolean | null, PROPOSAL?: boolean | null } | null } | null };

export type CustomGetCustomEventQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomGetCustomEventQuery = { __typename?: 'Query', getCustomEvent?: { __typename?: 'CustomEvent', color?: string | null, endsAt?: any | null, id?: string | null, name?: string | null, notes?: string | null, startsAt?: any | null, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string } | null, customEventBlocks?: Array<{ __typename?: 'CustomEventBlock', blockLength?: number | null, endsAt?: any | null, id?: string | null, scheduledAt?: any | null } | null> | null, customEventsToUsers?: Array<{ __typename?: 'CustomEventsToUsers', user?: { __typename?: 'User', id: string } | null } | null> | null } | null };

export type CustomGetCustomEventBlocksQueryVariables = Exact<{
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateUntil?: InputMaybe<Scalars['DateTime']>;
  crewId?: InputMaybe<Scalars['ID']>;
  customEventIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type CustomGetCustomEventBlocksQuery = { __typename?: 'Query', getCustomEventBlocks: Array<{ __typename?: 'CustomEventBlock', blockLength?: number | null, endsAt?: any | null, id?: string | null, scheduledAt?: any | null, customEvent?: { __typename?: 'CustomEvent', color?: string | null, endsAt?: any | null, id?: string | null, name?: string | null, notes?: string | null, startsAt?: any | null, crew?: { __typename?: 'Crew', color: string, id: string, name: string } | null, customEventsToUsers?: Array<{ __typename?: 'CustomEventsToUsers', user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } | null> | null } | null }> };

export type CustomGetDashboardMapDataQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomGetDashboardMapDataQuery = { __typename?: 'Query', getDashboardMapData: Array<{ __typename?: 'Job', id: string, status: JobStatus, jobPhases?: Array<{ __typename?: 'JobPhase', id: string, status: JobPhaseStatus, startsAt?: any | null, productName: string } | null> | null, proposalStage?: { __typename?: 'ProposalStage', id: string, name?: string | null } | null, address: { __typename?: 'ProposalAddress', latitude: string, longitude: string } } | null> };

export type CustomGetJobQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomGetJobQuery = { __typename?: 'Query', getJob: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualCostTransferTruck: string, actualProfitPercentage: number, datePushedToQuickbooks?: any | null, billingStatus?: JobBillingStatus | null, projectFilesFolderId?: string | null, proposalId: string, userId: string, endsAt?: any | null, id: string, externalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedCostTransferTruck: string, proposedProfitPercentage: number, startsAt?: any | null, shouldPushTaxesToQuickbooks?: boolean | null, mayShowTaxNotification?: boolean | null, status: JobStatus, notes?: string | null, address: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, organizationAddressId?: string | null, state?: string | null, zip?: string | null, mapImage?: string | null }, company: { __typename?: 'Company', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, email: string, id: string, name: string, notes?: string | null, phone?: string | null, website?: string | null }, contact: { __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }, jobPhases?: Array<{ __typename?: 'JobPhase', id: string, externalId: string, actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualCostTransferTruck: string, address: string, applicableStatuses?: Array<string> | null, productName: string, endsAt?: any | null, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, proposedCostTransferTruck: string, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, transferTruckId?: string | null, quantity?: number | null, name: string, tonnage: number, rateTon: number, rateHourly: number } | null> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, name?: string | null, type?: string | null, plant?: { __typename?: 'Plant', id: string, addressLine1: string, addressLine2?: string | null, addressCity: string, addressState: string, addressZip: string, addressCountry: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string } | null } | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', date: any, costMaterial: number, costEquipment: number, costLabour: number, costAdditional: number, costTransferTruck: number, id: string, plantId?: string | null, plantProductId?: string | null, user?: { __typename?: 'User', name: string } | null, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', id: string, plantId?: string | null, plantProductId?: string | null } } | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', id: string, plantId?: string | null, plantProductId?: string | null, date: any, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', id: string }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType } | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number }> | null } }> | null, jobPhase: { __typename?: 'JobPhase', endsAt?: any | null, id: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, rate: number }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, id: string, inviteToken?: string | null, invitedAt?: any | null, lastName?: string | null, name: string, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, productName?: string | null, profit: string, profitPercentage: number, costTransferTruck: string, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, material: { __typename?: 'ProposalMaterial', id: string, productId: string, name: string }, crews?: Array<{ __typename?: 'ProposalCrew', cost: string }> | null, plantProduct?: { __typename?: 'ProposalPlantProduct', type: string, plantProductId: string, plant: { __typename?: 'ProposalPlant', name: string, addressLine1: string, addressLine2?: string | null, addressCity: string, addressState: string, addressZip: string, addressCountry: string } } | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', estimatedMaterialOverride?: number | null, estimatedMaterial?: number | null, blockLength: number, endsAt: any, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> }, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, rate: number }>, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', name: string, cost: number, id: string, feeAmount: number, feeType: AdditionalCostFeeType }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, foremanUser?: { __typename?: 'User', id: string, name: string, phone?: string | null } | null, job: { __typename?: 'Job', externalId: string, actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, endsAt?: any | null, id: string, notes?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobStatus, billingStatus?: JobBillingStatus | null, userId: string, company: { __typename?: 'Company', id: string, name: string, phone?: string | null }, contact: { __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, title?: string | null } }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, id: string, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, profit: string, profitPercentage: number, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementMaterial?: ProductMeasurementMaterial | null, measurementJob?: ProductMeasurementJob | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, productName?: string | null, profit: string, profitPercentage: number, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, statementOfWork?: string | null, material: { __typename?: 'ProposalMaterial', id: string, name: string, externalProductName?: string | null, materialNeeded?: number | null, materialNeededOverride?: number | null, productId: string }, plantProduct?: { __typename?: 'ProposalPlantProduct', type: string, plantProductId: string, plant: { __typename?: 'ProposalPlant', plantId: string, addressLine1: string, addressLine2?: string | null, addressCity: string, addressState: string, addressZip: string, addressCountry: string } } | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', id: string, equipmentPieceId?: string | null, name: string, rate: number, timeTravel: number, timeTravelOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null }> | null, crews?: Array<{ __typename?: 'ProposalCrew', id: string, crewId?: string | null, name: string, rate: number, timeOnjob: number, timeOnjobOverride?: number | null }> | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', id: string, additionalCostId?: string | null, name: string, cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, quantity?: number | null, quantityOverride?: number | null } | null> | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, transferTruckId: string, name: string, tonnage: number, quantity: number, trucksNeeded?: number | null } | null> | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', estimatedMaterialOverride?: number | null, estimatedMaterial?: number | null, blockLength: number, endsAt: any, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean }>, organization: { __typename?: 'Organization', id: string, name: string, logo?: string | null }, crew?: { __typename?: 'Crew', id: string, color: string, displayName?: string | null } | null, users?: Array<{ __typename?: 'User', id: string }> | null, proposalStage: { __typename?: 'ProposalStage', name?: string | null } } | null> | null, proposalStage?: { __typename?: 'ProposalStage', id: string, name?: string | null } | null, proposal?: { __typename?: 'Proposal', id: string, isChangeOrder: boolean, status: ProposalStatus } | null, changeOrders?: Array<{ __typename?: 'Proposal', id: string, changeOrderJobId?: string | null, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string }> | null } };

export type CustomGetJobPhaseQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomGetJobPhaseQuery = { __typename?: 'Query', getJobPhase: { __typename?: 'JobPhase', id: string, externalId: string, actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, actualCostTransferTruck: string, address: string, applicableStatuses?: Array<string> | null, productName: string, endsAt?: any | null, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, proposedCostTransferTruck: string, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, usersColor?: string | null, workOrderCrews?: Array<{ __typename?: 'WorkOrderCrew', crewId?: string | null, id: string, name?: string | null } | null> | null, workOrderTransferTrucks?: Array<{ __typename?: 'WorkOrderTransferTruck', id: string, transferTruckId?: string | null, quantity?: number | null, name: string, tonnage: number, rateTon: number, rateHourly: number } | null> | null, jobPhasePlant?: { __typename?: 'JobPhasePlant', id: string, name?: string | null, type?: string | null, plant?: { __typename?: 'Plant', id: string, addressLine1: string, addressLine2?: string | null, addressCity: string, addressState: string, addressZip: string, addressCountry: string } | null, plantProduct?: { __typename?: 'PlantProduct', id: string } | null } | null, workOrderEquipmentPieces?: Array<{ __typename?: 'WorkOrderEquipmentPiece', equipmentPieceId?: string | null, id: string, name?: string | null } | null> | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', date: any, costMaterial: number, costEquipment: number, costLabour: number, costAdditional: number, costTransferTruck: number, id: string, plantId?: string | null, plantProductId?: string | null, user?: { __typename?: 'User', name: string } | null, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', id: string, plantId?: string | null, plantProductId?: string | null } } | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', id: string, plantId?: string | null, plantProductId?: string | null, date: any, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', id: string }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType } | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number }> | null } }> | null, jobPhase: { __typename?: 'JobPhase', endsAt?: any | null, id: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, rate: number }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, id: string, inviteToken?: string | null, invitedAt?: any | null, lastName?: string | null, name: string, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, productName?: string | null, profit: string, profitPercentage: number, costTransferTruck: string, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, material: { __typename?: 'ProposalMaterial', id: string, productId: string, name: string }, crews?: Array<{ __typename?: 'ProposalCrew', cost: string }> | null, plantProduct?: { __typename?: 'ProposalPlantProduct', type: string, plantProductId: string, plant: { __typename?: 'ProposalPlant', name: string, addressLine1: string, addressLine2?: string | null, addressCity: string, addressState: string, addressZip: string, addressCountry: string } } | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', estimatedMaterialOverride?: number | null, estimatedMaterial?: number | null, blockLength: number, endsAt: any, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> }, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, rate: number }>, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', name: string, cost: number, id: string, feeAmount: number, feeType: AdditionalCostFeeType }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, foremanUser?: { __typename?: 'User', id: string, name: string, phone?: string | null } | null, job: { __typename?: 'Job', externalId: string, actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, endsAt?: any | null, id: string, notes?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobStatus, billingStatus?: JobBillingStatus | null, userId: string, company: { __typename?: 'Company', id: string, name: string, phone?: string | null }, contact: { __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, title?: string | null } }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, id: string, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, profit: string, profitPercentage: number, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementMaterial?: ProductMeasurementMaterial | null, measurementJob?: ProductMeasurementJob | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, productName?: string | null, profit: string, profitPercentage: number, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, statementOfWork?: string | null, material: { __typename?: 'ProposalMaterial', id: string, name: string, externalProductName?: string | null, materialNeeded?: number | null, materialNeededOverride?: number | null, productId: string }, plantProduct?: { __typename?: 'ProposalPlantProduct', type: string, plantProductId: string, plant: { __typename?: 'ProposalPlant', plantId: string, addressLine1: string, addressLine2?: string | null, addressCity: string, addressState: string, addressZip: string, addressCountry: string } } | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null, type?: string | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', id: string, equipmentPieceId?: string | null, name: string, rate: number, timeTravel: number, timeTravelOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null }> | null, crews?: Array<{ __typename?: 'ProposalCrew', id: string, crewId?: string | null, name: string, rate: number, timeOnjob: number, timeOnjobOverride?: number | null }> | null, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', id: string, additionalCostId?: string | null, name: string, cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, quantity?: number | null, quantityOverride?: number | null } | null> | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, transferTruckId: string, name: string, tonnage: number, quantity: number, trucksNeeded?: number | null } | null> | null }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', estimatedMaterialOverride?: number | null, estimatedMaterial?: number | null, blockLength: number, endsAt: any, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean }>, organization: { __typename?: 'Organization', id: string, name: string, logo?: string | null }, crew?: { __typename?: 'Crew', id: string, color: string, displayName?: string | null } | null, users?: Array<{ __typename?: 'User', id: string }> | null, proposalStage: { __typename?: 'ProposalStage', name?: string | null } } };

export type CustomGetJobPhaseCostItemQueryVariables = Exact<{
  date: Scalars['Date'];
  jobPhaseId: Scalars['ID'];
}>;


export type CustomGetJobPhaseCostItemQuery = { __typename?: 'Query', getJobPhaseCostItem?: { __typename?: 'JobPhaseCostItem', id: string, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, costTotal: number, cost: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', date: any, costMaterial: number, costEquipment: number, costLabour: number, costAdditional: number, costTransferTruck: number, id: string, plantId?: string | null, plantProductId?: string | null, user?: { __typename?: 'User', name: string } | null, additionalCosts?: Array<{ __typename?: 'JobPhaseAdditionalCost', additionalCostId?: string | null, cost: number, costTotal: number, feeAmount: number, feeType: AdditionalCostFeeType, id: string, name: string }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, costItems: Array<{ __typename?: 'JobPhaseCostItem', id: string, plantId?: string | null, plantProductId?: string | null }>, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, defaultEmployees: Array<{ __typename?: 'Employee', firstName: string, id: string, lastName: string, name: string, rate: number }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', chargeType: EquipmentPieceChargeType, fuelSurcharge: number, id: string, name: string, rate: number, usePercentage: number }>, employees: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }>, files?: Array<{ __typename?: 'JobPhaseFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, foremanUser?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, id: string, inviteToken?: string | null, invitedAt?: any | null, lastName?: string | null, name: string, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus } | null, job: { __typename?: 'Job', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, endsAt?: any | null, id: string, notes?: string | null, proposalId: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobStatus, userId: string }, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, subscribed: boolean, trialEndsAt?: any | null }, organizationProductType?: { __typename?: 'OrganizationProductType', id: string, indirectPercentage?: number | null, markupPercentage?: number | null, name: string, overheadPercentage?: number | null, type: ProductType } | null, proposal: { __typename?: 'Proposal', contactId: string, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, id: string, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, profit: string, profitPercentage: number, signedAt?: any | null, signedInitials?: string | null, signedName?: string | null, source?: ProposalSource | null, status: ProposalStatus, userId?: string | null, uuid: string }, proposalProduct: { __typename?: 'ProposalProduct', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, measurementMaterial?: ProductMeasurementMaterial | null, netMargin: string, netMarginPercentage: number, notes?: string | null, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, productName?: string | null, profit: string, profitPercentage: number, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string }> | null }, proposalStage: { __typename?: 'ProposalStage', costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, distanceMeters?: number | null, distanceSeconds?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, name?: string | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal?: string | null, profit: string, profitPercentage: number }, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number }> }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType, jobPhaseCostItem: { __typename?: 'JobPhaseCostItem', id: string, plantId?: string | null, plantProductId?: string | null } } | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number }> | null } }> | null, employees?: Array<{ __typename?: 'JobPhaseEmployee', employeeId?: string | null, id: string, name: string, rate: number, timeOnjob: number, timeTravel: number }> | null, equipmentPieces?: Array<{ __typename?: 'JobPhaseEquipmentPiece', equipmentPieceId?: string | null, id: string, name: string, quantity: number, rate: number, timeOnjob: number, timeTravel: number }> | null, jobPhase: { __typename?: 'JobPhase', actualCostAdditional: string, actualCostDirect: string, actualCostEquipment: string, actualCostIndirect: string, actualCostLabour: string, actualCostMaterial: string, actualCostOverhead: string, actualCostTotal: string, actualEmployeeHours: string, actualGrossMargin: string, actualGrossMarginPercentage: number, actualMaterialNeeded: string, actualNetMargin: string, actualNetMarginPercentage: number, actualOperatingMargin: string, actualOperatingMarginPercentage: number, actualOverallTotal: string, actualProfit: string, actualProfitPercentage: number, address: string, applicableStatuses?: Array<string> | null, crewId?: string | null, endsAt?: any | null, id: string, jobDuration: number, jobSize: number, notes?: string | null, organizationProductTypeName?: string | null, productName: string, proposedCostAdditional: string, proposedCostDirect: string, proposedCostEquipment: string, proposedCostIndirect: string, proposedCostLabour: string, proposedCostMaterial: string, proposedCostOverhead: string, proposedCostTotal: string, proposedEmployeeHours: string, proposedGrossMargin: string, proposedGrossMarginPercentage: number, proposedMaterialNeeded: string, proposedNetMargin: string, proposedNetMarginPercentage: number, proposedOperatingMargin: string, proposedOperatingMarginPercentage: number, proposedOverallTotal: string, proposedProfit: string, proposedProfitPercentage: number, startsAt?: any | null, status: JobPhaseStatus, travelTimeEstimate?: number | null, proposalProduct: { __typename?: 'ProposalProduct', costEquipment: string, costMaterial: string, costTransferTruck: string, costLabour: string, costAdditional: string, costTotal: string, crews?: Array<{ __typename?: 'ProposalCrew', cost: string }> | null } }, material?: { __typename?: 'JobPhaseMaterial', costMaterial: number, id: string, materialNeeded: number, name: string, organizationProductTypeName?: string | null, type: ProductType } | null, transferTrucks?: Array<{ __typename?: 'JobPhaseTransferTruck', hours: number, id: string, name: string, transferTruckId?: string | null, plantTransferTruckId?: string | null, rateHourly: number, rateTon: number, tonnage: number }> | null } | null };

export type CustomGetJobPhaseForDropdownLazyQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomGetJobPhaseForDropdownLazyQuery = { __typename?: 'Query', getJobPhase: { __typename?: 'JobPhase', id: string, organizationProductTypeName?: string | null, address: string, startsAt?: any | null, endsAt?: any | null, proposalStage: { __typename?: 'ProposalStage', id: string, name?: string | null } } };

export type CustomGetJobPhasesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  searchByName?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
  foremanUserId?: InputMaybe<Scalars['ID']>;
  organizationProductTypeId?: InputMaybe<Scalars['ID']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<GetJobsSortKey>;
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  crewId?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['DateTime']>;
  billingStatuses?: InputMaybe<Array<JobBillingStatus> | JobBillingStatus>;
}>;


export type CustomGetJobPhasesQuery = { __typename?: 'Query', getJobPhases: { __typename?: 'GetJobPhasesResponse', data: Array<{ __typename?: 'JobPhase', id: string, externalId: string, address: string, productName: string, jobSize: number, travelTimeEstimate?: number | null, proposedMaterialNeeded: string, organizationProductTypeName?: string | null, startsAt?: any | null, jobDuration: number, proposalStage: { __typename?: 'ProposalStage', name?: string | null, distanceSeconds?: number | null }, foremanUser?: { __typename?: 'User', name: string } | null, organization: { __typename?: 'Organization', name: string }, defaultAdditionalCosts: Array<{ __typename?: 'AdditionalCost', name: string, id: string }>, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', name: string, id: string }>, crew?: { __typename?: 'Crew', name: string, displayName?: string | null } | null, job: { __typename?: 'Job', id: string, externalId: string, billingStatus?: JobBillingStatus | null, company: { __typename?: 'Company', name: string }, contact: { __typename?: 'Contact', firstName: string, lastName: string, phone?: string | null }, address: { __typename?: 'ProposalAddress', line1: string } } }>, paginatorInfo: { __typename?: 'CustomPaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type CustomGetJobPhasesForDropdownQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  searchByName?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
  foremanUserId?: InputMaybe<Scalars['ID']>;
  organizationProductTypeId?: InputMaybe<Scalars['ID']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<GetJobsSortKey>;
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  crewId?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['DateTime']>;
  billingStatuses?: InputMaybe<Array<JobBillingStatus> | JobBillingStatus>;
}>;


export type CustomGetJobPhasesForDropdownQuery = { __typename?: 'Query', getJobPhases: { __typename?: 'GetJobPhasesResponse', data: Array<{ __typename?: 'JobPhase', id: string, externalId: string, address: string, productName: string, organizationProductTypeName?: string | null, proposalStage: { __typename?: 'ProposalStage', id: string, name?: string | null, distanceSeconds?: number | null }, job: { __typename?: 'Job', id: string, company: { __typename?: 'Company', id: string, name: string } } }>, paginatorInfo: { __typename?: 'CustomPaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type CustomGetJobPhasesScheduleBlocksQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
  foremanUserId?: InputMaybe<Scalars['ID']>;
  organizationProductTypeId?: InputMaybe<Scalars['ID']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<GetJobsSortKey>;
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  crewId?: InputMaybe<Scalars['ID']>;
  date: Scalars['DateTime'];
}>;


export type CustomGetJobPhasesScheduleBlocksQuery = { __typename?: 'Query', getJobPhases: { __typename?: 'GetJobPhasesResponse', data: Array<{ __typename?: 'JobPhase', id: string, externalId: string, productName: string, jobSize: number, travelTimeEstimate?: number | null, proposedMaterialNeeded: string, organizationProductTypeName?: string | null, startsAt?: any | null, jobDuration: number, proposalStage: { __typename?: 'ProposalStage', name?: string | null, distanceSeconds?: number | null }, foremanUser?: { __typename?: 'User', name: string } | null, organization: { __typename?: 'Organization', name: string }, defaultEquipmentPieces: Array<{ __typename?: 'EquipmentPiece', name: string, id: string }>, crew?: { __typename?: 'Crew', name: string, displayName?: string | null } | null, job: { __typename?: 'Job', id: string, externalId: string, company: { __typename?: 'Company', name: string }, contact: { __typename?: 'Contact', firstName: string, lastName: string, phone?: string | null }, address: { __typename?: 'ProposalAddress', line1: string } }, scheduledBlockForDate?: Array<{ __typename?: 'JobPhaseScheduleBlock', scheduledAt: any, blockLength: number }> | null }>, paginatorInfo: { __typename?: 'CustomPaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type CustomGetJobSchedulesQueryVariables = Exact<{
  crewId?: InputMaybe<Scalars['ID']>;
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateUntil?: InputMaybe<Scalars['DateTime']>;
  jobIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  jobPhaseId?: InputMaybe<Scalars['ID']>;
}>;


export type CustomGetJobSchedulesQuery = { __typename?: 'Query', getJobSchedules: Array<{ __typename?: 'JobPhaseScheduleBlock', blockLength: number, endsAt: any, id: string, scheduledAt: any, showTravelFrom: boolean, showTravelTo: boolean, travelTime: number, crew?: { __typename?: 'Crew', color: string, displayName?: string | null, id: string, name: string, rate: number } | null, job: { __typename?: 'Job', id: string, datePushedToQuickbooks?: any | null, status: JobStatus, company: { __typename?: 'Company', name: string } }, jobPhase: { __typename?: 'JobPhase', id: string, productName: string, status: JobPhaseStatus, usersColor?: string | null, proposalProduct: { __typename?: 'ProposalProduct', material: { __typename?: 'ProposalMaterial', id: string, name: string, productId: string } }, organizationProductType?: { __typename?: 'OrganizationProductType', name: string } | null, proposalStage: { __typename?: 'ProposalStage', name?: string | null }, foremanUser?: { __typename?: 'User', name: string } | null } }> };

export type CustomGetJobsQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  multipleCompanyIDs?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  first: Scalars['Int'];
  jobIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  organizationProductTypeIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<GetJobsSortKey>;
  statuses?: InputMaybe<Array<JobStatus> | JobStatus>;
  userId?: InputMaybe<Scalars['ID']>;
  billingStatuses?: InputMaybe<Array<JobBillingStatus> | JobBillingStatus>;
}>;


export type CustomGetJobsQuery = { __typename?: 'Query', getJobs: { __typename?: 'GetJobsResponse', data: Array<{ __typename?: 'Job', actualOverallTotal: string, endsAt?: any | null, id: string, externalId: string, proposedOverallTotal: string, startsAt?: any | null, status: JobStatus, billingStatus?: JobBillingStatus | null, jobPhases?: Array<{ __typename?: 'JobPhase', id: string, externalId: string, applicableStatuses?: Array<string> | null, endsAt?: any | null, productName: string, startsAt?: any | null, status: JobPhaseStatus, organizationProductTypeName?: string | null, jobDuration: number, proposedOverallTotal: string, actualOverallTotal: string, foremanUser?: { __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null } | null, scheduleBlocks: Array<{ __typename?: 'JobPhaseScheduleBlock', id: string, scheduledAt: any, endsAt: any, blockLength: number, showTravelTo: boolean, showTravelFrom: boolean, travelTime: number }> } | null> | null, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, name: string } | null, foremanUser?: { __typename?: 'User', id: string, name: string, firstName?: string | null, lastName?: string | null } | null, address: { __typename?: 'ProposalAddress', id: string, line1: string }, company: { __typename?: 'Company', id: string, name: string }, contact: { __typename?: 'Contact', firstName: string, id: string, lastName: string, phone?: string | null }, proposal?: { __typename?: 'Proposal', wonAt?: any | null } | null, proposalStage?: { __typename?: 'ProposalStage', id: string, name?: string | null } | null }>, paginatorInfo: { __typename?: 'CustomPaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type CustomGetNotificationTriggerQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomGetNotificationTriggerQuery = { __typename?: 'Query', getNotificationTrigger: { __typename?: 'NotificationTrigger', id: string, name: string, active: boolean, delay: number, event: NotificationTriggerEvent, type: NotificationTriggerType, content: string, sendToUser: boolean, sendToAllRecipients: boolean, sendToContact: boolean, additionalRecipientTypes?: Array<NotificationTriggerAdditionalRecipientTypes> | null, isEmail?: boolean | null, isSMS?: boolean | null, smsContent?: string | null, emailSubject?: string | null, additionalRecipients: Array<{ __typename?: 'NotificationTriggerRecipient', id: string, firstName: string, lastName: string }> } };

export type CustomGetNotificationTriggersQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomGetNotificationTriggersQuery = { __typename?: 'Query', getNotificationTriggers?: Array<{ __typename?: 'NotificationTrigger', id: string, name: string, active: boolean, delay: number, event: NotificationTriggerEvent, type: NotificationTriggerType, content: string, sendToUser: boolean, sendToAllRecipients: boolean, sendToContact: boolean, additionalRecipientTypes?: Array<NotificationTriggerAdditionalRecipientTypes> | null, isEmail?: boolean | null, isSMS?: boolean | null, smsContent?: string | null, emailSubject?: string | null, additionalRecipients: Array<{ __typename?: 'NotificationTriggerRecipient', id: string, firstName: string, lastName: string }> }> | null };

export type CustomGetOpportunityQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomGetOpportunityQuery = { __typename?: 'Query', getOpportunity?: { __typename?: 'Opportunity', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, companyId: string, estimatedOpportunityValue?: number | null, projectFilesFolderId?: string | null, contactId: string, dueAt?: any | null, id: string, externalId: string, name: string, notes?: string | null, source?: OpportunitySource | null, status: string, statusId: string, userId?: string | null, company: { __typename?: 'Company', id: string, name: string, contacts: Array<{ __typename?: 'Contact', firstName: string, id: string, lastName: string }> }, products?: Array<{ __typename?: 'OrganizationProductType', id: string }> | null } | null };

export type CustomGetOrganizationEmailTemplateQueryVariables = Exact<{
  type: OrganizationEmailTemplateType;
}>;


export type CustomGetOrganizationEmailTemplateQuery = { __typename?: 'Query', getOrganizationEmailTemplate?: { __typename?: 'OrganizationEmailTemplate', type: OrganizationEmailTemplateType, html: string } | null };

export type CustomGetOrganizationEmailTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomGetOrganizationEmailTemplatesQuery = { __typename?: 'Query', getOrganizationEmailTemplates?: Array<{ __typename?: 'OrganizationEmailTemplate', type: OrganizationEmailTemplateType, html: string }> | null };

export type CustomGetProductsQueryVariables = Exact<{
  first: Scalars['Int'];
  orderBy?: InputMaybe<Array<QueryGetProductsOrderByOrderByClause> | QueryGetProductsOrderByOrderByClause>;
  organizationProductTypeId?: InputMaybe<Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<ProductType>;
}>;


export type CustomGetProductsQuery = { __typename?: 'Query', getProducts?: { __typename?: 'ProductPaginator', data: Array<{ __typename?: 'Product', dailyUnitsComplete?: number | null, id: string, indirectPercentage?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, name: string, overheadPercentage?: number | null, statementOfWork?: string | null, type: ProductType, subcontracted: boolean, unitPriceProduct: boolean, organizationProductType: { __typename?: 'OrganizationProductType', name: string } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } | null };

export type CustomGetProposalQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomGetProposalQuery = { __typename?: 'Query', getProposal: { __typename?: 'Proposal', id: string, uuid: string, activeVersion: boolean, contactId: string, status: ProposalStatus, source?: ProposalSource | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, grossMargin: string, grossMarginPercentage: number, externalId: string, isSendable: boolean, layout?: ProposalLayout | null, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, profit: string, profitPercentage: number, proposalNotes?: string | null, createdAt: any, removeUnitPriceAndQuantity?: boolean | null, removeIndividualLineItemPricing?: boolean | null, isChangeOrder: boolean, userId?: string | null, costTaxes: string, overallTotalAfterTaxes: string, acceptanceOverride?: string | null, version: string, changeOrderJobId?: string | null, projectFilesFolderId?: string | null, clientEmailOverride?: string | null, emailSubjectOverride?: string | null, emailBodyOverride?: string | null, emailBodyOverrideParsed?: string | null, company: { __typename?: 'Company', id: string, name: string, contacts: Array<{ __typename?: 'Contact', email?: string | null, firstName: string, id: string, lastName: string, phone?: string | null, primary: boolean, role?: string | null, title?: string | null }> }, contact: { __typename?: 'Contact', firstName: string, lastName: string, email?: string | null }, recipients: Array<{ __typename?: 'ProposalRecipient', contactId?: string | null, email: string, id: string }>, stages: Array<{ __typename?: 'ProposalStage', id: string, name?: string | null, mapData?: string | null, mapImage?: string | null, overallTotal?: string | null, distanceSeconds?: number | null, roundTripTravelTimeHours?: number | null, addressOverride?: string | null, ordering: number, proposalProducts?: Array<{ __typename?: 'ProposalProduct', notes?: string | null, costAdditional: string, costDirect: string, costEquipment: string, costIndirect: string, costLabour: string, costMaterial: string, costOverhead: string, costTotal: string, costTransferTruck: string, jobDurationOverride?: number | null, jobDurationDaysOverride?: number | null, roundTripTravelTimeHours?: number | null, grossMargin: string, grossMarginPercentage: number, id: string, jobDuration: number, jobSize: number, mapData?: string | null, mapImage?: string | null, mapImageDirty: boolean, netMargin: string, netMarginPercentage: number, operatingMargin: string, operatingMarginPercentage: number, overallTotal: string, overallTotalOverride?: string | null, ordering: number, profit: string, profitPercentage: number, profitPercentageOverride?: number | null, subcontractorCost?: string | null, subcontractorName?: string | null, subcontractorProposalId?: string | null, transferTruckLoadTimeBuffer?: number | null, transferTruckRoundTripTime?: number | null, transferTruckRoundTripTimeOverride?: number | null, transferTruckUnloadTimeBuffer?: number | null, isOptional: boolean, additionalCosts?: Array<{ __typename?: 'ProposalAdditionalCost', cost: number, costOverride?: number | null, feeAmount: number, feeAmountOverride?: number | null, feeType: AdditionalCostFeeType, id: string, name: string, costTotal?: string | null, quantity?: number | null, quantityOverride?: number | null, showOnProposal: boolean } | null> | null, crews?: Array<{ __typename?: 'ProposalCrew', cost: string, id: string, name: string, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, equipmentPieces?: Array<{ __typename?: 'ProposalEquipmentPiece', chargeType: EquipmentPieceChargeType, cost: string, id: string, name: string, quantity: number, quantityOverride?: number | null, rate: number, rateOverride?: number | null, timeOnjob: number, timeOnjobOverride?: number | null, timeTravel: number, timeTravelOverride?: number | null }> | null, files?: Array<{ __typename?: 'ProposalFile', createdAt: any, filename: string, id: string, thumbnail?: string | null }> | null, material: { __typename?: 'ProposalMaterial', areaCoverage?: number | null, costMaterial?: number | null, costMaterialOverride?: number | null, costMinimumProduct?: number | null, costMinimumProposal?: number | null, dailyUnitsComplete?: string | null, dailyUnitsCompleteOverride?: string | null, id: string, indirectPercentage?: number | null, indirectPercentageOverride?: number | null, labourCostType?: ProductLabourCostType | null, markupPercentage?: number | null, markupPercentageOverride?: number | null, materialNeeded?: number | null, materialNeededOverride?: number | null, measurementJob?: ProductMeasurementJob | null, measurementMaterial?: ProductMeasurementMaterial | null, organizationProductTypeName?: string | null, overheadPercentage?: number | null, overheadPercentageOverride?: number | null, productId: string, proposalId: string, proposalProductId: string, proposalStageId: string, statementOfWork?: string | null, statementOfWorkOverride?: string | null, tonConversionFactor?: number | null, tonConversionFactorOverride?: number | null, name: string, type: string, productionRateType?: ProductProductionRateType | null, subcontracted: boolean, unitPriceProduct: boolean, unitPrice?: number | null, unitPriceOverride?: number | null, attributes?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null, attributesOverride?: { __typename: 'ProductAttributeAsphalt', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteColumn', height?: number | null, diameter?: number | null } | { __typename: 'ProductAttributeConcreteCurbOrGutter', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeConcreteFlatwork', applicationRate?: number | null } | { __typename: 'ProductAttributeConcreteFooting', width?: number | null, depth?: number | null } | { __typename: 'ProductAttributeConcreteWall', height?: number | null, width?: number | null } | { __typename: 'ProductAttributeConcreteWaterway', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeCrackSeal', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeCurbWall', curbHeight?: number | null, curbWidth?: number | null, gutterHeight?: number | null, gutterWidth?: number | null } | { __typename: 'ProductAttributeExcavateOut', applicationRate?: number | null } | { __typename: 'ProductAttributeGrading', applicationRate?: number | null, poundsPerCubicYard?: number | null } | { __typename: 'ProductAttributeMastic', crackDepth?: number | null, crackWidth?: number | null, overbandThickness?: number | null, overbandWidth?: number | null, poundsPerBlock?: number | null, poundsPerGallon?: number | null } | { __typename: 'ProductAttributeMicrosurfacing', applicationRate?: number | null } | { __typename: 'ProductAttributeSealCoat', applicationRate?: number | null } | { __typename: 'ProductAttributeSlurrySeal', applicationRate?: number | null } | { __typename: 'ProductAttributeStriping', applicationRate?: number | null, lineWidth?: number | null } | null }, plantProduct?: { __typename?: 'ProposalPlantProduct', id: string, plantProductId: string, rate: number, rateOverride?: number | null, type: string, plant: { __typename?: 'ProposalPlant', addressCity: string, addressCountry: string, addressLine1: string, addressLine2?: string | null, addressState: string, addressZip: string, distanceMeters?: number | null, distanceSeconds?: number | null, id: string, name: string, phone: string, plantId: string, rateOnWeight: boolean, roundTripSeconds?: number | null } } | null, transferTrucks?: Array<{ __typename?: 'ProposalTransferTruck', id: string, name: string, plantTransferTruckId?: string | null, quantity: number, rateHourly: number, rateHourlyOverride?: number | null, rateTon: number, rateTonOverride?: number | null, tonnage: number, transferTruckId: string, trucksNeeded?: number | null, truckingProductionRate?: number | null, totalHaulingHours: number, totalHaulingHoursOverride?: number | null, cost: number, costOverride?: number | null } | null> | null }> | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null }>, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: string } | null, events: Array<{ __typename?: 'ProposalEvent', action: ProposalEventAction, createdAt: any }>, statusChanges: Array<{ __typename?: 'ProposalStatusChange', changeAt: any, status: ProposalStatus }>, salesTaxes?: Array<{ __typename?: 'ProposalSalesTax', id: string, name: string, percentage: number, organizationSalesTaxId: string }> | null, attachments?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string }> | null, changeOrders?: Array<{ __typename?: 'Proposal', id: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, changeOrderJobId?: string | null }> | null, versions?: Array<{ __typename?: 'Proposal', id: string, version: string, externalId: string, status: ProposalStatus, overallTotalAfterTaxes: string, activeVersion: boolean }> | null } };

export type CustomGetProposalsQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  multipleCompanyIDs?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  first: Scalars['Int'];
  organizationProductTypeIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<GetProposalsSortKey>;
  statuses?: InputMaybe<Array<ProposalStatus> | ProposalStatus>;
  userId?: InputMaybe<Scalars['ID']>;
  multipleUserIDs?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type CustomGetProposalsQuery = { __typename?: 'Query', getProposals: { __typename?: 'GetProposalsResponse', data: Array<{ __typename?: 'Proposal', id: string, externalId: string, status: ProposalStatus, overallTotal: string, userId?: string | null, uuid: string, createdAt: any, sentAt?: any | null, company: { __typename?: 'Company', email: string, id: string, name: string }, contact: { __typename?: 'Contact', firstName: string, id: string, lastName: string, phone?: string | null }, user?: { __typename?: 'User', firstName?: string | null, id: string, lastName?: string | null, name: string } | null, stages: Array<{ __typename?: 'ProposalStage', id: string, name?: string | null, overallTotal?: string | null, address?: { __typename?: 'ProposalAddress', city?: string | null, country?: string | null, id: string, latitude: string, line1: string, line2?: string | null, longitude: string, mapImage?: string | null, organizationAddressId?: string | null, state?: string | null, zip?: string | null } | null, proposalProducts?: Array<{ __typename?: 'ProposalProduct', id: string, productName?: string | null }> | null }> }>, paginatorInfo: { __typename?: 'CustomPaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type CustomGetTimeEntriesQueryVariables = Exact<{
  first: Scalars['Int'];
  forDate?: InputMaybe<Scalars['Date']>;
  jobPhaseId?: InputMaybe<Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  sortDirection?: InputMaybe<SortDirection>;
  sortKey?: InputMaybe<GetTimeEntriesSortKey>;
  userId?: InputMaybe<Scalars['ID']>;
  forDateStart?: InputMaybe<Scalars['Date']>;
  forDateEnd?: InputMaybe<Scalars['Date']>;
}>;


export type CustomGetTimeEntriesQuery = { __typename?: 'Query', getTimeEntries: { __typename?: 'GetTimeEntriesResponse', data: Array<{ __typename?: 'TimeEntry', endTime?: any | null, forDate: any, id: string, clockInLatitude?: number | null, clockInLongitude?: number | null, clockOutLatitude?: number | null, clockOutLongitude?: number | null, notes?: string | null, organizationId: string, startTime: any, timeTrackedSeconds?: number | null, timeTrackedSecondsOverride?: number | null, uuid: string, jobPhase?: { __typename?: 'JobPhase', id: string, externalId: string, address: string, proposalStage: { __typename?: 'ProposalStage', id: string, name?: string | null }, job: { __typename?: 'Job', id: string, externalId: string } } | null, timeBucket?: { __typename?: 'TimeBucket', id: string, name: string, organizationId: string } | null, user: { __typename?: 'User', firstName?: string | null, id: string, lastName?: string | null, name: string } }>, paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number } } };

export type CustomMeQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomMeQuery = { __typename?: 'Query', me?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, id: string, inviteToken?: string | null, invitedAt?: any | null, lastName?: string | null, name: string, phone?: string | null, proposalCount: number, roles: Array<UserRole>, permissions: Array<UserPermissions>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, id: string, inviteToken?: string | null, invitedAt?: any | null, lastName?: string | null, name: string, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, invitedBy?: { __typename?: 'User', addressCity?: string | null, addressCountry?: string | null, addressLine1?: string | null, addressLine2?: string | null, addressState?: string | null, addressZip?: string | null, autoAssign: boolean, avatar?: string | null, crewsCount: number, email: string, firstName?: string | null, id: string, inviteToken?: string | null, invitedAt?: any | null, lastName?: string | null, name: string, phone?: string | null, proposalCount: number, roles: Array<UserRole>, status: UserStatus, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, subscribed: boolean, trialEndsAt?: any | null, documents?: Array<{ __typename?: 'OrganizationDocument', id: string, name: string, path: string }> | null, linkedServices?: Array<{ __typename?: 'OrganizationLinkedService', active: boolean, expired: boolean, id: string, service: OrganizationLinkedServiceName, type: OrganizationLinkedServiceType }> | null, subscription?: { __typename?: 'StripeSubscription', endsAt?: any | null, id: string, name: string, quantity?: number | null, renewsAt?: any | null, stripeId: string, stripePrice?: string | null, stripeStatus: string, trialEndsAt?: any | null } | null } } | null } | null, organization: { __typename?: 'Organization', email?: string | null, emailTemplate: OrganizationEmailTemplateType, failingPayment: boolean, id: string, logo?: string | null, name: string, onTrial?: boolean | null, phone?: string | null, subscribed: boolean, trialEndsAt?: any | null, timezone?: string | null, subscription?: { __typename?: 'StripeSubscription', id: string } | null } } | null };

export const CompanyFragmentFragmentDoc = gql`
    fragment CompanyFragment on Company {
  addressCity
  addressCountry
  addressLine1
  addressLine2
  addressState
  addressZip
  addCompanyInfo
  projectFilesFolderId
  contacts {
    SMSNotifications
    SMSNotificationsReadOnly
    email
    firstName
    id
    lastName
    phone
    primary
    role
    title
  }
  email
  id
  jobsCount
  name
  notes
  phone
  primaryContact {
    SMSNotifications
    SMSNotificationsReadOnly
    email
    firstName
    id
    lastName
    phone
    primary
    role
    title
  }
  proposalsCount
  website
  notificationTypes {
    CONTACT
    JOB
    JOB_PHASE
    OPPORTUNITY
    PROPOSAL
  }
  logo
  status
}
    `;
export const CustomEventFragmentFragmentDoc = gql`
    fragment CustomEventFragment on CustomEvent {
  color
  crew {
    color
    displayName
    id
    name
  }
  customEventBlocks {
    blockLength
    endsAt
    id
    scheduledAt
  }
  endsAt
  id
  name
  notes
  startsAt
  customEventsToUsers {
    user {
      id
    }
  }
}
    `;
export const JobPhaseFragmentFragmentDoc = gql`
    fragment JobPhaseFragment on JobPhase {
  id
  externalId
  actualCostAdditional
  actualCostDirect
  actualCostEquipment
  actualCostIndirect
  actualCostLabour
  actualCostMaterial
  actualCostOverhead
  actualCostTotal
  actualEmployeeHours
  actualGrossMargin
  actualGrossMarginPercentage
  actualMaterialNeeded
  actualNetMargin
  actualNetMarginPercentage
  actualOperatingMargin
  actualOperatingMarginPercentage
  actualOverallTotal
  actualProfit
  actualProfitPercentage
  actualCostTransferTruck
  address
  applicableStatuses
  productName
  workOrderCrews {
    crewId
    id
    name
  }
  workOrderTransferTrucks {
    id
    transferTruckId
    quantity
    name
    tonnage
    rateTon
    rateHourly
  }
  jobPhasePlant {
    id
    plant {
      id
      addressLine1
      addressLine2
      addressCity
      addressState
      addressZip
      addressCountry
    }
    plantProduct {
      id
    }
    name
    type
  }
  workOrderEquipmentPieces {
    equipmentPieceId
    id
    name
  }
  costItems {
    date
    costMaterial
    costEquipment
    costLabour
    costAdditional
    costTransferTruck
    user {
      name
    }
    material {
      costMaterial
      id
      jobPhaseCostItem {
        id
        plantId
        plantProductId
      }
      materialNeeded
      name
      organizationProductTypeName
      type
    }
    additionalCosts {
      additionalCostId
      cost
      costTotal
      feeAmount
      feeType
      id
      jobPhaseCostItem {
        additionalCosts {
          additionalCostId
          cost
          costTotal
          feeAmount
          feeType
          id
          name
        }
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        equipmentPieces {
          equipmentPieceId
          id
          name
          quantity
          rate
          timeOnjob
          timeTravel
        }
        id
        jobPhase {
          id
        }
        material {
          costMaterial
          id
          materialNeeded
          name
          organizationProductTypeName
          type
        }
        plantId
        plantProductId
        transferTrucks {
          hours
          id
          name
          plantTransferTruckId
          rateHourly
          rateTon
          tonnage
        }
        date
      }
      name
    }
    jobPhase {
      defaultEmployees {
        firstName
        id
        lastName
        name
        rate
      }
      defaultEquipmentPieces {
        chargeType
        fuelSurcharge
        id
        name
        rate
        usePercentage
      }
      employees {
        employeeId
        id
        name
        rate
        timeOnjob
        timeTravel
      }
      endsAt
      files {
        createdAt
        filename
        id
        thumbnail
      }
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        id
        inviteToken
        invitedAt
        lastName
        name
        phone
        proposalCount
        roles
        status
      }
      id
      proposalProduct {
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        grossMargin
        grossMarginPercentage
        id
        jobDuration
        jobSize
        mapData
        mapImage
        mapImageDirty
        measurementMaterial
        netMargin
        netMarginPercentage
        notes
        operatingMargin
        operatingMarginPercentage
        overallTotal
        productName
        profit
        profitPercentage
        costTransferTruck
        transferTruckLoadTimeBuffer
        transferTruckRoundTripTime
        transferTruckRoundTripTimeOverride
        transferTruckUnloadTimeBuffer
        material {
          id
          productId
          name
        }
        crews {
          cost
        }
        plantProduct {
          type
          plantProductId
          plant {
            name
            addressLine1
            addressLine2
            addressCity
            addressState
            addressZip
            addressCountry
          }
        }
      }
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedEmployeeHours
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedMaterialNeeded
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      scheduleBlocks {
        estimatedMaterialOverride
        estimatedMaterial
        blockLength
        endsAt
        id
        scheduledAt
        showTravelFrom
        showTravelTo
        travelTime
      }
      startsAt
      status
      travelTimeEstimate
    }
    employees {
      employeeId
      id
      name
      rate
      timeOnjob
      timeTravel
    }
    equipmentPieces {
      equipmentPieceId
      id
      name
      quantity
      rate
      timeOnjob
      timeTravel
    }
    id
    plantId
    plantProductId
  }
  endsAt
  jobDuration
  jobSize
  notes
  organizationProductTypeName
  proposedCostAdditional
  proposedCostDirect
  proposedCostEquipment
  proposedCostIndirect
  proposedCostLabour
  proposedCostMaterial
  proposedCostOverhead
  proposedCostTotal
  proposedEmployeeHours
  proposedGrossMargin
  proposedGrossMarginPercentage
  proposedMaterialNeeded
  proposedNetMargin
  proposedNetMarginPercentage
  proposedOperatingMargin
  proposedOperatingMarginPercentage
  proposedOverallTotal
  proposedProfit
  proposedProfitPercentage
  proposedCostTransferTruck
  startsAt
  status
  travelTimeEstimate
  usersColor
  files {
    createdAt
    filename
    id
    thumbnail
  }
  defaultEmployees {
    firstName
    id
    lastName
    name
    rate
  }
  defaultAdditionalCosts {
    name
    cost
    id
    feeAmount
    feeType
  }
  defaultEquipmentPieces {
    chargeType
    fuelSurcharge
    id
    name
    rate
    usePercentage
  }
  foremanUser {
    id
    name
    phone
  }
  job {
    externalId
    actualCostAdditional
    actualCostDirect
    actualCostEquipment
    actualCostIndirect
    actualCostLabour
    actualCostMaterial
    actualCostOverhead
    actualCostTotal
    actualGrossMargin
    actualGrossMarginPercentage
    actualNetMargin
    actualNetMarginPercentage
    actualOperatingMargin
    actualOperatingMarginPercentage
    actualOverallTotal
    actualProfit
    actualProfitPercentage
    endsAt
    id
    notes
    proposalId
    proposedCostAdditional
    proposedCostDirect
    proposedCostEquipment
    proposedCostIndirect
    proposedCostLabour
    proposedCostMaterial
    proposedCostOverhead
    proposedCostTotal
    proposedGrossMargin
    proposedGrossMarginPercentage
    proposedNetMargin
    proposedNetMarginPercentage
    proposedOperatingMargin
    proposedOperatingMarginPercentage
    proposedOverallTotal
    proposedProfit
    proposedProfitPercentage
    startsAt
    status
    billingStatus
    userId
    company {
      id
      name
      phone
    }
    contact {
      email
      firstName
      id
      lastName
      phone
      title
    }
  }
  organizationProductType {
    id
    indirectPercentage
    markupPercentage
    name
    overheadPercentage
    type
  }
  proposal {
    contactId
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTotal
    grossMargin
    grossMarginPercentage
    id
    isSendable
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    overallTotal
    profit
    profitPercentage
    signedAt
    signedInitials
    signedName
    source
    status
    userId
    uuid
  }
  proposalProduct {
    material {
      id
      name
      externalProductName
      materialNeeded
      materialNeededOverride
      productId
    }
    plantProduct {
      type
      plantProductId
      plant {
        plantId
        addressLine1
        addressLine2
        addressCity
        addressState
        addressZip
        addressCountry
      }
    }
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTotal
    grossMargin
    grossMarginPercentage
    id
    jobDuration
    jobSize
    mapData
    mapImage
    mapImageDirty
    measurementMaterial
    measurementJob
    netMargin
    netMarginPercentage
    notes
    operatingMargin
    operatingMarginPercentage
    overallTotal
    productName
    profit
    profitPercentage
    transferTruckLoadTimeBuffer
    transferTruckRoundTripTime
    transferTruckRoundTripTimeOverride
    transferTruckUnloadTimeBuffer
    statementOfWork
    files {
      createdAt
      filename
      id
      thumbnail
      type
    }
    equipmentPieces {
      id
      equipmentPieceId
      name
      rate
      timeTravel
      timeTravelOverride
      timeOnjob
      timeOnjobOverride
    }
    crews {
      id
      crewId
      name
      rate
      timeOnjob
      timeOnjobOverride
    }
    additionalCosts {
      id
      additionalCostId
      name
      cost
      costOverride
      feeAmount
      feeAmountOverride
      quantity
      quantityOverride
    }
    transferTrucks {
      id
      transferTruckId
      name
      tonnage
      quantity
      trucksNeeded
    }
  }
  scheduleBlocks {
    estimatedMaterialOverride
    estimatedMaterial
    blockLength
    endsAt
    id
    scheduledAt
    showTravelFrom
    showTravelTo
  }
  organization {
    id
    name
    logo
  }
  crew {
    id
    color
    displayName
  }
  users {
    id
  }
  proposalStage {
    name
  }
}
    `;
export const NotificationTriggerFragmentFragmentDoc = gql`
    fragment NotificationTriggerFragment on NotificationTrigger {
  id
  name
  active
  delay
  event
  type
  content
  sendToUser
  sendToAllRecipients
  sendToContact
  additionalRecipientTypes
  isEmail
  isSMS
  smsContent
  emailSubject
  additionalRecipients {
    id
    firstName
    lastName
  }
}
    `;
export const BitumioOrganizationEmailTemplateFragmentDoc = gql`
    fragment BitumioOrganizationEmailTemplate on OrganizationEmailTemplate {
  type
  html
}
    `;
export const UpdatedProductFragmentDoc = gql`
    fragment UpdatedProduct on Product {
  id
}
    `;
export const BitumioProposalStageFragmentDoc = gql`
    fragment BitumioProposalStage on ProposalStage {
  id
  name
  mapData
  mapImage
  overallTotal
  distanceSeconds
  roundTripTravelTimeHours
  addressOverride
  proposalProducts {
    notes
    additionalCosts {
      cost
      costOverride
      feeAmount
      feeAmountOverride
      feeType
      id
      name
      costTotal
      quantity
      quantityOverride
      showOnProposal
    }
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTotal
    costTransferTruck
    jobDurationOverride
    jobDurationDaysOverride
    roundTripTravelTimeHours
    crews {
      cost
      id
      name
      rate
      rateOverride
      timeOnjob
      timeOnjobOverride
      timeTravel
      timeTravelOverride
    }
    equipmentPieces {
      chargeType
      cost
      id
      name
      quantity
      quantityOverride
      rate
      rateOverride
      timeOnjob
      timeOnjobOverride
      timeTravel
      timeTravelOverride
    }
    files {
      createdAt
      filename
      id
      thumbnail
    }
    grossMargin
    grossMarginPercentage
    id
    jobDuration
    jobSize
    mapData
    mapImage
    mapImageDirty
    material {
      areaCoverage
      attributes {
        __typename
        ... on ProductAttributeAsphalt {
          applicationRate
        }
        ... on ProductAttributeConcreteCurbOrGutter {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeConcreteFlatwork {
          applicationRate
        }
        ... on ProductAttributeConcreteWaterway {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeCrackSeal {
          crackDepth
          crackWidth
          overbandThickness
          overbandWidth
          poundsPerBlock
          poundsPerGallon
        }
        ... on ProductAttributeCurbWall {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeExcavateOut {
          applicationRate
        }
        ... on ProductAttributeGrading {
          applicationRate
          poundsPerCubicYard
        }
        ... on ProductAttributeMastic {
          crackDepth
          crackWidth
          overbandThickness
          overbandWidth
          poundsPerBlock
          poundsPerGallon
        }
        ... on ProductAttributeMicrosurfacing {
          applicationRate
        }
        ... on ProductAttributeSealCoat {
          applicationRate
        }
        ... on ProductAttributeSlurrySeal {
          applicationRate
        }
        ... on ProductAttributeStriping {
          applicationRate
          lineWidth
        }
        ... on ProductAttributeConcreteFooting {
          width
          depth
        }
        ... on ProductAttributeConcreteWall {
          height
          width
        }
        ... on ProductAttributeConcreteColumn {
          height
          diameter
        }
      }
      attributesOverride {
        __typename
        ... on ProductAttributeAsphalt {
          applicationRate
        }
        ... on ProductAttributeConcreteCurbOrGutter {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeConcreteFlatwork {
          applicationRate
        }
        ... on ProductAttributeConcreteWaterway {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeCrackSeal {
          crackDepth
          crackWidth
          overbandThickness
          overbandWidth
          poundsPerBlock
          poundsPerGallon
        }
        ... on ProductAttributeCurbWall {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeExcavateOut {
          applicationRate
        }
        ... on ProductAttributeGrading {
          applicationRate
          poundsPerCubicYard
        }
        ... on ProductAttributeMastic {
          crackDepth
          crackWidth
          overbandThickness
          overbandWidth
          poundsPerBlock
          poundsPerGallon
        }
        ... on ProductAttributeMicrosurfacing {
          applicationRate
        }
        ... on ProductAttributeSealCoat {
          applicationRate
        }
        ... on ProductAttributeSlurrySeal {
          applicationRate
        }
        ... on ProductAttributeStriping {
          applicationRate
          lineWidth
        }
        ... on ProductAttributeConcreteFooting {
          width
          depth
        }
        ... on ProductAttributeConcreteWall {
          height
          width
        }
        ... on ProductAttributeConcreteColumn {
          height
          diameter
        }
      }
      costMaterial
      costMaterialOverride
      costMinimumProduct
      costMinimumProposal
      dailyUnitsComplete
      dailyUnitsCompleteOverride
      id
      indirectPercentage
      indirectPercentageOverride
      labourCostType
      markupPercentage
      markupPercentageOverride
      materialNeeded
      materialNeededOverride
      measurementJob
      measurementMaterial
      organizationProductTypeName
      overheadPercentage
      overheadPercentageOverride
      productId
      proposalId
      proposalProductId
      proposalStageId
      statementOfWork
      statementOfWorkOverride
      tonConversionFactor
      tonConversionFactorOverride
      name
      type
      productionRateType
      subcontracted
      unitPriceProduct
      unitPrice
      unitPriceOverride
    }
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    overallTotal
    overallTotalOverride
    ordering
    plantProduct {
      id
      plant {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        distanceMeters
        distanceSeconds
        id
        name
        phone
        plantId
        rateOnWeight
        roundTripSeconds
      }
      plantProductId
      rate
      rateOverride
      type
    }
    profit
    profitPercentage
    profitPercentageOverride
    subcontractorCost
    subcontractorName
    subcontractorProposalId
    transferTruckLoadTimeBuffer
    transferTruckRoundTripTime
    transferTruckRoundTripTimeOverride
    transferTruckUnloadTimeBuffer
    transferTrucks {
      id
      name
      plantTransferTruckId
      quantity
      rateHourly
      rateHourlyOverride
      rateTon
      rateTonOverride
      tonnage
      transferTruckId
      trucksNeeded
      truckingProductionRate
      totalHaulingHours
      totalHaulingHoursOverride
      cost
      costOverride
    }
    isOptional
  }
  address {
    city
    country
    id
    latitude
    line1
    line2
    longitude
    organizationAddressId
    state
    zip
  }
  ordering
}
    `;
export const BitumioProposalFragmentDoc = gql`
    fragment BitumioProposal on Proposal {
  id
  uuid
  activeVersion
  company {
    id
    name
    contacts {
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
  }
  contact {
    firstName
    lastName
    email
  }
  recipients {
    contactId
    email
    id
  }
  contactId
  status
  source
  stages {
    ...BitumioProposalStage
  }
  costAdditional
  costDirect
  costEquipment
  costIndirect
  costLabour
  costMaterial
  costOverhead
  costTotal
  grossMargin
  grossMarginPercentage
  id
  externalId
  isSendable
  layout
  netMargin
  netMarginPercentage
  operatingMargin
  operatingMarginPercentage
  overallTotal
  profit
  profitPercentage
  proposalNotes
  createdAt
  removeUnitPriceAndQuantity
  removeIndividualLineItemPricing
  isChangeOrder
  user {
    id
    firstName
    lastName
    email
  }
  userId
  events {
    action
    createdAt
  }
  statusChanges {
    changeAt
    status
  }
  salesTaxes {
    id
    name
    percentage
    organizationSalesTaxId
  }
  costTaxes
  overallTotalAfterTaxes
  acceptanceOverride
  attachments {
    id
    name
    path
  }
  changeOrders {
    id
    externalId
    status
    overallTotalAfterTaxes
    changeOrderJobId
  }
  version
  changeOrderJobId
  projectFilesFolderId
  versions {
    id
    version
    externalId
    status
    overallTotalAfterTaxes
    activeVersion
  }
  clientEmailOverride
  emailSubjectOverride
  emailBodyOverride
  emailBodyOverrideParsed
}
    ${BitumioProposalStageFragmentDoc}`;
export const CreateOrganizationApiKeyDocument = gql`
    mutation CreateOrganizationApiKey($description: String!) {
  CreateOrganizationApiKey(description: $description) {
    success
  }
}
    `;
export type CreateOrganizationApiKeyMutationFn = Apollo.MutationFunction<CreateOrganizationApiKeyMutation, CreateOrganizationApiKeyMutationVariables>;

/**
 * __useCreateOrganizationApiKeyMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationApiKeyMutation, { data, loading, error }] = useCreateOrganizationApiKeyMutation({
 *   variables: {
 *      description: // value for 'description'
 *   },
 * });
 */
export function useCreateOrganizationApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationApiKeyMutation, CreateOrganizationApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationApiKeyMutation, CreateOrganizationApiKeyMutationVariables>(CreateOrganizationApiKeyDocument, options);
      }
export type CreateOrganizationApiKeyMutationHookResult = ReturnType<typeof useCreateOrganizationApiKeyMutation>;
export type CreateOrganizationApiKeyMutationResult = Apollo.MutationResult<CreateOrganizationApiKeyMutation>;
export type CreateOrganizationApiKeyMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationApiKeyMutation, CreateOrganizationApiKeyMutationVariables>;
export const DeleteOrganizationApiKeyDocument = gql`
    mutation DeleteOrganizationApiKey($id: ID!) {
  DeleteOrganizationApiKey(id: $id) {
    success
  }
}
    `;
export type DeleteOrganizationApiKeyMutationFn = Apollo.MutationFunction<DeleteOrganizationApiKeyMutation, DeleteOrganizationApiKeyMutationVariables>;

/**
 * __useDeleteOrganizationApiKeyMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationApiKeyMutation, { data, loading, error }] = useDeleteOrganizationApiKeyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOrganizationApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganizationApiKeyMutation, DeleteOrganizationApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganizationApiKeyMutation, DeleteOrganizationApiKeyMutationVariables>(DeleteOrganizationApiKeyDocument, options);
      }
export type DeleteOrganizationApiKeyMutationHookResult = ReturnType<typeof useDeleteOrganizationApiKeyMutation>;
export type DeleteOrganizationApiKeyMutationResult = Apollo.MutationResult<DeleteOrganizationApiKeyMutation>;
export type DeleteOrganizationApiKeyMutationOptions = Apollo.BaseMutationOptions<DeleteOrganizationApiKeyMutation, DeleteOrganizationApiKeyMutationVariables>;
export const AcceptUserInviteDocument = gql`
    mutation acceptUserInvite($input: AcceptUserInviteInput!) {
  acceptUserInvite(input: $input) {
    addressCity
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZip
    autoAssign
    avatar
    crewsCount
    email
    firstName
    hasEmployee
    id
    inviteToken
    invitedAt
    invitedBy {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          proposalDefaults {
            autoSave
            color
            id
            layout
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
    jobPhasesCount
    jobsCount
    lastName
    name
    organization {
      email
      emailTemplate
      failingPayment
      id
      logo
      name
      onTrial
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    permissions
    phone
    proposalCount
    roles
    status
  }
}
    `;
export type AcceptUserInviteMutationFn = Apollo.MutationFunction<AcceptUserInviteMutation, AcceptUserInviteMutationVariables>;

/**
 * __useAcceptUserInviteMutation__
 *
 * To run a mutation, you first call `useAcceptUserInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptUserInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptUserInviteMutation, { data, loading, error }] = useAcceptUserInviteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptUserInviteMutation(baseOptions?: Apollo.MutationHookOptions<AcceptUserInviteMutation, AcceptUserInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptUserInviteMutation, AcceptUserInviteMutationVariables>(AcceptUserInviteDocument, options);
      }
export type AcceptUserInviteMutationHookResult = ReturnType<typeof useAcceptUserInviteMutation>;
export type AcceptUserInviteMutationResult = Apollo.MutationResult<AcceptUserInviteMutation>;
export type AcceptUserInviteMutationOptions = Apollo.BaseMutationOptions<AcceptUserInviteMutation, AcceptUserInviteMutationVariables>;
export const AddJobPhaseCostsDocument = gql`
    mutation addJobPhaseCosts($input: AddJobPhaseCostsInput!) {
  addJobPhaseCosts(input: $input) {
    additionalCosts {
      additionalCostId
      cost
      costTotal
      feeAmount
      feeType
      id
      jobPhaseCostItem {
        additionalCosts {
          additionalCostId
          cost
          costTotal
          feeAmount
          feeType
          id
          name
        }
        costAdditional
        costEquipment
        costLabour
        costMaterial
        costTransferTruck
        date
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        equipmentPieces {
          equipmentPieceId
          id
          name
          quantity
          rate
          timeOnjob
          timeTravel
        }
        id
        jobPhase {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualEmployeeHours
          actualGrossMargin
          actualGrossMarginPercentage
          actualMaterialNeeded
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address
          applicableStatuses
          costItems {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          crew {
            color
            displayName
            id
            name
            rate
          }
          crewId
          defaultAdditionalCosts {
            cost
            feeAmount
            feeType
            id
            name
          }
          defaultEmployees {
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          defaultEquipmentPieces {
            chargeType
            fuelSurcharge
            id
            name
            rate
            usePercentage
          }
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          endsAt
          externalId
          files {
            createdAt
            filename
            id
            thumbnail
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            endsAt
            externalId
            id
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
          }
          jobDuration
          jobPhasePlant {
            id
            name
            type
          }
          jobSize
          notes
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          organizationProductType {
            id
            indirectPercentage
            markupPercentage
            name
            overheadPercentage
            type
          }
          organizationProductTypeName
          productName
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          proposalProduct {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          proposalStage {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedEmployeeHours
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedMaterialNeeded
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          scheduleBlocks {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          scheduledBlockForDate {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          startsAt
          status
          travelTimeEstimate
          users {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          usersColor
          workOrderCrews {
            crewId
            id
            name
          }
          workOrderEquipmentPieces {
            equipmentPieceId
            id
            name
          }
          workOrderTransferTrucks {
            id
            name
            quantity
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
        }
        material {
          costMaterial
          id
          jobPhaseCostItem {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          materialNeeded
          name
          organizationProductTypeName
          type
        }
        plantId
        plantProductId
        transferTrucks {
          hours
          id
          name
          plantTransferTruckId
          rateHourly
          rateTon
          tonnage
          transferTruckId
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
      }
      name
    }
    costAdditional
    costEquipment
    costLabour
    costMaterial
    costTransferTruck
    date
    employees {
      employeeId
      id
      name
      rate
      timeOnjob
      timeTravel
    }
    equipmentPieces {
      equipmentPieceId
      id
      name
      quantity
      rate
      timeOnjob
      timeTravel
    }
    id
    jobPhase {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualEmployeeHours
      actualGrossMargin
      actualGrossMarginPercentage
      actualMaterialNeeded
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      address
      applicableStatuses
      crewId
      endsAt
      externalId
      id
      jobDuration
      jobSize
      notes
      organizationProductTypeName
      productName
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedEmployeeHours
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedMaterialNeeded
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      startsAt
      status
      travelTimeEstimate
      usersColor
    }
    material {
      costMaterial
      id
      materialNeeded
      name
      organizationProductTypeName
      type
    }
    plantId
    plantProductId
    transferTrucks {
      hours
      id
      name
      plantTransferTruckId
      rateHourly
      rateTon
      tonnage
      transferTruckId
    }
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
  }
}
    `;
export type AddJobPhaseCostsMutationFn = Apollo.MutationFunction<AddJobPhaseCostsMutation, AddJobPhaseCostsMutationVariables>;

/**
 * __useAddJobPhaseCostsMutation__
 *
 * To run a mutation, you first call `useAddJobPhaseCostsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddJobPhaseCostsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addJobPhaseCostsMutation, { data, loading, error }] = useAddJobPhaseCostsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddJobPhaseCostsMutation(baseOptions?: Apollo.MutationHookOptions<AddJobPhaseCostsMutation, AddJobPhaseCostsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddJobPhaseCostsMutation, AddJobPhaseCostsMutationVariables>(AddJobPhaseCostsDocument, options);
      }
export type AddJobPhaseCostsMutationHookResult = ReturnType<typeof useAddJobPhaseCostsMutation>;
export type AddJobPhaseCostsMutationResult = Apollo.MutationResult<AddJobPhaseCostsMutation>;
export type AddJobPhaseCostsMutationOptions = Apollo.BaseMutationOptions<AddJobPhaseCostsMutation, AddJobPhaseCostsMutationVariables>;
export const AddJobPhaseFileDocument = gql`
    mutation addJobPhaseFile($jobPhaseId: ID!, $path: String!) {
  addJobPhaseFile(jobPhaseId: $jobPhaseId, path: $path) {
    actualCostAdditional
    actualCostDirect
    actualCostEquipment
    actualCostIndirect
    actualCostLabour
    actualCostMaterial
    actualCostOverhead
    actualCostTotal
    actualCostTransferTruck
    actualEmployeeHours
    actualGrossMargin
    actualGrossMarginPercentage
    actualMaterialNeeded
    actualNetMargin
    actualNetMarginPercentage
    actualOperatingMargin
    actualOperatingMarginPercentage
    actualOverallTotal
    actualProfit
    actualProfitPercentage
    address
    applicableStatuses
    costItems {
      additionalCosts {
        additionalCostId
        cost
        costTotal
        feeAmount
        feeType
        id
        jobPhaseCostItem {
          additionalCosts {
            additionalCostId
            cost
            costTotal
            feeAmount
            feeType
            id
            name
          }
          costAdditional
          costEquipment
          costLabour
          costMaterial
          costTransferTruck
          date
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          equipmentPieces {
            equipmentPieceId
            id
            name
            quantity
            rate
            timeOnjob
            timeTravel
          }
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            address
            applicableStatuses
            crewId
            endsAt
            externalId
            id
            jobDuration
            jobSize
            notes
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          material {
            costMaterial
            id
            materialNeeded
            name
            organizationProductTypeName
            type
          }
          plantId
          plantProductId
          transferTrucks {
            hours
            id
            name
            plantTransferTruckId
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
        }
        name
      }
      costAdditional
      costEquipment
      costLabour
      costMaterial
      costTransferTruck
      date
      employees {
        employeeId
        id
        name
        rate
        timeOnjob
        timeTravel
      }
      equipmentPieces {
        equipmentPieceId
        id
        name
        quantity
        rate
        timeOnjob
        timeTravel
      }
      id
      jobPhase {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualEmployeeHours
        actualGrossMargin
        actualGrossMarginPercentage
        actualMaterialNeeded
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        address
        applicableStatuses
        costItems {
          costAdditional
          costEquipment
          costLabour
          costMaterial
          costTransferTruck
          date
          id
          material {
            costMaterial
            id
            materialNeeded
            name
            organizationProductTypeName
            type
          }
          plantId
          plantProductId
          transferTrucks {
            hours
            id
            name
            plantTransferTruckId
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
        }
        crew {
          color
          displayName
          employees {
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          id
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          rate
        }
        crewId
        defaultAdditionalCosts {
          cost
          feeAmount
          feeType
          id
          name
        }
        defaultEmployees {
          firstName
          id
          lastName
          name
          organizationId
          rate
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
        }
        defaultEquipmentPieces {
          chargeType
          fuelSurcharge
          id
          name
          rate
          usePercentage
        }
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        endsAt
        externalId
        files {
          createdAt
          filename
          id
          thumbnail
        }
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        id
        job {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualGrossMargin
          actualGrossMarginPercentage
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          billingStatus
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          datePushedToQuickbooks
          endsAt
          externalId
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          id
          jobPhases {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            address
            applicableStatuses
            crewId
            endsAt
            externalId
            id
            jobDuration
            jobSize
            notes
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          mayShowTaxNotification
          notes
          projectFilesFolderId
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          proposalId
          proposalStage {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          shouldPushTaxesToQuickbooks
          startsAt
          status
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
        }
        jobDuration
        jobPhasePlant {
          id
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            rate
            type
          }
          type
        }
        jobSize
        notes
        organization {
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          proposalDefaults {
            autoSave
            color
            id
            layout
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        organizationProductType {
          id
          indirectPercentage
          markupPercentage
          name
          overheadPercentage
          type
        }
        organizationProductTypeName
        productName
        proposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        proposalProduct {
          additionalCosts {
            additionalCostId
            cost
            costOverride
            costTotal
            feeAmount
            feeAmountOverride
            feeType
            id
            name
            quantity
            quantityOverride
            showOnProposal
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          costTransferTruck
          crews {
            cost
            crewId
            id
            name
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
          }
          equipmentPieces {
            chargeType
            cost
            equipmentPieceId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
            usePercentage
          }
          externalProductName
          files {
            createdAt
            filename
            id
            thumbnail
            type
          }
          grossMargin
          grossMarginPercentage
          id
          isOptional
          jobDuration
          jobDurationDaysOverride
          jobDurationOverride
          jobSize
          mapData
          mapImage
          mapImageDirty
          material {
            areaCoverage
            attributes {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            attributesOverride {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            costMaterial
            costMaterialOverride
            costMinimumProduct
            costMinimumProposal
            dailyUnitsComplete
            dailyUnitsCompleteOverride
            externalProductName
            id
            indirectPercentage
            indirectPercentageOverride
            labourCostType
            markupPercentage
            markupPercentageOverride
            materialNeeded
            materialNeededOverride
            measurementJob
            measurementMaterial
            name
            organizationProductTypeName
            overheadPercentage
            overheadPercentageOverride
            productId
            productionRateType
            proposalId
            proposalProductId
            proposalStageId
            statementOfWork
            statementOfWorkOverride
            subcontracted
            tonConversionFactor
            tonConversionFactorOverride
            type
            unitPrice
            unitPriceOverride
            unitPriceProduct
          }
          measurementJob
          measurementMaterial
          netMargin
          netMarginPercentage
          notes
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalOverride
          plantProduct {
            id
            plantProductId
            rate
            rateOverride
            type
          }
          productName
          profit
          profitPercentage
          profitPercentageOverride
          roundTripTravelTimeHours
          statementOfWork
          subcontractorCost
          subcontractorName
          subcontractorProposalId
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTime
          transferTruckRoundTripTimeOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            quantity
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
        }
        proposalStage {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          profit
          profitPercentage
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          roundTripTravelTimeHours
        }
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedEmployeeHours
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedMaterialNeeded
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        scheduleBlocks {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            endsAt
            externalId
            id
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            address
            applicableStatuses
            crewId
            endsAt
            externalId
            id
            jobDuration
            jobSize
            notes
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        scheduledBlockForDate {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            endsAt
            externalId
            id
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            address
            applicableStatuses
            crewId
            endsAt
            externalId
            id
            jobDuration
            jobSize
            notes
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        startsAt
        status
        travelTimeEstimate
        users {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        usersColor
        workOrderCrews {
          crewId
          id
          name
        }
        workOrderEquipmentPieces {
          equipmentPieceId
          id
          name
        }
        workOrderTransferTrucks {
          id
          name
          quantity
          rateHourly
          rateTon
          tonnage
          transferTruckId
        }
      }
      plantId
      plantProductId
    }
    crew {
      color
      displayName
      id
      name
      rate
    }
    crewId
    defaultAdditionalCosts {
      cost
      feeAmount
      feeType
      id
      name
    }
    defaultEmployees {
      firstName
      id
      lastName
      name
      organizationId
      rate
      userId
    }
    defaultEquipmentPieces {
      chargeType
      fuelSurcharge
      id
      name
      rate
      usePercentage
    }
    employees {
      employeeId
      id
      name
      rate
      timeOnjob
      timeTravel
    }
    endsAt
    externalId
    files {
      createdAt
      filename
      id
      thumbnail
    }
    foremanUser {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
    id
    job {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualGrossMargin
      actualGrossMarginPercentage
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      billingStatus
      datePushedToQuickbooks
      endsAt
      externalId
      id
      mayShowTaxNotification
      notes
      projectFilesFolderId
      proposalId
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      shouldPushTaxesToQuickbooks
      startsAt
      status
      userId
    }
    jobDuration
    jobPhasePlant {
      id
      name
      type
    }
    jobSize
    notes
    organization {
      email
      emailTemplate
      failingPayment
      id
      logo
      name
      onTrial
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    organizationProductType {
      id
      indirectPercentage
      markupPercentage
      name
      overheadPercentage
      type
    }
    organizationProductTypeName
    productName
    proposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    proposalProduct {
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      costTransferTruck
      externalProductName
      grossMargin
      grossMarginPercentage
      id
      isOptional
      jobDuration
      jobDurationDaysOverride
      jobDurationOverride
      jobSize
      mapData
      mapImage
      mapImageDirty
      measurementJob
      measurementMaterial
      netMargin
      netMarginPercentage
      notes
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalOverride
      productName
      profit
      profitPercentage
      profitPercentageOverride
      roundTripTravelTimeHours
      statementOfWork
      subcontractorCost
      subcontractorName
      subcontractorProposalId
      transferTruckLoadTimeBuffer
      transferTruckRoundTripTime
      transferTruckRoundTripTimeOverride
      transferTruckUnloadTimeBuffer
    }
    proposalStage {
      addressOverride
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      profit
      profitPercentage
      roundTripTravelTimeHours
    }
    proposedCostAdditional
    proposedCostDirect
    proposedCostEquipment
    proposedCostIndirect
    proposedCostLabour
    proposedCostMaterial
    proposedCostOverhead
    proposedCostTotal
    proposedCostTransferTruck
    proposedEmployeeHours
    proposedGrossMargin
    proposedGrossMarginPercentage
    proposedMaterialNeeded
    proposedNetMargin
    proposedNetMarginPercentage
    proposedOperatingMargin
    proposedOperatingMarginPercentage
    proposedOverallTotal
    proposedProfit
    proposedProfitPercentage
    scheduleBlocks {
      blockLength
      endsAt
      estimatedMaterial
      estimatedMaterialOverride
      id
      scheduledAt
      showTravelFrom
      showTravelTo
      travelTime
    }
    scheduledBlockForDate {
      blockLength
      endsAt
      estimatedMaterial
      estimatedMaterialOverride
      id
      scheduledAt
      showTravelFrom
      showTravelTo
      travelTime
    }
    startsAt
    status
    travelTimeEstimate
    users {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
    usersColor
    workOrderCrews {
      crewId
      id
      name
    }
    workOrderEquipmentPieces {
      equipmentPieceId
      id
      name
    }
    workOrderTransferTrucks {
      id
      name
      quantity
      rateHourly
      rateTon
      tonnage
      transferTruckId
    }
  }
}
    `;
export type AddJobPhaseFileMutationFn = Apollo.MutationFunction<AddJobPhaseFileMutation, AddJobPhaseFileMutationVariables>;

/**
 * __useAddJobPhaseFileMutation__
 *
 * To run a mutation, you first call `useAddJobPhaseFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddJobPhaseFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addJobPhaseFileMutation, { data, loading, error }] = useAddJobPhaseFileMutation({
 *   variables: {
 *      jobPhaseId: // value for 'jobPhaseId'
 *      path: // value for 'path'
 *   },
 * });
 */
export function useAddJobPhaseFileMutation(baseOptions?: Apollo.MutationHookOptions<AddJobPhaseFileMutation, AddJobPhaseFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddJobPhaseFileMutation, AddJobPhaseFileMutationVariables>(AddJobPhaseFileDocument, options);
      }
export type AddJobPhaseFileMutationHookResult = ReturnType<typeof useAddJobPhaseFileMutation>;
export type AddJobPhaseFileMutationResult = Apollo.MutationResult<AddJobPhaseFileMutation>;
export type AddJobPhaseFileMutationOptions = Apollo.BaseMutationOptions<AddJobPhaseFileMutation, AddJobPhaseFileMutationVariables>;
export const AddOrganizationDataUploadDocument = gql`
    mutation addOrganizationDataUpload($input: AddOrganizationDataUploadInput!) {
  addOrganizationDataUpload(input: $input) {
    createdAt
    error
    id
    organization {
      conversionFactorOverride {
        asphaltTonConversionFactorOverride
        excavateOutTonConversionFactorOverride
        id
        organization {
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          proposalDefaults {
            autoSave
            color
            id
            layout
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
      }
      email
      emailTemplate
      failingPayment
      id
      logo
      name
      onTrial
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    path
    startedAt
    status
    type
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        email
        emailTemplate
        failingPayment
        id
        logo
        name
        onTrial
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      status
    }
  }
}
    `;
export type AddOrganizationDataUploadMutationFn = Apollo.MutationFunction<AddOrganizationDataUploadMutation, AddOrganizationDataUploadMutationVariables>;

/**
 * __useAddOrganizationDataUploadMutation__
 *
 * To run a mutation, you first call `useAddOrganizationDataUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrganizationDataUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrganizationDataUploadMutation, { data, loading, error }] = useAddOrganizationDataUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddOrganizationDataUploadMutation(baseOptions?: Apollo.MutationHookOptions<AddOrganizationDataUploadMutation, AddOrganizationDataUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddOrganizationDataUploadMutation, AddOrganizationDataUploadMutationVariables>(AddOrganizationDataUploadDocument, options);
      }
export type AddOrganizationDataUploadMutationHookResult = ReturnType<typeof useAddOrganizationDataUploadMutation>;
export type AddOrganizationDataUploadMutationResult = Apollo.MutationResult<AddOrganizationDataUploadMutation>;
export type AddOrganizationDataUploadMutationOptions = Apollo.BaseMutationOptions<AddOrganizationDataUploadMutation, AddOrganizationDataUploadMutationVariables>;
export const AddOrganizationDocumentDocument = gql`
    mutation addOrganizationDocument($name: String!, $path: String!) {
  addOrganizationDocument(name: $name, path: $path) {
    conversionFactorOverride {
      asphaltTonConversionFactorOverride
      excavateOutTonConversionFactorOverride
      id
      organization {
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
        }
        documents {
          id
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        phone
        proposalDefaults {
          autoSave
          color
          id
          layout
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
    }
    documents {
      id
      name
      path
      thumbnailPath
    }
    email
    emailTemplate
    failingPayment
    id
    linkedServices {
      active
      expired
      id
      service
      type
    }
    logo
    name
    onTrial
    phone
    proposalDefaults {
      autoSave
      color
      id
      layout
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
    }
    proposalSentEmailText
    salesTaxes {
      id
      isDefault
      name
      percentage
      quickbooksDesktopTaxCodeId
      quickbooksTaxCodeId
    }
    subscribed
    subscription {
      endsAt
      id
      name
      quantity
      renewsAt
      stripeId
      stripePrice
      stripeStatus
      trialEndsAt
    }
    timezone
    trialEndsAt
  }
}
    `;
export type AddOrganizationDocumentMutationFn = Apollo.MutationFunction<AddOrganizationDocumentMutation, AddOrganizationDocumentMutationVariables>;

/**
 * __useAddOrganizationDocumentMutation__
 *
 * To run a mutation, you first call `useAddOrganizationDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrganizationDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrganizationDocumentMutation, { data, loading, error }] = useAddOrganizationDocumentMutation({
 *   variables: {
 *      name: // value for 'name'
 *      path: // value for 'path'
 *   },
 * });
 */
export function useAddOrganizationDocumentMutation(baseOptions?: Apollo.MutationHookOptions<AddOrganizationDocumentMutation, AddOrganizationDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddOrganizationDocumentMutation, AddOrganizationDocumentMutationVariables>(AddOrganizationDocumentDocument, options);
      }
export type AddOrganizationDocumentMutationHookResult = ReturnType<typeof useAddOrganizationDocumentMutation>;
export type AddOrganizationDocumentMutationResult = Apollo.MutationResult<AddOrganizationDocumentMutation>;
export type AddOrganizationDocumentMutationOptions = Apollo.BaseMutationOptions<AddOrganizationDocumentMutation, AddOrganizationDocumentMutationVariables>;
export const AddProductToProposalStageDocument = gql`
    mutation addProductToProposalStage($productId: ID!, $proposalStageId: ID!) {
  addProductToProposalStage(
    productId: $productId
    proposalStageId: $proposalStageId
  ) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        phone
        proposalDefaults {
          autoSave
          color
          id
          layout
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        events {
          action
          createdAt
        }
        externalId
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterTaxes
        profit
        profitPercentage
        projectFilesFolderId
        proposalNotes
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          profit
          profitPercentage
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          roundTripTravelTimeHours
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          status
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
        uuid
        version
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    clientEmailOverride
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    events {
      action
      createdAt
    }
    externalId
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isSendable
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    overallTotal
    overallTotalAfterTaxes
    profit
    profitPercentage
    projectFilesFolderId
    proposalNotes
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      profit
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
    userId
    uuid
    version
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    wonAt
  }
}
    `;
export type AddProductToProposalStageMutationFn = Apollo.MutationFunction<AddProductToProposalStageMutation, AddProductToProposalStageMutationVariables>;

/**
 * __useAddProductToProposalStageMutation__
 *
 * To run a mutation, you first call `useAddProductToProposalStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProductToProposalStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProductToProposalStageMutation, { data, loading, error }] = useAddProductToProposalStageMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      proposalStageId: // value for 'proposalStageId'
 *   },
 * });
 */
export function useAddProductToProposalStageMutation(baseOptions?: Apollo.MutationHookOptions<AddProductToProposalStageMutation, AddProductToProposalStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProductToProposalStageMutation, AddProductToProposalStageMutationVariables>(AddProductToProposalStageDocument, options);
      }
export type AddProductToProposalStageMutationHookResult = ReturnType<typeof useAddProductToProposalStageMutation>;
export type AddProductToProposalStageMutationResult = Apollo.MutationResult<AddProductToProposalStageMutation>;
export type AddProductToProposalStageMutationOptions = Apollo.BaseMutationOptions<AddProductToProposalStageMutation, AddProductToProposalStageMutationVariables>;
export const AddProjectFileDocument = gql`
    mutation addProjectFile($name: String!, $parentFolderId: ID, $path: String!) {
  addProjectFile(name: $name, parentFolderId: $parentFolderId, path: $path) {
    children {
      children {
        fileSizeBytes
        id
        name
        parentFolderId
        path
        type
      }
      fileSizeBytes
      id
      name
      parentFolderId
      path
      type
    }
    fileSizeBytes
    id
    name
    parentFolderId
    path
    type
  }
}
    `;
export type AddProjectFileMutationFn = Apollo.MutationFunction<AddProjectFileMutation, AddProjectFileMutationVariables>;

/**
 * __useAddProjectFileMutation__
 *
 * To run a mutation, you first call `useAddProjectFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProjectFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProjectFileMutation, { data, loading, error }] = useAddProjectFileMutation({
 *   variables: {
 *      name: // value for 'name'
 *      parentFolderId: // value for 'parentFolderId'
 *      path: // value for 'path'
 *   },
 * });
 */
export function useAddProjectFileMutation(baseOptions?: Apollo.MutationHookOptions<AddProjectFileMutation, AddProjectFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProjectFileMutation, AddProjectFileMutationVariables>(AddProjectFileDocument, options);
      }
export type AddProjectFileMutationHookResult = ReturnType<typeof useAddProjectFileMutation>;
export type AddProjectFileMutationResult = Apollo.MutationResult<AddProjectFileMutation>;
export type AddProjectFileMutationOptions = Apollo.BaseMutationOptions<AddProjectFileMutation, AddProjectFileMutationVariables>;
export const AddProposalAdditionalCostDocument = gql`
    mutation addProposalAdditionalCost($additionalCostId: ID!, $proposalProductId: ID!) {
  addProposalAdditionalCost(
    additionalCostId: $additionalCostId
    proposalProductId: $proposalProductId
  ) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        phone
        proposalDefaults {
          autoSave
          color
          id
          layout
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        events {
          action
          createdAt
        }
        externalId
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterTaxes
        profit
        profitPercentage
        projectFilesFolderId
        proposalNotes
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          profit
          profitPercentage
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          roundTripTravelTimeHours
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          status
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
        uuid
        version
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    clientEmailOverride
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    events {
      action
      createdAt
    }
    externalId
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isSendable
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    overallTotal
    overallTotalAfterTaxes
    profit
    profitPercentage
    projectFilesFolderId
    proposalNotes
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      profit
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
    userId
    uuid
    version
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    wonAt
  }
}
    `;
export type AddProposalAdditionalCostMutationFn = Apollo.MutationFunction<AddProposalAdditionalCostMutation, AddProposalAdditionalCostMutationVariables>;

/**
 * __useAddProposalAdditionalCostMutation__
 *
 * To run a mutation, you first call `useAddProposalAdditionalCostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProposalAdditionalCostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProposalAdditionalCostMutation, { data, loading, error }] = useAddProposalAdditionalCostMutation({
 *   variables: {
 *      additionalCostId: // value for 'additionalCostId'
 *      proposalProductId: // value for 'proposalProductId'
 *   },
 * });
 */
export function useAddProposalAdditionalCostMutation(baseOptions?: Apollo.MutationHookOptions<AddProposalAdditionalCostMutation, AddProposalAdditionalCostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProposalAdditionalCostMutation, AddProposalAdditionalCostMutationVariables>(AddProposalAdditionalCostDocument, options);
      }
export type AddProposalAdditionalCostMutationHookResult = ReturnType<typeof useAddProposalAdditionalCostMutation>;
export type AddProposalAdditionalCostMutationResult = Apollo.MutationResult<AddProposalAdditionalCostMutation>;
export type AddProposalAdditionalCostMutationOptions = Apollo.BaseMutationOptions<AddProposalAdditionalCostMutation, AddProposalAdditionalCostMutationVariables>;
export const AddProposalAdditionalCostsDocument = gql`
    mutation addProposalAdditionalCosts($additionalCosts: [ID!]!, $proposalProductId: ID!) {
  addProposalAdditionalCosts(
    additionalCosts: $additionalCosts
    proposalProductId: $proposalProductId
  ) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        phone
        proposalDefaults {
          autoSave
          color
          id
          layout
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        events {
          action
          createdAt
        }
        externalId
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterTaxes
        profit
        profitPercentage
        projectFilesFolderId
        proposalNotes
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          profit
          profitPercentage
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          roundTripTravelTimeHours
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          status
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
        uuid
        version
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    clientEmailOverride
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    events {
      action
      createdAt
    }
    externalId
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isSendable
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    overallTotal
    overallTotalAfterTaxes
    profit
    profitPercentage
    projectFilesFolderId
    proposalNotes
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      profit
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
    userId
    uuid
    version
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    wonAt
  }
}
    `;
export type AddProposalAdditionalCostsMutationFn = Apollo.MutationFunction<AddProposalAdditionalCostsMutation, AddProposalAdditionalCostsMutationVariables>;

/**
 * __useAddProposalAdditionalCostsMutation__
 *
 * To run a mutation, you first call `useAddProposalAdditionalCostsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProposalAdditionalCostsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProposalAdditionalCostsMutation, { data, loading, error }] = useAddProposalAdditionalCostsMutation({
 *   variables: {
 *      additionalCosts: // value for 'additionalCosts'
 *      proposalProductId: // value for 'proposalProductId'
 *   },
 * });
 */
export function useAddProposalAdditionalCostsMutation(baseOptions?: Apollo.MutationHookOptions<AddProposalAdditionalCostsMutation, AddProposalAdditionalCostsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProposalAdditionalCostsMutation, AddProposalAdditionalCostsMutationVariables>(AddProposalAdditionalCostsDocument, options);
      }
export type AddProposalAdditionalCostsMutationHookResult = ReturnType<typeof useAddProposalAdditionalCostsMutation>;
export type AddProposalAdditionalCostsMutationResult = Apollo.MutationResult<AddProposalAdditionalCostsMutation>;
export type AddProposalAdditionalCostsMutationOptions = Apollo.BaseMutationOptions<AddProposalAdditionalCostsMutation, AddProposalAdditionalCostsMutationVariables>;
export const AddProposalAddressDocument = gql`
    mutation addProposalAddress($input: AddProposalAddressInput!) {
  addProposalAddress(input: $input) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        phone
        proposalDefaults {
          autoSave
          color
          id
          layout
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        events {
          action
          createdAt
        }
        externalId
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterTaxes
        profit
        profitPercentage
        projectFilesFolderId
        proposalNotes
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          profit
          profitPercentage
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          roundTripTravelTimeHours
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          status
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
        uuid
        version
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    clientEmailOverride
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    events {
      action
      createdAt
    }
    externalId
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isSendable
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    overallTotal
    overallTotalAfterTaxes
    profit
    profitPercentage
    projectFilesFolderId
    proposalNotes
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      profit
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
    userId
    uuid
    version
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    wonAt
  }
}
    `;
export type AddProposalAddressMutationFn = Apollo.MutationFunction<AddProposalAddressMutation, AddProposalAddressMutationVariables>;

/**
 * __useAddProposalAddressMutation__
 *
 * To run a mutation, you first call `useAddProposalAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProposalAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProposalAddressMutation, { data, loading, error }] = useAddProposalAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddProposalAddressMutation(baseOptions?: Apollo.MutationHookOptions<AddProposalAddressMutation, AddProposalAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProposalAddressMutation, AddProposalAddressMutationVariables>(AddProposalAddressDocument, options);
      }
export type AddProposalAddressMutationHookResult = ReturnType<typeof useAddProposalAddressMutation>;
export type AddProposalAddressMutationResult = Apollo.MutationResult<AddProposalAddressMutation>;
export type AddProposalAddressMutationOptions = Apollo.BaseMutationOptions<AddProposalAddressMutation, AddProposalAddressMutationVariables>;
export const AddProposalCrewDocument = gql`
    mutation addProposalCrew($crewId: ID!, $proposalProductId: ID!) {
  addProposalCrew(crewId: $crewId, proposalProductId: $proposalProductId) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        phone
        proposalDefaults {
          autoSave
          color
          id
          layout
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        events {
          action
          createdAt
        }
        externalId
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterTaxes
        profit
        profitPercentage
        projectFilesFolderId
        proposalNotes
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          profit
          profitPercentage
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          roundTripTravelTimeHours
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          status
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
        uuid
        version
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    clientEmailOverride
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    events {
      action
      createdAt
    }
    externalId
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isSendable
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    overallTotal
    overallTotalAfterTaxes
    profit
    profitPercentage
    projectFilesFolderId
    proposalNotes
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      profit
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
    userId
    uuid
    version
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    wonAt
  }
}
    `;
export type AddProposalCrewMutationFn = Apollo.MutationFunction<AddProposalCrewMutation, AddProposalCrewMutationVariables>;

/**
 * __useAddProposalCrewMutation__
 *
 * To run a mutation, you first call `useAddProposalCrewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProposalCrewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProposalCrewMutation, { data, loading, error }] = useAddProposalCrewMutation({
 *   variables: {
 *      crewId: // value for 'crewId'
 *      proposalProductId: // value for 'proposalProductId'
 *   },
 * });
 */
export function useAddProposalCrewMutation(baseOptions?: Apollo.MutationHookOptions<AddProposalCrewMutation, AddProposalCrewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProposalCrewMutation, AddProposalCrewMutationVariables>(AddProposalCrewDocument, options);
      }
export type AddProposalCrewMutationHookResult = ReturnType<typeof useAddProposalCrewMutation>;
export type AddProposalCrewMutationResult = Apollo.MutationResult<AddProposalCrewMutation>;
export type AddProposalCrewMutationOptions = Apollo.BaseMutationOptions<AddProposalCrewMutation, AddProposalCrewMutationVariables>;
export const AddProposalCrewsDocument = gql`
    mutation addProposalCrews($crewIds: [ID!]!, $proposalProductId: ID!) {
  addProposalCrews(crewIds: $crewIds, proposalProductId: $proposalProductId) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        phone
        proposalDefaults {
          autoSave
          color
          id
          layout
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        events {
          action
          createdAt
        }
        externalId
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterTaxes
        profit
        profitPercentage
        projectFilesFolderId
        proposalNotes
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          profit
          profitPercentage
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          roundTripTravelTimeHours
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          status
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
        uuid
        version
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    clientEmailOverride
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    events {
      action
      createdAt
    }
    externalId
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isSendable
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    overallTotal
    overallTotalAfterTaxes
    profit
    profitPercentage
    projectFilesFolderId
    proposalNotes
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      profit
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
    userId
    uuid
    version
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    wonAt
  }
}
    `;
export type AddProposalCrewsMutationFn = Apollo.MutationFunction<AddProposalCrewsMutation, AddProposalCrewsMutationVariables>;

/**
 * __useAddProposalCrewsMutation__
 *
 * To run a mutation, you first call `useAddProposalCrewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProposalCrewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProposalCrewsMutation, { data, loading, error }] = useAddProposalCrewsMutation({
 *   variables: {
 *      crewIds: // value for 'crewIds'
 *      proposalProductId: // value for 'proposalProductId'
 *   },
 * });
 */
export function useAddProposalCrewsMutation(baseOptions?: Apollo.MutationHookOptions<AddProposalCrewsMutation, AddProposalCrewsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProposalCrewsMutation, AddProposalCrewsMutationVariables>(AddProposalCrewsDocument, options);
      }
export type AddProposalCrewsMutationHookResult = ReturnType<typeof useAddProposalCrewsMutation>;
export type AddProposalCrewsMutationResult = Apollo.MutationResult<AddProposalCrewsMutation>;
export type AddProposalCrewsMutationOptions = Apollo.BaseMutationOptions<AddProposalCrewsMutation, AddProposalCrewsMutationVariables>;
export const AddProposalEquipmentPieceDocument = gql`
    mutation addProposalEquipmentPiece($equipmentPieceId: ID!, $proposalProductId: ID!, $quantity: Int!) {
  addProposalEquipmentPiece(
    equipmentPieceId: $equipmentPieceId
    proposalProductId: $proposalProductId
    quantity: $quantity
  ) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        phone
        proposalDefaults {
          autoSave
          color
          id
          layout
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        events {
          action
          createdAt
        }
        externalId
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterTaxes
        profit
        profitPercentage
        projectFilesFolderId
        proposalNotes
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          profit
          profitPercentage
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          roundTripTravelTimeHours
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          status
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
        uuid
        version
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    clientEmailOverride
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    events {
      action
      createdAt
    }
    externalId
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isSendable
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    overallTotal
    overallTotalAfterTaxes
    profit
    profitPercentage
    projectFilesFolderId
    proposalNotes
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      profit
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
    userId
    uuid
    version
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    wonAt
  }
}
    `;
export type AddProposalEquipmentPieceMutationFn = Apollo.MutationFunction<AddProposalEquipmentPieceMutation, AddProposalEquipmentPieceMutationVariables>;

/**
 * __useAddProposalEquipmentPieceMutation__
 *
 * To run a mutation, you first call `useAddProposalEquipmentPieceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProposalEquipmentPieceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProposalEquipmentPieceMutation, { data, loading, error }] = useAddProposalEquipmentPieceMutation({
 *   variables: {
 *      equipmentPieceId: // value for 'equipmentPieceId'
 *      proposalProductId: // value for 'proposalProductId'
 *      quantity: // value for 'quantity'
 *   },
 * });
 */
export function useAddProposalEquipmentPieceMutation(baseOptions?: Apollo.MutationHookOptions<AddProposalEquipmentPieceMutation, AddProposalEquipmentPieceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProposalEquipmentPieceMutation, AddProposalEquipmentPieceMutationVariables>(AddProposalEquipmentPieceDocument, options);
      }
export type AddProposalEquipmentPieceMutationHookResult = ReturnType<typeof useAddProposalEquipmentPieceMutation>;
export type AddProposalEquipmentPieceMutationResult = Apollo.MutationResult<AddProposalEquipmentPieceMutation>;
export type AddProposalEquipmentPieceMutationOptions = Apollo.BaseMutationOptions<AddProposalEquipmentPieceMutation, AddProposalEquipmentPieceMutationVariables>;
export const AddProposalEquipmentPiecesDocument = gql`
    mutation addProposalEquipmentPieces($equipmentPieces: [AddProposalEquipmentPieceInput!]!, $proposalProductId: ID!) {
  addProposalEquipmentPieces(
    equipmentPieces: $equipmentPieces
    proposalProductId: $proposalProductId
  ) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        phone
        proposalDefaults {
          autoSave
          color
          id
          layout
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        events {
          action
          createdAt
        }
        externalId
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterTaxes
        profit
        profitPercentage
        projectFilesFolderId
        proposalNotes
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          profit
          profitPercentage
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          roundTripTravelTimeHours
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          status
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
        uuid
        version
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    clientEmailOverride
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    events {
      action
      createdAt
    }
    externalId
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isSendable
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    overallTotal
    overallTotalAfterTaxes
    profit
    profitPercentage
    projectFilesFolderId
    proposalNotes
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      profit
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
    userId
    uuid
    version
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    wonAt
  }
}
    `;
export type AddProposalEquipmentPiecesMutationFn = Apollo.MutationFunction<AddProposalEquipmentPiecesMutation, AddProposalEquipmentPiecesMutationVariables>;

/**
 * __useAddProposalEquipmentPiecesMutation__
 *
 * To run a mutation, you first call `useAddProposalEquipmentPiecesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProposalEquipmentPiecesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProposalEquipmentPiecesMutation, { data, loading, error }] = useAddProposalEquipmentPiecesMutation({
 *   variables: {
 *      equipmentPieces: // value for 'equipmentPieces'
 *      proposalProductId: // value for 'proposalProductId'
 *   },
 * });
 */
export function useAddProposalEquipmentPiecesMutation(baseOptions?: Apollo.MutationHookOptions<AddProposalEquipmentPiecesMutation, AddProposalEquipmentPiecesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProposalEquipmentPiecesMutation, AddProposalEquipmentPiecesMutationVariables>(AddProposalEquipmentPiecesDocument, options);
      }
export type AddProposalEquipmentPiecesMutationHookResult = ReturnType<typeof useAddProposalEquipmentPiecesMutation>;
export type AddProposalEquipmentPiecesMutationResult = Apollo.MutationResult<AddProposalEquipmentPiecesMutation>;
export type AddProposalEquipmentPiecesMutationOptions = Apollo.BaseMutationOptions<AddProposalEquipmentPiecesMutation, AddProposalEquipmentPiecesMutationVariables>;
export const AddProposalFileDocument = gql`
    mutation addProposalFile($path: String!, $proposalProductId: ID!) {
  addProposalFile(path: $path, proposalProductId: $proposalProductId) {
    additionalCosts {
      additionalCostId
      cost
      costOverride
      costTotal
      feeAmount
      feeAmountOverride
      feeType
      id
      name
      quantity
      quantityOverride
      showOnProposal
    }
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTotal
    costTransferTruck
    crews {
      cost
      crewId
      id
      name
      rate
      rateOverride
      timeOnjob
      timeOnjobOverride
      timeTravel
      timeTravelOverride
    }
    equipmentPieces {
      chargeType
      cost
      equipmentPieceId
      id
      name
      quantity
      quantityOverride
      rate
      rateOverride
      timeOnjob
      timeOnjobOverride
      timeTravel
      timeTravelOverride
      usePercentage
    }
    externalProductName
    files {
      createdAt
      filename
      id
      thumbnail
      type
    }
    grossMargin
    grossMarginPercentage
    id
    isOptional
    jobDuration
    jobDurationDaysOverride
    jobDurationOverride
    jobSize
    mapData
    mapImage
    mapImageDirty
    material {
      areaCoverage
      attributes {
        __typename
        ... on ProductAttributeAsphalt {
          applicationRate
        }
        ... on ProductAttributeConcreteColumn {
          diameter
          height
        }
        ... on ProductAttributeConcreteCurbOrGutter {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeConcreteFlatwork {
          applicationRate
        }
        ... on ProductAttributeConcreteFooting {
          depth
          width
        }
        ... on ProductAttributeConcreteWall {
          height
          width
        }
        ... on ProductAttributeConcreteWaterway {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeCrackSeal {
          crackDepth
          crackWidth
          overbandThickness
          overbandWidth
          poundsPerBlock
          poundsPerGallon
        }
        ... on ProductAttributeCurbWall {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeExcavateOut {
          applicationRate
        }
        ... on ProductAttributeGrading {
          applicationRate
          poundsPerCubicYard
        }
        ... on ProductAttributeMastic {
          crackDepth
          crackWidth
          overbandThickness
          overbandWidth
          poundsPerBlock
          poundsPerGallon
        }
        ... on ProductAttributeMicrosurfacing {
          applicationRate
        }
        ... on ProductAttributeSealCoat {
          applicationRate
        }
        ... on ProductAttributeSlurrySeal {
          applicationRate
        }
        ... on ProductAttributeStriping {
          applicationRate
          lineWidth
        }
      }
      attributesOverride {
        __typename
        ... on ProductAttributeAsphalt {
          applicationRate
        }
        ... on ProductAttributeConcreteColumn {
          diameter
          height
        }
        ... on ProductAttributeConcreteCurbOrGutter {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeConcreteFlatwork {
          applicationRate
        }
        ... on ProductAttributeConcreteFooting {
          depth
          width
        }
        ... on ProductAttributeConcreteWall {
          height
          width
        }
        ... on ProductAttributeConcreteWaterway {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeCrackSeal {
          crackDepth
          crackWidth
          overbandThickness
          overbandWidth
          poundsPerBlock
          poundsPerGallon
        }
        ... on ProductAttributeCurbWall {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeExcavateOut {
          applicationRate
        }
        ... on ProductAttributeGrading {
          applicationRate
          poundsPerCubicYard
        }
        ... on ProductAttributeMastic {
          crackDepth
          crackWidth
          overbandThickness
          overbandWidth
          poundsPerBlock
          poundsPerGallon
        }
        ... on ProductAttributeMicrosurfacing {
          applicationRate
        }
        ... on ProductAttributeSealCoat {
          applicationRate
        }
        ... on ProductAttributeSlurrySeal {
          applicationRate
        }
        ... on ProductAttributeStriping {
          applicationRate
          lineWidth
        }
      }
      costMaterial
      costMaterialOverride
      costMinimumProduct
      costMinimumProposal
      dailyUnitsComplete
      dailyUnitsCompleteOverride
      externalProductName
      id
      indirectPercentage
      indirectPercentageOverride
      labourCostType
      markupPercentage
      markupPercentageOverride
      materialNeeded
      materialNeededOverride
      measurementJob
      measurementMaterial
      name
      organizationProductTypeName
      overheadPercentage
      overheadPercentageOverride
      productId
      productionRateType
      proposalId
      proposalProductId
      proposalStageId
      statementOfWork
      statementOfWorkOverride
      subcontracted
      tonConversionFactor
      tonConversionFactorOverride
      type
      unitPrice
      unitPriceOverride
      unitPriceProduct
    }
    measurementJob
    measurementMaterial
    netMargin
    netMarginPercentage
    notes
    operatingMargin
    operatingMarginPercentage
    ordering
    overallTotal
    overallTotalOverride
    plantProduct {
      id
      plant {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        distanceMeters
        distanceSeconds
        id
        name
        phone
        plantId
        rateOnWeight
        roundTripSeconds
      }
      plantProductId
      rate
      rateOverride
      type
    }
    productName
    profit
    profitPercentage
    profitPercentageOverride
    roundTripTravelTimeHours
    statementOfWork
    subcontractorCost
    subcontractorName
    subcontractorProposalId
    transferTruckLoadTimeBuffer
    transferTruckRoundTripTime
    transferTruckRoundTripTimeOverride
    transferTruckUnloadTimeBuffer
    transferTrucks {
      cost
      costOverride
      id
      name
      plantTransferTruckId
      quantity
      rateHourly
      rateHourlyOverride
      rateTon
      rateTonOverride
      tonnage
      totalHaulingHours
      totalHaulingHoursOverride
      transferTruckId
      truckingProductionRate
      trucksNeeded
    }
  }
}
    `;
export type AddProposalFileMutationFn = Apollo.MutationFunction<AddProposalFileMutation, AddProposalFileMutationVariables>;

/**
 * __useAddProposalFileMutation__
 *
 * To run a mutation, you first call `useAddProposalFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProposalFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProposalFileMutation, { data, loading, error }] = useAddProposalFileMutation({
 *   variables: {
 *      path: // value for 'path'
 *      proposalProductId: // value for 'proposalProductId'
 *   },
 * });
 */
export function useAddProposalFileMutation(baseOptions?: Apollo.MutationHookOptions<AddProposalFileMutation, AddProposalFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProposalFileMutation, AddProposalFileMutationVariables>(AddProposalFileDocument, options);
      }
export type AddProposalFileMutationHookResult = ReturnType<typeof useAddProposalFileMutation>;
export type AddProposalFileMutationResult = Apollo.MutationResult<AddProposalFileMutation>;
export type AddProposalFileMutationOptions = Apollo.BaseMutationOptions<AddProposalFileMutation, AddProposalFileMutationVariables>;
export const AddProposalStageDocument = gql`
    mutation addProposalStage($proposalId: ID!) {
  addProposalStage(proposalId: $proposalId) {
    address {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    addressOverride
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTotal
    distanceMeters
    distanceSeconds
    grossMargin
    grossMarginPercentage
    id
    mapData
    mapImage
    mapImageDirty
    name
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    ordering
    overallTotal
    profit
    profitPercentage
    proposalProducts {
      additionalCosts {
        additionalCostId
        cost
        costOverride
        costTotal
        feeAmount
        feeAmountOverride
        feeType
        id
        name
        quantity
        quantityOverride
        showOnProposal
      }
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      costTransferTruck
      crews {
        cost
        crewId
        id
        name
        rate
        rateOverride
        timeOnjob
        timeOnjobOverride
        timeTravel
        timeTravelOverride
      }
      equipmentPieces {
        chargeType
        cost
        equipmentPieceId
        id
        name
        quantity
        quantityOverride
        rate
        rateOverride
        timeOnjob
        timeOnjobOverride
        timeTravel
        timeTravelOverride
        usePercentage
      }
      externalProductName
      files {
        createdAt
        filename
        id
        thumbnail
        type
      }
      grossMargin
      grossMarginPercentage
      id
      isOptional
      jobDuration
      jobDurationDaysOverride
      jobDurationOverride
      jobSize
      mapData
      mapImage
      mapImageDirty
      material {
        areaCoverage
        attributes {
          __typename
          ... on ProductAttributeAsphalt {
            applicationRate
          }
          ... on ProductAttributeConcreteColumn {
            diameter
            height
          }
          ... on ProductAttributeConcreteCurbOrGutter {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeConcreteFlatwork {
            applicationRate
          }
          ... on ProductAttributeConcreteFooting {
            depth
            width
          }
          ... on ProductAttributeConcreteWall {
            height
            width
          }
          ... on ProductAttributeConcreteWaterway {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeCrackSeal {
            crackDepth
            crackWidth
            overbandThickness
            overbandWidth
            poundsPerBlock
            poundsPerGallon
          }
          ... on ProductAttributeCurbWall {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeExcavateOut {
            applicationRate
          }
          ... on ProductAttributeGrading {
            applicationRate
            poundsPerCubicYard
          }
          ... on ProductAttributeMastic {
            crackDepth
            crackWidth
            overbandThickness
            overbandWidth
            poundsPerBlock
            poundsPerGallon
          }
          ... on ProductAttributeMicrosurfacing {
            applicationRate
          }
          ... on ProductAttributeSealCoat {
            applicationRate
          }
          ... on ProductAttributeSlurrySeal {
            applicationRate
          }
          ... on ProductAttributeStriping {
            applicationRate
            lineWidth
          }
        }
        attributesOverride {
          __typename
          ... on ProductAttributeAsphalt {
            applicationRate
          }
          ... on ProductAttributeConcreteColumn {
            diameter
            height
          }
          ... on ProductAttributeConcreteCurbOrGutter {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeConcreteFlatwork {
            applicationRate
          }
          ... on ProductAttributeConcreteFooting {
            depth
            width
          }
          ... on ProductAttributeConcreteWall {
            height
            width
          }
          ... on ProductAttributeConcreteWaterway {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeCrackSeal {
            crackDepth
            crackWidth
            overbandThickness
            overbandWidth
            poundsPerBlock
            poundsPerGallon
          }
          ... on ProductAttributeCurbWall {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeExcavateOut {
            applicationRate
          }
          ... on ProductAttributeGrading {
            applicationRate
            poundsPerCubicYard
          }
          ... on ProductAttributeMastic {
            crackDepth
            crackWidth
            overbandThickness
            overbandWidth
            poundsPerBlock
            poundsPerGallon
          }
          ... on ProductAttributeMicrosurfacing {
            applicationRate
          }
          ... on ProductAttributeSealCoat {
            applicationRate
          }
          ... on ProductAttributeSlurrySeal {
            applicationRate
          }
          ... on ProductAttributeStriping {
            applicationRate
            lineWidth
          }
        }
        costMaterial
        costMaterialOverride
        costMinimumProduct
        costMinimumProposal
        dailyUnitsComplete
        dailyUnitsCompleteOverride
        externalProductName
        id
        indirectPercentage
        indirectPercentageOverride
        labourCostType
        markupPercentage
        markupPercentageOverride
        materialNeeded
        materialNeededOverride
        measurementJob
        measurementMaterial
        name
        organizationProductTypeName
        overheadPercentage
        overheadPercentageOverride
        productId
        productionRateType
        proposalId
        proposalProductId
        proposalStageId
        statementOfWork
        statementOfWorkOverride
        subcontracted
        tonConversionFactor
        tonConversionFactorOverride
        type
        unitPrice
        unitPriceOverride
        unitPriceProduct
      }
      measurementJob
      measurementMaterial
      netMargin
      netMarginPercentage
      notes
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalOverride
      plantProduct {
        id
        plant {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          distanceMeters
          distanceSeconds
          id
          name
          phone
          plantId
          rateOnWeight
          roundTripSeconds
        }
        plantProductId
        rate
        rateOverride
        type
      }
      productName
      profit
      profitPercentage
      profitPercentageOverride
      roundTripTravelTimeHours
      statementOfWork
      subcontractorCost
      subcontractorName
      subcontractorProposalId
      transferTruckLoadTimeBuffer
      transferTruckRoundTripTime
      transferTruckRoundTripTimeOverride
      transferTruckUnloadTimeBuffer
      transferTrucks {
        cost
        costOverride
        id
        name
        plantTransferTruckId
        quantity
        rateHourly
        rateHourlyOverride
        rateTon
        rateTonOverride
        tonnage
        totalHaulingHours
        totalHaulingHoursOverride
        transferTruckId
        truckingProductionRate
        trucksNeeded
      }
    }
    roundTripTravelTimeHours
  }
}
    `;
export type AddProposalStageMutationFn = Apollo.MutationFunction<AddProposalStageMutation, AddProposalStageMutationVariables>;

/**
 * __useAddProposalStageMutation__
 *
 * To run a mutation, you first call `useAddProposalStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProposalStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProposalStageMutation, { data, loading, error }] = useAddProposalStageMutation({
 *   variables: {
 *      proposalId: // value for 'proposalId'
 *   },
 * });
 */
export function useAddProposalStageMutation(baseOptions?: Apollo.MutationHookOptions<AddProposalStageMutation, AddProposalStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProposalStageMutation, AddProposalStageMutationVariables>(AddProposalStageDocument, options);
      }
export type AddProposalStageMutationHookResult = ReturnType<typeof useAddProposalStageMutation>;
export type AddProposalStageMutationResult = Apollo.MutationResult<AddProposalStageMutation>;
export type AddProposalStageMutationOptions = Apollo.BaseMutationOptions<AddProposalStageMutation, AddProposalStageMutationVariables>;
export const AddTruckToProposalProductDocument = gql`
    mutation addTruckToProposalProduct($input: AddTruckToProposalProductInput!) {
  addTruckToProposalProduct(input: $input) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        phone
        proposalDefaults {
          autoSave
          color
          id
          layout
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        events {
          action
          createdAt
        }
        externalId
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterTaxes
        profit
        profitPercentage
        projectFilesFolderId
        proposalNotes
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          profit
          profitPercentage
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          roundTripTravelTimeHours
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          status
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
        uuid
        version
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    clientEmailOverride
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    events {
      action
      createdAt
    }
    externalId
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isSendable
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    overallTotal
    overallTotalAfterTaxes
    profit
    profitPercentage
    projectFilesFolderId
    proposalNotes
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      profit
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
    userId
    uuid
    version
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    wonAt
  }
}
    `;
export type AddTruckToProposalProductMutationFn = Apollo.MutationFunction<AddTruckToProposalProductMutation, AddTruckToProposalProductMutationVariables>;

/**
 * __useAddTruckToProposalProductMutation__
 *
 * To run a mutation, you first call `useAddTruckToProposalProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTruckToProposalProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTruckToProposalProductMutation, { data, loading, error }] = useAddTruckToProposalProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddTruckToProposalProductMutation(baseOptions?: Apollo.MutationHookOptions<AddTruckToProposalProductMutation, AddTruckToProposalProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTruckToProposalProductMutation, AddTruckToProposalProductMutationVariables>(AddTruckToProposalProductDocument, options);
      }
export type AddTruckToProposalProductMutationHookResult = ReturnType<typeof useAddTruckToProposalProductMutation>;
export type AddTruckToProposalProductMutationResult = Apollo.MutationResult<AddTruckToProposalProductMutation>;
export type AddTruckToProposalProductMutationOptions = Apollo.BaseMutationOptions<AddTruckToProposalProductMutation, AddTruckToProposalProductMutationVariables>;
export const AppLoginDocument = gql`
    mutation appLogin($input: LoginInput!) {
  appLogin(input: $input) {
    token
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        phone
        proposalDefaults {
          autoSave
          color
          id
          layout
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      status
    }
  }
}
    `;
export type AppLoginMutationFn = Apollo.MutationFunction<AppLoginMutation, AppLoginMutationVariables>;

/**
 * __useAppLoginMutation__
 *
 * To run a mutation, you first call `useAppLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appLoginMutation, { data, loading, error }] = useAppLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAppLoginMutation(baseOptions?: Apollo.MutationHookOptions<AppLoginMutation, AppLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AppLoginMutation, AppLoginMutationVariables>(AppLoginDocument, options);
      }
export type AppLoginMutationHookResult = ReturnType<typeof useAppLoginMutation>;
export type AppLoginMutationResult = Apollo.MutationResult<AppLoginMutation>;
export type AppLoginMutationOptions = Apollo.BaseMutationOptions<AppLoginMutation, AppLoginMutationVariables>;
export const AppLogoutDocument = gql`
    mutation appLogout {
  appLogout
}
    `;
export type AppLogoutMutationFn = Apollo.MutationFunction<AppLogoutMutation, AppLogoutMutationVariables>;

/**
 * __useAppLogoutMutation__
 *
 * To run a mutation, you first call `useAppLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appLogoutMutation, { data, loading, error }] = useAppLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useAppLogoutMutation(baseOptions?: Apollo.MutationHookOptions<AppLogoutMutation, AppLogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AppLogoutMutation, AppLogoutMutationVariables>(AppLogoutDocument, options);
      }
export type AppLogoutMutationHookResult = ReturnType<typeof useAppLogoutMutation>;
export type AppLogoutMutationResult = Apollo.MutationResult<AppLogoutMutation>;
export type AppLogoutMutationOptions = Apollo.BaseMutationOptions<AppLogoutMutation, AppLogoutMutationVariables>;
export const ArchiveCompanyDocument = gql`
    mutation archiveCompany($id: ID!) {
  archiveCompany(id: $id)
}
    `;
export type ArchiveCompanyMutationFn = Apollo.MutationFunction<ArchiveCompanyMutation, ArchiveCompanyMutationVariables>;

/**
 * __useArchiveCompanyMutation__
 *
 * To run a mutation, you first call `useArchiveCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveCompanyMutation, { data, loading, error }] = useArchiveCompanyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveCompanyMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveCompanyMutation, ArchiveCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveCompanyMutation, ArchiveCompanyMutationVariables>(ArchiveCompanyDocument, options);
      }
export type ArchiveCompanyMutationHookResult = ReturnType<typeof useArchiveCompanyMutation>;
export type ArchiveCompanyMutationResult = Apollo.MutationResult<ArchiveCompanyMutation>;
export type ArchiveCompanyMutationOptions = Apollo.BaseMutationOptions<ArchiveCompanyMutation, ArchiveCompanyMutationVariables>;
export const CancelOpportunityDocument = gql`
    mutation cancelOpportunity($id: ID!) {
  cancelOpportunity(id: $id) {
    addressCity
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZip
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      contacts {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      email
      id
      jobsCount
      logo
      name
      notes
      notificationTypes {
        CONTACT
        JOB
        JOB_PHASE
        OPPORTUNITY
        PROPOSAL
      }
      phone
      primaryContact {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    companyId
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    createdAt
    dueAt
    estimatedOpportunityValue
    externalId
    id
    name
    notes
    products {
      id
      indirectPercentage
      markupPercentage
      name
      overheadPercentage
      type
    }
    projectFilesFolderId
    source
    status
    statusId
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        phone
        proposalDefaults {
          autoSave
          color
          id
          layout
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      status
    }
    userId
  }
}
    `;
export type CancelOpportunityMutationFn = Apollo.MutationFunction<CancelOpportunityMutation, CancelOpportunityMutationVariables>;

/**
 * __useCancelOpportunityMutation__
 *
 * To run a mutation, you first call `useCancelOpportunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelOpportunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelOpportunityMutation, { data, loading, error }] = useCancelOpportunityMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelOpportunityMutation(baseOptions?: Apollo.MutationHookOptions<CancelOpportunityMutation, CancelOpportunityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelOpportunityMutation, CancelOpportunityMutationVariables>(CancelOpportunityDocument, options);
      }
export type CancelOpportunityMutationHookResult = ReturnType<typeof useCancelOpportunityMutation>;
export type CancelOpportunityMutationResult = Apollo.MutationResult<CancelOpportunityMutation>;
export type CancelOpportunityMutationOptions = Apollo.BaseMutationOptions<CancelOpportunityMutation, CancelOpportunityMutationVariables>;
export const CancelProposalDocument = gql`
    mutation cancelProposal($duplicate: Boolean!, $id: ID!, $maintainCurrentId: Boolean) {
  cancelProposal(
    duplicate: $duplicate
    id: $id
    maintainCurrentId: $maintainCurrentId
  ) {
    newProposal {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        organization {
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          proposalDefaults {
            autoSave
            color
            id
            layout
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        addresses {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        attachments {
          id
          name
          path
          thumbnailPath
        }
        changeOrderJobId
        changeOrders {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        clientEmailOverride
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        externalId
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterTaxes
        profit
        profitPercentage
        projectFilesFolderId
        proposalNotes
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        userId
        uuid
        version
        wonAt
      }
      clientEmailOverride
      company {
        addCompanyInfo
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        contacts {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        email
        id
        jobsCount
        logo
        name
        notes
        notificationTypes {
          CONTACT
          JOB
          JOB_PHASE
          OPPORTUNITY
          PROPOSAL
        }
        phone
        primaryContact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        projectFilesFolderId
        proposalsCount
        status
        website
      }
      contact {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      events {
        action
        createdAt
      }
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      recipients {
        contactId
        createdAt
        email
        id
      }
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      salesTaxes {
        id
        name
        organizationSalesTaxId
        percentage
      }
      sentAt
      signedAt
      signedInitials
      signedName
      source
      stages {
        address {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        addressOverride
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        distanceMeters
        distanceSeconds
        grossMargin
        grossMarginPercentage
        id
        mapData
        mapImage
        mapImageDirty
        name
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        profit
        profitPercentage
        proposalProducts {
          additionalCosts {
            additionalCostId
            cost
            costOverride
            costTotal
            feeAmount
            feeAmountOverride
            feeType
            id
            name
            quantity
            quantityOverride
            showOnProposal
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          costTransferTruck
          crews {
            cost
            crewId
            id
            name
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
          }
          equipmentPieces {
            chargeType
            cost
            equipmentPieceId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
            usePercentage
          }
          externalProductName
          files {
            createdAt
            filename
            id
            thumbnail
            type
          }
          grossMargin
          grossMarginPercentage
          id
          isOptional
          jobDuration
          jobDurationDaysOverride
          jobDurationOverride
          jobSize
          mapData
          mapImage
          mapImageDirty
          material {
            areaCoverage
            attributes {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            attributesOverride {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            costMaterial
            costMaterialOverride
            costMinimumProduct
            costMinimumProposal
            dailyUnitsComplete
            dailyUnitsCompleteOverride
            externalProductName
            id
            indirectPercentage
            indirectPercentageOverride
            labourCostType
            markupPercentage
            markupPercentageOverride
            materialNeeded
            materialNeededOverride
            measurementJob
            measurementMaterial
            name
            organizationProductTypeName
            overheadPercentage
            overheadPercentageOverride
            productId
            productionRateType
            proposalId
            proposalProductId
            proposalStageId
            statementOfWork
            statementOfWorkOverride
            subcontracted
            tonConversionFactor
            tonConversionFactorOverride
            type
            unitPrice
            unitPriceOverride
            unitPriceProduct
          }
          measurementJob
          measurementMaterial
          netMargin
          netMarginPercentage
          notes
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalOverride
          plantProduct {
            id
            plantProductId
            rate
            rateOverride
            type
          }
          productName
          profit
          profitPercentage
          profitPercentageOverride
          roundTripTravelTimeHours
          statementOfWork
          subcontractorCost
          subcontractorName
          subcontractorProposalId
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTime
          transferTruckRoundTripTimeOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            quantity
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
        }
        roundTripTravelTimeHours
      }
      status
      statusChanges {
        changeAt
        changedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        status
      }
      user {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          email
          emailTemplate
          failingPayment
          id
          logo
          name
          onTrial
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        status
      }
      userId
      uuid
      version
      versions {
        acceptanceOverride
        activeVersion
        addresses {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        attachments {
          id
          name
          path
          thumbnailPath
        }
        changeOrderJobId
        changeOrders {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          userId
          uuid
          version
          wonAt
        }
        clientEmailOverride
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          email
          id
          jobsCount
          logo
          name
          notes
          phone
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        events {
          action
          createdAt
        }
        externalId
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterTaxes
        profit
        profitPercentage
        projectFilesFolderId
        proposalNotes
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          addressOverride
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          profit
          profitPercentage
          roundTripTravelTimeHours
        }
        status
        statusChanges {
          changeAt
          status
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
        uuid
        version
        versions {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          userId
          uuid
          version
          wonAt
        }
        wonAt
      }
      wonAt
    }
    proposal {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        externalId
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterTaxes
        profit
        profitPercentage
        projectFilesFolderId
        proposalNotes
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        userId
        uuid
        version
        wonAt
      }
      clientEmailOverride
      company {
        addCompanyInfo
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        email
        id
        jobsCount
        logo
        name
        notes
        phone
        projectFilesFolderId
        proposalsCount
        status
        website
      }
      contact {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      events {
        action
        createdAt
      }
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      recipients {
        contactId
        createdAt
        email
        id
      }
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      salesTaxes {
        id
        name
        organizationSalesTaxId
        percentage
      }
      sentAt
      signedAt
      signedInitials
      signedName
      source
      stages {
        addressOverride
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        distanceMeters
        distanceSeconds
        grossMargin
        grossMarginPercentage
        id
        mapData
        mapImage
        mapImageDirty
        name
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        profit
        profitPercentage
        roundTripTravelTimeHours
      }
      status
      statusChanges {
        changeAt
        status
      }
      user {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        status
      }
      userId
      uuid
      version
      versions {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        externalId
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterTaxes
        profit
        profitPercentage
        projectFilesFolderId
        proposalNotes
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        userId
        uuid
        version
        wonAt
      }
      wonAt
    }
  }
}
    `;
export type CancelProposalMutationFn = Apollo.MutationFunction<CancelProposalMutation, CancelProposalMutationVariables>;

/**
 * __useCancelProposalMutation__
 *
 * To run a mutation, you first call `useCancelProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelProposalMutation, { data, loading, error }] = useCancelProposalMutation({
 *   variables: {
 *      duplicate: // value for 'duplicate'
 *      id: // value for 'id'
 *      maintainCurrentId: // value for 'maintainCurrentId'
 *   },
 * });
 */
export function useCancelProposalMutation(baseOptions?: Apollo.MutationHookOptions<CancelProposalMutation, CancelProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelProposalMutation, CancelProposalMutationVariables>(CancelProposalDocument, options);
      }
export type CancelProposalMutationHookResult = ReturnType<typeof useCancelProposalMutation>;
export type CancelProposalMutationResult = Apollo.MutationResult<CancelProposalMutation>;
export type CancelProposalMutationOptions = Apollo.BaseMutationOptions<CancelProposalMutation, CancelProposalMutationVariables>;
export const CloseProposalDocument = gql`
    mutation closeProposal($id: ID!) {
  closeProposal(id: $id) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        phone
        proposalDefaults {
          autoSave
          color
          id
          layout
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        events {
          action
          createdAt
        }
        externalId
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterTaxes
        profit
        profitPercentage
        projectFilesFolderId
        proposalNotes
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          profit
          profitPercentage
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          roundTripTravelTimeHours
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          status
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
        uuid
        version
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    clientEmailOverride
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    events {
      action
      createdAt
    }
    externalId
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isSendable
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    overallTotal
    overallTotalAfterTaxes
    profit
    profitPercentage
    projectFilesFolderId
    proposalNotes
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      profit
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
    userId
    uuid
    version
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    wonAt
  }
}
    `;
export type CloseProposalMutationFn = Apollo.MutationFunction<CloseProposalMutation, CloseProposalMutationVariables>;

/**
 * __useCloseProposalMutation__
 *
 * To run a mutation, you first call `useCloseProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeProposalMutation, { data, loading, error }] = useCloseProposalMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCloseProposalMutation(baseOptions?: Apollo.MutationHookOptions<CloseProposalMutation, CloseProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloseProposalMutation, CloseProposalMutationVariables>(CloseProposalDocument, options);
      }
export type CloseProposalMutationHookResult = ReturnType<typeof useCloseProposalMutation>;
export type CloseProposalMutationResult = Apollo.MutationResult<CloseProposalMutation>;
export type CloseProposalMutationOptions = Apollo.BaseMutationOptions<CloseProposalMutation, CloseProposalMutationVariables>;
export const CreateAdditionalCostDocument = gql`
    mutation createAdditionalCost($input: CreateAdditionalCostInput!) {
  createAdditionalCost(input: $input) {
    cost
    feeAmount
    feeType
    id
    name
  }
}
    `;
export type CreateAdditionalCostMutationFn = Apollo.MutationFunction<CreateAdditionalCostMutation, CreateAdditionalCostMutationVariables>;

/**
 * __useCreateAdditionalCostMutation__
 *
 * To run a mutation, you first call `useCreateAdditionalCostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdditionalCostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdditionalCostMutation, { data, loading, error }] = useCreateAdditionalCostMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAdditionalCostMutation(baseOptions?: Apollo.MutationHookOptions<CreateAdditionalCostMutation, CreateAdditionalCostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAdditionalCostMutation, CreateAdditionalCostMutationVariables>(CreateAdditionalCostDocument, options);
      }
export type CreateAdditionalCostMutationHookResult = ReturnType<typeof useCreateAdditionalCostMutation>;
export type CreateAdditionalCostMutationResult = Apollo.MutationResult<CreateAdditionalCostMutation>;
export type CreateAdditionalCostMutationOptions = Apollo.BaseMutationOptions<CreateAdditionalCostMutation, CreateAdditionalCostMutationVariables>;
export const CreateCompanyDocument = gql`
    mutation createCompany($input: CreateCompanyInput!) {
  createCompany(input: $input) {
    addCompanyInfo
    addressCity
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZip
    contacts {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    email
    id
    jobsCount
    logo
    name
    notes
    notificationTypes {
      CONTACT
      JOB
      JOB_PHASE
      OPPORTUNITY
      PROPOSAL
    }
    phone
    primaryContact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    projectFilesFolderId
    proposalsCount
    status
    website
  }
}
    `;
export type CreateCompanyMutationFn = Apollo.MutationFunction<CreateCompanyMutation, CreateCompanyMutationVariables>;

/**
 * __useCreateCompanyMutation__
 *
 * To run a mutation, you first call `useCreateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyMutation, { data, loading, error }] = useCreateCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompanyMutation, CreateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompanyMutation, CreateCompanyMutationVariables>(CreateCompanyDocument, options);
      }
export type CreateCompanyMutationHookResult = ReturnType<typeof useCreateCompanyMutation>;
export type CreateCompanyMutationResult = Apollo.MutationResult<CreateCompanyMutation>;
export type CreateCompanyMutationOptions = Apollo.BaseMutationOptions<CreateCompanyMutation, CreateCompanyMutationVariables>;
export const CreateCrewDocument = gql`
    mutation createCrew($input: CreateCrewInput!) {
  createCrew(input: $input) {
    color
    displayName
    employees {
      firstName
      id
      lastName
      name
      organizationId
      rate
      user {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          proposalDefaults {
            autoSave
            color
            id
            layout
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        status
      }
      userId
    }
    foremanUser {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        email
        emailTemplate
        failingPayment
        id
        logo
        name
        onTrial
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      status
    }
    id
    name
    organization {
      email
      emailTemplate
      failingPayment
      id
      logo
      name
      onTrial
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    rate
  }
}
    `;
export type CreateCrewMutationFn = Apollo.MutationFunction<CreateCrewMutation, CreateCrewMutationVariables>;

/**
 * __useCreateCrewMutation__
 *
 * To run a mutation, you first call `useCreateCrewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCrewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCrewMutation, { data, loading, error }] = useCreateCrewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCrewMutation(baseOptions?: Apollo.MutationHookOptions<CreateCrewMutation, CreateCrewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCrewMutation, CreateCrewMutationVariables>(CreateCrewDocument, options);
      }
export type CreateCrewMutationHookResult = ReturnType<typeof useCreateCrewMutation>;
export type CreateCrewMutationResult = Apollo.MutationResult<CreateCrewMutation>;
export type CreateCrewMutationOptions = Apollo.BaseMutationOptions<CreateCrewMutation, CreateCrewMutationVariables>;
export const CreateCustomEventDocument = gql`
    mutation createCustomEvent($input: CreateCustomEventInput) {
  createCustomEvent(input: $input) {
    color
    crew {
      color
      displayName
      employees {
        firstName
        id
        lastName
        name
        organizationId
        rate
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
      }
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          proposalDefaults {
            autoSave
            color
            id
            layout
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        status
      }
      id
      name
      organization {
        email
        emailTemplate
        failingPayment
        id
        logo
        name
        onTrial
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      rate
    }
    customEventBlocks {
      blockLength
      customEvent {
        color
        crew {
          color
          displayName
          id
          name
          rate
        }
        customEventBlocks {
          blockLength
          endsAt
          id
          scheduledAt
        }
        customEventsToUsers {
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
        }
        endsAt
        id
        name
        notes
        startsAt
      }
      endsAt
      id
      scheduledAt
    }
    endsAt
    id
    name
    notes
    startsAt
  }
}
    `;
export type CreateCustomEventMutationFn = Apollo.MutationFunction<CreateCustomEventMutation, CreateCustomEventMutationVariables>;

/**
 * __useCreateCustomEventMutation__
 *
 * To run a mutation, you first call `useCreateCustomEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomEventMutation, { data, loading, error }] = useCreateCustomEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomEventMutation, CreateCustomEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomEventMutation, CreateCustomEventMutationVariables>(CreateCustomEventDocument, options);
      }
export type CreateCustomEventMutationHookResult = ReturnType<typeof useCreateCustomEventMutation>;
export type CreateCustomEventMutationResult = Apollo.MutationResult<CreateCustomEventMutation>;
export type CreateCustomEventMutationOptions = Apollo.BaseMutationOptions<CreateCustomEventMutation, CreateCustomEventMutationVariables>;
export const CreateEmployeeDocument = gql`
    mutation createEmployee($input: CreateEmployeeInput!) {
  createEmployee(input: $input) {
    firstName
    id
    lastName
    name
    organizationId
    rate
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        phone
        proposalDefaults {
          autoSave
          color
          id
          layout
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      status
    }
    userId
  }
}
    `;
export type CreateEmployeeMutationFn = Apollo.MutationFunction<CreateEmployeeMutation, CreateEmployeeMutationVariables>;

/**
 * __useCreateEmployeeMutation__
 *
 * To run a mutation, you first call `useCreateEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmployeeMutation, { data, loading, error }] = useCreateEmployeeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<CreateEmployeeMutation, CreateEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEmployeeMutation, CreateEmployeeMutationVariables>(CreateEmployeeDocument, options);
      }
export type CreateEmployeeMutationHookResult = ReturnType<typeof useCreateEmployeeMutation>;
export type CreateEmployeeMutationResult = Apollo.MutationResult<CreateEmployeeMutation>;
export type CreateEmployeeMutationOptions = Apollo.BaseMutationOptions<CreateEmployeeMutation, CreateEmployeeMutationVariables>;
export const CreateEquipmentPieceDocument = gql`
    mutation createEquipmentPiece($input: CreateEquipmentPieceInput!) {
  createEquipmentPiece(input: $input) {
    chargeType
    fuelSurcharge
    id
    name
    rate
    usePercentage
  }
}
    `;
export type CreateEquipmentPieceMutationFn = Apollo.MutationFunction<CreateEquipmentPieceMutation, CreateEquipmentPieceMutationVariables>;

/**
 * __useCreateEquipmentPieceMutation__
 *
 * To run a mutation, you first call `useCreateEquipmentPieceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEquipmentPieceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEquipmentPieceMutation, { data, loading, error }] = useCreateEquipmentPieceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEquipmentPieceMutation(baseOptions?: Apollo.MutationHookOptions<CreateEquipmentPieceMutation, CreateEquipmentPieceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEquipmentPieceMutation, CreateEquipmentPieceMutationVariables>(CreateEquipmentPieceDocument, options);
      }
export type CreateEquipmentPieceMutationHookResult = ReturnType<typeof useCreateEquipmentPieceMutation>;
export type CreateEquipmentPieceMutationResult = Apollo.MutationResult<CreateEquipmentPieceMutation>;
export type CreateEquipmentPieceMutationOptions = Apollo.BaseMutationOptions<CreateEquipmentPieceMutation, CreateEquipmentPieceMutationVariables>;
export const CreateJobInvoiceOnLinkedServiceDocument = gql`
    mutation createJobInvoiceOnLinkedService($jobId: ID!, $service: OrganizationLinkedServiceName!) {
  createJobInvoiceOnLinkedService(jobId: $jobId, service: $service)
}
    `;
export type CreateJobInvoiceOnLinkedServiceMutationFn = Apollo.MutationFunction<CreateJobInvoiceOnLinkedServiceMutation, CreateJobInvoiceOnLinkedServiceMutationVariables>;

/**
 * __useCreateJobInvoiceOnLinkedServiceMutation__
 *
 * To run a mutation, you first call `useCreateJobInvoiceOnLinkedServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobInvoiceOnLinkedServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJobInvoiceOnLinkedServiceMutation, { data, loading, error }] = useCreateJobInvoiceOnLinkedServiceMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      service: // value for 'service'
 *   },
 * });
 */
export function useCreateJobInvoiceOnLinkedServiceMutation(baseOptions?: Apollo.MutationHookOptions<CreateJobInvoiceOnLinkedServiceMutation, CreateJobInvoiceOnLinkedServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateJobInvoiceOnLinkedServiceMutation, CreateJobInvoiceOnLinkedServiceMutationVariables>(CreateJobInvoiceOnLinkedServiceDocument, options);
      }
export type CreateJobInvoiceOnLinkedServiceMutationHookResult = ReturnType<typeof useCreateJobInvoiceOnLinkedServiceMutation>;
export type CreateJobInvoiceOnLinkedServiceMutationResult = Apollo.MutationResult<CreateJobInvoiceOnLinkedServiceMutation>;
export type CreateJobInvoiceOnLinkedServiceMutationOptions = Apollo.BaseMutationOptions<CreateJobInvoiceOnLinkedServiceMutation, CreateJobInvoiceOnLinkedServiceMutationVariables>;
export const CreateNotificationTriggerDocument = gql`
    mutation createNotificationTrigger($input: CreateNotificationTriggerInput!) {
  createNotificationTrigger(input: $input) {
    active
    additionalRecipientTypes
    additionalRecipients {
      email
      firstName
      id
      lastName
    }
    content
    delay
    emailSubject
    event
    id
    isEmail
    isSMS
    name
    organization {
      conversionFactorOverride {
        asphaltTonConversionFactorOverride
        excavateOutTonConversionFactorOverride
        id
        organization {
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          proposalDefaults {
            autoSave
            color
            id
            layout
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
      }
      email
      emailTemplate
      failingPayment
      id
      logo
      name
      onTrial
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    sendToAllRecipients
    sendToContact
    sendToUser
    smsContent
    type
  }
}
    `;
export type CreateNotificationTriggerMutationFn = Apollo.MutationFunction<CreateNotificationTriggerMutation, CreateNotificationTriggerMutationVariables>;

/**
 * __useCreateNotificationTriggerMutation__
 *
 * To run a mutation, you first call `useCreateNotificationTriggerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNotificationTriggerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNotificationTriggerMutation, { data, loading, error }] = useCreateNotificationTriggerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNotificationTriggerMutation(baseOptions?: Apollo.MutationHookOptions<CreateNotificationTriggerMutation, CreateNotificationTriggerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNotificationTriggerMutation, CreateNotificationTriggerMutationVariables>(CreateNotificationTriggerDocument, options);
      }
export type CreateNotificationTriggerMutationHookResult = ReturnType<typeof useCreateNotificationTriggerMutation>;
export type CreateNotificationTriggerMutationResult = Apollo.MutationResult<CreateNotificationTriggerMutation>;
export type CreateNotificationTriggerMutationOptions = Apollo.BaseMutationOptions<CreateNotificationTriggerMutation, CreateNotificationTriggerMutationVariables>;
export const CreateOpportunityDocument = gql`
    mutation createOpportunity($input: CreateOpportunityInput!) {
  createOpportunity(input: $input) {
    addressCity
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZip
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      contacts {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      email
      id
      jobsCount
      logo
      name
      notes
      notificationTypes {
        CONTACT
        JOB
        JOB_PHASE
        OPPORTUNITY
        PROPOSAL
      }
      phone
      primaryContact {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    companyId
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    createdAt
    dueAt
    estimatedOpportunityValue
    externalId
    id
    name
    notes
    products {
      id
      indirectPercentage
      markupPercentage
      name
      overheadPercentage
      type
    }
    projectFilesFolderId
    source
    status
    statusId
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        phone
        proposalDefaults {
          autoSave
          color
          id
          layout
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      status
    }
    userId
  }
}
    `;
export type CreateOpportunityMutationFn = Apollo.MutationFunction<CreateOpportunityMutation, CreateOpportunityMutationVariables>;

/**
 * __useCreateOpportunityMutation__
 *
 * To run a mutation, you first call `useCreateOpportunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOpportunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOpportunityMutation, { data, loading, error }] = useCreateOpportunityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOpportunityMutation(baseOptions?: Apollo.MutationHookOptions<CreateOpportunityMutation, CreateOpportunityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOpportunityMutation, CreateOpportunityMutationVariables>(CreateOpportunityDocument, options);
      }
export type CreateOpportunityMutationHookResult = ReturnType<typeof useCreateOpportunityMutation>;
export type CreateOpportunityMutationResult = Apollo.MutationResult<CreateOpportunityMutation>;
export type CreateOpportunityMutationOptions = Apollo.BaseMutationOptions<CreateOpportunityMutation, CreateOpportunityMutationVariables>;
export const CreateOpportunityStatusDocument = gql`
    mutation createOpportunityStatus($name: String!) {
  createOpportunityStatus(name: $name) {
    id
    name
  }
}
    `;
export type CreateOpportunityStatusMutationFn = Apollo.MutationFunction<CreateOpportunityStatusMutation, CreateOpportunityStatusMutationVariables>;

/**
 * __useCreateOpportunityStatusMutation__
 *
 * To run a mutation, you first call `useCreateOpportunityStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOpportunityStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOpportunityStatusMutation, { data, loading, error }] = useCreateOpportunityStatusMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateOpportunityStatusMutation(baseOptions?: Apollo.MutationHookOptions<CreateOpportunityStatusMutation, CreateOpportunityStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOpportunityStatusMutation, CreateOpportunityStatusMutationVariables>(CreateOpportunityStatusDocument, options);
      }
export type CreateOpportunityStatusMutationHookResult = ReturnType<typeof useCreateOpportunityStatusMutation>;
export type CreateOpportunityStatusMutationResult = Apollo.MutationResult<CreateOpportunityStatusMutation>;
export type CreateOpportunityStatusMutationOptions = Apollo.BaseMutationOptions<CreateOpportunityStatusMutation, CreateOpportunityStatusMutationVariables>;
export const CreateOrganizationAddressDocument = gql`
    mutation createOrganizationAddress($input: CreateOrganizationAddressInput!) {
  createOrganizationAddress(input: $input) {
    city
    country
    id
    isPrimary
    latitude
    line1
    line2
    longitude
    state
    zip
  }
}
    `;
export type CreateOrganizationAddressMutationFn = Apollo.MutationFunction<CreateOrganizationAddressMutation, CreateOrganizationAddressMutationVariables>;

/**
 * __useCreateOrganizationAddressMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationAddressMutation, { data, loading, error }] = useCreateOrganizationAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationAddressMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationAddressMutation, CreateOrganizationAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationAddressMutation, CreateOrganizationAddressMutationVariables>(CreateOrganizationAddressDocument, options);
      }
export type CreateOrganizationAddressMutationHookResult = ReturnType<typeof useCreateOrganizationAddressMutation>;
export type CreateOrganizationAddressMutationResult = Apollo.MutationResult<CreateOrganizationAddressMutation>;
export type CreateOrganizationAddressMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationAddressMutation, CreateOrganizationAddressMutationVariables>;
export const CreateOrganizationProductTypeDocument = gql`
    mutation createOrganizationProductType($input: CreateOrganizationProductTypeInput!) {
  createOrganizationProductType(input: $input) {
    id
    indirectPercentage
    markupPercentage
    name
    overheadPercentage
    type
  }
}
    `;
export type CreateOrganizationProductTypeMutationFn = Apollo.MutationFunction<CreateOrganizationProductTypeMutation, CreateOrganizationProductTypeMutationVariables>;

/**
 * __useCreateOrganizationProductTypeMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationProductTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationProductTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationProductTypeMutation, { data, loading, error }] = useCreateOrganizationProductTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationProductTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganizationProductTypeMutation, CreateOrganizationProductTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganizationProductTypeMutation, CreateOrganizationProductTypeMutationVariables>(CreateOrganizationProductTypeDocument, options);
      }
export type CreateOrganizationProductTypeMutationHookResult = ReturnType<typeof useCreateOrganizationProductTypeMutation>;
export type CreateOrganizationProductTypeMutationResult = Apollo.MutationResult<CreateOrganizationProductTypeMutation>;
export type CreateOrganizationProductTypeMutationOptions = Apollo.BaseMutationOptions<CreateOrganizationProductTypeMutation, CreateOrganizationProductTypeMutationVariables>;
export const CreatePlantDocument = gql`
    mutation createPlant($input: CreatePlantInput!) {
  createPlant(input: $input) {
    addressCity
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZip
    id
    name
    phone
    products {
      id
      rate
      type
    }
  }
}
    `;
export type CreatePlantMutationFn = Apollo.MutationFunction<CreatePlantMutation, CreatePlantMutationVariables>;

/**
 * __useCreatePlantMutation__
 *
 * To run a mutation, you first call `useCreatePlantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlantMutation, { data, loading, error }] = useCreatePlantMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePlantMutation(baseOptions?: Apollo.MutationHookOptions<CreatePlantMutation, CreatePlantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePlantMutation, CreatePlantMutationVariables>(CreatePlantDocument, options);
      }
export type CreatePlantMutationHookResult = ReturnType<typeof useCreatePlantMutation>;
export type CreatePlantMutationResult = Apollo.MutationResult<CreatePlantMutation>;
export type CreatePlantMutationOptions = Apollo.BaseMutationOptions<CreatePlantMutation, CreatePlantMutationVariables>;
export const CreatePlantProductTypeDocument = gql`
    mutation createPlantProductType($name: String!) {
  createPlantProductType(name: $name) {
    id
    name
  }
}
    `;
export type CreatePlantProductTypeMutationFn = Apollo.MutationFunction<CreatePlantProductTypeMutation, CreatePlantProductTypeMutationVariables>;

/**
 * __useCreatePlantProductTypeMutation__
 *
 * To run a mutation, you first call `useCreatePlantProductTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlantProductTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlantProductTypeMutation, { data, loading, error }] = useCreatePlantProductTypeMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreatePlantProductTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreatePlantProductTypeMutation, CreatePlantProductTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePlantProductTypeMutation, CreatePlantProductTypeMutationVariables>(CreatePlantProductTypeDocument, options);
      }
export type CreatePlantProductTypeMutationHookResult = ReturnType<typeof useCreatePlantProductTypeMutation>;
export type CreatePlantProductTypeMutationResult = Apollo.MutationResult<CreatePlantProductTypeMutation>;
export type CreatePlantProductTypeMutationOptions = Apollo.BaseMutationOptions<CreatePlantProductTypeMutation, CreatePlantProductTypeMutationVariables>;
export const CreateProductDocument = gql`
    mutation createProduct($input: CreateProductInput!) {
  createProduct(input: $input) {
    areaCoverage
    attributes {
      __typename
      ... on ProductAttributeAsphalt {
        applicationRate
      }
      ... on ProductAttributeConcreteColumn {
        diameter
        height
      }
      ... on ProductAttributeConcreteCurbOrGutter {
        curbHeight
        curbWidth
        gutterHeight
        gutterWidth
      }
      ... on ProductAttributeConcreteFlatwork {
        applicationRate
      }
      ... on ProductAttributeConcreteFooting {
        depth
        width
      }
      ... on ProductAttributeConcreteWall {
        height
        width
      }
      ... on ProductAttributeConcreteWaterway {
        curbHeight
        curbWidth
        gutterHeight
        gutterWidth
      }
      ... on ProductAttributeCrackSeal {
        crackDepth
        crackWidth
        overbandThickness
        overbandWidth
        poundsPerBlock
        poundsPerGallon
      }
      ... on ProductAttributeCurbWall {
        curbHeight
        curbWidth
        gutterHeight
        gutterWidth
      }
      ... on ProductAttributeExcavateOut {
        applicationRate
      }
      ... on ProductAttributeGrading {
        applicationRate
        poundsPerCubicYard
      }
      ... on ProductAttributeMastic {
        crackDepth
        crackWidth
        overbandThickness
        overbandWidth
        poundsPerBlock
        poundsPerGallon
      }
      ... on ProductAttributeMicrosurfacing {
        applicationRate
      }
      ... on ProductAttributeSealCoat {
        applicationRate
      }
      ... on ProductAttributeSlurrySeal {
        applicationRate
      }
      ... on ProductAttributeStriping {
        applicationRate
        lineWidth
      }
    }
    costMaterial
    costMinimumProduct
    costMinimumProposal
    crew {
      color
      displayName
      employees {
        firstName
        id
        lastName
        name
        organizationId
        rate
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
      }
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          proposalDefaults {
            autoSave
            color
            id
            layout
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        status
      }
      id
      name
      organization {
        email
        emailTemplate
        failingPayment
        id
        logo
        name
        onTrial
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      rate
    }
    dailyUnitsComplete
    externalProductName
    id
    indirectPercentage
    labourCostType
    markupPercentage
    measurementJob
    measurementMaterial
    name
    organizationProductType {
      id
      indirectPercentage
      markupPercentage
      name
      overheadPercentage
      type
    }
    overheadPercentage
    plant {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      id
      name
      phone
      products {
        id
        rate
        type
      }
    }
    plantProductId
    productAdditionalCosts {
      additionalCost {
        cost
        feeAmount
        feeType
        id
        name
      }
      id
      type
    }
    productEquipmentPieces {
      equipmentPiece {
        chargeType
        fuelSurcharge
        id
        name
        rate
        usePercentage
      }
      id
      quantity
    }
    productionRateType
    statementOfWork
    subcontracted
    type
    unitPrice
    unitPriceProduct
  }
}
    `;
export type CreateProductMutationFn = Apollo.MutationFunction<CreateProductMutation, CreateProductMutationVariables>;

/**
 * __useCreateProductMutation__
 *
 * To run a mutation, you first call `useCreateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductMutation, { data, loading, error }] = useCreateProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProductMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductMutation, CreateProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProductMutation, CreateProductMutationVariables>(CreateProductDocument, options);
      }
export type CreateProductMutationHookResult = ReturnType<typeof useCreateProductMutation>;
export type CreateProductMutationResult = Apollo.MutationResult<CreateProductMutation>;
export type CreateProductMutationOptions = Apollo.BaseMutationOptions<CreateProductMutation, CreateProductMutationVariables>;
export const CreateProjectFileFolderDocument = gql`
    mutation createProjectFileFolder($name: String!, $parentFolderId: ID) {
  createProjectFileFolder(name: $name, parentFolderId: $parentFolderId) {
    children {
      children {
        fileSizeBytes
        id
        name
        parentFolderId
        path
        type
      }
      fileSizeBytes
      id
      name
      parentFolderId
      path
      type
    }
    fileSizeBytes
    id
    name
    parentFolderId
    path
    type
  }
}
    `;
export type CreateProjectFileFolderMutationFn = Apollo.MutationFunction<CreateProjectFileFolderMutation, CreateProjectFileFolderMutationVariables>;

/**
 * __useCreateProjectFileFolderMutation__
 *
 * To run a mutation, you first call `useCreateProjectFileFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectFileFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectFileFolderMutation, { data, loading, error }] = useCreateProjectFileFolderMutation({
 *   variables: {
 *      name: // value for 'name'
 *      parentFolderId: // value for 'parentFolderId'
 *   },
 * });
 */
export function useCreateProjectFileFolderMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectFileFolderMutation, CreateProjectFileFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectFileFolderMutation, CreateProjectFileFolderMutationVariables>(CreateProjectFileFolderDocument, options);
      }
export type CreateProjectFileFolderMutationHookResult = ReturnType<typeof useCreateProjectFileFolderMutation>;
export type CreateProjectFileFolderMutationResult = Apollo.MutationResult<CreateProjectFileFolderMutation>;
export type CreateProjectFileFolderMutationOptions = Apollo.BaseMutationOptions<CreateProjectFileFolderMutation, CreateProjectFileFolderMutationVariables>;
export const CreateProposalDocument = gql`
    mutation createProposal($companyId: ID!, $contactId: ID!, $source: ProposalSource) {
  createProposal(companyId: $companyId, contactId: $contactId, source: $source) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        phone
        proposalDefaults {
          autoSave
          color
          id
          layout
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        events {
          action
          createdAt
        }
        externalId
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterTaxes
        profit
        profitPercentage
        projectFilesFolderId
        proposalNotes
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          profit
          profitPercentage
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          roundTripTravelTimeHours
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          status
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
        uuid
        version
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    clientEmailOverride
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    events {
      action
      createdAt
    }
    externalId
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isSendable
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    overallTotal
    overallTotalAfterTaxes
    profit
    profitPercentage
    projectFilesFolderId
    proposalNotes
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      profit
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
    userId
    uuid
    version
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    wonAt
  }
}
    `;
export type CreateProposalMutationFn = Apollo.MutationFunction<CreateProposalMutation, CreateProposalMutationVariables>;

/**
 * __useCreateProposalMutation__
 *
 * To run a mutation, you first call `useCreateProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProposalMutation, { data, loading, error }] = useCreateProposalMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      contactId: // value for 'contactId'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useCreateProposalMutation(baseOptions?: Apollo.MutationHookOptions<CreateProposalMutation, CreateProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProposalMutation, CreateProposalMutationVariables>(CreateProposalDocument, options);
      }
export type CreateProposalMutationHookResult = ReturnType<typeof useCreateProposalMutation>;
export type CreateProposalMutationResult = Apollo.MutationResult<CreateProposalMutation>;
export type CreateProposalMutationOptions = Apollo.BaseMutationOptions<CreateProposalMutation, CreateProposalMutationVariables>;
export const CreateProposalFromOpportunityDocument = gql`
    mutation createProposalFromOpportunity($id: ID!) {
  createProposalFromOpportunity(id: $id) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        phone
        proposalDefaults {
          autoSave
          color
          id
          layout
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        events {
          action
          createdAt
        }
        externalId
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterTaxes
        profit
        profitPercentage
        projectFilesFolderId
        proposalNotes
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          profit
          profitPercentage
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          roundTripTravelTimeHours
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          status
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
        uuid
        version
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    clientEmailOverride
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    events {
      action
      createdAt
    }
    externalId
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isSendable
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    overallTotal
    overallTotalAfterTaxes
    profit
    profitPercentage
    projectFilesFolderId
    proposalNotes
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      profit
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
    userId
    uuid
    version
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    wonAt
  }
}
    `;
export type CreateProposalFromOpportunityMutationFn = Apollo.MutationFunction<CreateProposalFromOpportunityMutation, CreateProposalFromOpportunityMutationVariables>;

/**
 * __useCreateProposalFromOpportunityMutation__
 *
 * To run a mutation, you first call `useCreateProposalFromOpportunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProposalFromOpportunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProposalFromOpportunityMutation, { data, loading, error }] = useCreateProposalFromOpportunityMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCreateProposalFromOpportunityMutation(baseOptions?: Apollo.MutationHookOptions<CreateProposalFromOpportunityMutation, CreateProposalFromOpportunityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProposalFromOpportunityMutation, CreateProposalFromOpportunityMutationVariables>(CreateProposalFromOpportunityDocument, options);
      }
export type CreateProposalFromOpportunityMutationHookResult = ReturnType<typeof useCreateProposalFromOpportunityMutation>;
export type CreateProposalFromOpportunityMutationResult = Apollo.MutationResult<CreateProposalFromOpportunityMutation>;
export type CreateProposalFromOpportunityMutationOptions = Apollo.BaseMutationOptions<CreateProposalFromOpportunityMutation, CreateProposalFromOpportunityMutationVariables>;
export const CreateTimeBucketDocument = gql`
    mutation createTimeBucket($input: CreateTimeBucketInput!) {
  createTimeBucket(input: $input) {
    id
    name
    organizationId
  }
}
    `;
export type CreateTimeBucketMutationFn = Apollo.MutationFunction<CreateTimeBucketMutation, CreateTimeBucketMutationVariables>;

/**
 * __useCreateTimeBucketMutation__
 *
 * To run a mutation, you first call `useCreateTimeBucketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTimeBucketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTimeBucketMutation, { data, loading, error }] = useCreateTimeBucketMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTimeBucketMutation(baseOptions?: Apollo.MutationHookOptions<CreateTimeBucketMutation, CreateTimeBucketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTimeBucketMutation, CreateTimeBucketMutationVariables>(CreateTimeBucketDocument, options);
      }
export type CreateTimeBucketMutationHookResult = ReturnType<typeof useCreateTimeBucketMutation>;
export type CreateTimeBucketMutationResult = Apollo.MutationResult<CreateTimeBucketMutation>;
export type CreateTimeBucketMutationOptions = Apollo.BaseMutationOptions<CreateTimeBucketMutation, CreateTimeBucketMutationVariables>;
export const CreateTimeEntryDocument = gql`
    mutation createTimeEntry($input: CreateTimeEntryInput!) {
  createTimeEntry(input: $input) {
    clockInLatitude
    clockInLongitude
    clockOutLatitude
    clockOutLongitude
    endTime
    forDate
    id
    jobPhase {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualEmployeeHours
      actualGrossMargin
      actualGrossMarginPercentage
      actualMaterialNeeded
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      address
      applicableStatuses
      costItems {
        additionalCosts {
          additionalCostId
          cost
          costTotal
          feeAmount
          feeType
          id
          jobPhaseCostItem {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          name
        }
        costAdditional
        costEquipment
        costLabour
        costMaterial
        costTransferTruck
        date
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        equipmentPieces {
          equipmentPieceId
          id
          name
          quantity
          rate
          timeOnjob
          timeTravel
        }
        id
        jobPhase {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualEmployeeHours
          actualGrossMargin
          actualGrossMarginPercentage
          actualMaterialNeeded
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address
          applicableStatuses
          crew {
            color
            displayName
            id
            name
            rate
          }
          crewId
          defaultAdditionalCosts {
            cost
            feeAmount
            feeType
            id
            name
          }
          defaultEmployees {
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          defaultEquipmentPieces {
            chargeType
            fuelSurcharge
            id
            name
            rate
            usePercentage
          }
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          endsAt
          externalId
          files {
            createdAt
            filename
            id
            thumbnail
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            endsAt
            externalId
            id
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
          }
          jobDuration
          jobPhasePlant {
            id
            name
            type
          }
          jobSize
          notes
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          organizationProductType {
            id
            indirectPercentage
            markupPercentage
            name
            overheadPercentage
            type
          }
          organizationProductTypeName
          productName
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          proposalProduct {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          proposalStage {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedEmployeeHours
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedMaterialNeeded
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          scheduleBlocks {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          scheduledBlockForDate {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          startsAt
          status
          travelTimeEstimate
          users {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          usersColor
          workOrderCrews {
            crewId
            id
            name
          }
          workOrderEquipmentPieces {
            equipmentPieceId
            id
            name
          }
          workOrderTransferTrucks {
            id
            name
            quantity
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
        }
        material {
          costMaterial
          id
          jobPhaseCostItem {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          materialNeeded
          name
          organizationProductTypeName
          type
        }
        plantId
        plantProductId
        transferTrucks {
          hours
          id
          name
          plantTransferTruckId
          rateHourly
          rateTon
          tonnage
          transferTruckId
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
      }
      crewId
      endsAt
      externalId
      id
      jobDuration
      jobSize
      notes
      organizationProductTypeName
      productName
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedEmployeeHours
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedMaterialNeeded
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      startsAt
      status
      travelTimeEstimate
      usersColor
    }
    notes
    organizationId
    startTime
    timeBucket {
      id
      name
      organizationId
    }
    timeTrackedSeconds
    timeTrackedSecondsOverride
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
    uuid
  }
}
    `;
export type CreateTimeEntryMutationFn = Apollo.MutationFunction<CreateTimeEntryMutation, CreateTimeEntryMutationVariables>;

/**
 * __useCreateTimeEntryMutation__
 *
 * To run a mutation, you first call `useCreateTimeEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTimeEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTimeEntryMutation, { data, loading, error }] = useCreateTimeEntryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTimeEntryMutation(baseOptions?: Apollo.MutationHookOptions<CreateTimeEntryMutation, CreateTimeEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTimeEntryMutation, CreateTimeEntryMutationVariables>(CreateTimeEntryDocument, options);
      }
export type CreateTimeEntryMutationHookResult = ReturnType<typeof useCreateTimeEntryMutation>;
export type CreateTimeEntryMutationResult = Apollo.MutationResult<CreateTimeEntryMutation>;
export type CreateTimeEntryMutationOptions = Apollo.BaseMutationOptions<CreateTimeEntryMutation, CreateTimeEntryMutationVariables>;
export const CreateTransferTruckDocument = gql`
    mutation createTransferTruck($input: CreateTransferTruckInput!) {
  createTransferTruck(input: $input) {
    defaultRateHourly
    defaultRateTon
    defaultTonnage
    id
    name
  }
}
    `;
export type CreateTransferTruckMutationFn = Apollo.MutationFunction<CreateTransferTruckMutation, CreateTransferTruckMutationVariables>;

/**
 * __useCreateTransferTruckMutation__
 *
 * To run a mutation, you first call `useCreateTransferTruckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTransferTruckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTransferTruckMutation, { data, loading, error }] = useCreateTransferTruckMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTransferTruckMutation(baseOptions?: Apollo.MutationHookOptions<CreateTransferTruckMutation, CreateTransferTruckMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTransferTruckMutation, CreateTransferTruckMutationVariables>(CreateTransferTruckDocument, options);
      }
export type CreateTransferTruckMutationHookResult = ReturnType<typeof useCreateTransferTruckMutation>;
export type CreateTransferTruckMutationResult = Apollo.MutationResult<CreateTransferTruckMutation>;
export type CreateTransferTruckMutationOptions = Apollo.BaseMutationOptions<CreateTransferTruckMutation, CreateTransferTruckMutationVariables>;
export const DeleteAdditionalCostDocument = gql`
    mutation deleteAdditionalCost($id: ID!) {
  deleteAdditionalCost(id: $id)
}
    `;
export type DeleteAdditionalCostMutationFn = Apollo.MutationFunction<DeleteAdditionalCostMutation, DeleteAdditionalCostMutationVariables>;

/**
 * __useDeleteAdditionalCostMutation__
 *
 * To run a mutation, you first call `useDeleteAdditionalCostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAdditionalCostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAdditionalCostMutation, { data, loading, error }] = useDeleteAdditionalCostMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAdditionalCostMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAdditionalCostMutation, DeleteAdditionalCostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAdditionalCostMutation, DeleteAdditionalCostMutationVariables>(DeleteAdditionalCostDocument, options);
      }
export type DeleteAdditionalCostMutationHookResult = ReturnType<typeof useDeleteAdditionalCostMutation>;
export type DeleteAdditionalCostMutationResult = Apollo.MutationResult<DeleteAdditionalCostMutation>;
export type DeleteAdditionalCostMutationOptions = Apollo.BaseMutationOptions<DeleteAdditionalCostMutation, DeleteAdditionalCostMutationVariables>;
export const DeleteCrewDocument = gql`
    mutation deleteCrew($id: ID!) {
  deleteCrew(id: $id)
}
    `;
export type DeleteCrewMutationFn = Apollo.MutationFunction<DeleteCrewMutation, DeleteCrewMutationVariables>;

/**
 * __useDeleteCrewMutation__
 *
 * To run a mutation, you first call `useDeleteCrewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCrewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCrewMutation, { data, loading, error }] = useDeleteCrewMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCrewMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCrewMutation, DeleteCrewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCrewMutation, DeleteCrewMutationVariables>(DeleteCrewDocument, options);
      }
export type DeleteCrewMutationHookResult = ReturnType<typeof useDeleteCrewMutation>;
export type DeleteCrewMutationResult = Apollo.MutationResult<DeleteCrewMutation>;
export type DeleteCrewMutationOptions = Apollo.BaseMutationOptions<DeleteCrewMutation, DeleteCrewMutationVariables>;
export const DeleteCustomEventDocument = gql`
    mutation deleteCustomEvent($id: ID!) {
  deleteCustomEvent(id: $id) {
    color
    crew {
      color
      displayName
      employees {
        firstName
        id
        lastName
        name
        organizationId
        rate
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
      }
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          proposalDefaults {
            autoSave
            color
            id
            layout
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        status
      }
      id
      name
      organization {
        email
        emailTemplate
        failingPayment
        id
        logo
        name
        onTrial
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      rate
    }
    customEventBlocks {
      blockLength
      customEvent {
        color
        crew {
          color
          displayName
          id
          name
          rate
        }
        customEventBlocks {
          blockLength
          endsAt
          id
          scheduledAt
        }
        customEventsToUsers {
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
        }
        endsAt
        id
        name
        notes
        startsAt
      }
      endsAt
      id
      scheduledAt
    }
    endsAt
    id
    name
    notes
    startsAt
  }
}
    `;
export type DeleteCustomEventMutationFn = Apollo.MutationFunction<DeleteCustomEventMutation, DeleteCustomEventMutationVariables>;

/**
 * __useDeleteCustomEventMutation__
 *
 * To run a mutation, you first call `useDeleteCustomEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomEventMutation, { data, loading, error }] = useDeleteCustomEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCustomEventMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCustomEventMutation, DeleteCustomEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCustomEventMutation, DeleteCustomEventMutationVariables>(DeleteCustomEventDocument, options);
      }
export type DeleteCustomEventMutationHookResult = ReturnType<typeof useDeleteCustomEventMutation>;
export type DeleteCustomEventMutationResult = Apollo.MutationResult<DeleteCustomEventMutation>;
export type DeleteCustomEventMutationOptions = Apollo.BaseMutationOptions<DeleteCustomEventMutation, DeleteCustomEventMutationVariables>;
export const DeleteEmployeeDocument = gql`
    mutation deleteEmployee($id: ID!) {
  deleteEmployee(id: $id)
}
    `;
export type DeleteEmployeeMutationFn = Apollo.MutationFunction<DeleteEmployeeMutation, DeleteEmployeeMutationVariables>;

/**
 * __useDeleteEmployeeMutation__
 *
 * To run a mutation, you first call `useDeleteEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmployeeMutation, { data, loading, error }] = useDeleteEmployeeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEmployeeMutation, DeleteEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEmployeeMutation, DeleteEmployeeMutationVariables>(DeleteEmployeeDocument, options);
      }
export type DeleteEmployeeMutationHookResult = ReturnType<typeof useDeleteEmployeeMutation>;
export type DeleteEmployeeMutationResult = Apollo.MutationResult<DeleteEmployeeMutation>;
export type DeleteEmployeeMutationOptions = Apollo.BaseMutationOptions<DeleteEmployeeMutation, DeleteEmployeeMutationVariables>;
export const DeleteEquipmentPieceDocument = gql`
    mutation deleteEquipmentPiece($id: ID!) {
  deleteEquipmentPiece(id: $id)
}
    `;
export type DeleteEquipmentPieceMutationFn = Apollo.MutationFunction<DeleteEquipmentPieceMutation, DeleteEquipmentPieceMutationVariables>;

/**
 * __useDeleteEquipmentPieceMutation__
 *
 * To run a mutation, you first call `useDeleteEquipmentPieceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEquipmentPieceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEquipmentPieceMutation, { data, loading, error }] = useDeleteEquipmentPieceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEquipmentPieceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEquipmentPieceMutation, DeleteEquipmentPieceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEquipmentPieceMutation, DeleteEquipmentPieceMutationVariables>(DeleteEquipmentPieceDocument, options);
      }
export type DeleteEquipmentPieceMutationHookResult = ReturnType<typeof useDeleteEquipmentPieceMutation>;
export type DeleteEquipmentPieceMutationResult = Apollo.MutationResult<DeleteEquipmentPieceMutation>;
export type DeleteEquipmentPieceMutationOptions = Apollo.BaseMutationOptions<DeleteEquipmentPieceMutation, DeleteEquipmentPieceMutationVariables>;
export const DeleteJobPhaseCostDocument = gql`
    mutation deleteJobPhaseCost($date: Date!, $jobPhaseId: ID!) {
  deleteJobPhaseCost(date: $date, jobPhaseId: $jobPhaseId)
}
    `;
export type DeleteJobPhaseCostMutationFn = Apollo.MutationFunction<DeleteJobPhaseCostMutation, DeleteJobPhaseCostMutationVariables>;

/**
 * __useDeleteJobPhaseCostMutation__
 *
 * To run a mutation, you first call `useDeleteJobPhaseCostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteJobPhaseCostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteJobPhaseCostMutation, { data, loading, error }] = useDeleteJobPhaseCostMutation({
 *   variables: {
 *      date: // value for 'date'
 *      jobPhaseId: // value for 'jobPhaseId'
 *   },
 * });
 */
export function useDeleteJobPhaseCostMutation(baseOptions?: Apollo.MutationHookOptions<DeleteJobPhaseCostMutation, DeleteJobPhaseCostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteJobPhaseCostMutation, DeleteJobPhaseCostMutationVariables>(DeleteJobPhaseCostDocument, options);
      }
export type DeleteJobPhaseCostMutationHookResult = ReturnType<typeof useDeleteJobPhaseCostMutation>;
export type DeleteJobPhaseCostMutationResult = Apollo.MutationResult<DeleteJobPhaseCostMutation>;
export type DeleteJobPhaseCostMutationOptions = Apollo.BaseMutationOptions<DeleteJobPhaseCostMutation, DeleteJobPhaseCostMutationVariables>;
export const DeleteJobPhaseFileDocument = gql`
    mutation deleteJobPhaseFile($id: ID!) {
  deleteJobPhaseFile(id: $id)
}
    `;
export type DeleteJobPhaseFileMutationFn = Apollo.MutationFunction<DeleteJobPhaseFileMutation, DeleteJobPhaseFileMutationVariables>;

/**
 * __useDeleteJobPhaseFileMutation__
 *
 * To run a mutation, you first call `useDeleteJobPhaseFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteJobPhaseFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteJobPhaseFileMutation, { data, loading, error }] = useDeleteJobPhaseFileMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteJobPhaseFileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteJobPhaseFileMutation, DeleteJobPhaseFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteJobPhaseFileMutation, DeleteJobPhaseFileMutationVariables>(DeleteJobPhaseFileDocument, options);
      }
export type DeleteJobPhaseFileMutationHookResult = ReturnType<typeof useDeleteJobPhaseFileMutation>;
export type DeleteJobPhaseFileMutationResult = Apollo.MutationResult<DeleteJobPhaseFileMutation>;
export type DeleteJobPhaseFileMutationOptions = Apollo.BaseMutationOptions<DeleteJobPhaseFileMutation, DeleteJobPhaseFileMutationVariables>;
export const DeleteNotificationTriggerDocument = gql`
    mutation deleteNotificationTrigger($id: ID!) {
  deleteNotificationTrigger(id: $id)
}
    `;
export type DeleteNotificationTriggerMutationFn = Apollo.MutationFunction<DeleteNotificationTriggerMutation, DeleteNotificationTriggerMutationVariables>;

/**
 * __useDeleteNotificationTriggerMutation__
 *
 * To run a mutation, you first call `useDeleteNotificationTriggerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNotificationTriggerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNotificationTriggerMutation, { data, loading, error }] = useDeleteNotificationTriggerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteNotificationTriggerMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNotificationTriggerMutation, DeleteNotificationTriggerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNotificationTriggerMutation, DeleteNotificationTriggerMutationVariables>(DeleteNotificationTriggerDocument, options);
      }
export type DeleteNotificationTriggerMutationHookResult = ReturnType<typeof useDeleteNotificationTriggerMutation>;
export type DeleteNotificationTriggerMutationResult = Apollo.MutationResult<DeleteNotificationTriggerMutation>;
export type DeleteNotificationTriggerMutationOptions = Apollo.BaseMutationOptions<DeleteNotificationTriggerMutation, DeleteNotificationTriggerMutationVariables>;
export const DeleteOpportunityDocument = gql`
    mutation deleteOpportunity($id: ID!) {
  deleteOpportunity(id: $id) {
    addressCity
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZip
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      contacts {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      email
      id
      jobsCount
      logo
      name
      notes
      notificationTypes {
        CONTACT
        JOB
        JOB_PHASE
        OPPORTUNITY
        PROPOSAL
      }
      phone
      primaryContact {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    companyId
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    createdAt
    dueAt
    estimatedOpportunityValue
    externalId
    id
    name
    notes
    products {
      id
      indirectPercentage
      markupPercentage
      name
      overheadPercentage
      type
    }
    projectFilesFolderId
    source
    status
    statusId
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        phone
        proposalDefaults {
          autoSave
          color
          id
          layout
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      status
    }
    userId
  }
}
    `;
export type DeleteOpportunityMutationFn = Apollo.MutationFunction<DeleteOpportunityMutation, DeleteOpportunityMutationVariables>;

/**
 * __useDeleteOpportunityMutation__
 *
 * To run a mutation, you first call `useDeleteOpportunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOpportunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOpportunityMutation, { data, loading, error }] = useDeleteOpportunityMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOpportunityMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOpportunityMutation, DeleteOpportunityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOpportunityMutation, DeleteOpportunityMutationVariables>(DeleteOpportunityDocument, options);
      }
export type DeleteOpportunityMutationHookResult = ReturnType<typeof useDeleteOpportunityMutation>;
export type DeleteOpportunityMutationResult = Apollo.MutationResult<DeleteOpportunityMutation>;
export type DeleteOpportunityMutationOptions = Apollo.BaseMutationOptions<DeleteOpportunityMutation, DeleteOpportunityMutationVariables>;
export const DeleteOrganizationAddressDocument = gql`
    mutation deleteOrganizationAddress($id: ID!) {
  deleteOrganizationAddress(id: $id)
}
    `;
export type DeleteOrganizationAddressMutationFn = Apollo.MutationFunction<DeleteOrganizationAddressMutation, DeleteOrganizationAddressMutationVariables>;

/**
 * __useDeleteOrganizationAddressMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationAddressMutation, { data, loading, error }] = useDeleteOrganizationAddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOrganizationAddressMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganizationAddressMutation, DeleteOrganizationAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganizationAddressMutation, DeleteOrganizationAddressMutationVariables>(DeleteOrganizationAddressDocument, options);
      }
export type DeleteOrganizationAddressMutationHookResult = ReturnType<typeof useDeleteOrganizationAddressMutation>;
export type DeleteOrganizationAddressMutationResult = Apollo.MutationResult<DeleteOrganizationAddressMutation>;
export type DeleteOrganizationAddressMutationOptions = Apollo.BaseMutationOptions<DeleteOrganizationAddressMutation, DeleteOrganizationAddressMutationVariables>;
export const DeleteOrganizationDocumentDocument = gql`
    mutation deleteOrganizationDocument($id: ID!) {
  deleteOrganizationDocument(id: $id)
}
    `;
export type DeleteOrganizationDocumentMutationFn = Apollo.MutationFunction<DeleteOrganizationDocumentMutation, DeleteOrganizationDocumentMutationVariables>;

/**
 * __useDeleteOrganizationDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationDocumentMutation, { data, loading, error }] = useDeleteOrganizationDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOrganizationDocumentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganizationDocumentMutation, DeleteOrganizationDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganizationDocumentMutation, DeleteOrganizationDocumentMutationVariables>(DeleteOrganizationDocumentDocument, options);
      }
export type DeleteOrganizationDocumentMutationHookResult = ReturnType<typeof useDeleteOrganizationDocumentMutation>;
export type DeleteOrganizationDocumentMutationResult = Apollo.MutationResult<DeleteOrganizationDocumentMutation>;
export type DeleteOrganizationDocumentMutationOptions = Apollo.BaseMutationOptions<DeleteOrganizationDocumentMutation, DeleteOrganizationDocumentMutationVariables>;
export const DeleteOrganizationProductTypeDocument = gql`
    mutation deleteOrganizationProductType($id: ID!) {
  deleteOrganizationProductType(id: $id)
}
    `;
export type DeleteOrganizationProductTypeMutationFn = Apollo.MutationFunction<DeleteOrganizationProductTypeMutation, DeleteOrganizationProductTypeMutationVariables>;

/**
 * __useDeleteOrganizationProductTypeMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationProductTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationProductTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationProductTypeMutation, { data, loading, error }] = useDeleteOrganizationProductTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOrganizationProductTypeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganizationProductTypeMutation, DeleteOrganizationProductTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganizationProductTypeMutation, DeleteOrganizationProductTypeMutationVariables>(DeleteOrganizationProductTypeDocument, options);
      }
export type DeleteOrganizationProductTypeMutationHookResult = ReturnType<typeof useDeleteOrganizationProductTypeMutation>;
export type DeleteOrganizationProductTypeMutationResult = Apollo.MutationResult<DeleteOrganizationProductTypeMutation>;
export type DeleteOrganizationProductTypeMutationOptions = Apollo.BaseMutationOptions<DeleteOrganizationProductTypeMutation, DeleteOrganizationProductTypeMutationVariables>;
export const DeleteOrganizationUserDocument = gql`
    mutation deleteOrganizationUser($id: ID!, $openProposalAction: DeleteOpenProposalAction!, $reassignJobPhaseForemanUserId: ID, $reassignJobUserId: ID, $reassignUserId: ID) {
  deleteOrganizationUser(
    id: $id
    openProposalAction: $openProposalAction
    reassignJobPhaseForemanUserId: $reassignJobPhaseForemanUserId
    reassignJobUserId: $reassignJobUserId
    reassignUserId: $reassignUserId
  )
}
    `;
export type DeleteOrganizationUserMutationFn = Apollo.MutationFunction<DeleteOrganizationUserMutation, DeleteOrganizationUserMutationVariables>;

/**
 * __useDeleteOrganizationUserMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationUserMutation, { data, loading, error }] = useDeleteOrganizationUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      openProposalAction: // value for 'openProposalAction'
 *      reassignJobPhaseForemanUserId: // value for 'reassignJobPhaseForemanUserId'
 *      reassignJobUserId: // value for 'reassignJobUserId'
 *      reassignUserId: // value for 'reassignUserId'
 *   },
 * });
 */
export function useDeleteOrganizationUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganizationUserMutation, DeleteOrganizationUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganizationUserMutation, DeleteOrganizationUserMutationVariables>(DeleteOrganizationUserDocument, options);
      }
export type DeleteOrganizationUserMutationHookResult = ReturnType<typeof useDeleteOrganizationUserMutation>;
export type DeleteOrganizationUserMutationResult = Apollo.MutationResult<DeleteOrganizationUserMutation>;
export type DeleteOrganizationUserMutationOptions = Apollo.BaseMutationOptions<DeleteOrganizationUserMutation, DeleteOrganizationUserMutationVariables>;
export const DeletePlantDocument = gql`
    mutation deletePlant($id: ID!) {
  deletePlant(id: $id)
}
    `;
export type DeletePlantMutationFn = Apollo.MutationFunction<DeletePlantMutation, DeletePlantMutationVariables>;

/**
 * __useDeletePlantMutation__
 *
 * To run a mutation, you first call `useDeletePlantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePlantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePlantMutation, { data, loading, error }] = useDeletePlantMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePlantMutation(baseOptions?: Apollo.MutationHookOptions<DeletePlantMutation, DeletePlantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePlantMutation, DeletePlantMutationVariables>(DeletePlantDocument, options);
      }
export type DeletePlantMutationHookResult = ReturnType<typeof useDeletePlantMutation>;
export type DeletePlantMutationResult = Apollo.MutationResult<DeletePlantMutation>;
export type DeletePlantMutationOptions = Apollo.BaseMutationOptions<DeletePlantMutation, DeletePlantMutationVariables>;
export const DeleteProductDocument = gql`
    mutation deleteProduct($id: ID!) {
  deleteProduct(id: $id)
}
    `;
export type DeleteProductMutationFn = Apollo.MutationFunction<DeleteProductMutation, DeleteProductMutationVariables>;

/**
 * __useDeleteProductMutation__
 *
 * To run a mutation, you first call `useDeleteProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductMutation, { data, loading, error }] = useDeleteProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProductMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProductMutation, DeleteProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProductMutation, DeleteProductMutationVariables>(DeleteProductDocument, options);
      }
export type DeleteProductMutationHookResult = ReturnType<typeof useDeleteProductMutation>;
export type DeleteProductMutationResult = Apollo.MutationResult<DeleteProductMutation>;
export type DeleteProductMutationOptions = Apollo.BaseMutationOptions<DeleteProductMutation, DeleteProductMutationVariables>;
export const DeleteProjectFileDocument = gql`
    mutation deleteProjectFile($id: ID!) {
  deleteProjectFile(id: $id) {
    children {
      children {
        fileSizeBytes
        id
        name
        parentFolderId
        path
        type
      }
      fileSizeBytes
      id
      name
      parentFolderId
      path
      type
    }
    fileSizeBytes
    id
    name
    parentFolderId
    path
    type
  }
}
    `;
export type DeleteProjectFileMutationFn = Apollo.MutationFunction<DeleteProjectFileMutation, DeleteProjectFileMutationVariables>;

/**
 * __useDeleteProjectFileMutation__
 *
 * To run a mutation, you first call `useDeleteProjectFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectFileMutation, { data, loading, error }] = useDeleteProjectFileMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProjectFileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectFileMutation, DeleteProjectFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectFileMutation, DeleteProjectFileMutationVariables>(DeleteProjectFileDocument, options);
      }
export type DeleteProjectFileMutationHookResult = ReturnType<typeof useDeleteProjectFileMutation>;
export type DeleteProjectFileMutationResult = Apollo.MutationResult<DeleteProjectFileMutation>;
export type DeleteProjectFileMutationOptions = Apollo.BaseMutationOptions<DeleteProjectFileMutation, DeleteProjectFileMutationVariables>;
export const DeleteProposalDocument = gql`
    mutation deleteProposal($id: ID!) {
  deleteProposal(id: $id) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        phone
        proposalDefaults {
          autoSave
          color
          id
          layout
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        events {
          action
          createdAt
        }
        externalId
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterTaxes
        profit
        profitPercentage
        projectFilesFolderId
        proposalNotes
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          profit
          profitPercentage
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          roundTripTravelTimeHours
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          status
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
        uuid
        version
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    clientEmailOverride
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    events {
      action
      createdAt
    }
    externalId
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isSendable
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    overallTotal
    overallTotalAfterTaxes
    profit
    profitPercentage
    projectFilesFolderId
    proposalNotes
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      profit
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
    userId
    uuid
    version
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    wonAt
  }
}
    `;
export type DeleteProposalMutationFn = Apollo.MutationFunction<DeleteProposalMutation, DeleteProposalMutationVariables>;

/**
 * __useDeleteProposalMutation__
 *
 * To run a mutation, you first call `useDeleteProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProposalMutation, { data, loading, error }] = useDeleteProposalMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProposalMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProposalMutation, DeleteProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProposalMutation, DeleteProposalMutationVariables>(DeleteProposalDocument, options);
      }
export type DeleteProposalMutationHookResult = ReturnType<typeof useDeleteProposalMutation>;
export type DeleteProposalMutationResult = Apollo.MutationResult<DeleteProposalMutation>;
export type DeleteProposalMutationOptions = Apollo.BaseMutationOptions<DeleteProposalMutation, DeleteProposalMutationVariables>;
export const DeleteProposalFileDocument = gql`
    mutation deleteProposalFile($id: ID!) {
  deleteProposalFile(id: $id)
}
    `;
export type DeleteProposalFileMutationFn = Apollo.MutationFunction<DeleteProposalFileMutation, DeleteProposalFileMutationVariables>;

/**
 * __useDeleteProposalFileMutation__
 *
 * To run a mutation, you first call `useDeleteProposalFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProposalFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProposalFileMutation, { data, loading, error }] = useDeleteProposalFileMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProposalFileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProposalFileMutation, DeleteProposalFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProposalFileMutation, DeleteProposalFileMutationVariables>(DeleteProposalFileDocument, options);
      }
export type DeleteProposalFileMutationHookResult = ReturnType<typeof useDeleteProposalFileMutation>;
export type DeleteProposalFileMutationResult = Apollo.MutationResult<DeleteProposalFileMutation>;
export type DeleteProposalFileMutationOptions = Apollo.BaseMutationOptions<DeleteProposalFileMutation, DeleteProposalFileMutationVariables>;
export const DeleteProposalMapImageDocument = gql`
    mutation deleteProposalMapImage($id: ID!) {
  deleteProposalMapImage(id: $id)
}
    `;
export type DeleteProposalMapImageMutationFn = Apollo.MutationFunction<DeleteProposalMapImageMutation, DeleteProposalMapImageMutationVariables>;

/**
 * __useDeleteProposalMapImageMutation__
 *
 * To run a mutation, you first call `useDeleteProposalMapImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProposalMapImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProposalMapImageMutation, { data, loading, error }] = useDeleteProposalMapImageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProposalMapImageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProposalMapImageMutation, DeleteProposalMapImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProposalMapImageMutation, DeleteProposalMapImageMutationVariables>(DeleteProposalMapImageDocument, options);
      }
export type DeleteProposalMapImageMutationHookResult = ReturnType<typeof useDeleteProposalMapImageMutation>;
export type DeleteProposalMapImageMutationResult = Apollo.MutationResult<DeleteProposalMapImageMutation>;
export type DeleteProposalMapImageMutationOptions = Apollo.BaseMutationOptions<DeleteProposalMapImageMutation, DeleteProposalMapImageMutationVariables>;
export const DeleteProposalProductDocument = gql`
    mutation deleteProposalProduct($id: ID!) {
  deleteProposalProduct(id: $id) {
    address {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    addressOverride
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTotal
    distanceMeters
    distanceSeconds
    grossMargin
    grossMarginPercentage
    id
    mapData
    mapImage
    mapImageDirty
    name
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    ordering
    overallTotal
    profit
    profitPercentage
    proposalProducts {
      additionalCosts {
        additionalCostId
        cost
        costOverride
        costTotal
        feeAmount
        feeAmountOverride
        feeType
        id
        name
        quantity
        quantityOverride
        showOnProposal
      }
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      costTransferTruck
      crews {
        cost
        crewId
        id
        name
        rate
        rateOverride
        timeOnjob
        timeOnjobOverride
        timeTravel
        timeTravelOverride
      }
      equipmentPieces {
        chargeType
        cost
        equipmentPieceId
        id
        name
        quantity
        quantityOverride
        rate
        rateOverride
        timeOnjob
        timeOnjobOverride
        timeTravel
        timeTravelOverride
        usePercentage
      }
      externalProductName
      files {
        createdAt
        filename
        id
        thumbnail
        type
      }
      grossMargin
      grossMarginPercentage
      id
      isOptional
      jobDuration
      jobDurationDaysOverride
      jobDurationOverride
      jobSize
      mapData
      mapImage
      mapImageDirty
      material {
        areaCoverage
        attributes {
          __typename
          ... on ProductAttributeAsphalt {
            applicationRate
          }
          ... on ProductAttributeConcreteColumn {
            diameter
            height
          }
          ... on ProductAttributeConcreteCurbOrGutter {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeConcreteFlatwork {
            applicationRate
          }
          ... on ProductAttributeConcreteFooting {
            depth
            width
          }
          ... on ProductAttributeConcreteWall {
            height
            width
          }
          ... on ProductAttributeConcreteWaterway {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeCrackSeal {
            crackDepth
            crackWidth
            overbandThickness
            overbandWidth
            poundsPerBlock
            poundsPerGallon
          }
          ... on ProductAttributeCurbWall {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeExcavateOut {
            applicationRate
          }
          ... on ProductAttributeGrading {
            applicationRate
            poundsPerCubicYard
          }
          ... on ProductAttributeMastic {
            crackDepth
            crackWidth
            overbandThickness
            overbandWidth
            poundsPerBlock
            poundsPerGallon
          }
          ... on ProductAttributeMicrosurfacing {
            applicationRate
          }
          ... on ProductAttributeSealCoat {
            applicationRate
          }
          ... on ProductAttributeSlurrySeal {
            applicationRate
          }
          ... on ProductAttributeStriping {
            applicationRate
            lineWidth
          }
        }
        attributesOverride {
          __typename
          ... on ProductAttributeAsphalt {
            applicationRate
          }
          ... on ProductAttributeConcreteColumn {
            diameter
            height
          }
          ... on ProductAttributeConcreteCurbOrGutter {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeConcreteFlatwork {
            applicationRate
          }
          ... on ProductAttributeConcreteFooting {
            depth
            width
          }
          ... on ProductAttributeConcreteWall {
            height
            width
          }
          ... on ProductAttributeConcreteWaterway {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeCrackSeal {
            crackDepth
            crackWidth
            overbandThickness
            overbandWidth
            poundsPerBlock
            poundsPerGallon
          }
          ... on ProductAttributeCurbWall {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeExcavateOut {
            applicationRate
          }
          ... on ProductAttributeGrading {
            applicationRate
            poundsPerCubicYard
          }
          ... on ProductAttributeMastic {
            crackDepth
            crackWidth
            overbandThickness
            overbandWidth
            poundsPerBlock
            poundsPerGallon
          }
          ... on ProductAttributeMicrosurfacing {
            applicationRate
          }
          ... on ProductAttributeSealCoat {
            applicationRate
          }
          ... on ProductAttributeSlurrySeal {
            applicationRate
          }
          ... on ProductAttributeStriping {
            applicationRate
            lineWidth
          }
        }
        costMaterial
        costMaterialOverride
        costMinimumProduct
        costMinimumProposal
        dailyUnitsComplete
        dailyUnitsCompleteOverride
        externalProductName
        id
        indirectPercentage
        indirectPercentageOverride
        labourCostType
        markupPercentage
        markupPercentageOverride
        materialNeeded
        materialNeededOverride
        measurementJob
        measurementMaterial
        name
        organizationProductTypeName
        overheadPercentage
        overheadPercentageOverride
        productId
        productionRateType
        proposalId
        proposalProductId
        proposalStageId
        statementOfWork
        statementOfWorkOverride
        subcontracted
        tonConversionFactor
        tonConversionFactorOverride
        type
        unitPrice
        unitPriceOverride
        unitPriceProduct
      }
      measurementJob
      measurementMaterial
      netMargin
      netMarginPercentage
      notes
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalOverride
      plantProduct {
        id
        plant {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          distanceMeters
          distanceSeconds
          id
          name
          phone
          plantId
          rateOnWeight
          roundTripSeconds
        }
        plantProductId
        rate
        rateOverride
        type
      }
      productName
      profit
      profitPercentage
      profitPercentageOverride
      roundTripTravelTimeHours
      statementOfWork
      subcontractorCost
      subcontractorName
      subcontractorProposalId
      transferTruckLoadTimeBuffer
      transferTruckRoundTripTime
      transferTruckRoundTripTimeOverride
      transferTruckUnloadTimeBuffer
      transferTrucks {
        cost
        costOverride
        id
        name
        plantTransferTruckId
        quantity
        rateHourly
        rateHourlyOverride
        rateTon
        rateTonOverride
        tonnage
        totalHaulingHours
        totalHaulingHoursOverride
        transferTruckId
        truckingProductionRate
        trucksNeeded
      }
    }
    roundTripTravelTimeHours
  }
}
    `;
export type DeleteProposalProductMutationFn = Apollo.MutationFunction<DeleteProposalProductMutation, DeleteProposalProductMutationVariables>;

/**
 * __useDeleteProposalProductMutation__
 *
 * To run a mutation, you first call `useDeleteProposalProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProposalProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProposalProductMutation, { data, loading, error }] = useDeleteProposalProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProposalProductMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProposalProductMutation, DeleteProposalProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProposalProductMutation, DeleteProposalProductMutationVariables>(DeleteProposalProductDocument, options);
      }
export type DeleteProposalProductMutationHookResult = ReturnType<typeof useDeleteProposalProductMutation>;
export type DeleteProposalProductMutationResult = Apollo.MutationResult<DeleteProposalProductMutation>;
export type DeleteProposalProductMutationOptions = Apollo.BaseMutationOptions<DeleteProposalProductMutation, DeleteProposalProductMutationVariables>;
export const DeleteProposalRecipientDocument = gql`
    mutation deleteProposalRecipient($email: String!, $proposalId: ID!) {
  deleteProposalRecipient(email: $email, proposalId: $proposalId)
}
    `;
export type DeleteProposalRecipientMutationFn = Apollo.MutationFunction<DeleteProposalRecipientMutation, DeleteProposalRecipientMutationVariables>;

/**
 * __useDeleteProposalRecipientMutation__
 *
 * To run a mutation, you first call `useDeleteProposalRecipientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProposalRecipientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProposalRecipientMutation, { data, loading, error }] = useDeleteProposalRecipientMutation({
 *   variables: {
 *      email: // value for 'email'
 *      proposalId: // value for 'proposalId'
 *   },
 * });
 */
export function useDeleteProposalRecipientMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProposalRecipientMutation, DeleteProposalRecipientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProposalRecipientMutation, DeleteProposalRecipientMutationVariables>(DeleteProposalRecipientDocument, options);
      }
export type DeleteProposalRecipientMutationHookResult = ReturnType<typeof useDeleteProposalRecipientMutation>;
export type DeleteProposalRecipientMutationResult = Apollo.MutationResult<DeleteProposalRecipientMutation>;
export type DeleteProposalRecipientMutationOptions = Apollo.BaseMutationOptions<DeleteProposalRecipientMutation, DeleteProposalRecipientMutationVariables>;
export const DeleteProposalStageDocument = gql`
    mutation deleteProposalStage($id: ID!) {
  deleteProposalStage(id: $id) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        phone
        proposalDefaults {
          autoSave
          color
          id
          layout
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        events {
          action
          createdAt
        }
        externalId
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterTaxes
        profit
        profitPercentage
        projectFilesFolderId
        proposalNotes
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          profit
          profitPercentage
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          roundTripTravelTimeHours
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          status
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
        uuid
        version
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    clientEmailOverride
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    events {
      action
      createdAt
    }
    externalId
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isSendable
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    overallTotal
    overallTotalAfterTaxes
    profit
    profitPercentage
    projectFilesFolderId
    proposalNotes
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      profit
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
    userId
    uuid
    version
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    wonAt
  }
}
    `;
export type DeleteProposalStageMutationFn = Apollo.MutationFunction<DeleteProposalStageMutation, DeleteProposalStageMutationVariables>;

/**
 * __useDeleteProposalStageMutation__
 *
 * To run a mutation, you first call `useDeleteProposalStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProposalStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProposalStageMutation, { data, loading, error }] = useDeleteProposalStageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProposalStageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProposalStageMutation, DeleteProposalStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProposalStageMutation, DeleteProposalStageMutationVariables>(DeleteProposalStageDocument, options);
      }
export type DeleteProposalStageMutationHookResult = ReturnType<typeof useDeleteProposalStageMutation>;
export type DeleteProposalStageMutationResult = Apollo.MutationResult<DeleteProposalStageMutation>;
export type DeleteProposalStageMutationOptions = Apollo.BaseMutationOptions<DeleteProposalStageMutation, DeleteProposalStageMutationVariables>;
export const DeleteTimeBucketDocument = gql`
    mutation deleteTimeBucket($id: ID!) {
  deleteTimeBucket(id: $id) {
    id
    name
    organizationId
  }
}
    `;
export type DeleteTimeBucketMutationFn = Apollo.MutationFunction<DeleteTimeBucketMutation, DeleteTimeBucketMutationVariables>;

/**
 * __useDeleteTimeBucketMutation__
 *
 * To run a mutation, you first call `useDeleteTimeBucketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTimeBucketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTimeBucketMutation, { data, loading, error }] = useDeleteTimeBucketMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTimeBucketMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTimeBucketMutation, DeleteTimeBucketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTimeBucketMutation, DeleteTimeBucketMutationVariables>(DeleteTimeBucketDocument, options);
      }
export type DeleteTimeBucketMutationHookResult = ReturnType<typeof useDeleteTimeBucketMutation>;
export type DeleteTimeBucketMutationResult = Apollo.MutationResult<DeleteTimeBucketMutation>;
export type DeleteTimeBucketMutationOptions = Apollo.BaseMutationOptions<DeleteTimeBucketMutation, DeleteTimeBucketMutationVariables>;
export const DeleteTimeEntryDocument = gql`
    mutation deleteTimeEntry($id: ID!) {
  deleteTimeEntry(id: $id) {
    clockInLatitude
    clockInLongitude
    clockOutLatitude
    clockOutLongitude
    endTime
    forDate
    id
    jobPhase {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualEmployeeHours
      actualGrossMargin
      actualGrossMarginPercentage
      actualMaterialNeeded
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      address
      applicableStatuses
      costItems {
        additionalCosts {
          additionalCostId
          cost
          costTotal
          feeAmount
          feeType
          id
          jobPhaseCostItem {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          name
        }
        costAdditional
        costEquipment
        costLabour
        costMaterial
        costTransferTruck
        date
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        equipmentPieces {
          equipmentPieceId
          id
          name
          quantity
          rate
          timeOnjob
          timeTravel
        }
        id
        jobPhase {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualEmployeeHours
          actualGrossMargin
          actualGrossMarginPercentage
          actualMaterialNeeded
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address
          applicableStatuses
          crew {
            color
            displayName
            id
            name
            rate
          }
          crewId
          defaultAdditionalCosts {
            cost
            feeAmount
            feeType
            id
            name
          }
          defaultEmployees {
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          defaultEquipmentPieces {
            chargeType
            fuelSurcharge
            id
            name
            rate
            usePercentage
          }
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          endsAt
          externalId
          files {
            createdAt
            filename
            id
            thumbnail
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            endsAt
            externalId
            id
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
          }
          jobDuration
          jobPhasePlant {
            id
            name
            type
          }
          jobSize
          notes
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          organizationProductType {
            id
            indirectPercentage
            markupPercentage
            name
            overheadPercentage
            type
          }
          organizationProductTypeName
          productName
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          proposalProduct {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          proposalStage {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedEmployeeHours
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedMaterialNeeded
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          scheduleBlocks {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          scheduledBlockForDate {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          startsAt
          status
          travelTimeEstimate
          users {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          usersColor
          workOrderCrews {
            crewId
            id
            name
          }
          workOrderEquipmentPieces {
            equipmentPieceId
            id
            name
          }
          workOrderTransferTrucks {
            id
            name
            quantity
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
        }
        material {
          costMaterial
          id
          jobPhaseCostItem {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          materialNeeded
          name
          organizationProductTypeName
          type
        }
        plantId
        plantProductId
        transferTrucks {
          hours
          id
          name
          plantTransferTruckId
          rateHourly
          rateTon
          tonnage
          transferTruckId
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
      }
      crewId
      endsAt
      externalId
      id
      jobDuration
      jobSize
      notes
      organizationProductTypeName
      productName
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedEmployeeHours
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedMaterialNeeded
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      startsAt
      status
      travelTimeEstimate
      usersColor
    }
    notes
    organizationId
    startTime
    timeBucket {
      id
      name
      organizationId
    }
    timeTrackedSeconds
    timeTrackedSecondsOverride
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
    uuid
  }
}
    `;
export type DeleteTimeEntryMutationFn = Apollo.MutationFunction<DeleteTimeEntryMutation, DeleteTimeEntryMutationVariables>;

/**
 * __useDeleteTimeEntryMutation__
 *
 * To run a mutation, you first call `useDeleteTimeEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTimeEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTimeEntryMutation, { data, loading, error }] = useDeleteTimeEntryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTimeEntryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTimeEntryMutation, DeleteTimeEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTimeEntryMutation, DeleteTimeEntryMutationVariables>(DeleteTimeEntryDocument, options);
      }
export type DeleteTimeEntryMutationHookResult = ReturnType<typeof useDeleteTimeEntryMutation>;
export type DeleteTimeEntryMutationResult = Apollo.MutationResult<DeleteTimeEntryMutation>;
export type DeleteTimeEntryMutationOptions = Apollo.BaseMutationOptions<DeleteTimeEntryMutation, DeleteTimeEntryMutationVariables>;
export const DeleteTransferTruckDocument = gql`
    mutation deleteTransferTruck($id: ID!) {
  deleteTransferTruck(id: $id)
}
    `;
export type DeleteTransferTruckMutationFn = Apollo.MutationFunction<DeleteTransferTruckMutation, DeleteTransferTruckMutationVariables>;

/**
 * __useDeleteTransferTruckMutation__
 *
 * To run a mutation, you first call `useDeleteTransferTruckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTransferTruckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTransferTruckMutation, { data, loading, error }] = useDeleteTransferTruckMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTransferTruckMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTransferTruckMutation, DeleteTransferTruckMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTransferTruckMutation, DeleteTransferTruckMutationVariables>(DeleteTransferTruckDocument, options);
      }
export type DeleteTransferTruckMutationHookResult = ReturnType<typeof useDeleteTransferTruckMutation>;
export type DeleteTransferTruckMutationResult = Apollo.MutationResult<DeleteTransferTruckMutation>;
export type DeleteTransferTruckMutationOptions = Apollo.BaseMutationOptions<DeleteTransferTruckMutation, DeleteTransferTruckMutationVariables>;
export const DeleteUserInviteDocument = gql`
    mutation deleteUserInvite($id: ID!) {
  deleteUserInvite(id: $id)
}
    `;
export type DeleteUserInviteMutationFn = Apollo.MutationFunction<DeleteUserInviteMutation, DeleteUserInviteMutationVariables>;

/**
 * __useDeleteUserInviteMutation__
 *
 * To run a mutation, you first call `useDeleteUserInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserInviteMutation, { data, loading, error }] = useDeleteUserInviteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserInviteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserInviteMutation, DeleteUserInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserInviteMutation, DeleteUserInviteMutationVariables>(DeleteUserInviteDocument, options);
      }
export type DeleteUserInviteMutationHookResult = ReturnType<typeof useDeleteUserInviteMutation>;
export type DeleteUserInviteMutationResult = Apollo.MutationResult<DeleteUserInviteMutation>;
export type DeleteUserInviteMutationOptions = Apollo.BaseMutationOptions<DeleteUserInviteMutation, DeleteUserInviteMutationVariables>;
export const DuplicateProductDocument = gql`
    mutation duplicateProduct($id: ID!) {
  duplicateProduct(id: $id) {
    areaCoverage
    attributes {
      __typename
      ... on ProductAttributeAsphalt {
        applicationRate
      }
      ... on ProductAttributeConcreteColumn {
        diameter
        height
      }
      ... on ProductAttributeConcreteCurbOrGutter {
        curbHeight
        curbWidth
        gutterHeight
        gutterWidth
      }
      ... on ProductAttributeConcreteFlatwork {
        applicationRate
      }
      ... on ProductAttributeConcreteFooting {
        depth
        width
      }
      ... on ProductAttributeConcreteWall {
        height
        width
      }
      ... on ProductAttributeConcreteWaterway {
        curbHeight
        curbWidth
        gutterHeight
        gutterWidth
      }
      ... on ProductAttributeCrackSeal {
        crackDepth
        crackWidth
        overbandThickness
        overbandWidth
        poundsPerBlock
        poundsPerGallon
      }
      ... on ProductAttributeCurbWall {
        curbHeight
        curbWidth
        gutterHeight
        gutterWidth
      }
      ... on ProductAttributeExcavateOut {
        applicationRate
      }
      ... on ProductAttributeGrading {
        applicationRate
        poundsPerCubicYard
      }
      ... on ProductAttributeMastic {
        crackDepth
        crackWidth
        overbandThickness
        overbandWidth
        poundsPerBlock
        poundsPerGallon
      }
      ... on ProductAttributeMicrosurfacing {
        applicationRate
      }
      ... on ProductAttributeSealCoat {
        applicationRate
      }
      ... on ProductAttributeSlurrySeal {
        applicationRate
      }
      ... on ProductAttributeStriping {
        applicationRate
        lineWidth
      }
    }
    costMaterial
    costMinimumProduct
    costMinimumProposal
    crew {
      color
      displayName
      employees {
        firstName
        id
        lastName
        name
        organizationId
        rate
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
      }
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          proposalDefaults {
            autoSave
            color
            id
            layout
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        status
      }
      id
      name
      organization {
        email
        emailTemplate
        failingPayment
        id
        logo
        name
        onTrial
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      rate
    }
    dailyUnitsComplete
    externalProductName
    id
    indirectPercentage
    labourCostType
    markupPercentage
    measurementJob
    measurementMaterial
    name
    organizationProductType {
      id
      indirectPercentage
      markupPercentage
      name
      overheadPercentage
      type
    }
    overheadPercentage
    plant {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      id
      name
      phone
      products {
        id
        rate
        type
      }
    }
    plantProductId
    productAdditionalCosts {
      additionalCost {
        cost
        feeAmount
        feeType
        id
        name
      }
      id
      type
    }
    productEquipmentPieces {
      equipmentPiece {
        chargeType
        fuelSurcharge
        id
        name
        rate
        usePercentage
      }
      id
      quantity
    }
    productionRateType
    statementOfWork
    subcontracted
    type
    unitPrice
    unitPriceProduct
  }
}
    `;
export type DuplicateProductMutationFn = Apollo.MutationFunction<DuplicateProductMutation, DuplicateProductMutationVariables>;

/**
 * __useDuplicateProductMutation__
 *
 * To run a mutation, you first call `useDuplicateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateProductMutation, { data, loading, error }] = useDuplicateProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDuplicateProductMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateProductMutation, DuplicateProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateProductMutation, DuplicateProductMutationVariables>(DuplicateProductDocument, options);
      }
export type DuplicateProductMutationHookResult = ReturnType<typeof useDuplicateProductMutation>;
export type DuplicateProductMutationResult = Apollo.MutationResult<DuplicateProductMutation>;
export type DuplicateProductMutationOptions = Apollo.BaseMutationOptions<DuplicateProductMutation, DuplicateProductMutationVariables>;
export const DuplicateProposalDocument = gql`
    mutation duplicateProposal($changeOrderJobId: ID, $createNewVersion: Boolean, $id: ID!, $isChangeOrder: Boolean, $startNewProposal: Boolean) {
  duplicateProposal(
    changeOrderJobId: $changeOrderJobId
    createNewVersion: $createNewVersion
    id: $id
    isChangeOrder: $isChangeOrder
    startNewProposal: $startNewProposal
  ) {
    newProposal {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        organization {
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          proposalDefaults {
            autoSave
            color
            id
            layout
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        addresses {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        attachments {
          id
          name
          path
          thumbnailPath
        }
        changeOrderJobId
        changeOrders {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        clientEmailOverride
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        externalId
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterTaxes
        profit
        profitPercentage
        projectFilesFolderId
        proposalNotes
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        userId
        uuid
        version
        wonAt
      }
      clientEmailOverride
      company {
        addCompanyInfo
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        contacts {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        email
        id
        jobsCount
        logo
        name
        notes
        notificationTypes {
          CONTACT
          JOB
          JOB_PHASE
          OPPORTUNITY
          PROPOSAL
        }
        phone
        primaryContact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        projectFilesFolderId
        proposalsCount
        status
        website
      }
      contact {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      events {
        action
        createdAt
      }
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      recipients {
        contactId
        createdAt
        email
        id
      }
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      salesTaxes {
        id
        name
        organizationSalesTaxId
        percentage
      }
      sentAt
      signedAt
      signedInitials
      signedName
      source
      stages {
        address {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        addressOverride
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        distanceMeters
        distanceSeconds
        grossMargin
        grossMarginPercentage
        id
        mapData
        mapImage
        mapImageDirty
        name
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        profit
        profitPercentage
        proposalProducts {
          additionalCosts {
            additionalCostId
            cost
            costOverride
            costTotal
            feeAmount
            feeAmountOverride
            feeType
            id
            name
            quantity
            quantityOverride
            showOnProposal
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          costTransferTruck
          crews {
            cost
            crewId
            id
            name
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
          }
          equipmentPieces {
            chargeType
            cost
            equipmentPieceId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
            usePercentage
          }
          externalProductName
          files {
            createdAt
            filename
            id
            thumbnail
            type
          }
          grossMargin
          grossMarginPercentage
          id
          isOptional
          jobDuration
          jobDurationDaysOverride
          jobDurationOverride
          jobSize
          mapData
          mapImage
          mapImageDirty
          material {
            areaCoverage
            attributes {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            attributesOverride {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            costMaterial
            costMaterialOverride
            costMinimumProduct
            costMinimumProposal
            dailyUnitsComplete
            dailyUnitsCompleteOverride
            externalProductName
            id
            indirectPercentage
            indirectPercentageOverride
            labourCostType
            markupPercentage
            markupPercentageOverride
            materialNeeded
            materialNeededOverride
            measurementJob
            measurementMaterial
            name
            organizationProductTypeName
            overheadPercentage
            overheadPercentageOverride
            productId
            productionRateType
            proposalId
            proposalProductId
            proposalStageId
            statementOfWork
            statementOfWorkOverride
            subcontracted
            tonConversionFactor
            tonConversionFactorOverride
            type
            unitPrice
            unitPriceOverride
            unitPriceProduct
          }
          measurementJob
          measurementMaterial
          netMargin
          netMarginPercentage
          notes
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalOverride
          plantProduct {
            id
            plantProductId
            rate
            rateOverride
            type
          }
          productName
          profit
          profitPercentage
          profitPercentageOverride
          roundTripTravelTimeHours
          statementOfWork
          subcontractorCost
          subcontractorName
          subcontractorProposalId
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTime
          transferTruckRoundTripTimeOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            quantity
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
        }
        roundTripTravelTimeHours
      }
      status
      statusChanges {
        changeAt
        changedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        status
      }
      user {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          email
          emailTemplate
          failingPayment
          id
          logo
          name
          onTrial
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        status
      }
      userId
      uuid
      version
      versions {
        acceptanceOverride
        activeVersion
        addresses {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        attachments {
          id
          name
          path
          thumbnailPath
        }
        changeOrderJobId
        changeOrders {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          userId
          uuid
          version
          wonAt
        }
        clientEmailOverride
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          email
          id
          jobsCount
          logo
          name
          notes
          phone
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        events {
          action
          createdAt
        }
        externalId
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterTaxes
        profit
        profitPercentage
        projectFilesFolderId
        proposalNotes
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          addressOverride
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          profit
          profitPercentage
          roundTripTravelTimeHours
        }
        status
        statusChanges {
          changeAt
          status
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
        uuid
        version
        versions {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          userId
          uuid
          version
          wonAt
        }
        wonAt
      }
      wonAt
    }
    proposal {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        externalId
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterTaxes
        profit
        profitPercentage
        projectFilesFolderId
        proposalNotes
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        userId
        uuid
        version
        wonAt
      }
      clientEmailOverride
      company {
        addCompanyInfo
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        email
        id
        jobsCount
        logo
        name
        notes
        phone
        projectFilesFolderId
        proposalsCount
        status
        website
      }
      contact {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      events {
        action
        createdAt
      }
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      recipients {
        contactId
        createdAt
        email
        id
      }
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      salesTaxes {
        id
        name
        organizationSalesTaxId
        percentage
      }
      sentAt
      signedAt
      signedInitials
      signedName
      source
      stages {
        addressOverride
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        distanceMeters
        distanceSeconds
        grossMargin
        grossMarginPercentage
        id
        mapData
        mapImage
        mapImageDirty
        name
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        profit
        profitPercentage
        roundTripTravelTimeHours
      }
      status
      statusChanges {
        changeAt
        status
      }
      user {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        status
      }
      userId
      uuid
      version
      versions {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        externalId
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterTaxes
        profit
        profitPercentage
        projectFilesFolderId
        proposalNotes
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        userId
        uuid
        version
        wonAt
      }
      wonAt
    }
  }
}
    `;
export type DuplicateProposalMutationFn = Apollo.MutationFunction<DuplicateProposalMutation, DuplicateProposalMutationVariables>;

/**
 * __useDuplicateProposalMutation__
 *
 * To run a mutation, you first call `useDuplicateProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateProposalMutation, { data, loading, error }] = useDuplicateProposalMutation({
 *   variables: {
 *      changeOrderJobId: // value for 'changeOrderJobId'
 *      createNewVersion: // value for 'createNewVersion'
 *      id: // value for 'id'
 *      isChangeOrder: // value for 'isChangeOrder'
 *      startNewProposal: // value for 'startNewProposal'
 *   },
 * });
 */
export function useDuplicateProposalMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateProposalMutation, DuplicateProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateProposalMutation, DuplicateProposalMutationVariables>(DuplicateProposalDocument, options);
      }
export type DuplicateProposalMutationHookResult = ReturnType<typeof useDuplicateProposalMutation>;
export type DuplicateProposalMutationResult = Apollo.MutationResult<DuplicateProposalMutation>;
export type DuplicateProposalMutationOptions = Apollo.BaseMutationOptions<DuplicateProposalMutation, DuplicateProposalMutationVariables>;
export const FinalizeLinkedServiceAccountDocument = gql`
    mutation finalizeLinkedServiceAccount($code: String, $realmId: String, $service: OrganizationLinkedServiceName!, $state: String) {
  finalizeLinkedServiceAccount(
    code: $code
    realmId: $realmId
    service: $service
    state: $state
  )
}
    `;
export type FinalizeLinkedServiceAccountMutationFn = Apollo.MutationFunction<FinalizeLinkedServiceAccountMutation, FinalizeLinkedServiceAccountMutationVariables>;

/**
 * __useFinalizeLinkedServiceAccountMutation__
 *
 * To run a mutation, you first call `useFinalizeLinkedServiceAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinalizeLinkedServiceAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finalizeLinkedServiceAccountMutation, { data, loading, error }] = useFinalizeLinkedServiceAccountMutation({
 *   variables: {
 *      code: // value for 'code'
 *      realmId: // value for 'realmId'
 *      service: // value for 'service'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useFinalizeLinkedServiceAccountMutation(baseOptions?: Apollo.MutationHookOptions<FinalizeLinkedServiceAccountMutation, FinalizeLinkedServiceAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinalizeLinkedServiceAccountMutation, FinalizeLinkedServiceAccountMutationVariables>(FinalizeLinkedServiceAccountDocument, options);
      }
export type FinalizeLinkedServiceAccountMutationHookResult = ReturnType<typeof useFinalizeLinkedServiceAccountMutation>;
export type FinalizeLinkedServiceAccountMutationResult = Apollo.MutationResult<FinalizeLinkedServiceAccountMutation>;
export type FinalizeLinkedServiceAccountMutationOptions = Apollo.BaseMutationOptions<FinalizeLinkedServiceAccountMutation, FinalizeLinkedServiceAccountMutationVariables>;
export const FinishRegistrationDocument = gql`
    mutation finishRegistration($input: FinishRegistrationInput!) {
  finishRegistration(input: $input) {
    addressCity
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZip
    autoAssign
    avatar
    crewsCount
    email
    firstName
    hasEmployee
    id
    inviteToken
    invitedAt
    invitedBy {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          proposalDefaults {
            autoSave
            color
            id
            layout
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
    jobPhasesCount
    jobsCount
    lastName
    name
    organization {
      email
      emailTemplate
      failingPayment
      id
      logo
      name
      onTrial
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    permissions
    phone
    proposalCount
    roles
    status
  }
}
    `;
export type FinishRegistrationMutationFn = Apollo.MutationFunction<FinishRegistrationMutation, FinishRegistrationMutationVariables>;

/**
 * __useFinishRegistrationMutation__
 *
 * To run a mutation, you first call `useFinishRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishRegistrationMutation, { data, loading, error }] = useFinishRegistrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFinishRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<FinishRegistrationMutation, FinishRegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinishRegistrationMutation, FinishRegistrationMutationVariables>(FinishRegistrationDocument, options);
      }
export type FinishRegistrationMutationHookResult = ReturnType<typeof useFinishRegistrationMutation>;
export type FinishRegistrationMutationResult = Apollo.MutationResult<FinishRegistrationMutation>;
export type FinishRegistrationMutationOptions = Apollo.BaseMutationOptions<FinishRegistrationMutation, FinishRegistrationMutationVariables>;
export const GenerateOrganizationDataUploadUrlDocument = gql`
    mutation generateOrganizationDataUploadUrl($contentType: String!, $filename: String!) {
  generateOrganizationDataUploadUrl(
    contentType: $contentType
    filename: $filename
  ) {
    method
    path
    url
  }
}
    `;
export type GenerateOrganizationDataUploadUrlMutationFn = Apollo.MutationFunction<GenerateOrganizationDataUploadUrlMutation, GenerateOrganizationDataUploadUrlMutationVariables>;

/**
 * __useGenerateOrganizationDataUploadUrlMutation__
 *
 * To run a mutation, you first call `useGenerateOrganizationDataUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateOrganizationDataUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateOrganizationDataUploadUrlMutation, { data, loading, error }] = useGenerateOrganizationDataUploadUrlMutation({
 *   variables: {
 *      contentType: // value for 'contentType'
 *      filename: // value for 'filename'
 *   },
 * });
 */
export function useGenerateOrganizationDataUploadUrlMutation(baseOptions?: Apollo.MutationHookOptions<GenerateOrganizationDataUploadUrlMutation, GenerateOrganizationDataUploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateOrganizationDataUploadUrlMutation, GenerateOrganizationDataUploadUrlMutationVariables>(GenerateOrganizationDataUploadUrlDocument, options);
      }
export type GenerateOrganizationDataUploadUrlMutationHookResult = ReturnType<typeof useGenerateOrganizationDataUploadUrlMutation>;
export type GenerateOrganizationDataUploadUrlMutationResult = Apollo.MutationResult<GenerateOrganizationDataUploadUrlMutation>;
export type GenerateOrganizationDataUploadUrlMutationOptions = Apollo.BaseMutationOptions<GenerateOrganizationDataUploadUrlMutation, GenerateOrganizationDataUploadUrlMutationVariables>;
export const GenerateReportDocument = gql`
    mutation generateReport($endDate: DateTime!, $startDate: DateTime!, $type: ReportType!) {
  generateReport(endDate: $endDate, startDate: $startDate, type: $type)
}
    `;
export type GenerateReportMutationFn = Apollo.MutationFunction<GenerateReportMutation, GenerateReportMutationVariables>;

/**
 * __useGenerateReportMutation__
 *
 * To run a mutation, you first call `useGenerateReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateReportMutation, { data, loading, error }] = useGenerateReportMutation({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGenerateReportMutation(baseOptions?: Apollo.MutationHookOptions<GenerateReportMutation, GenerateReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateReportMutation, GenerateReportMutationVariables>(GenerateReportDocument, options);
      }
export type GenerateReportMutationHookResult = ReturnType<typeof useGenerateReportMutation>;
export type GenerateReportMutationResult = Apollo.MutationResult<GenerateReportMutation>;
export type GenerateReportMutationOptions = Apollo.BaseMutationOptions<GenerateReportMutation, GenerateReportMutationVariables>;
export const GenerateUploadCompanyLogoUrlDocument = gql`
    mutation generateUploadCompanyLogoUrl($contentType: String!, $filename: String!) {
  generateUploadCompanyLogoUrl(contentType: $contentType, filename: $filename) {
    method
    path
    url
  }
}
    `;
export type GenerateUploadCompanyLogoUrlMutationFn = Apollo.MutationFunction<GenerateUploadCompanyLogoUrlMutation, GenerateUploadCompanyLogoUrlMutationVariables>;

/**
 * __useGenerateUploadCompanyLogoUrlMutation__
 *
 * To run a mutation, you first call `useGenerateUploadCompanyLogoUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateUploadCompanyLogoUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateUploadCompanyLogoUrlMutation, { data, loading, error }] = useGenerateUploadCompanyLogoUrlMutation({
 *   variables: {
 *      contentType: // value for 'contentType'
 *      filename: // value for 'filename'
 *   },
 * });
 */
export function useGenerateUploadCompanyLogoUrlMutation(baseOptions?: Apollo.MutationHookOptions<GenerateUploadCompanyLogoUrlMutation, GenerateUploadCompanyLogoUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateUploadCompanyLogoUrlMutation, GenerateUploadCompanyLogoUrlMutationVariables>(GenerateUploadCompanyLogoUrlDocument, options);
      }
export type GenerateUploadCompanyLogoUrlMutationHookResult = ReturnType<typeof useGenerateUploadCompanyLogoUrlMutation>;
export type GenerateUploadCompanyLogoUrlMutationResult = Apollo.MutationResult<GenerateUploadCompanyLogoUrlMutation>;
export type GenerateUploadCompanyLogoUrlMutationOptions = Apollo.BaseMutationOptions<GenerateUploadCompanyLogoUrlMutation, GenerateUploadCompanyLogoUrlMutationVariables>;
export const GenerateUploadJobPhaseCostItemFileUrlDocument = gql`
    mutation generateUploadJobPhaseCostItemFileUrl($contentType: String!, $filename: String!, $jobPhaseId: ID!) {
  generateUploadJobPhaseCostItemFileUrl(
    contentType: $contentType
    filename: $filename
    jobPhaseId: $jobPhaseId
  ) {
    method
    path
    url
  }
}
    `;
export type GenerateUploadJobPhaseCostItemFileUrlMutationFn = Apollo.MutationFunction<GenerateUploadJobPhaseCostItemFileUrlMutation, GenerateUploadJobPhaseCostItemFileUrlMutationVariables>;

/**
 * __useGenerateUploadJobPhaseCostItemFileUrlMutation__
 *
 * To run a mutation, you first call `useGenerateUploadJobPhaseCostItemFileUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateUploadJobPhaseCostItemFileUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateUploadJobPhaseCostItemFileUrlMutation, { data, loading, error }] = useGenerateUploadJobPhaseCostItemFileUrlMutation({
 *   variables: {
 *      contentType: // value for 'contentType'
 *      filename: // value for 'filename'
 *      jobPhaseId: // value for 'jobPhaseId'
 *   },
 * });
 */
export function useGenerateUploadJobPhaseCostItemFileUrlMutation(baseOptions?: Apollo.MutationHookOptions<GenerateUploadJobPhaseCostItemFileUrlMutation, GenerateUploadJobPhaseCostItemFileUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateUploadJobPhaseCostItemFileUrlMutation, GenerateUploadJobPhaseCostItemFileUrlMutationVariables>(GenerateUploadJobPhaseCostItemFileUrlDocument, options);
      }
export type GenerateUploadJobPhaseCostItemFileUrlMutationHookResult = ReturnType<typeof useGenerateUploadJobPhaseCostItemFileUrlMutation>;
export type GenerateUploadJobPhaseCostItemFileUrlMutationResult = Apollo.MutationResult<GenerateUploadJobPhaseCostItemFileUrlMutation>;
export type GenerateUploadJobPhaseCostItemFileUrlMutationOptions = Apollo.BaseMutationOptions<GenerateUploadJobPhaseCostItemFileUrlMutation, GenerateUploadJobPhaseCostItemFileUrlMutationVariables>;
export const GenerateUploadOrganizationDocumentUrlDocument = gql`
    mutation generateUploadOrganizationDocumentUrl($contentType: String!, $filename: String!) {
  generateUploadOrganizationDocumentUrl(
    contentType: $contentType
    filename: $filename
  ) {
    method
    path
    url
  }
}
    `;
export type GenerateUploadOrganizationDocumentUrlMutationFn = Apollo.MutationFunction<GenerateUploadOrganizationDocumentUrlMutation, GenerateUploadOrganizationDocumentUrlMutationVariables>;

/**
 * __useGenerateUploadOrganizationDocumentUrlMutation__
 *
 * To run a mutation, you first call `useGenerateUploadOrganizationDocumentUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateUploadOrganizationDocumentUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateUploadOrganizationDocumentUrlMutation, { data, loading, error }] = useGenerateUploadOrganizationDocumentUrlMutation({
 *   variables: {
 *      contentType: // value for 'contentType'
 *      filename: // value for 'filename'
 *   },
 * });
 */
export function useGenerateUploadOrganizationDocumentUrlMutation(baseOptions?: Apollo.MutationHookOptions<GenerateUploadOrganizationDocumentUrlMutation, GenerateUploadOrganizationDocumentUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateUploadOrganizationDocumentUrlMutation, GenerateUploadOrganizationDocumentUrlMutationVariables>(GenerateUploadOrganizationDocumentUrlDocument, options);
      }
export type GenerateUploadOrganizationDocumentUrlMutationHookResult = ReturnType<typeof useGenerateUploadOrganizationDocumentUrlMutation>;
export type GenerateUploadOrganizationDocumentUrlMutationResult = Apollo.MutationResult<GenerateUploadOrganizationDocumentUrlMutation>;
export type GenerateUploadOrganizationDocumentUrlMutationOptions = Apollo.BaseMutationOptions<GenerateUploadOrganizationDocumentUrlMutation, GenerateUploadOrganizationDocumentUrlMutationVariables>;
export const GenerateUploadOrganizationLogoUrlDocument = gql`
    mutation generateUploadOrganizationLogoUrl($contentType: String!, $filename: String!) {
  generateUploadOrganizationLogoUrl(
    contentType: $contentType
    filename: $filename
  ) {
    method
    path
    url
  }
}
    `;
export type GenerateUploadOrganizationLogoUrlMutationFn = Apollo.MutationFunction<GenerateUploadOrganizationLogoUrlMutation, GenerateUploadOrganizationLogoUrlMutationVariables>;

/**
 * __useGenerateUploadOrganizationLogoUrlMutation__
 *
 * To run a mutation, you first call `useGenerateUploadOrganizationLogoUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateUploadOrganizationLogoUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateUploadOrganizationLogoUrlMutation, { data, loading, error }] = useGenerateUploadOrganizationLogoUrlMutation({
 *   variables: {
 *      contentType: // value for 'contentType'
 *      filename: // value for 'filename'
 *   },
 * });
 */
export function useGenerateUploadOrganizationLogoUrlMutation(baseOptions?: Apollo.MutationHookOptions<GenerateUploadOrganizationLogoUrlMutation, GenerateUploadOrganizationLogoUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateUploadOrganizationLogoUrlMutation, GenerateUploadOrganizationLogoUrlMutationVariables>(GenerateUploadOrganizationLogoUrlDocument, options);
      }
export type GenerateUploadOrganizationLogoUrlMutationHookResult = ReturnType<typeof useGenerateUploadOrganizationLogoUrlMutation>;
export type GenerateUploadOrganizationLogoUrlMutationResult = Apollo.MutationResult<GenerateUploadOrganizationLogoUrlMutation>;
export type GenerateUploadOrganizationLogoUrlMutationOptions = Apollo.BaseMutationOptions<GenerateUploadOrganizationLogoUrlMutation, GenerateUploadOrganizationLogoUrlMutationVariables>;
export const GenerateUploadProjectFileUrlDocument = gql`
    mutation generateUploadProjectFileUrl($contentType: String, $filename: String!) {
  generateUploadProjectFileUrl(contentType: $contentType, filename: $filename) {
    contentDisposition
    contentType
    method
    path
    url
  }
}
    `;
export type GenerateUploadProjectFileUrlMutationFn = Apollo.MutationFunction<GenerateUploadProjectFileUrlMutation, GenerateUploadProjectFileUrlMutationVariables>;

/**
 * __useGenerateUploadProjectFileUrlMutation__
 *
 * To run a mutation, you first call `useGenerateUploadProjectFileUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateUploadProjectFileUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateUploadProjectFileUrlMutation, { data, loading, error }] = useGenerateUploadProjectFileUrlMutation({
 *   variables: {
 *      contentType: // value for 'contentType'
 *      filename: // value for 'filename'
 *   },
 * });
 */
export function useGenerateUploadProjectFileUrlMutation(baseOptions?: Apollo.MutationHookOptions<GenerateUploadProjectFileUrlMutation, GenerateUploadProjectFileUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateUploadProjectFileUrlMutation, GenerateUploadProjectFileUrlMutationVariables>(GenerateUploadProjectFileUrlDocument, options);
      }
export type GenerateUploadProjectFileUrlMutationHookResult = ReturnType<typeof useGenerateUploadProjectFileUrlMutation>;
export type GenerateUploadProjectFileUrlMutationResult = Apollo.MutationResult<GenerateUploadProjectFileUrlMutation>;
export type GenerateUploadProjectFileUrlMutationOptions = Apollo.BaseMutationOptions<GenerateUploadProjectFileUrlMutation, GenerateUploadProjectFileUrlMutationVariables>;
export const GenerateUploadProposalFileUrlDocument = gql`
    mutation generateUploadProposalFileUrl($contentType: String!, $filename: String!, $proposalProductId: ID!) {
  generateUploadProposalFileUrl(
    contentType: $contentType
    filename: $filename
    proposalProductId: $proposalProductId
  ) {
    method
    path
    url
  }
}
    `;
export type GenerateUploadProposalFileUrlMutationFn = Apollo.MutationFunction<GenerateUploadProposalFileUrlMutation, GenerateUploadProposalFileUrlMutationVariables>;

/**
 * __useGenerateUploadProposalFileUrlMutation__
 *
 * To run a mutation, you first call `useGenerateUploadProposalFileUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateUploadProposalFileUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateUploadProposalFileUrlMutation, { data, loading, error }] = useGenerateUploadProposalFileUrlMutation({
 *   variables: {
 *      contentType: // value for 'contentType'
 *      filename: // value for 'filename'
 *      proposalProductId: // value for 'proposalProductId'
 *   },
 * });
 */
export function useGenerateUploadProposalFileUrlMutation(baseOptions?: Apollo.MutationHookOptions<GenerateUploadProposalFileUrlMutation, GenerateUploadProposalFileUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateUploadProposalFileUrlMutation, GenerateUploadProposalFileUrlMutationVariables>(GenerateUploadProposalFileUrlDocument, options);
      }
export type GenerateUploadProposalFileUrlMutationHookResult = ReturnType<typeof useGenerateUploadProposalFileUrlMutation>;
export type GenerateUploadProposalFileUrlMutationResult = Apollo.MutationResult<GenerateUploadProposalFileUrlMutation>;
export type GenerateUploadProposalFileUrlMutationOptions = Apollo.BaseMutationOptions<GenerateUploadProposalFileUrlMutation, GenerateUploadProposalFileUrlMutationVariables>;
export const GetLinkedServiceAuthUrlDocument = gql`
    mutation getLinkedServiceAuthUrl($service: OrganizationLinkedServiceName!) {
  getLinkedServiceAuthUrl(service: $service)
}
    `;
export type GetLinkedServiceAuthUrlMutationFn = Apollo.MutationFunction<GetLinkedServiceAuthUrlMutation, GetLinkedServiceAuthUrlMutationVariables>;

/**
 * __useGetLinkedServiceAuthUrlMutation__
 *
 * To run a mutation, you first call `useGetLinkedServiceAuthUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetLinkedServiceAuthUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getLinkedServiceAuthUrlMutation, { data, loading, error }] = useGetLinkedServiceAuthUrlMutation({
 *   variables: {
 *      service: // value for 'service'
 *   },
 * });
 */
export function useGetLinkedServiceAuthUrlMutation(baseOptions?: Apollo.MutationHookOptions<GetLinkedServiceAuthUrlMutation, GetLinkedServiceAuthUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetLinkedServiceAuthUrlMutation, GetLinkedServiceAuthUrlMutationVariables>(GetLinkedServiceAuthUrlDocument, options);
      }
export type GetLinkedServiceAuthUrlMutationHookResult = ReturnType<typeof useGetLinkedServiceAuthUrlMutation>;
export type GetLinkedServiceAuthUrlMutationResult = Apollo.MutationResult<GetLinkedServiceAuthUrlMutation>;
export type GetLinkedServiceAuthUrlMutationOptions = Apollo.BaseMutationOptions<GetLinkedServiceAuthUrlMutation, GetLinkedServiceAuthUrlMutationVariables>;
export const InviteUserDocument = gql`
    mutation inviteUser($input: InviteUserInput!) {
  inviteUser(input: $input)
}
    `;
export type InviteUserMutationFn = Apollo.MutationFunction<InviteUserMutation, InviteUserMutationVariables>;

/**
 * __useInviteUserMutation__
 *
 * To run a mutation, you first call `useInviteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteUserMutation, { data, loading, error }] = useInviteUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteUserMutation(baseOptions?: Apollo.MutationHookOptions<InviteUserMutation, InviteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteUserMutation, InviteUserMutationVariables>(InviteUserDocument, options);
      }
export type InviteUserMutationHookResult = ReturnType<typeof useInviteUserMutation>;
export type InviteUserMutationResult = Apollo.MutationResult<InviteUserMutation>;
export type InviteUserMutationOptions = Apollo.BaseMutationOptions<InviteUserMutation, InviteUserMutationVariables>;
export const LoginDocument = gql`
    mutation login($input: LoginInput!) {
  login(input: $input) {
    addressCity
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZip
    autoAssign
    avatar
    crewsCount
    email
    firstName
    hasEmployee
    id
    inviteToken
    invitedAt
    invitedBy {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          proposalDefaults {
            autoSave
            color
            id
            layout
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
    jobPhasesCount
    jobsCount
    lastName
    name
    organization {
      email
      emailTemplate
      failingPayment
      id
      logo
      name
      onTrial
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    permissions
    phone
    proposalCount
    roles
    status
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const LogoutDocument = gql`
    mutation logout {
  logout
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const MergeCompanyDocument = gql`
    mutation mergeCompany($sourceCompany: ID!, $targetCompany: ID!) {
  mergeCompany(sourceCompany: $sourceCompany, targetCompany: $targetCompany) {
    addCompanyInfo
    addressCity
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZip
    contacts {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    email
    id
    jobsCount
    logo
    name
    notes
    notificationTypes {
      CONTACT
      JOB
      JOB_PHASE
      OPPORTUNITY
      PROPOSAL
    }
    phone
    primaryContact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    projectFilesFolderId
    proposalsCount
    status
    website
  }
}
    `;
export type MergeCompanyMutationFn = Apollo.MutationFunction<MergeCompanyMutation, MergeCompanyMutationVariables>;

/**
 * __useMergeCompanyMutation__
 *
 * To run a mutation, you first call `useMergeCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeCompanyMutation, { data, loading, error }] = useMergeCompanyMutation({
 *   variables: {
 *      sourceCompany: // value for 'sourceCompany'
 *      targetCompany: // value for 'targetCompany'
 *   },
 * });
 */
export function useMergeCompanyMutation(baseOptions?: Apollo.MutationHookOptions<MergeCompanyMutation, MergeCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MergeCompanyMutation, MergeCompanyMutationVariables>(MergeCompanyDocument, options);
      }
export type MergeCompanyMutationHookResult = ReturnType<typeof useMergeCompanyMutation>;
export type MergeCompanyMutationResult = Apollo.MutationResult<MergeCompanyMutation>;
export type MergeCompanyMutationOptions = Apollo.BaseMutationOptions<MergeCompanyMutation, MergeCompanyMutationVariables>;
export const PreviewProposalDocument = gql`
    mutation previewProposal($acceptanceOverride: String, $attachments: [ID!], $clientEmailOverride: String, $emailBodyOverride: String, $emailSubjectOverride: String, $forceSend: Boolean, $layout: ProposalLayout!, $proposalId: ID!, $removeIndividualLineItemPricing: Boolean, $removeUnitPriceAndQuantity: Boolean) {
  previewProposal(
    acceptanceOverride: $acceptanceOverride
    attachments: $attachments
    clientEmailOverride: $clientEmailOverride
    emailBodyOverride: $emailBodyOverride
    emailSubjectOverride: $emailSubjectOverride
    forceSend: $forceSend
    layout: $layout
    proposalId: $proposalId
    removeIndividualLineItemPricing: $removeIndividualLineItemPricing
    removeUnitPriceAndQuantity: $removeUnitPriceAndQuantity
  )
}
    `;
export type PreviewProposalMutationFn = Apollo.MutationFunction<PreviewProposalMutation, PreviewProposalMutationVariables>;

/**
 * __usePreviewProposalMutation__
 *
 * To run a mutation, you first call `usePreviewProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePreviewProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [previewProposalMutation, { data, loading, error }] = usePreviewProposalMutation({
 *   variables: {
 *      acceptanceOverride: // value for 'acceptanceOverride'
 *      attachments: // value for 'attachments'
 *      clientEmailOverride: // value for 'clientEmailOverride'
 *      emailBodyOverride: // value for 'emailBodyOverride'
 *      emailSubjectOverride: // value for 'emailSubjectOverride'
 *      forceSend: // value for 'forceSend'
 *      layout: // value for 'layout'
 *      proposalId: // value for 'proposalId'
 *      removeIndividualLineItemPricing: // value for 'removeIndividualLineItemPricing'
 *      removeUnitPriceAndQuantity: // value for 'removeUnitPriceAndQuantity'
 *   },
 * });
 */
export function usePreviewProposalMutation(baseOptions?: Apollo.MutationHookOptions<PreviewProposalMutation, PreviewProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PreviewProposalMutation, PreviewProposalMutationVariables>(PreviewProposalDocument, options);
      }
export type PreviewProposalMutationHookResult = ReturnType<typeof usePreviewProposalMutation>;
export type PreviewProposalMutationResult = Apollo.MutationResult<PreviewProposalMutation>;
export type PreviewProposalMutationOptions = Apollo.BaseMutationOptions<PreviewProposalMutation, PreviewProposalMutationVariables>;
export const RegisterDocument = gql`
    mutation register($input: RegisterInput!) {
  register(input: $input)
}
    `;
export type RegisterMutationFn = Apollo.MutationFunction<RegisterMutation, RegisterMutationVariables>;

/**
 * __useRegisterMutation__
 *
 * To run a mutation, you first call `useRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMutation, { data, loading, error }] = useRegisterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterMutation(baseOptions?: Apollo.MutationHookOptions<RegisterMutation, RegisterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterMutation, RegisterMutationVariables>(RegisterDocument, options);
      }
export type RegisterMutationHookResult = ReturnType<typeof useRegisterMutation>;
export type RegisterMutationResult = Apollo.MutationResult<RegisterMutation>;
export type RegisterMutationOptions = Apollo.BaseMutationOptions<RegisterMutation, RegisterMutationVariables>;
export const RemoveTruckFromProposalProductDocument = gql`
    mutation removeTruckFromProposalProduct($id: ID!) {
  removeTruckFromProposalProduct(id: $id) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        phone
        proposalDefaults {
          autoSave
          color
          id
          layout
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        events {
          action
          createdAt
        }
        externalId
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterTaxes
        profit
        profitPercentage
        projectFilesFolderId
        proposalNotes
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          profit
          profitPercentage
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          roundTripTravelTimeHours
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          status
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
        uuid
        version
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    clientEmailOverride
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    events {
      action
      createdAt
    }
    externalId
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isSendable
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    overallTotal
    overallTotalAfterTaxes
    profit
    profitPercentage
    projectFilesFolderId
    proposalNotes
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      profit
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
    userId
    uuid
    version
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    wonAt
  }
}
    `;
export type RemoveTruckFromProposalProductMutationFn = Apollo.MutationFunction<RemoveTruckFromProposalProductMutation, RemoveTruckFromProposalProductMutationVariables>;

/**
 * __useRemoveTruckFromProposalProductMutation__
 *
 * To run a mutation, you first call `useRemoveTruckFromProposalProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTruckFromProposalProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTruckFromProposalProductMutation, { data, loading, error }] = useRemoveTruckFromProposalProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveTruckFromProposalProductMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTruckFromProposalProductMutation, RemoveTruckFromProposalProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTruckFromProposalProductMutation, RemoveTruckFromProposalProductMutationVariables>(RemoveTruckFromProposalProductDocument, options);
      }
export type RemoveTruckFromProposalProductMutationHookResult = ReturnType<typeof useRemoveTruckFromProposalProductMutation>;
export type RemoveTruckFromProposalProductMutationResult = Apollo.MutationResult<RemoveTruckFromProposalProductMutation>;
export type RemoveTruckFromProposalProductMutationOptions = Apollo.BaseMutationOptions<RemoveTruckFromProposalProductMutation, RemoveTruckFromProposalProductMutationVariables>;
export const RequestPasswordResetDocument = gql`
    mutation requestPasswordReset($input: RequestPasswordResetInput!) {
  requestPasswordReset(input: $input)
}
    `;
export type RequestPasswordResetMutationFn = Apollo.MutationFunction<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>;

/**
 * __useRequestPasswordResetMutation__
 *
 * To run a mutation, you first call `useRequestPasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPasswordResetMutation, { data, loading, error }] = useRequestPasswordResetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestPasswordResetMutation(baseOptions?: Apollo.MutationHookOptions<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>(RequestPasswordResetDocument, options);
      }
export type RequestPasswordResetMutationHookResult = ReturnType<typeof useRequestPasswordResetMutation>;
export type RequestPasswordResetMutationResult = Apollo.MutationResult<RequestPasswordResetMutation>;
export type RequestPasswordResetMutationOptions = Apollo.BaseMutationOptions<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>;
export const ResendUserInviteDocument = gql`
    mutation resendUserInvite($id: ID!) {
  resendUserInvite(id: $id)
}
    `;
export type ResendUserInviteMutationFn = Apollo.MutationFunction<ResendUserInviteMutation, ResendUserInviteMutationVariables>;

/**
 * __useResendUserInviteMutation__
 *
 * To run a mutation, you first call `useResendUserInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendUserInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendUserInviteMutation, { data, loading, error }] = useResendUserInviteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResendUserInviteMutation(baseOptions?: Apollo.MutationHookOptions<ResendUserInviteMutation, ResendUserInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendUserInviteMutation, ResendUserInviteMutationVariables>(ResendUserInviteDocument, options);
      }
export type ResendUserInviteMutationHookResult = ReturnType<typeof useResendUserInviteMutation>;
export type ResendUserInviteMutationResult = Apollo.MutationResult<ResendUserInviteMutation>;
export type ResendUserInviteMutationOptions = Apollo.BaseMutationOptions<ResendUserInviteMutation, ResendUserInviteMutationVariables>;
export const ResendVerificationEmailDocument = gql`
    mutation resendVerificationEmail($input: ResendVerificationEmailInput!) {
  resendVerificationEmail(input: $input)
}
    `;
export type ResendVerificationEmailMutationFn = Apollo.MutationFunction<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>;

/**
 * __useResendVerificationEmailMutation__
 *
 * To run a mutation, you first call `useResendVerificationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendVerificationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendVerificationEmailMutation, { data, loading, error }] = useResendVerificationEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResendVerificationEmailMutation(baseOptions?: Apollo.MutationHookOptions<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>(ResendVerificationEmailDocument, options);
      }
export type ResendVerificationEmailMutationHookResult = ReturnType<typeof useResendVerificationEmailMutation>;
export type ResendVerificationEmailMutationResult = Apollo.MutationResult<ResendVerificationEmailMutation>;
export type ResendVerificationEmailMutationOptions = Apollo.BaseMutationOptions<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation resetPassword($input: ResetPasswordInput!) {
  resetPassword(input: $input)
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const SaveQuickbooksIncomeAccountDocument = gql`
    mutation saveQuickbooksIncomeAccount($id: ID!) {
  saveQuickbooksIncomeAccount(id: $id)
}
    `;
export type SaveQuickbooksIncomeAccountMutationFn = Apollo.MutationFunction<SaveQuickbooksIncomeAccountMutation, SaveQuickbooksIncomeAccountMutationVariables>;

/**
 * __useSaveQuickbooksIncomeAccountMutation__
 *
 * To run a mutation, you first call `useSaveQuickbooksIncomeAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveQuickbooksIncomeAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveQuickbooksIncomeAccountMutation, { data, loading, error }] = useSaveQuickbooksIncomeAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSaveQuickbooksIncomeAccountMutation(baseOptions?: Apollo.MutationHookOptions<SaveQuickbooksIncomeAccountMutation, SaveQuickbooksIncomeAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveQuickbooksIncomeAccountMutation, SaveQuickbooksIncomeAccountMutationVariables>(SaveQuickbooksIncomeAccountDocument, options);
      }
export type SaveQuickbooksIncomeAccountMutationHookResult = ReturnType<typeof useSaveQuickbooksIncomeAccountMutation>;
export type SaveQuickbooksIncomeAccountMutationResult = Apollo.MutationResult<SaveQuickbooksIncomeAccountMutation>;
export type SaveQuickbooksIncomeAccountMutationOptions = Apollo.BaseMutationOptions<SaveQuickbooksIncomeAccountMutation, SaveQuickbooksIncomeAccountMutationVariables>;
export const SaveQuickbooksIntegrationDocument = gql`
    mutation saveQuickbooksIntegration($input: QuickbooksIntegrationInput!) {
  saveQuickbooksIntegration(input: $input)
}
    `;
export type SaveQuickbooksIntegrationMutationFn = Apollo.MutationFunction<SaveQuickbooksIntegrationMutation, SaveQuickbooksIntegrationMutationVariables>;

/**
 * __useSaveQuickbooksIntegrationMutation__
 *
 * To run a mutation, you first call `useSaveQuickbooksIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveQuickbooksIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveQuickbooksIntegrationMutation, { data, loading, error }] = useSaveQuickbooksIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveQuickbooksIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<SaveQuickbooksIntegrationMutation, SaveQuickbooksIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveQuickbooksIntegrationMutation, SaveQuickbooksIntegrationMutationVariables>(SaveQuickbooksIntegrationDocument, options);
      }
export type SaveQuickbooksIntegrationMutationHookResult = ReturnType<typeof useSaveQuickbooksIntegrationMutation>;
export type SaveQuickbooksIntegrationMutationResult = Apollo.MutationResult<SaveQuickbooksIntegrationMutation>;
export type SaveQuickbooksIntegrationMutationOptions = Apollo.BaseMutationOptions<SaveQuickbooksIntegrationMutation, SaveQuickbooksIntegrationMutationVariables>;
export const ScheduleCustomEventBlockDocument = gql`
    mutation scheduleCustomEventBlock($input: ScheduleCustomEventBlockInput!) {
  scheduleCustomEventBlock(input: $input) {
    color
    crew {
      color
      displayName
      employees {
        firstName
        id
        lastName
        name
        organizationId
        rate
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
      }
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          proposalDefaults {
            autoSave
            color
            id
            layout
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        status
      }
      id
      name
      organization {
        email
        emailTemplate
        failingPayment
        id
        logo
        name
        onTrial
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      rate
    }
    customEventBlocks {
      blockLength
      customEvent {
        color
        crew {
          color
          displayName
          id
          name
          rate
        }
        customEventBlocks {
          blockLength
          endsAt
          id
          scheduledAt
        }
        customEventsToUsers {
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
        }
        endsAt
        id
        name
        notes
        startsAt
      }
      endsAt
      id
      scheduledAt
    }
    endsAt
    id
    name
    notes
    startsAt
  }
}
    `;
export type ScheduleCustomEventBlockMutationFn = Apollo.MutationFunction<ScheduleCustomEventBlockMutation, ScheduleCustomEventBlockMutationVariables>;

/**
 * __useScheduleCustomEventBlockMutation__
 *
 * To run a mutation, you first call `useScheduleCustomEventBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleCustomEventBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleCustomEventBlockMutation, { data, loading, error }] = useScheduleCustomEventBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useScheduleCustomEventBlockMutation(baseOptions?: Apollo.MutationHookOptions<ScheduleCustomEventBlockMutation, ScheduleCustomEventBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScheduleCustomEventBlockMutation, ScheduleCustomEventBlockMutationVariables>(ScheduleCustomEventBlockDocument, options);
      }
export type ScheduleCustomEventBlockMutationHookResult = ReturnType<typeof useScheduleCustomEventBlockMutation>;
export type ScheduleCustomEventBlockMutationResult = Apollo.MutationResult<ScheduleCustomEventBlockMutation>;
export type ScheduleCustomEventBlockMutationOptions = Apollo.BaseMutationOptions<ScheduleCustomEventBlockMutation, ScheduleCustomEventBlockMutationVariables>;
export const ScheduleJobPhaseDocument = gql`
    mutation scheduleJobPhase($blocks: [AddJobPhaseScheduleBlock]!, $crewId: ID, $jobPhaseId: ID!, $travelTimeEstimate: Float, $userIDs: [ID!], $usersColor: String) {
  scheduleJobPhase(
    blocks: $blocks
    crewId: $crewId
    jobPhaseId: $jobPhaseId
    travelTimeEstimate: $travelTimeEstimate
    userIDs: $userIDs
    usersColor: $usersColor
  ) {
    actualCostAdditional
    actualCostDirect
    actualCostEquipment
    actualCostIndirect
    actualCostLabour
    actualCostMaterial
    actualCostOverhead
    actualCostTotal
    actualCostTransferTruck
    actualGrossMargin
    actualGrossMarginPercentage
    actualNetMargin
    actualNetMarginPercentage
    actualOperatingMargin
    actualOperatingMarginPercentage
    actualOverallTotal
    actualProfit
    actualProfitPercentage
    address {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    billingStatus
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        organization {
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          proposalDefaults {
            autoSave
            color
            id
            layout
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        events {
          action
          createdAt
        }
        externalId
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterTaxes
        profit
        profitPercentage
        projectFilesFolderId
        proposalNotes
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          profit
          profitPercentage
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          roundTripTravelTimeHours
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          status
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
        uuid
        version
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    datePushedToQuickbooks
    endsAt
    externalId
    foremanUser {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        email
        emailTemplate
        failingPayment
        id
        logo
        name
        onTrial
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      status
    }
    id
    jobPhases {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualEmployeeHours
      actualGrossMargin
      actualGrossMarginPercentage
      actualMaterialNeeded
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      address
      applicableStatuses
      costItems {
        additionalCosts {
          additionalCostId
          cost
          costTotal
          feeAmount
          feeType
          id
          jobPhaseCostItem {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          name
        }
        costAdditional
        costEquipment
        costLabour
        costMaterial
        costTransferTruck
        date
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        equipmentPieces {
          equipmentPieceId
          id
          name
          quantity
          rate
          timeOnjob
          timeTravel
        }
        id
        jobPhase {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualEmployeeHours
          actualGrossMargin
          actualGrossMarginPercentage
          actualMaterialNeeded
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address
          applicableStatuses
          costItems {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          crew {
            color
            displayName
            id
            name
            rate
          }
          crewId
          defaultAdditionalCosts {
            cost
            feeAmount
            feeType
            id
            name
          }
          defaultEmployees {
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          defaultEquipmentPieces {
            chargeType
            fuelSurcharge
            id
            name
            rate
            usePercentage
          }
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          endsAt
          externalId
          files {
            createdAt
            filename
            id
            thumbnail
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            endsAt
            externalId
            id
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
          }
          jobDuration
          jobPhasePlant {
            id
            name
            type
          }
          jobSize
          notes
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          organizationProductType {
            id
            indirectPercentage
            markupPercentage
            name
            overheadPercentage
            type
          }
          organizationProductTypeName
          productName
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          proposalProduct {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          proposalStage {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedEmployeeHours
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedMaterialNeeded
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          scheduleBlocks {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          scheduledBlockForDate {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          startsAt
          status
          travelTimeEstimate
          users {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          usersColor
          workOrderCrews {
            crewId
            id
            name
          }
          workOrderEquipmentPieces {
            equipmentPieceId
            id
            name
          }
          workOrderTransferTrucks {
            id
            name
            quantity
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
        }
        material {
          costMaterial
          id
          jobPhaseCostItem {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          materialNeeded
          name
          organizationProductTypeName
          type
        }
        plantId
        plantProductId
        transferTrucks {
          hours
          id
          name
          plantTransferTruckId
          rateHourly
          rateTon
          tonnage
          transferTruckId
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          status
        }
      }
      crew {
        color
        displayName
        employees {
          firstName
          id
          lastName
          name
          organizationId
          rate
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
        }
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          status
        }
        id
        name
        organization {
          email
          emailTemplate
          failingPayment
          id
          logo
          name
          onTrial
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        rate
      }
      crewId
      defaultAdditionalCosts {
        cost
        feeAmount
        feeType
        id
        name
      }
      defaultEmployees {
        firstName
        id
        lastName
        name
        organizationId
        rate
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
      }
      defaultEquipmentPieces {
        chargeType
        fuelSurcharge
        id
        name
        rate
        usePercentage
      }
      employees {
        employeeId
        id
        name
        rate
        timeOnjob
        timeTravel
      }
      endsAt
      externalId
      files {
        createdAt
        filename
        id
        thumbnail
      }
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        status
      }
      id
      job {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualGrossMargin
        actualGrossMarginPercentage
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        address {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        billingStatus
        changeOrders {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          userId
          uuid
          version
          wonAt
        }
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          email
          id
          jobsCount
          logo
          name
          notes
          phone
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        datePushedToQuickbooks
        endsAt
        externalId
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          status
        }
        id
        jobPhases {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualEmployeeHours
          actualGrossMargin
          actualGrossMarginPercentage
          actualMaterialNeeded
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address
          applicableStatuses
          crewId
          endsAt
          externalId
          id
          jobDuration
          jobPhasePlant {
            id
            name
            type
          }
          jobSize
          notes
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          organizationProductType {
            id
            indirectPercentage
            markupPercentage
            name
            overheadPercentage
            type
          }
          organizationProductTypeName
          productName
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          proposalProduct {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          proposalStage {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedEmployeeHours
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedMaterialNeeded
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          scheduleBlocks {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          scheduledBlockForDate {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          startsAt
          status
          travelTimeEstimate
          users {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          usersColor
          workOrderCrews {
            crewId
            id
            name
          }
          workOrderEquipmentPieces {
            equipmentPieceId
            id
            name
          }
          workOrderTransferTrucks {
            id
            name
            quantity
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
        }
        mayShowTaxNotification
        notes
        projectFilesFolderId
        proposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        proposalId
        proposalStage {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          profit
          profitPercentage
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          roundTripTravelTimeHours
        }
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        shouldPushTaxesToQuickbooks
        startsAt
        status
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
      }
      jobDuration
      jobSize
      notes
      organizationProductTypeName
      productName
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedEmployeeHours
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedMaterialNeeded
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      startsAt
      status
      travelTimeEstimate
      usersColor
    }
    mayShowTaxNotification
    notes
    projectFilesFolderId
    proposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    proposalId
    proposalStage {
      addressOverride
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      profit
      profitPercentage
      roundTripTravelTimeHours
    }
    proposedCostAdditional
    proposedCostDirect
    proposedCostEquipment
    proposedCostIndirect
    proposedCostLabour
    proposedCostMaterial
    proposedCostOverhead
    proposedCostTotal
    proposedCostTransferTruck
    proposedGrossMargin
    proposedGrossMarginPercentage
    proposedNetMargin
    proposedNetMarginPercentage
    proposedOperatingMargin
    proposedOperatingMarginPercentage
    proposedOverallTotal
    proposedProfit
    proposedProfitPercentage
    shouldPushTaxesToQuickbooks
    startsAt
    status
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
    userId
  }
}
    `;
export type ScheduleJobPhaseMutationFn = Apollo.MutationFunction<ScheduleJobPhaseMutation, ScheduleJobPhaseMutationVariables>;

/**
 * __useScheduleJobPhaseMutation__
 *
 * To run a mutation, you first call `useScheduleJobPhaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleJobPhaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleJobPhaseMutation, { data, loading, error }] = useScheduleJobPhaseMutation({
 *   variables: {
 *      blocks: // value for 'blocks'
 *      crewId: // value for 'crewId'
 *      jobPhaseId: // value for 'jobPhaseId'
 *      travelTimeEstimate: // value for 'travelTimeEstimate'
 *      userIDs: // value for 'userIDs'
 *      usersColor: // value for 'usersColor'
 *   },
 * });
 */
export function useScheduleJobPhaseMutation(baseOptions?: Apollo.MutationHookOptions<ScheduleJobPhaseMutation, ScheduleJobPhaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScheduleJobPhaseMutation, ScheduleJobPhaseMutationVariables>(ScheduleJobPhaseDocument, options);
      }
export type ScheduleJobPhaseMutationHookResult = ReturnType<typeof useScheduleJobPhaseMutation>;
export type ScheduleJobPhaseMutationResult = Apollo.MutationResult<ScheduleJobPhaseMutation>;
export type ScheduleJobPhaseMutationOptions = Apollo.BaseMutationOptions<ScheduleJobPhaseMutation, ScheduleJobPhaseMutationVariables>;
export const ScheduleJobPhaseBlockDocument = gql`
    mutation scheduleJobPhaseBlock($input: ScheduleJobPhaseBlockInput!) {
  scheduleJobPhaseBlock(input: $input) {
    actualCostAdditional
    actualCostDirect
    actualCostEquipment
    actualCostIndirect
    actualCostLabour
    actualCostMaterial
    actualCostOverhead
    actualCostTotal
    actualCostTransferTruck
    actualGrossMargin
    actualGrossMarginPercentage
    actualNetMargin
    actualNetMarginPercentage
    actualOperatingMargin
    actualOperatingMarginPercentage
    actualOverallTotal
    actualProfit
    actualProfitPercentage
    address {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    billingStatus
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        organization {
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          proposalDefaults {
            autoSave
            color
            id
            layout
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        events {
          action
          createdAt
        }
        externalId
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterTaxes
        profit
        profitPercentage
        projectFilesFolderId
        proposalNotes
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          profit
          profitPercentage
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          roundTripTravelTimeHours
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          status
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
        uuid
        version
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    datePushedToQuickbooks
    endsAt
    externalId
    foremanUser {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        email
        emailTemplate
        failingPayment
        id
        logo
        name
        onTrial
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      status
    }
    id
    jobPhases {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualEmployeeHours
      actualGrossMargin
      actualGrossMarginPercentage
      actualMaterialNeeded
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      address
      applicableStatuses
      costItems {
        additionalCosts {
          additionalCostId
          cost
          costTotal
          feeAmount
          feeType
          id
          jobPhaseCostItem {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          name
        }
        costAdditional
        costEquipment
        costLabour
        costMaterial
        costTransferTruck
        date
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        equipmentPieces {
          equipmentPieceId
          id
          name
          quantity
          rate
          timeOnjob
          timeTravel
        }
        id
        jobPhase {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualEmployeeHours
          actualGrossMargin
          actualGrossMarginPercentage
          actualMaterialNeeded
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address
          applicableStatuses
          costItems {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          crew {
            color
            displayName
            id
            name
            rate
          }
          crewId
          defaultAdditionalCosts {
            cost
            feeAmount
            feeType
            id
            name
          }
          defaultEmployees {
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          defaultEquipmentPieces {
            chargeType
            fuelSurcharge
            id
            name
            rate
            usePercentage
          }
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          endsAt
          externalId
          files {
            createdAt
            filename
            id
            thumbnail
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            endsAt
            externalId
            id
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
          }
          jobDuration
          jobPhasePlant {
            id
            name
            type
          }
          jobSize
          notes
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          organizationProductType {
            id
            indirectPercentage
            markupPercentage
            name
            overheadPercentage
            type
          }
          organizationProductTypeName
          productName
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          proposalProduct {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          proposalStage {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedEmployeeHours
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedMaterialNeeded
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          scheduleBlocks {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          scheduledBlockForDate {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          startsAt
          status
          travelTimeEstimate
          users {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          usersColor
          workOrderCrews {
            crewId
            id
            name
          }
          workOrderEquipmentPieces {
            equipmentPieceId
            id
            name
          }
          workOrderTransferTrucks {
            id
            name
            quantity
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
        }
        material {
          costMaterial
          id
          jobPhaseCostItem {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          materialNeeded
          name
          organizationProductTypeName
          type
        }
        plantId
        plantProductId
        transferTrucks {
          hours
          id
          name
          plantTransferTruckId
          rateHourly
          rateTon
          tonnage
          transferTruckId
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          status
        }
      }
      crew {
        color
        displayName
        employees {
          firstName
          id
          lastName
          name
          organizationId
          rate
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
        }
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          status
        }
        id
        name
        organization {
          email
          emailTemplate
          failingPayment
          id
          logo
          name
          onTrial
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        rate
      }
      crewId
      defaultAdditionalCosts {
        cost
        feeAmount
        feeType
        id
        name
      }
      defaultEmployees {
        firstName
        id
        lastName
        name
        organizationId
        rate
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
      }
      defaultEquipmentPieces {
        chargeType
        fuelSurcharge
        id
        name
        rate
        usePercentage
      }
      employees {
        employeeId
        id
        name
        rate
        timeOnjob
        timeTravel
      }
      endsAt
      externalId
      files {
        createdAt
        filename
        id
        thumbnail
      }
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        status
      }
      id
      job {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualGrossMargin
        actualGrossMarginPercentage
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        address {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        billingStatus
        changeOrders {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          userId
          uuid
          version
          wonAt
        }
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          email
          id
          jobsCount
          logo
          name
          notes
          phone
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        datePushedToQuickbooks
        endsAt
        externalId
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          status
        }
        id
        jobPhases {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualEmployeeHours
          actualGrossMargin
          actualGrossMarginPercentage
          actualMaterialNeeded
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address
          applicableStatuses
          crewId
          endsAt
          externalId
          id
          jobDuration
          jobPhasePlant {
            id
            name
            type
          }
          jobSize
          notes
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          organizationProductType {
            id
            indirectPercentage
            markupPercentage
            name
            overheadPercentage
            type
          }
          organizationProductTypeName
          productName
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          proposalProduct {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          proposalStage {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedEmployeeHours
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedMaterialNeeded
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          scheduleBlocks {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          scheduledBlockForDate {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          startsAt
          status
          travelTimeEstimate
          users {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          usersColor
          workOrderCrews {
            crewId
            id
            name
          }
          workOrderEquipmentPieces {
            equipmentPieceId
            id
            name
          }
          workOrderTransferTrucks {
            id
            name
            quantity
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
        }
        mayShowTaxNotification
        notes
        projectFilesFolderId
        proposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        proposalId
        proposalStage {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          profit
          profitPercentage
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          roundTripTravelTimeHours
        }
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        shouldPushTaxesToQuickbooks
        startsAt
        status
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
      }
      jobDuration
      jobSize
      notes
      organizationProductTypeName
      productName
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedEmployeeHours
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedMaterialNeeded
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      startsAt
      status
      travelTimeEstimate
      usersColor
    }
    mayShowTaxNotification
    notes
    projectFilesFolderId
    proposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    proposalId
    proposalStage {
      addressOverride
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      profit
      profitPercentage
      roundTripTravelTimeHours
    }
    proposedCostAdditional
    proposedCostDirect
    proposedCostEquipment
    proposedCostIndirect
    proposedCostLabour
    proposedCostMaterial
    proposedCostOverhead
    proposedCostTotal
    proposedCostTransferTruck
    proposedGrossMargin
    proposedGrossMarginPercentage
    proposedNetMargin
    proposedNetMarginPercentage
    proposedOperatingMargin
    proposedOperatingMarginPercentage
    proposedOverallTotal
    proposedProfit
    proposedProfitPercentage
    shouldPushTaxesToQuickbooks
    startsAt
    status
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
    userId
  }
}
    `;
export type ScheduleJobPhaseBlockMutationFn = Apollo.MutationFunction<ScheduleJobPhaseBlockMutation, ScheduleJobPhaseBlockMutationVariables>;

/**
 * __useScheduleJobPhaseBlockMutation__
 *
 * To run a mutation, you first call `useScheduleJobPhaseBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleJobPhaseBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleJobPhaseBlockMutation, { data, loading, error }] = useScheduleJobPhaseBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useScheduleJobPhaseBlockMutation(baseOptions?: Apollo.MutationHookOptions<ScheduleJobPhaseBlockMutation, ScheduleJobPhaseBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScheduleJobPhaseBlockMutation, ScheduleJobPhaseBlockMutationVariables>(ScheduleJobPhaseBlockDocument, options);
      }
export type ScheduleJobPhaseBlockMutationHookResult = ReturnType<typeof useScheduleJobPhaseBlockMutation>;
export type ScheduleJobPhaseBlockMutationResult = Apollo.MutationResult<ScheduleJobPhaseBlockMutation>;
export type ScheduleJobPhaseBlockMutationOptions = Apollo.BaseMutationOptions<ScheduleJobPhaseBlockMutation, ScheduleJobPhaseBlockMutationVariables>;
export const SendOrganizationEmailTemplatePreviewDocument = gql`
    mutation sendOrganizationEmailTemplatePreview($html: String!) {
  sendOrganizationEmailTemplatePreview(html: $html)
}
    `;
export type SendOrganizationEmailTemplatePreviewMutationFn = Apollo.MutationFunction<SendOrganizationEmailTemplatePreviewMutation, SendOrganizationEmailTemplatePreviewMutationVariables>;

/**
 * __useSendOrganizationEmailTemplatePreviewMutation__
 *
 * To run a mutation, you first call `useSendOrganizationEmailTemplatePreviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendOrganizationEmailTemplatePreviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendOrganizationEmailTemplatePreviewMutation, { data, loading, error }] = useSendOrganizationEmailTemplatePreviewMutation({
 *   variables: {
 *      html: // value for 'html'
 *   },
 * });
 */
export function useSendOrganizationEmailTemplatePreviewMutation(baseOptions?: Apollo.MutationHookOptions<SendOrganizationEmailTemplatePreviewMutation, SendOrganizationEmailTemplatePreviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendOrganizationEmailTemplatePreviewMutation, SendOrganizationEmailTemplatePreviewMutationVariables>(SendOrganizationEmailTemplatePreviewDocument, options);
      }
export type SendOrganizationEmailTemplatePreviewMutationHookResult = ReturnType<typeof useSendOrganizationEmailTemplatePreviewMutation>;
export type SendOrganizationEmailTemplatePreviewMutationResult = Apollo.MutationResult<SendOrganizationEmailTemplatePreviewMutation>;
export type SendOrganizationEmailTemplatePreviewMutationOptions = Apollo.BaseMutationOptions<SendOrganizationEmailTemplatePreviewMutation, SendOrganizationEmailTemplatePreviewMutationVariables>;
export const SendProposalDocument = gql`
    mutation sendProposal($acceptanceOverride: String, $attachments: [ID!], $clientEmailOverride: String, $emailBodyOverride: String, $emailSubjectOverride: String, $emails: [String!], $forceSend: Boolean, $layout: ProposalLayout!, $proposalId: ID!, $proposalNotes: String, $removeIndividualLineItemPricing: Boolean, $removeUnitPriceAndQuantity: Boolean) {
  sendProposal(
    acceptanceOverride: $acceptanceOverride
    attachments: $attachments
    clientEmailOverride: $clientEmailOverride
    emailBodyOverride: $emailBodyOverride
    emailSubjectOverride: $emailSubjectOverride
    emails: $emails
    forceSend: $forceSend
    layout: $layout
    proposalId: $proposalId
    proposalNotes: $proposalNotes
    removeIndividualLineItemPricing: $removeIndividualLineItemPricing
    removeUnitPriceAndQuantity: $removeUnitPriceAndQuantity
  )
}
    `;
export type SendProposalMutationFn = Apollo.MutationFunction<SendProposalMutation, SendProposalMutationVariables>;

/**
 * __useSendProposalMutation__
 *
 * To run a mutation, you first call `useSendProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendProposalMutation, { data, loading, error }] = useSendProposalMutation({
 *   variables: {
 *      acceptanceOverride: // value for 'acceptanceOverride'
 *      attachments: // value for 'attachments'
 *      clientEmailOverride: // value for 'clientEmailOverride'
 *      emailBodyOverride: // value for 'emailBodyOverride'
 *      emailSubjectOverride: // value for 'emailSubjectOverride'
 *      emails: // value for 'emails'
 *      forceSend: // value for 'forceSend'
 *      layout: // value for 'layout'
 *      proposalId: // value for 'proposalId'
 *      proposalNotes: // value for 'proposalNotes'
 *      removeIndividualLineItemPricing: // value for 'removeIndividualLineItemPricing'
 *      removeUnitPriceAndQuantity: // value for 'removeUnitPriceAndQuantity'
 *   },
 * });
 */
export function useSendProposalMutation(baseOptions?: Apollo.MutationHookOptions<SendProposalMutation, SendProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendProposalMutation, SendProposalMutationVariables>(SendProposalDocument, options);
      }
export type SendProposalMutationHookResult = ReturnType<typeof useSendProposalMutation>;
export type SendProposalMutationResult = Apollo.MutationResult<SendProposalMutation>;
export type SendProposalMutationOptions = Apollo.BaseMutationOptions<SendProposalMutation, SendProposalMutationVariables>;
export const SendProposalToSpecificRecipientsDocument = gql`
    mutation sendProposalToSpecificRecipients($clientEmailOverride: String, $emailBodyOverride: String, $emailSubjectOverride: String, $emails: [String!]!, $forceSend: Boolean, $proposalId: ID!, $removeIndividualLineItemPricing: Boolean, $removeUnitPriceAndQuantity: Boolean) {
  sendProposalToSpecificRecipients(
    clientEmailOverride: $clientEmailOverride
    emailBodyOverride: $emailBodyOverride
    emailSubjectOverride: $emailSubjectOverride
    emails: $emails
    forceSend: $forceSend
    proposalId: $proposalId
    removeIndividualLineItemPricing: $removeIndividualLineItemPricing
    removeUnitPriceAndQuantity: $removeUnitPriceAndQuantity
  ) {
    contactId
    createdAt
    email
    id
  }
}
    `;
export type SendProposalToSpecificRecipientsMutationFn = Apollo.MutationFunction<SendProposalToSpecificRecipientsMutation, SendProposalToSpecificRecipientsMutationVariables>;

/**
 * __useSendProposalToSpecificRecipientsMutation__
 *
 * To run a mutation, you first call `useSendProposalToSpecificRecipientsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendProposalToSpecificRecipientsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendProposalToSpecificRecipientsMutation, { data, loading, error }] = useSendProposalToSpecificRecipientsMutation({
 *   variables: {
 *      clientEmailOverride: // value for 'clientEmailOverride'
 *      emailBodyOverride: // value for 'emailBodyOverride'
 *      emailSubjectOverride: // value for 'emailSubjectOverride'
 *      emails: // value for 'emails'
 *      forceSend: // value for 'forceSend'
 *      proposalId: // value for 'proposalId'
 *      removeIndividualLineItemPricing: // value for 'removeIndividualLineItemPricing'
 *      removeUnitPriceAndQuantity: // value for 'removeUnitPriceAndQuantity'
 *   },
 * });
 */
export function useSendProposalToSpecificRecipientsMutation(baseOptions?: Apollo.MutationHookOptions<SendProposalToSpecificRecipientsMutation, SendProposalToSpecificRecipientsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendProposalToSpecificRecipientsMutation, SendProposalToSpecificRecipientsMutationVariables>(SendProposalToSpecificRecipientsDocument, options);
      }
export type SendProposalToSpecificRecipientsMutationHookResult = ReturnType<typeof useSendProposalToSpecificRecipientsMutation>;
export type SendProposalToSpecificRecipientsMutationResult = Apollo.MutationResult<SendProposalToSpecificRecipientsMutation>;
export type SendProposalToSpecificRecipientsMutationOptions = Apollo.BaseMutationOptions<SendProposalToSpecificRecipientsMutation, SendProposalToSpecificRecipientsMutationVariables>;
export const SetProposalToDraftDocument = gql`
    mutation setProposalToDraft($id: ID!) {
  setProposalToDraft(id: $id) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        phone
        proposalDefaults {
          autoSave
          color
          id
          layout
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        events {
          action
          createdAt
        }
        externalId
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterTaxes
        profit
        profitPercentage
        projectFilesFolderId
        proposalNotes
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          profit
          profitPercentage
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          roundTripTravelTimeHours
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          status
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
        uuid
        version
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    clientEmailOverride
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    events {
      action
      createdAt
    }
    externalId
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isSendable
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    overallTotal
    overallTotalAfterTaxes
    profit
    profitPercentage
    projectFilesFolderId
    proposalNotes
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      profit
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
    userId
    uuid
    version
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    wonAt
  }
}
    `;
export type SetProposalToDraftMutationFn = Apollo.MutationFunction<SetProposalToDraftMutation, SetProposalToDraftMutationVariables>;

/**
 * __useSetProposalToDraftMutation__
 *
 * To run a mutation, you first call `useSetProposalToDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetProposalToDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setProposalToDraftMutation, { data, loading, error }] = useSetProposalToDraftMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetProposalToDraftMutation(baseOptions?: Apollo.MutationHookOptions<SetProposalToDraftMutation, SetProposalToDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetProposalToDraftMutation, SetProposalToDraftMutationVariables>(SetProposalToDraftDocument, options);
      }
export type SetProposalToDraftMutationHookResult = ReturnType<typeof useSetProposalToDraftMutation>;
export type SetProposalToDraftMutationResult = Apollo.MutationResult<SetProposalToDraftMutation>;
export type SetProposalToDraftMutationOptions = Apollo.BaseMutationOptions<SetProposalToDraftMutation, SetProposalToDraftMutationVariables>;
export const SetProposalToWonDocument = gql`
    mutation setProposalToWon($forceSend: Boolean, $id: ID!) {
  setProposalToWon(forceSend: $forceSend, id: $id) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        phone
        proposalDefaults {
          autoSave
          color
          id
          layout
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        events {
          action
          createdAt
        }
        externalId
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterTaxes
        profit
        profitPercentage
        projectFilesFolderId
        proposalNotes
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          profit
          profitPercentage
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          roundTripTravelTimeHours
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          status
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
        uuid
        version
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    clientEmailOverride
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    events {
      action
      createdAt
    }
    externalId
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isSendable
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    overallTotal
    overallTotalAfterTaxes
    profit
    profitPercentage
    projectFilesFolderId
    proposalNotes
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      profit
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
    userId
    uuid
    version
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    wonAt
  }
}
    `;
export type SetProposalToWonMutationFn = Apollo.MutationFunction<SetProposalToWonMutation, SetProposalToWonMutationVariables>;

/**
 * __useSetProposalToWonMutation__
 *
 * To run a mutation, you first call `useSetProposalToWonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetProposalToWonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setProposalToWonMutation, { data, loading, error }] = useSetProposalToWonMutation({
 *   variables: {
 *      forceSend: // value for 'forceSend'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetProposalToWonMutation(baseOptions?: Apollo.MutationHookOptions<SetProposalToWonMutation, SetProposalToWonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetProposalToWonMutation, SetProposalToWonMutationVariables>(SetProposalToWonDocument, options);
      }
export type SetProposalToWonMutationHookResult = ReturnType<typeof useSetProposalToWonMutation>;
export type SetProposalToWonMutationResult = Apollo.MutationResult<SetProposalToWonMutation>;
export type SetProposalToWonMutationOptions = Apollo.BaseMutationOptions<SetProposalToWonMutation, SetProposalToWonMutationVariables>;
export const SignProposalDocument = gql`
    mutation signProposal($email: String!, $removeProducts: [String!], $signature: String!, $signeeInitials: String!, $signeeName: String!, $signeeTitle: String!, $uuid: String!) {
  signProposal(
    email: $email
    removeProducts: $removeProducts
    signature: $signature
    signeeInitials: $signeeInitials
    signeeName: $signeeName
    signeeTitle: $signeeTitle
    uuid: $uuid
  ) {
    acceptanceOverride
    attachments {
      id
      name
      organization {
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        phone
        proposalDefaults {
          autoSave
          color
          id
          layout
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    company {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      name
      phone
      website
    }
    contact {
      email
      firstName
      id
      lastName
      phone
      title
    }
    content {
      content
      contentOverride
      type
    }
    costTaxes
    externalId
    id
    layout
    organization {
      address {
        city
        country
        id
        isPrimary
        latitude
        line1
        line2
        longitude
        state
        zip
      }
      email
      id
      logo
      name
      phone
    }
    overallTotal
    overallTotalAfterTaxes
    proposalPDF
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    signedAt
    signeeInitials
    signeeName
    signeeTitle
    stages {
      address {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        state
        zip
      }
      addressOverride
      content {
        content
        contentOverride
        type
      }
      id
      name
      ordering
      overallTotal
      proposalProducts {
        additionalCosts {
          additionalCostId
          cost
          costOverride
          costTotal
          feeAmount
          feeAmountOverride
          feeType
          id
          name
          quantity
          quantityOverride
          showOnProposal
        }
        files {
          createdAt
          filename
          id
          thumbnail
          type
        }
        id
        isOptional
        jobDuration
        jobSize
        mapImage
        material {
          areaCoverage
          attributes {
            __typename
            ... on ProductAttributeAsphalt {
              applicationRate
            }
            ... on ProductAttributeConcreteColumn {
              diameter
              height
            }
            ... on ProductAttributeConcreteCurbOrGutter {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeConcreteFlatwork {
              applicationRate
            }
            ... on ProductAttributeConcreteFooting {
              depth
              width
            }
            ... on ProductAttributeConcreteWall {
              height
              width
            }
            ... on ProductAttributeConcreteWaterway {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeCrackSeal {
              crackDepth
              crackWidth
              overbandThickness
              overbandWidth
              poundsPerBlock
              poundsPerGallon
            }
            ... on ProductAttributeCurbWall {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeExcavateOut {
              applicationRate
            }
            ... on ProductAttributeGrading {
              applicationRate
              poundsPerCubicYard
            }
            ... on ProductAttributeMastic {
              crackDepth
              crackWidth
              overbandThickness
              overbandWidth
              poundsPerBlock
              poundsPerGallon
            }
            ... on ProductAttributeMicrosurfacing {
              applicationRate
            }
            ... on ProductAttributeSealCoat {
              applicationRate
            }
            ... on ProductAttributeSlurrySeal {
              applicationRate
            }
            ... on ProductAttributeStriping {
              applicationRate
              lineWidth
            }
          }
          attributesOverride {
            __typename
            ... on ProductAttributeAsphalt {
              applicationRate
            }
            ... on ProductAttributeConcreteColumn {
              diameter
              height
            }
            ... on ProductAttributeConcreteCurbOrGutter {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeConcreteFlatwork {
              applicationRate
            }
            ... on ProductAttributeConcreteFooting {
              depth
              width
            }
            ... on ProductAttributeConcreteWall {
              height
              width
            }
            ... on ProductAttributeConcreteWaterway {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeCrackSeal {
              crackDepth
              crackWidth
              overbandThickness
              overbandWidth
              poundsPerBlock
              poundsPerGallon
            }
            ... on ProductAttributeCurbWall {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeExcavateOut {
              applicationRate
            }
            ... on ProductAttributeGrading {
              applicationRate
              poundsPerCubicYard
            }
            ... on ProductAttributeMastic {
              crackDepth
              crackWidth
              overbandThickness
              overbandWidth
              poundsPerBlock
              poundsPerGallon
            }
            ... on ProductAttributeMicrosurfacing {
              applicationRate
            }
            ... on ProductAttributeSealCoat {
              applicationRate
            }
            ... on ProductAttributeSlurrySeal {
              applicationRate
            }
            ... on ProductAttributeStriping {
              applicationRate
              lineWidth
            }
          }
          costMaterial
          costMaterialOverride
          costMinimumProduct
          costMinimumProposal
          dailyUnitsComplete
          dailyUnitsCompleteOverride
          externalProductName
          id
          indirectPercentage
          indirectPercentageOverride
          labourCostType
          markupPercentage
          markupPercentageOverride
          materialNeeded
          materialNeededOverride
          measurementJob
          measurementMaterial
          name
          organizationProductTypeName
          overheadPercentage
          overheadPercentageOverride
          productId
          productionRateType
          proposalId
          proposalProductId
          proposalStageId
          statementOfWork
          statementOfWorkOverride
          subcontracted
          tonConversionFactor
          tonConversionFactorOverride
          type
          unitPrice
          unitPriceOverride
          unitPriceProduct
        }
        ordering
        overallTotal
        overallTotalOverride
        statementOfWork
      }
    }
    status
    user {
      email
      firstName
      id
      lastName
      phone
    }
  }
}
    `;
export type SignProposalMutationFn = Apollo.MutationFunction<SignProposalMutation, SignProposalMutationVariables>;

/**
 * __useSignProposalMutation__
 *
 * To run a mutation, you first call `useSignProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signProposalMutation, { data, loading, error }] = useSignProposalMutation({
 *   variables: {
 *      email: // value for 'email'
 *      removeProducts: // value for 'removeProducts'
 *      signature: // value for 'signature'
 *      signeeInitials: // value for 'signeeInitials'
 *      signeeName: // value for 'signeeName'
 *      signeeTitle: // value for 'signeeTitle'
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useSignProposalMutation(baseOptions?: Apollo.MutationHookOptions<SignProposalMutation, SignProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignProposalMutation, SignProposalMutationVariables>(SignProposalDocument, options);
      }
export type SignProposalMutationHookResult = ReturnType<typeof useSignProposalMutation>;
export type SignProposalMutationResult = Apollo.MutationResult<SignProposalMutation>;
export type SignProposalMutationOptions = Apollo.BaseMutationOptions<SignProposalMutation, SignProposalMutationVariables>;
export const ToggleProposalProductOptionalityDocument = gql`
    mutation toggleProposalProductOptionality($id: ID!, $isOptional: Boolean!) {
  toggleProposalProductOptionality(id: $id, isOptional: $isOptional) {
    additionalCosts {
      additionalCostId
      cost
      costOverride
      costTotal
      feeAmount
      feeAmountOverride
      feeType
      id
      name
      quantity
      quantityOverride
      showOnProposal
    }
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTotal
    costTransferTruck
    crews {
      cost
      crewId
      id
      name
      rate
      rateOverride
      timeOnjob
      timeOnjobOverride
      timeTravel
      timeTravelOverride
    }
    equipmentPieces {
      chargeType
      cost
      equipmentPieceId
      id
      name
      quantity
      quantityOverride
      rate
      rateOverride
      timeOnjob
      timeOnjobOverride
      timeTravel
      timeTravelOverride
      usePercentage
    }
    externalProductName
    files {
      createdAt
      filename
      id
      thumbnail
      type
    }
    grossMargin
    grossMarginPercentage
    id
    isOptional
    jobDuration
    jobDurationDaysOverride
    jobDurationOverride
    jobSize
    mapData
    mapImage
    mapImageDirty
    material {
      areaCoverage
      attributes {
        __typename
        ... on ProductAttributeAsphalt {
          applicationRate
        }
        ... on ProductAttributeConcreteColumn {
          diameter
          height
        }
        ... on ProductAttributeConcreteCurbOrGutter {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeConcreteFlatwork {
          applicationRate
        }
        ... on ProductAttributeConcreteFooting {
          depth
          width
        }
        ... on ProductAttributeConcreteWall {
          height
          width
        }
        ... on ProductAttributeConcreteWaterway {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeCrackSeal {
          crackDepth
          crackWidth
          overbandThickness
          overbandWidth
          poundsPerBlock
          poundsPerGallon
        }
        ... on ProductAttributeCurbWall {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeExcavateOut {
          applicationRate
        }
        ... on ProductAttributeGrading {
          applicationRate
          poundsPerCubicYard
        }
        ... on ProductAttributeMastic {
          crackDepth
          crackWidth
          overbandThickness
          overbandWidth
          poundsPerBlock
          poundsPerGallon
        }
        ... on ProductAttributeMicrosurfacing {
          applicationRate
        }
        ... on ProductAttributeSealCoat {
          applicationRate
        }
        ... on ProductAttributeSlurrySeal {
          applicationRate
        }
        ... on ProductAttributeStriping {
          applicationRate
          lineWidth
        }
      }
      attributesOverride {
        __typename
        ... on ProductAttributeAsphalt {
          applicationRate
        }
        ... on ProductAttributeConcreteColumn {
          diameter
          height
        }
        ... on ProductAttributeConcreteCurbOrGutter {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeConcreteFlatwork {
          applicationRate
        }
        ... on ProductAttributeConcreteFooting {
          depth
          width
        }
        ... on ProductAttributeConcreteWall {
          height
          width
        }
        ... on ProductAttributeConcreteWaterway {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeCrackSeal {
          crackDepth
          crackWidth
          overbandThickness
          overbandWidth
          poundsPerBlock
          poundsPerGallon
        }
        ... on ProductAttributeCurbWall {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeExcavateOut {
          applicationRate
        }
        ... on ProductAttributeGrading {
          applicationRate
          poundsPerCubicYard
        }
        ... on ProductAttributeMastic {
          crackDepth
          crackWidth
          overbandThickness
          overbandWidth
          poundsPerBlock
          poundsPerGallon
        }
        ... on ProductAttributeMicrosurfacing {
          applicationRate
        }
        ... on ProductAttributeSealCoat {
          applicationRate
        }
        ... on ProductAttributeSlurrySeal {
          applicationRate
        }
        ... on ProductAttributeStriping {
          applicationRate
          lineWidth
        }
      }
      costMaterial
      costMaterialOverride
      costMinimumProduct
      costMinimumProposal
      dailyUnitsComplete
      dailyUnitsCompleteOverride
      externalProductName
      id
      indirectPercentage
      indirectPercentageOverride
      labourCostType
      markupPercentage
      markupPercentageOverride
      materialNeeded
      materialNeededOverride
      measurementJob
      measurementMaterial
      name
      organizationProductTypeName
      overheadPercentage
      overheadPercentageOverride
      productId
      productionRateType
      proposalId
      proposalProductId
      proposalStageId
      statementOfWork
      statementOfWorkOverride
      subcontracted
      tonConversionFactor
      tonConversionFactorOverride
      type
      unitPrice
      unitPriceOverride
      unitPriceProduct
    }
    measurementJob
    measurementMaterial
    netMargin
    netMarginPercentage
    notes
    operatingMargin
    operatingMarginPercentage
    ordering
    overallTotal
    overallTotalOverride
    plantProduct {
      id
      plant {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        distanceMeters
        distanceSeconds
        id
        name
        phone
        plantId
        rateOnWeight
        roundTripSeconds
      }
      plantProductId
      rate
      rateOverride
      type
    }
    productName
    profit
    profitPercentage
    profitPercentageOverride
    roundTripTravelTimeHours
    statementOfWork
    subcontractorCost
    subcontractorName
    subcontractorProposalId
    transferTruckLoadTimeBuffer
    transferTruckRoundTripTime
    transferTruckRoundTripTimeOverride
    transferTruckUnloadTimeBuffer
    transferTrucks {
      cost
      costOverride
      id
      name
      plantTransferTruckId
      quantity
      rateHourly
      rateHourlyOverride
      rateTon
      rateTonOverride
      tonnage
      totalHaulingHours
      totalHaulingHoursOverride
      transferTruckId
      truckingProductionRate
      trucksNeeded
    }
  }
}
    `;
export type ToggleProposalProductOptionalityMutationFn = Apollo.MutationFunction<ToggleProposalProductOptionalityMutation, ToggleProposalProductOptionalityMutationVariables>;

/**
 * __useToggleProposalProductOptionalityMutation__
 *
 * To run a mutation, you first call `useToggleProposalProductOptionalityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleProposalProductOptionalityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleProposalProductOptionalityMutation, { data, loading, error }] = useToggleProposalProductOptionalityMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isOptional: // value for 'isOptional'
 *   },
 * });
 */
export function useToggleProposalProductOptionalityMutation(baseOptions?: Apollo.MutationHookOptions<ToggleProposalProductOptionalityMutation, ToggleProposalProductOptionalityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleProposalProductOptionalityMutation, ToggleProposalProductOptionalityMutationVariables>(ToggleProposalProductOptionalityDocument, options);
      }
export type ToggleProposalProductOptionalityMutationHookResult = ReturnType<typeof useToggleProposalProductOptionalityMutation>;
export type ToggleProposalProductOptionalityMutationResult = Apollo.MutationResult<ToggleProposalProductOptionalityMutation>;
export type ToggleProposalProductOptionalityMutationOptions = Apollo.BaseMutationOptions<ToggleProposalProductOptionalityMutation, ToggleProposalProductOptionalityMutationVariables>;
export const UnlinkServiceDocument = gql`
    mutation unlinkService($service: OrganizationLinkedServiceName!) {
  unlinkService(service: $service)
}
    `;
export type UnlinkServiceMutationFn = Apollo.MutationFunction<UnlinkServiceMutation, UnlinkServiceMutationVariables>;

/**
 * __useUnlinkServiceMutation__
 *
 * To run a mutation, you first call `useUnlinkServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkServiceMutation, { data, loading, error }] = useUnlinkServiceMutation({
 *   variables: {
 *      service: // value for 'service'
 *   },
 * });
 */
export function useUnlinkServiceMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkServiceMutation, UnlinkServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkServiceMutation, UnlinkServiceMutationVariables>(UnlinkServiceDocument, options);
      }
export type UnlinkServiceMutationHookResult = ReturnType<typeof useUnlinkServiceMutation>;
export type UnlinkServiceMutationResult = Apollo.MutationResult<UnlinkServiceMutation>;
export type UnlinkServiceMutationOptions = Apollo.BaseMutationOptions<UnlinkServiceMutation, UnlinkServiceMutationVariables>;
export const UnscheduleCustomEventDocument = gql`
    mutation unscheduleCustomEvent($id: ID!) {
  unscheduleCustomEvent(id: $id) {
    color
    crew {
      color
      displayName
      employees {
        firstName
        id
        lastName
        name
        organizationId
        rate
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
      }
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          proposalDefaults {
            autoSave
            color
            id
            layout
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        status
      }
      id
      name
      organization {
        email
        emailTemplate
        failingPayment
        id
        logo
        name
        onTrial
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      rate
    }
    customEventBlocks {
      blockLength
      customEvent {
        color
        crew {
          color
          displayName
          id
          name
          rate
        }
        customEventBlocks {
          blockLength
          endsAt
          id
          scheduledAt
        }
        customEventsToUsers {
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
        }
        endsAt
        id
        name
        notes
        startsAt
      }
      endsAt
      id
      scheduledAt
    }
    endsAt
    id
    name
    notes
    startsAt
  }
}
    `;
export type UnscheduleCustomEventMutationFn = Apollo.MutationFunction<UnscheduleCustomEventMutation, UnscheduleCustomEventMutationVariables>;

/**
 * __useUnscheduleCustomEventMutation__
 *
 * To run a mutation, you first call `useUnscheduleCustomEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnscheduleCustomEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unscheduleCustomEventMutation, { data, loading, error }] = useUnscheduleCustomEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnscheduleCustomEventMutation(baseOptions?: Apollo.MutationHookOptions<UnscheduleCustomEventMutation, UnscheduleCustomEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnscheduleCustomEventMutation, UnscheduleCustomEventMutationVariables>(UnscheduleCustomEventDocument, options);
      }
export type UnscheduleCustomEventMutationHookResult = ReturnType<typeof useUnscheduleCustomEventMutation>;
export type UnscheduleCustomEventMutationResult = Apollo.MutationResult<UnscheduleCustomEventMutation>;
export type UnscheduleCustomEventMutationOptions = Apollo.BaseMutationOptions<UnscheduleCustomEventMutation, UnscheduleCustomEventMutationVariables>;
export const UnscheduleJobPhaseDocument = gql`
    mutation unscheduleJobPhase($jobPhaseId: ID!) {
  unscheduleJobPhase(jobPhaseId: $jobPhaseId) {
    actualCostAdditional
    actualCostDirect
    actualCostEquipment
    actualCostIndirect
    actualCostLabour
    actualCostMaterial
    actualCostOverhead
    actualCostTotal
    actualCostTransferTruck
    actualGrossMargin
    actualGrossMarginPercentage
    actualNetMargin
    actualNetMarginPercentage
    actualOperatingMargin
    actualOperatingMarginPercentage
    actualOverallTotal
    actualProfit
    actualProfitPercentage
    address {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    billingStatus
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        organization {
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          proposalDefaults {
            autoSave
            color
            id
            layout
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        events {
          action
          createdAt
        }
        externalId
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterTaxes
        profit
        profitPercentage
        projectFilesFolderId
        proposalNotes
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          profit
          profitPercentage
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          roundTripTravelTimeHours
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          status
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
        uuid
        version
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    datePushedToQuickbooks
    endsAt
    externalId
    foremanUser {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        email
        emailTemplate
        failingPayment
        id
        logo
        name
        onTrial
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      status
    }
    id
    jobPhases {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualEmployeeHours
      actualGrossMargin
      actualGrossMarginPercentage
      actualMaterialNeeded
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      address
      applicableStatuses
      costItems {
        additionalCosts {
          additionalCostId
          cost
          costTotal
          feeAmount
          feeType
          id
          jobPhaseCostItem {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          name
        }
        costAdditional
        costEquipment
        costLabour
        costMaterial
        costTransferTruck
        date
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        equipmentPieces {
          equipmentPieceId
          id
          name
          quantity
          rate
          timeOnjob
          timeTravel
        }
        id
        jobPhase {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualEmployeeHours
          actualGrossMargin
          actualGrossMarginPercentage
          actualMaterialNeeded
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address
          applicableStatuses
          costItems {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          crew {
            color
            displayName
            id
            name
            rate
          }
          crewId
          defaultAdditionalCosts {
            cost
            feeAmount
            feeType
            id
            name
          }
          defaultEmployees {
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          defaultEquipmentPieces {
            chargeType
            fuelSurcharge
            id
            name
            rate
            usePercentage
          }
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          endsAt
          externalId
          files {
            createdAt
            filename
            id
            thumbnail
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            endsAt
            externalId
            id
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
          }
          jobDuration
          jobPhasePlant {
            id
            name
            type
          }
          jobSize
          notes
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          organizationProductType {
            id
            indirectPercentage
            markupPercentage
            name
            overheadPercentage
            type
          }
          organizationProductTypeName
          productName
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          proposalProduct {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          proposalStage {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedEmployeeHours
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedMaterialNeeded
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          scheduleBlocks {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          scheduledBlockForDate {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          startsAt
          status
          travelTimeEstimate
          users {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          usersColor
          workOrderCrews {
            crewId
            id
            name
          }
          workOrderEquipmentPieces {
            equipmentPieceId
            id
            name
          }
          workOrderTransferTrucks {
            id
            name
            quantity
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
        }
        material {
          costMaterial
          id
          jobPhaseCostItem {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          materialNeeded
          name
          organizationProductTypeName
          type
        }
        plantId
        plantProductId
        transferTrucks {
          hours
          id
          name
          plantTransferTruckId
          rateHourly
          rateTon
          tonnage
          transferTruckId
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          status
        }
      }
      crew {
        color
        displayName
        employees {
          firstName
          id
          lastName
          name
          organizationId
          rate
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
        }
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          status
        }
        id
        name
        organization {
          email
          emailTemplate
          failingPayment
          id
          logo
          name
          onTrial
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        rate
      }
      crewId
      defaultAdditionalCosts {
        cost
        feeAmount
        feeType
        id
        name
      }
      defaultEmployees {
        firstName
        id
        lastName
        name
        organizationId
        rate
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
      }
      defaultEquipmentPieces {
        chargeType
        fuelSurcharge
        id
        name
        rate
        usePercentage
      }
      employees {
        employeeId
        id
        name
        rate
        timeOnjob
        timeTravel
      }
      endsAt
      externalId
      files {
        createdAt
        filename
        id
        thumbnail
      }
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        status
      }
      id
      job {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualGrossMargin
        actualGrossMarginPercentage
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        address {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        billingStatus
        changeOrders {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          userId
          uuid
          version
          wonAt
        }
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          email
          id
          jobsCount
          logo
          name
          notes
          phone
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        datePushedToQuickbooks
        endsAt
        externalId
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          status
        }
        id
        jobPhases {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualEmployeeHours
          actualGrossMargin
          actualGrossMarginPercentage
          actualMaterialNeeded
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address
          applicableStatuses
          crewId
          endsAt
          externalId
          id
          jobDuration
          jobPhasePlant {
            id
            name
            type
          }
          jobSize
          notes
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          organizationProductType {
            id
            indirectPercentage
            markupPercentage
            name
            overheadPercentage
            type
          }
          organizationProductTypeName
          productName
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          proposalProduct {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          proposalStage {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedEmployeeHours
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedMaterialNeeded
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          scheduleBlocks {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          scheduledBlockForDate {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          startsAt
          status
          travelTimeEstimate
          users {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          usersColor
          workOrderCrews {
            crewId
            id
            name
          }
          workOrderEquipmentPieces {
            equipmentPieceId
            id
            name
          }
          workOrderTransferTrucks {
            id
            name
            quantity
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
        }
        mayShowTaxNotification
        notes
        projectFilesFolderId
        proposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        proposalId
        proposalStage {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          profit
          profitPercentage
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          roundTripTravelTimeHours
        }
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        shouldPushTaxesToQuickbooks
        startsAt
        status
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
      }
      jobDuration
      jobSize
      notes
      organizationProductTypeName
      productName
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedEmployeeHours
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedMaterialNeeded
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      startsAt
      status
      travelTimeEstimate
      usersColor
    }
    mayShowTaxNotification
    notes
    projectFilesFolderId
    proposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    proposalId
    proposalStage {
      addressOverride
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      profit
      profitPercentage
      roundTripTravelTimeHours
    }
    proposedCostAdditional
    proposedCostDirect
    proposedCostEquipment
    proposedCostIndirect
    proposedCostLabour
    proposedCostMaterial
    proposedCostOverhead
    proposedCostTotal
    proposedCostTransferTruck
    proposedGrossMargin
    proposedGrossMarginPercentage
    proposedNetMargin
    proposedNetMarginPercentage
    proposedOperatingMargin
    proposedOperatingMarginPercentage
    proposedOverallTotal
    proposedProfit
    proposedProfitPercentage
    shouldPushTaxesToQuickbooks
    startsAt
    status
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
    userId
  }
}
    `;
export type UnscheduleJobPhaseMutationFn = Apollo.MutationFunction<UnscheduleJobPhaseMutation, UnscheduleJobPhaseMutationVariables>;

/**
 * __useUnscheduleJobPhaseMutation__
 *
 * To run a mutation, you first call `useUnscheduleJobPhaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnscheduleJobPhaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unscheduleJobPhaseMutation, { data, loading, error }] = useUnscheduleJobPhaseMutation({
 *   variables: {
 *      jobPhaseId: // value for 'jobPhaseId'
 *   },
 * });
 */
export function useUnscheduleJobPhaseMutation(baseOptions?: Apollo.MutationHookOptions<UnscheduleJobPhaseMutation, UnscheduleJobPhaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnscheduleJobPhaseMutation, UnscheduleJobPhaseMutationVariables>(UnscheduleJobPhaseDocument, options);
      }
export type UnscheduleJobPhaseMutationHookResult = ReturnType<typeof useUnscheduleJobPhaseMutation>;
export type UnscheduleJobPhaseMutationResult = Apollo.MutationResult<UnscheduleJobPhaseMutation>;
export type UnscheduleJobPhaseMutationOptions = Apollo.BaseMutationOptions<UnscheduleJobPhaseMutation, UnscheduleJobPhaseMutationVariables>;
export const UpdateAdditionalCostDocument = gql`
    mutation updateAdditionalCost($input: UpdateAdditionalCostInput!) {
  updateAdditionalCost(input: $input) {
    cost
    feeAmount
    feeType
    id
    name
  }
}
    `;
export type UpdateAdditionalCostMutationFn = Apollo.MutationFunction<UpdateAdditionalCostMutation, UpdateAdditionalCostMutationVariables>;

/**
 * __useUpdateAdditionalCostMutation__
 *
 * To run a mutation, you first call `useUpdateAdditionalCostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdditionalCostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdditionalCostMutation, { data, loading, error }] = useUpdateAdditionalCostMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAdditionalCostMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAdditionalCostMutation, UpdateAdditionalCostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAdditionalCostMutation, UpdateAdditionalCostMutationVariables>(UpdateAdditionalCostDocument, options);
      }
export type UpdateAdditionalCostMutationHookResult = ReturnType<typeof useUpdateAdditionalCostMutation>;
export type UpdateAdditionalCostMutationResult = Apollo.MutationResult<UpdateAdditionalCostMutation>;
export type UpdateAdditionalCostMutationOptions = Apollo.BaseMutationOptions<UpdateAdditionalCostMutation, UpdateAdditionalCostMutationVariables>;
export const UpdateCompanyDocument = gql`
    mutation updateCompany($input: UpdateCompanyInput!) {
  updateCompany(input: $input) {
    addCompanyInfo
    addressCity
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZip
    contacts {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    email
    id
    jobsCount
    logo
    name
    notes
    notificationTypes {
      CONTACT
      JOB
      JOB_PHASE
      OPPORTUNITY
      PROPOSAL
    }
    phone
    primaryContact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    projectFilesFolderId
    proposalsCount
    status
    website
  }
}
    `;
export type UpdateCompanyMutationFn = Apollo.MutationFunction<UpdateCompanyMutation, UpdateCompanyMutationVariables>;

/**
 * __useUpdateCompanyMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyMutation, { data, loading, error }] = useUpdateCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyMutation, UpdateCompanyMutationVariables>(UpdateCompanyDocument, options);
      }
export type UpdateCompanyMutationHookResult = ReturnType<typeof useUpdateCompanyMutation>;
export type UpdateCompanyMutationResult = Apollo.MutationResult<UpdateCompanyMutation>;
export type UpdateCompanyMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>;
export const UpdateCompanyNotesDocument = gql`
    mutation updateCompanyNotes($input: UpdateCompanyNotesInput!) {
  updateCompanyNotes(input: $input) {
    addCompanyInfo
    addressCity
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZip
    contacts {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    email
    id
    jobsCount
    logo
    name
    notes
    notificationTypes {
      CONTACT
      JOB
      JOB_PHASE
      OPPORTUNITY
      PROPOSAL
    }
    phone
    primaryContact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    projectFilesFolderId
    proposalsCount
    status
    website
  }
}
    `;
export type UpdateCompanyNotesMutationFn = Apollo.MutationFunction<UpdateCompanyNotesMutation, UpdateCompanyNotesMutationVariables>;

/**
 * __useUpdateCompanyNotesMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyNotesMutation, { data, loading, error }] = useUpdateCompanyNotesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCompanyNotesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyNotesMutation, UpdateCompanyNotesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyNotesMutation, UpdateCompanyNotesMutationVariables>(UpdateCompanyNotesDocument, options);
      }
export type UpdateCompanyNotesMutationHookResult = ReturnType<typeof useUpdateCompanyNotesMutation>;
export type UpdateCompanyNotesMutationResult = Apollo.MutationResult<UpdateCompanyNotesMutation>;
export type UpdateCompanyNotesMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyNotesMutation, UpdateCompanyNotesMutationVariables>;
export const UpdateCompanyProjectFileFolderIdDocument = gql`
    mutation updateCompanyProjectFileFolderId($id: ID!, $projectFilesFolderId: ID) {
  updateCompanyProjectFileFolderId(
    id: $id
    projectFilesFolderId: $projectFilesFolderId
  ) {
    addCompanyInfo
    addressCity
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZip
    contacts {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    email
    id
    jobsCount
    logo
    name
    notes
    notificationTypes {
      CONTACT
      JOB
      JOB_PHASE
      OPPORTUNITY
      PROPOSAL
    }
    phone
    primaryContact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    projectFilesFolderId
    proposalsCount
    status
    website
  }
}
    `;
export type UpdateCompanyProjectFileFolderIdMutationFn = Apollo.MutationFunction<UpdateCompanyProjectFileFolderIdMutation, UpdateCompanyProjectFileFolderIdMutationVariables>;

/**
 * __useUpdateCompanyProjectFileFolderIdMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyProjectFileFolderIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyProjectFileFolderIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyProjectFileFolderIdMutation, { data, loading, error }] = useUpdateCompanyProjectFileFolderIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      projectFilesFolderId: // value for 'projectFilesFolderId'
 *   },
 * });
 */
export function useUpdateCompanyProjectFileFolderIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyProjectFileFolderIdMutation, UpdateCompanyProjectFileFolderIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyProjectFileFolderIdMutation, UpdateCompanyProjectFileFolderIdMutationVariables>(UpdateCompanyProjectFileFolderIdDocument, options);
      }
export type UpdateCompanyProjectFileFolderIdMutationHookResult = ReturnType<typeof useUpdateCompanyProjectFileFolderIdMutation>;
export type UpdateCompanyProjectFileFolderIdMutationResult = Apollo.MutationResult<UpdateCompanyProjectFileFolderIdMutation>;
export type UpdateCompanyProjectFileFolderIdMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyProjectFileFolderIdMutation, UpdateCompanyProjectFileFolderIdMutationVariables>;
export const UpdateCrewDocument = gql`
    mutation updateCrew($input: UpdateCrewInput!) {
  updateCrew(input: $input) {
    color
    displayName
    employees {
      firstName
      id
      lastName
      name
      organizationId
      rate
      user {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          proposalDefaults {
            autoSave
            color
            id
            layout
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        status
      }
      userId
    }
    foremanUser {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        email
        emailTemplate
        failingPayment
        id
        logo
        name
        onTrial
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      status
    }
    id
    name
    organization {
      email
      emailTemplate
      failingPayment
      id
      logo
      name
      onTrial
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    rate
  }
}
    `;
export type UpdateCrewMutationFn = Apollo.MutationFunction<UpdateCrewMutation, UpdateCrewMutationVariables>;

/**
 * __useUpdateCrewMutation__
 *
 * To run a mutation, you first call `useUpdateCrewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCrewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCrewMutation, { data, loading, error }] = useUpdateCrewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCrewMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCrewMutation, UpdateCrewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCrewMutation, UpdateCrewMutationVariables>(UpdateCrewDocument, options);
      }
export type UpdateCrewMutationHookResult = ReturnType<typeof useUpdateCrewMutation>;
export type UpdateCrewMutationResult = Apollo.MutationResult<UpdateCrewMutation>;
export type UpdateCrewMutationOptions = Apollo.BaseMutationOptions<UpdateCrewMutation, UpdateCrewMutationVariables>;
export const UpdateCustomEventDocument = gql`
    mutation updateCustomEvent($input: UpdateCustomEventInput) {
  updateCustomEvent(input: $input) {
    color
    crew {
      color
      displayName
      employees {
        firstName
        id
        lastName
        name
        organizationId
        rate
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
      }
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          proposalDefaults {
            autoSave
            color
            id
            layout
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        status
      }
      id
      name
      organization {
        email
        emailTemplate
        failingPayment
        id
        logo
        name
        onTrial
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      rate
    }
    customEventBlocks {
      blockLength
      customEvent {
        color
        crew {
          color
          displayName
          id
          name
          rate
        }
        customEventBlocks {
          blockLength
          endsAt
          id
          scheduledAt
        }
        customEventsToUsers {
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
        }
        endsAt
        id
        name
        notes
        startsAt
      }
      endsAt
      id
      scheduledAt
    }
    endsAt
    id
    name
    notes
    startsAt
  }
}
    `;
export type UpdateCustomEventMutationFn = Apollo.MutationFunction<UpdateCustomEventMutation, UpdateCustomEventMutationVariables>;

/**
 * __useUpdateCustomEventMutation__
 *
 * To run a mutation, you first call `useUpdateCustomEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomEventMutation, { data, loading, error }] = useUpdateCustomEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomEventMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomEventMutation, UpdateCustomEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomEventMutation, UpdateCustomEventMutationVariables>(UpdateCustomEventDocument, options);
      }
export type UpdateCustomEventMutationHookResult = ReturnType<typeof useUpdateCustomEventMutation>;
export type UpdateCustomEventMutationResult = Apollo.MutationResult<UpdateCustomEventMutation>;
export type UpdateCustomEventMutationOptions = Apollo.BaseMutationOptions<UpdateCustomEventMutation, UpdateCustomEventMutationVariables>;
export const UpdateEmployeeDocument = gql`
    mutation updateEmployee($input: UpdateEmployeeInput!) {
  updateEmployee(input: $input) {
    firstName
    id
    lastName
    name
    organizationId
    rate
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        phone
        proposalDefaults {
          autoSave
          color
          id
          layout
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      status
    }
    userId
  }
}
    `;
export type UpdateEmployeeMutationFn = Apollo.MutationFunction<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>;

/**
 * __useUpdateEmployeeMutation__
 *
 * To run a mutation, you first call `useUpdateEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmployeeMutation, { data, loading, error }] = useUpdateEmployeeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>(UpdateEmployeeDocument, options);
      }
export type UpdateEmployeeMutationHookResult = ReturnType<typeof useUpdateEmployeeMutation>;
export type UpdateEmployeeMutationResult = Apollo.MutationResult<UpdateEmployeeMutation>;
export type UpdateEmployeeMutationOptions = Apollo.BaseMutationOptions<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>;
export const UpdateEquipmentPieceDocument = gql`
    mutation updateEquipmentPiece($input: UpdateEquipmentPieceInput!) {
  updateEquipmentPiece(input: $input) {
    chargeType
    fuelSurcharge
    id
    name
    rate
    usePercentage
  }
}
    `;
export type UpdateEquipmentPieceMutationFn = Apollo.MutationFunction<UpdateEquipmentPieceMutation, UpdateEquipmentPieceMutationVariables>;

/**
 * __useUpdateEquipmentPieceMutation__
 *
 * To run a mutation, you first call `useUpdateEquipmentPieceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEquipmentPieceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEquipmentPieceMutation, { data, loading, error }] = useUpdateEquipmentPieceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEquipmentPieceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEquipmentPieceMutation, UpdateEquipmentPieceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEquipmentPieceMutation, UpdateEquipmentPieceMutationVariables>(UpdateEquipmentPieceDocument, options);
      }
export type UpdateEquipmentPieceMutationHookResult = ReturnType<typeof useUpdateEquipmentPieceMutation>;
export type UpdateEquipmentPieceMutationResult = Apollo.MutationResult<UpdateEquipmentPieceMutation>;
export type UpdateEquipmentPieceMutationOptions = Apollo.BaseMutationOptions<UpdateEquipmentPieceMutation, UpdateEquipmentPieceMutationVariables>;
export const UpdateJobBillingStatusDocument = gql`
    mutation updateJobBillingStatus($billingStatus: JobBillingStatus!, $id: ID!) {
  updateJobBillingStatus(billingStatus: $billingStatus, id: $id) {
    actualCostAdditional
    actualCostDirect
    actualCostEquipment
    actualCostIndirect
    actualCostLabour
    actualCostMaterial
    actualCostOverhead
    actualCostTotal
    actualCostTransferTruck
    actualGrossMargin
    actualGrossMarginPercentage
    actualNetMargin
    actualNetMarginPercentage
    actualOperatingMargin
    actualOperatingMarginPercentage
    actualOverallTotal
    actualProfit
    actualProfitPercentage
    address {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    billingStatus
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        organization {
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          proposalDefaults {
            autoSave
            color
            id
            layout
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        events {
          action
          createdAt
        }
        externalId
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterTaxes
        profit
        profitPercentage
        projectFilesFolderId
        proposalNotes
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          profit
          profitPercentage
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          roundTripTravelTimeHours
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          status
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
        uuid
        version
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    datePushedToQuickbooks
    endsAt
    externalId
    foremanUser {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        email
        emailTemplate
        failingPayment
        id
        logo
        name
        onTrial
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      status
    }
    id
    jobPhases {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualEmployeeHours
      actualGrossMargin
      actualGrossMarginPercentage
      actualMaterialNeeded
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      address
      applicableStatuses
      costItems {
        additionalCosts {
          additionalCostId
          cost
          costTotal
          feeAmount
          feeType
          id
          jobPhaseCostItem {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          name
        }
        costAdditional
        costEquipment
        costLabour
        costMaterial
        costTransferTruck
        date
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        equipmentPieces {
          equipmentPieceId
          id
          name
          quantity
          rate
          timeOnjob
          timeTravel
        }
        id
        jobPhase {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualEmployeeHours
          actualGrossMargin
          actualGrossMarginPercentage
          actualMaterialNeeded
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address
          applicableStatuses
          costItems {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          crew {
            color
            displayName
            id
            name
            rate
          }
          crewId
          defaultAdditionalCosts {
            cost
            feeAmount
            feeType
            id
            name
          }
          defaultEmployees {
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          defaultEquipmentPieces {
            chargeType
            fuelSurcharge
            id
            name
            rate
            usePercentage
          }
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          endsAt
          externalId
          files {
            createdAt
            filename
            id
            thumbnail
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            endsAt
            externalId
            id
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
          }
          jobDuration
          jobPhasePlant {
            id
            name
            type
          }
          jobSize
          notes
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          organizationProductType {
            id
            indirectPercentage
            markupPercentage
            name
            overheadPercentage
            type
          }
          organizationProductTypeName
          productName
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          proposalProduct {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          proposalStage {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedEmployeeHours
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedMaterialNeeded
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          scheduleBlocks {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          scheduledBlockForDate {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          startsAt
          status
          travelTimeEstimate
          users {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          usersColor
          workOrderCrews {
            crewId
            id
            name
          }
          workOrderEquipmentPieces {
            equipmentPieceId
            id
            name
          }
          workOrderTransferTrucks {
            id
            name
            quantity
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
        }
        material {
          costMaterial
          id
          jobPhaseCostItem {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          materialNeeded
          name
          organizationProductTypeName
          type
        }
        plantId
        plantProductId
        transferTrucks {
          hours
          id
          name
          plantTransferTruckId
          rateHourly
          rateTon
          tonnage
          transferTruckId
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          status
        }
      }
      crew {
        color
        displayName
        employees {
          firstName
          id
          lastName
          name
          organizationId
          rate
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
        }
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          status
        }
        id
        name
        organization {
          email
          emailTemplate
          failingPayment
          id
          logo
          name
          onTrial
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        rate
      }
      crewId
      defaultAdditionalCosts {
        cost
        feeAmount
        feeType
        id
        name
      }
      defaultEmployees {
        firstName
        id
        lastName
        name
        organizationId
        rate
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
      }
      defaultEquipmentPieces {
        chargeType
        fuelSurcharge
        id
        name
        rate
        usePercentage
      }
      employees {
        employeeId
        id
        name
        rate
        timeOnjob
        timeTravel
      }
      endsAt
      externalId
      files {
        createdAt
        filename
        id
        thumbnail
      }
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        status
      }
      id
      job {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualGrossMargin
        actualGrossMarginPercentage
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        address {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        billingStatus
        changeOrders {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          userId
          uuid
          version
          wonAt
        }
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          email
          id
          jobsCount
          logo
          name
          notes
          phone
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        datePushedToQuickbooks
        endsAt
        externalId
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          status
        }
        id
        jobPhases {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualEmployeeHours
          actualGrossMargin
          actualGrossMarginPercentage
          actualMaterialNeeded
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address
          applicableStatuses
          crewId
          endsAt
          externalId
          id
          jobDuration
          jobPhasePlant {
            id
            name
            type
          }
          jobSize
          notes
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          organizationProductType {
            id
            indirectPercentage
            markupPercentage
            name
            overheadPercentage
            type
          }
          organizationProductTypeName
          productName
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          proposalProduct {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          proposalStage {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedEmployeeHours
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedMaterialNeeded
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          scheduleBlocks {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          scheduledBlockForDate {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          startsAt
          status
          travelTimeEstimate
          users {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          usersColor
          workOrderCrews {
            crewId
            id
            name
          }
          workOrderEquipmentPieces {
            equipmentPieceId
            id
            name
          }
          workOrderTransferTrucks {
            id
            name
            quantity
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
        }
        mayShowTaxNotification
        notes
        projectFilesFolderId
        proposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        proposalId
        proposalStage {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          profit
          profitPercentage
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          roundTripTravelTimeHours
        }
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        shouldPushTaxesToQuickbooks
        startsAt
        status
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
      }
      jobDuration
      jobSize
      notes
      organizationProductTypeName
      productName
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedEmployeeHours
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedMaterialNeeded
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      startsAt
      status
      travelTimeEstimate
      usersColor
    }
    mayShowTaxNotification
    notes
    projectFilesFolderId
    proposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    proposalId
    proposalStage {
      addressOverride
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      profit
      profitPercentage
      roundTripTravelTimeHours
    }
    proposedCostAdditional
    proposedCostDirect
    proposedCostEquipment
    proposedCostIndirect
    proposedCostLabour
    proposedCostMaterial
    proposedCostOverhead
    proposedCostTotal
    proposedCostTransferTruck
    proposedGrossMargin
    proposedGrossMarginPercentage
    proposedNetMargin
    proposedNetMarginPercentage
    proposedOperatingMargin
    proposedOperatingMarginPercentage
    proposedOverallTotal
    proposedProfit
    proposedProfitPercentage
    shouldPushTaxesToQuickbooks
    startsAt
    status
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
    userId
  }
}
    `;
export type UpdateJobBillingStatusMutationFn = Apollo.MutationFunction<UpdateJobBillingStatusMutation, UpdateJobBillingStatusMutationVariables>;

/**
 * __useUpdateJobBillingStatusMutation__
 *
 * To run a mutation, you first call `useUpdateJobBillingStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobBillingStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobBillingStatusMutation, { data, loading, error }] = useUpdateJobBillingStatusMutation({
 *   variables: {
 *      billingStatus: // value for 'billingStatus'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateJobBillingStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobBillingStatusMutation, UpdateJobBillingStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJobBillingStatusMutation, UpdateJobBillingStatusMutationVariables>(UpdateJobBillingStatusDocument, options);
      }
export type UpdateJobBillingStatusMutationHookResult = ReturnType<typeof useUpdateJobBillingStatusMutation>;
export type UpdateJobBillingStatusMutationResult = Apollo.MutationResult<UpdateJobBillingStatusMutation>;
export type UpdateJobBillingStatusMutationOptions = Apollo.BaseMutationOptions<UpdateJobBillingStatusMutation, UpdateJobBillingStatusMutationVariables>;
export const UpdateJobNotesDocument = gql`
    mutation updateJobNotes($id: ID!, $notes: String!) {
  updateJobNotes(id: $id, notes: $notes) {
    actualCostAdditional
    actualCostDirect
    actualCostEquipment
    actualCostIndirect
    actualCostLabour
    actualCostMaterial
    actualCostOverhead
    actualCostTotal
    actualCostTransferTruck
    actualGrossMargin
    actualGrossMarginPercentage
    actualNetMargin
    actualNetMarginPercentage
    actualOperatingMargin
    actualOperatingMarginPercentage
    actualOverallTotal
    actualProfit
    actualProfitPercentage
    address {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    billingStatus
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        organization {
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          proposalDefaults {
            autoSave
            color
            id
            layout
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        events {
          action
          createdAt
        }
        externalId
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterTaxes
        profit
        profitPercentage
        projectFilesFolderId
        proposalNotes
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          profit
          profitPercentage
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          roundTripTravelTimeHours
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          status
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
        uuid
        version
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    datePushedToQuickbooks
    endsAt
    externalId
    foremanUser {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        email
        emailTemplate
        failingPayment
        id
        logo
        name
        onTrial
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      status
    }
    id
    jobPhases {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualEmployeeHours
      actualGrossMargin
      actualGrossMarginPercentage
      actualMaterialNeeded
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      address
      applicableStatuses
      costItems {
        additionalCosts {
          additionalCostId
          cost
          costTotal
          feeAmount
          feeType
          id
          jobPhaseCostItem {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          name
        }
        costAdditional
        costEquipment
        costLabour
        costMaterial
        costTransferTruck
        date
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        equipmentPieces {
          equipmentPieceId
          id
          name
          quantity
          rate
          timeOnjob
          timeTravel
        }
        id
        jobPhase {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualEmployeeHours
          actualGrossMargin
          actualGrossMarginPercentage
          actualMaterialNeeded
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address
          applicableStatuses
          costItems {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          crew {
            color
            displayName
            id
            name
            rate
          }
          crewId
          defaultAdditionalCosts {
            cost
            feeAmount
            feeType
            id
            name
          }
          defaultEmployees {
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          defaultEquipmentPieces {
            chargeType
            fuelSurcharge
            id
            name
            rate
            usePercentage
          }
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          endsAt
          externalId
          files {
            createdAt
            filename
            id
            thumbnail
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            endsAt
            externalId
            id
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
          }
          jobDuration
          jobPhasePlant {
            id
            name
            type
          }
          jobSize
          notes
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          organizationProductType {
            id
            indirectPercentage
            markupPercentage
            name
            overheadPercentage
            type
          }
          organizationProductTypeName
          productName
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          proposalProduct {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          proposalStage {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedEmployeeHours
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedMaterialNeeded
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          scheduleBlocks {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          scheduledBlockForDate {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          startsAt
          status
          travelTimeEstimate
          users {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          usersColor
          workOrderCrews {
            crewId
            id
            name
          }
          workOrderEquipmentPieces {
            equipmentPieceId
            id
            name
          }
          workOrderTransferTrucks {
            id
            name
            quantity
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
        }
        material {
          costMaterial
          id
          jobPhaseCostItem {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          materialNeeded
          name
          organizationProductTypeName
          type
        }
        plantId
        plantProductId
        transferTrucks {
          hours
          id
          name
          plantTransferTruckId
          rateHourly
          rateTon
          tonnage
          transferTruckId
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          status
        }
      }
      crew {
        color
        displayName
        employees {
          firstName
          id
          lastName
          name
          organizationId
          rate
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
        }
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          status
        }
        id
        name
        organization {
          email
          emailTemplate
          failingPayment
          id
          logo
          name
          onTrial
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        rate
      }
      crewId
      defaultAdditionalCosts {
        cost
        feeAmount
        feeType
        id
        name
      }
      defaultEmployees {
        firstName
        id
        lastName
        name
        organizationId
        rate
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
      }
      defaultEquipmentPieces {
        chargeType
        fuelSurcharge
        id
        name
        rate
        usePercentage
      }
      employees {
        employeeId
        id
        name
        rate
        timeOnjob
        timeTravel
      }
      endsAt
      externalId
      files {
        createdAt
        filename
        id
        thumbnail
      }
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        status
      }
      id
      job {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualGrossMargin
        actualGrossMarginPercentage
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        address {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        billingStatus
        changeOrders {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          userId
          uuid
          version
          wonAt
        }
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          email
          id
          jobsCount
          logo
          name
          notes
          phone
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        datePushedToQuickbooks
        endsAt
        externalId
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          status
        }
        id
        jobPhases {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualEmployeeHours
          actualGrossMargin
          actualGrossMarginPercentage
          actualMaterialNeeded
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address
          applicableStatuses
          crewId
          endsAt
          externalId
          id
          jobDuration
          jobPhasePlant {
            id
            name
            type
          }
          jobSize
          notes
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          organizationProductType {
            id
            indirectPercentage
            markupPercentage
            name
            overheadPercentage
            type
          }
          organizationProductTypeName
          productName
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          proposalProduct {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          proposalStage {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedEmployeeHours
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedMaterialNeeded
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          scheduleBlocks {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          scheduledBlockForDate {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          startsAt
          status
          travelTimeEstimate
          users {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          usersColor
          workOrderCrews {
            crewId
            id
            name
          }
          workOrderEquipmentPieces {
            equipmentPieceId
            id
            name
          }
          workOrderTransferTrucks {
            id
            name
            quantity
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
        }
        mayShowTaxNotification
        notes
        projectFilesFolderId
        proposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        proposalId
        proposalStage {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          profit
          profitPercentage
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          roundTripTravelTimeHours
        }
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        shouldPushTaxesToQuickbooks
        startsAt
        status
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
      }
      jobDuration
      jobSize
      notes
      organizationProductTypeName
      productName
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedEmployeeHours
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedMaterialNeeded
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      startsAt
      status
      travelTimeEstimate
      usersColor
    }
    mayShowTaxNotification
    notes
    projectFilesFolderId
    proposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    proposalId
    proposalStage {
      addressOverride
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      profit
      profitPercentage
      roundTripTravelTimeHours
    }
    proposedCostAdditional
    proposedCostDirect
    proposedCostEquipment
    proposedCostIndirect
    proposedCostLabour
    proposedCostMaterial
    proposedCostOverhead
    proposedCostTotal
    proposedCostTransferTruck
    proposedGrossMargin
    proposedGrossMarginPercentage
    proposedNetMargin
    proposedNetMarginPercentage
    proposedOperatingMargin
    proposedOperatingMarginPercentage
    proposedOverallTotal
    proposedProfit
    proposedProfitPercentage
    shouldPushTaxesToQuickbooks
    startsAt
    status
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
    userId
  }
}
    `;
export type UpdateJobNotesMutationFn = Apollo.MutationFunction<UpdateJobNotesMutation, UpdateJobNotesMutationVariables>;

/**
 * __useUpdateJobNotesMutation__
 *
 * To run a mutation, you first call `useUpdateJobNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobNotesMutation, { data, loading, error }] = useUpdateJobNotesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useUpdateJobNotesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobNotesMutation, UpdateJobNotesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJobNotesMutation, UpdateJobNotesMutationVariables>(UpdateJobNotesDocument, options);
      }
export type UpdateJobNotesMutationHookResult = ReturnType<typeof useUpdateJobNotesMutation>;
export type UpdateJobNotesMutationResult = Apollo.MutationResult<UpdateJobNotesMutation>;
export type UpdateJobNotesMutationOptions = Apollo.BaseMutationOptions<UpdateJobNotesMutation, UpdateJobNotesMutationVariables>;
export const UpdateJobPhaseNotesDocument = gql`
    mutation updateJobPhaseNotes($input: UpdateJobPhaseNotesInput!) {
  updateJobPhaseNotes(input: $input) {
    actualCostAdditional
    actualCostDirect
    actualCostEquipment
    actualCostIndirect
    actualCostLabour
    actualCostMaterial
    actualCostOverhead
    actualCostTotal
    actualCostTransferTruck
    actualEmployeeHours
    actualGrossMargin
    actualGrossMarginPercentage
    actualMaterialNeeded
    actualNetMargin
    actualNetMarginPercentage
    actualOperatingMargin
    actualOperatingMarginPercentage
    actualOverallTotal
    actualProfit
    actualProfitPercentage
    address
    applicableStatuses
    costItems {
      additionalCosts {
        additionalCostId
        cost
        costTotal
        feeAmount
        feeType
        id
        jobPhaseCostItem {
          additionalCosts {
            additionalCostId
            cost
            costTotal
            feeAmount
            feeType
            id
            name
          }
          costAdditional
          costEquipment
          costLabour
          costMaterial
          costTransferTruck
          date
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          equipmentPieces {
            equipmentPieceId
            id
            name
            quantity
            rate
            timeOnjob
            timeTravel
          }
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            address
            applicableStatuses
            crewId
            endsAt
            externalId
            id
            jobDuration
            jobSize
            notes
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          material {
            costMaterial
            id
            materialNeeded
            name
            organizationProductTypeName
            type
          }
          plantId
          plantProductId
          transferTrucks {
            hours
            id
            name
            plantTransferTruckId
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
        }
        name
      }
      costAdditional
      costEquipment
      costLabour
      costMaterial
      costTransferTruck
      date
      employees {
        employeeId
        id
        name
        rate
        timeOnjob
        timeTravel
      }
      equipmentPieces {
        equipmentPieceId
        id
        name
        quantity
        rate
        timeOnjob
        timeTravel
      }
      id
      jobPhase {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualEmployeeHours
        actualGrossMargin
        actualGrossMarginPercentage
        actualMaterialNeeded
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        address
        applicableStatuses
        costItems {
          costAdditional
          costEquipment
          costLabour
          costMaterial
          costTransferTruck
          date
          id
          material {
            costMaterial
            id
            materialNeeded
            name
            organizationProductTypeName
            type
          }
          plantId
          plantProductId
          transferTrucks {
            hours
            id
            name
            plantTransferTruckId
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
        }
        crew {
          color
          displayName
          employees {
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          id
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          rate
        }
        crewId
        defaultAdditionalCosts {
          cost
          feeAmount
          feeType
          id
          name
        }
        defaultEmployees {
          firstName
          id
          lastName
          name
          organizationId
          rate
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
        }
        defaultEquipmentPieces {
          chargeType
          fuelSurcharge
          id
          name
          rate
          usePercentage
        }
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        endsAt
        externalId
        files {
          createdAt
          filename
          id
          thumbnail
        }
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        id
        job {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualGrossMargin
          actualGrossMarginPercentage
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          billingStatus
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          datePushedToQuickbooks
          endsAt
          externalId
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          id
          jobPhases {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            address
            applicableStatuses
            crewId
            endsAt
            externalId
            id
            jobDuration
            jobSize
            notes
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          mayShowTaxNotification
          notes
          projectFilesFolderId
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          proposalId
          proposalStage {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          shouldPushTaxesToQuickbooks
          startsAt
          status
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
        }
        jobDuration
        jobPhasePlant {
          id
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            rate
            type
          }
          type
        }
        jobSize
        notes
        organization {
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          proposalDefaults {
            autoSave
            color
            id
            layout
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        organizationProductType {
          id
          indirectPercentage
          markupPercentage
          name
          overheadPercentage
          type
        }
        organizationProductTypeName
        productName
        proposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        proposalProduct {
          additionalCosts {
            additionalCostId
            cost
            costOverride
            costTotal
            feeAmount
            feeAmountOverride
            feeType
            id
            name
            quantity
            quantityOverride
            showOnProposal
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          costTransferTruck
          crews {
            cost
            crewId
            id
            name
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
          }
          equipmentPieces {
            chargeType
            cost
            equipmentPieceId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
            usePercentage
          }
          externalProductName
          files {
            createdAt
            filename
            id
            thumbnail
            type
          }
          grossMargin
          grossMarginPercentage
          id
          isOptional
          jobDuration
          jobDurationDaysOverride
          jobDurationOverride
          jobSize
          mapData
          mapImage
          mapImageDirty
          material {
            areaCoverage
            attributes {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            attributesOverride {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            costMaterial
            costMaterialOverride
            costMinimumProduct
            costMinimumProposal
            dailyUnitsComplete
            dailyUnitsCompleteOverride
            externalProductName
            id
            indirectPercentage
            indirectPercentageOverride
            labourCostType
            markupPercentage
            markupPercentageOverride
            materialNeeded
            materialNeededOverride
            measurementJob
            measurementMaterial
            name
            organizationProductTypeName
            overheadPercentage
            overheadPercentageOverride
            productId
            productionRateType
            proposalId
            proposalProductId
            proposalStageId
            statementOfWork
            statementOfWorkOverride
            subcontracted
            tonConversionFactor
            tonConversionFactorOverride
            type
            unitPrice
            unitPriceOverride
            unitPriceProduct
          }
          measurementJob
          measurementMaterial
          netMargin
          netMarginPercentage
          notes
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalOverride
          plantProduct {
            id
            plantProductId
            rate
            rateOverride
            type
          }
          productName
          profit
          profitPercentage
          profitPercentageOverride
          roundTripTravelTimeHours
          statementOfWork
          subcontractorCost
          subcontractorName
          subcontractorProposalId
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTime
          transferTruckRoundTripTimeOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            quantity
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
        }
        proposalStage {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          profit
          profitPercentage
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          roundTripTravelTimeHours
        }
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedEmployeeHours
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedMaterialNeeded
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        scheduleBlocks {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            endsAt
            externalId
            id
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            address
            applicableStatuses
            crewId
            endsAt
            externalId
            id
            jobDuration
            jobSize
            notes
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        scheduledBlockForDate {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            endsAt
            externalId
            id
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            address
            applicableStatuses
            crewId
            endsAt
            externalId
            id
            jobDuration
            jobSize
            notes
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        startsAt
        status
        travelTimeEstimate
        users {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        usersColor
        workOrderCrews {
          crewId
          id
          name
        }
        workOrderEquipmentPieces {
          equipmentPieceId
          id
          name
        }
        workOrderTransferTrucks {
          id
          name
          quantity
          rateHourly
          rateTon
          tonnage
          transferTruckId
        }
      }
      plantId
      plantProductId
    }
    crew {
      color
      displayName
      id
      name
      rate
    }
    crewId
    defaultAdditionalCosts {
      cost
      feeAmount
      feeType
      id
      name
    }
    defaultEmployees {
      firstName
      id
      lastName
      name
      organizationId
      rate
      userId
    }
    defaultEquipmentPieces {
      chargeType
      fuelSurcharge
      id
      name
      rate
      usePercentage
    }
    employees {
      employeeId
      id
      name
      rate
      timeOnjob
      timeTravel
    }
    endsAt
    externalId
    files {
      createdAt
      filename
      id
      thumbnail
    }
    foremanUser {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
    id
    job {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualGrossMargin
      actualGrossMarginPercentage
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      billingStatus
      datePushedToQuickbooks
      endsAt
      externalId
      id
      mayShowTaxNotification
      notes
      projectFilesFolderId
      proposalId
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      shouldPushTaxesToQuickbooks
      startsAt
      status
      userId
    }
    jobDuration
    jobPhasePlant {
      id
      name
      type
    }
    jobSize
    notes
    organization {
      email
      emailTemplate
      failingPayment
      id
      logo
      name
      onTrial
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    organizationProductType {
      id
      indirectPercentage
      markupPercentage
      name
      overheadPercentage
      type
    }
    organizationProductTypeName
    productName
    proposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    proposalProduct {
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      costTransferTruck
      externalProductName
      grossMargin
      grossMarginPercentage
      id
      isOptional
      jobDuration
      jobDurationDaysOverride
      jobDurationOverride
      jobSize
      mapData
      mapImage
      mapImageDirty
      measurementJob
      measurementMaterial
      netMargin
      netMarginPercentage
      notes
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalOverride
      productName
      profit
      profitPercentage
      profitPercentageOverride
      roundTripTravelTimeHours
      statementOfWork
      subcontractorCost
      subcontractorName
      subcontractorProposalId
      transferTruckLoadTimeBuffer
      transferTruckRoundTripTime
      transferTruckRoundTripTimeOverride
      transferTruckUnloadTimeBuffer
    }
    proposalStage {
      addressOverride
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      profit
      profitPercentage
      roundTripTravelTimeHours
    }
    proposedCostAdditional
    proposedCostDirect
    proposedCostEquipment
    proposedCostIndirect
    proposedCostLabour
    proposedCostMaterial
    proposedCostOverhead
    proposedCostTotal
    proposedCostTransferTruck
    proposedEmployeeHours
    proposedGrossMargin
    proposedGrossMarginPercentage
    proposedMaterialNeeded
    proposedNetMargin
    proposedNetMarginPercentage
    proposedOperatingMargin
    proposedOperatingMarginPercentage
    proposedOverallTotal
    proposedProfit
    proposedProfitPercentage
    scheduleBlocks {
      blockLength
      endsAt
      estimatedMaterial
      estimatedMaterialOverride
      id
      scheduledAt
      showTravelFrom
      showTravelTo
      travelTime
    }
    scheduledBlockForDate {
      blockLength
      endsAt
      estimatedMaterial
      estimatedMaterialOverride
      id
      scheduledAt
      showTravelFrom
      showTravelTo
      travelTime
    }
    startsAt
    status
    travelTimeEstimate
    users {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
    usersColor
    workOrderCrews {
      crewId
      id
      name
    }
    workOrderEquipmentPieces {
      equipmentPieceId
      id
      name
    }
    workOrderTransferTrucks {
      id
      name
      quantity
      rateHourly
      rateTon
      tonnage
      transferTruckId
    }
  }
}
    `;
export type UpdateJobPhaseNotesMutationFn = Apollo.MutationFunction<UpdateJobPhaseNotesMutation, UpdateJobPhaseNotesMutationVariables>;

/**
 * __useUpdateJobPhaseNotesMutation__
 *
 * To run a mutation, you first call `useUpdateJobPhaseNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobPhaseNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobPhaseNotesMutation, { data, loading, error }] = useUpdateJobPhaseNotesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateJobPhaseNotesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobPhaseNotesMutation, UpdateJobPhaseNotesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJobPhaseNotesMutation, UpdateJobPhaseNotesMutationVariables>(UpdateJobPhaseNotesDocument, options);
      }
export type UpdateJobPhaseNotesMutationHookResult = ReturnType<typeof useUpdateJobPhaseNotesMutation>;
export type UpdateJobPhaseNotesMutationResult = Apollo.MutationResult<UpdateJobPhaseNotesMutation>;
export type UpdateJobPhaseNotesMutationOptions = Apollo.BaseMutationOptions<UpdateJobPhaseNotesMutation, UpdateJobPhaseNotesMutationVariables>;
export const UpdateJobPhaseStatusDocument = gql`
    mutation updateJobPhaseStatus($id: ID!, $status: JobPhaseStatus!) {
  updateJobPhaseStatus(id: $id, status: $status) {
    actualCostAdditional
    actualCostDirect
    actualCostEquipment
    actualCostIndirect
    actualCostLabour
    actualCostMaterial
    actualCostOverhead
    actualCostTotal
    actualCostTransferTruck
    actualEmployeeHours
    actualGrossMargin
    actualGrossMarginPercentage
    actualMaterialNeeded
    actualNetMargin
    actualNetMarginPercentage
    actualOperatingMargin
    actualOperatingMarginPercentage
    actualOverallTotal
    actualProfit
    actualProfitPercentage
    address
    applicableStatuses
    costItems {
      additionalCosts {
        additionalCostId
        cost
        costTotal
        feeAmount
        feeType
        id
        jobPhaseCostItem {
          additionalCosts {
            additionalCostId
            cost
            costTotal
            feeAmount
            feeType
            id
            name
          }
          costAdditional
          costEquipment
          costLabour
          costMaterial
          costTransferTruck
          date
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          equipmentPieces {
            equipmentPieceId
            id
            name
            quantity
            rate
            timeOnjob
            timeTravel
          }
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            address
            applicableStatuses
            crewId
            endsAt
            externalId
            id
            jobDuration
            jobSize
            notes
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          material {
            costMaterial
            id
            materialNeeded
            name
            organizationProductTypeName
            type
          }
          plantId
          plantProductId
          transferTrucks {
            hours
            id
            name
            plantTransferTruckId
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
        }
        name
      }
      costAdditional
      costEquipment
      costLabour
      costMaterial
      costTransferTruck
      date
      employees {
        employeeId
        id
        name
        rate
        timeOnjob
        timeTravel
      }
      equipmentPieces {
        equipmentPieceId
        id
        name
        quantity
        rate
        timeOnjob
        timeTravel
      }
      id
      jobPhase {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualEmployeeHours
        actualGrossMargin
        actualGrossMarginPercentage
        actualMaterialNeeded
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        address
        applicableStatuses
        costItems {
          costAdditional
          costEquipment
          costLabour
          costMaterial
          costTransferTruck
          date
          id
          material {
            costMaterial
            id
            materialNeeded
            name
            organizationProductTypeName
            type
          }
          plantId
          plantProductId
          transferTrucks {
            hours
            id
            name
            plantTransferTruckId
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
        }
        crew {
          color
          displayName
          employees {
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          id
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          rate
        }
        crewId
        defaultAdditionalCosts {
          cost
          feeAmount
          feeType
          id
          name
        }
        defaultEmployees {
          firstName
          id
          lastName
          name
          organizationId
          rate
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
        }
        defaultEquipmentPieces {
          chargeType
          fuelSurcharge
          id
          name
          rate
          usePercentage
        }
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        endsAt
        externalId
        files {
          createdAt
          filename
          id
          thumbnail
        }
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        id
        job {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualGrossMargin
          actualGrossMarginPercentage
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          billingStatus
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          datePushedToQuickbooks
          endsAt
          externalId
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          id
          jobPhases {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            address
            applicableStatuses
            crewId
            endsAt
            externalId
            id
            jobDuration
            jobSize
            notes
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          mayShowTaxNotification
          notes
          projectFilesFolderId
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          proposalId
          proposalStage {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          shouldPushTaxesToQuickbooks
          startsAt
          status
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
        }
        jobDuration
        jobPhasePlant {
          id
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            rate
            type
          }
          type
        }
        jobSize
        notes
        organization {
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          proposalDefaults {
            autoSave
            color
            id
            layout
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        organizationProductType {
          id
          indirectPercentage
          markupPercentage
          name
          overheadPercentage
          type
        }
        organizationProductTypeName
        productName
        proposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        proposalProduct {
          additionalCosts {
            additionalCostId
            cost
            costOverride
            costTotal
            feeAmount
            feeAmountOverride
            feeType
            id
            name
            quantity
            quantityOverride
            showOnProposal
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          costTransferTruck
          crews {
            cost
            crewId
            id
            name
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
          }
          equipmentPieces {
            chargeType
            cost
            equipmentPieceId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
            usePercentage
          }
          externalProductName
          files {
            createdAt
            filename
            id
            thumbnail
            type
          }
          grossMargin
          grossMarginPercentage
          id
          isOptional
          jobDuration
          jobDurationDaysOverride
          jobDurationOverride
          jobSize
          mapData
          mapImage
          mapImageDirty
          material {
            areaCoverage
            attributes {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            attributesOverride {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            costMaterial
            costMaterialOverride
            costMinimumProduct
            costMinimumProposal
            dailyUnitsComplete
            dailyUnitsCompleteOverride
            externalProductName
            id
            indirectPercentage
            indirectPercentageOverride
            labourCostType
            markupPercentage
            markupPercentageOverride
            materialNeeded
            materialNeededOverride
            measurementJob
            measurementMaterial
            name
            organizationProductTypeName
            overheadPercentage
            overheadPercentageOverride
            productId
            productionRateType
            proposalId
            proposalProductId
            proposalStageId
            statementOfWork
            statementOfWorkOverride
            subcontracted
            tonConversionFactor
            tonConversionFactorOverride
            type
            unitPrice
            unitPriceOverride
            unitPriceProduct
          }
          measurementJob
          measurementMaterial
          netMargin
          netMarginPercentage
          notes
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalOverride
          plantProduct {
            id
            plantProductId
            rate
            rateOverride
            type
          }
          productName
          profit
          profitPercentage
          profitPercentageOverride
          roundTripTravelTimeHours
          statementOfWork
          subcontractorCost
          subcontractorName
          subcontractorProposalId
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTime
          transferTruckRoundTripTimeOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            quantity
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
        }
        proposalStage {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          profit
          profitPercentage
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          roundTripTravelTimeHours
        }
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedEmployeeHours
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedMaterialNeeded
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        scheduleBlocks {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            endsAt
            externalId
            id
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            address
            applicableStatuses
            crewId
            endsAt
            externalId
            id
            jobDuration
            jobSize
            notes
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        scheduledBlockForDate {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            endsAt
            externalId
            id
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            address
            applicableStatuses
            crewId
            endsAt
            externalId
            id
            jobDuration
            jobSize
            notes
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        startsAt
        status
        travelTimeEstimate
        users {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        usersColor
        workOrderCrews {
          crewId
          id
          name
        }
        workOrderEquipmentPieces {
          equipmentPieceId
          id
          name
        }
        workOrderTransferTrucks {
          id
          name
          quantity
          rateHourly
          rateTon
          tonnage
          transferTruckId
        }
      }
      plantId
      plantProductId
    }
    crew {
      color
      displayName
      id
      name
      rate
    }
    crewId
    defaultAdditionalCosts {
      cost
      feeAmount
      feeType
      id
      name
    }
    defaultEmployees {
      firstName
      id
      lastName
      name
      organizationId
      rate
      userId
    }
    defaultEquipmentPieces {
      chargeType
      fuelSurcharge
      id
      name
      rate
      usePercentage
    }
    employees {
      employeeId
      id
      name
      rate
      timeOnjob
      timeTravel
    }
    endsAt
    externalId
    files {
      createdAt
      filename
      id
      thumbnail
    }
    foremanUser {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
    id
    job {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualGrossMargin
      actualGrossMarginPercentage
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      billingStatus
      datePushedToQuickbooks
      endsAt
      externalId
      id
      mayShowTaxNotification
      notes
      projectFilesFolderId
      proposalId
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      shouldPushTaxesToQuickbooks
      startsAt
      status
      userId
    }
    jobDuration
    jobPhasePlant {
      id
      name
      type
    }
    jobSize
    notes
    organization {
      email
      emailTemplate
      failingPayment
      id
      logo
      name
      onTrial
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    organizationProductType {
      id
      indirectPercentage
      markupPercentage
      name
      overheadPercentage
      type
    }
    organizationProductTypeName
    productName
    proposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    proposalProduct {
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      costTransferTruck
      externalProductName
      grossMargin
      grossMarginPercentage
      id
      isOptional
      jobDuration
      jobDurationDaysOverride
      jobDurationOverride
      jobSize
      mapData
      mapImage
      mapImageDirty
      measurementJob
      measurementMaterial
      netMargin
      netMarginPercentage
      notes
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalOverride
      productName
      profit
      profitPercentage
      profitPercentageOverride
      roundTripTravelTimeHours
      statementOfWork
      subcontractorCost
      subcontractorName
      subcontractorProposalId
      transferTruckLoadTimeBuffer
      transferTruckRoundTripTime
      transferTruckRoundTripTimeOverride
      transferTruckUnloadTimeBuffer
    }
    proposalStage {
      addressOverride
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      profit
      profitPercentage
      roundTripTravelTimeHours
    }
    proposedCostAdditional
    proposedCostDirect
    proposedCostEquipment
    proposedCostIndirect
    proposedCostLabour
    proposedCostMaterial
    proposedCostOverhead
    proposedCostTotal
    proposedCostTransferTruck
    proposedEmployeeHours
    proposedGrossMargin
    proposedGrossMarginPercentage
    proposedMaterialNeeded
    proposedNetMargin
    proposedNetMarginPercentage
    proposedOperatingMargin
    proposedOperatingMarginPercentage
    proposedOverallTotal
    proposedProfit
    proposedProfitPercentage
    scheduleBlocks {
      blockLength
      endsAt
      estimatedMaterial
      estimatedMaterialOverride
      id
      scheduledAt
      showTravelFrom
      showTravelTo
      travelTime
    }
    scheduledBlockForDate {
      blockLength
      endsAt
      estimatedMaterial
      estimatedMaterialOverride
      id
      scheduledAt
      showTravelFrom
      showTravelTo
      travelTime
    }
    startsAt
    status
    travelTimeEstimate
    users {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
    usersColor
    workOrderCrews {
      crewId
      id
      name
    }
    workOrderEquipmentPieces {
      equipmentPieceId
      id
      name
    }
    workOrderTransferTrucks {
      id
      name
      quantity
      rateHourly
      rateTon
      tonnage
      transferTruckId
    }
  }
}
    `;
export type UpdateJobPhaseStatusMutationFn = Apollo.MutationFunction<UpdateJobPhaseStatusMutation, UpdateJobPhaseStatusMutationVariables>;

/**
 * __useUpdateJobPhaseStatusMutation__
 *
 * To run a mutation, you first call `useUpdateJobPhaseStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobPhaseStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobPhaseStatusMutation, { data, loading, error }] = useUpdateJobPhaseStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateJobPhaseStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobPhaseStatusMutation, UpdateJobPhaseStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJobPhaseStatusMutation, UpdateJobPhaseStatusMutationVariables>(UpdateJobPhaseStatusDocument, options);
      }
export type UpdateJobPhaseStatusMutationHookResult = ReturnType<typeof useUpdateJobPhaseStatusMutation>;
export type UpdateJobPhaseStatusMutationResult = Apollo.MutationResult<UpdateJobPhaseStatusMutation>;
export type UpdateJobPhaseStatusMutationOptions = Apollo.BaseMutationOptions<UpdateJobPhaseStatusMutation, UpdateJobPhaseStatusMutationVariables>;
export const UpdateJobProjectFileFolderIdDocument = gql`
    mutation updateJobProjectFileFolderId($id: ID!, $projectFilesFolderId: ID) {
  updateJobProjectFileFolderId(
    id: $id
    projectFilesFolderId: $projectFilesFolderId
  ) {
    actualCostAdditional
    actualCostDirect
    actualCostEquipment
    actualCostIndirect
    actualCostLabour
    actualCostMaterial
    actualCostOverhead
    actualCostTotal
    actualCostTransferTruck
    actualGrossMargin
    actualGrossMarginPercentage
    actualNetMargin
    actualNetMarginPercentage
    actualOperatingMargin
    actualOperatingMarginPercentage
    actualOverallTotal
    actualProfit
    actualProfitPercentage
    address {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    billingStatus
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        organization {
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          proposalDefaults {
            autoSave
            color
            id
            layout
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        events {
          action
          createdAt
        }
        externalId
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterTaxes
        profit
        profitPercentage
        projectFilesFolderId
        proposalNotes
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          profit
          profitPercentage
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          roundTripTravelTimeHours
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          status
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
        uuid
        version
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    datePushedToQuickbooks
    endsAt
    externalId
    foremanUser {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        email
        emailTemplate
        failingPayment
        id
        logo
        name
        onTrial
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      status
    }
    id
    jobPhases {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualEmployeeHours
      actualGrossMargin
      actualGrossMarginPercentage
      actualMaterialNeeded
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      address
      applicableStatuses
      costItems {
        additionalCosts {
          additionalCostId
          cost
          costTotal
          feeAmount
          feeType
          id
          jobPhaseCostItem {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          name
        }
        costAdditional
        costEquipment
        costLabour
        costMaterial
        costTransferTruck
        date
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        equipmentPieces {
          equipmentPieceId
          id
          name
          quantity
          rate
          timeOnjob
          timeTravel
        }
        id
        jobPhase {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualEmployeeHours
          actualGrossMargin
          actualGrossMarginPercentage
          actualMaterialNeeded
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address
          applicableStatuses
          costItems {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          crew {
            color
            displayName
            id
            name
            rate
          }
          crewId
          defaultAdditionalCosts {
            cost
            feeAmount
            feeType
            id
            name
          }
          defaultEmployees {
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          defaultEquipmentPieces {
            chargeType
            fuelSurcharge
            id
            name
            rate
            usePercentage
          }
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          endsAt
          externalId
          files {
            createdAt
            filename
            id
            thumbnail
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            endsAt
            externalId
            id
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
          }
          jobDuration
          jobPhasePlant {
            id
            name
            type
          }
          jobSize
          notes
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          organizationProductType {
            id
            indirectPercentage
            markupPercentage
            name
            overheadPercentage
            type
          }
          organizationProductTypeName
          productName
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          proposalProduct {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          proposalStage {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedEmployeeHours
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedMaterialNeeded
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          scheduleBlocks {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          scheduledBlockForDate {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          startsAt
          status
          travelTimeEstimate
          users {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          usersColor
          workOrderCrews {
            crewId
            id
            name
          }
          workOrderEquipmentPieces {
            equipmentPieceId
            id
            name
          }
          workOrderTransferTrucks {
            id
            name
            quantity
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
        }
        material {
          costMaterial
          id
          jobPhaseCostItem {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          materialNeeded
          name
          organizationProductTypeName
          type
        }
        plantId
        plantProductId
        transferTrucks {
          hours
          id
          name
          plantTransferTruckId
          rateHourly
          rateTon
          tonnage
          transferTruckId
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          status
        }
      }
      crew {
        color
        displayName
        employees {
          firstName
          id
          lastName
          name
          organizationId
          rate
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
        }
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          status
        }
        id
        name
        organization {
          email
          emailTemplate
          failingPayment
          id
          logo
          name
          onTrial
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        rate
      }
      crewId
      defaultAdditionalCosts {
        cost
        feeAmount
        feeType
        id
        name
      }
      defaultEmployees {
        firstName
        id
        lastName
        name
        organizationId
        rate
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
      }
      defaultEquipmentPieces {
        chargeType
        fuelSurcharge
        id
        name
        rate
        usePercentage
      }
      employees {
        employeeId
        id
        name
        rate
        timeOnjob
        timeTravel
      }
      endsAt
      externalId
      files {
        createdAt
        filename
        id
        thumbnail
      }
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        status
      }
      id
      job {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualGrossMargin
        actualGrossMarginPercentage
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        address {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        billingStatus
        changeOrders {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          userId
          uuid
          version
          wonAt
        }
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          email
          id
          jobsCount
          logo
          name
          notes
          phone
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        datePushedToQuickbooks
        endsAt
        externalId
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          status
        }
        id
        jobPhases {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualEmployeeHours
          actualGrossMargin
          actualGrossMarginPercentage
          actualMaterialNeeded
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address
          applicableStatuses
          crewId
          endsAt
          externalId
          id
          jobDuration
          jobPhasePlant {
            id
            name
            type
          }
          jobSize
          notes
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          organizationProductType {
            id
            indirectPercentage
            markupPercentage
            name
            overheadPercentage
            type
          }
          organizationProductTypeName
          productName
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          proposalProduct {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          proposalStage {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedEmployeeHours
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedMaterialNeeded
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          scheduleBlocks {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          scheduledBlockForDate {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          startsAt
          status
          travelTimeEstimate
          users {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          usersColor
          workOrderCrews {
            crewId
            id
            name
          }
          workOrderEquipmentPieces {
            equipmentPieceId
            id
            name
          }
          workOrderTransferTrucks {
            id
            name
            quantity
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
        }
        mayShowTaxNotification
        notes
        projectFilesFolderId
        proposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        proposalId
        proposalStage {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          profit
          profitPercentage
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          roundTripTravelTimeHours
        }
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        shouldPushTaxesToQuickbooks
        startsAt
        status
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
      }
      jobDuration
      jobSize
      notes
      organizationProductTypeName
      productName
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedEmployeeHours
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedMaterialNeeded
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      startsAt
      status
      travelTimeEstimate
      usersColor
    }
    mayShowTaxNotification
    notes
    projectFilesFolderId
    proposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    proposalId
    proposalStage {
      addressOverride
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      profit
      profitPercentage
      roundTripTravelTimeHours
    }
    proposedCostAdditional
    proposedCostDirect
    proposedCostEquipment
    proposedCostIndirect
    proposedCostLabour
    proposedCostMaterial
    proposedCostOverhead
    proposedCostTotal
    proposedCostTransferTruck
    proposedGrossMargin
    proposedGrossMarginPercentage
    proposedNetMargin
    proposedNetMarginPercentage
    proposedOperatingMargin
    proposedOperatingMarginPercentage
    proposedOverallTotal
    proposedProfit
    proposedProfitPercentage
    shouldPushTaxesToQuickbooks
    startsAt
    status
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
    userId
  }
}
    `;
export type UpdateJobProjectFileFolderIdMutationFn = Apollo.MutationFunction<UpdateJobProjectFileFolderIdMutation, UpdateJobProjectFileFolderIdMutationVariables>;

/**
 * __useUpdateJobProjectFileFolderIdMutation__
 *
 * To run a mutation, you first call `useUpdateJobProjectFileFolderIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobProjectFileFolderIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobProjectFileFolderIdMutation, { data, loading, error }] = useUpdateJobProjectFileFolderIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      projectFilesFolderId: // value for 'projectFilesFolderId'
 *   },
 * });
 */
export function useUpdateJobProjectFileFolderIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobProjectFileFolderIdMutation, UpdateJobProjectFileFolderIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJobProjectFileFolderIdMutation, UpdateJobProjectFileFolderIdMutationVariables>(UpdateJobProjectFileFolderIdDocument, options);
      }
export type UpdateJobProjectFileFolderIdMutationHookResult = ReturnType<typeof useUpdateJobProjectFileFolderIdMutation>;
export type UpdateJobProjectFileFolderIdMutationResult = Apollo.MutationResult<UpdateJobProjectFileFolderIdMutation>;
export type UpdateJobProjectFileFolderIdMutationOptions = Apollo.BaseMutationOptions<UpdateJobProjectFileFolderIdMutation, UpdateJobProjectFileFolderIdMutationVariables>;
export const UpdateJobProjectManagerDocument = gql`
    mutation updateJobProjectManager($id: ID!, $userId: ID!) {
  updateJobProjectManager(id: $id, userId: $userId) {
    actualCostAdditional
    actualCostDirect
    actualCostEquipment
    actualCostIndirect
    actualCostLabour
    actualCostMaterial
    actualCostOverhead
    actualCostTotal
    actualCostTransferTruck
    actualGrossMargin
    actualGrossMarginPercentage
    actualNetMargin
    actualNetMarginPercentage
    actualOperatingMargin
    actualOperatingMarginPercentage
    actualOverallTotal
    actualProfit
    actualProfitPercentage
    address {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    billingStatus
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        organization {
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          proposalDefaults {
            autoSave
            color
            id
            layout
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        events {
          action
          createdAt
        }
        externalId
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterTaxes
        profit
        profitPercentage
        projectFilesFolderId
        proposalNotes
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          profit
          profitPercentage
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          roundTripTravelTimeHours
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          status
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
        uuid
        version
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    datePushedToQuickbooks
    endsAt
    externalId
    foremanUser {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        email
        emailTemplate
        failingPayment
        id
        logo
        name
        onTrial
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      status
    }
    id
    jobPhases {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualEmployeeHours
      actualGrossMargin
      actualGrossMarginPercentage
      actualMaterialNeeded
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      address
      applicableStatuses
      costItems {
        additionalCosts {
          additionalCostId
          cost
          costTotal
          feeAmount
          feeType
          id
          jobPhaseCostItem {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          name
        }
        costAdditional
        costEquipment
        costLabour
        costMaterial
        costTransferTruck
        date
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        equipmentPieces {
          equipmentPieceId
          id
          name
          quantity
          rate
          timeOnjob
          timeTravel
        }
        id
        jobPhase {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualEmployeeHours
          actualGrossMargin
          actualGrossMarginPercentage
          actualMaterialNeeded
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address
          applicableStatuses
          costItems {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          crew {
            color
            displayName
            id
            name
            rate
          }
          crewId
          defaultAdditionalCosts {
            cost
            feeAmount
            feeType
            id
            name
          }
          defaultEmployees {
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          defaultEquipmentPieces {
            chargeType
            fuelSurcharge
            id
            name
            rate
            usePercentage
          }
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          endsAt
          externalId
          files {
            createdAt
            filename
            id
            thumbnail
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            endsAt
            externalId
            id
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
          }
          jobDuration
          jobPhasePlant {
            id
            name
            type
          }
          jobSize
          notes
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          organizationProductType {
            id
            indirectPercentage
            markupPercentage
            name
            overheadPercentage
            type
          }
          organizationProductTypeName
          productName
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          proposalProduct {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          proposalStage {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedEmployeeHours
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedMaterialNeeded
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          scheduleBlocks {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          scheduledBlockForDate {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          startsAt
          status
          travelTimeEstimate
          users {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          usersColor
          workOrderCrews {
            crewId
            id
            name
          }
          workOrderEquipmentPieces {
            equipmentPieceId
            id
            name
          }
          workOrderTransferTrucks {
            id
            name
            quantity
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
        }
        material {
          costMaterial
          id
          jobPhaseCostItem {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          materialNeeded
          name
          organizationProductTypeName
          type
        }
        plantId
        plantProductId
        transferTrucks {
          hours
          id
          name
          plantTransferTruckId
          rateHourly
          rateTon
          tonnage
          transferTruckId
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          status
        }
      }
      crew {
        color
        displayName
        employees {
          firstName
          id
          lastName
          name
          organizationId
          rate
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
        }
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          status
        }
        id
        name
        organization {
          email
          emailTemplate
          failingPayment
          id
          logo
          name
          onTrial
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        rate
      }
      crewId
      defaultAdditionalCosts {
        cost
        feeAmount
        feeType
        id
        name
      }
      defaultEmployees {
        firstName
        id
        lastName
        name
        organizationId
        rate
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
      }
      defaultEquipmentPieces {
        chargeType
        fuelSurcharge
        id
        name
        rate
        usePercentage
      }
      employees {
        employeeId
        id
        name
        rate
        timeOnjob
        timeTravel
      }
      endsAt
      externalId
      files {
        createdAt
        filename
        id
        thumbnail
      }
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        status
      }
      id
      job {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualGrossMargin
        actualGrossMarginPercentage
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        address {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        billingStatus
        changeOrders {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          userId
          uuid
          version
          wonAt
        }
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          email
          id
          jobsCount
          logo
          name
          notes
          phone
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        datePushedToQuickbooks
        endsAt
        externalId
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          status
        }
        id
        jobPhases {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualEmployeeHours
          actualGrossMargin
          actualGrossMarginPercentage
          actualMaterialNeeded
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address
          applicableStatuses
          crewId
          endsAt
          externalId
          id
          jobDuration
          jobPhasePlant {
            id
            name
            type
          }
          jobSize
          notes
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          organizationProductType {
            id
            indirectPercentage
            markupPercentage
            name
            overheadPercentage
            type
          }
          organizationProductTypeName
          productName
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          proposalProduct {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          proposalStage {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedEmployeeHours
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedMaterialNeeded
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          scheduleBlocks {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          scheduledBlockForDate {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          startsAt
          status
          travelTimeEstimate
          users {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          usersColor
          workOrderCrews {
            crewId
            id
            name
          }
          workOrderEquipmentPieces {
            equipmentPieceId
            id
            name
          }
          workOrderTransferTrucks {
            id
            name
            quantity
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
        }
        mayShowTaxNotification
        notes
        projectFilesFolderId
        proposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        proposalId
        proposalStage {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          profit
          profitPercentage
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          roundTripTravelTimeHours
        }
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        shouldPushTaxesToQuickbooks
        startsAt
        status
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
      }
      jobDuration
      jobSize
      notes
      organizationProductTypeName
      productName
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedEmployeeHours
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedMaterialNeeded
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      startsAt
      status
      travelTimeEstimate
      usersColor
    }
    mayShowTaxNotification
    notes
    projectFilesFolderId
    proposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    proposalId
    proposalStage {
      addressOverride
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      profit
      profitPercentage
      roundTripTravelTimeHours
    }
    proposedCostAdditional
    proposedCostDirect
    proposedCostEquipment
    proposedCostIndirect
    proposedCostLabour
    proposedCostMaterial
    proposedCostOverhead
    proposedCostTotal
    proposedCostTransferTruck
    proposedGrossMargin
    proposedGrossMarginPercentage
    proposedNetMargin
    proposedNetMarginPercentage
    proposedOperatingMargin
    proposedOperatingMarginPercentage
    proposedOverallTotal
    proposedProfit
    proposedProfitPercentage
    shouldPushTaxesToQuickbooks
    startsAt
    status
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
    userId
  }
}
    `;
export type UpdateJobProjectManagerMutationFn = Apollo.MutationFunction<UpdateJobProjectManagerMutation, UpdateJobProjectManagerMutationVariables>;

/**
 * __useUpdateJobProjectManagerMutation__
 *
 * To run a mutation, you first call `useUpdateJobProjectManagerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobProjectManagerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobProjectManagerMutation, { data, loading, error }] = useUpdateJobProjectManagerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUpdateJobProjectManagerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobProjectManagerMutation, UpdateJobProjectManagerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJobProjectManagerMutation, UpdateJobProjectManagerMutationVariables>(UpdateJobProjectManagerDocument, options);
      }
export type UpdateJobProjectManagerMutationHookResult = ReturnType<typeof useUpdateJobProjectManagerMutation>;
export type UpdateJobProjectManagerMutationResult = Apollo.MutationResult<UpdateJobProjectManagerMutation>;
export type UpdateJobProjectManagerMutationOptions = Apollo.BaseMutationOptions<UpdateJobProjectManagerMutation, UpdateJobProjectManagerMutationVariables>;
export const UpdateNotificationTriggerDocument = gql`
    mutation updateNotificationTrigger($input: UpdateNotificationTriggerInput!) {
  updateNotificationTrigger(input: $input) {
    active
    additionalRecipientTypes
    additionalRecipients {
      email
      firstName
      id
      lastName
    }
    content
    delay
    emailSubject
    event
    id
    isEmail
    isSMS
    name
    organization {
      conversionFactorOverride {
        asphaltTonConversionFactorOverride
        excavateOutTonConversionFactorOverride
        id
        organization {
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          proposalDefaults {
            autoSave
            color
            id
            layout
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
      }
      email
      emailTemplate
      failingPayment
      id
      logo
      name
      onTrial
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    sendToAllRecipients
    sendToContact
    sendToUser
    smsContent
    type
  }
}
    `;
export type UpdateNotificationTriggerMutationFn = Apollo.MutationFunction<UpdateNotificationTriggerMutation, UpdateNotificationTriggerMutationVariables>;

/**
 * __useUpdateNotificationTriggerMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationTriggerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationTriggerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationTriggerMutation, { data, loading, error }] = useUpdateNotificationTriggerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNotificationTriggerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationTriggerMutation, UpdateNotificationTriggerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotificationTriggerMutation, UpdateNotificationTriggerMutationVariables>(UpdateNotificationTriggerDocument, options);
      }
export type UpdateNotificationTriggerMutationHookResult = ReturnType<typeof useUpdateNotificationTriggerMutation>;
export type UpdateNotificationTriggerMutationResult = Apollo.MutationResult<UpdateNotificationTriggerMutation>;
export type UpdateNotificationTriggerMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationTriggerMutation, UpdateNotificationTriggerMutationVariables>;
export const UpdateOpportunityDocument = gql`
    mutation updateOpportunity($input: UpdateOpportunityInput!) {
  updateOpportunity(input: $input) {
    addressCity
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZip
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      contacts {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      email
      id
      jobsCount
      logo
      name
      notes
      notificationTypes {
        CONTACT
        JOB
        JOB_PHASE
        OPPORTUNITY
        PROPOSAL
      }
      phone
      primaryContact {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    companyId
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    createdAt
    dueAt
    estimatedOpportunityValue
    externalId
    id
    name
    notes
    products {
      id
      indirectPercentage
      markupPercentage
      name
      overheadPercentage
      type
    }
    projectFilesFolderId
    source
    status
    statusId
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        phone
        proposalDefaults {
          autoSave
          color
          id
          layout
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      status
    }
    userId
  }
}
    `;
export type UpdateOpportunityMutationFn = Apollo.MutationFunction<UpdateOpportunityMutation, UpdateOpportunityMutationVariables>;

/**
 * __useUpdateOpportunityMutation__
 *
 * To run a mutation, you first call `useUpdateOpportunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOpportunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOpportunityMutation, { data, loading, error }] = useUpdateOpportunityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOpportunityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOpportunityMutation, UpdateOpportunityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOpportunityMutation, UpdateOpportunityMutationVariables>(UpdateOpportunityDocument, options);
      }
export type UpdateOpportunityMutationHookResult = ReturnType<typeof useUpdateOpportunityMutation>;
export type UpdateOpportunityMutationResult = Apollo.MutationResult<UpdateOpportunityMutation>;
export type UpdateOpportunityMutationOptions = Apollo.BaseMutationOptions<UpdateOpportunityMutation, UpdateOpportunityMutationVariables>;
export const UpdateOrganizationDocument = gql`
    mutation updateOrganization($input: UpdateOrganizationInput!) {
  updateOrganization(input: $input) {
    conversionFactorOverride {
      asphaltTonConversionFactorOverride
      excavateOutTonConversionFactorOverride
      id
      organization {
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
        }
        documents {
          id
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        phone
        proposalDefaults {
          autoSave
          color
          id
          layout
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
    }
    documents {
      id
      name
      path
      thumbnailPath
    }
    email
    emailTemplate
    failingPayment
    id
    linkedServices {
      active
      expired
      id
      service
      type
    }
    logo
    name
    onTrial
    phone
    proposalDefaults {
      autoSave
      color
      id
      layout
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
    }
    proposalSentEmailText
    salesTaxes {
      id
      isDefault
      name
      percentage
      quickbooksDesktopTaxCodeId
      quickbooksTaxCodeId
    }
    subscribed
    subscription {
      endsAt
      id
      name
      quantity
      renewsAt
      stripeId
      stripePrice
      stripeStatus
      trialEndsAt
    }
    timezone
    trialEndsAt
  }
}
    `;
export type UpdateOrganizationMutationFn = Apollo.MutationFunction<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;

/**
 * __useUpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationMutation, { data, loading, error }] = useUpdateOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>(UpdateOrganizationDocument, options);
      }
export type UpdateOrganizationMutationHookResult = ReturnType<typeof useUpdateOrganizationMutation>;
export type UpdateOrganizationMutationResult = Apollo.MutationResult<UpdateOrganizationMutation>;
export type UpdateOrganizationMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;
export const UpdateOrganizationAddressDocument = gql`
    mutation updateOrganizationAddress($input: UpdateOrganizationAddressInput!) {
  updateOrganizationAddress(input: $input) {
    city
    country
    id
    isPrimary
    latitude
    line1
    line2
    longitude
    state
    zip
  }
}
    `;
export type UpdateOrganizationAddressMutationFn = Apollo.MutationFunction<UpdateOrganizationAddressMutation, UpdateOrganizationAddressMutationVariables>;

/**
 * __useUpdateOrganizationAddressMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationAddressMutation, { data, loading, error }] = useUpdateOrganizationAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationAddressMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationAddressMutation, UpdateOrganizationAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationAddressMutation, UpdateOrganizationAddressMutationVariables>(UpdateOrganizationAddressDocument, options);
      }
export type UpdateOrganizationAddressMutationHookResult = ReturnType<typeof useUpdateOrganizationAddressMutation>;
export type UpdateOrganizationAddressMutationResult = Apollo.MutationResult<UpdateOrganizationAddressMutation>;
export type UpdateOrganizationAddressMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationAddressMutation, UpdateOrganizationAddressMutationVariables>;
export const UpdateOrganizationAddressPrimaryDocument = gql`
    mutation updateOrganizationAddressPrimary($id: ID!) {
  updateOrganizationAddressPrimary(id: $id)
}
    `;
export type UpdateOrganizationAddressPrimaryMutationFn = Apollo.MutationFunction<UpdateOrganizationAddressPrimaryMutation, UpdateOrganizationAddressPrimaryMutationVariables>;

/**
 * __useUpdateOrganizationAddressPrimaryMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationAddressPrimaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationAddressPrimaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationAddressPrimaryMutation, { data, loading, error }] = useUpdateOrganizationAddressPrimaryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateOrganizationAddressPrimaryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationAddressPrimaryMutation, UpdateOrganizationAddressPrimaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationAddressPrimaryMutation, UpdateOrganizationAddressPrimaryMutationVariables>(UpdateOrganizationAddressPrimaryDocument, options);
      }
export type UpdateOrganizationAddressPrimaryMutationHookResult = ReturnType<typeof useUpdateOrganizationAddressPrimaryMutation>;
export type UpdateOrganizationAddressPrimaryMutationResult = Apollo.MutationResult<UpdateOrganizationAddressPrimaryMutation>;
export type UpdateOrganizationAddressPrimaryMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationAddressPrimaryMutation, UpdateOrganizationAddressPrimaryMutationVariables>;
export const UpdateOrganizationConversionFactorOverrideDocument = gql`
    mutation updateOrganizationConversionFactorOverride($input: UpdateOrganizationConversionFactorOverrideInput!) {
  updateOrganizationConversionFactorOverride(input: $input) {
    asphaltTonConversionFactorOverride
    excavateOutTonConversionFactorOverride
    id
    organization {
      conversionFactorOverride {
        asphaltTonConversionFactorOverride
        excavateOutTonConversionFactorOverride
        id
        organization {
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          proposalDefaults {
            autoSave
            color
            id
            layout
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
      }
      email
      emailTemplate
      failingPayment
      id
      logo
      name
      onTrial
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
  }
}
    `;
export type UpdateOrganizationConversionFactorOverrideMutationFn = Apollo.MutationFunction<UpdateOrganizationConversionFactorOverrideMutation, UpdateOrganizationConversionFactorOverrideMutationVariables>;

/**
 * __useUpdateOrganizationConversionFactorOverrideMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationConversionFactorOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationConversionFactorOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationConversionFactorOverrideMutation, { data, loading, error }] = useUpdateOrganizationConversionFactorOverrideMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationConversionFactorOverrideMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationConversionFactorOverrideMutation, UpdateOrganizationConversionFactorOverrideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationConversionFactorOverrideMutation, UpdateOrganizationConversionFactorOverrideMutationVariables>(UpdateOrganizationConversionFactorOverrideDocument, options);
      }
export type UpdateOrganizationConversionFactorOverrideMutationHookResult = ReturnType<typeof useUpdateOrganizationConversionFactorOverrideMutation>;
export type UpdateOrganizationConversionFactorOverrideMutationResult = Apollo.MutationResult<UpdateOrganizationConversionFactorOverrideMutation>;
export type UpdateOrganizationConversionFactorOverrideMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationConversionFactorOverrideMutation, UpdateOrganizationConversionFactorOverrideMutationVariables>;
export const UpdateOrganizationEmailTemplateDocument = gql`
    mutation updateOrganizationEmailTemplate($html: String, $type: OrganizationEmailTemplateType!) {
  updateOrganizationEmailTemplate(html: $html, type: $type)
}
    `;
export type UpdateOrganizationEmailTemplateMutationFn = Apollo.MutationFunction<UpdateOrganizationEmailTemplateMutation, UpdateOrganizationEmailTemplateMutationVariables>;

/**
 * __useUpdateOrganizationEmailTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationEmailTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationEmailTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationEmailTemplateMutation, { data, loading, error }] = useUpdateOrganizationEmailTemplateMutation({
 *   variables: {
 *      html: // value for 'html'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useUpdateOrganizationEmailTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationEmailTemplateMutation, UpdateOrganizationEmailTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationEmailTemplateMutation, UpdateOrganizationEmailTemplateMutationVariables>(UpdateOrganizationEmailTemplateDocument, options);
      }
export type UpdateOrganizationEmailTemplateMutationHookResult = ReturnType<typeof useUpdateOrganizationEmailTemplateMutation>;
export type UpdateOrganizationEmailTemplateMutationResult = Apollo.MutationResult<UpdateOrganizationEmailTemplateMutation>;
export type UpdateOrganizationEmailTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationEmailTemplateMutation, UpdateOrganizationEmailTemplateMutationVariables>;
export const UpdateOrganizationProductTypeDocument = gql`
    mutation updateOrganizationProductType($input: UpdateOrganizationProductTypeInput!) {
  updateOrganizationProductType(input: $input) {
    id
    indirectPercentage
    markupPercentage
    name
    overheadPercentage
    type
  }
}
    `;
export type UpdateOrganizationProductTypeMutationFn = Apollo.MutationFunction<UpdateOrganizationProductTypeMutation, UpdateOrganizationProductTypeMutationVariables>;

/**
 * __useUpdateOrganizationProductTypeMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationProductTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationProductTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationProductTypeMutation, { data, loading, error }] = useUpdateOrganizationProductTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationProductTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationProductTypeMutation, UpdateOrganizationProductTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationProductTypeMutation, UpdateOrganizationProductTypeMutationVariables>(UpdateOrganizationProductTypeDocument, options);
      }
export type UpdateOrganizationProductTypeMutationHookResult = ReturnType<typeof useUpdateOrganizationProductTypeMutation>;
export type UpdateOrganizationProductTypeMutationResult = Apollo.MutationResult<UpdateOrganizationProductTypeMutation>;
export type UpdateOrganizationProductTypeMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationProductTypeMutation, UpdateOrganizationProductTypeMutationVariables>;
export const UpdateOrganizationProposalContentDocument = gql`
    mutation updateOrganizationProposalContent($content: String!, $type: ProposalContentType!) {
  updateOrganizationProposalContent(content: $content, type: $type) {
    content
    id
    type
  }
}
    `;
export type UpdateOrganizationProposalContentMutationFn = Apollo.MutationFunction<UpdateOrganizationProposalContentMutation, UpdateOrganizationProposalContentMutationVariables>;

/**
 * __useUpdateOrganizationProposalContentMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationProposalContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationProposalContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationProposalContentMutation, { data, loading, error }] = useUpdateOrganizationProposalContentMutation({
 *   variables: {
 *      content: // value for 'content'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useUpdateOrganizationProposalContentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationProposalContentMutation, UpdateOrganizationProposalContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationProposalContentMutation, UpdateOrganizationProposalContentMutationVariables>(UpdateOrganizationProposalContentDocument, options);
      }
export type UpdateOrganizationProposalContentMutationHookResult = ReturnType<typeof useUpdateOrganizationProposalContentMutation>;
export type UpdateOrganizationProposalContentMutationResult = Apollo.MutationResult<UpdateOrganizationProposalContentMutation>;
export type UpdateOrganizationProposalContentMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationProposalContentMutation, UpdateOrganizationProposalContentMutationVariables>;
export const UpdateOrganizationProposalDefaultsDocument = gql`
    mutation updateOrganizationProposalDefaults($input: UpdateOrganizationProposalDefaultsInput!) {
  updateOrganizationProposalDefaults(input: $input) {
    autoSave
    color
    id
    layout
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
  }
}
    `;
export type UpdateOrganizationProposalDefaultsMutationFn = Apollo.MutationFunction<UpdateOrganizationProposalDefaultsMutation, UpdateOrganizationProposalDefaultsMutationVariables>;

/**
 * __useUpdateOrganizationProposalDefaultsMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationProposalDefaultsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationProposalDefaultsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationProposalDefaultsMutation, { data, loading, error }] = useUpdateOrganizationProposalDefaultsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationProposalDefaultsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationProposalDefaultsMutation, UpdateOrganizationProposalDefaultsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationProposalDefaultsMutation, UpdateOrganizationProposalDefaultsMutationVariables>(UpdateOrganizationProposalDefaultsDocument, options);
      }
export type UpdateOrganizationProposalDefaultsMutationHookResult = ReturnType<typeof useUpdateOrganizationProposalDefaultsMutation>;
export type UpdateOrganizationProposalDefaultsMutationResult = Apollo.MutationResult<UpdateOrganizationProposalDefaultsMutation>;
export type UpdateOrganizationProposalDefaultsMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationProposalDefaultsMutation, UpdateOrganizationProposalDefaultsMutationVariables>;
export const UpdateOrganizationProposalSentEmailTextDocument = gql`
    mutation updateOrganizationProposalSentEmailText($id: ID!, $text: String!) {
  updateOrganizationProposalSentEmailText(id: $id, text: $text) {
    conversionFactorOverride {
      asphaltTonConversionFactorOverride
      excavateOutTonConversionFactorOverride
      id
      organization {
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
        }
        documents {
          id
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        phone
        proposalDefaults {
          autoSave
          color
          id
          layout
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
    }
    documents {
      id
      name
      path
      thumbnailPath
    }
    email
    emailTemplate
    failingPayment
    id
    linkedServices {
      active
      expired
      id
      service
      type
    }
    logo
    name
    onTrial
    phone
    proposalDefaults {
      autoSave
      color
      id
      layout
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
    }
    proposalSentEmailText
    salesTaxes {
      id
      isDefault
      name
      percentage
      quickbooksDesktopTaxCodeId
      quickbooksTaxCodeId
    }
    subscribed
    subscription {
      endsAt
      id
      name
      quantity
      renewsAt
      stripeId
      stripePrice
      stripeStatus
      trialEndsAt
    }
    timezone
    trialEndsAt
  }
}
    `;
export type UpdateOrganizationProposalSentEmailTextMutationFn = Apollo.MutationFunction<UpdateOrganizationProposalSentEmailTextMutation, UpdateOrganizationProposalSentEmailTextMutationVariables>;

/**
 * __useUpdateOrganizationProposalSentEmailTextMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationProposalSentEmailTextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationProposalSentEmailTextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationProposalSentEmailTextMutation, { data, loading, error }] = useUpdateOrganizationProposalSentEmailTextMutation({
 *   variables: {
 *      id: // value for 'id'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useUpdateOrganizationProposalSentEmailTextMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationProposalSentEmailTextMutation, UpdateOrganizationProposalSentEmailTextMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationProposalSentEmailTextMutation, UpdateOrganizationProposalSentEmailTextMutationVariables>(UpdateOrganizationProposalSentEmailTextDocument, options);
      }
export type UpdateOrganizationProposalSentEmailTextMutationHookResult = ReturnType<typeof useUpdateOrganizationProposalSentEmailTextMutation>;
export type UpdateOrganizationProposalSentEmailTextMutationResult = Apollo.MutationResult<UpdateOrganizationProposalSentEmailTextMutation>;
export type UpdateOrganizationProposalSentEmailTextMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationProposalSentEmailTextMutation, UpdateOrganizationProposalSentEmailTextMutationVariables>;
export const UpdateOrganizationSalesTaxesDocument = gql`
    mutation updateOrganizationSalesTaxes($input: UpdateOrganizationSalesTaxesInput!) {
  updateOrganizationSalesTaxes(input: $input) {
    conversionFactorOverride {
      asphaltTonConversionFactorOverride
      excavateOutTonConversionFactorOverride
      id
      organization {
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
        }
        documents {
          id
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        phone
        proposalDefaults {
          autoSave
          color
          id
          layout
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
    }
    documents {
      id
      name
      path
      thumbnailPath
    }
    email
    emailTemplate
    failingPayment
    id
    linkedServices {
      active
      expired
      id
      service
      type
    }
    logo
    name
    onTrial
    phone
    proposalDefaults {
      autoSave
      color
      id
      layout
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
    }
    proposalSentEmailText
    salesTaxes {
      id
      isDefault
      name
      percentage
      quickbooksDesktopTaxCodeId
      quickbooksTaxCodeId
    }
    subscribed
    subscription {
      endsAt
      id
      name
      quantity
      renewsAt
      stripeId
      stripePrice
      stripeStatus
      trialEndsAt
    }
    timezone
    trialEndsAt
  }
}
    `;
export type UpdateOrganizationSalesTaxesMutationFn = Apollo.MutationFunction<UpdateOrganizationSalesTaxesMutation, UpdateOrganizationSalesTaxesMutationVariables>;

/**
 * __useUpdateOrganizationSalesTaxesMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationSalesTaxesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationSalesTaxesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationSalesTaxesMutation, { data, loading, error }] = useUpdateOrganizationSalesTaxesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationSalesTaxesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationSalesTaxesMutation, UpdateOrganizationSalesTaxesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationSalesTaxesMutation, UpdateOrganizationSalesTaxesMutationVariables>(UpdateOrganizationSalesTaxesDocument, options);
      }
export type UpdateOrganizationSalesTaxesMutationHookResult = ReturnType<typeof useUpdateOrganizationSalesTaxesMutation>;
export type UpdateOrganizationSalesTaxesMutationResult = Apollo.MutationResult<UpdateOrganizationSalesTaxesMutation>;
export type UpdateOrganizationSalesTaxesMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationSalesTaxesMutation, UpdateOrganizationSalesTaxesMutationVariables>;
export const UpdateOrganizationSettingsDocument = gql`
    mutation updateOrganizationSettings($settings: [UpdateOrganizationSettingsInput!]!) {
  updateOrganizationSettings(settings: $settings)
}
    `;
export type UpdateOrganizationSettingsMutationFn = Apollo.MutationFunction<UpdateOrganizationSettingsMutation, UpdateOrganizationSettingsMutationVariables>;

/**
 * __useUpdateOrganizationSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationSettingsMutation, { data, loading, error }] = useUpdateOrganizationSettingsMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useUpdateOrganizationSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationSettingsMutation, UpdateOrganizationSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationSettingsMutation, UpdateOrganizationSettingsMutationVariables>(UpdateOrganizationSettingsDocument, options);
      }
export type UpdateOrganizationSettingsMutationHookResult = ReturnType<typeof useUpdateOrganizationSettingsMutation>;
export type UpdateOrganizationSettingsMutationResult = Apollo.MutationResult<UpdateOrganizationSettingsMutation>;
export type UpdateOrganizationSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationSettingsMutation, UpdateOrganizationSettingsMutationVariables>;
export const UpdateOrganizationUserDocument = gql`
    mutation updateOrganizationUser($input: UpdateOrganizationUserInput!) {
  updateOrganizationUser(input: $input) {
    addressCity
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZip
    autoAssign
    avatar
    crewsCount
    email
    firstName
    hasEmployee
    id
    inviteToken
    invitedAt
    invitedBy {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          proposalDefaults {
            autoSave
            color
            id
            layout
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
    jobPhasesCount
    jobsCount
    lastName
    name
    organization {
      email
      emailTemplate
      failingPayment
      id
      logo
      name
      onTrial
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    permissions
    phone
    proposalCount
    roles
    status
  }
}
    `;
export type UpdateOrganizationUserMutationFn = Apollo.MutationFunction<UpdateOrganizationUserMutation, UpdateOrganizationUserMutationVariables>;

/**
 * __useUpdateOrganizationUserMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationUserMutation, { data, loading, error }] = useUpdateOrganizationUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationUserMutation, UpdateOrganizationUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationUserMutation, UpdateOrganizationUserMutationVariables>(UpdateOrganizationUserDocument, options);
      }
export type UpdateOrganizationUserMutationHookResult = ReturnType<typeof useUpdateOrganizationUserMutation>;
export type UpdateOrganizationUserMutationResult = Apollo.MutationResult<UpdateOrganizationUserMutation>;
export type UpdateOrganizationUserMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationUserMutation, UpdateOrganizationUserMutationVariables>;
export const UpdatePlantDocument = gql`
    mutation updatePlant($input: UpdatePlantInput!) {
  updatePlant(input: $input) {
    addressCity
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZip
    id
    name
    phone
    products {
      id
      rate
      type
    }
  }
}
    `;
export type UpdatePlantMutationFn = Apollo.MutationFunction<UpdatePlantMutation, UpdatePlantMutationVariables>;

/**
 * __useUpdatePlantMutation__
 *
 * To run a mutation, you first call `useUpdatePlantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlantMutation, { data, loading, error }] = useUpdatePlantMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePlantMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePlantMutation, UpdatePlantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlantMutation, UpdatePlantMutationVariables>(UpdatePlantDocument, options);
      }
export type UpdatePlantMutationHookResult = ReturnType<typeof useUpdatePlantMutation>;
export type UpdatePlantMutationResult = Apollo.MutationResult<UpdatePlantMutation>;
export type UpdatePlantMutationOptions = Apollo.BaseMutationOptions<UpdatePlantMutation, UpdatePlantMutationVariables>;
export const UpdateProductDocument = gql`
    mutation updateProduct($input: UpdateProductInput!) {
  updateProduct(input: $input) {
    areaCoverage
    attributes {
      __typename
      ... on ProductAttributeAsphalt {
        applicationRate
      }
      ... on ProductAttributeConcreteColumn {
        diameter
        height
      }
      ... on ProductAttributeConcreteCurbOrGutter {
        curbHeight
        curbWidth
        gutterHeight
        gutterWidth
      }
      ... on ProductAttributeConcreteFlatwork {
        applicationRate
      }
      ... on ProductAttributeConcreteFooting {
        depth
        width
      }
      ... on ProductAttributeConcreteWall {
        height
        width
      }
      ... on ProductAttributeConcreteWaterway {
        curbHeight
        curbWidth
        gutterHeight
        gutterWidth
      }
      ... on ProductAttributeCrackSeal {
        crackDepth
        crackWidth
        overbandThickness
        overbandWidth
        poundsPerBlock
        poundsPerGallon
      }
      ... on ProductAttributeCurbWall {
        curbHeight
        curbWidth
        gutterHeight
        gutterWidth
      }
      ... on ProductAttributeExcavateOut {
        applicationRate
      }
      ... on ProductAttributeGrading {
        applicationRate
        poundsPerCubicYard
      }
      ... on ProductAttributeMastic {
        crackDepth
        crackWidth
        overbandThickness
        overbandWidth
        poundsPerBlock
        poundsPerGallon
      }
      ... on ProductAttributeMicrosurfacing {
        applicationRate
      }
      ... on ProductAttributeSealCoat {
        applicationRate
      }
      ... on ProductAttributeSlurrySeal {
        applicationRate
      }
      ... on ProductAttributeStriping {
        applicationRate
        lineWidth
      }
    }
    costMaterial
    costMinimumProduct
    costMinimumProposal
    crew {
      color
      displayName
      employees {
        firstName
        id
        lastName
        name
        organizationId
        rate
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
      }
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          proposalDefaults {
            autoSave
            color
            id
            layout
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        status
      }
      id
      name
      organization {
        email
        emailTemplate
        failingPayment
        id
        logo
        name
        onTrial
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      rate
    }
    dailyUnitsComplete
    externalProductName
    id
    indirectPercentage
    labourCostType
    markupPercentage
    measurementJob
    measurementMaterial
    name
    organizationProductType {
      id
      indirectPercentage
      markupPercentage
      name
      overheadPercentage
      type
    }
    overheadPercentage
    plant {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      id
      name
      phone
      products {
        id
        rate
        type
      }
    }
    plantProductId
    productAdditionalCosts {
      additionalCost {
        cost
        feeAmount
        feeType
        id
        name
      }
      id
      type
    }
    productEquipmentPieces {
      equipmentPiece {
        chargeType
        fuelSurcharge
        id
        name
        rate
        usePercentage
      }
      id
      quantity
    }
    productionRateType
    statementOfWork
    subcontracted
    type
    unitPrice
    unitPriceProduct
  }
}
    `;
export type UpdateProductMutationFn = Apollo.MutationFunction<UpdateProductMutation, UpdateProductMutationVariables>;

/**
 * __useUpdateProductMutation__
 *
 * To run a mutation, you first call `useUpdateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductMutation, { data, loading, error }] = useUpdateProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductMutation, UpdateProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductMutation, UpdateProductMutationVariables>(UpdateProductDocument, options);
      }
export type UpdateProductMutationHookResult = ReturnType<typeof useUpdateProductMutation>;
export type UpdateProductMutationResult = Apollo.MutationResult<UpdateProductMutation>;
export type UpdateProductMutationOptions = Apollo.BaseMutationOptions<UpdateProductMutation, UpdateProductMutationVariables>;
export const UpdateProposalDocument = gql`
    mutation updateProposal($companyId: ID!, $contactId: ID!, $id: ID!, $source: ProposalSource) {
  updateProposal(
    companyId: $companyId
    contactId: $contactId
    id: $id
    source: $source
  ) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        phone
        proposalDefaults {
          autoSave
          color
          id
          layout
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        events {
          action
          createdAt
        }
        externalId
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterTaxes
        profit
        profitPercentage
        projectFilesFolderId
        proposalNotes
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          profit
          profitPercentage
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          roundTripTravelTimeHours
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          status
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
        uuid
        version
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    clientEmailOverride
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    events {
      action
      createdAt
    }
    externalId
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isSendable
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    overallTotal
    overallTotalAfterTaxes
    profit
    profitPercentage
    projectFilesFolderId
    proposalNotes
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      profit
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
    userId
    uuid
    version
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    wonAt
  }
}
    `;
export type UpdateProposalMutationFn = Apollo.MutationFunction<UpdateProposalMutation, UpdateProposalMutationVariables>;

/**
 * __useUpdateProposalMutation__
 *
 * To run a mutation, you first call `useUpdateProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProposalMutation, { data, loading, error }] = useUpdateProposalMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      contactId: // value for 'contactId'
 *      id: // value for 'id'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useUpdateProposalMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProposalMutation, UpdateProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProposalMutation, UpdateProposalMutationVariables>(UpdateProposalDocument, options);
      }
export type UpdateProposalMutationHookResult = ReturnType<typeof useUpdateProposalMutation>;
export type UpdateProposalMutationResult = Apollo.MutationResult<UpdateProposalMutation>;
export type UpdateProposalMutationOptions = Apollo.BaseMutationOptions<UpdateProposalMutation, UpdateProposalMutationVariables>;
export const UpdateProposalAddressDocument = gql`
    mutation updateProposalAddress($input: UpdateProposalAddress!) {
  updateProposalAddress(input: $input) {
    city
    country
    id
    latitude
    line1
    line2
    longitude
    mapImage
    organizationAddressId
    state
    zip
  }
}
    `;
export type UpdateProposalAddressMutationFn = Apollo.MutationFunction<UpdateProposalAddressMutation, UpdateProposalAddressMutationVariables>;

/**
 * __useUpdateProposalAddressMutation__
 *
 * To run a mutation, you first call `useUpdateProposalAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProposalAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProposalAddressMutation, { data, loading, error }] = useUpdateProposalAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProposalAddressMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProposalAddressMutation, UpdateProposalAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProposalAddressMutation, UpdateProposalAddressMutationVariables>(UpdateProposalAddressDocument, options);
      }
export type UpdateProposalAddressMutationHookResult = ReturnType<typeof useUpdateProposalAddressMutation>;
export type UpdateProposalAddressMutationResult = Apollo.MutationResult<UpdateProposalAddressMutation>;
export type UpdateProposalAddressMutationOptions = Apollo.BaseMutationOptions<UpdateProposalAddressMutation, UpdateProposalAddressMutationVariables>;
export const UpdateProposalInfoDocument = gql`
    mutation updateProposalInfo($input: UpdateProposalInfoInput) {
  updateProposalInfo(input: $input) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        phone
        proposalDefaults {
          autoSave
          color
          id
          layout
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        events {
          action
          createdAt
        }
        externalId
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterTaxes
        profit
        profitPercentage
        projectFilesFolderId
        proposalNotes
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          profit
          profitPercentage
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          roundTripTravelTimeHours
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          status
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
        uuid
        version
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    clientEmailOverride
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    events {
      action
      createdAt
    }
    externalId
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isSendable
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    overallTotal
    overallTotalAfterTaxes
    profit
    profitPercentage
    projectFilesFolderId
    proposalNotes
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      profit
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
    userId
    uuid
    version
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    wonAt
  }
}
    `;
export type UpdateProposalInfoMutationFn = Apollo.MutationFunction<UpdateProposalInfoMutation, UpdateProposalInfoMutationVariables>;

/**
 * __useUpdateProposalInfoMutation__
 *
 * To run a mutation, you first call `useUpdateProposalInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProposalInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProposalInfoMutation, { data, loading, error }] = useUpdateProposalInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProposalInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProposalInfoMutation, UpdateProposalInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProposalInfoMutation, UpdateProposalInfoMutationVariables>(UpdateProposalInfoDocument, options);
      }
export type UpdateProposalInfoMutationHookResult = ReturnType<typeof useUpdateProposalInfoMutation>;
export type UpdateProposalInfoMutationResult = Apollo.MutationResult<UpdateProposalInfoMutation>;
export type UpdateProposalInfoMutationOptions = Apollo.BaseMutationOptions<UpdateProposalInfoMutation, UpdateProposalInfoMutationVariables>;
export const UpdateProposalPlantProductDocument = gql`
    mutation updateProposalPlantProduct($plantProductId: ID!, $proposalProductId: ID!) {
  updateProposalPlantProduct(
    plantProductId: $plantProductId
    proposalProductId: $proposalProductId
  ) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        phone
        proposalDefaults {
          autoSave
          color
          id
          layout
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        events {
          action
          createdAt
        }
        externalId
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterTaxes
        profit
        profitPercentage
        projectFilesFolderId
        proposalNotes
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          profit
          profitPercentage
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          roundTripTravelTimeHours
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          status
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
        uuid
        version
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    clientEmailOverride
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    events {
      action
      createdAt
    }
    externalId
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isSendable
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    overallTotal
    overallTotalAfterTaxes
    profit
    profitPercentage
    projectFilesFolderId
    proposalNotes
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      profit
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
    userId
    uuid
    version
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    wonAt
  }
}
    `;
export type UpdateProposalPlantProductMutationFn = Apollo.MutationFunction<UpdateProposalPlantProductMutation, UpdateProposalPlantProductMutationVariables>;

/**
 * __useUpdateProposalPlantProductMutation__
 *
 * To run a mutation, you first call `useUpdateProposalPlantProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProposalPlantProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProposalPlantProductMutation, { data, loading, error }] = useUpdateProposalPlantProductMutation({
 *   variables: {
 *      plantProductId: // value for 'plantProductId'
 *      proposalProductId: // value for 'proposalProductId'
 *   },
 * });
 */
export function useUpdateProposalPlantProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProposalPlantProductMutation, UpdateProposalPlantProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProposalPlantProductMutation, UpdateProposalPlantProductMutationVariables>(UpdateProposalPlantProductDocument, options);
      }
export type UpdateProposalPlantProductMutationHookResult = ReturnType<typeof useUpdateProposalPlantProductMutation>;
export type UpdateProposalPlantProductMutationResult = Apollo.MutationResult<UpdateProposalPlantProductMutation>;
export type UpdateProposalPlantProductMutationOptions = Apollo.BaseMutationOptions<UpdateProposalPlantProductMutation, UpdateProposalPlantProductMutationVariables>;
export const UpdateProposalProductDocument = gql`
    mutation updateProposalProduct($input: UpdateProposalProductInput!) {
  updateProposalProduct(input: $input) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        phone
        proposalDefaults {
          autoSave
          color
          id
          layout
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        events {
          action
          createdAt
        }
        externalId
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterTaxes
        profit
        profitPercentage
        projectFilesFolderId
        proposalNotes
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          profit
          profitPercentage
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          roundTripTravelTimeHours
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          status
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
        uuid
        version
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    clientEmailOverride
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    events {
      action
      createdAt
    }
    externalId
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isSendable
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    overallTotal
    overallTotalAfterTaxes
    profit
    profitPercentage
    projectFilesFolderId
    proposalNotes
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      profit
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
    userId
    uuid
    version
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    wonAt
  }
}
    `;
export type UpdateProposalProductMutationFn = Apollo.MutationFunction<UpdateProposalProductMutation, UpdateProposalProductMutationVariables>;

/**
 * __useUpdateProposalProductMutation__
 *
 * To run a mutation, you first call `useUpdateProposalProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProposalProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProposalProductMutation, { data, loading, error }] = useUpdateProposalProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProposalProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProposalProductMutation, UpdateProposalProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProposalProductMutation, UpdateProposalProductMutationVariables>(UpdateProposalProductDocument, options);
      }
export type UpdateProposalProductMutationHookResult = ReturnType<typeof useUpdateProposalProductMutation>;
export type UpdateProposalProductMutationResult = Apollo.MutationResult<UpdateProposalProductMutation>;
export type UpdateProposalProductMutationOptions = Apollo.BaseMutationOptions<UpdateProposalProductMutation, UpdateProposalProductMutationVariables>;
export const UpdateProposalSalesTaxesDocument = gql`
    mutation updateProposalSalesTaxes($input: UpdateProposalSalesTaxesInput) {
  updateProposalSalesTaxes(input: $input) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        phone
        proposalDefaults {
          autoSave
          color
          id
          layout
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        events {
          action
          createdAt
        }
        externalId
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterTaxes
        profit
        profitPercentage
        projectFilesFolderId
        proposalNotes
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          profit
          profitPercentage
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          roundTripTravelTimeHours
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          status
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
        uuid
        version
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    clientEmailOverride
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    events {
      action
      createdAt
    }
    externalId
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isSendable
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    overallTotal
    overallTotalAfterTaxes
    profit
    profitPercentage
    projectFilesFolderId
    proposalNotes
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      profit
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
    userId
    uuid
    version
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    wonAt
  }
}
    `;
export type UpdateProposalSalesTaxesMutationFn = Apollo.MutationFunction<UpdateProposalSalesTaxesMutation, UpdateProposalSalesTaxesMutationVariables>;

/**
 * __useUpdateProposalSalesTaxesMutation__
 *
 * To run a mutation, you first call `useUpdateProposalSalesTaxesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProposalSalesTaxesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProposalSalesTaxesMutation, { data, loading, error }] = useUpdateProposalSalesTaxesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProposalSalesTaxesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProposalSalesTaxesMutation, UpdateProposalSalesTaxesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProposalSalesTaxesMutation, UpdateProposalSalesTaxesMutationVariables>(UpdateProposalSalesTaxesDocument, options);
      }
export type UpdateProposalSalesTaxesMutationHookResult = ReturnType<typeof useUpdateProposalSalesTaxesMutation>;
export type UpdateProposalSalesTaxesMutationResult = Apollo.MutationResult<UpdateProposalSalesTaxesMutation>;
export type UpdateProposalSalesTaxesMutationOptions = Apollo.BaseMutationOptions<UpdateProposalSalesTaxesMutation, UpdateProposalSalesTaxesMutationVariables>;
export const UpdateProposalStageDocument = gql`
    mutation updateProposalStage($addressOverride: String, $id: ID!, $mapData: String, $name: String) {
  updateProposalStage(
    addressOverride: $addressOverride
    id: $id
    mapData: $mapData
    name: $name
  ) {
    address {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    addressOverride
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTotal
    distanceMeters
    distanceSeconds
    grossMargin
    grossMarginPercentage
    id
    mapData
    mapImage
    mapImageDirty
    name
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    ordering
    overallTotal
    profit
    profitPercentage
    proposalProducts {
      additionalCosts {
        additionalCostId
        cost
        costOverride
        costTotal
        feeAmount
        feeAmountOverride
        feeType
        id
        name
        quantity
        quantityOverride
        showOnProposal
      }
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      costTransferTruck
      crews {
        cost
        crewId
        id
        name
        rate
        rateOverride
        timeOnjob
        timeOnjobOverride
        timeTravel
        timeTravelOverride
      }
      equipmentPieces {
        chargeType
        cost
        equipmentPieceId
        id
        name
        quantity
        quantityOverride
        rate
        rateOverride
        timeOnjob
        timeOnjobOverride
        timeTravel
        timeTravelOverride
        usePercentage
      }
      externalProductName
      files {
        createdAt
        filename
        id
        thumbnail
        type
      }
      grossMargin
      grossMarginPercentage
      id
      isOptional
      jobDuration
      jobDurationDaysOverride
      jobDurationOverride
      jobSize
      mapData
      mapImage
      mapImageDirty
      material {
        areaCoverage
        attributes {
          __typename
          ... on ProductAttributeAsphalt {
            applicationRate
          }
          ... on ProductAttributeConcreteColumn {
            diameter
            height
          }
          ... on ProductAttributeConcreteCurbOrGutter {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeConcreteFlatwork {
            applicationRate
          }
          ... on ProductAttributeConcreteFooting {
            depth
            width
          }
          ... on ProductAttributeConcreteWall {
            height
            width
          }
          ... on ProductAttributeConcreteWaterway {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeCrackSeal {
            crackDepth
            crackWidth
            overbandThickness
            overbandWidth
            poundsPerBlock
            poundsPerGallon
          }
          ... on ProductAttributeCurbWall {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeExcavateOut {
            applicationRate
          }
          ... on ProductAttributeGrading {
            applicationRate
            poundsPerCubicYard
          }
          ... on ProductAttributeMastic {
            crackDepth
            crackWidth
            overbandThickness
            overbandWidth
            poundsPerBlock
            poundsPerGallon
          }
          ... on ProductAttributeMicrosurfacing {
            applicationRate
          }
          ... on ProductAttributeSealCoat {
            applicationRate
          }
          ... on ProductAttributeSlurrySeal {
            applicationRate
          }
          ... on ProductAttributeStriping {
            applicationRate
            lineWidth
          }
        }
        attributesOverride {
          __typename
          ... on ProductAttributeAsphalt {
            applicationRate
          }
          ... on ProductAttributeConcreteColumn {
            diameter
            height
          }
          ... on ProductAttributeConcreteCurbOrGutter {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeConcreteFlatwork {
            applicationRate
          }
          ... on ProductAttributeConcreteFooting {
            depth
            width
          }
          ... on ProductAttributeConcreteWall {
            height
            width
          }
          ... on ProductAttributeConcreteWaterway {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeCrackSeal {
            crackDepth
            crackWidth
            overbandThickness
            overbandWidth
            poundsPerBlock
            poundsPerGallon
          }
          ... on ProductAttributeCurbWall {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeExcavateOut {
            applicationRate
          }
          ... on ProductAttributeGrading {
            applicationRate
            poundsPerCubicYard
          }
          ... on ProductAttributeMastic {
            crackDepth
            crackWidth
            overbandThickness
            overbandWidth
            poundsPerBlock
            poundsPerGallon
          }
          ... on ProductAttributeMicrosurfacing {
            applicationRate
          }
          ... on ProductAttributeSealCoat {
            applicationRate
          }
          ... on ProductAttributeSlurrySeal {
            applicationRate
          }
          ... on ProductAttributeStriping {
            applicationRate
            lineWidth
          }
        }
        costMaterial
        costMaterialOverride
        costMinimumProduct
        costMinimumProposal
        dailyUnitsComplete
        dailyUnitsCompleteOverride
        externalProductName
        id
        indirectPercentage
        indirectPercentageOverride
        labourCostType
        markupPercentage
        markupPercentageOverride
        materialNeeded
        materialNeededOverride
        measurementJob
        measurementMaterial
        name
        organizationProductTypeName
        overheadPercentage
        overheadPercentageOverride
        productId
        productionRateType
        proposalId
        proposalProductId
        proposalStageId
        statementOfWork
        statementOfWorkOverride
        subcontracted
        tonConversionFactor
        tonConversionFactorOverride
        type
        unitPrice
        unitPriceOverride
        unitPriceProduct
      }
      measurementJob
      measurementMaterial
      netMargin
      netMarginPercentage
      notes
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalOverride
      plantProduct {
        id
        plant {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          distanceMeters
          distanceSeconds
          id
          name
          phone
          plantId
          rateOnWeight
          roundTripSeconds
        }
        plantProductId
        rate
        rateOverride
        type
      }
      productName
      profit
      profitPercentage
      profitPercentageOverride
      roundTripTravelTimeHours
      statementOfWork
      subcontractorCost
      subcontractorName
      subcontractorProposalId
      transferTruckLoadTimeBuffer
      transferTruckRoundTripTime
      transferTruckRoundTripTimeOverride
      transferTruckUnloadTimeBuffer
      transferTrucks {
        cost
        costOverride
        id
        name
        plantTransferTruckId
        quantity
        rateHourly
        rateHourlyOverride
        rateTon
        rateTonOverride
        tonnage
        totalHaulingHours
        totalHaulingHoursOverride
        transferTruckId
        truckingProductionRate
        trucksNeeded
      }
    }
    roundTripTravelTimeHours
  }
}
    `;
export type UpdateProposalStageMutationFn = Apollo.MutationFunction<UpdateProposalStageMutation, UpdateProposalStageMutationVariables>;

/**
 * __useUpdateProposalStageMutation__
 *
 * To run a mutation, you first call `useUpdateProposalStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProposalStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProposalStageMutation, { data, loading, error }] = useUpdateProposalStageMutation({
 *   variables: {
 *      addressOverride: // value for 'addressOverride'
 *      id: // value for 'id'
 *      mapData: // value for 'mapData'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateProposalStageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProposalStageMutation, UpdateProposalStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProposalStageMutation, UpdateProposalStageMutationVariables>(UpdateProposalStageDocument, options);
      }
export type UpdateProposalStageMutationHookResult = ReturnType<typeof useUpdateProposalStageMutation>;
export type UpdateProposalStageMutationResult = Apollo.MutationResult<UpdateProposalStageMutation>;
export type UpdateProposalStageMutationOptions = Apollo.BaseMutationOptions<UpdateProposalStageMutation, UpdateProposalStageMutationVariables>;
export const UpdateProposalStagesOrderingDocument = gql`
    mutation updateProposalStagesOrdering($input: UpdateProposalStagesOrdering!) {
  updateProposalStagesOrdering(input: $input) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        phone
        proposalDefaults {
          autoSave
          color
          id
          layout
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        events {
          action
          createdAt
        }
        externalId
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterTaxes
        profit
        profitPercentage
        projectFilesFolderId
        proposalNotes
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          profit
          profitPercentage
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          roundTripTravelTimeHours
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          status
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
        uuid
        version
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    clientEmailOverride
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    events {
      action
      createdAt
    }
    externalId
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isSendable
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    overallTotal
    overallTotalAfterTaxes
    profit
    profitPercentage
    projectFilesFolderId
    proposalNotes
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      profit
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
    userId
    uuid
    version
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    wonAt
  }
}
    `;
export type UpdateProposalStagesOrderingMutationFn = Apollo.MutationFunction<UpdateProposalStagesOrderingMutation, UpdateProposalStagesOrderingMutationVariables>;

/**
 * __useUpdateProposalStagesOrderingMutation__
 *
 * To run a mutation, you first call `useUpdateProposalStagesOrderingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProposalStagesOrderingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProposalStagesOrderingMutation, { data, loading, error }] = useUpdateProposalStagesOrderingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProposalStagesOrderingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProposalStagesOrderingMutation, UpdateProposalStagesOrderingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProposalStagesOrderingMutation, UpdateProposalStagesOrderingMutationVariables>(UpdateProposalStagesOrderingDocument, options);
      }
export type UpdateProposalStagesOrderingMutationHookResult = ReturnType<typeof useUpdateProposalStagesOrderingMutation>;
export type UpdateProposalStagesOrderingMutationResult = Apollo.MutationResult<UpdateProposalStagesOrderingMutation>;
export type UpdateProposalStagesOrderingMutationOptions = Apollo.BaseMutationOptions<UpdateProposalStagesOrderingMutation, UpdateProposalStagesOrderingMutationVariables>;
export const UpdateRolesWithPermissionsDocument = gql`
    mutation updateRolesWithPermissions($input: UpdateRolesWithPermissionsInput) {
  updateRolesWithPermissions(input: $input) {
    admin
    employee
    foreman
    officeManager
    salesperson
    subcontractor
  }
}
    `;
export type UpdateRolesWithPermissionsMutationFn = Apollo.MutationFunction<UpdateRolesWithPermissionsMutation, UpdateRolesWithPermissionsMutationVariables>;

/**
 * __useUpdateRolesWithPermissionsMutation__
 *
 * To run a mutation, you first call `useUpdateRolesWithPermissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRolesWithPermissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRolesWithPermissionsMutation, { data, loading, error }] = useUpdateRolesWithPermissionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRolesWithPermissionsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRolesWithPermissionsMutation, UpdateRolesWithPermissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRolesWithPermissionsMutation, UpdateRolesWithPermissionsMutationVariables>(UpdateRolesWithPermissionsDocument, options);
      }
export type UpdateRolesWithPermissionsMutationHookResult = ReturnType<typeof useUpdateRolesWithPermissionsMutation>;
export type UpdateRolesWithPermissionsMutationResult = Apollo.MutationResult<UpdateRolesWithPermissionsMutation>;
export type UpdateRolesWithPermissionsMutationOptions = Apollo.BaseMutationOptions<UpdateRolesWithPermissionsMutation, UpdateRolesWithPermissionsMutationVariables>;
export const UpdateStageProductsOrderingDocument = gql`
    mutation updateStageProductsOrdering($input: UpdateProposalProductsOrderingInput!) {
  updateStageProductsOrdering(input: $input) {
    address {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    addressOverride
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTotal
    distanceMeters
    distanceSeconds
    grossMargin
    grossMarginPercentage
    id
    mapData
    mapImage
    mapImageDirty
    name
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    ordering
    overallTotal
    profit
    profitPercentage
    proposalProducts {
      additionalCosts {
        additionalCostId
        cost
        costOverride
        costTotal
        feeAmount
        feeAmountOverride
        feeType
        id
        name
        quantity
        quantityOverride
        showOnProposal
      }
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      costTransferTruck
      crews {
        cost
        crewId
        id
        name
        rate
        rateOverride
        timeOnjob
        timeOnjobOverride
        timeTravel
        timeTravelOverride
      }
      equipmentPieces {
        chargeType
        cost
        equipmentPieceId
        id
        name
        quantity
        quantityOverride
        rate
        rateOverride
        timeOnjob
        timeOnjobOverride
        timeTravel
        timeTravelOverride
        usePercentage
      }
      externalProductName
      files {
        createdAt
        filename
        id
        thumbnail
        type
      }
      grossMargin
      grossMarginPercentage
      id
      isOptional
      jobDuration
      jobDurationDaysOverride
      jobDurationOverride
      jobSize
      mapData
      mapImage
      mapImageDirty
      material {
        areaCoverage
        attributes {
          __typename
          ... on ProductAttributeAsphalt {
            applicationRate
          }
          ... on ProductAttributeConcreteColumn {
            diameter
            height
          }
          ... on ProductAttributeConcreteCurbOrGutter {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeConcreteFlatwork {
            applicationRate
          }
          ... on ProductAttributeConcreteFooting {
            depth
            width
          }
          ... on ProductAttributeConcreteWall {
            height
            width
          }
          ... on ProductAttributeConcreteWaterway {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeCrackSeal {
            crackDepth
            crackWidth
            overbandThickness
            overbandWidth
            poundsPerBlock
            poundsPerGallon
          }
          ... on ProductAttributeCurbWall {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeExcavateOut {
            applicationRate
          }
          ... on ProductAttributeGrading {
            applicationRate
            poundsPerCubicYard
          }
          ... on ProductAttributeMastic {
            crackDepth
            crackWidth
            overbandThickness
            overbandWidth
            poundsPerBlock
            poundsPerGallon
          }
          ... on ProductAttributeMicrosurfacing {
            applicationRate
          }
          ... on ProductAttributeSealCoat {
            applicationRate
          }
          ... on ProductAttributeSlurrySeal {
            applicationRate
          }
          ... on ProductAttributeStriping {
            applicationRate
            lineWidth
          }
        }
        attributesOverride {
          __typename
          ... on ProductAttributeAsphalt {
            applicationRate
          }
          ... on ProductAttributeConcreteColumn {
            diameter
            height
          }
          ... on ProductAttributeConcreteCurbOrGutter {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeConcreteFlatwork {
            applicationRate
          }
          ... on ProductAttributeConcreteFooting {
            depth
            width
          }
          ... on ProductAttributeConcreteWall {
            height
            width
          }
          ... on ProductAttributeConcreteWaterway {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeCrackSeal {
            crackDepth
            crackWidth
            overbandThickness
            overbandWidth
            poundsPerBlock
            poundsPerGallon
          }
          ... on ProductAttributeCurbWall {
            curbHeight
            curbWidth
            gutterHeight
            gutterWidth
          }
          ... on ProductAttributeExcavateOut {
            applicationRate
          }
          ... on ProductAttributeGrading {
            applicationRate
            poundsPerCubicYard
          }
          ... on ProductAttributeMastic {
            crackDepth
            crackWidth
            overbandThickness
            overbandWidth
            poundsPerBlock
            poundsPerGallon
          }
          ... on ProductAttributeMicrosurfacing {
            applicationRate
          }
          ... on ProductAttributeSealCoat {
            applicationRate
          }
          ... on ProductAttributeSlurrySeal {
            applicationRate
          }
          ... on ProductAttributeStriping {
            applicationRate
            lineWidth
          }
        }
        costMaterial
        costMaterialOverride
        costMinimumProduct
        costMinimumProposal
        dailyUnitsComplete
        dailyUnitsCompleteOverride
        externalProductName
        id
        indirectPercentage
        indirectPercentageOverride
        labourCostType
        markupPercentage
        markupPercentageOverride
        materialNeeded
        materialNeededOverride
        measurementJob
        measurementMaterial
        name
        organizationProductTypeName
        overheadPercentage
        overheadPercentageOverride
        productId
        productionRateType
        proposalId
        proposalProductId
        proposalStageId
        statementOfWork
        statementOfWorkOverride
        subcontracted
        tonConversionFactor
        tonConversionFactorOverride
        type
        unitPrice
        unitPriceOverride
        unitPriceProduct
      }
      measurementJob
      measurementMaterial
      netMargin
      netMarginPercentage
      notes
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalOverride
      plantProduct {
        id
        plant {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          distanceMeters
          distanceSeconds
          id
          name
          phone
          plantId
          rateOnWeight
          roundTripSeconds
        }
        plantProductId
        rate
        rateOverride
        type
      }
      productName
      profit
      profitPercentage
      profitPercentageOverride
      roundTripTravelTimeHours
      statementOfWork
      subcontractorCost
      subcontractorName
      subcontractorProposalId
      transferTruckLoadTimeBuffer
      transferTruckRoundTripTime
      transferTruckRoundTripTimeOverride
      transferTruckUnloadTimeBuffer
      transferTrucks {
        cost
        costOverride
        id
        name
        plantTransferTruckId
        quantity
        rateHourly
        rateHourlyOverride
        rateTon
        rateTonOverride
        tonnage
        totalHaulingHours
        totalHaulingHoursOverride
        transferTruckId
        truckingProductionRate
        trucksNeeded
      }
    }
    roundTripTravelTimeHours
  }
}
    `;
export type UpdateStageProductsOrderingMutationFn = Apollo.MutationFunction<UpdateStageProductsOrderingMutation, UpdateStageProductsOrderingMutationVariables>;

/**
 * __useUpdateStageProductsOrderingMutation__
 *
 * To run a mutation, you first call `useUpdateStageProductsOrderingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStageProductsOrderingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStageProductsOrderingMutation, { data, loading, error }] = useUpdateStageProductsOrderingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStageProductsOrderingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStageProductsOrderingMutation, UpdateStageProductsOrderingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStageProductsOrderingMutation, UpdateStageProductsOrderingMutationVariables>(UpdateStageProductsOrderingDocument, options);
      }
export type UpdateStageProductsOrderingMutationHookResult = ReturnType<typeof useUpdateStageProductsOrderingMutation>;
export type UpdateStageProductsOrderingMutationResult = Apollo.MutationResult<UpdateStageProductsOrderingMutation>;
export type UpdateStageProductsOrderingMutationOptions = Apollo.BaseMutationOptions<UpdateStageProductsOrderingMutation, UpdateStageProductsOrderingMutationVariables>;
export const UpdateTimeBucketDocument = gql`
    mutation updateTimeBucket($input: UpdateTimeBucketInput!) {
  updateTimeBucket(input: $input) {
    id
    name
    organizationId
  }
}
    `;
export type UpdateTimeBucketMutationFn = Apollo.MutationFunction<UpdateTimeBucketMutation, UpdateTimeBucketMutationVariables>;

/**
 * __useUpdateTimeBucketMutation__
 *
 * To run a mutation, you first call `useUpdateTimeBucketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTimeBucketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTimeBucketMutation, { data, loading, error }] = useUpdateTimeBucketMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTimeBucketMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTimeBucketMutation, UpdateTimeBucketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTimeBucketMutation, UpdateTimeBucketMutationVariables>(UpdateTimeBucketDocument, options);
      }
export type UpdateTimeBucketMutationHookResult = ReturnType<typeof useUpdateTimeBucketMutation>;
export type UpdateTimeBucketMutationResult = Apollo.MutationResult<UpdateTimeBucketMutation>;
export type UpdateTimeBucketMutationOptions = Apollo.BaseMutationOptions<UpdateTimeBucketMutation, UpdateTimeBucketMutationVariables>;
export const UpdateTimeEntryDocument = gql`
    mutation updateTimeEntry($input: UpdateTimeEntryInput!) {
  updateTimeEntry(input: $input) {
    clockInLatitude
    clockInLongitude
    clockOutLatitude
    clockOutLongitude
    endTime
    forDate
    id
    jobPhase {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualEmployeeHours
      actualGrossMargin
      actualGrossMarginPercentage
      actualMaterialNeeded
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      address
      applicableStatuses
      costItems {
        additionalCosts {
          additionalCostId
          cost
          costTotal
          feeAmount
          feeType
          id
          jobPhaseCostItem {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          name
        }
        costAdditional
        costEquipment
        costLabour
        costMaterial
        costTransferTruck
        date
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        equipmentPieces {
          equipmentPieceId
          id
          name
          quantity
          rate
          timeOnjob
          timeTravel
        }
        id
        jobPhase {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualEmployeeHours
          actualGrossMargin
          actualGrossMarginPercentage
          actualMaterialNeeded
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address
          applicableStatuses
          crew {
            color
            displayName
            id
            name
            rate
          }
          crewId
          defaultAdditionalCosts {
            cost
            feeAmount
            feeType
            id
            name
          }
          defaultEmployees {
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          defaultEquipmentPieces {
            chargeType
            fuelSurcharge
            id
            name
            rate
            usePercentage
          }
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          endsAt
          externalId
          files {
            createdAt
            filename
            id
            thumbnail
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            endsAt
            externalId
            id
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
          }
          jobDuration
          jobPhasePlant {
            id
            name
            type
          }
          jobSize
          notes
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          organizationProductType {
            id
            indirectPercentage
            markupPercentage
            name
            overheadPercentage
            type
          }
          organizationProductTypeName
          productName
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          proposalProduct {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          proposalStage {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedEmployeeHours
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedMaterialNeeded
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          scheduleBlocks {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          scheduledBlockForDate {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          startsAt
          status
          travelTimeEstimate
          users {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          usersColor
          workOrderCrews {
            crewId
            id
            name
          }
          workOrderEquipmentPieces {
            equipmentPieceId
            id
            name
          }
          workOrderTransferTrucks {
            id
            name
            quantity
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
        }
        material {
          costMaterial
          id
          jobPhaseCostItem {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          materialNeeded
          name
          organizationProductTypeName
          type
        }
        plantId
        plantProductId
        transferTrucks {
          hours
          id
          name
          plantTransferTruckId
          rateHourly
          rateTon
          tonnage
          transferTruckId
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
      }
      crewId
      endsAt
      externalId
      id
      jobDuration
      jobSize
      notes
      organizationProductTypeName
      productName
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedEmployeeHours
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedMaterialNeeded
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      startsAt
      status
      travelTimeEstimate
      usersColor
    }
    notes
    organizationId
    startTime
    timeBucket {
      id
      name
      organizationId
    }
    timeTrackedSeconds
    timeTrackedSecondsOverride
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
    uuid
  }
}
    `;
export type UpdateTimeEntryMutationFn = Apollo.MutationFunction<UpdateTimeEntryMutation, UpdateTimeEntryMutationVariables>;

/**
 * __useUpdateTimeEntryMutation__
 *
 * To run a mutation, you first call `useUpdateTimeEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTimeEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTimeEntryMutation, { data, loading, error }] = useUpdateTimeEntryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTimeEntryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTimeEntryMutation, UpdateTimeEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTimeEntryMutation, UpdateTimeEntryMutationVariables>(UpdateTimeEntryDocument, options);
      }
export type UpdateTimeEntryMutationHookResult = ReturnType<typeof useUpdateTimeEntryMutation>;
export type UpdateTimeEntryMutationResult = Apollo.MutationResult<UpdateTimeEntryMutation>;
export type UpdateTimeEntryMutationOptions = Apollo.BaseMutationOptions<UpdateTimeEntryMutation, UpdateTimeEntryMutationVariables>;
export const UpdateTransferTruckDocument = gql`
    mutation updateTransferTruck($input: UpdateTransferTruckInput!) {
  updateTransferTruck(input: $input) {
    defaultRateHourly
    defaultRateTon
    defaultTonnage
    id
    name
  }
}
    `;
export type UpdateTransferTruckMutationFn = Apollo.MutationFunction<UpdateTransferTruckMutation, UpdateTransferTruckMutationVariables>;

/**
 * __useUpdateTransferTruckMutation__
 *
 * To run a mutation, you first call `useUpdateTransferTruckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTransferTruckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTransferTruckMutation, { data, loading, error }] = useUpdateTransferTruckMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTransferTruckMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTransferTruckMutation, UpdateTransferTruckMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTransferTruckMutation, UpdateTransferTruckMutationVariables>(UpdateTransferTruckDocument, options);
      }
export type UpdateTransferTruckMutationHookResult = ReturnType<typeof useUpdateTransferTruckMutation>;
export type UpdateTransferTruckMutationResult = Apollo.MutationResult<UpdateTransferTruckMutation>;
export type UpdateTransferTruckMutationOptions = Apollo.BaseMutationOptions<UpdateTransferTruckMutation, UpdateTransferTruckMutationVariables>;
export const UpdateWorkOrderItemsDocument = gql`
    mutation updateWorkOrderItems($input: UpdateWorkOrderItemsInput!) {
  updateWorkOrderItems(input: $input) {
    actualCostAdditional
    actualCostDirect
    actualCostEquipment
    actualCostIndirect
    actualCostLabour
    actualCostMaterial
    actualCostOverhead
    actualCostTotal
    actualCostTransferTruck
    actualEmployeeHours
    actualGrossMargin
    actualGrossMarginPercentage
    actualMaterialNeeded
    actualNetMargin
    actualNetMarginPercentage
    actualOperatingMargin
    actualOperatingMarginPercentage
    actualOverallTotal
    actualProfit
    actualProfitPercentage
    address
    applicableStatuses
    costItems {
      additionalCosts {
        additionalCostId
        cost
        costTotal
        feeAmount
        feeType
        id
        jobPhaseCostItem {
          additionalCosts {
            additionalCostId
            cost
            costTotal
            feeAmount
            feeType
            id
            name
          }
          costAdditional
          costEquipment
          costLabour
          costMaterial
          costTransferTruck
          date
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          equipmentPieces {
            equipmentPieceId
            id
            name
            quantity
            rate
            timeOnjob
            timeTravel
          }
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            address
            applicableStatuses
            crewId
            endsAt
            externalId
            id
            jobDuration
            jobSize
            notes
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          material {
            costMaterial
            id
            materialNeeded
            name
            organizationProductTypeName
            type
          }
          plantId
          plantProductId
          transferTrucks {
            hours
            id
            name
            plantTransferTruckId
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
        }
        name
      }
      costAdditional
      costEquipment
      costLabour
      costMaterial
      costTransferTruck
      date
      employees {
        employeeId
        id
        name
        rate
        timeOnjob
        timeTravel
      }
      equipmentPieces {
        equipmentPieceId
        id
        name
        quantity
        rate
        timeOnjob
        timeTravel
      }
      id
      jobPhase {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualEmployeeHours
        actualGrossMargin
        actualGrossMarginPercentage
        actualMaterialNeeded
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        address
        applicableStatuses
        costItems {
          costAdditional
          costEquipment
          costLabour
          costMaterial
          costTransferTruck
          date
          id
          material {
            costMaterial
            id
            materialNeeded
            name
            organizationProductTypeName
            type
          }
          plantId
          plantProductId
          transferTrucks {
            hours
            id
            name
            plantTransferTruckId
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
        }
        crew {
          color
          displayName
          employees {
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          id
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          rate
        }
        crewId
        defaultAdditionalCosts {
          cost
          feeAmount
          feeType
          id
          name
        }
        defaultEmployees {
          firstName
          id
          lastName
          name
          organizationId
          rate
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
        }
        defaultEquipmentPieces {
          chargeType
          fuelSurcharge
          id
          name
          rate
          usePercentage
        }
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        endsAt
        externalId
        files {
          createdAt
          filename
          id
          thumbnail
        }
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        id
        job {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualGrossMargin
          actualGrossMarginPercentage
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          billingStatus
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          datePushedToQuickbooks
          endsAt
          externalId
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          id
          jobPhases {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            address
            applicableStatuses
            crewId
            endsAt
            externalId
            id
            jobDuration
            jobSize
            notes
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          mayShowTaxNotification
          notes
          projectFilesFolderId
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          proposalId
          proposalStage {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          shouldPushTaxesToQuickbooks
          startsAt
          status
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
        }
        jobDuration
        jobPhasePlant {
          id
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            rate
            type
          }
          type
        }
        jobSize
        notes
        organization {
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          proposalDefaults {
            autoSave
            color
            id
            layout
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        organizationProductType {
          id
          indirectPercentage
          markupPercentage
          name
          overheadPercentage
          type
        }
        organizationProductTypeName
        productName
        proposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        proposalProduct {
          additionalCosts {
            additionalCostId
            cost
            costOverride
            costTotal
            feeAmount
            feeAmountOverride
            feeType
            id
            name
            quantity
            quantityOverride
            showOnProposal
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          costTransferTruck
          crews {
            cost
            crewId
            id
            name
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
          }
          equipmentPieces {
            chargeType
            cost
            equipmentPieceId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
            usePercentage
          }
          externalProductName
          files {
            createdAt
            filename
            id
            thumbnail
            type
          }
          grossMargin
          grossMarginPercentage
          id
          isOptional
          jobDuration
          jobDurationDaysOverride
          jobDurationOverride
          jobSize
          mapData
          mapImage
          mapImageDirty
          material {
            areaCoverage
            attributes {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            attributesOverride {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            costMaterial
            costMaterialOverride
            costMinimumProduct
            costMinimumProposal
            dailyUnitsComplete
            dailyUnitsCompleteOverride
            externalProductName
            id
            indirectPercentage
            indirectPercentageOverride
            labourCostType
            markupPercentage
            markupPercentageOverride
            materialNeeded
            materialNeededOverride
            measurementJob
            measurementMaterial
            name
            organizationProductTypeName
            overheadPercentage
            overheadPercentageOverride
            productId
            productionRateType
            proposalId
            proposalProductId
            proposalStageId
            statementOfWork
            statementOfWorkOverride
            subcontracted
            tonConversionFactor
            tonConversionFactorOverride
            type
            unitPrice
            unitPriceOverride
            unitPriceProduct
          }
          measurementJob
          measurementMaterial
          netMargin
          netMarginPercentage
          notes
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalOverride
          plantProduct {
            id
            plantProductId
            rate
            rateOverride
            type
          }
          productName
          profit
          profitPercentage
          profitPercentageOverride
          roundTripTravelTimeHours
          statementOfWork
          subcontractorCost
          subcontractorName
          subcontractorProposalId
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTime
          transferTruckRoundTripTimeOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            quantity
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
        }
        proposalStage {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          profit
          profitPercentage
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          roundTripTravelTimeHours
        }
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedEmployeeHours
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedMaterialNeeded
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        scheduleBlocks {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            endsAt
            externalId
            id
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            address
            applicableStatuses
            crewId
            endsAt
            externalId
            id
            jobDuration
            jobSize
            notes
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        scheduledBlockForDate {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            endsAt
            externalId
            id
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            address
            applicableStatuses
            crewId
            endsAt
            externalId
            id
            jobDuration
            jobSize
            notes
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        startsAt
        status
        travelTimeEstimate
        users {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        usersColor
        workOrderCrews {
          crewId
          id
          name
        }
        workOrderEquipmentPieces {
          equipmentPieceId
          id
          name
        }
        workOrderTransferTrucks {
          id
          name
          quantity
          rateHourly
          rateTon
          tonnage
          transferTruckId
        }
      }
      plantId
      plantProductId
    }
    crew {
      color
      displayName
      id
      name
      rate
    }
    crewId
    defaultAdditionalCosts {
      cost
      feeAmount
      feeType
      id
      name
    }
    defaultEmployees {
      firstName
      id
      lastName
      name
      organizationId
      rate
      userId
    }
    defaultEquipmentPieces {
      chargeType
      fuelSurcharge
      id
      name
      rate
      usePercentage
    }
    employees {
      employeeId
      id
      name
      rate
      timeOnjob
      timeTravel
    }
    endsAt
    externalId
    files {
      createdAt
      filename
      id
      thumbnail
    }
    foremanUser {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
    id
    job {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualGrossMargin
      actualGrossMarginPercentage
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      billingStatus
      datePushedToQuickbooks
      endsAt
      externalId
      id
      mayShowTaxNotification
      notes
      projectFilesFolderId
      proposalId
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      shouldPushTaxesToQuickbooks
      startsAt
      status
      userId
    }
    jobDuration
    jobPhasePlant {
      id
      name
      type
    }
    jobSize
    notes
    organization {
      email
      emailTemplate
      failingPayment
      id
      logo
      name
      onTrial
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    organizationProductType {
      id
      indirectPercentage
      markupPercentage
      name
      overheadPercentage
      type
    }
    organizationProductTypeName
    productName
    proposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    proposalProduct {
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      costTransferTruck
      externalProductName
      grossMargin
      grossMarginPercentage
      id
      isOptional
      jobDuration
      jobDurationDaysOverride
      jobDurationOverride
      jobSize
      mapData
      mapImage
      mapImageDirty
      measurementJob
      measurementMaterial
      netMargin
      netMarginPercentage
      notes
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalOverride
      productName
      profit
      profitPercentage
      profitPercentageOverride
      roundTripTravelTimeHours
      statementOfWork
      subcontractorCost
      subcontractorName
      subcontractorProposalId
      transferTruckLoadTimeBuffer
      transferTruckRoundTripTime
      transferTruckRoundTripTimeOverride
      transferTruckUnloadTimeBuffer
    }
    proposalStage {
      addressOverride
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      profit
      profitPercentage
      roundTripTravelTimeHours
    }
    proposedCostAdditional
    proposedCostDirect
    proposedCostEquipment
    proposedCostIndirect
    proposedCostLabour
    proposedCostMaterial
    proposedCostOverhead
    proposedCostTotal
    proposedCostTransferTruck
    proposedEmployeeHours
    proposedGrossMargin
    proposedGrossMarginPercentage
    proposedMaterialNeeded
    proposedNetMargin
    proposedNetMarginPercentage
    proposedOperatingMargin
    proposedOperatingMarginPercentage
    proposedOverallTotal
    proposedProfit
    proposedProfitPercentage
    scheduleBlocks {
      blockLength
      endsAt
      estimatedMaterial
      estimatedMaterialOverride
      id
      scheduledAt
      showTravelFrom
      showTravelTo
      travelTime
    }
    scheduledBlockForDate {
      blockLength
      endsAt
      estimatedMaterial
      estimatedMaterialOverride
      id
      scheduledAt
      showTravelFrom
      showTravelTo
      travelTime
    }
    startsAt
    status
    travelTimeEstimate
    users {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
    usersColor
    workOrderCrews {
      crewId
      id
      name
    }
    workOrderEquipmentPieces {
      equipmentPieceId
      id
      name
    }
    workOrderTransferTrucks {
      id
      name
      quantity
      rateHourly
      rateTon
      tonnage
      transferTruckId
    }
  }
}
    `;
export type UpdateWorkOrderItemsMutationFn = Apollo.MutationFunction<UpdateWorkOrderItemsMutation, UpdateWorkOrderItemsMutationVariables>;

/**
 * __useUpdateWorkOrderItemsMutation__
 *
 * To run a mutation, you first call `useUpdateWorkOrderItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkOrderItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkOrderItemsMutation, { data, loading, error }] = useUpdateWorkOrderItemsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkOrderItemsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkOrderItemsMutation, UpdateWorkOrderItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkOrderItemsMutation, UpdateWorkOrderItemsMutationVariables>(UpdateWorkOrderItemsDocument, options);
      }
export type UpdateWorkOrderItemsMutationHookResult = ReturnType<typeof useUpdateWorkOrderItemsMutation>;
export type UpdateWorkOrderItemsMutationResult = Apollo.MutationResult<UpdateWorkOrderItemsMutation>;
export type UpdateWorkOrderItemsMutationOptions = Apollo.BaseMutationOptions<UpdateWorkOrderItemsMutation, UpdateWorkOrderItemsMutationVariables>;
export const ValidateRegistrationTokenDocument = gql`
    mutation validateRegistrationToken($input: ValidateRegistrationTokenInput!) {
  validateRegistrationToken(input: $input)
}
    `;
export type ValidateRegistrationTokenMutationFn = Apollo.MutationFunction<ValidateRegistrationTokenMutation, ValidateRegistrationTokenMutationVariables>;

/**
 * __useValidateRegistrationTokenMutation__
 *
 * To run a mutation, you first call `useValidateRegistrationTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateRegistrationTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateRegistrationTokenMutation, { data, loading, error }] = useValidateRegistrationTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateRegistrationTokenMutation(baseOptions?: Apollo.MutationHookOptions<ValidateRegistrationTokenMutation, ValidateRegistrationTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateRegistrationTokenMutation, ValidateRegistrationTokenMutationVariables>(ValidateRegistrationTokenDocument, options);
      }
export type ValidateRegistrationTokenMutationHookResult = ReturnType<typeof useValidateRegistrationTokenMutation>;
export type ValidateRegistrationTokenMutationResult = Apollo.MutationResult<ValidateRegistrationTokenMutation>;
export type ValidateRegistrationTokenMutationOptions = Apollo.BaseMutationOptions<ValidateRegistrationTokenMutation, ValidateRegistrationTokenMutationVariables>;
export const GetOrganizationApiKeysDocument = gql`
    query GetOrganizationApiKeys {
  GetOrganizationApiKeys {
    api_key
    description
    id
    is_active
    organizationId
  }
}
    `;

/**
 * __useGetOrganizationApiKeysQuery__
 *
 * To run a query within a React component, call `useGetOrganizationApiKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationApiKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationApiKeysQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizationApiKeysQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationApiKeysQuery, GetOrganizationApiKeysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationApiKeysQuery, GetOrganizationApiKeysQueryVariables>(GetOrganizationApiKeysDocument, options);
      }
export function useGetOrganizationApiKeysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationApiKeysQuery, GetOrganizationApiKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationApiKeysQuery, GetOrganizationApiKeysQueryVariables>(GetOrganizationApiKeysDocument, options);
        }
export type GetOrganizationApiKeysQueryHookResult = ReturnType<typeof useGetOrganizationApiKeysQuery>;
export type GetOrganizationApiKeysLazyQueryHookResult = ReturnType<typeof useGetOrganizationApiKeysLazyQuery>;
export type GetOrganizationApiKeysQueryResult = Apollo.QueryResult<GetOrganizationApiKeysQuery, GetOrganizationApiKeysQueryVariables>;
export const GetAdditionalCostDocument = gql`
    query getAdditionalCost($id: ID!) {
  getAdditionalCost(id: $id) {
    cost
    feeAmount
    feeType
    id
    name
  }
}
    `;

/**
 * __useGetAdditionalCostQuery__
 *
 * To run a query within a React component, call `useGetAdditionalCostQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdditionalCostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdditionalCostQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAdditionalCostQuery(baseOptions: Apollo.QueryHookOptions<GetAdditionalCostQuery, GetAdditionalCostQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdditionalCostQuery, GetAdditionalCostQueryVariables>(GetAdditionalCostDocument, options);
      }
export function useGetAdditionalCostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdditionalCostQuery, GetAdditionalCostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdditionalCostQuery, GetAdditionalCostQueryVariables>(GetAdditionalCostDocument, options);
        }
export type GetAdditionalCostQueryHookResult = ReturnType<typeof useGetAdditionalCostQuery>;
export type GetAdditionalCostLazyQueryHookResult = ReturnType<typeof useGetAdditionalCostLazyQuery>;
export type GetAdditionalCostQueryResult = Apollo.QueryResult<GetAdditionalCostQuery, GetAdditionalCostQueryVariables>;
export const GetAdditionalCostsDocument = gql`
    query getAdditionalCosts($first: Int!, $page: Int, $search: String, $sort: SortDirection) {
  getAdditionalCosts(first: $first, page: $page, search: $search, sort: $sort) {
    data {
      cost
      feeAmount
      feeType
      id
      name
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useGetAdditionalCostsQuery__
 *
 * To run a query within a React component, call `useGetAdditionalCostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdditionalCostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdditionalCostsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetAdditionalCostsQuery(baseOptions: Apollo.QueryHookOptions<GetAdditionalCostsQuery, GetAdditionalCostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdditionalCostsQuery, GetAdditionalCostsQueryVariables>(GetAdditionalCostsDocument, options);
      }
export function useGetAdditionalCostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdditionalCostsQuery, GetAdditionalCostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdditionalCostsQuery, GetAdditionalCostsQueryVariables>(GetAdditionalCostsDocument, options);
        }
export type GetAdditionalCostsQueryHookResult = ReturnType<typeof useGetAdditionalCostsQuery>;
export type GetAdditionalCostsLazyQueryHookResult = ReturnType<typeof useGetAdditionalCostsLazyQuery>;
export type GetAdditionalCostsQueryResult = Apollo.QueryResult<GetAdditionalCostsQuery, GetAdditionalCostsQueryVariables>;
export const GetAllCrewsDocument = gql`
    query getAllCrews {
  getAllCrews {
    color
    displayName
    employees {
      firstName
      id
      lastName
      name
      organizationId
      rate
      user {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          proposalDefaults {
            autoSave
            color
            id
            layout
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        status
      }
      userId
    }
    foremanUser {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        email
        emailTemplate
        failingPayment
        id
        logo
        name
        onTrial
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      status
    }
    id
    name
    organization {
      email
      emailTemplate
      failingPayment
      id
      logo
      name
      onTrial
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    rate
  }
}
    `;

/**
 * __useGetAllCrewsQuery__
 *
 * To run a query within a React component, call `useGetAllCrewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCrewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCrewsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllCrewsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllCrewsQuery, GetAllCrewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCrewsQuery, GetAllCrewsQueryVariables>(GetAllCrewsDocument, options);
      }
export function useGetAllCrewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCrewsQuery, GetAllCrewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCrewsQuery, GetAllCrewsQueryVariables>(GetAllCrewsDocument, options);
        }
export type GetAllCrewsQueryHookResult = ReturnType<typeof useGetAllCrewsQuery>;
export type GetAllCrewsLazyQueryHookResult = ReturnType<typeof useGetAllCrewsLazyQuery>;
export type GetAllCrewsQueryResult = Apollo.QueryResult<GetAllCrewsQuery, GetAllCrewsQueryVariables>;
export const GetArchivedCompaniesDocument = gql`
    query getArchivedCompanies($first: Int!, $page: Int) {
  getArchivedCompanies(first: $first, page: $page) {
    data {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      contacts {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      email
      id
      jobsCount
      logo
      name
      notes
      notificationTypes {
        CONTACT
        JOB
        JOB_PHASE
        OPPORTUNITY
        PROPOSAL
      }
      phone
      primaryContact {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useGetArchivedCompaniesQuery__
 *
 * To run a query within a React component, call `useGetArchivedCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArchivedCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArchivedCompaniesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetArchivedCompaniesQuery(baseOptions: Apollo.QueryHookOptions<GetArchivedCompaniesQuery, GetArchivedCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArchivedCompaniesQuery, GetArchivedCompaniesQueryVariables>(GetArchivedCompaniesDocument, options);
      }
export function useGetArchivedCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArchivedCompaniesQuery, GetArchivedCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArchivedCompaniesQuery, GetArchivedCompaniesQueryVariables>(GetArchivedCompaniesDocument, options);
        }
export type GetArchivedCompaniesQueryHookResult = ReturnType<typeof useGetArchivedCompaniesQuery>;
export type GetArchivedCompaniesLazyQueryHookResult = ReturnType<typeof useGetArchivedCompaniesLazyQuery>;
export type GetArchivedCompaniesQueryResult = Apollo.QueryResult<GetArchivedCompaniesQuery, GetArchivedCompaniesQueryVariables>;
export const GetCheckoutUrlDocument = gql`
    query getCheckoutUrl {
  getCheckoutUrl
}
    `;

/**
 * __useGetCheckoutUrlQuery__
 *
 * To run a query within a React component, call `useGetCheckoutUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCheckoutUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCheckoutUrlQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCheckoutUrlQuery(baseOptions?: Apollo.QueryHookOptions<GetCheckoutUrlQuery, GetCheckoutUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCheckoutUrlQuery, GetCheckoutUrlQueryVariables>(GetCheckoutUrlDocument, options);
      }
export function useGetCheckoutUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCheckoutUrlQuery, GetCheckoutUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCheckoutUrlQuery, GetCheckoutUrlQueryVariables>(GetCheckoutUrlDocument, options);
        }
export type GetCheckoutUrlQueryHookResult = ReturnType<typeof useGetCheckoutUrlQuery>;
export type GetCheckoutUrlLazyQueryHookResult = ReturnType<typeof useGetCheckoutUrlLazyQuery>;
export type GetCheckoutUrlQueryResult = Apollo.QueryResult<GetCheckoutUrlQuery, GetCheckoutUrlQueryVariables>;
export const GetCompaniesDocument = gql`
    query getCompanies($first: Int!, $page: Int, $search: String, $searchByName: Boolean, $sort: SortDirection, $sortKey: GetCompaniesSortKey) {
  getCompanies(
    first: $first
    page: $page
    search: $search
    searchByName: $searchByName
    sort: $sort
    sortKey: $sortKey
  ) {
    data {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      contacts {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      email
      id
      jobsCount
      logo
      name
      notes
      notificationTypes {
        CONTACT
        JOB
        JOB_PHASE
        OPPORTUNITY
        PROPOSAL
      }
      phone
      primaryContact {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useGetCompaniesQuery__
 *
 * To run a query within a React component, call `useGetCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompaniesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      searchByName: // value for 'searchByName'
 *      sort: // value for 'sort'
 *      sortKey: // value for 'sortKey'
 *   },
 * });
 */
export function useGetCompaniesQuery(baseOptions: Apollo.QueryHookOptions<GetCompaniesQuery, GetCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompaniesQuery, GetCompaniesQueryVariables>(GetCompaniesDocument, options);
      }
export function useGetCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompaniesQuery, GetCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompaniesQuery, GetCompaniesQueryVariables>(GetCompaniesDocument, options);
        }
export type GetCompaniesQueryHookResult = ReturnType<typeof useGetCompaniesQuery>;
export type GetCompaniesLazyQueryHookResult = ReturnType<typeof useGetCompaniesLazyQuery>;
export type GetCompaniesQueryResult = Apollo.QueryResult<GetCompaniesQuery, GetCompaniesQueryVariables>;
export const GetCompanyDocument = gql`
    query getCompany($id: ID!) {
  getCompany(id: $id) {
    addCompanyInfo
    addressCity
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZip
    contacts {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    email
    id
    jobsCount
    logo
    name
    notes
    notificationTypes {
      CONTACT
      JOB
      JOB_PHASE
      OPPORTUNITY
      PROPOSAL
    }
    phone
    primaryContact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    projectFilesFolderId
    proposalsCount
    status
    website
  }
}
    `;

/**
 * __useGetCompanyQuery__
 *
 * To run a query within a React component, call `useGetCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCompanyQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyQuery, GetCompanyQueryVariables>(GetCompanyDocument, options);
      }
export function useGetCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyQuery, GetCompanyQueryVariables>(GetCompanyDocument, options);
        }
export type GetCompanyQueryHookResult = ReturnType<typeof useGetCompanyQuery>;
export type GetCompanyLazyQueryHookResult = ReturnType<typeof useGetCompanyLazyQuery>;
export type GetCompanyQueryResult = Apollo.QueryResult<GetCompanyQuery, GetCompanyQueryVariables>;
export const GetCompanyContactsDocument = gql`
    query getCompanyContacts($id: ID!) {
  getCompanyContacts(id: $id) {
    SMSNotifications
    SMSNotificationsReadOnly
    email
    firstName
    id
    lastName
    phone
    primary
    role
    title
  }
}
    `;

/**
 * __useGetCompanyContactsQuery__
 *
 * To run a query within a React component, call `useGetCompanyContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyContactsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCompanyContactsQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyContactsQuery, GetCompanyContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyContactsQuery, GetCompanyContactsQueryVariables>(GetCompanyContactsDocument, options);
      }
export function useGetCompanyContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyContactsQuery, GetCompanyContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyContactsQuery, GetCompanyContactsQueryVariables>(GetCompanyContactsDocument, options);
        }
export type GetCompanyContactsQueryHookResult = ReturnType<typeof useGetCompanyContactsQuery>;
export type GetCompanyContactsLazyQueryHookResult = ReturnType<typeof useGetCompanyContactsLazyQuery>;
export type GetCompanyContactsQueryResult = Apollo.QueryResult<GetCompanyContactsQuery, GetCompanyContactsQueryVariables>;
export const GetCrewDocument = gql`
    query getCrew($id: ID!) {
  getCrew(id: $id) {
    color
    displayName
    employees {
      firstName
      id
      lastName
      name
      organizationId
      rate
      user {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          proposalDefaults {
            autoSave
            color
            id
            layout
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        status
      }
      userId
    }
    foremanUser {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        email
        emailTemplate
        failingPayment
        id
        logo
        name
        onTrial
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      status
    }
    id
    name
    organization {
      email
      emailTemplate
      failingPayment
      id
      logo
      name
      onTrial
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    rate
  }
}
    `;

/**
 * __useGetCrewQuery__
 *
 * To run a query within a React component, call `useGetCrewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCrewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCrewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCrewQuery(baseOptions: Apollo.QueryHookOptions<GetCrewQuery, GetCrewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCrewQuery, GetCrewQueryVariables>(GetCrewDocument, options);
      }
export function useGetCrewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCrewQuery, GetCrewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCrewQuery, GetCrewQueryVariables>(GetCrewDocument, options);
        }
export type GetCrewQueryHookResult = ReturnType<typeof useGetCrewQuery>;
export type GetCrewLazyQueryHookResult = ReturnType<typeof useGetCrewLazyQuery>;
export type GetCrewQueryResult = Apollo.QueryResult<GetCrewQuery, GetCrewQueryVariables>;
export const GetCrewsDocument = gql`
    query getCrews($first: Int!, $page: Int, $search: String, $sort: SortDirection) {
  getCrews(first: $first, page: $page, search: $search, sort: $sort) {
    data {
      color
      displayName
      employees {
        firstName
        id
        lastName
        name
        organizationId
        rate
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
      }
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          proposalDefaults {
            autoSave
            color
            id
            layout
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        status
      }
      id
      name
      organization {
        email
        emailTemplate
        failingPayment
        id
        logo
        name
        onTrial
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      rate
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useGetCrewsQuery__
 *
 * To run a query within a React component, call `useGetCrewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCrewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCrewsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetCrewsQuery(baseOptions: Apollo.QueryHookOptions<GetCrewsQuery, GetCrewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCrewsQuery, GetCrewsQueryVariables>(GetCrewsDocument, options);
      }
export function useGetCrewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCrewsQuery, GetCrewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCrewsQuery, GetCrewsQueryVariables>(GetCrewsDocument, options);
        }
export type GetCrewsQueryHookResult = ReturnType<typeof useGetCrewsQuery>;
export type GetCrewsLazyQueryHookResult = ReturnType<typeof useGetCrewsLazyQuery>;
export type GetCrewsQueryResult = Apollo.QueryResult<GetCrewsQuery, GetCrewsQueryVariables>;
export const GetCurrentMonthStatsDocument = gql`
    query getCurrentMonthStats {
  getCurrentMonthStats {
    closedBids
    closedRate
    closedRevenue
    sentBids
  }
}
    `;

/**
 * __useGetCurrentMonthStatsQuery__
 *
 * To run a query within a React component, call `useGetCurrentMonthStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentMonthStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentMonthStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentMonthStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentMonthStatsQuery, GetCurrentMonthStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentMonthStatsQuery, GetCurrentMonthStatsQueryVariables>(GetCurrentMonthStatsDocument, options);
      }
export function useGetCurrentMonthStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentMonthStatsQuery, GetCurrentMonthStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentMonthStatsQuery, GetCurrentMonthStatsQueryVariables>(GetCurrentMonthStatsDocument, options);
        }
export type GetCurrentMonthStatsQueryHookResult = ReturnType<typeof useGetCurrentMonthStatsQuery>;
export type GetCurrentMonthStatsLazyQueryHookResult = ReturnType<typeof useGetCurrentMonthStatsLazyQuery>;
export type GetCurrentMonthStatsQueryResult = Apollo.QueryResult<GetCurrentMonthStatsQuery, GetCurrentMonthStatsQueryVariables>;
export const GetCustomEventDocument = gql`
    query getCustomEvent($id: ID!) {
  getCustomEvent(id: $id) {
    color
    crew {
      color
      displayName
      employees {
        firstName
        id
        lastName
        name
        organizationId
        rate
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
      }
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          proposalDefaults {
            autoSave
            color
            id
            layout
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        status
      }
      id
      name
      organization {
        email
        emailTemplate
        failingPayment
        id
        logo
        name
        onTrial
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      rate
    }
    customEventBlocks {
      blockLength
      customEvent {
        color
        crew {
          color
          displayName
          id
          name
          rate
        }
        customEventBlocks {
          blockLength
          endsAt
          id
          scheduledAt
        }
        customEventsToUsers {
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
        }
        endsAt
        id
        name
        notes
        startsAt
      }
      endsAt
      id
      scheduledAt
    }
    endsAt
    id
    name
    notes
    startsAt
  }
}
    `;

/**
 * __useGetCustomEventQuery__
 *
 * To run a query within a React component, call `useGetCustomEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomEventQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCustomEventQuery(baseOptions: Apollo.QueryHookOptions<GetCustomEventQuery, GetCustomEventQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomEventQuery, GetCustomEventQueryVariables>(GetCustomEventDocument, options);
      }
export function useGetCustomEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomEventQuery, GetCustomEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomEventQuery, GetCustomEventQueryVariables>(GetCustomEventDocument, options);
        }
export type GetCustomEventQueryHookResult = ReturnType<typeof useGetCustomEventQuery>;
export type GetCustomEventLazyQueryHookResult = ReturnType<typeof useGetCustomEventLazyQuery>;
export type GetCustomEventQueryResult = Apollo.QueryResult<GetCustomEventQuery, GetCustomEventQueryVariables>;
export const GetCustomEventBlocksDocument = gql`
    query getCustomEventBlocks($crewId: ID, $customEventIds: [ID], $dateFrom: DateTime, $dateUntil: DateTime) {
  getCustomEventBlocks(
    crewId: $crewId
    customEventIds: $customEventIds
    dateFrom: $dateFrom
    dateUntil: $dateUntil
  ) {
    blockLength
    customEvent {
      color
      crew {
        color
        displayName
        employees {
          firstName
          id
          lastName
          name
          organizationId
          rate
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
        }
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        id
        name
        organization {
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          proposalDefaults {
            autoSave
            color
            id
            layout
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        rate
      }
      customEventBlocks {
        blockLength
        customEvent {
          color
          endsAt
          id
          name
          notes
          startsAt
        }
        endsAt
        id
        scheduledAt
      }
      endsAt
      id
      name
      notes
      startsAt
    }
    endsAt
    id
    scheduledAt
  }
}
    `;

/**
 * __useGetCustomEventBlocksQuery__
 *
 * To run a query within a React component, call `useGetCustomEventBlocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomEventBlocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomEventBlocksQuery({
 *   variables: {
 *      crewId: // value for 'crewId'
 *      customEventIds: // value for 'customEventIds'
 *      dateFrom: // value for 'dateFrom'
 *      dateUntil: // value for 'dateUntil'
 *   },
 * });
 */
export function useGetCustomEventBlocksQuery(baseOptions?: Apollo.QueryHookOptions<GetCustomEventBlocksQuery, GetCustomEventBlocksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomEventBlocksQuery, GetCustomEventBlocksQueryVariables>(GetCustomEventBlocksDocument, options);
      }
export function useGetCustomEventBlocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomEventBlocksQuery, GetCustomEventBlocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomEventBlocksQuery, GetCustomEventBlocksQueryVariables>(GetCustomEventBlocksDocument, options);
        }
export type GetCustomEventBlocksQueryHookResult = ReturnType<typeof useGetCustomEventBlocksQuery>;
export type GetCustomEventBlocksLazyQueryHookResult = ReturnType<typeof useGetCustomEventBlocksLazyQuery>;
export type GetCustomEventBlocksQueryResult = Apollo.QueryResult<GetCustomEventBlocksQuery, GetCustomEventBlocksQueryVariables>;
export const GetDashboardMapDataDocument = gql`
    query getDashboardMapData {
  getDashboardMapData {
    actualCostAdditional
    actualCostDirect
    actualCostEquipment
    actualCostIndirect
    actualCostLabour
    actualCostMaterial
    actualCostOverhead
    actualCostTotal
    actualCostTransferTruck
    actualGrossMargin
    actualGrossMarginPercentage
    actualNetMargin
    actualNetMarginPercentage
    actualOperatingMargin
    actualOperatingMarginPercentage
    actualOverallTotal
    actualProfit
    actualProfitPercentage
    address {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    billingStatus
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        organization {
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          proposalDefaults {
            autoSave
            color
            id
            layout
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        events {
          action
          createdAt
        }
        externalId
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterTaxes
        profit
        profitPercentage
        projectFilesFolderId
        proposalNotes
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          profit
          profitPercentage
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          roundTripTravelTimeHours
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          status
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
        uuid
        version
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    datePushedToQuickbooks
    endsAt
    externalId
    foremanUser {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        email
        emailTemplate
        failingPayment
        id
        logo
        name
        onTrial
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      status
    }
    id
    jobPhases {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualEmployeeHours
      actualGrossMargin
      actualGrossMarginPercentage
      actualMaterialNeeded
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      address
      applicableStatuses
      costItems {
        additionalCosts {
          additionalCostId
          cost
          costTotal
          feeAmount
          feeType
          id
          jobPhaseCostItem {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          name
        }
        costAdditional
        costEquipment
        costLabour
        costMaterial
        costTransferTruck
        date
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        equipmentPieces {
          equipmentPieceId
          id
          name
          quantity
          rate
          timeOnjob
          timeTravel
        }
        id
        jobPhase {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualEmployeeHours
          actualGrossMargin
          actualGrossMarginPercentage
          actualMaterialNeeded
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address
          applicableStatuses
          costItems {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          crew {
            color
            displayName
            id
            name
            rate
          }
          crewId
          defaultAdditionalCosts {
            cost
            feeAmount
            feeType
            id
            name
          }
          defaultEmployees {
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          defaultEquipmentPieces {
            chargeType
            fuelSurcharge
            id
            name
            rate
            usePercentage
          }
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          endsAt
          externalId
          files {
            createdAt
            filename
            id
            thumbnail
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            endsAt
            externalId
            id
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
          }
          jobDuration
          jobPhasePlant {
            id
            name
            type
          }
          jobSize
          notes
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          organizationProductType {
            id
            indirectPercentage
            markupPercentage
            name
            overheadPercentage
            type
          }
          organizationProductTypeName
          productName
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          proposalProduct {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          proposalStage {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedEmployeeHours
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedMaterialNeeded
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          scheduleBlocks {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          scheduledBlockForDate {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          startsAt
          status
          travelTimeEstimate
          users {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          usersColor
          workOrderCrews {
            crewId
            id
            name
          }
          workOrderEquipmentPieces {
            equipmentPieceId
            id
            name
          }
          workOrderTransferTrucks {
            id
            name
            quantity
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
        }
        material {
          costMaterial
          id
          jobPhaseCostItem {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          materialNeeded
          name
          organizationProductTypeName
          type
        }
        plantId
        plantProductId
        transferTrucks {
          hours
          id
          name
          plantTransferTruckId
          rateHourly
          rateTon
          tonnage
          transferTruckId
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          status
        }
      }
      crew {
        color
        displayName
        employees {
          firstName
          id
          lastName
          name
          organizationId
          rate
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
        }
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          status
        }
        id
        name
        organization {
          email
          emailTemplate
          failingPayment
          id
          logo
          name
          onTrial
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        rate
      }
      crewId
      defaultAdditionalCosts {
        cost
        feeAmount
        feeType
        id
        name
      }
      defaultEmployees {
        firstName
        id
        lastName
        name
        organizationId
        rate
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
      }
      defaultEquipmentPieces {
        chargeType
        fuelSurcharge
        id
        name
        rate
        usePercentage
      }
      employees {
        employeeId
        id
        name
        rate
        timeOnjob
        timeTravel
      }
      endsAt
      externalId
      files {
        createdAt
        filename
        id
        thumbnail
      }
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        status
      }
      id
      job {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualGrossMargin
        actualGrossMarginPercentage
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        address {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        billingStatus
        changeOrders {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          userId
          uuid
          version
          wonAt
        }
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          email
          id
          jobsCount
          logo
          name
          notes
          phone
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        datePushedToQuickbooks
        endsAt
        externalId
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          status
        }
        id
        jobPhases {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualEmployeeHours
          actualGrossMargin
          actualGrossMarginPercentage
          actualMaterialNeeded
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address
          applicableStatuses
          crewId
          endsAt
          externalId
          id
          jobDuration
          jobPhasePlant {
            id
            name
            type
          }
          jobSize
          notes
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          organizationProductType {
            id
            indirectPercentage
            markupPercentage
            name
            overheadPercentage
            type
          }
          organizationProductTypeName
          productName
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          proposalProduct {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          proposalStage {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedEmployeeHours
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedMaterialNeeded
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          scheduleBlocks {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          scheduledBlockForDate {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          startsAt
          status
          travelTimeEstimate
          users {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          usersColor
          workOrderCrews {
            crewId
            id
            name
          }
          workOrderEquipmentPieces {
            equipmentPieceId
            id
            name
          }
          workOrderTransferTrucks {
            id
            name
            quantity
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
        }
        mayShowTaxNotification
        notes
        projectFilesFolderId
        proposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        proposalId
        proposalStage {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          profit
          profitPercentage
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          roundTripTravelTimeHours
        }
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        shouldPushTaxesToQuickbooks
        startsAt
        status
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
      }
      jobDuration
      jobSize
      notes
      organizationProductTypeName
      productName
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedEmployeeHours
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedMaterialNeeded
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      startsAt
      status
      travelTimeEstimate
      usersColor
    }
    mayShowTaxNotification
    notes
    projectFilesFolderId
    proposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    proposalId
    proposalStage {
      addressOverride
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      profit
      profitPercentage
      roundTripTravelTimeHours
    }
    proposedCostAdditional
    proposedCostDirect
    proposedCostEquipment
    proposedCostIndirect
    proposedCostLabour
    proposedCostMaterial
    proposedCostOverhead
    proposedCostTotal
    proposedCostTransferTruck
    proposedGrossMargin
    proposedGrossMarginPercentage
    proposedNetMargin
    proposedNetMarginPercentage
    proposedOperatingMargin
    proposedOperatingMarginPercentage
    proposedOverallTotal
    proposedProfit
    proposedProfitPercentage
    shouldPushTaxesToQuickbooks
    startsAt
    status
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
    userId
  }
}
    `;

/**
 * __useGetDashboardMapDataQuery__
 *
 * To run a query within a React component, call `useGetDashboardMapDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardMapDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardMapDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDashboardMapDataQuery(baseOptions?: Apollo.QueryHookOptions<GetDashboardMapDataQuery, GetDashboardMapDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDashboardMapDataQuery, GetDashboardMapDataQueryVariables>(GetDashboardMapDataDocument, options);
      }
export function useGetDashboardMapDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDashboardMapDataQuery, GetDashboardMapDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDashboardMapDataQuery, GetDashboardMapDataQueryVariables>(GetDashboardMapDataDocument, options);
        }
export type GetDashboardMapDataQueryHookResult = ReturnType<typeof useGetDashboardMapDataQuery>;
export type GetDashboardMapDataLazyQueryHookResult = ReturnType<typeof useGetDashboardMapDataLazyQuery>;
export type GetDashboardMapDataQueryResult = Apollo.QueryResult<GetDashboardMapDataQuery, GetDashboardMapDataQueryVariables>;
export const GetEmployeeDocument = gql`
    query getEmployee($id: ID!) {
  getEmployee(id: $id) {
    firstName
    id
    lastName
    name
    organizationId
    rate
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        phone
        proposalDefaults {
          autoSave
          color
          id
          layout
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      status
    }
    userId
  }
}
    `;

/**
 * __useGetEmployeeQuery__
 *
 * To run a query within a React component, call `useGetEmployeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEmployeeQuery(baseOptions: Apollo.QueryHookOptions<GetEmployeeQuery, GetEmployeeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeeQuery, GetEmployeeQueryVariables>(GetEmployeeDocument, options);
      }
export function useGetEmployeeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeeQuery, GetEmployeeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeeQuery, GetEmployeeQueryVariables>(GetEmployeeDocument, options);
        }
export type GetEmployeeQueryHookResult = ReturnType<typeof useGetEmployeeQuery>;
export type GetEmployeeLazyQueryHookResult = ReturnType<typeof useGetEmployeeLazyQuery>;
export type GetEmployeeQueryResult = Apollo.QueryResult<GetEmployeeQuery, GetEmployeeQueryVariables>;
export const GetEmployeesDocument = gql`
    query getEmployees($first: Int!, $page: Int, $search: String, $sort: SortDirection) {
  getEmployees(first: $first, page: $page, search: $search, sort: $sort) {
    data {
      firstName
      id
      lastName
      name
      organizationId
      rate
      user {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          proposalDefaults {
            autoSave
            color
            id
            layout
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        status
      }
      userId
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useGetEmployeesQuery__
 *
 * To run a query within a React component, call `useGetEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetEmployeesQuery(baseOptions: Apollo.QueryHookOptions<GetEmployeesQuery, GetEmployeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeesQuery, GetEmployeesQueryVariables>(GetEmployeesDocument, options);
      }
export function useGetEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeesQuery, GetEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeesQuery, GetEmployeesQueryVariables>(GetEmployeesDocument, options);
        }
export type GetEmployeesQueryHookResult = ReturnType<typeof useGetEmployeesQuery>;
export type GetEmployeesLazyQueryHookResult = ReturnType<typeof useGetEmployeesLazyQuery>;
export type GetEmployeesQueryResult = Apollo.QueryResult<GetEmployeesQuery, GetEmployeesQueryVariables>;
export const GetEquipmentPieceDocument = gql`
    query getEquipmentPiece($id: ID!) {
  getEquipmentPiece(id: $id) {
    chargeType
    fuelSurcharge
    id
    name
    rate
    usePercentage
  }
}
    `;

/**
 * __useGetEquipmentPieceQuery__
 *
 * To run a query within a React component, call `useGetEquipmentPieceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEquipmentPieceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEquipmentPieceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEquipmentPieceQuery(baseOptions: Apollo.QueryHookOptions<GetEquipmentPieceQuery, GetEquipmentPieceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEquipmentPieceQuery, GetEquipmentPieceQueryVariables>(GetEquipmentPieceDocument, options);
      }
export function useGetEquipmentPieceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEquipmentPieceQuery, GetEquipmentPieceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEquipmentPieceQuery, GetEquipmentPieceQueryVariables>(GetEquipmentPieceDocument, options);
        }
export type GetEquipmentPieceQueryHookResult = ReturnType<typeof useGetEquipmentPieceQuery>;
export type GetEquipmentPieceLazyQueryHookResult = ReturnType<typeof useGetEquipmentPieceLazyQuery>;
export type GetEquipmentPieceQueryResult = Apollo.QueryResult<GetEquipmentPieceQuery, GetEquipmentPieceQueryVariables>;
export const GetEquipmentPiecesDocument = gql`
    query getEquipmentPieces($first: Int!, $page: Int, $search: String, $sort: SortDirection) {
  getEquipmentPieces(first: $first, page: $page, search: $search, sort: $sort) {
    data {
      chargeType
      fuelSurcharge
      id
      name
      rate
      usePercentage
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useGetEquipmentPiecesQuery__
 *
 * To run a query within a React component, call `useGetEquipmentPiecesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEquipmentPiecesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEquipmentPiecesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetEquipmentPiecesQuery(baseOptions: Apollo.QueryHookOptions<GetEquipmentPiecesQuery, GetEquipmentPiecesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEquipmentPiecesQuery, GetEquipmentPiecesQueryVariables>(GetEquipmentPiecesDocument, options);
      }
export function useGetEquipmentPiecesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEquipmentPiecesQuery, GetEquipmentPiecesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEquipmentPiecesQuery, GetEquipmentPiecesQueryVariables>(GetEquipmentPiecesDocument, options);
        }
export type GetEquipmentPiecesQueryHookResult = ReturnType<typeof useGetEquipmentPiecesQuery>;
export type GetEquipmentPiecesLazyQueryHookResult = ReturnType<typeof useGetEquipmentPiecesLazyQuery>;
export type GetEquipmentPiecesQueryResult = Apollo.QueryResult<GetEquipmentPiecesQuery, GetEquipmentPiecesQueryVariables>;
export const GetJobDocument = gql`
    query getJob($id: ID!) {
  getJob(id: $id) {
    actualCostAdditional
    actualCostDirect
    actualCostEquipment
    actualCostIndirect
    actualCostLabour
    actualCostMaterial
    actualCostOverhead
    actualCostTotal
    actualCostTransferTruck
    actualGrossMargin
    actualGrossMarginPercentage
    actualNetMargin
    actualNetMarginPercentage
    actualOperatingMargin
    actualOperatingMarginPercentage
    actualOverallTotal
    actualProfit
    actualProfitPercentage
    address {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    billingStatus
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        organization {
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          proposalDefaults {
            autoSave
            color
            id
            layout
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        events {
          action
          createdAt
        }
        externalId
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterTaxes
        profit
        profitPercentage
        projectFilesFolderId
        proposalNotes
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          profit
          profitPercentage
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          roundTripTravelTimeHours
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          status
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
        uuid
        version
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    datePushedToQuickbooks
    endsAt
    externalId
    foremanUser {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        email
        emailTemplate
        failingPayment
        id
        logo
        name
        onTrial
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      status
    }
    id
    jobPhases {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualEmployeeHours
      actualGrossMargin
      actualGrossMarginPercentage
      actualMaterialNeeded
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      address
      applicableStatuses
      costItems {
        additionalCosts {
          additionalCostId
          cost
          costTotal
          feeAmount
          feeType
          id
          jobPhaseCostItem {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          name
        }
        costAdditional
        costEquipment
        costLabour
        costMaterial
        costTransferTruck
        date
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        equipmentPieces {
          equipmentPieceId
          id
          name
          quantity
          rate
          timeOnjob
          timeTravel
        }
        id
        jobPhase {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualEmployeeHours
          actualGrossMargin
          actualGrossMarginPercentage
          actualMaterialNeeded
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address
          applicableStatuses
          costItems {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          crew {
            color
            displayName
            id
            name
            rate
          }
          crewId
          defaultAdditionalCosts {
            cost
            feeAmount
            feeType
            id
            name
          }
          defaultEmployees {
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          defaultEquipmentPieces {
            chargeType
            fuelSurcharge
            id
            name
            rate
            usePercentage
          }
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          endsAt
          externalId
          files {
            createdAt
            filename
            id
            thumbnail
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            endsAt
            externalId
            id
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
          }
          jobDuration
          jobPhasePlant {
            id
            name
            type
          }
          jobSize
          notes
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          organizationProductType {
            id
            indirectPercentage
            markupPercentage
            name
            overheadPercentage
            type
          }
          organizationProductTypeName
          productName
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          proposalProduct {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          proposalStage {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedEmployeeHours
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedMaterialNeeded
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          scheduleBlocks {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          scheduledBlockForDate {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          startsAt
          status
          travelTimeEstimate
          users {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          usersColor
          workOrderCrews {
            crewId
            id
            name
          }
          workOrderEquipmentPieces {
            equipmentPieceId
            id
            name
          }
          workOrderTransferTrucks {
            id
            name
            quantity
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
        }
        material {
          costMaterial
          id
          jobPhaseCostItem {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          materialNeeded
          name
          organizationProductTypeName
          type
        }
        plantId
        plantProductId
        transferTrucks {
          hours
          id
          name
          plantTransferTruckId
          rateHourly
          rateTon
          tonnage
          transferTruckId
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          status
        }
      }
      crew {
        color
        displayName
        employees {
          firstName
          id
          lastName
          name
          organizationId
          rate
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
        }
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          status
        }
        id
        name
        organization {
          email
          emailTemplate
          failingPayment
          id
          logo
          name
          onTrial
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        rate
      }
      crewId
      defaultAdditionalCosts {
        cost
        feeAmount
        feeType
        id
        name
      }
      defaultEmployees {
        firstName
        id
        lastName
        name
        organizationId
        rate
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
      }
      defaultEquipmentPieces {
        chargeType
        fuelSurcharge
        id
        name
        rate
        usePercentage
      }
      employees {
        employeeId
        id
        name
        rate
        timeOnjob
        timeTravel
      }
      endsAt
      externalId
      files {
        createdAt
        filename
        id
        thumbnail
      }
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        status
      }
      id
      job {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualGrossMargin
        actualGrossMarginPercentage
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        address {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        billingStatus
        changeOrders {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          userId
          uuid
          version
          wonAt
        }
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          email
          id
          jobsCount
          logo
          name
          notes
          phone
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        datePushedToQuickbooks
        endsAt
        externalId
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          status
        }
        id
        jobPhases {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualEmployeeHours
          actualGrossMargin
          actualGrossMarginPercentage
          actualMaterialNeeded
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address
          applicableStatuses
          crewId
          endsAt
          externalId
          id
          jobDuration
          jobPhasePlant {
            id
            name
            type
          }
          jobSize
          notes
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          organizationProductType {
            id
            indirectPercentage
            markupPercentage
            name
            overheadPercentage
            type
          }
          organizationProductTypeName
          productName
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          proposalProduct {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          proposalStage {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedEmployeeHours
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedMaterialNeeded
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          scheduleBlocks {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          scheduledBlockForDate {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          startsAt
          status
          travelTimeEstimate
          users {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          usersColor
          workOrderCrews {
            crewId
            id
            name
          }
          workOrderEquipmentPieces {
            equipmentPieceId
            id
            name
          }
          workOrderTransferTrucks {
            id
            name
            quantity
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
        }
        mayShowTaxNotification
        notes
        projectFilesFolderId
        proposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        proposalId
        proposalStage {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          profit
          profitPercentage
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          roundTripTravelTimeHours
        }
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        shouldPushTaxesToQuickbooks
        startsAt
        status
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
      }
      jobDuration
      jobSize
      notes
      organizationProductTypeName
      productName
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedEmployeeHours
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedMaterialNeeded
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      startsAt
      status
      travelTimeEstimate
      usersColor
    }
    mayShowTaxNotification
    notes
    projectFilesFolderId
    proposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    proposalId
    proposalStage {
      addressOverride
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      profit
      profitPercentage
      roundTripTravelTimeHours
    }
    proposedCostAdditional
    proposedCostDirect
    proposedCostEquipment
    proposedCostIndirect
    proposedCostLabour
    proposedCostMaterial
    proposedCostOverhead
    proposedCostTotal
    proposedCostTransferTruck
    proposedGrossMargin
    proposedGrossMarginPercentage
    proposedNetMargin
    proposedNetMarginPercentage
    proposedOperatingMargin
    proposedOperatingMarginPercentage
    proposedOverallTotal
    proposedProfit
    proposedProfitPercentage
    shouldPushTaxesToQuickbooks
    startsAt
    status
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
    userId
  }
}
    `;

/**
 * __useGetJobQuery__
 *
 * To run a query within a React component, call `useGetJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetJobQuery(baseOptions: Apollo.QueryHookOptions<GetJobQuery, GetJobQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobQuery, GetJobQueryVariables>(GetJobDocument, options);
      }
export function useGetJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobQuery, GetJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobQuery, GetJobQueryVariables>(GetJobDocument, options);
        }
export type GetJobQueryHookResult = ReturnType<typeof useGetJobQuery>;
export type GetJobLazyQueryHookResult = ReturnType<typeof useGetJobLazyQuery>;
export type GetJobQueryResult = Apollo.QueryResult<GetJobQuery, GetJobQueryVariables>;
export const GetJobBillingStatusesDocument = gql`
    query getJobBillingStatuses {
  getJobBillingStatuses {
    statuses
  }
}
    `;

/**
 * __useGetJobBillingStatusesQuery__
 *
 * To run a query within a React component, call `useGetJobBillingStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobBillingStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobBillingStatusesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetJobBillingStatusesQuery(baseOptions?: Apollo.QueryHookOptions<GetJobBillingStatusesQuery, GetJobBillingStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobBillingStatusesQuery, GetJobBillingStatusesQueryVariables>(GetJobBillingStatusesDocument, options);
      }
export function useGetJobBillingStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobBillingStatusesQuery, GetJobBillingStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobBillingStatusesQuery, GetJobBillingStatusesQueryVariables>(GetJobBillingStatusesDocument, options);
        }
export type GetJobBillingStatusesQueryHookResult = ReturnType<typeof useGetJobBillingStatusesQuery>;
export type GetJobBillingStatusesLazyQueryHookResult = ReturnType<typeof useGetJobBillingStatusesLazyQuery>;
export type GetJobBillingStatusesQueryResult = Apollo.QueryResult<GetJobBillingStatusesQuery, GetJobBillingStatusesQueryVariables>;
export const GetJobPhaseDocument = gql`
    query getJobPhase($id: ID!) {
  getJobPhase(id: $id) {
    actualCostAdditional
    actualCostDirect
    actualCostEquipment
    actualCostIndirect
    actualCostLabour
    actualCostMaterial
    actualCostOverhead
    actualCostTotal
    actualCostTransferTruck
    actualEmployeeHours
    actualGrossMargin
    actualGrossMarginPercentage
    actualMaterialNeeded
    actualNetMargin
    actualNetMarginPercentage
    actualOperatingMargin
    actualOperatingMarginPercentage
    actualOverallTotal
    actualProfit
    actualProfitPercentage
    address
    applicableStatuses
    costItems {
      additionalCosts {
        additionalCostId
        cost
        costTotal
        feeAmount
        feeType
        id
        jobPhaseCostItem {
          additionalCosts {
            additionalCostId
            cost
            costTotal
            feeAmount
            feeType
            id
            name
          }
          costAdditional
          costEquipment
          costLabour
          costMaterial
          costTransferTruck
          date
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          equipmentPieces {
            equipmentPieceId
            id
            name
            quantity
            rate
            timeOnjob
            timeTravel
          }
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            address
            applicableStatuses
            crewId
            endsAt
            externalId
            id
            jobDuration
            jobSize
            notes
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          material {
            costMaterial
            id
            materialNeeded
            name
            organizationProductTypeName
            type
          }
          plantId
          plantProductId
          transferTrucks {
            hours
            id
            name
            plantTransferTruckId
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
        }
        name
      }
      costAdditional
      costEquipment
      costLabour
      costMaterial
      costTransferTruck
      date
      employees {
        employeeId
        id
        name
        rate
        timeOnjob
        timeTravel
      }
      equipmentPieces {
        equipmentPieceId
        id
        name
        quantity
        rate
        timeOnjob
        timeTravel
      }
      id
      jobPhase {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualEmployeeHours
        actualGrossMargin
        actualGrossMarginPercentage
        actualMaterialNeeded
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        address
        applicableStatuses
        costItems {
          costAdditional
          costEquipment
          costLabour
          costMaterial
          costTransferTruck
          date
          id
          material {
            costMaterial
            id
            materialNeeded
            name
            organizationProductTypeName
            type
          }
          plantId
          plantProductId
          transferTrucks {
            hours
            id
            name
            plantTransferTruckId
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
        }
        crew {
          color
          displayName
          employees {
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          id
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          rate
        }
        crewId
        defaultAdditionalCosts {
          cost
          feeAmount
          feeType
          id
          name
        }
        defaultEmployees {
          firstName
          id
          lastName
          name
          organizationId
          rate
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
        }
        defaultEquipmentPieces {
          chargeType
          fuelSurcharge
          id
          name
          rate
          usePercentage
        }
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        endsAt
        externalId
        files {
          createdAt
          filename
          id
          thumbnail
        }
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        id
        job {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualGrossMargin
          actualGrossMarginPercentage
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          billingStatus
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          datePushedToQuickbooks
          endsAt
          externalId
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          id
          jobPhases {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            address
            applicableStatuses
            crewId
            endsAt
            externalId
            id
            jobDuration
            jobSize
            notes
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          mayShowTaxNotification
          notes
          projectFilesFolderId
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          proposalId
          proposalStage {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          shouldPushTaxesToQuickbooks
          startsAt
          status
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
        }
        jobDuration
        jobPhasePlant {
          id
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            rate
            type
          }
          type
        }
        jobSize
        notes
        organization {
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          proposalDefaults {
            autoSave
            color
            id
            layout
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        organizationProductType {
          id
          indirectPercentage
          markupPercentage
          name
          overheadPercentage
          type
        }
        organizationProductTypeName
        productName
        proposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        proposalProduct {
          additionalCosts {
            additionalCostId
            cost
            costOverride
            costTotal
            feeAmount
            feeAmountOverride
            feeType
            id
            name
            quantity
            quantityOverride
            showOnProposal
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          costTransferTruck
          crews {
            cost
            crewId
            id
            name
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
          }
          equipmentPieces {
            chargeType
            cost
            equipmentPieceId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
            usePercentage
          }
          externalProductName
          files {
            createdAt
            filename
            id
            thumbnail
            type
          }
          grossMargin
          grossMarginPercentage
          id
          isOptional
          jobDuration
          jobDurationDaysOverride
          jobDurationOverride
          jobSize
          mapData
          mapImage
          mapImageDirty
          material {
            areaCoverage
            attributes {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            attributesOverride {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            costMaterial
            costMaterialOverride
            costMinimumProduct
            costMinimumProposal
            dailyUnitsComplete
            dailyUnitsCompleteOverride
            externalProductName
            id
            indirectPercentage
            indirectPercentageOverride
            labourCostType
            markupPercentage
            markupPercentageOverride
            materialNeeded
            materialNeededOverride
            measurementJob
            measurementMaterial
            name
            organizationProductTypeName
            overheadPercentage
            overheadPercentageOverride
            productId
            productionRateType
            proposalId
            proposalProductId
            proposalStageId
            statementOfWork
            statementOfWorkOverride
            subcontracted
            tonConversionFactor
            tonConversionFactorOverride
            type
            unitPrice
            unitPriceOverride
            unitPriceProduct
          }
          measurementJob
          measurementMaterial
          netMargin
          netMarginPercentage
          notes
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalOverride
          plantProduct {
            id
            plantProductId
            rate
            rateOverride
            type
          }
          productName
          profit
          profitPercentage
          profitPercentageOverride
          roundTripTravelTimeHours
          statementOfWork
          subcontractorCost
          subcontractorName
          subcontractorProposalId
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTime
          transferTruckRoundTripTimeOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            quantity
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
        }
        proposalStage {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          profit
          profitPercentage
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          roundTripTravelTimeHours
        }
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedEmployeeHours
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedMaterialNeeded
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        scheduleBlocks {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            endsAt
            externalId
            id
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            address
            applicableStatuses
            crewId
            endsAt
            externalId
            id
            jobDuration
            jobSize
            notes
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        scheduledBlockForDate {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            endsAt
            externalId
            id
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            address
            applicableStatuses
            crewId
            endsAt
            externalId
            id
            jobDuration
            jobSize
            notes
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        startsAt
        status
        travelTimeEstimate
        users {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        usersColor
        workOrderCrews {
          crewId
          id
          name
        }
        workOrderEquipmentPieces {
          equipmentPieceId
          id
          name
        }
        workOrderTransferTrucks {
          id
          name
          quantity
          rateHourly
          rateTon
          tonnage
          transferTruckId
        }
      }
      plantId
      plantProductId
    }
    crew {
      color
      displayName
      id
      name
      rate
    }
    crewId
    defaultAdditionalCosts {
      cost
      feeAmount
      feeType
      id
      name
    }
    defaultEmployees {
      firstName
      id
      lastName
      name
      organizationId
      rate
      userId
    }
    defaultEquipmentPieces {
      chargeType
      fuelSurcharge
      id
      name
      rate
      usePercentage
    }
    employees {
      employeeId
      id
      name
      rate
      timeOnjob
      timeTravel
    }
    endsAt
    externalId
    files {
      createdAt
      filename
      id
      thumbnail
    }
    foremanUser {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
    id
    job {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualGrossMargin
      actualGrossMarginPercentage
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      billingStatus
      datePushedToQuickbooks
      endsAt
      externalId
      id
      mayShowTaxNotification
      notes
      projectFilesFolderId
      proposalId
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      shouldPushTaxesToQuickbooks
      startsAt
      status
      userId
    }
    jobDuration
    jobPhasePlant {
      id
      name
      type
    }
    jobSize
    notes
    organization {
      email
      emailTemplate
      failingPayment
      id
      logo
      name
      onTrial
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    organizationProductType {
      id
      indirectPercentage
      markupPercentage
      name
      overheadPercentage
      type
    }
    organizationProductTypeName
    productName
    proposal {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    proposalProduct {
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      costTransferTruck
      externalProductName
      grossMargin
      grossMarginPercentage
      id
      isOptional
      jobDuration
      jobDurationDaysOverride
      jobDurationOverride
      jobSize
      mapData
      mapImage
      mapImageDirty
      measurementJob
      measurementMaterial
      netMargin
      netMarginPercentage
      notes
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      overallTotalOverride
      productName
      profit
      profitPercentage
      profitPercentageOverride
      roundTripTravelTimeHours
      statementOfWork
      subcontractorCost
      subcontractorName
      subcontractorProposalId
      transferTruckLoadTimeBuffer
      transferTruckRoundTripTime
      transferTruckRoundTripTimeOverride
      transferTruckUnloadTimeBuffer
    }
    proposalStage {
      addressOverride
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      profit
      profitPercentage
      roundTripTravelTimeHours
    }
    proposedCostAdditional
    proposedCostDirect
    proposedCostEquipment
    proposedCostIndirect
    proposedCostLabour
    proposedCostMaterial
    proposedCostOverhead
    proposedCostTotal
    proposedCostTransferTruck
    proposedEmployeeHours
    proposedGrossMargin
    proposedGrossMarginPercentage
    proposedMaterialNeeded
    proposedNetMargin
    proposedNetMarginPercentage
    proposedOperatingMargin
    proposedOperatingMarginPercentage
    proposedOverallTotal
    proposedProfit
    proposedProfitPercentage
    scheduleBlocks {
      blockLength
      endsAt
      estimatedMaterial
      estimatedMaterialOverride
      id
      scheduledAt
      showTravelFrom
      showTravelTo
      travelTime
    }
    scheduledBlockForDate {
      blockLength
      endsAt
      estimatedMaterial
      estimatedMaterialOverride
      id
      scheduledAt
      showTravelFrom
      showTravelTo
      travelTime
    }
    startsAt
    status
    travelTimeEstimate
    users {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
    usersColor
    workOrderCrews {
      crewId
      id
      name
    }
    workOrderEquipmentPieces {
      equipmentPieceId
      id
      name
    }
    workOrderTransferTrucks {
      id
      name
      quantity
      rateHourly
      rateTon
      tonnage
      transferTruckId
    }
  }
}
    `;

/**
 * __useGetJobPhaseQuery__
 *
 * To run a query within a React component, call `useGetJobPhaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobPhaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobPhaseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetJobPhaseQuery(baseOptions: Apollo.QueryHookOptions<GetJobPhaseQuery, GetJobPhaseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobPhaseQuery, GetJobPhaseQueryVariables>(GetJobPhaseDocument, options);
      }
export function useGetJobPhaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobPhaseQuery, GetJobPhaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobPhaseQuery, GetJobPhaseQueryVariables>(GetJobPhaseDocument, options);
        }
export type GetJobPhaseQueryHookResult = ReturnType<typeof useGetJobPhaseQuery>;
export type GetJobPhaseLazyQueryHookResult = ReturnType<typeof useGetJobPhaseLazyQuery>;
export type GetJobPhaseQueryResult = Apollo.QueryResult<GetJobPhaseQuery, GetJobPhaseQueryVariables>;
export const GetJobPhaseCostItemDocument = gql`
    query getJobPhaseCostItem($date: Date!, $jobPhaseId: ID!) {
  getJobPhaseCostItem(date: $date, jobPhaseId: $jobPhaseId) {
    additionalCosts {
      additionalCostId
      cost
      costTotal
      feeAmount
      feeType
      id
      jobPhaseCostItem {
        additionalCosts {
          additionalCostId
          cost
          costTotal
          feeAmount
          feeType
          id
          name
        }
        costAdditional
        costEquipment
        costLabour
        costMaterial
        costTransferTruck
        date
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        equipmentPieces {
          equipmentPieceId
          id
          name
          quantity
          rate
          timeOnjob
          timeTravel
        }
        id
        jobPhase {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualEmployeeHours
          actualGrossMargin
          actualGrossMarginPercentage
          actualMaterialNeeded
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address
          applicableStatuses
          costItems {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          crew {
            color
            displayName
            id
            name
            rate
          }
          crewId
          defaultAdditionalCosts {
            cost
            feeAmount
            feeType
            id
            name
          }
          defaultEmployees {
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          defaultEquipmentPieces {
            chargeType
            fuelSurcharge
            id
            name
            rate
            usePercentage
          }
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          endsAt
          externalId
          files {
            createdAt
            filename
            id
            thumbnail
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            endsAt
            externalId
            id
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
          }
          jobDuration
          jobPhasePlant {
            id
            name
            type
          }
          jobSize
          notes
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          organizationProductType {
            id
            indirectPercentage
            markupPercentage
            name
            overheadPercentage
            type
          }
          organizationProductTypeName
          productName
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          proposalProduct {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          proposalStage {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedEmployeeHours
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedMaterialNeeded
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          scheduleBlocks {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          scheduledBlockForDate {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          startsAt
          status
          travelTimeEstimate
          users {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          usersColor
          workOrderCrews {
            crewId
            id
            name
          }
          workOrderEquipmentPieces {
            equipmentPieceId
            id
            name
          }
          workOrderTransferTrucks {
            id
            name
            quantity
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
        }
        material {
          costMaterial
          id
          jobPhaseCostItem {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          materialNeeded
          name
          organizationProductTypeName
          type
        }
        plantId
        plantProductId
        transferTrucks {
          hours
          id
          name
          plantTransferTruckId
          rateHourly
          rateTon
          tonnage
          transferTruckId
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
      }
      name
    }
    costAdditional
    costEquipment
    costLabour
    costMaterial
    costTransferTruck
    date
    employees {
      employeeId
      id
      name
      rate
      timeOnjob
      timeTravel
    }
    equipmentPieces {
      equipmentPieceId
      id
      name
      quantity
      rate
      timeOnjob
      timeTravel
    }
    id
    jobPhase {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualEmployeeHours
      actualGrossMargin
      actualGrossMarginPercentage
      actualMaterialNeeded
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      address
      applicableStatuses
      crewId
      endsAt
      externalId
      id
      jobDuration
      jobSize
      notes
      organizationProductTypeName
      productName
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedEmployeeHours
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedMaterialNeeded
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      startsAt
      status
      travelTimeEstimate
      usersColor
    }
    material {
      costMaterial
      id
      materialNeeded
      name
      organizationProductTypeName
      type
    }
    plantId
    plantProductId
    transferTrucks {
      hours
      id
      name
      plantTransferTruckId
      rateHourly
      rateTon
      tonnage
      transferTruckId
    }
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
  }
}
    `;

/**
 * __useGetJobPhaseCostItemQuery__
 *
 * To run a query within a React component, call `useGetJobPhaseCostItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobPhaseCostItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobPhaseCostItemQuery({
 *   variables: {
 *      date: // value for 'date'
 *      jobPhaseId: // value for 'jobPhaseId'
 *   },
 * });
 */
export function useGetJobPhaseCostItemQuery(baseOptions: Apollo.QueryHookOptions<GetJobPhaseCostItemQuery, GetJobPhaseCostItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobPhaseCostItemQuery, GetJobPhaseCostItemQueryVariables>(GetJobPhaseCostItemDocument, options);
      }
export function useGetJobPhaseCostItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobPhaseCostItemQuery, GetJobPhaseCostItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobPhaseCostItemQuery, GetJobPhaseCostItemQueryVariables>(GetJobPhaseCostItemDocument, options);
        }
export type GetJobPhaseCostItemQueryHookResult = ReturnType<typeof useGetJobPhaseCostItemQuery>;
export type GetJobPhaseCostItemLazyQueryHookResult = ReturnType<typeof useGetJobPhaseCostItemLazyQuery>;
export type GetJobPhaseCostItemQueryResult = Apollo.QueryResult<GetJobPhaseCostItemQuery, GetJobPhaseCostItemQueryVariables>;
export const GetJobPhaseCostsDocument = gql`
    query getJobPhaseCosts($id: ID!) {
  getJobPhaseCosts(id: $id) {
    additionalCosts {
      additionalCostId
      cost
      costTotal
      feeAmount
      feeType
      id
      jobPhaseCostItem {
        additionalCosts {
          additionalCostId
          cost
          costTotal
          feeAmount
          feeType
          id
          name
        }
        costAdditional
        costEquipment
        costLabour
        costMaterial
        costTransferTruck
        date
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        equipmentPieces {
          equipmentPieceId
          id
          name
          quantity
          rate
          timeOnjob
          timeTravel
        }
        id
        jobPhase {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualEmployeeHours
          actualGrossMargin
          actualGrossMarginPercentage
          actualMaterialNeeded
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address
          applicableStatuses
          costItems {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          crew {
            color
            displayName
            id
            name
            rate
          }
          crewId
          defaultAdditionalCosts {
            cost
            feeAmount
            feeType
            id
            name
          }
          defaultEmployees {
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          defaultEquipmentPieces {
            chargeType
            fuelSurcharge
            id
            name
            rate
            usePercentage
          }
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          endsAt
          externalId
          files {
            createdAt
            filename
            id
            thumbnail
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            endsAt
            externalId
            id
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
          }
          jobDuration
          jobPhasePlant {
            id
            name
            type
          }
          jobSize
          notes
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          organizationProductType {
            id
            indirectPercentage
            markupPercentage
            name
            overheadPercentage
            type
          }
          organizationProductTypeName
          productName
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          proposalProduct {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          proposalStage {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedEmployeeHours
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedMaterialNeeded
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          scheduleBlocks {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          scheduledBlockForDate {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          startsAt
          status
          travelTimeEstimate
          users {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          usersColor
          workOrderCrews {
            crewId
            id
            name
          }
          workOrderEquipmentPieces {
            equipmentPieceId
            id
            name
          }
          workOrderTransferTrucks {
            id
            name
            quantity
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
        }
        material {
          costMaterial
          id
          jobPhaseCostItem {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          materialNeeded
          name
          organizationProductTypeName
          type
        }
        plantId
        plantProductId
        transferTrucks {
          hours
          id
          name
          plantTransferTruckId
          rateHourly
          rateTon
          tonnage
          transferTruckId
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
      }
      name
    }
    costAdditional
    costEquipment
    costLabour
    costMaterial
    costTransferTruck
    date
    employees {
      employeeId
      id
      name
      rate
      timeOnjob
      timeTravel
    }
    equipmentPieces {
      equipmentPieceId
      id
      name
      quantity
      rate
      timeOnjob
      timeTravel
    }
    id
    jobPhase {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualEmployeeHours
      actualGrossMargin
      actualGrossMarginPercentage
      actualMaterialNeeded
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      address
      applicableStatuses
      crewId
      endsAt
      externalId
      id
      jobDuration
      jobSize
      notes
      organizationProductTypeName
      productName
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedEmployeeHours
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedMaterialNeeded
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      startsAt
      status
      travelTimeEstimate
      usersColor
    }
    material {
      costMaterial
      id
      materialNeeded
      name
      organizationProductTypeName
      type
    }
    plantId
    plantProductId
    transferTrucks {
      hours
      id
      name
      plantTransferTruckId
      rateHourly
      rateTon
      tonnage
      transferTruckId
    }
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
  }
}
    `;

/**
 * __useGetJobPhaseCostsQuery__
 *
 * To run a query within a React component, call `useGetJobPhaseCostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobPhaseCostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobPhaseCostsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetJobPhaseCostsQuery(baseOptions: Apollo.QueryHookOptions<GetJobPhaseCostsQuery, GetJobPhaseCostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobPhaseCostsQuery, GetJobPhaseCostsQueryVariables>(GetJobPhaseCostsDocument, options);
      }
export function useGetJobPhaseCostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobPhaseCostsQuery, GetJobPhaseCostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobPhaseCostsQuery, GetJobPhaseCostsQueryVariables>(GetJobPhaseCostsDocument, options);
        }
export type GetJobPhaseCostsQueryHookResult = ReturnType<typeof useGetJobPhaseCostsQuery>;
export type GetJobPhaseCostsLazyQueryHookResult = ReturnType<typeof useGetJobPhaseCostsLazyQuery>;
export type GetJobPhaseCostsQueryResult = Apollo.QueryResult<GetJobPhaseCostsQuery, GetJobPhaseCostsQueryVariables>;
export const GetJobPhasesDocument = gql`
    query getJobPhases($billingStatuses: [JobBillingStatus!], $companyId: ID, $crewId: ID, $date: DateTime, $endDate: DateTime, $first: Int!, $foremanUserId: ID, $organizationProductTypeId: ID, $page: Int, $search: String, $searchByName: Boolean, $sortDirection: SortDirection, $sortKey: GetJobsSortKey, $startDate: DateTime, $userId: ID) {
  getJobPhases(
    billingStatuses: $billingStatuses
    companyId: $companyId
    crewId: $crewId
    date: $date
    endDate: $endDate
    first: $first
    foremanUserId: $foremanUserId
    organizationProductTypeId: $organizationProductTypeId
    page: $page
    search: $search
    searchByName: $searchByName
    sortDirection: $sortDirection
    sortKey: $sortKey
    startDate: $startDate
    userId: $userId
  ) {
    data {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualEmployeeHours
      actualGrossMargin
      actualGrossMarginPercentage
      actualMaterialNeeded
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      address
      applicableStatuses
      costItems {
        additionalCosts {
          additionalCostId
          cost
          costTotal
          feeAmount
          feeType
          id
          jobPhaseCostItem {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          name
        }
        costAdditional
        costEquipment
        costLabour
        costMaterial
        costTransferTruck
        date
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        equipmentPieces {
          equipmentPieceId
          id
          name
          quantity
          rate
          timeOnjob
          timeTravel
        }
        id
        jobPhase {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualEmployeeHours
          actualGrossMargin
          actualGrossMarginPercentage
          actualMaterialNeeded
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address
          applicableStatuses
          costItems {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          crew {
            color
            displayName
            id
            name
            rate
          }
          crewId
          defaultAdditionalCosts {
            cost
            feeAmount
            feeType
            id
            name
          }
          defaultEmployees {
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          defaultEquipmentPieces {
            chargeType
            fuelSurcharge
            id
            name
            rate
            usePercentage
          }
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          endsAt
          externalId
          files {
            createdAt
            filename
            id
            thumbnail
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            endsAt
            externalId
            id
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
          }
          jobDuration
          jobPhasePlant {
            id
            name
            type
          }
          jobSize
          notes
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          organizationProductType {
            id
            indirectPercentage
            markupPercentage
            name
            overheadPercentage
            type
          }
          organizationProductTypeName
          productName
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          proposalProduct {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          proposalStage {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedEmployeeHours
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedMaterialNeeded
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          scheduleBlocks {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          scheduledBlockForDate {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          startsAt
          status
          travelTimeEstimate
          users {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          usersColor
          workOrderCrews {
            crewId
            id
            name
          }
          workOrderEquipmentPieces {
            equipmentPieceId
            id
            name
          }
          workOrderTransferTrucks {
            id
            name
            quantity
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
        }
        material {
          costMaterial
          id
          jobPhaseCostItem {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          materialNeeded
          name
          organizationProductTypeName
          type
        }
        plantId
        plantProductId
        transferTrucks {
          hours
          id
          name
          plantTransferTruckId
          rateHourly
          rateTon
          tonnage
          transferTruckId
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
      }
      crew {
        color
        displayName
        employees {
          firstName
          id
          lastName
          name
          organizationId
          rate
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
        }
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        id
        name
        organization {
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          proposalDefaults {
            autoSave
            color
            id
            layout
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        rate
      }
      crewId
      defaultAdditionalCosts {
        cost
        feeAmount
        feeType
        id
        name
      }
      defaultEmployees {
        firstName
        id
        lastName
        name
        organizationId
        rate
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
      }
      defaultEquipmentPieces {
        chargeType
        fuelSurcharge
        id
        name
        rate
        usePercentage
      }
      employees {
        employeeId
        id
        name
        rate
        timeOnjob
        timeTravel
      }
      endsAt
      externalId
      files {
        createdAt
        filename
        id
        thumbnail
      }
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        status
      }
      id
      job {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualGrossMargin
        actualGrossMarginPercentage
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        address {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        billingStatus
        changeOrders {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        datePushedToQuickbooks
        endsAt
        externalId
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          status
        }
        id
        jobPhases {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualEmployeeHours
          actualGrossMargin
          actualGrossMarginPercentage
          actualMaterialNeeded
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address
          applicableStatuses
          costItems {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          crew {
            color
            displayName
            id
            name
            rate
          }
          crewId
          defaultAdditionalCosts {
            cost
            feeAmount
            feeType
            id
            name
          }
          defaultEmployees {
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          defaultEquipmentPieces {
            chargeType
            fuelSurcharge
            id
            name
            rate
            usePercentage
          }
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          endsAt
          externalId
          files {
            createdAt
            filename
            id
            thumbnail
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            endsAt
            externalId
            id
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
          }
          jobDuration
          jobPhasePlant {
            id
            name
            type
          }
          jobSize
          notes
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          organizationProductType {
            id
            indirectPercentage
            markupPercentage
            name
            overheadPercentage
            type
          }
          organizationProductTypeName
          productName
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          proposalProduct {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          proposalStage {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedEmployeeHours
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedMaterialNeeded
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          scheduleBlocks {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          scheduledBlockForDate {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          startsAt
          status
          travelTimeEstimate
          users {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          usersColor
          workOrderCrews {
            crewId
            id
            name
          }
          workOrderEquipmentPieces {
            equipmentPieceId
            id
            name
          }
          workOrderTransferTrucks {
            id
            name
            quantity
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
        }
        mayShowTaxNotification
        notes
        projectFilesFolderId
        proposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        proposalId
        proposalStage {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          profit
          profitPercentage
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          roundTripTravelTimeHours
        }
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        shouldPushTaxesToQuickbooks
        startsAt
        status
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
      }
      jobDuration
      jobPhasePlant {
        id
        name
        plant {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          id
          name
          phone
          products {
            id
            rate
            type
          }
        }
        plantProduct {
          id
          rate
          type
        }
        type
      }
      jobSize
      notes
      organization {
        email
        emailTemplate
        failingPayment
        id
        logo
        name
        onTrial
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      organizationProductType {
        id
        indirectPercentage
        markupPercentage
        name
        overheadPercentage
        type
      }
      organizationProductTypeName
      productName
      proposal {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        externalId
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterTaxes
        profit
        profitPercentage
        projectFilesFolderId
        proposalNotes
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        userId
        uuid
        version
        wonAt
      }
      proposalProduct {
        additionalCosts {
          additionalCostId
          cost
          costOverride
          costTotal
          feeAmount
          feeAmountOverride
          feeType
          id
          name
          quantity
          quantityOverride
          showOnProposal
        }
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        costTransferTruck
        crews {
          cost
          crewId
          id
          name
          rate
          rateOverride
          timeOnjob
          timeOnjobOverride
          timeTravel
          timeTravelOverride
        }
        equipmentPieces {
          chargeType
          cost
          equipmentPieceId
          id
          name
          quantity
          quantityOverride
          rate
          rateOverride
          timeOnjob
          timeOnjobOverride
          timeTravel
          timeTravelOverride
          usePercentage
        }
        externalProductName
        files {
          createdAt
          filename
          id
          thumbnail
          type
        }
        grossMargin
        grossMarginPercentage
        id
        isOptional
        jobDuration
        jobDurationDaysOverride
        jobDurationOverride
        jobSize
        mapData
        mapImage
        mapImageDirty
        material {
          areaCoverage
          attributes {
            __typename
            ... on ProductAttributeAsphalt {
              applicationRate
            }
            ... on ProductAttributeConcreteColumn {
              diameter
              height
            }
            ... on ProductAttributeConcreteCurbOrGutter {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeConcreteFlatwork {
              applicationRate
            }
            ... on ProductAttributeConcreteFooting {
              depth
              width
            }
            ... on ProductAttributeConcreteWall {
              height
              width
            }
            ... on ProductAttributeConcreteWaterway {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeCrackSeal {
              crackDepth
              crackWidth
              overbandThickness
              overbandWidth
              poundsPerBlock
              poundsPerGallon
            }
            ... on ProductAttributeCurbWall {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeExcavateOut {
              applicationRate
            }
            ... on ProductAttributeGrading {
              applicationRate
              poundsPerCubicYard
            }
            ... on ProductAttributeMastic {
              crackDepth
              crackWidth
              overbandThickness
              overbandWidth
              poundsPerBlock
              poundsPerGallon
            }
            ... on ProductAttributeMicrosurfacing {
              applicationRate
            }
            ... on ProductAttributeSealCoat {
              applicationRate
            }
            ... on ProductAttributeSlurrySeal {
              applicationRate
            }
            ... on ProductAttributeStriping {
              applicationRate
              lineWidth
            }
          }
          attributesOverride {
            __typename
            ... on ProductAttributeAsphalt {
              applicationRate
            }
            ... on ProductAttributeConcreteColumn {
              diameter
              height
            }
            ... on ProductAttributeConcreteCurbOrGutter {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeConcreteFlatwork {
              applicationRate
            }
            ... on ProductAttributeConcreteFooting {
              depth
              width
            }
            ... on ProductAttributeConcreteWall {
              height
              width
            }
            ... on ProductAttributeConcreteWaterway {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeCrackSeal {
              crackDepth
              crackWidth
              overbandThickness
              overbandWidth
              poundsPerBlock
              poundsPerGallon
            }
            ... on ProductAttributeCurbWall {
              curbHeight
              curbWidth
              gutterHeight
              gutterWidth
            }
            ... on ProductAttributeExcavateOut {
              applicationRate
            }
            ... on ProductAttributeGrading {
              applicationRate
              poundsPerCubicYard
            }
            ... on ProductAttributeMastic {
              crackDepth
              crackWidth
              overbandThickness
              overbandWidth
              poundsPerBlock
              poundsPerGallon
            }
            ... on ProductAttributeMicrosurfacing {
              applicationRate
            }
            ... on ProductAttributeSealCoat {
              applicationRate
            }
            ... on ProductAttributeSlurrySeal {
              applicationRate
            }
            ... on ProductAttributeStriping {
              applicationRate
              lineWidth
            }
          }
          costMaterial
          costMaterialOverride
          costMinimumProduct
          costMinimumProposal
          dailyUnitsComplete
          dailyUnitsCompleteOverride
          externalProductName
          id
          indirectPercentage
          indirectPercentageOverride
          labourCostType
          markupPercentage
          markupPercentageOverride
          materialNeeded
          materialNeededOverride
          measurementJob
          measurementMaterial
          name
          organizationProductTypeName
          overheadPercentage
          overheadPercentageOverride
          productId
          productionRateType
          proposalId
          proposalProductId
          proposalStageId
          statementOfWork
          statementOfWorkOverride
          subcontracted
          tonConversionFactor
          tonConversionFactorOverride
          type
          unitPrice
          unitPriceOverride
          unitPriceProduct
        }
        measurementJob
        measurementMaterial
        netMargin
        netMarginPercentage
        notes
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        overallTotalOverride
        plantProduct {
          id
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            distanceMeters
            distanceSeconds
            id
            name
            phone
            plantId
            rateOnWeight
            roundTripSeconds
          }
          plantProductId
          rate
          rateOverride
          type
        }
        productName
        profit
        profitPercentage
        profitPercentageOverride
        roundTripTravelTimeHours
        statementOfWork
        subcontractorCost
        subcontractorName
        subcontractorProposalId
        transferTruckLoadTimeBuffer
        transferTruckRoundTripTime
        transferTruckRoundTripTimeOverride
        transferTruckUnloadTimeBuffer
        transferTrucks {
          cost
          costOverride
          id
          name
          plantTransferTruckId
          quantity
          rateHourly
          rateHourlyOverride
          rateTon
          rateTonOverride
          tonnage
          totalHaulingHours
          totalHaulingHoursOverride
          transferTruckId
          truckingProductionRate
          trucksNeeded
        }
      }
      proposalStage {
        addressOverride
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        distanceMeters
        distanceSeconds
        grossMargin
        grossMarginPercentage
        id
        mapData
        mapImage
        mapImageDirty
        name
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        profit
        profitPercentage
        roundTripTravelTimeHours
      }
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedEmployeeHours
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedMaterialNeeded
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      scheduleBlocks {
        blockLength
        crew {
          color
          displayName
          id
          name
          rate
        }
        endsAt
        estimatedMaterial
        estimatedMaterialOverride
        id
        job {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualGrossMargin
          actualGrossMarginPercentage
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          billingStatus
          datePushedToQuickbooks
          endsAt
          externalId
          id
          mayShowTaxNotification
          notes
          projectFilesFolderId
          proposalId
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          shouldPushTaxesToQuickbooks
          startsAt
          status
          userId
        }
        jobPhase {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualEmployeeHours
          actualGrossMargin
          actualGrossMarginPercentage
          actualMaterialNeeded
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address
          applicableStatuses
          crewId
          endsAt
          externalId
          id
          jobDuration
          jobSize
          notes
          organizationProductTypeName
          productName
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedEmployeeHours
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedMaterialNeeded
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          startsAt
          status
          travelTimeEstimate
          usersColor
        }
        scheduledAt
        showTravelFrom
        showTravelTo
        travelTime
      }
      scheduledBlockForDate {
        blockLength
        crew {
          color
          displayName
          id
          name
          rate
        }
        endsAt
        estimatedMaterial
        estimatedMaterialOverride
        id
        job {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualGrossMargin
          actualGrossMarginPercentage
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          billingStatus
          datePushedToQuickbooks
          endsAt
          externalId
          id
          mayShowTaxNotification
          notes
          projectFilesFolderId
          proposalId
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          shouldPushTaxesToQuickbooks
          startsAt
          status
          userId
        }
        jobPhase {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualEmployeeHours
          actualGrossMargin
          actualGrossMarginPercentage
          actualMaterialNeeded
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address
          applicableStatuses
          crewId
          endsAt
          externalId
          id
          jobDuration
          jobSize
          notes
          organizationProductTypeName
          productName
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedEmployeeHours
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedMaterialNeeded
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          startsAt
          status
          travelTimeEstimate
          usersColor
        }
        scheduledAt
        showTravelFrom
        showTravelTo
        travelTime
      }
      startsAt
      status
      travelTimeEstimate
      users {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          email
          emailTemplate
          failingPayment
          id
          logo
          name
          onTrial
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        status
      }
      usersColor
      workOrderCrews {
        crewId
        id
        name
      }
      workOrderEquipmentPieces {
        equipmentPieceId
        id
        name
      }
      workOrderTransferTrucks {
        id
        name
        quantity
        rateHourly
        rateTon
        tonnage
        transferTruckId
      }
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useGetJobPhasesQuery__
 *
 * To run a query within a React component, call `useGetJobPhasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobPhasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobPhasesQuery({
 *   variables: {
 *      billingStatuses: // value for 'billingStatuses'
 *      companyId: // value for 'companyId'
 *      crewId: // value for 'crewId'
 *      date: // value for 'date'
 *      endDate: // value for 'endDate'
 *      first: // value for 'first'
 *      foremanUserId: // value for 'foremanUserId'
 *      organizationProductTypeId: // value for 'organizationProductTypeId'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      searchByName: // value for 'searchByName'
 *      sortDirection: // value for 'sortDirection'
 *      sortKey: // value for 'sortKey'
 *      startDate: // value for 'startDate'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetJobPhasesQuery(baseOptions: Apollo.QueryHookOptions<GetJobPhasesQuery, GetJobPhasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobPhasesQuery, GetJobPhasesQueryVariables>(GetJobPhasesDocument, options);
      }
export function useGetJobPhasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobPhasesQuery, GetJobPhasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobPhasesQuery, GetJobPhasesQueryVariables>(GetJobPhasesDocument, options);
        }
export type GetJobPhasesQueryHookResult = ReturnType<typeof useGetJobPhasesQuery>;
export type GetJobPhasesLazyQueryHookResult = ReturnType<typeof useGetJobPhasesLazyQuery>;
export type GetJobPhasesQueryResult = Apollo.QueryResult<GetJobPhasesQuery, GetJobPhasesQueryVariables>;
export const GetJobScheduleByAmountStatsDocument = gql`
    query getJobScheduleByAmountStats {
  getJobScheduleByAmountStats {
    date
    overallTotal
  }
}
    `;

/**
 * __useGetJobScheduleByAmountStatsQuery__
 *
 * To run a query within a React component, call `useGetJobScheduleByAmountStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobScheduleByAmountStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobScheduleByAmountStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetJobScheduleByAmountStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetJobScheduleByAmountStatsQuery, GetJobScheduleByAmountStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobScheduleByAmountStatsQuery, GetJobScheduleByAmountStatsQueryVariables>(GetJobScheduleByAmountStatsDocument, options);
      }
export function useGetJobScheduleByAmountStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobScheduleByAmountStatsQuery, GetJobScheduleByAmountStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobScheduleByAmountStatsQuery, GetJobScheduleByAmountStatsQueryVariables>(GetJobScheduleByAmountStatsDocument, options);
        }
export type GetJobScheduleByAmountStatsQueryHookResult = ReturnType<typeof useGetJobScheduleByAmountStatsQuery>;
export type GetJobScheduleByAmountStatsLazyQueryHookResult = ReturnType<typeof useGetJobScheduleByAmountStatsLazyQuery>;
export type GetJobScheduleByAmountStatsQueryResult = Apollo.QueryResult<GetJobScheduleByAmountStatsQuery, GetJobScheduleByAmountStatsQueryVariables>;
export const GetJobSchedulesDocument = gql`
    query getJobSchedules($crewId: ID, $dateFrom: DateTime, $dateUntil: DateTime, $jobIds: [ID!], $jobPhaseId: ID) {
  getJobSchedules(
    crewId: $crewId
    dateFrom: $dateFrom
    dateUntil: $dateUntil
    jobIds: $jobIds
    jobPhaseId: $jobPhaseId
  ) {
    blockLength
    crew {
      color
      displayName
      employees {
        firstName
        id
        lastName
        name
        organizationId
        rate
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
      }
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          proposalDefaults {
            autoSave
            color
            id
            layout
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        status
      }
      id
      name
      organization {
        email
        emailTemplate
        failingPayment
        id
        logo
        name
        onTrial
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      rate
    }
    endsAt
    estimatedMaterial
    estimatedMaterialOverride
    id
    job {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualGrossMargin
      actualGrossMarginPercentage
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      address {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      billingStatus
      changeOrders {
        acceptanceOverride
        activeVersion
        addresses {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        attachments {
          id
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        changeOrderJobId
        changeOrders {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        clientEmailOverride
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        externalId
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterTaxes
        profit
        profitPercentage
        projectFilesFolderId
        proposalNotes
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        userId
        uuid
        version
        wonAt
      }
      company {
        addCompanyInfo
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        contacts {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        email
        id
        jobsCount
        logo
        name
        notes
        notificationTypes {
          CONTACT
          JOB
          JOB_PHASE
          OPPORTUNITY
          PROPOSAL
        }
        phone
        primaryContact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        projectFilesFolderId
        proposalsCount
        status
        website
      }
      contact {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      datePushedToQuickbooks
      endsAt
      externalId
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        status
      }
      id
      jobPhases {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualEmployeeHours
        actualGrossMargin
        actualGrossMarginPercentage
        actualMaterialNeeded
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        address
        applicableStatuses
        costItems {
          additionalCosts {
            additionalCostId
            cost
            costTotal
            feeAmount
            feeType
            id
            name
          }
          costAdditional
          costEquipment
          costLabour
          costMaterial
          costTransferTruck
          date
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          equipmentPieces {
            equipmentPieceId
            id
            name
            quantity
            rate
            timeOnjob
            timeTravel
          }
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            address
            applicableStatuses
            crewId
            endsAt
            externalId
            id
            jobDuration
            jobSize
            notes
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          material {
            costMaterial
            id
            materialNeeded
            name
            organizationProductTypeName
            type
          }
          plantId
          plantProductId
          transferTrucks {
            hours
            id
            name
            plantTransferTruckId
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
        }
        crew {
          color
          displayName
          id
          name
          rate
        }
        crewId
        defaultAdditionalCosts {
          cost
          feeAmount
          feeType
          id
          name
        }
        defaultEmployees {
          firstName
          id
          lastName
          name
          organizationId
          rate
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
        }
        defaultEquipmentPieces {
          chargeType
          fuelSurcharge
          id
          name
          rate
          usePercentage
        }
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        endsAt
        externalId
        files {
          createdAt
          filename
          id
          thumbnail
        }
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          status
        }
        id
        job {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualGrossMargin
          actualGrossMarginPercentage
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          billingStatus
          datePushedToQuickbooks
          endsAt
          externalId
          id
          mayShowTaxNotification
          notes
          projectFilesFolderId
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          proposalId
          proposalStage {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          shouldPushTaxesToQuickbooks
          startsAt
          status
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
        }
        jobDuration
        jobPhasePlant {
          id
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            rate
            type
          }
          type
        }
        jobSize
        notes
        organization {
          email
          emailTemplate
          failingPayment
          id
          logo
          name
          onTrial
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        organizationProductType {
          id
          indirectPercentage
          markupPercentage
          name
          overheadPercentage
          type
        }
        organizationProductTypeName
        productName
        proposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        proposalProduct {
          additionalCosts {
            additionalCostId
            cost
            costOverride
            costTotal
            feeAmount
            feeAmountOverride
            feeType
            id
            name
            quantity
            quantityOverride
            showOnProposal
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          costTransferTruck
          crews {
            cost
            crewId
            id
            name
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
          }
          equipmentPieces {
            chargeType
            cost
            equipmentPieceId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
            usePercentage
          }
          externalProductName
          files {
            createdAt
            filename
            id
            thumbnail
            type
          }
          grossMargin
          grossMarginPercentage
          id
          isOptional
          jobDuration
          jobDurationDaysOverride
          jobDurationOverride
          jobSize
          mapData
          mapImage
          mapImageDirty
          material {
            areaCoverage
            attributes {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            attributesOverride {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            costMaterial
            costMaterialOverride
            costMinimumProduct
            costMinimumProposal
            dailyUnitsComplete
            dailyUnitsCompleteOverride
            externalProductName
            id
            indirectPercentage
            indirectPercentageOverride
            labourCostType
            markupPercentage
            markupPercentageOverride
            materialNeeded
            materialNeededOverride
            measurementJob
            measurementMaterial
            name
            organizationProductTypeName
            overheadPercentage
            overheadPercentageOverride
            productId
            productionRateType
            proposalId
            proposalProductId
            proposalStageId
            statementOfWork
            statementOfWorkOverride
            subcontracted
            tonConversionFactor
            tonConversionFactorOverride
            type
            unitPrice
            unitPriceOverride
            unitPriceProduct
          }
          measurementJob
          measurementMaterial
          netMargin
          netMarginPercentage
          notes
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalOverride
          plantProduct {
            id
            plantProductId
            rate
            rateOverride
            type
          }
          productName
          profit
          profitPercentage
          profitPercentageOverride
          roundTripTravelTimeHours
          statementOfWork
          subcontractorCost
          subcontractorName
          subcontractorProposalId
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTime
          transferTruckRoundTripTimeOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            quantity
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
        }
        proposalStage {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          profit
          profitPercentage
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          roundTripTravelTimeHours
        }
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedEmployeeHours
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedMaterialNeeded
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        scheduleBlocks {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            endsAt
            externalId
            id
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            address
            applicableStatuses
            crewId
            endsAt
            externalId
            id
            jobDuration
            jobSize
            notes
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        scheduledBlockForDate {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            endsAt
            externalId
            id
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            address
            applicableStatuses
            crewId
            endsAt
            externalId
            id
            jobDuration
            jobSize
            notes
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        startsAt
        status
        travelTimeEstimate
        users {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        usersColor
        workOrderCrews {
          crewId
          id
          name
        }
        workOrderEquipmentPieces {
          equipmentPieceId
          id
          name
        }
        workOrderTransferTrucks {
          id
          name
          quantity
          rateHourly
          rateTon
          tonnage
          transferTruckId
        }
      }
      mayShowTaxNotification
      notes
      projectFilesFolderId
      proposalId
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      shouldPushTaxesToQuickbooks
      startsAt
      status
      userId
    }
    jobPhase {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualEmployeeHours
      actualGrossMargin
      actualGrossMarginPercentage
      actualMaterialNeeded
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      address
      applicableStatuses
      costItems {
        costAdditional
        costEquipment
        costLabour
        costMaterial
        costTransferTruck
        date
        id
        plantId
        plantProductId
      }
      crew {
        color
        displayName
        id
        name
        rate
      }
      crewId
      defaultAdditionalCosts {
        cost
        feeAmount
        feeType
        id
        name
      }
      defaultEmployees {
        firstName
        id
        lastName
        name
        organizationId
        rate
        userId
      }
      defaultEquipmentPieces {
        chargeType
        fuelSurcharge
        id
        name
        rate
        usePercentage
      }
      employees {
        employeeId
        id
        name
        rate
        timeOnjob
        timeTravel
      }
      endsAt
      externalId
      files {
        createdAt
        filename
        id
        thumbnail
      }
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        status
      }
      id
      job {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualGrossMargin
        actualGrossMarginPercentage
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        billingStatus
        datePushedToQuickbooks
        endsAt
        externalId
        id
        mayShowTaxNotification
        notes
        projectFilesFolderId
        proposalId
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        shouldPushTaxesToQuickbooks
        startsAt
        status
        userId
      }
      jobDuration
      jobPhasePlant {
        id
        name
        type
      }
      jobSize
      notes
      organization {
        email
        emailTemplate
        failingPayment
        id
        logo
        name
        onTrial
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      organizationProductType {
        id
        indirectPercentage
        markupPercentage
        name
        overheadPercentage
        type
      }
      organizationProductTypeName
      productName
      proposal {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        externalId
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterTaxes
        profit
        profitPercentage
        projectFilesFolderId
        proposalNotes
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        userId
        uuid
        version
        wonAt
      }
      proposalProduct {
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        costTransferTruck
        externalProductName
        grossMargin
        grossMarginPercentage
        id
        isOptional
        jobDuration
        jobDurationDaysOverride
        jobDurationOverride
        jobSize
        mapData
        mapImage
        mapImageDirty
        measurementJob
        measurementMaterial
        netMargin
        netMarginPercentage
        notes
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        overallTotalOverride
        productName
        profit
        profitPercentage
        profitPercentageOverride
        roundTripTravelTimeHours
        statementOfWork
        subcontractorCost
        subcontractorName
        subcontractorProposalId
        transferTruckLoadTimeBuffer
        transferTruckRoundTripTime
        transferTruckRoundTripTimeOverride
        transferTruckUnloadTimeBuffer
      }
      proposalStage {
        addressOverride
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        distanceMeters
        distanceSeconds
        grossMargin
        grossMarginPercentage
        id
        mapData
        mapImage
        mapImageDirty
        name
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        profit
        profitPercentage
        roundTripTravelTimeHours
      }
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedEmployeeHours
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedMaterialNeeded
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      scheduleBlocks {
        blockLength
        endsAt
        estimatedMaterial
        estimatedMaterialOverride
        id
        scheduledAt
        showTravelFrom
        showTravelTo
        travelTime
      }
      scheduledBlockForDate {
        blockLength
        endsAt
        estimatedMaterial
        estimatedMaterialOverride
        id
        scheduledAt
        showTravelFrom
        showTravelTo
        travelTime
      }
      startsAt
      status
      travelTimeEstimate
      users {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        status
      }
      usersColor
      workOrderCrews {
        crewId
        id
        name
      }
      workOrderEquipmentPieces {
        equipmentPieceId
        id
        name
      }
      workOrderTransferTrucks {
        id
        name
        quantity
        rateHourly
        rateTon
        tonnage
        transferTruckId
      }
    }
    scheduledAt
    showTravelFrom
    showTravelTo
    travelTime
  }
}
    `;

/**
 * __useGetJobSchedulesQuery__
 *
 * To run a query within a React component, call `useGetJobSchedulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobSchedulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobSchedulesQuery({
 *   variables: {
 *      crewId: // value for 'crewId'
 *      dateFrom: // value for 'dateFrom'
 *      dateUntil: // value for 'dateUntil'
 *      jobIds: // value for 'jobIds'
 *      jobPhaseId: // value for 'jobPhaseId'
 *   },
 * });
 */
export function useGetJobSchedulesQuery(baseOptions?: Apollo.QueryHookOptions<GetJobSchedulesQuery, GetJobSchedulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobSchedulesQuery, GetJobSchedulesQueryVariables>(GetJobSchedulesDocument, options);
      }
export function useGetJobSchedulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobSchedulesQuery, GetJobSchedulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobSchedulesQuery, GetJobSchedulesQueryVariables>(GetJobSchedulesDocument, options);
        }
export type GetJobSchedulesQueryHookResult = ReturnType<typeof useGetJobSchedulesQuery>;
export type GetJobSchedulesLazyQueryHookResult = ReturnType<typeof useGetJobSchedulesLazyQuery>;
export type GetJobSchedulesQueryResult = Apollo.QueryResult<GetJobSchedulesQuery, GetJobSchedulesQueryVariables>;
export const GetJobsDocument = gql`
    query getJobs($billingStatuses: [JobBillingStatus!], $companyId: ID, $first: Int!, $jobIds: [ID!], $multipleCompanyIDs: [ID!], $multipleUserIDs: [ID!], $organizationProductTypeIds: [ID!], $page: Int, $search: String, $sortDirection: SortDirection, $sortKey: GetJobsSortKey, $statuses: [JobStatus!], $userId: ID) {
  getJobs(
    billingStatuses: $billingStatuses
    companyId: $companyId
    first: $first
    jobIds: $jobIds
    multipleCompanyIDs: $multipleCompanyIDs
    multipleUserIDs: $multipleUserIDs
    organizationProductTypeIds: $organizationProductTypeIds
    page: $page
    search: $search
    sortDirection: $sortDirection
    sortKey: $sortKey
    statuses: $statuses
    userId: $userId
  ) {
    data {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualGrossMargin
      actualGrossMarginPercentage
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      address {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      billingStatus
      changeOrders {
        acceptanceOverride
        activeVersion
        addresses {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        attachments {
          id
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        changeOrderJobId
        changeOrders {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        clientEmailOverride
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        externalId
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterTaxes
        profit
        profitPercentage
        projectFilesFolderId
        proposalNotes
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        userId
        uuid
        version
        wonAt
      }
      company {
        addCompanyInfo
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        contacts {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        email
        id
        jobsCount
        logo
        name
        notes
        notificationTypes {
          CONTACT
          JOB
          JOB_PHASE
          OPPORTUNITY
          PROPOSAL
        }
        phone
        primaryContact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        projectFilesFolderId
        proposalsCount
        status
        website
      }
      contact {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      datePushedToQuickbooks
      endsAt
      externalId
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          proposalDefaults {
            autoSave
            color
            id
            layout
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        status
      }
      id
      jobPhases {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualEmployeeHours
        actualGrossMargin
        actualGrossMarginPercentage
        actualMaterialNeeded
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        address
        applicableStatuses
        costItems {
          additionalCosts {
            additionalCostId
            cost
            costTotal
            feeAmount
            feeType
            id
            name
          }
          costAdditional
          costEquipment
          costLabour
          costMaterial
          costTransferTruck
          date
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          equipmentPieces {
            equipmentPieceId
            id
            name
            quantity
            rate
            timeOnjob
            timeTravel
          }
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            address
            applicableStatuses
            crewId
            endsAt
            externalId
            id
            jobDuration
            jobSize
            notes
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          material {
            costMaterial
            id
            materialNeeded
            name
            organizationProductTypeName
            type
          }
          plantId
          plantProductId
          transferTrucks {
            hours
            id
            name
            plantTransferTruckId
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
        }
        crew {
          color
          displayName
          employees {
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          id
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          rate
        }
        crewId
        defaultAdditionalCosts {
          cost
          feeAmount
          feeType
          id
          name
        }
        defaultEmployees {
          firstName
          id
          lastName
          name
          organizationId
          rate
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
        }
        defaultEquipmentPieces {
          chargeType
          fuelSurcharge
          id
          name
          rate
          usePercentage
        }
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        endsAt
        externalId
        files {
          createdAt
          filename
          id
          thumbnail
        }
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          status
        }
        id
        job {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualGrossMargin
          actualGrossMarginPercentage
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          billingStatus
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          datePushedToQuickbooks
          endsAt
          externalId
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          id
          jobPhases {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            address
            applicableStatuses
            crewId
            endsAt
            externalId
            id
            jobDuration
            jobSize
            notes
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          mayShowTaxNotification
          notes
          projectFilesFolderId
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          proposalId
          proposalStage {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          shouldPushTaxesToQuickbooks
          startsAt
          status
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
        }
        jobDuration
        jobPhasePlant {
          id
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            rate
            type
          }
          type
        }
        jobSize
        notes
        organization {
          email
          emailTemplate
          failingPayment
          id
          logo
          name
          onTrial
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        organizationProductType {
          id
          indirectPercentage
          markupPercentage
          name
          overheadPercentage
          type
        }
        organizationProductTypeName
        productName
        proposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        proposalProduct {
          additionalCosts {
            additionalCostId
            cost
            costOverride
            costTotal
            feeAmount
            feeAmountOverride
            feeType
            id
            name
            quantity
            quantityOverride
            showOnProposal
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          costTransferTruck
          crews {
            cost
            crewId
            id
            name
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
          }
          equipmentPieces {
            chargeType
            cost
            equipmentPieceId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
            usePercentage
          }
          externalProductName
          files {
            createdAt
            filename
            id
            thumbnail
            type
          }
          grossMargin
          grossMarginPercentage
          id
          isOptional
          jobDuration
          jobDurationDaysOverride
          jobDurationOverride
          jobSize
          mapData
          mapImage
          mapImageDirty
          material {
            areaCoverage
            attributes {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            attributesOverride {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            costMaterial
            costMaterialOverride
            costMinimumProduct
            costMinimumProposal
            dailyUnitsComplete
            dailyUnitsCompleteOverride
            externalProductName
            id
            indirectPercentage
            indirectPercentageOverride
            labourCostType
            markupPercentage
            markupPercentageOverride
            materialNeeded
            materialNeededOverride
            measurementJob
            measurementMaterial
            name
            organizationProductTypeName
            overheadPercentage
            overheadPercentageOverride
            productId
            productionRateType
            proposalId
            proposalProductId
            proposalStageId
            statementOfWork
            statementOfWorkOverride
            subcontracted
            tonConversionFactor
            tonConversionFactorOverride
            type
            unitPrice
            unitPriceOverride
            unitPriceProduct
          }
          measurementJob
          measurementMaterial
          netMargin
          netMarginPercentage
          notes
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalOverride
          plantProduct {
            id
            plantProductId
            rate
            rateOverride
            type
          }
          productName
          profit
          profitPercentage
          profitPercentageOverride
          roundTripTravelTimeHours
          statementOfWork
          subcontractorCost
          subcontractorName
          subcontractorProposalId
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTime
          transferTruckRoundTripTimeOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            quantity
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
        }
        proposalStage {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          profit
          profitPercentage
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          roundTripTravelTimeHours
        }
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedEmployeeHours
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedMaterialNeeded
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        scheduleBlocks {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            endsAt
            externalId
            id
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            address
            applicableStatuses
            crewId
            endsAt
            externalId
            id
            jobDuration
            jobSize
            notes
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        scheduledBlockForDate {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            endsAt
            externalId
            id
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            address
            applicableStatuses
            crewId
            endsAt
            externalId
            id
            jobDuration
            jobSize
            notes
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        startsAt
        status
        travelTimeEstimate
        users {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        usersColor
        workOrderCrews {
          crewId
          id
          name
        }
        workOrderEquipmentPieces {
          equipmentPieceId
          id
          name
        }
        workOrderTransferTrucks {
          id
          name
          quantity
          rateHourly
          rateTon
          tonnage
          transferTruckId
        }
      }
      mayShowTaxNotification
      notes
      projectFilesFolderId
      proposal {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        externalId
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterTaxes
        profit
        profitPercentage
        projectFilesFolderId
        proposalNotes
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        userId
        uuid
        version
        wonAt
      }
      proposalId
      proposalStage {
        addressOverride
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        distanceMeters
        distanceSeconds
        grossMargin
        grossMarginPercentage
        id
        mapData
        mapImage
        mapImageDirty
        name
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        profit
        profitPercentage
        roundTripTravelTimeHours
      }
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      shouldPushTaxesToQuickbooks
      startsAt
      status
      user {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          email
          emailTemplate
          failingPayment
          id
          logo
          name
          onTrial
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        status
      }
      userId
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useGetJobsQuery__
 *
 * To run a query within a React component, call `useGetJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobsQuery({
 *   variables: {
 *      billingStatuses: // value for 'billingStatuses'
 *      companyId: // value for 'companyId'
 *      first: // value for 'first'
 *      jobIds: // value for 'jobIds'
 *      multipleCompanyIDs: // value for 'multipleCompanyIDs'
 *      multipleUserIDs: // value for 'multipleUserIDs'
 *      organizationProductTypeIds: // value for 'organizationProductTypeIds'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      sortDirection: // value for 'sortDirection'
 *      sortKey: // value for 'sortKey'
 *      statuses: // value for 'statuses'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetJobsQuery(baseOptions: Apollo.QueryHookOptions<GetJobsQuery, GetJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobsQuery, GetJobsQueryVariables>(GetJobsDocument, options);
      }
export function useGetJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobsQuery, GetJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobsQuery, GetJobsQueryVariables>(GetJobsDocument, options);
        }
export type GetJobsQueryHookResult = ReturnType<typeof useGetJobsQuery>;
export type GetJobsLazyQueryHookResult = ReturnType<typeof useGetJobsLazyQuery>;
export type GetJobsQueryResult = Apollo.QueryResult<GetJobsQuery, GetJobsQueryVariables>;
export const GetLastYearStatsDocument = gql`
    query getLastYearStats {
  getLastYearStats {
    closedBids {
      month
      total
      year
    }
    closedRate {
      month
      total
      year
    }
    closedRevenue {
      month
      total
      year
    }
    sentBids {
      month
      total
      year
    }
  }
}
    `;

/**
 * __useGetLastYearStatsQuery__
 *
 * To run a query within a React component, call `useGetLastYearStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLastYearStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLastYearStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLastYearStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetLastYearStatsQuery, GetLastYearStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLastYearStatsQuery, GetLastYearStatsQueryVariables>(GetLastYearStatsDocument, options);
      }
export function useGetLastYearStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLastYearStatsQuery, GetLastYearStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLastYearStatsQuery, GetLastYearStatsQueryVariables>(GetLastYearStatsDocument, options);
        }
export type GetLastYearStatsQueryHookResult = ReturnType<typeof useGetLastYearStatsQuery>;
export type GetLastYearStatsLazyQueryHookResult = ReturnType<typeof useGetLastYearStatsLazyQuery>;
export type GetLastYearStatsQueryResult = Apollo.QueryResult<GetLastYearStatsQuery, GetLastYearStatsQueryVariables>;
export const GetManageSubscriptionUrlDocument = gql`
    query getManageSubscriptionUrl {
  getManageSubscriptionUrl
}
    `;

/**
 * __useGetManageSubscriptionUrlQuery__
 *
 * To run a query within a React component, call `useGetManageSubscriptionUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManageSubscriptionUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManageSubscriptionUrlQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetManageSubscriptionUrlQuery(baseOptions?: Apollo.QueryHookOptions<GetManageSubscriptionUrlQuery, GetManageSubscriptionUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetManageSubscriptionUrlQuery, GetManageSubscriptionUrlQueryVariables>(GetManageSubscriptionUrlDocument, options);
      }
export function useGetManageSubscriptionUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManageSubscriptionUrlQuery, GetManageSubscriptionUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetManageSubscriptionUrlQuery, GetManageSubscriptionUrlQueryVariables>(GetManageSubscriptionUrlDocument, options);
        }
export type GetManageSubscriptionUrlQueryHookResult = ReturnType<typeof useGetManageSubscriptionUrlQuery>;
export type GetManageSubscriptionUrlLazyQueryHookResult = ReturnType<typeof useGetManageSubscriptionUrlLazyQuery>;
export type GetManageSubscriptionUrlQueryResult = Apollo.QueryResult<GetManageSubscriptionUrlQuery, GetManageSubscriptionUrlQueryVariables>;
export const GetMaterialNeededByDayStatsDocument = gql`
    query getMaterialNeededByDayStats {
  getMaterialNeededByDayStats {
    JobPhaseAmountScheduledInDay
    date
    jobPhaseMaterialNeededInDay
    material
  }
}
    `;

/**
 * __useGetMaterialNeededByDayStatsQuery__
 *
 * To run a query within a React component, call `useGetMaterialNeededByDayStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaterialNeededByDayStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMaterialNeededByDayStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMaterialNeededByDayStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetMaterialNeededByDayStatsQuery, GetMaterialNeededByDayStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMaterialNeededByDayStatsQuery, GetMaterialNeededByDayStatsQueryVariables>(GetMaterialNeededByDayStatsDocument, options);
      }
export function useGetMaterialNeededByDayStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMaterialNeededByDayStatsQuery, GetMaterialNeededByDayStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMaterialNeededByDayStatsQuery, GetMaterialNeededByDayStatsQueryVariables>(GetMaterialNeededByDayStatsDocument, options);
        }
export type GetMaterialNeededByDayStatsQueryHookResult = ReturnType<typeof useGetMaterialNeededByDayStatsQuery>;
export type GetMaterialNeededByDayStatsLazyQueryHookResult = ReturnType<typeof useGetMaterialNeededByDayStatsLazyQuery>;
export type GetMaterialNeededByDayStatsQueryResult = Apollo.QueryResult<GetMaterialNeededByDayStatsQuery, GetMaterialNeededByDayStatsQueryVariables>;
export const GetNotificationTriggerDocument = gql`
    query getNotificationTrigger($id: ID!) {
  getNotificationTrigger(id: $id) {
    active
    additionalRecipientTypes
    additionalRecipients {
      email
      firstName
      id
      lastName
    }
    content
    delay
    emailSubject
    event
    id
    isEmail
    isSMS
    name
    organization {
      conversionFactorOverride {
        asphaltTonConversionFactorOverride
        excavateOutTonConversionFactorOverride
        id
        organization {
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          proposalDefaults {
            autoSave
            color
            id
            layout
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
      }
      email
      emailTemplate
      failingPayment
      id
      logo
      name
      onTrial
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    sendToAllRecipients
    sendToContact
    sendToUser
    smsContent
    type
  }
}
    `;

/**
 * __useGetNotificationTriggerQuery__
 *
 * To run a query within a React component, call `useGetNotificationTriggerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationTriggerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationTriggerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetNotificationTriggerQuery(baseOptions: Apollo.QueryHookOptions<GetNotificationTriggerQuery, GetNotificationTriggerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationTriggerQuery, GetNotificationTriggerQueryVariables>(GetNotificationTriggerDocument, options);
      }
export function useGetNotificationTriggerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationTriggerQuery, GetNotificationTriggerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationTriggerQuery, GetNotificationTriggerQueryVariables>(GetNotificationTriggerDocument, options);
        }
export type GetNotificationTriggerQueryHookResult = ReturnType<typeof useGetNotificationTriggerQuery>;
export type GetNotificationTriggerLazyQueryHookResult = ReturnType<typeof useGetNotificationTriggerLazyQuery>;
export type GetNotificationTriggerQueryResult = Apollo.QueryResult<GetNotificationTriggerQuery, GetNotificationTriggerQueryVariables>;
export const GetNotificationTriggersDocument = gql`
    query getNotificationTriggers {
  getNotificationTriggers {
    active
    additionalRecipientTypes
    additionalRecipients {
      email
      firstName
      id
      lastName
    }
    content
    delay
    emailSubject
    event
    id
    isEmail
    isSMS
    name
    organization {
      conversionFactorOverride {
        asphaltTonConversionFactorOverride
        excavateOutTonConversionFactorOverride
        id
        organization {
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          proposalDefaults {
            autoSave
            color
            id
            layout
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
      }
      email
      emailTemplate
      failingPayment
      id
      logo
      name
      onTrial
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    sendToAllRecipients
    sendToContact
    sendToUser
    smsContent
    type
  }
}
    `;

/**
 * __useGetNotificationTriggersQuery__
 *
 * To run a query within a React component, call `useGetNotificationTriggersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationTriggersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationTriggersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNotificationTriggersQuery(baseOptions?: Apollo.QueryHookOptions<GetNotificationTriggersQuery, GetNotificationTriggersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationTriggersQuery, GetNotificationTriggersQueryVariables>(GetNotificationTriggersDocument, options);
      }
export function useGetNotificationTriggersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationTriggersQuery, GetNotificationTriggersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationTriggersQuery, GetNotificationTriggersQueryVariables>(GetNotificationTriggersDocument, options);
        }
export type GetNotificationTriggersQueryHookResult = ReturnType<typeof useGetNotificationTriggersQuery>;
export type GetNotificationTriggersLazyQueryHookResult = ReturnType<typeof useGetNotificationTriggersLazyQuery>;
export type GetNotificationTriggersQueryResult = Apollo.QueryResult<GetNotificationTriggersQuery, GetNotificationTriggersQueryVariables>;
export const GetOpportunitiesDocument = gql`
    query getOpportunities($companyId: ID, $contactName: String, $dueAt: Date, $first: Int!, $multipleCompanyIDs: [ID!], $multipleUserIDs: [ID!], $page: Int, $search: String, $sort: SortDirection, $sortKey: GetOpportunitiesSortKey, $statuses: [String!], $userId: ID) {
  getOpportunities(
    companyId: $companyId
    contactName: $contactName
    dueAt: $dueAt
    first: $first
    multipleCompanyIDs: $multipleCompanyIDs
    multipleUserIDs: $multipleUserIDs
    page: $page
    search: $search
    sort: $sort
    sortKey: $sortKey
    statuses: $statuses
    userId: $userId
  ) {
    data {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      company {
        addCompanyInfo
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        contacts {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        email
        id
        jobsCount
        logo
        name
        notes
        notificationTypes {
          CONTACT
          JOB
          JOB_PHASE
          OPPORTUNITY
          PROPOSAL
        }
        phone
        primaryContact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        projectFilesFolderId
        proposalsCount
        status
        website
      }
      companyId
      contact {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      contactId
      createdAt
      dueAt
      estimatedOpportunityValue
      externalId
      id
      name
      notes
      products {
        id
        indirectPercentage
        markupPercentage
        name
        overheadPercentage
        type
      }
      projectFilesFolderId
      source
      status
      statusId
      updatedAt
      user {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          proposalDefaults {
            autoSave
            color
            id
            layout
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        status
      }
      userId
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useGetOpportunitiesQuery__
 *
 * To run a query within a React component, call `useGetOpportunitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpportunitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOpportunitiesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      contactName: // value for 'contactName'
 *      dueAt: // value for 'dueAt'
 *      first: // value for 'first'
 *      multipleCompanyIDs: // value for 'multipleCompanyIDs'
 *      multipleUserIDs: // value for 'multipleUserIDs'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      sort: // value for 'sort'
 *      sortKey: // value for 'sortKey'
 *      statuses: // value for 'statuses'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetOpportunitiesQuery(baseOptions: Apollo.QueryHookOptions<GetOpportunitiesQuery, GetOpportunitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOpportunitiesQuery, GetOpportunitiesQueryVariables>(GetOpportunitiesDocument, options);
      }
export function useGetOpportunitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOpportunitiesQuery, GetOpportunitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOpportunitiesQuery, GetOpportunitiesQueryVariables>(GetOpportunitiesDocument, options);
        }
export type GetOpportunitiesQueryHookResult = ReturnType<typeof useGetOpportunitiesQuery>;
export type GetOpportunitiesLazyQueryHookResult = ReturnType<typeof useGetOpportunitiesLazyQuery>;
export type GetOpportunitiesQueryResult = Apollo.QueryResult<GetOpportunitiesQuery, GetOpportunitiesQueryVariables>;
export const GetOpportunityDocument = gql`
    query getOpportunity($id: ID!) {
  getOpportunity(id: $id) {
    addressCity
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZip
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      contacts {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      email
      id
      jobsCount
      logo
      name
      notes
      notificationTypes {
        CONTACT
        JOB
        JOB_PHASE
        OPPORTUNITY
        PROPOSAL
      }
      phone
      primaryContact {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    companyId
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    createdAt
    dueAt
    estimatedOpportunityValue
    externalId
    id
    name
    notes
    products {
      id
      indirectPercentage
      markupPercentage
      name
      overheadPercentage
      type
    }
    projectFilesFolderId
    source
    status
    statusId
    updatedAt
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        phone
        proposalDefaults {
          autoSave
          color
          id
          layout
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      status
    }
    userId
  }
}
    `;

/**
 * __useGetOpportunityQuery__
 *
 * To run a query within a React component, call `useGetOpportunityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpportunityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOpportunityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOpportunityQuery(baseOptions: Apollo.QueryHookOptions<GetOpportunityQuery, GetOpportunityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOpportunityQuery, GetOpportunityQueryVariables>(GetOpportunityDocument, options);
      }
export function useGetOpportunityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOpportunityQuery, GetOpportunityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOpportunityQuery, GetOpportunityQueryVariables>(GetOpportunityDocument, options);
        }
export type GetOpportunityQueryHookResult = ReturnType<typeof useGetOpportunityQuery>;
export type GetOpportunityLazyQueryHookResult = ReturnType<typeof useGetOpportunityLazyQuery>;
export type GetOpportunityQueryResult = Apollo.QueryResult<GetOpportunityQuery, GetOpportunityQueryVariables>;
export const GetOpportunityStatusesDocument = gql`
    query getOpportunityStatuses {
  getOpportunityStatuses {
    id
    name
  }
}
    `;

/**
 * __useGetOpportunityStatusesQuery__
 *
 * To run a query within a React component, call `useGetOpportunityStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOpportunityStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOpportunityStatusesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOpportunityStatusesQuery(baseOptions?: Apollo.QueryHookOptions<GetOpportunityStatusesQuery, GetOpportunityStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOpportunityStatusesQuery, GetOpportunityStatusesQueryVariables>(GetOpportunityStatusesDocument, options);
      }
export function useGetOpportunityStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOpportunityStatusesQuery, GetOpportunityStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOpportunityStatusesQuery, GetOpportunityStatusesQueryVariables>(GetOpportunityStatusesDocument, options);
        }
export type GetOpportunityStatusesQueryHookResult = ReturnType<typeof useGetOpportunityStatusesQuery>;
export type GetOpportunityStatusesLazyQueryHookResult = ReturnType<typeof useGetOpportunityStatusesLazyQuery>;
export type GetOpportunityStatusesQueryResult = Apollo.QueryResult<GetOpportunityStatusesQuery, GetOpportunityStatusesQueryVariables>;
export const GetOrganizationAddressDocument = gql`
    query getOrganizationAddress($id: ID!) {
  getOrganizationAddress(id: $id) {
    city
    country
    id
    isPrimary
    latitude
    line1
    line2
    longitude
    state
    zip
  }
}
    `;

/**
 * __useGetOrganizationAddressQuery__
 *
 * To run a query within a React component, call `useGetOrganizationAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationAddressQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrganizationAddressQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationAddressQuery, GetOrganizationAddressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationAddressQuery, GetOrganizationAddressQueryVariables>(GetOrganizationAddressDocument, options);
      }
export function useGetOrganizationAddressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationAddressQuery, GetOrganizationAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationAddressQuery, GetOrganizationAddressQueryVariables>(GetOrganizationAddressDocument, options);
        }
export type GetOrganizationAddressQueryHookResult = ReturnType<typeof useGetOrganizationAddressQuery>;
export type GetOrganizationAddressLazyQueryHookResult = ReturnType<typeof useGetOrganizationAddressLazyQuery>;
export type GetOrganizationAddressQueryResult = Apollo.QueryResult<GetOrganizationAddressQuery, GetOrganizationAddressQueryVariables>;
export const GetOrganizationAddressesDocument = gql`
    query getOrganizationAddresses($first: Int!, $page: Int) {
  getOrganizationAddresses(first: $first, page: $page) {
    data {
      city
      country
      id
      isPrimary
      latitude
      line1
      line2
      longitude
      state
      zip
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useGetOrganizationAddressesQuery__
 *
 * To run a query within a React component, call `useGetOrganizationAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationAddressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationAddressesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetOrganizationAddressesQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationAddressesQuery, GetOrganizationAddressesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationAddressesQuery, GetOrganizationAddressesQueryVariables>(GetOrganizationAddressesDocument, options);
      }
export function useGetOrganizationAddressesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationAddressesQuery, GetOrganizationAddressesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationAddressesQuery, GetOrganizationAddressesQueryVariables>(GetOrganizationAddressesDocument, options);
        }
export type GetOrganizationAddressesQueryHookResult = ReturnType<typeof useGetOrganizationAddressesQuery>;
export type GetOrganizationAddressesLazyQueryHookResult = ReturnType<typeof useGetOrganizationAddressesLazyQuery>;
export type GetOrganizationAddressesQueryResult = Apollo.QueryResult<GetOrganizationAddressesQuery, GetOrganizationAddressesQueryVariables>;
export const GetOrganizationDataUploadsDocument = gql`
    query getOrganizationDataUploads($first: Int!, $page: Int) {
  getOrganizationDataUploads(first: $first, page: $page) {
    data {
      createdAt
      error
      id
      organization {
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        phone
        proposalDefaults {
          autoSave
          color
          id
          layout
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      startedAt
      status
      type
      updatedAt
      user {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          email
          emailTemplate
          failingPayment
          id
          logo
          name
          onTrial
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        status
      }
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useGetOrganizationDataUploadsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationDataUploadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationDataUploadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationDataUploadsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetOrganizationDataUploadsQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationDataUploadsQuery, GetOrganizationDataUploadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationDataUploadsQuery, GetOrganizationDataUploadsQueryVariables>(GetOrganizationDataUploadsDocument, options);
      }
export function useGetOrganizationDataUploadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationDataUploadsQuery, GetOrganizationDataUploadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationDataUploadsQuery, GetOrganizationDataUploadsQueryVariables>(GetOrganizationDataUploadsDocument, options);
        }
export type GetOrganizationDataUploadsQueryHookResult = ReturnType<typeof useGetOrganizationDataUploadsQuery>;
export type GetOrganizationDataUploadsLazyQueryHookResult = ReturnType<typeof useGetOrganizationDataUploadsLazyQuery>;
export type GetOrganizationDataUploadsQueryResult = Apollo.QueryResult<GetOrganizationDataUploadsQuery, GetOrganizationDataUploadsQueryVariables>;
export const GetOrganizationEmailTemplateDocument = gql`
    query getOrganizationEmailTemplate($type: OrganizationEmailTemplateType!) {
  getOrganizationEmailTemplate(type: $type) {
    html
    id
    organization {
      conversionFactorOverride {
        asphaltTonConversionFactorOverride
        excavateOutTonConversionFactorOverride
        id
        organization {
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          proposalDefaults {
            autoSave
            color
            id
            layout
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
      }
      email
      emailTemplate
      failingPayment
      id
      logo
      name
      onTrial
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    type
  }
}
    `;

/**
 * __useGetOrganizationEmailTemplateQuery__
 *
 * To run a query within a React component, call `useGetOrganizationEmailTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationEmailTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationEmailTemplateQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetOrganizationEmailTemplateQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationEmailTemplateQuery, GetOrganizationEmailTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationEmailTemplateQuery, GetOrganizationEmailTemplateQueryVariables>(GetOrganizationEmailTemplateDocument, options);
      }
export function useGetOrganizationEmailTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationEmailTemplateQuery, GetOrganizationEmailTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationEmailTemplateQuery, GetOrganizationEmailTemplateQueryVariables>(GetOrganizationEmailTemplateDocument, options);
        }
export type GetOrganizationEmailTemplateQueryHookResult = ReturnType<typeof useGetOrganizationEmailTemplateQuery>;
export type GetOrganizationEmailTemplateLazyQueryHookResult = ReturnType<typeof useGetOrganizationEmailTemplateLazyQuery>;
export type GetOrganizationEmailTemplateQueryResult = Apollo.QueryResult<GetOrganizationEmailTemplateQuery, GetOrganizationEmailTemplateQueryVariables>;
export const GetOrganizationEmailTemplatesDocument = gql`
    query getOrganizationEmailTemplates {
  getOrganizationEmailTemplates {
    html
    id
    organization {
      conversionFactorOverride {
        asphaltTonConversionFactorOverride
        excavateOutTonConversionFactorOverride
        id
        organization {
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          proposalDefaults {
            autoSave
            color
            id
            layout
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
      }
      email
      emailTemplate
      failingPayment
      id
      logo
      name
      onTrial
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    type
  }
}
    `;

/**
 * __useGetOrganizationEmailTemplatesQuery__
 *
 * To run a query within a React component, call `useGetOrganizationEmailTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationEmailTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationEmailTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizationEmailTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationEmailTemplatesQuery, GetOrganizationEmailTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationEmailTemplatesQuery, GetOrganizationEmailTemplatesQueryVariables>(GetOrganizationEmailTemplatesDocument, options);
      }
export function useGetOrganizationEmailTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationEmailTemplatesQuery, GetOrganizationEmailTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationEmailTemplatesQuery, GetOrganizationEmailTemplatesQueryVariables>(GetOrganizationEmailTemplatesDocument, options);
        }
export type GetOrganizationEmailTemplatesQueryHookResult = ReturnType<typeof useGetOrganizationEmailTemplatesQuery>;
export type GetOrganizationEmailTemplatesLazyQueryHookResult = ReturnType<typeof useGetOrganizationEmailTemplatesLazyQuery>;
export type GetOrganizationEmailTemplatesQueryResult = Apollo.QueryResult<GetOrganizationEmailTemplatesQuery, GetOrganizationEmailTemplatesQueryVariables>;
export const GetOrganizationProductTypeDocument = gql`
    query getOrganizationProductType($id: ID!) {
  getOrganizationProductType(id: $id) {
    id
    indirectPercentage
    markupPercentage
    name
    overheadPercentage
    type
  }
}
    `;

/**
 * __useGetOrganizationProductTypeQuery__
 *
 * To run a query within a React component, call `useGetOrganizationProductTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationProductTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationProductTypeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrganizationProductTypeQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationProductTypeQuery, GetOrganizationProductTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationProductTypeQuery, GetOrganizationProductTypeQueryVariables>(GetOrganizationProductTypeDocument, options);
      }
export function useGetOrganizationProductTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationProductTypeQuery, GetOrganizationProductTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationProductTypeQuery, GetOrganizationProductTypeQueryVariables>(GetOrganizationProductTypeDocument, options);
        }
export type GetOrganizationProductTypeQueryHookResult = ReturnType<typeof useGetOrganizationProductTypeQuery>;
export type GetOrganizationProductTypeLazyQueryHookResult = ReturnType<typeof useGetOrganizationProductTypeLazyQuery>;
export type GetOrganizationProductTypeQueryResult = Apollo.QueryResult<GetOrganizationProductTypeQuery, GetOrganizationProductTypeQueryVariables>;
export const GetOrganizationProductTypesDocument = gql`
    query getOrganizationProductTypes {
  getOrganizationProductTypes {
    id
    indirectPercentage
    markupPercentage
    name
    overheadPercentage
    type
  }
}
    `;

/**
 * __useGetOrganizationProductTypesQuery__
 *
 * To run a query within a React component, call `useGetOrganizationProductTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationProductTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationProductTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizationProductTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationProductTypesQuery, GetOrganizationProductTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationProductTypesQuery, GetOrganizationProductTypesQueryVariables>(GetOrganizationProductTypesDocument, options);
      }
export function useGetOrganizationProductTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationProductTypesQuery, GetOrganizationProductTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationProductTypesQuery, GetOrganizationProductTypesQueryVariables>(GetOrganizationProductTypesDocument, options);
        }
export type GetOrganizationProductTypesQueryHookResult = ReturnType<typeof useGetOrganizationProductTypesQuery>;
export type GetOrganizationProductTypesLazyQueryHookResult = ReturnType<typeof useGetOrganizationProductTypesLazyQuery>;
export type GetOrganizationProductTypesQueryResult = Apollo.QueryResult<GetOrganizationProductTypesQuery, GetOrganizationProductTypesQueryVariables>;
export const GetOrganizationProposalContentDocument = gql`
    query getOrganizationProposalContent {
  getOrganizationProposalContent {
    content
    id
    type
  }
}
    `;

/**
 * __useGetOrganizationProposalContentQuery__
 *
 * To run a query within a React component, call `useGetOrganizationProposalContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationProposalContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationProposalContentQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizationProposalContentQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationProposalContentQuery, GetOrganizationProposalContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationProposalContentQuery, GetOrganizationProposalContentQueryVariables>(GetOrganizationProposalContentDocument, options);
      }
export function useGetOrganizationProposalContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationProposalContentQuery, GetOrganizationProposalContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationProposalContentQuery, GetOrganizationProposalContentQueryVariables>(GetOrganizationProposalContentDocument, options);
        }
export type GetOrganizationProposalContentQueryHookResult = ReturnType<typeof useGetOrganizationProposalContentQuery>;
export type GetOrganizationProposalContentLazyQueryHookResult = ReturnType<typeof useGetOrganizationProposalContentLazyQuery>;
export type GetOrganizationProposalContentQueryResult = Apollo.QueryResult<GetOrganizationProposalContentQuery, GetOrganizationProposalContentQueryVariables>;
export const GetOrganizationSettingsDocument = gql`
    query getOrganizationSettings {
  getOrganizationSettings {
    key
    value
  }
}
    `;

/**
 * __useGetOrganizationSettingsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizationSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationSettingsQuery, GetOrganizationSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationSettingsQuery, GetOrganizationSettingsQueryVariables>(GetOrganizationSettingsDocument, options);
      }
export function useGetOrganizationSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationSettingsQuery, GetOrganizationSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationSettingsQuery, GetOrganizationSettingsQueryVariables>(GetOrganizationSettingsDocument, options);
        }
export type GetOrganizationSettingsQueryHookResult = ReturnType<typeof useGetOrganizationSettingsQuery>;
export type GetOrganizationSettingsLazyQueryHookResult = ReturnType<typeof useGetOrganizationSettingsLazyQuery>;
export type GetOrganizationSettingsQueryResult = Apollo.QueryResult<GetOrganizationSettingsQuery, GetOrganizationSettingsQueryVariables>;
export const GetOrganizationUserDocument = gql`
    query getOrganizationUser($id: ID!) {
  getOrganizationUser(id: $id) {
    addressCity
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZip
    autoAssign
    avatar
    crewsCount
    email
    firstName
    hasEmployee
    id
    inviteToken
    invitedAt
    invitedBy {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          proposalDefaults {
            autoSave
            color
            id
            layout
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
    jobPhasesCount
    jobsCount
    lastName
    name
    organization {
      email
      emailTemplate
      failingPayment
      id
      logo
      name
      onTrial
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    permissions
    phone
    proposalCount
    roles
    status
  }
}
    `;

/**
 * __useGetOrganizationUserQuery__
 *
 * To run a query within a React component, call `useGetOrganizationUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrganizationUserQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationUserQuery, GetOrganizationUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationUserQuery, GetOrganizationUserQueryVariables>(GetOrganizationUserDocument, options);
      }
export function useGetOrganizationUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationUserQuery, GetOrganizationUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationUserQuery, GetOrganizationUserQueryVariables>(GetOrganizationUserDocument, options);
        }
export type GetOrganizationUserQueryHookResult = ReturnType<typeof useGetOrganizationUserQuery>;
export type GetOrganizationUserLazyQueryHookResult = ReturnType<typeof useGetOrganizationUserLazyQuery>;
export type GetOrganizationUserQueryResult = Apollo.QueryResult<GetOrganizationUserQuery, GetOrganizationUserQueryVariables>;
export const GetOrganizationUsersDocument = gql`
    query getOrganizationUsers($first: Int!, $page: Int, $roles: [UserRole], $search: String, $status: UserStatus) {
  getOrganizationUsers(
    first: $first
    page: $page
    roles: $roles
    search: $search
    status: $status
  ) {
    data {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        permissions
        phone
        proposalCount
        roles
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      organization {
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        phone
        proposalDefaults {
          autoSave
          color
          id
          layout
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      permissions
      phone
      proposalCount
      roles
      status
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useGetOrganizationUsersQuery__
 *
 * To run a query within a React component, call `useGetOrganizationUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationUsersQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      roles: // value for 'roles'
 *      search: // value for 'search'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetOrganizationUsersQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationUsersQuery, GetOrganizationUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationUsersQuery, GetOrganizationUsersQueryVariables>(GetOrganizationUsersDocument, options);
      }
export function useGetOrganizationUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationUsersQuery, GetOrganizationUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationUsersQuery, GetOrganizationUsersQueryVariables>(GetOrganizationUsersDocument, options);
        }
export type GetOrganizationUsersQueryHookResult = ReturnType<typeof useGetOrganizationUsersQuery>;
export type GetOrganizationUsersLazyQueryHookResult = ReturnType<typeof useGetOrganizationUsersLazyQuery>;
export type GetOrganizationUsersQueryResult = Apollo.QueryResult<GetOrganizationUsersQuery, GetOrganizationUsersQueryVariables>;
export const GetPersonsStatsDocument = gql`
    query getPersonsStats {
  getPersonsStats {
    firstName
    lastName
    proposalsWonCount
    proposalsWonPercentage
    proposalsWonSum
    sentProposalsCount
    winRate
  }
}
    `;

/**
 * __useGetPersonsStatsQuery__
 *
 * To run a query within a React component, call `useGetPersonsStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonsStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonsStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPersonsStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetPersonsStatsQuery, GetPersonsStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPersonsStatsQuery, GetPersonsStatsQueryVariables>(GetPersonsStatsDocument, options);
      }
export function useGetPersonsStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPersonsStatsQuery, GetPersonsStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPersonsStatsQuery, GetPersonsStatsQueryVariables>(GetPersonsStatsDocument, options);
        }
export type GetPersonsStatsQueryHookResult = ReturnType<typeof useGetPersonsStatsQuery>;
export type GetPersonsStatsLazyQueryHookResult = ReturnType<typeof useGetPersonsStatsLazyQuery>;
export type GetPersonsStatsQueryResult = Apollo.QueryResult<GetPersonsStatsQuery, GetPersonsStatsQueryVariables>;
export const GetPlantDocument = gql`
    query getPlant($id: ID!) {
  getPlant(id: $id) {
    addressCity
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZip
    id
    name
    phone
    products {
      id
      rate
      type
    }
  }
}
    `;

/**
 * __useGetPlantQuery__
 *
 * To run a query within a React component, call `useGetPlantQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlantQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPlantQuery(baseOptions: Apollo.QueryHookOptions<GetPlantQuery, GetPlantQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlantQuery, GetPlantQueryVariables>(GetPlantDocument, options);
      }
export function useGetPlantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlantQuery, GetPlantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlantQuery, GetPlantQueryVariables>(GetPlantDocument, options);
        }
export type GetPlantQueryHookResult = ReturnType<typeof useGetPlantQuery>;
export type GetPlantLazyQueryHookResult = ReturnType<typeof useGetPlantLazyQuery>;
export type GetPlantQueryResult = Apollo.QueryResult<GetPlantQuery, GetPlantQueryVariables>;
export const GetPlantProductTypesDocument = gql`
    query getPlantProductTypes {
  getPlantProductTypes {
    id
    name
  }
}
    `;

/**
 * __useGetPlantProductTypesQuery__
 *
 * To run a query within a React component, call `useGetPlantProductTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlantProductTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlantProductTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPlantProductTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetPlantProductTypesQuery, GetPlantProductTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlantProductTypesQuery, GetPlantProductTypesQueryVariables>(GetPlantProductTypesDocument, options);
      }
export function useGetPlantProductTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlantProductTypesQuery, GetPlantProductTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlantProductTypesQuery, GetPlantProductTypesQueryVariables>(GetPlantProductTypesDocument, options);
        }
export type GetPlantProductTypesQueryHookResult = ReturnType<typeof useGetPlantProductTypesQuery>;
export type GetPlantProductTypesLazyQueryHookResult = ReturnType<typeof useGetPlantProductTypesLazyQuery>;
export type GetPlantProductTypesQueryResult = Apollo.QueryResult<GetPlantProductTypesQuery, GetPlantProductTypesQueryVariables>;
export const GetPlantTransferTrucksDocument = gql`
    query getPlantTransferTrucks($plantId: ID!) {
  getPlantTransferTrucks(plantId: $plantId) {
    id
    rateHourly
    rateTon
    tonnage
    transferTruck {
      defaultRateHourly
      defaultRateTon
      defaultTonnage
      id
      name
    }
  }
}
    `;

/**
 * __useGetPlantTransferTrucksQuery__
 *
 * To run a query within a React component, call `useGetPlantTransferTrucksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlantTransferTrucksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlantTransferTrucksQuery({
 *   variables: {
 *      plantId: // value for 'plantId'
 *   },
 * });
 */
export function useGetPlantTransferTrucksQuery(baseOptions: Apollo.QueryHookOptions<GetPlantTransferTrucksQuery, GetPlantTransferTrucksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlantTransferTrucksQuery, GetPlantTransferTrucksQueryVariables>(GetPlantTransferTrucksDocument, options);
      }
export function useGetPlantTransferTrucksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlantTransferTrucksQuery, GetPlantTransferTrucksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlantTransferTrucksQuery, GetPlantTransferTrucksQueryVariables>(GetPlantTransferTrucksDocument, options);
        }
export type GetPlantTransferTrucksQueryHookResult = ReturnType<typeof useGetPlantTransferTrucksQuery>;
export type GetPlantTransferTrucksLazyQueryHookResult = ReturnType<typeof useGetPlantTransferTrucksLazyQuery>;
export type GetPlantTransferTrucksQueryResult = Apollo.QueryResult<GetPlantTransferTrucksQuery, GetPlantTransferTrucksQueryVariables>;
export const GetPlantsDocument = gql`
    query getPlants($first: Int!, $page: Int, $search: String) {
  getPlants(first: $first, page: $page, search: $search) {
    data {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      id
      name
      phone
      products {
        id
        rate
        type
      }
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useGetPlantsQuery__
 *
 * To run a query within a React component, call `useGetPlantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlantsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetPlantsQuery(baseOptions: Apollo.QueryHookOptions<GetPlantsQuery, GetPlantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlantsQuery, GetPlantsQueryVariables>(GetPlantsDocument, options);
      }
export function useGetPlantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlantsQuery, GetPlantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlantsQuery, GetPlantsQueryVariables>(GetPlantsDocument, options);
        }
export type GetPlantsQueryHookResult = ReturnType<typeof useGetPlantsQuery>;
export type GetPlantsLazyQueryHookResult = ReturnType<typeof useGetPlantsLazyQuery>;
export type GetPlantsQueryResult = Apollo.QueryResult<GetPlantsQuery, GetPlantsQueryVariables>;
export const GetPreviousMonthStatsDocument = gql`
    query getPreviousMonthStats {
  getPreviousMonthStats {
    closedBids
    closedRate
    closedRevenue
    sentBids
  }
}
    `;

/**
 * __useGetPreviousMonthStatsQuery__
 *
 * To run a query within a React component, call `useGetPreviousMonthStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreviousMonthStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreviousMonthStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPreviousMonthStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetPreviousMonthStatsQuery, GetPreviousMonthStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPreviousMonthStatsQuery, GetPreviousMonthStatsQueryVariables>(GetPreviousMonthStatsDocument, options);
      }
export function useGetPreviousMonthStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPreviousMonthStatsQuery, GetPreviousMonthStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPreviousMonthStatsQuery, GetPreviousMonthStatsQueryVariables>(GetPreviousMonthStatsDocument, options);
        }
export type GetPreviousMonthStatsQueryHookResult = ReturnType<typeof useGetPreviousMonthStatsQuery>;
export type GetPreviousMonthStatsLazyQueryHookResult = ReturnType<typeof useGetPreviousMonthStatsLazyQuery>;
export type GetPreviousMonthStatsQueryResult = Apollo.QueryResult<GetPreviousMonthStatsQuery, GetPreviousMonthStatsQueryVariables>;
export const GetProductDocument = gql`
    query getProduct($id: ID!) {
  getProduct(id: $id) {
    areaCoverage
    attributes {
      __typename
      ... on ProductAttributeAsphalt {
        applicationRate
      }
      ... on ProductAttributeConcreteColumn {
        diameter
        height
      }
      ... on ProductAttributeConcreteCurbOrGutter {
        curbHeight
        curbWidth
        gutterHeight
        gutterWidth
      }
      ... on ProductAttributeConcreteFlatwork {
        applicationRate
      }
      ... on ProductAttributeConcreteFooting {
        depth
        width
      }
      ... on ProductAttributeConcreteWall {
        height
        width
      }
      ... on ProductAttributeConcreteWaterway {
        curbHeight
        curbWidth
        gutterHeight
        gutterWidth
      }
      ... on ProductAttributeCrackSeal {
        crackDepth
        crackWidth
        overbandThickness
        overbandWidth
        poundsPerBlock
        poundsPerGallon
      }
      ... on ProductAttributeCurbWall {
        curbHeight
        curbWidth
        gutterHeight
        gutterWidth
      }
      ... on ProductAttributeExcavateOut {
        applicationRate
      }
      ... on ProductAttributeGrading {
        applicationRate
        poundsPerCubicYard
      }
      ... on ProductAttributeMastic {
        crackDepth
        crackWidth
        overbandThickness
        overbandWidth
        poundsPerBlock
        poundsPerGallon
      }
      ... on ProductAttributeMicrosurfacing {
        applicationRate
      }
      ... on ProductAttributeSealCoat {
        applicationRate
      }
      ... on ProductAttributeSlurrySeal {
        applicationRate
      }
      ... on ProductAttributeStriping {
        applicationRate
        lineWidth
      }
    }
    costMaterial
    costMinimumProduct
    costMinimumProposal
    crew {
      color
      displayName
      employees {
        firstName
        id
        lastName
        name
        organizationId
        rate
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
      }
      foremanUser {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          proposalDefaults {
            autoSave
            color
            id
            layout
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        status
      }
      id
      name
      organization {
        email
        emailTemplate
        failingPayment
        id
        logo
        name
        onTrial
        phone
        proposalSentEmailText
        subscribed
        timezone
        trialEndsAt
      }
      rate
    }
    dailyUnitsComplete
    externalProductName
    id
    indirectPercentage
    labourCostType
    markupPercentage
    measurementJob
    measurementMaterial
    name
    organizationProductType {
      id
      indirectPercentage
      markupPercentage
      name
      overheadPercentage
      type
    }
    overheadPercentage
    plant {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      id
      name
      phone
      products {
        id
        rate
        type
      }
    }
    plantProductId
    productAdditionalCosts {
      additionalCost {
        cost
        feeAmount
        feeType
        id
        name
      }
      id
      type
    }
    productEquipmentPieces {
      equipmentPiece {
        chargeType
        fuelSurcharge
        id
        name
        rate
        usePercentage
      }
      id
      quantity
    }
    productionRateType
    statementOfWork
    subcontracted
    type
    unitPrice
    unitPriceProduct
  }
}
    `;

/**
 * __useGetProductQuery__
 *
 * To run a query within a React component, call `useGetProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProductQuery(baseOptions: Apollo.QueryHookOptions<GetProductQuery, GetProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
      }
export function useGetProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductQuery, GetProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
        }
export type GetProductQueryHookResult = ReturnType<typeof useGetProductQuery>;
export type GetProductLazyQueryHookResult = ReturnType<typeof useGetProductLazyQuery>;
export type GetProductQueryResult = Apollo.QueryResult<GetProductQuery, GetProductQueryVariables>;
export const GetProductStatsDocument = gql`
    query getProductStats {
  getProductStats {
    materialUsed {
      jobSizeComplete
      productMaterialUsed
      productType
      proposalJobSize
      proposalMaterialNeeded
    }
    productTypeUsedPercentages {
      equipmentUsedPercentage
      labourUsedPercentage
      materialUsedPercentage
      productType
    }
    products {
      actualProfitPercentage
      name
      proposedProfitPercentage
      sumOverallTotal
    }
  }
}
    `;

/**
 * __useGetProductStatsQuery__
 *
 * To run a query within a React component, call `useGetProductStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProductStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetProductStatsQuery, GetProductStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductStatsQuery, GetProductStatsQueryVariables>(GetProductStatsDocument, options);
      }
export function useGetProductStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductStatsQuery, GetProductStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductStatsQuery, GetProductStatsQueryVariables>(GetProductStatsDocument, options);
        }
export type GetProductStatsQueryHookResult = ReturnType<typeof useGetProductStatsQuery>;
export type GetProductStatsLazyQueryHookResult = ReturnType<typeof useGetProductStatsLazyQuery>;
export type GetProductStatsQueryResult = Apollo.QueryResult<GetProductStatsQuery, GetProductStatsQueryVariables>;
export const GetProductsDocument = gql`
    query getProducts($first: Int!, $orderBy: [QueryGetProductsOrderByOrderByClause!], $organizationProductTypeId: ID, $page: Int, $search: String, $type: ProductType) {
  getProducts(
    first: $first
    orderBy: $orderBy
    organizationProductTypeId: $organizationProductTypeId
    page: $page
    search: $search
    type: $type
  ) {
    data {
      areaCoverage
      attributes {
        __typename
        ... on ProductAttributeAsphalt {
          applicationRate
        }
        ... on ProductAttributeConcreteColumn {
          diameter
          height
        }
        ... on ProductAttributeConcreteCurbOrGutter {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeConcreteFlatwork {
          applicationRate
        }
        ... on ProductAttributeConcreteFooting {
          depth
          width
        }
        ... on ProductAttributeConcreteWall {
          height
          width
        }
        ... on ProductAttributeConcreteWaterway {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeCrackSeal {
          crackDepth
          crackWidth
          overbandThickness
          overbandWidth
          poundsPerBlock
          poundsPerGallon
        }
        ... on ProductAttributeCurbWall {
          curbHeight
          curbWidth
          gutterHeight
          gutterWidth
        }
        ... on ProductAttributeExcavateOut {
          applicationRate
        }
        ... on ProductAttributeGrading {
          applicationRate
          poundsPerCubicYard
        }
        ... on ProductAttributeMastic {
          crackDepth
          crackWidth
          overbandThickness
          overbandWidth
          poundsPerBlock
          poundsPerGallon
        }
        ... on ProductAttributeMicrosurfacing {
          applicationRate
        }
        ... on ProductAttributeSealCoat {
          applicationRate
        }
        ... on ProductAttributeSlurrySeal {
          applicationRate
        }
        ... on ProductAttributeStriping {
          applicationRate
          lineWidth
        }
      }
      costMaterial
      costMinimumProduct
      costMinimumProposal
      crew {
        color
        displayName
        employees {
          firstName
          id
          lastName
          name
          organizationId
          rate
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
        }
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        id
        name
        organization {
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          proposalDefaults {
            autoSave
            color
            id
            layout
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        rate
      }
      dailyUnitsComplete
      externalProductName
      id
      indirectPercentage
      labourCostType
      markupPercentage
      measurementJob
      measurementMaterial
      name
      organizationProductType {
        id
        indirectPercentage
        markupPercentage
        name
        overheadPercentage
        type
      }
      overheadPercentage
      plant {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        id
        name
        phone
        products {
          id
          rate
          type
        }
      }
      plantProductId
      productAdditionalCosts {
        additionalCost {
          cost
          feeAmount
          feeType
          id
          name
        }
        id
        type
      }
      productEquipmentPieces {
        equipmentPiece {
          chargeType
          fuelSurcharge
          id
          name
          rate
          usePercentage
        }
        id
        quantity
      }
      productionRateType
      statementOfWork
      subcontracted
      type
      unitPrice
      unitPriceProduct
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useGetProductsQuery__
 *
 * To run a query within a React component, call `useGetProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      orderBy: // value for 'orderBy'
 *      organizationProductTypeId: // value for 'organizationProductTypeId'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetProductsQuery(baseOptions: Apollo.QueryHookOptions<GetProductsQuery, GetProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
      }
export function useGetProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsQuery, GetProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
        }
export type GetProductsQueryHookResult = ReturnType<typeof useGetProductsQuery>;
export type GetProductsLazyQueryHookResult = ReturnType<typeof useGetProductsLazyQuery>;
export type GetProductsQueryResult = Apollo.QueryResult<GetProductsQuery, GetProductsQueryVariables>;
export const GetProjectFileDocument = gql`
    query getProjectFile($id: ID!) {
  getProjectFile(id: $id) {
    children {
      children {
        fileSizeBytes
        id
        name
        parentFolderId
        path
        type
      }
      fileSizeBytes
      id
      name
      parentFolderId
      path
      type
    }
    fileSizeBytes
    id
    name
    parentFolderId
    path
    type
  }
}
    `;

/**
 * __useGetProjectFileQuery__
 *
 * To run a query within a React component, call `useGetProjectFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectFileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectFileQuery(baseOptions: Apollo.QueryHookOptions<GetProjectFileQuery, GetProjectFileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectFileQuery, GetProjectFileQueryVariables>(GetProjectFileDocument, options);
      }
export function useGetProjectFileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectFileQuery, GetProjectFileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectFileQuery, GetProjectFileQueryVariables>(GetProjectFileDocument, options);
        }
export type GetProjectFileQueryHookResult = ReturnType<typeof useGetProjectFileQuery>;
export type GetProjectFileLazyQueryHookResult = ReturnType<typeof useGetProjectFileLazyQuery>;
export type GetProjectFileQueryResult = Apollo.QueryResult<GetProjectFileQuery, GetProjectFileQueryVariables>;
export const GetProjectFilesDocument = gql`
    query getProjectFiles {
  getProjectFiles {
    children {
      children {
        fileSizeBytes
        id
        name
        parentFolderId
        path
        type
      }
      fileSizeBytes
      id
      name
      parentFolderId
      path
      type
    }
    fileSizeBytes
    id
    name
    parentFolderId
    path
    type
  }
}
    `;

/**
 * __useGetProjectFilesQuery__
 *
 * To run a query within a React component, call `useGetProjectFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectFilesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProjectFilesQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectFilesQuery, GetProjectFilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectFilesQuery, GetProjectFilesQueryVariables>(GetProjectFilesDocument, options);
      }
export function useGetProjectFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectFilesQuery, GetProjectFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectFilesQuery, GetProjectFilesQueryVariables>(GetProjectFilesDocument, options);
        }
export type GetProjectFilesQueryHookResult = ReturnType<typeof useGetProjectFilesQuery>;
export type GetProjectFilesLazyQueryHookResult = ReturnType<typeof useGetProjectFilesLazyQuery>;
export type GetProjectFilesQueryResult = Apollo.QueryResult<GetProjectFilesQuery, GetProjectFilesQueryVariables>;
export const GetProposalDocument = gql`
    query getProposal($id: ID!) {
  getProposal(id: $id) {
    acceptanceOverride
    activeVersion
    addresses {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      mapImage
      organizationAddressId
      state
      zip
    }
    attachments {
      id
      name
      organization {
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
        }
        documents {
          id
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        phone
        proposalDefaults {
          autoSave
          color
          id
          layout
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
      path
      thumbnailPath
    }
    changeOrderJobId
    changeOrders {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        changeOrderJobId
        clientEmailOverride
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          contacts {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          email
          id
          jobsCount
          logo
          name
          notes
          notificationTypes {
            CONTACT
            JOB
            JOB_PHASE
            OPPORTUNITY
            PROPOSAL
          }
          phone
          primaryContact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        events {
          action
          createdAt
        }
        externalId
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterTaxes
        profit
        profitPercentage
        projectFilesFolderId
        proposalNotes
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          profit
          profitPercentage
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          roundTripTravelTimeHours
        }
        status
        statusChanges {
          changeAt
          changedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          status
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
        uuid
        version
        versions {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        wonAt
      }
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    clientEmailOverride
    company {
      addCompanyInfo
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      jobsCount
      logo
      name
      notes
      phone
      projectFilesFolderId
      proposalsCount
      status
      website
    }
    contact {
      SMSNotifications
      SMSNotificationsReadOnly
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    contactId
    costAdditional
    costDirect
    costEquipment
    costIndirect
    costLabour
    costMaterial
    costOverhead
    costTaxes
    costTotal
    createdAt
    emailBodyOverride
    emailBodyOverrideParsed
    emailSubjectOverride
    events {
      action
      createdAt
    }
    externalId
    grossMargin
    grossMarginPercentage
    id
    isChangeOrder
    isSendable
    layout
    netMargin
    netMarginPercentage
    operatingMargin
    operatingMarginPercentage
    overallTotal
    overallTotalAfterTaxes
    profit
    profitPercentage
    projectFilesFolderId
    proposalNotes
    recipients {
      contactId
      createdAt
      email
      id
    }
    removeIndividualLineItemPricing
    removeUnitPriceAndQuantity
    salesTaxes {
      id
      name
      organizationSalesTaxId
      percentage
    }
    sentAt
    signedAt
    signedInitials
    signedName
    source
    stages {
      addressOverride
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTotal
      distanceMeters
      distanceSeconds
      grossMargin
      grossMarginPercentage
      id
      mapData
      mapImage
      mapImageDirty
      name
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      ordering
      overallTotal
      profit
      profitPercentage
      roundTripTravelTimeHours
    }
    status
    statusChanges {
      changeAt
      status
    }
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
    userId
    uuid
    version
    versions {
      acceptanceOverride
      activeVersion
      changeOrderJobId
      clientEmailOverride
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      sentAt
      signedAt
      signedInitials
      signedName
      source
      status
      userId
      uuid
      version
      wonAt
    }
    wonAt
  }
}
    `;

/**
 * __useGetProposalQuery__
 *
 * To run a query within a React component, call `useGetProposalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProposalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProposalQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProposalQuery(baseOptions: Apollo.QueryHookOptions<GetProposalQuery, GetProposalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProposalQuery, GetProposalQueryVariables>(GetProposalDocument, options);
      }
export function useGetProposalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProposalQuery, GetProposalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProposalQuery, GetProposalQueryVariables>(GetProposalDocument, options);
        }
export type GetProposalQueryHookResult = ReturnType<typeof useGetProposalQuery>;
export type GetProposalLazyQueryHookResult = ReturnType<typeof useGetProposalLazyQuery>;
export type GetProposalQueryResult = Apollo.QueryResult<GetProposalQuery, GetProposalQueryVariables>;
export const GetProposalProductMapDataDocument = gql`
    query getProposalProductMapData($proposalProductId: ID!, $token: String!) {
  getProposalProductMapData(proposalProductId: $proposalProductId, token: $token)
}
    `;

/**
 * __useGetProposalProductMapDataQuery__
 *
 * To run a query within a React component, call `useGetProposalProductMapDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProposalProductMapDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProposalProductMapDataQuery({
 *   variables: {
 *      proposalProductId: // value for 'proposalProductId'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGetProposalProductMapDataQuery(baseOptions: Apollo.QueryHookOptions<GetProposalProductMapDataQuery, GetProposalProductMapDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProposalProductMapDataQuery, GetProposalProductMapDataQueryVariables>(GetProposalProductMapDataDocument, options);
      }
export function useGetProposalProductMapDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProposalProductMapDataQuery, GetProposalProductMapDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProposalProductMapDataQuery, GetProposalProductMapDataQueryVariables>(GetProposalProductMapDataDocument, options);
        }
export type GetProposalProductMapDataQueryHookResult = ReturnType<typeof useGetProposalProductMapDataQuery>;
export type GetProposalProductMapDataLazyQueryHookResult = ReturnType<typeof useGetProposalProductMapDataLazyQuery>;
export type GetProposalProductMapDataQueryResult = Apollo.QueryResult<GetProposalProductMapDataQuery, GetProposalProductMapDataQueryVariables>;
export const GetProposalsDocument = gql`
    query getProposals($companyId: ID, $first: Int!, $multipleCompanyIDs: [ID!], $multipleUserIDs: [ID!], $organizationProductTypeIds: [ID!], $page: Int, $search: String, $sortDirection: SortDirection, $sortKey: GetProposalsSortKey, $statuses: [ProposalStatus!], $userId: ID) {
  getProposals(
    companyId: $companyId
    first: $first
    multipleCompanyIDs: $multipleCompanyIDs
    multipleUserIDs: $multipleUserIDs
    organizationProductTypeIds: $organizationProductTypeIds
    page: $page
    search: $search
    sortDirection: $sortDirection
    sortKey: $sortKey
    statuses: $statuses
    userId: $userId
  ) {
    data {
      acceptanceOverride
      activeVersion
      addresses {
        city
        country
        id
        latitude
        line1
        line2
        longitude
        mapImage
        organizationAddressId
        state
        zip
      }
      attachments {
        id
        name
        organization {
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          proposalDefaults {
            autoSave
            color
            id
            layout
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        path
        thumbnailPath
      }
      changeOrderJobId
      changeOrders {
        acceptanceOverride
        activeVersion
        addresses {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        attachments {
          id
          name
          path
          thumbnailPath
        }
        changeOrderJobId
        changeOrders {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        clientEmailOverride
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        externalId
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterTaxes
        profit
        profitPercentage
        projectFilesFolderId
        proposalNotes
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        sentAt
        signedAt
        signedInitials
        signedName
        source
        status
        userId
        uuid
        version
        wonAt
      }
      clientEmailOverride
      company {
        addCompanyInfo
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        contacts {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        email
        id
        jobsCount
        logo
        name
        notes
        notificationTypes {
          CONTACT
          JOB
          JOB_PHASE
          OPPORTUNITY
          PROPOSAL
        }
        phone
        primaryContact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        projectFilesFolderId
        proposalsCount
        status
        website
      }
      contact {
        SMSNotifications
        SMSNotificationsReadOnly
        email
        firstName
        id
        lastName
        phone
        primary
        role
        title
      }
      contactId
      costAdditional
      costDirect
      costEquipment
      costIndirect
      costLabour
      costMaterial
      costOverhead
      costTaxes
      costTotal
      createdAt
      emailBodyOverride
      emailBodyOverrideParsed
      emailSubjectOverride
      events {
        action
        createdAt
      }
      externalId
      grossMargin
      grossMarginPercentage
      id
      isChangeOrder
      isSendable
      layout
      netMargin
      netMarginPercentage
      operatingMargin
      operatingMarginPercentage
      overallTotal
      overallTotalAfterTaxes
      profit
      profitPercentage
      projectFilesFolderId
      proposalNotes
      recipients {
        contactId
        createdAt
        email
        id
      }
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      salesTaxes {
        id
        name
        organizationSalesTaxId
        percentage
      }
      sentAt
      signedAt
      signedInitials
      signedName
      source
      stages {
        address {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        addressOverride
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTotal
        distanceMeters
        distanceSeconds
        grossMargin
        grossMarginPercentage
        id
        mapData
        mapImage
        mapImageDirty
        name
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        ordering
        overallTotal
        profit
        profitPercentage
        proposalProducts {
          additionalCosts {
            additionalCostId
            cost
            costOverride
            costTotal
            feeAmount
            feeAmountOverride
            feeType
            id
            name
            quantity
            quantityOverride
            showOnProposal
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          costTransferTruck
          crews {
            cost
            crewId
            id
            name
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
          }
          equipmentPieces {
            chargeType
            cost
            equipmentPieceId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
            usePercentage
          }
          externalProductName
          files {
            createdAt
            filename
            id
            thumbnail
            type
          }
          grossMargin
          grossMarginPercentage
          id
          isOptional
          jobDuration
          jobDurationDaysOverride
          jobDurationOverride
          jobSize
          mapData
          mapImage
          mapImageDirty
          material {
            areaCoverage
            attributes {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            attributesOverride {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            costMaterial
            costMaterialOverride
            costMinimumProduct
            costMinimumProposal
            dailyUnitsComplete
            dailyUnitsCompleteOverride
            externalProductName
            id
            indirectPercentage
            indirectPercentageOverride
            labourCostType
            markupPercentage
            markupPercentageOverride
            materialNeeded
            materialNeededOverride
            measurementJob
            measurementMaterial
            name
            organizationProductTypeName
            overheadPercentage
            overheadPercentageOverride
            productId
            productionRateType
            proposalId
            proposalProductId
            proposalStageId
            statementOfWork
            statementOfWorkOverride
            subcontracted
            tonConversionFactor
            tonConversionFactorOverride
            type
            unitPrice
            unitPriceOverride
            unitPriceProduct
          }
          measurementJob
          measurementMaterial
          netMargin
          netMarginPercentage
          notes
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalOverride
          plantProduct {
            id
            plantProductId
            rate
            rateOverride
            type
          }
          productName
          profit
          profitPercentage
          profitPercentageOverride
          roundTripTravelTimeHours
          statementOfWork
          subcontractorCost
          subcontractorName
          subcontractorProposalId
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTime
          transferTruckRoundTripTimeOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            quantity
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
        }
        roundTripTravelTimeHours
      }
      status
      statusChanges {
        changeAt
        changedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        status
      }
      user {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          email
          emailTemplate
          failingPayment
          id
          logo
          name
          onTrial
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        status
      }
      userId
      uuid
      version
      versions {
        acceptanceOverride
        activeVersion
        addresses {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        attachments {
          id
          name
          path
          thumbnailPath
        }
        changeOrderJobId
        changeOrders {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          userId
          uuid
          version
          wonAt
        }
        clientEmailOverride
        company {
          addCompanyInfo
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          email
          id
          jobsCount
          logo
          name
          notes
          phone
          projectFilesFolderId
          proposalsCount
          status
          website
        }
        contact {
          SMSNotifications
          SMSNotificationsReadOnly
          email
          firstName
          id
          lastName
          phone
          primary
          role
          title
        }
        contactId
        costAdditional
        costDirect
        costEquipment
        costIndirect
        costLabour
        costMaterial
        costOverhead
        costTaxes
        costTotal
        createdAt
        emailBodyOverride
        emailBodyOverrideParsed
        emailSubjectOverride
        events {
          action
          createdAt
        }
        externalId
        grossMargin
        grossMarginPercentage
        id
        isChangeOrder
        isSendable
        layout
        netMargin
        netMarginPercentage
        operatingMargin
        operatingMarginPercentage
        overallTotal
        overallTotalAfterTaxes
        profit
        profitPercentage
        projectFilesFolderId
        proposalNotes
        recipients {
          contactId
          createdAt
          email
          id
        }
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
        salesTaxes {
          id
          name
          organizationSalesTaxId
          percentage
        }
        sentAt
        signedAt
        signedInitials
        signedName
        source
        stages {
          addressOverride
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          profit
          profitPercentage
          roundTripTravelTimeHours
        }
        status
        statusChanges {
          changeAt
          status
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          jobPhasesCount
          jobsCount
          lastName
          name
          permissions
          phone
          proposalCount
          roles
          status
        }
        userId
        uuid
        version
        versions {
          acceptanceOverride
          activeVersion
          changeOrderJobId
          clientEmailOverride
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          sentAt
          signedAt
          signedInitials
          signedName
          source
          status
          userId
          uuid
          version
          wonAt
        }
        wonAt
      }
      wonAt
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useGetProposalsQuery__
 *
 * To run a query within a React component, call `useGetProposalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProposalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProposalsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      first: // value for 'first'
 *      multipleCompanyIDs: // value for 'multipleCompanyIDs'
 *      multipleUserIDs: // value for 'multipleUserIDs'
 *      organizationProductTypeIds: // value for 'organizationProductTypeIds'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      sortDirection: // value for 'sortDirection'
 *      sortKey: // value for 'sortKey'
 *      statuses: // value for 'statuses'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetProposalsQuery(baseOptions: Apollo.QueryHookOptions<GetProposalsQuery, GetProposalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProposalsQuery, GetProposalsQueryVariables>(GetProposalsDocument, options);
      }
export function useGetProposalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProposalsQuery, GetProposalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProposalsQuery, GetProposalsQueryVariables>(GetProposalsDocument, options);
        }
export type GetProposalsQueryHookResult = ReturnType<typeof useGetProposalsQuery>;
export type GetProposalsLazyQueryHookResult = ReturnType<typeof useGetProposalsLazyQuery>;
export type GetProposalsQueryResult = Apollo.QueryResult<GetProposalsQuery, GetProposalsQueryVariables>;
export const GetPublicProposalDocument = gql`
    query getPublicProposal($email: String, $token: String, $uuid: String!) {
  getPublicProposal(email: $email, token: $token, uuid: $uuid) {
    __typename
    ... on PublicProposal {
      acceptanceOverride
      attachments {
        id
        name
        organization {
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
            organization {
              conversionFactorOverride {
                asphaltTonConversionFactorOverride
                excavateOutTonConversionFactorOverride
                id
              }
              documents {
                id
                name
                path
                thumbnailPath
              }
              email
              emailTemplate
              failingPayment
              id
              linkedServices {
                active
                expired
                id
                service
                type
              }
              logo
              name
              onTrial
              phone
              proposalDefaults {
                autoSave
                color
                id
                layout
                removeIndividualLineItemPricing
                removeUnitPriceAndQuantity
              }
              proposalSentEmailText
              salesTaxes {
                id
                isDefault
                name
                percentage
                quickbooksDesktopTaxCodeId
                quickbooksTaxCodeId
              }
              subscribed
              subscription {
                endsAt
                id
                name
                quantity
                renewsAt
                stripeId
                stripePrice
                stripeStatus
                trialEndsAt
              }
              timezone
              trialEndsAt
            }
          }
          documents {
            id
            name
            organization {
              conversionFactorOverride {
                asphaltTonConversionFactorOverride
                excavateOutTonConversionFactorOverride
                id
              }
              documents {
                id
                name
                path
                thumbnailPath
              }
              email
              emailTemplate
              failingPayment
              id
              linkedServices {
                active
                expired
                id
                service
                type
              }
              logo
              name
              onTrial
              phone
              proposalDefaults {
                autoSave
                color
                id
                layout
                removeIndividualLineItemPricing
                removeUnitPriceAndQuantity
              }
              proposalSentEmailText
              salesTaxes {
                id
                isDefault
                name
                percentage
                quickbooksDesktopTaxCodeId
                quickbooksTaxCodeId
              }
              subscribed
              subscription {
                endsAt
                id
                name
                quantity
                renewsAt
                stripeId
                stripePrice
                stripeStatus
                trialEndsAt
              }
              timezone
              trialEndsAt
            }
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          proposalDefaults {
            autoSave
            color
            id
            layout
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        path
        thumbnailPath
      }
      company {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        email
        id
        name
        phone
        website
      }
      contact {
        email
        firstName
        id
        lastName
        phone
        title
      }
      content {
        content
        contentOverride
        type
      }
      costTaxes
      externalId
      id
      layout
      organization {
        address {
          city
          country
          id
          isPrimary
          latitude
          line1
          line2
          longitude
          state
          zip
        }
        email
        id
        logo
        name
        phone
        proposalDefaults {
          autoSave
          color
          id
          layout
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
        }
      }
      overallTotal
      overallTotalAfterTaxes
      proposalPDF
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
      salesTaxes {
        id
        name
        organizationSalesTaxId
        percentage
      }
      signedAt
      signeeInitials
      signeeName
      signeeTitle
      stages {
        address {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          state
          zip
        }
        addressOverride
        content {
          content
          contentOverride
          type
        }
        id
        name
        ordering
        overallTotal
        proposalProducts {
          additionalCosts {
            additionalCostId
            cost
            costOverride
            costTotal
            feeAmount
            feeAmountOverride
            feeType
            id
            name
            quantity
            quantityOverride
            showOnProposal
          }
          files {
            createdAt
            filename
            id
            thumbnail
            type
          }
          id
          isOptional
          jobDuration
          jobSize
          mapImage
          material {
            areaCoverage
            attributes {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            attributesOverride {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            costMaterial
            costMaterialOverride
            costMinimumProduct
            costMinimumProposal
            dailyUnitsComplete
            dailyUnitsCompleteOverride
            externalProductName
            id
            indirectPercentage
            indirectPercentageOverride
            labourCostType
            markupPercentage
            markupPercentageOverride
            materialNeeded
            materialNeededOverride
            measurementJob
            measurementMaterial
            name
            organizationProductTypeName
            overheadPercentage
            overheadPercentageOverride
            productId
            productionRateType
            proposalId
            proposalProductId
            proposalStageId
            statementOfWork
            statementOfWorkOverride
            subcontracted
            tonConversionFactor
            tonConversionFactorOverride
            type
            unitPrice
            unitPriceOverride
            unitPriceProduct
          }
          ordering
          overallTotal
          overallTotalOverride
          statementOfWork
        }
      }
      status
      user {
        email
        firstName
        id
        lastName
        phone
      }
    }
    ... on PublicProposalOrganization {
      estimatorEmail
      id
      logo
    }
  }
}
    `;

/**
 * __useGetPublicProposalQuery__
 *
 * To run a query within a React component, call `useGetPublicProposalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicProposalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicProposalQuery({
 *   variables: {
 *      email: // value for 'email'
 *      token: // value for 'token'
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetPublicProposalQuery(baseOptions: Apollo.QueryHookOptions<GetPublicProposalQuery, GetPublicProposalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicProposalQuery, GetPublicProposalQueryVariables>(GetPublicProposalDocument, options);
      }
export function useGetPublicProposalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicProposalQuery, GetPublicProposalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicProposalQuery, GetPublicProposalQueryVariables>(GetPublicProposalDocument, options);
        }
export type GetPublicProposalQueryHookResult = ReturnType<typeof useGetPublicProposalQuery>;
export type GetPublicProposalLazyQueryHookResult = ReturnType<typeof useGetPublicProposalLazyQuery>;
export type GetPublicProposalQueryResult = Apollo.QueryResult<GetPublicProposalQuery, GetPublicProposalQueryVariables>;
export const GetPublicProposalCompanyOrgDocument = gql`
    query getPublicProposalCompanyOrg($uuid: String!) {
  getPublicProposalCompanyOrg(uuid: $uuid) {
    company {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      name
      phone
      website
    }
    organization {
      address {
        city
        country
        id
        isPrimary
        latitude
        line1
        line2
        longitude
        state
        zip
      }
      email
      id
      logo
      name
      phone
      proposalDefaults {
        autoSave
        color
        id
        layout
        removeIndividualLineItemPricing
        removeUnitPriceAndQuantity
      }
    }
  }
}
    `;

/**
 * __useGetPublicProposalCompanyOrgQuery__
 *
 * To run a query within a React component, call `useGetPublicProposalCompanyOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicProposalCompanyOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicProposalCompanyOrgQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useGetPublicProposalCompanyOrgQuery(baseOptions: Apollo.QueryHookOptions<GetPublicProposalCompanyOrgQuery, GetPublicProposalCompanyOrgQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicProposalCompanyOrgQuery, GetPublicProposalCompanyOrgQueryVariables>(GetPublicProposalCompanyOrgDocument, options);
      }
export function useGetPublicProposalCompanyOrgLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicProposalCompanyOrgQuery, GetPublicProposalCompanyOrgQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicProposalCompanyOrgQuery, GetPublicProposalCompanyOrgQueryVariables>(GetPublicProposalCompanyOrgDocument, options);
        }
export type GetPublicProposalCompanyOrgQueryHookResult = ReturnType<typeof useGetPublicProposalCompanyOrgQuery>;
export type GetPublicProposalCompanyOrgLazyQueryHookResult = ReturnType<typeof useGetPublicProposalCompanyOrgLazyQuery>;
export type GetPublicProposalCompanyOrgQueryResult = Apollo.QueryResult<GetPublicProposalCompanyOrgQuery, GetPublicProposalCompanyOrgQueryVariables>;
export const GetQuickbooksIncomeAccountsDocument = gql`
    query getQuickbooksIncomeAccounts {
  getQuickbooksIncomeAccounts {
    id
    name
  }
}
    `;

/**
 * __useGetQuickbooksIncomeAccountsQuery__
 *
 * To run a query within a React component, call `useGetQuickbooksIncomeAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuickbooksIncomeAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuickbooksIncomeAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetQuickbooksIncomeAccountsQuery(baseOptions?: Apollo.QueryHookOptions<GetQuickbooksIncomeAccountsQuery, GetQuickbooksIncomeAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuickbooksIncomeAccountsQuery, GetQuickbooksIncomeAccountsQueryVariables>(GetQuickbooksIncomeAccountsDocument, options);
      }
export function useGetQuickbooksIncomeAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuickbooksIncomeAccountsQuery, GetQuickbooksIncomeAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuickbooksIncomeAccountsQuery, GetQuickbooksIncomeAccountsQueryVariables>(GetQuickbooksIncomeAccountsDocument, options);
        }
export type GetQuickbooksIncomeAccountsQueryHookResult = ReturnType<typeof useGetQuickbooksIncomeAccountsQuery>;
export type GetQuickbooksIncomeAccountsLazyQueryHookResult = ReturnType<typeof useGetQuickbooksIncomeAccountsLazyQuery>;
export type GetQuickbooksIncomeAccountsQueryResult = Apollo.QueryResult<GetQuickbooksIncomeAccountsQuery, GetQuickbooksIncomeAccountsQueryVariables>;
export const GetQuickbooksTaxCodesDocument = gql`
    query getQuickbooksTaxCodes {
  getQuickbooksTaxCodes {
    description
    id
    name
  }
}
    `;

/**
 * __useGetQuickbooksTaxCodesQuery__
 *
 * To run a query within a React component, call `useGetQuickbooksTaxCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuickbooksTaxCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuickbooksTaxCodesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetQuickbooksTaxCodesQuery(baseOptions?: Apollo.QueryHookOptions<GetQuickbooksTaxCodesQuery, GetQuickbooksTaxCodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuickbooksTaxCodesQuery, GetQuickbooksTaxCodesQueryVariables>(GetQuickbooksTaxCodesDocument, options);
      }
export function useGetQuickbooksTaxCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuickbooksTaxCodesQuery, GetQuickbooksTaxCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuickbooksTaxCodesQuery, GetQuickbooksTaxCodesQueryVariables>(GetQuickbooksTaxCodesDocument, options);
        }
export type GetQuickbooksTaxCodesQueryHookResult = ReturnType<typeof useGetQuickbooksTaxCodesQuery>;
export type GetQuickbooksTaxCodesLazyQueryHookResult = ReturnType<typeof useGetQuickbooksTaxCodesLazyQuery>;
export type GetQuickbooksTaxCodesQueryResult = Apollo.QueryResult<GetQuickbooksTaxCodesQuery, GetQuickbooksTaxCodesQueryVariables>;
export const GetQuickbooksTaxRatesDocument = gql`
    query getQuickbooksTaxRates {
  getQuickbooksTaxRates {
    description
    id
    name
    rateValue
  }
}
    `;

/**
 * __useGetQuickbooksTaxRatesQuery__
 *
 * To run a query within a React component, call `useGetQuickbooksTaxRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuickbooksTaxRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuickbooksTaxRatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetQuickbooksTaxRatesQuery(baseOptions?: Apollo.QueryHookOptions<GetQuickbooksTaxRatesQuery, GetQuickbooksTaxRatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuickbooksTaxRatesQuery, GetQuickbooksTaxRatesQueryVariables>(GetQuickbooksTaxRatesDocument, options);
      }
export function useGetQuickbooksTaxRatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuickbooksTaxRatesQuery, GetQuickbooksTaxRatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuickbooksTaxRatesQuery, GetQuickbooksTaxRatesQueryVariables>(GetQuickbooksTaxRatesDocument, options);
        }
export type GetQuickbooksTaxRatesQueryHookResult = ReturnType<typeof useGetQuickbooksTaxRatesQuery>;
export type GetQuickbooksTaxRatesLazyQueryHookResult = ReturnType<typeof useGetQuickbooksTaxRatesLazyQuery>;
export type GetQuickbooksTaxRatesQueryResult = Apollo.QueryResult<GetQuickbooksTaxRatesQuery, GetQuickbooksTaxRatesQueryVariables>;
export const GetRolesWithPermissionsDocument = gql`
    query getRolesWithPermissions {
  getRolesWithPermissions {
    admin
    employee
    foreman
    officeManager
    salesperson
    subcontractor
  }
}
    `;

/**
 * __useGetRolesWithPermissionsQuery__
 *
 * To run a query within a React component, call `useGetRolesWithPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolesWithPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRolesWithPermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRolesWithPermissionsQuery(baseOptions?: Apollo.QueryHookOptions<GetRolesWithPermissionsQuery, GetRolesWithPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRolesWithPermissionsQuery, GetRolesWithPermissionsQueryVariables>(GetRolesWithPermissionsDocument, options);
      }
export function useGetRolesWithPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRolesWithPermissionsQuery, GetRolesWithPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRolesWithPermissionsQuery, GetRolesWithPermissionsQueryVariables>(GetRolesWithPermissionsDocument, options);
        }
export type GetRolesWithPermissionsQueryHookResult = ReturnType<typeof useGetRolesWithPermissionsQuery>;
export type GetRolesWithPermissionsLazyQueryHookResult = ReturnType<typeof useGetRolesWithPermissionsLazyQuery>;
export type GetRolesWithPermissionsQueryResult = Apollo.QueryResult<GetRolesWithPermissionsQuery, GetRolesWithPermissionsQueryVariables>;
export const GetTimeBucketDocument = gql`
    query getTimeBucket($id: ID!) {
  getTimeBucket(id: $id) {
    id
    name
    organizationId
  }
}
    `;

/**
 * __useGetTimeBucketQuery__
 *
 * To run a query within a React component, call `useGetTimeBucketQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimeBucketQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimeBucketQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTimeBucketQuery(baseOptions: Apollo.QueryHookOptions<GetTimeBucketQuery, GetTimeBucketQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTimeBucketQuery, GetTimeBucketQueryVariables>(GetTimeBucketDocument, options);
      }
export function useGetTimeBucketLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTimeBucketQuery, GetTimeBucketQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTimeBucketQuery, GetTimeBucketQueryVariables>(GetTimeBucketDocument, options);
        }
export type GetTimeBucketQueryHookResult = ReturnType<typeof useGetTimeBucketQuery>;
export type GetTimeBucketLazyQueryHookResult = ReturnType<typeof useGetTimeBucketLazyQuery>;
export type GetTimeBucketQueryResult = Apollo.QueryResult<GetTimeBucketQuery, GetTimeBucketQueryVariables>;
export const GetTimeBucketsDocument = gql`
    query getTimeBuckets {
  getTimeBuckets {
    id
    name
    organizationId
  }
}
    `;

/**
 * __useGetTimeBucketsQuery__
 *
 * To run a query within a React component, call `useGetTimeBucketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimeBucketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimeBucketsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTimeBucketsQuery(baseOptions?: Apollo.QueryHookOptions<GetTimeBucketsQuery, GetTimeBucketsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTimeBucketsQuery, GetTimeBucketsQueryVariables>(GetTimeBucketsDocument, options);
      }
export function useGetTimeBucketsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTimeBucketsQuery, GetTimeBucketsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTimeBucketsQuery, GetTimeBucketsQueryVariables>(GetTimeBucketsDocument, options);
        }
export type GetTimeBucketsQueryHookResult = ReturnType<typeof useGetTimeBucketsQuery>;
export type GetTimeBucketsLazyQueryHookResult = ReturnType<typeof useGetTimeBucketsLazyQuery>;
export type GetTimeBucketsQueryResult = Apollo.QueryResult<GetTimeBucketsQuery, GetTimeBucketsQueryVariables>;
export const GetTimeEntriesDocument = gql`
    query getTimeEntries($first: Int!, $forDate: Date, $forDateEnd: Date, $forDateStart: Date, $jobPhaseId: ID, $page: Int, $sortDirection: SortDirection, $sortKey: GetTimeEntriesSortKey, $userId: ID) {
  getTimeEntries(
    first: $first
    forDate: $forDate
    forDateEnd: $forDateEnd
    forDateStart: $forDateStart
    jobPhaseId: $jobPhaseId
    page: $page
    sortDirection: $sortDirection
    sortKey: $sortKey
    userId: $userId
  ) {
    data {
      clockInLatitude
      clockInLongitude
      clockOutLatitude
      clockOutLongitude
      endTime
      forDate
      id
      jobPhase {
        actualCostAdditional
        actualCostDirect
        actualCostEquipment
        actualCostIndirect
        actualCostLabour
        actualCostMaterial
        actualCostOverhead
        actualCostTotal
        actualCostTransferTruck
        actualEmployeeHours
        actualGrossMargin
        actualGrossMarginPercentage
        actualMaterialNeeded
        actualNetMargin
        actualNetMarginPercentage
        actualOperatingMargin
        actualOperatingMarginPercentage
        actualOverallTotal
        actualProfit
        actualProfitPercentage
        address
        applicableStatuses
        costItems {
          additionalCosts {
            additionalCostId
            cost
            costTotal
            feeAmount
            feeType
            id
            name
          }
          costAdditional
          costEquipment
          costLabour
          costMaterial
          costTransferTruck
          date
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          equipmentPieces {
            equipmentPieceId
            id
            name
            quantity
            rate
            timeOnjob
            timeTravel
          }
          id
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            address
            applicableStatuses
            crewId
            endsAt
            externalId
            id
            jobDuration
            jobSize
            notes
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          material {
            costMaterial
            id
            materialNeeded
            name
            organizationProductTypeName
            type
          }
          plantId
          plantProductId
          transferTrucks {
            hours
            id
            name
            plantTransferTruckId
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
        }
        crew {
          color
          displayName
          employees {
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          id
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          rate
        }
        crewId
        defaultAdditionalCosts {
          cost
          feeAmount
          feeType
          id
          name
        }
        defaultEmployees {
          firstName
          id
          lastName
          name
          organizationId
          rate
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
        }
        defaultEquipmentPieces {
          chargeType
          fuelSurcharge
          id
          name
          rate
          usePercentage
        }
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        endsAt
        externalId
        files {
          createdAt
          filename
          id
          thumbnail
        }
        foremanUser {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        id
        job {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualGrossMargin
          actualGrossMarginPercentage
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          billingStatus
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          datePushedToQuickbooks
          endsAt
          externalId
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          id
          jobPhases {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            address
            applicableStatuses
            crewId
            endsAt
            externalId
            id
            jobDuration
            jobSize
            notes
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          mayShowTaxNotification
          notes
          projectFilesFolderId
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          proposalId
          proposalStage {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          shouldPushTaxesToQuickbooks
          startsAt
          status
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
        }
        jobDuration
        jobPhasePlant {
          id
          name
          plant {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            id
            name
            phone
          }
          plantProduct {
            id
            rate
            type
          }
          type
        }
        jobSize
        notes
        organization {
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          proposalDefaults {
            autoSave
            color
            id
            layout
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        organizationProductType {
          id
          indirectPercentage
          markupPercentage
          name
          overheadPercentage
          type
        }
        organizationProductTypeName
        productName
        proposal {
          acceptanceOverride
          activeVersion
          addresses {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          attachments {
            id
            name
            path
            thumbnailPath
          }
          changeOrderJobId
          changeOrders {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          clientEmailOverride
          company {
            addCompanyInfo
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            email
            id
            jobsCount
            logo
            name
            notes
            phone
            projectFilesFolderId
            proposalsCount
            status
            website
          }
          contact {
            SMSNotifications
            SMSNotificationsReadOnly
            email
            firstName
            id
            lastName
            phone
            primary
            role
            title
          }
          contactId
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTaxes
          costTotal
          createdAt
          emailBodyOverride
          emailBodyOverrideParsed
          emailSubjectOverride
          events {
            action
            createdAt
          }
          externalId
          grossMargin
          grossMarginPercentage
          id
          isChangeOrder
          isSendable
          layout
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          overallTotal
          overallTotalAfterTaxes
          profit
          profitPercentage
          projectFilesFolderId
          proposalNotes
          recipients {
            contactId
            createdAt
            email
            id
          }
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
          salesTaxes {
            id
            name
            organizationSalesTaxId
            percentage
          }
          sentAt
          signedAt
          signedInitials
          signedName
          source
          stages {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          status
          statusChanges {
            changeAt
            status
          }
          user {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          userId
          uuid
          version
          versions {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          wonAt
        }
        proposalProduct {
          additionalCosts {
            additionalCostId
            cost
            costOverride
            costTotal
            feeAmount
            feeAmountOverride
            feeType
            id
            name
            quantity
            quantityOverride
            showOnProposal
          }
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          costTransferTruck
          crews {
            cost
            crewId
            id
            name
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
          }
          equipmentPieces {
            chargeType
            cost
            equipmentPieceId
            id
            name
            quantity
            quantityOverride
            rate
            rateOverride
            timeOnjob
            timeOnjobOverride
            timeTravel
            timeTravelOverride
            usePercentage
          }
          externalProductName
          files {
            createdAt
            filename
            id
            thumbnail
            type
          }
          grossMargin
          grossMarginPercentage
          id
          isOptional
          jobDuration
          jobDurationDaysOverride
          jobDurationOverride
          jobSize
          mapData
          mapImage
          mapImageDirty
          material {
            areaCoverage
            attributes {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            attributesOverride {
              __typename
              ... on ProductAttributeAsphalt {
                applicationRate
              }
              ... on ProductAttributeConcreteColumn {
                diameter
                height
              }
              ... on ProductAttributeConcreteCurbOrGutter {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeConcreteFlatwork {
                applicationRate
              }
              ... on ProductAttributeConcreteFooting {
                depth
                width
              }
              ... on ProductAttributeConcreteWall {
                height
                width
              }
              ... on ProductAttributeConcreteWaterway {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeCrackSeal {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeCurbWall {
                curbHeight
                curbWidth
                gutterHeight
                gutterWidth
              }
              ... on ProductAttributeExcavateOut {
                applicationRate
              }
              ... on ProductAttributeGrading {
                applicationRate
                poundsPerCubicYard
              }
              ... on ProductAttributeMastic {
                crackDepth
                crackWidth
                overbandThickness
                overbandWidth
                poundsPerBlock
                poundsPerGallon
              }
              ... on ProductAttributeMicrosurfacing {
                applicationRate
              }
              ... on ProductAttributeSealCoat {
                applicationRate
              }
              ... on ProductAttributeSlurrySeal {
                applicationRate
              }
              ... on ProductAttributeStriping {
                applicationRate
                lineWidth
              }
            }
            costMaterial
            costMaterialOverride
            costMinimumProduct
            costMinimumProposal
            dailyUnitsComplete
            dailyUnitsCompleteOverride
            externalProductName
            id
            indirectPercentage
            indirectPercentageOverride
            labourCostType
            markupPercentage
            markupPercentageOverride
            materialNeeded
            materialNeededOverride
            measurementJob
            measurementMaterial
            name
            organizationProductTypeName
            overheadPercentage
            overheadPercentageOverride
            productId
            productionRateType
            proposalId
            proposalProductId
            proposalStageId
            statementOfWork
            statementOfWorkOverride
            subcontracted
            tonConversionFactor
            tonConversionFactorOverride
            type
            unitPrice
            unitPriceOverride
            unitPriceProduct
          }
          measurementJob
          measurementMaterial
          netMargin
          netMarginPercentage
          notes
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          overallTotalOverride
          plantProduct {
            id
            plantProductId
            rate
            rateOverride
            type
          }
          productName
          profit
          profitPercentage
          profitPercentageOverride
          roundTripTravelTimeHours
          statementOfWork
          subcontractorCost
          subcontractorName
          subcontractorProposalId
          transferTruckLoadTimeBuffer
          transferTruckRoundTripTime
          transferTruckRoundTripTimeOverride
          transferTruckUnloadTimeBuffer
          transferTrucks {
            cost
            costOverride
            id
            name
            plantTransferTruckId
            quantity
            rateHourly
            rateHourlyOverride
            rateTon
            rateTonOverride
            tonnage
            totalHaulingHours
            totalHaulingHoursOverride
            transferTruckId
            truckingProductionRate
            trucksNeeded
          }
        }
        proposalStage {
          address {
            city
            country
            id
            latitude
            line1
            line2
            longitude
            mapImage
            organizationAddressId
            state
            zip
          }
          addressOverride
          costAdditional
          costDirect
          costEquipment
          costIndirect
          costLabour
          costMaterial
          costOverhead
          costTotal
          distanceMeters
          distanceSeconds
          grossMargin
          grossMarginPercentage
          id
          mapData
          mapImage
          mapImageDirty
          name
          netMargin
          netMarginPercentage
          operatingMargin
          operatingMarginPercentage
          ordering
          overallTotal
          profit
          profitPercentage
          proposalProducts {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          roundTripTravelTimeHours
        }
        proposedCostAdditional
        proposedCostDirect
        proposedCostEquipment
        proposedCostIndirect
        proposedCostLabour
        proposedCostMaterial
        proposedCostOverhead
        proposedCostTotal
        proposedCostTransferTruck
        proposedEmployeeHours
        proposedGrossMargin
        proposedGrossMarginPercentage
        proposedMaterialNeeded
        proposedNetMargin
        proposedNetMarginPercentage
        proposedOperatingMargin
        proposedOperatingMarginPercentage
        proposedOverallTotal
        proposedProfit
        proposedProfitPercentage
        scheduleBlocks {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            endsAt
            externalId
            id
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            address
            applicableStatuses
            crewId
            endsAt
            externalId
            id
            jobDuration
            jobSize
            notes
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        scheduledBlockForDate {
          blockLength
          crew {
            color
            displayName
            id
            name
            rate
          }
          endsAt
          estimatedMaterial
          estimatedMaterialOverride
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            endsAt
            externalId
            id
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
          }
          jobPhase {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualEmployeeHours
            actualGrossMargin
            actualGrossMarginPercentage
            actualMaterialNeeded
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            address
            applicableStatuses
            crewId
            endsAt
            externalId
            id
            jobDuration
            jobSize
            notes
            organizationProductTypeName
            productName
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedEmployeeHours
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedMaterialNeeded
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            travelTimeEstimate
            usersColor
          }
          scheduledAt
          showTravelFrom
          showTravelTo
          travelTime
        }
        startsAt
        status
        travelTimeEstimate
        users {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        usersColor
        workOrderCrews {
          crewId
          id
          name
        }
        workOrderEquipmentPieces {
          equipmentPieceId
          id
          name
        }
        workOrderTransferTrucks {
          id
          name
          quantity
          rateHourly
          rateTon
          tonnage
          transferTruckId
        }
      }
      notes
      organizationId
      startTime
      timeBucket {
        id
        name
        organizationId
      }
      timeTrackedSeconds
      timeTrackedSecondsOverride
      user {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        invitedBy {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          email
          emailTemplate
          failingPayment
          id
          logo
          name
          onTrial
          phone
          proposalSentEmailText
          subscribed
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        status
      }
      uuid
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useGetTimeEntriesQuery__
 *
 * To run a query within a React component, call `useGetTimeEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimeEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimeEntriesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      forDate: // value for 'forDate'
 *      forDateEnd: // value for 'forDateEnd'
 *      forDateStart: // value for 'forDateStart'
 *      jobPhaseId: // value for 'jobPhaseId'
 *      page: // value for 'page'
 *      sortDirection: // value for 'sortDirection'
 *      sortKey: // value for 'sortKey'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetTimeEntriesQuery(baseOptions: Apollo.QueryHookOptions<GetTimeEntriesQuery, GetTimeEntriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTimeEntriesQuery, GetTimeEntriesQueryVariables>(GetTimeEntriesDocument, options);
      }
export function useGetTimeEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTimeEntriesQuery, GetTimeEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTimeEntriesQuery, GetTimeEntriesQueryVariables>(GetTimeEntriesDocument, options);
        }
export type GetTimeEntriesQueryHookResult = ReturnType<typeof useGetTimeEntriesQuery>;
export type GetTimeEntriesLazyQueryHookResult = ReturnType<typeof useGetTimeEntriesLazyQuery>;
export type GetTimeEntriesQueryResult = Apollo.QueryResult<GetTimeEntriesQuery, GetTimeEntriesQueryVariables>;
export const GetTransferTruckDocument = gql`
    query getTransferTruck($id: ID!) {
  getTransferTruck(id: $id) {
    defaultRateHourly
    defaultRateTon
    defaultTonnage
    id
    name
  }
}
    `;

/**
 * __useGetTransferTruckQuery__
 *
 * To run a query within a React component, call `useGetTransferTruckQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransferTruckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransferTruckQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTransferTruckQuery(baseOptions: Apollo.QueryHookOptions<GetTransferTruckQuery, GetTransferTruckQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransferTruckQuery, GetTransferTruckQueryVariables>(GetTransferTruckDocument, options);
      }
export function useGetTransferTruckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransferTruckQuery, GetTransferTruckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransferTruckQuery, GetTransferTruckQueryVariables>(GetTransferTruckDocument, options);
        }
export type GetTransferTruckQueryHookResult = ReturnType<typeof useGetTransferTruckQuery>;
export type GetTransferTruckLazyQueryHookResult = ReturnType<typeof useGetTransferTruckLazyQuery>;
export type GetTransferTruckQueryResult = Apollo.QueryResult<GetTransferTruckQuery, GetTransferTruckQueryVariables>;
export const GetTransferTrucksDocument = gql`
    query getTransferTrucks {
  getTransferTrucks {
    defaultRateHourly
    defaultRateTon
    defaultTonnage
    id
    name
  }
}
    `;

/**
 * __useGetTransferTrucksQuery__
 *
 * To run a query within a React component, call `useGetTransferTrucksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransferTrucksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransferTrucksQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTransferTrucksQuery(baseOptions?: Apollo.QueryHookOptions<GetTransferTrucksQuery, GetTransferTrucksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransferTrucksQuery, GetTransferTrucksQueryVariables>(GetTransferTrucksDocument, options);
      }
export function useGetTransferTrucksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransferTrucksQuery, GetTransferTrucksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransferTrucksQuery, GetTransferTrucksQueryVariables>(GetTransferTrucksDocument, options);
        }
export type GetTransferTrucksQueryHookResult = ReturnType<typeof useGetTransferTrucksQuery>;
export type GetTransferTrucksLazyQueryHookResult = ReturnType<typeof useGetTransferTrucksLazyQuery>;
export type GetTransferTrucksQueryResult = Apollo.QueryResult<GetTransferTrucksQuery, GetTransferTrucksQueryVariables>;
export const GetUserOrganizationDocument = gql`
    query getUserOrganization {
  getUserOrganization {
    conversionFactorOverride {
      asphaltTonConversionFactorOverride
      excavateOutTonConversionFactorOverride
      id
      organization {
        conversionFactorOverride {
          asphaltTonConversionFactorOverride
          excavateOutTonConversionFactorOverride
          id
        }
        documents {
          id
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          path
          thumbnailPath
        }
        email
        emailTemplate
        failingPayment
        id
        linkedServices {
          active
          expired
          id
          service
          type
        }
        logo
        name
        onTrial
        phone
        proposalDefaults {
          autoSave
          color
          id
          layout
          removeIndividualLineItemPricing
          removeUnitPriceAndQuantity
        }
        proposalSentEmailText
        salesTaxes {
          id
          isDefault
          name
          percentage
          quickbooksDesktopTaxCodeId
          quickbooksTaxCodeId
        }
        subscribed
        subscription {
          endsAt
          id
          name
          quantity
          renewsAt
          stripeId
          stripePrice
          stripeStatus
          trialEndsAt
        }
        timezone
        trialEndsAt
      }
    }
    documents {
      id
      name
      path
      thumbnailPath
    }
    email
    emailTemplate
    failingPayment
    id
    linkedServices {
      active
      expired
      id
      service
      type
    }
    logo
    name
    onTrial
    phone
    proposalDefaults {
      autoSave
      color
      id
      layout
      removeIndividualLineItemPricing
      removeUnitPriceAndQuantity
    }
    proposalSentEmailText
    salesTaxes {
      id
      isDefault
      name
      percentage
      quickbooksDesktopTaxCodeId
      quickbooksTaxCodeId
    }
    subscribed
    subscription {
      endsAt
      id
      name
      quantity
      renewsAt
      stripeId
      stripePrice
      stripeStatus
      trialEndsAt
    }
    timezone
    trialEndsAt
  }
}
    `;

/**
 * __useGetUserOrganizationQuery__
 *
 * To run a query within a React component, call `useGetUserOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserOrganizationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserOrganizationQuery(baseOptions?: Apollo.QueryHookOptions<GetUserOrganizationQuery, GetUserOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserOrganizationQuery, GetUserOrganizationQueryVariables>(GetUserOrganizationDocument, options);
      }
export function useGetUserOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserOrganizationQuery, GetUserOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserOrganizationQuery, GetUserOrganizationQueryVariables>(GetUserOrganizationDocument, options);
        }
export type GetUserOrganizationQueryHookResult = ReturnType<typeof useGetUserOrganizationQuery>;
export type GetUserOrganizationLazyQueryHookResult = ReturnType<typeof useGetUserOrganizationLazyQuery>;
export type GetUserOrganizationQueryResult = Apollo.QueryResult<GetUserOrganizationQuery, GetUserOrganizationQueryVariables>;
export const GetYearToDateStatsDocument = gql`
    query getYearToDateStats {
  getYearToDateStats {
    yearToDateCloseRate
    yearToDateJobAmountCompleted
    yearToDateNetMarginCalculated
    yearToDateTotalAmountProposed
    yearToDateTotalSalesWon
  }
}
    `;

/**
 * __useGetYearToDateStatsQuery__
 *
 * To run a query within a React component, call `useGetYearToDateStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetYearToDateStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetYearToDateStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetYearToDateStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetYearToDateStatsQuery, GetYearToDateStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetYearToDateStatsQuery, GetYearToDateStatsQueryVariables>(GetYearToDateStatsDocument, options);
      }
export function useGetYearToDateStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetYearToDateStatsQuery, GetYearToDateStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetYearToDateStatsQuery, GetYearToDateStatsQueryVariables>(GetYearToDateStatsDocument, options);
        }
export type GetYearToDateStatsQueryHookResult = ReturnType<typeof useGetYearToDateStatsQuery>;
export type GetYearToDateStatsLazyQueryHookResult = ReturnType<typeof useGetYearToDateStatsLazyQuery>;
export type GetYearToDateStatsQueryResult = Apollo.QueryResult<GetYearToDateStatsQuery, GetYearToDateStatsQueryVariables>;
export const IsCompanySearchableDocument = gql`
    query isCompanySearchable($id: ID!) {
  isCompanySearchable(id: $id)
}
    `;

/**
 * __useIsCompanySearchableQuery__
 *
 * To run a query within a React component, call `useIsCompanySearchableQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsCompanySearchableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsCompanySearchableQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIsCompanySearchableQuery(baseOptions: Apollo.QueryHookOptions<IsCompanySearchableQuery, IsCompanySearchableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsCompanySearchableQuery, IsCompanySearchableQueryVariables>(IsCompanySearchableDocument, options);
      }
export function useIsCompanySearchableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsCompanySearchableQuery, IsCompanySearchableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsCompanySearchableQuery, IsCompanySearchableQueryVariables>(IsCompanySearchableDocument, options);
        }
export type IsCompanySearchableQueryHookResult = ReturnType<typeof useIsCompanySearchableQuery>;
export type IsCompanySearchableLazyQueryHookResult = ReturnType<typeof useIsCompanySearchableLazyQuery>;
export type IsCompanySearchableQueryResult = Apollo.QueryResult<IsCompanySearchableQuery, IsCompanySearchableQueryVariables>;
export const IsJobSearchableDocument = gql`
    query isJobSearchable($id: ID!) {
  isJobSearchable(id: $id)
}
    `;

/**
 * __useIsJobSearchableQuery__
 *
 * To run a query within a React component, call `useIsJobSearchableQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsJobSearchableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsJobSearchableQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIsJobSearchableQuery(baseOptions: Apollo.QueryHookOptions<IsJobSearchableQuery, IsJobSearchableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsJobSearchableQuery, IsJobSearchableQueryVariables>(IsJobSearchableDocument, options);
      }
export function useIsJobSearchableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsJobSearchableQuery, IsJobSearchableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsJobSearchableQuery, IsJobSearchableQueryVariables>(IsJobSearchableDocument, options);
        }
export type IsJobSearchableQueryHookResult = ReturnType<typeof useIsJobSearchableQuery>;
export type IsJobSearchableLazyQueryHookResult = ReturnType<typeof useIsJobSearchableLazyQuery>;
export type IsJobSearchableQueryResult = Apollo.QueryResult<IsJobSearchableQuery, IsJobSearchableQueryVariables>;
export const IsOpportunitySearchableDocument = gql`
    query isOpportunitySearchable($id: ID!) {
  isOpportunitySearchable(id: $id)
}
    `;

/**
 * __useIsOpportunitySearchableQuery__
 *
 * To run a query within a React component, call `useIsOpportunitySearchableQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsOpportunitySearchableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsOpportunitySearchableQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIsOpportunitySearchableQuery(baseOptions: Apollo.QueryHookOptions<IsOpportunitySearchableQuery, IsOpportunitySearchableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsOpportunitySearchableQuery, IsOpportunitySearchableQueryVariables>(IsOpportunitySearchableDocument, options);
      }
export function useIsOpportunitySearchableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsOpportunitySearchableQuery, IsOpportunitySearchableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsOpportunitySearchableQuery, IsOpportunitySearchableQueryVariables>(IsOpportunitySearchableDocument, options);
        }
export type IsOpportunitySearchableQueryHookResult = ReturnType<typeof useIsOpportunitySearchableQuery>;
export type IsOpportunitySearchableLazyQueryHookResult = ReturnType<typeof useIsOpportunitySearchableLazyQuery>;
export type IsOpportunitySearchableQueryResult = Apollo.QueryResult<IsOpportunitySearchableQuery, IsOpportunitySearchableQueryVariables>;
export const IsProposalSearchableDocument = gql`
    query isProposalSearchable($id: ID!) {
  isProposalSearchable(id: $id)
}
    `;

/**
 * __useIsProposalSearchableQuery__
 *
 * To run a query within a React component, call `useIsProposalSearchableQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsProposalSearchableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsProposalSearchableQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIsProposalSearchableQuery(baseOptions: Apollo.QueryHookOptions<IsProposalSearchableQuery, IsProposalSearchableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsProposalSearchableQuery, IsProposalSearchableQueryVariables>(IsProposalSearchableDocument, options);
      }
export function useIsProposalSearchableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsProposalSearchableQuery, IsProposalSearchableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsProposalSearchableQuery, IsProposalSearchableQueryVariables>(IsProposalSearchableDocument, options);
        }
export type IsProposalSearchableQueryHookResult = ReturnType<typeof useIsProposalSearchableQuery>;
export type IsProposalSearchableLazyQueryHookResult = ReturnType<typeof useIsProposalSearchableLazyQuery>;
export type IsProposalSearchableQueryResult = Apollo.QueryResult<IsProposalSearchableQuery, IsProposalSearchableQueryVariables>;
export const MeDocument = gql`
    query me {
  me {
    addressCity
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZip
    autoAssign
    avatar
    crewsCount
    email
    firstName
    hasEmployee
    id
    inviteToken
    invitedAt
    invitedBy {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        hasEmployee
        id
        inviteToken
        invitedAt
        jobPhasesCount
        jobsCount
        lastName
        name
        organization {
          conversionFactorOverride {
            asphaltTonConversionFactorOverride
            excavateOutTonConversionFactorOverride
            id
          }
          documents {
            id
            name
            path
            thumbnailPath
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          proposalDefaults {
            autoSave
            color
            id
            layout
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
          }
          proposalSentEmailText
          salesTaxes {
            id
            isDefault
            name
            percentage
            quickbooksDesktopTaxCodeId
            quickbooksTaxCodeId
          }
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          timezone
          trialEndsAt
        }
        permissions
        phone
        proposalCount
        roles
        status
      }
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
    jobPhasesCount
    jobsCount
    lastName
    name
    organization {
      email
      emailTemplate
      failingPayment
      id
      logo
      name
      onTrial
      phone
      proposalSentEmailText
      subscribed
      timezone
      trialEndsAt
    }
    permissions
    phone
    proposalCount
    roles
    status
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const PreviewSubscriptionChangeDocument = gql`
    query previewSubscriptionChange($email: String, $quantityChange: Int!) {
  previewSubscriptionChange(email: $email, quantityChange: $quantityChange) {
    totalOnRenewal
    totalToday
  }
}
    `;

/**
 * __usePreviewSubscriptionChangeQuery__
 *
 * To run a query within a React component, call `usePreviewSubscriptionChangeQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewSubscriptionChangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewSubscriptionChangeQuery({
 *   variables: {
 *      email: // value for 'email'
 *      quantityChange: // value for 'quantityChange'
 *   },
 * });
 */
export function usePreviewSubscriptionChangeQuery(baseOptions: Apollo.QueryHookOptions<PreviewSubscriptionChangeQuery, PreviewSubscriptionChangeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreviewSubscriptionChangeQuery, PreviewSubscriptionChangeQueryVariables>(PreviewSubscriptionChangeDocument, options);
      }
export function usePreviewSubscriptionChangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreviewSubscriptionChangeQuery, PreviewSubscriptionChangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreviewSubscriptionChangeQuery, PreviewSubscriptionChangeQueryVariables>(PreviewSubscriptionChangeDocument, options);
        }
export type PreviewSubscriptionChangeQueryHookResult = ReturnType<typeof usePreviewSubscriptionChangeQuery>;
export type PreviewSubscriptionChangeLazyQueryHookResult = ReturnType<typeof usePreviewSubscriptionChangeLazyQuery>;
export type PreviewSubscriptionChangeQueryResult = Apollo.QueryResult<PreviewSubscriptionChangeQuery, PreviewSubscriptionChangeQueryVariables>;
export const TimeEntryDocument = gql`
    query timeEntry($id: ID!) {
  timeEntry(id: $id) {
    clockInLatitude
    clockInLongitude
    clockOutLatitude
    clockOutLongitude
    endTime
    forDate
    id
    jobPhase {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualCostTransferTruck
      actualEmployeeHours
      actualGrossMargin
      actualGrossMarginPercentage
      actualMaterialNeeded
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      address
      applicableStatuses
      costItems {
        additionalCosts {
          additionalCostId
          cost
          costTotal
          feeAmount
          feeType
          id
          jobPhaseCostItem {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          name
        }
        costAdditional
        costEquipment
        costLabour
        costMaterial
        costTransferTruck
        date
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        equipmentPieces {
          equipmentPieceId
          id
          name
          quantity
          rate
          timeOnjob
          timeTravel
        }
        id
        jobPhase {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualCostTransferTruck
          actualEmployeeHours
          actualGrossMargin
          actualGrossMarginPercentage
          actualMaterialNeeded
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address
          applicableStatuses
          crew {
            color
            displayName
            id
            name
            rate
          }
          crewId
          defaultAdditionalCosts {
            cost
            feeAmount
            feeType
            id
            name
          }
          defaultEmployees {
            firstName
            id
            lastName
            name
            organizationId
            rate
            userId
          }
          defaultEquipmentPieces {
            chargeType
            fuelSurcharge
            id
            name
            rate
            usePercentage
          }
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          endsAt
          externalId
          files {
            createdAt
            filename
            id
            thumbnail
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualCostTransferTruck
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            billingStatus
            datePushedToQuickbooks
            endsAt
            externalId
            id
            mayShowTaxNotification
            notes
            projectFilesFolderId
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedCostTransferTruck
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            shouldPushTaxesToQuickbooks
            startsAt
            status
            userId
          }
          jobDuration
          jobPhasePlant {
            id
            name
            type
          }
          jobSize
          notes
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          organizationProductType {
            id
            indirectPercentage
            markupPercentage
            name
            overheadPercentage
            type
          }
          organizationProductTypeName
          productName
          proposal {
            acceptanceOverride
            activeVersion
            changeOrderJobId
            clientEmailOverride
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTaxes
            costTotal
            createdAt
            emailBodyOverride
            emailBodyOverrideParsed
            emailSubjectOverride
            externalId
            grossMargin
            grossMarginPercentage
            id
            isChangeOrder
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            overallTotalAfterTaxes
            profit
            profitPercentage
            projectFilesFolderId
            proposalNotes
            removeIndividualLineItemPricing
            removeUnitPriceAndQuantity
            sentAt
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
            version
            wonAt
          }
          proposalProduct {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            costTransferTruck
            externalProductName
            grossMargin
            grossMarginPercentage
            id
            isOptional
            jobDuration
            jobDurationDaysOverride
            jobDurationOverride
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementJob
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            overallTotalOverride
            productName
            profit
            profitPercentage
            profitPercentageOverride
            roundTripTravelTimeHours
            statementOfWork
            subcontractorCost
            subcontractorName
            subcontractorProposalId
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
          }
          proposalStage {
            addressOverride
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            ordering
            overallTotal
            profit
            profitPercentage
            roundTripTravelTimeHours
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedCostTransferTruck
          proposedEmployeeHours
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedMaterialNeeded
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          scheduleBlocks {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          scheduledBlockForDate {
            blockLength
            endsAt
            estimatedMaterial
            estimatedMaterialOverride
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          startsAt
          status
          travelTimeEstimate
          users {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          usersColor
          workOrderCrews {
            crewId
            id
            name
          }
          workOrderEquipmentPieces {
            equipmentPieceId
            id
            name
          }
          workOrderTransferTrucks {
            id
            name
            quantity
            rateHourly
            rateTon
            tonnage
            transferTruckId
          }
        }
        material {
          costMaterial
          id
          jobPhaseCostItem {
            costAdditional
            costEquipment
            costLabour
            costMaterial
            costTransferTruck
            date
            id
            plantId
            plantProductId
          }
          materialNeeded
          name
          organizationProductTypeName
          type
        }
        plantId
        plantProductId
        transferTrucks {
          hours
          id
          name
          plantTransferTruckId
          rateHourly
          rateTon
          tonnage
          transferTruckId
        }
        user {
          addressCity
          addressCountry
          addressLine1
          addressLine2
          addressState
          addressZip
          autoAssign
          avatar
          crewsCount
          email
          firstName
          hasEmployee
          id
          inviteToken
          invitedAt
          invitedBy {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            hasEmployee
            id
            inviteToken
            invitedAt
            jobPhasesCount
            jobsCount
            lastName
            name
            permissions
            phone
            proposalCount
            roles
            status
          }
          jobPhasesCount
          jobsCount
          lastName
          name
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            proposalSentEmailText
            subscribed
            timezone
            trialEndsAt
          }
          permissions
          phone
          proposalCount
          roles
          status
        }
      }
      crewId
      endsAt
      externalId
      id
      jobDuration
      jobSize
      notes
      organizationProductTypeName
      productName
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedCostTransferTruck
      proposedEmployeeHours
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedMaterialNeeded
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      startsAt
      status
      travelTimeEstimate
      usersColor
    }
    notes
    organizationId
    startTime
    timeBucket {
      id
      name
      organizationId
    }
    timeTrackedSeconds
    timeTrackedSecondsOverride
    user {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      hasEmployee
      id
      inviteToken
      invitedAt
      jobPhasesCount
      jobsCount
      lastName
      name
      permissions
      phone
      proposalCount
      roles
      status
    }
    uuid
  }
}
    `;

/**
 * __useTimeEntryQuery__
 *
 * To run a query within a React component, call `useTimeEntryQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeEntryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeEntryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTimeEntryQuery(baseOptions: Apollo.QueryHookOptions<TimeEntryQuery, TimeEntryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimeEntryQuery, TimeEntryQueryVariables>(TimeEntryDocument, options);
      }
export function useTimeEntryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimeEntryQuery, TimeEntryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimeEntryQuery, TimeEntryQueryVariables>(TimeEntryDocument, options);
        }
export type TimeEntryQueryHookResult = ReturnType<typeof useTimeEntryQuery>;
export type TimeEntryLazyQueryHookResult = ReturnType<typeof useTimeEntryLazyQuery>;
export type TimeEntryQueryResult = Apollo.QueryResult<TimeEntryQuery, TimeEntryQueryVariables>;
export const ValidateLoginDocument = gql`
    query validateLogin($input: ValidateLoginInput!) {
  validateLogin(input: $input)
}
    `;

/**
 * __useValidateLoginQuery__
 *
 * To run a query within a React component, call `useValidateLoginQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateLoginQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateLoginQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateLoginQuery(baseOptions: Apollo.QueryHookOptions<ValidateLoginQuery, ValidateLoginQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateLoginQuery, ValidateLoginQueryVariables>(ValidateLoginDocument, options);
      }
export function useValidateLoginLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateLoginQuery, ValidateLoginQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateLoginQuery, ValidateLoginQueryVariables>(ValidateLoginDocument, options);
        }
export type ValidateLoginQueryHookResult = ReturnType<typeof useValidateLoginQuery>;
export type ValidateLoginLazyQueryHookResult = ReturnType<typeof useValidateLoginLazyQuery>;
export type ValidateLoginQueryResult = Apollo.QueryResult<ValidateLoginQuery, ValidateLoginQueryVariables>;
export const ValidateUserInviteTokenDocument = gql`
    query validateUserInviteToken($email: String!, $inviteToken: String!) {
  validateUserInviteToken(email: $email, inviteToken: $inviteToken)
}
    `;

/**
 * __useValidateUserInviteTokenQuery__
 *
 * To run a query within a React component, call `useValidateUserInviteTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateUserInviteTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateUserInviteTokenQuery({
 *   variables: {
 *      email: // value for 'email'
 *      inviteToken: // value for 'inviteToken'
 *   },
 * });
 */
export function useValidateUserInviteTokenQuery(baseOptions: Apollo.QueryHookOptions<ValidateUserInviteTokenQuery, ValidateUserInviteTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateUserInviteTokenQuery, ValidateUserInviteTokenQueryVariables>(ValidateUserInviteTokenDocument, options);
      }
export function useValidateUserInviteTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateUserInviteTokenQuery, ValidateUserInviteTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateUserInviteTokenQuery, ValidateUserInviteTokenQueryVariables>(ValidateUserInviteTokenDocument, options);
        }
export type ValidateUserInviteTokenQueryHookResult = ReturnType<typeof useValidateUserInviteTokenQuery>;
export type ValidateUserInviteTokenLazyQueryHookResult = ReturnType<typeof useValidateUserInviteTokenLazyQuery>;
export type ValidateUserInviteTokenQueryResult = Apollo.QueryResult<ValidateUserInviteTokenQuery, ValidateUserInviteTokenQueryVariables>;
export const CustomAddProductToProposalStageDocument = gql`
    mutation customAddProductToProposalStage($proposalStageId: ID!, $productId: ID!) {
  addProductToProposalStage(
    proposalStageId: $proposalStageId
    productId: $productId
  ) {
    ...BitumioProposal
  }
}
    ${BitumioProposalFragmentDoc}`;
export type CustomAddProductToProposalStageMutationFn = Apollo.MutationFunction<CustomAddProductToProposalStageMutation, CustomAddProductToProposalStageMutationVariables>;

/**
 * __useCustomAddProductToProposalStageMutation__
 *
 * To run a mutation, you first call `useCustomAddProductToProposalStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomAddProductToProposalStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customAddProductToProposalStageMutation, { data, loading, error }] = useCustomAddProductToProposalStageMutation({
 *   variables: {
 *      proposalStageId: // value for 'proposalStageId'
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useCustomAddProductToProposalStageMutation(baseOptions?: Apollo.MutationHookOptions<CustomAddProductToProposalStageMutation, CustomAddProductToProposalStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomAddProductToProposalStageMutation, CustomAddProductToProposalStageMutationVariables>(CustomAddProductToProposalStageDocument, options);
      }
export type CustomAddProductToProposalStageMutationHookResult = ReturnType<typeof useCustomAddProductToProposalStageMutation>;
export type CustomAddProductToProposalStageMutationResult = Apollo.MutationResult<CustomAddProductToProposalStageMutation>;
export type CustomAddProductToProposalStageMutationOptions = Apollo.BaseMutationOptions<CustomAddProductToProposalStageMutation, CustomAddProductToProposalStageMutationVariables>;
export const CustomAddProposalAddressDocument = gql`
    mutation customAddProposalAddress($input: AddProposalAddressInput!) {
  addProposalAddress(input: $input) {
    ...BitumioProposal
  }
}
    ${BitumioProposalFragmentDoc}`;
export type CustomAddProposalAddressMutationFn = Apollo.MutationFunction<CustomAddProposalAddressMutation, CustomAddProposalAddressMutationVariables>;

/**
 * __useCustomAddProposalAddressMutation__
 *
 * To run a mutation, you first call `useCustomAddProposalAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomAddProposalAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customAddProposalAddressMutation, { data, loading, error }] = useCustomAddProposalAddressMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomAddProposalAddressMutation(baseOptions?: Apollo.MutationHookOptions<CustomAddProposalAddressMutation, CustomAddProposalAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomAddProposalAddressMutation, CustomAddProposalAddressMutationVariables>(CustomAddProposalAddressDocument, options);
      }
export type CustomAddProposalAddressMutationHookResult = ReturnType<typeof useCustomAddProposalAddressMutation>;
export type CustomAddProposalAddressMutationResult = Apollo.MutationResult<CustomAddProposalAddressMutation>;
export type CustomAddProposalAddressMutationOptions = Apollo.BaseMutationOptions<CustomAddProposalAddressMutation, CustomAddProposalAddressMutationVariables>;
export const CustomAddProposalEquipmentPieceDocument = gql`
    mutation customAddProposalEquipmentPiece($equipmentPieceId: ID!, $proposalProductId: ID!, $quantity: Int!) {
  addProposalEquipmentPiece(
    equipmentPieceId: $equipmentPieceId
    proposalProductId: $proposalProductId
    quantity: $quantity
  ) {
    ...BitumioProposal
  }
}
    ${BitumioProposalFragmentDoc}`;
export type CustomAddProposalEquipmentPieceMutationFn = Apollo.MutationFunction<CustomAddProposalEquipmentPieceMutation, CustomAddProposalEquipmentPieceMutationVariables>;

/**
 * __useCustomAddProposalEquipmentPieceMutation__
 *
 * To run a mutation, you first call `useCustomAddProposalEquipmentPieceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomAddProposalEquipmentPieceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customAddProposalEquipmentPieceMutation, { data, loading, error }] = useCustomAddProposalEquipmentPieceMutation({
 *   variables: {
 *      equipmentPieceId: // value for 'equipmentPieceId'
 *      proposalProductId: // value for 'proposalProductId'
 *      quantity: // value for 'quantity'
 *   },
 * });
 */
export function useCustomAddProposalEquipmentPieceMutation(baseOptions?: Apollo.MutationHookOptions<CustomAddProposalEquipmentPieceMutation, CustomAddProposalEquipmentPieceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomAddProposalEquipmentPieceMutation, CustomAddProposalEquipmentPieceMutationVariables>(CustomAddProposalEquipmentPieceDocument, options);
      }
export type CustomAddProposalEquipmentPieceMutationHookResult = ReturnType<typeof useCustomAddProposalEquipmentPieceMutation>;
export type CustomAddProposalEquipmentPieceMutationResult = Apollo.MutationResult<CustomAddProposalEquipmentPieceMutation>;
export type CustomAddProposalEquipmentPieceMutationOptions = Apollo.BaseMutationOptions<CustomAddProposalEquipmentPieceMutation, CustomAddProposalEquipmentPieceMutationVariables>;
export const CustomAddProposalStageDocument = gql`
    mutation customAddProposalStage($proposalId: ID!) {
  addProposalStage(proposalId: $proposalId) {
    ...BitumioProposalStage
  }
}
    ${BitumioProposalStageFragmentDoc}`;
export type CustomAddProposalStageMutationFn = Apollo.MutationFunction<CustomAddProposalStageMutation, CustomAddProposalStageMutationVariables>;

/**
 * __useCustomAddProposalStageMutation__
 *
 * To run a mutation, you first call `useCustomAddProposalStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomAddProposalStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customAddProposalStageMutation, { data, loading, error }] = useCustomAddProposalStageMutation({
 *   variables: {
 *      proposalId: // value for 'proposalId'
 *   },
 * });
 */
export function useCustomAddProposalStageMutation(baseOptions?: Apollo.MutationHookOptions<CustomAddProposalStageMutation, CustomAddProposalStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomAddProposalStageMutation, CustomAddProposalStageMutationVariables>(CustomAddProposalStageDocument, options);
      }
export type CustomAddProposalStageMutationHookResult = ReturnType<typeof useCustomAddProposalStageMutation>;
export type CustomAddProposalStageMutationResult = Apollo.MutationResult<CustomAddProposalStageMutation>;
export type CustomAddProposalStageMutationOptions = Apollo.BaseMutationOptions<CustomAddProposalStageMutation, CustomAddProposalStageMutationVariables>;
export const CustomCancelOpportunityDocument = gql`
    mutation customCancelOpportunity($id: ID!) {
  cancelOpportunity(id: $id) {
    addressCity
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZip
    company {
      name
    }
    companyId
    contact {
      email
      firstName
      id
      lastName
    }
    contactId
    createdAt
    dueAt
    id
    name
    notes
    products {
      id
      name
    }
    source
    status
    updatedAt
    user {
      firstName
      id
      lastName
    }
    userId
  }
}
    `;
export type CustomCancelOpportunityMutationFn = Apollo.MutationFunction<CustomCancelOpportunityMutation, CustomCancelOpportunityMutationVariables>;

/**
 * __useCustomCancelOpportunityMutation__
 *
 * To run a mutation, you first call `useCustomCancelOpportunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomCancelOpportunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customCancelOpportunityMutation, { data, loading, error }] = useCustomCancelOpportunityMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomCancelOpportunityMutation(baseOptions?: Apollo.MutationHookOptions<CustomCancelOpportunityMutation, CustomCancelOpportunityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomCancelOpportunityMutation, CustomCancelOpportunityMutationVariables>(CustomCancelOpportunityDocument, options);
      }
export type CustomCancelOpportunityMutationHookResult = ReturnType<typeof useCustomCancelOpportunityMutation>;
export type CustomCancelOpportunityMutationResult = Apollo.MutationResult<CustomCancelOpportunityMutation>;
export type CustomCancelOpportunityMutationOptions = Apollo.BaseMutationOptions<CustomCancelOpportunityMutation, CustomCancelOpportunityMutationVariables>;
export const CustomCancelProposalDocument = gql`
    mutation customCancelProposal($duplicate: Boolean!, $id: ID!, $maintainCurrentId: Boolean) {
  cancelProposal(
    duplicate: $duplicate
    id: $id
    maintainCurrentId: $maintainCurrentId
  ) {
    newProposal {
      ...BitumioProposal
    }
    proposal {
      ...BitumioProposal
    }
  }
}
    ${BitumioProposalFragmentDoc}`;
export type CustomCancelProposalMutationFn = Apollo.MutationFunction<CustomCancelProposalMutation, CustomCancelProposalMutationVariables>;

/**
 * __useCustomCancelProposalMutation__
 *
 * To run a mutation, you first call `useCustomCancelProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomCancelProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customCancelProposalMutation, { data, loading, error }] = useCustomCancelProposalMutation({
 *   variables: {
 *      duplicate: // value for 'duplicate'
 *      id: // value for 'id'
 *      maintainCurrentId: // value for 'maintainCurrentId'
 *   },
 * });
 */
export function useCustomCancelProposalMutation(baseOptions?: Apollo.MutationHookOptions<CustomCancelProposalMutation, CustomCancelProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomCancelProposalMutation, CustomCancelProposalMutationVariables>(CustomCancelProposalDocument, options);
      }
export type CustomCancelProposalMutationHookResult = ReturnType<typeof useCustomCancelProposalMutation>;
export type CustomCancelProposalMutationResult = Apollo.MutationResult<CustomCancelProposalMutation>;
export type CustomCancelProposalMutationOptions = Apollo.BaseMutationOptions<CustomCancelProposalMutation, CustomCancelProposalMutationVariables>;
export const CustomCloseProposalDocument = gql`
    mutation customCloseProposal($id: ID!) {
  closeProposal(id: $id) {
    ...BitumioProposal
  }
}
    ${BitumioProposalFragmentDoc}`;
export type CustomCloseProposalMutationFn = Apollo.MutationFunction<CustomCloseProposalMutation, CustomCloseProposalMutationVariables>;

/**
 * __useCustomCloseProposalMutation__
 *
 * To run a mutation, you first call `useCustomCloseProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomCloseProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customCloseProposalMutation, { data, loading, error }] = useCustomCloseProposalMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomCloseProposalMutation(baseOptions?: Apollo.MutationHookOptions<CustomCloseProposalMutation, CustomCloseProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomCloseProposalMutation, CustomCloseProposalMutationVariables>(CustomCloseProposalDocument, options);
      }
export type CustomCloseProposalMutationHookResult = ReturnType<typeof useCustomCloseProposalMutation>;
export type CustomCloseProposalMutationResult = Apollo.MutationResult<CustomCloseProposalMutation>;
export type CustomCloseProposalMutationOptions = Apollo.BaseMutationOptions<CustomCloseProposalMutation, CustomCloseProposalMutationVariables>;
export const CustomCreateCustomEventDocument = gql`
    mutation customCreateCustomEvent($input: CreateCustomEventInput) {
  createCustomEvent(input: $input) {
    ...CustomEventFragment
  }
}
    ${CustomEventFragmentFragmentDoc}`;
export type CustomCreateCustomEventMutationFn = Apollo.MutationFunction<CustomCreateCustomEventMutation, CustomCreateCustomEventMutationVariables>;

/**
 * __useCustomCreateCustomEventMutation__
 *
 * To run a mutation, you first call `useCustomCreateCustomEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomCreateCustomEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customCreateCustomEventMutation, { data, loading, error }] = useCustomCreateCustomEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomCreateCustomEventMutation(baseOptions?: Apollo.MutationHookOptions<CustomCreateCustomEventMutation, CustomCreateCustomEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomCreateCustomEventMutation, CustomCreateCustomEventMutationVariables>(CustomCreateCustomEventDocument, options);
      }
export type CustomCreateCustomEventMutationHookResult = ReturnType<typeof useCustomCreateCustomEventMutation>;
export type CustomCreateCustomEventMutationResult = Apollo.MutationResult<CustomCreateCustomEventMutation>;
export type CustomCreateCustomEventMutationOptions = Apollo.BaseMutationOptions<CustomCreateCustomEventMutation, CustomCreateCustomEventMutationVariables>;
export const CustomCreateNotificationTriggerDocument = gql`
    mutation CustomCreateNotificationTrigger($input: CreateNotificationTriggerInput!) {
  createNotificationTrigger(input: $input) {
    ...NotificationTriggerFragment
  }
}
    ${NotificationTriggerFragmentFragmentDoc}`;
export type CustomCreateNotificationTriggerMutationFn = Apollo.MutationFunction<CustomCreateNotificationTriggerMutation, CustomCreateNotificationTriggerMutationVariables>;

/**
 * __useCustomCreateNotificationTriggerMutation__
 *
 * To run a mutation, you first call `useCustomCreateNotificationTriggerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomCreateNotificationTriggerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customCreateNotificationTriggerMutation, { data, loading, error }] = useCustomCreateNotificationTriggerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomCreateNotificationTriggerMutation(baseOptions?: Apollo.MutationHookOptions<CustomCreateNotificationTriggerMutation, CustomCreateNotificationTriggerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomCreateNotificationTriggerMutation, CustomCreateNotificationTriggerMutationVariables>(CustomCreateNotificationTriggerDocument, options);
      }
export type CustomCreateNotificationTriggerMutationHookResult = ReturnType<typeof useCustomCreateNotificationTriggerMutation>;
export type CustomCreateNotificationTriggerMutationResult = Apollo.MutationResult<CustomCreateNotificationTriggerMutation>;
export type CustomCreateNotificationTriggerMutationOptions = Apollo.BaseMutationOptions<CustomCreateNotificationTriggerMutation, CustomCreateNotificationTriggerMutationVariables>;
export const CustomCreateProductDocument = gql`
    mutation customCreateProduct($input: CreateProductInput!) {
  createProduct(input: $input) {
    ...UpdatedProduct
  }
}
    ${UpdatedProductFragmentDoc}`;
export type CustomCreateProductMutationFn = Apollo.MutationFunction<CustomCreateProductMutation, CustomCreateProductMutationVariables>;

/**
 * __useCustomCreateProductMutation__
 *
 * To run a mutation, you first call `useCustomCreateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomCreateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customCreateProductMutation, { data, loading, error }] = useCustomCreateProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomCreateProductMutation(baseOptions?: Apollo.MutationHookOptions<CustomCreateProductMutation, CustomCreateProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomCreateProductMutation, CustomCreateProductMutationVariables>(CustomCreateProductDocument, options);
      }
export type CustomCreateProductMutationHookResult = ReturnType<typeof useCustomCreateProductMutation>;
export type CustomCreateProductMutationResult = Apollo.MutationResult<CustomCreateProductMutation>;
export type CustomCreateProductMutationOptions = Apollo.BaseMutationOptions<CustomCreateProductMutation, CustomCreateProductMutationVariables>;
export const CustomCreateProposalDocument = gql`
    mutation customCreateProposal($companyId: ID!, $contactId: ID!, $source: ProposalSource) {
  createProposal(companyId: $companyId, contactId: $contactId, source: $source) {
    ...BitumioProposal
  }
}
    ${BitumioProposalFragmentDoc}`;
export type CustomCreateProposalMutationFn = Apollo.MutationFunction<CustomCreateProposalMutation, CustomCreateProposalMutationVariables>;

/**
 * __useCustomCreateProposalMutation__
 *
 * To run a mutation, you first call `useCustomCreateProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomCreateProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customCreateProposalMutation, { data, loading, error }] = useCustomCreateProposalMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      contactId: // value for 'contactId'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useCustomCreateProposalMutation(baseOptions?: Apollo.MutationHookOptions<CustomCreateProposalMutation, CustomCreateProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomCreateProposalMutation, CustomCreateProposalMutationVariables>(CustomCreateProposalDocument, options);
      }
export type CustomCreateProposalMutationHookResult = ReturnType<typeof useCustomCreateProposalMutation>;
export type CustomCreateProposalMutationResult = Apollo.MutationResult<CustomCreateProposalMutation>;
export type CustomCreateProposalMutationOptions = Apollo.BaseMutationOptions<CustomCreateProposalMutation, CustomCreateProposalMutationVariables>;
export const CustomCreateProposalFromOpportunityDocument = gql`
    mutation customCreateProposalFromOpportunity($id: ID!) {
  createProposalFromOpportunity(id: $id) {
    id
  }
}
    `;
export type CustomCreateProposalFromOpportunityMutationFn = Apollo.MutationFunction<CustomCreateProposalFromOpportunityMutation, CustomCreateProposalFromOpportunityMutationVariables>;

/**
 * __useCustomCreateProposalFromOpportunityMutation__
 *
 * To run a mutation, you first call `useCustomCreateProposalFromOpportunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomCreateProposalFromOpportunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customCreateProposalFromOpportunityMutation, { data, loading, error }] = useCustomCreateProposalFromOpportunityMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomCreateProposalFromOpportunityMutation(baseOptions?: Apollo.MutationHookOptions<CustomCreateProposalFromOpportunityMutation, CustomCreateProposalFromOpportunityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomCreateProposalFromOpportunityMutation, CustomCreateProposalFromOpportunityMutationVariables>(CustomCreateProposalFromOpportunityDocument, options);
      }
export type CustomCreateProposalFromOpportunityMutationHookResult = ReturnType<typeof useCustomCreateProposalFromOpportunityMutation>;
export type CustomCreateProposalFromOpportunityMutationResult = Apollo.MutationResult<CustomCreateProposalFromOpportunityMutation>;
export type CustomCreateProposalFromOpportunityMutationOptions = Apollo.BaseMutationOptions<CustomCreateProposalFromOpportunityMutation, CustomCreateProposalFromOpportunityMutationVariables>;
export const CustomDeleteCustomEventDocument = gql`
    mutation customDeleteCustomEvent($id: ID!) {
  deleteCustomEvent(id: $id) {
    ...CustomEventFragment
  }
}
    ${CustomEventFragmentFragmentDoc}`;
export type CustomDeleteCustomEventMutationFn = Apollo.MutationFunction<CustomDeleteCustomEventMutation, CustomDeleteCustomEventMutationVariables>;

/**
 * __useCustomDeleteCustomEventMutation__
 *
 * To run a mutation, you first call `useCustomDeleteCustomEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomDeleteCustomEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customDeleteCustomEventMutation, { data, loading, error }] = useCustomDeleteCustomEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomDeleteCustomEventMutation(baseOptions?: Apollo.MutationHookOptions<CustomDeleteCustomEventMutation, CustomDeleteCustomEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomDeleteCustomEventMutation, CustomDeleteCustomEventMutationVariables>(CustomDeleteCustomEventDocument, options);
      }
export type CustomDeleteCustomEventMutationHookResult = ReturnType<typeof useCustomDeleteCustomEventMutation>;
export type CustomDeleteCustomEventMutationResult = Apollo.MutationResult<CustomDeleteCustomEventMutation>;
export type CustomDeleteCustomEventMutationOptions = Apollo.BaseMutationOptions<CustomDeleteCustomEventMutation, CustomDeleteCustomEventMutationVariables>;
export const CustomDeleteProposalDocument = gql`
    mutation customDeleteProposal($id: ID!) {
  deleteProposal(id: $id) {
    ...BitumioProposal
  }
}
    ${BitumioProposalFragmentDoc}`;
export type CustomDeleteProposalMutationFn = Apollo.MutationFunction<CustomDeleteProposalMutation, CustomDeleteProposalMutationVariables>;

/**
 * __useCustomDeleteProposalMutation__
 *
 * To run a mutation, you first call `useCustomDeleteProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomDeleteProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customDeleteProposalMutation, { data, loading, error }] = useCustomDeleteProposalMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomDeleteProposalMutation(baseOptions?: Apollo.MutationHookOptions<CustomDeleteProposalMutation, CustomDeleteProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomDeleteProposalMutation, CustomDeleteProposalMutationVariables>(CustomDeleteProposalDocument, options);
      }
export type CustomDeleteProposalMutationHookResult = ReturnType<typeof useCustomDeleteProposalMutation>;
export type CustomDeleteProposalMutationResult = Apollo.MutationResult<CustomDeleteProposalMutation>;
export type CustomDeleteProposalMutationOptions = Apollo.BaseMutationOptions<CustomDeleteProposalMutation, CustomDeleteProposalMutationVariables>;
export const CustomDeleteProposalProductDocument = gql`
    mutation customDeleteProposalProduct($id: ID!) {
  deleteProposalProduct(id: $id) {
    ...BitumioProposalStage
  }
}
    ${BitumioProposalStageFragmentDoc}`;
export type CustomDeleteProposalProductMutationFn = Apollo.MutationFunction<CustomDeleteProposalProductMutation, CustomDeleteProposalProductMutationVariables>;

/**
 * __useCustomDeleteProposalProductMutation__
 *
 * To run a mutation, you first call `useCustomDeleteProposalProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomDeleteProposalProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customDeleteProposalProductMutation, { data, loading, error }] = useCustomDeleteProposalProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomDeleteProposalProductMutation(baseOptions?: Apollo.MutationHookOptions<CustomDeleteProposalProductMutation, CustomDeleteProposalProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomDeleteProposalProductMutation, CustomDeleteProposalProductMutationVariables>(CustomDeleteProposalProductDocument, options);
      }
export type CustomDeleteProposalProductMutationHookResult = ReturnType<typeof useCustomDeleteProposalProductMutation>;
export type CustomDeleteProposalProductMutationResult = Apollo.MutationResult<CustomDeleteProposalProductMutation>;
export type CustomDeleteProposalProductMutationOptions = Apollo.BaseMutationOptions<CustomDeleteProposalProductMutation, CustomDeleteProposalProductMutationVariables>;
export const CustomDeleteProposalStageDocument = gql`
    mutation customDeleteProposalStage($id: ID!) {
  deleteProposalStage(id: $id) {
    ...BitumioProposal
  }
}
    ${BitumioProposalFragmentDoc}`;
export type CustomDeleteProposalStageMutationFn = Apollo.MutationFunction<CustomDeleteProposalStageMutation, CustomDeleteProposalStageMutationVariables>;

/**
 * __useCustomDeleteProposalStageMutation__
 *
 * To run a mutation, you first call `useCustomDeleteProposalStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomDeleteProposalStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customDeleteProposalStageMutation, { data, loading, error }] = useCustomDeleteProposalStageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomDeleteProposalStageMutation(baseOptions?: Apollo.MutationHookOptions<CustomDeleteProposalStageMutation, CustomDeleteProposalStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomDeleteProposalStageMutation, CustomDeleteProposalStageMutationVariables>(CustomDeleteProposalStageDocument, options);
      }
export type CustomDeleteProposalStageMutationHookResult = ReturnType<typeof useCustomDeleteProposalStageMutation>;
export type CustomDeleteProposalStageMutationResult = Apollo.MutationResult<CustomDeleteProposalStageMutation>;
export type CustomDeleteProposalStageMutationOptions = Apollo.BaseMutationOptions<CustomDeleteProposalStageMutation, CustomDeleteProposalStageMutationVariables>;
export const CustomDuplicateProductDocument = gql`
    mutation customDuplicateProduct($id: ID!) {
  duplicateProduct(id: $id) {
    id
  }
}
    `;
export type CustomDuplicateProductMutationFn = Apollo.MutationFunction<CustomDuplicateProductMutation, CustomDuplicateProductMutationVariables>;

/**
 * __useCustomDuplicateProductMutation__
 *
 * To run a mutation, you first call `useCustomDuplicateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomDuplicateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customDuplicateProductMutation, { data, loading, error }] = useCustomDuplicateProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomDuplicateProductMutation(baseOptions?: Apollo.MutationHookOptions<CustomDuplicateProductMutation, CustomDuplicateProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomDuplicateProductMutation, CustomDuplicateProductMutationVariables>(CustomDuplicateProductDocument, options);
      }
export type CustomDuplicateProductMutationHookResult = ReturnType<typeof useCustomDuplicateProductMutation>;
export type CustomDuplicateProductMutationResult = Apollo.MutationResult<CustomDuplicateProductMutation>;
export type CustomDuplicateProductMutationOptions = Apollo.BaseMutationOptions<CustomDuplicateProductMutation, CustomDuplicateProductMutationVariables>;
export const CustomDuplicateProposalDocument = gql`
    mutation customDuplicateProposal($id: ID!, $isChangeOrder: Boolean, $startNewProposal: Boolean, $createNewVersion: Boolean, $changeOrderJobId: ID) {
  duplicateProposal(
    id: $id
    isChangeOrder: $isChangeOrder
    startNewProposal: $startNewProposal
    createNewVersion: $createNewVersion
    changeOrderJobId: $changeOrderJobId
  ) {
    newProposal {
      ...BitumioProposal
    }
    proposal {
      ...BitumioProposal
    }
  }
}
    ${BitumioProposalFragmentDoc}`;
export type CustomDuplicateProposalMutationFn = Apollo.MutationFunction<CustomDuplicateProposalMutation, CustomDuplicateProposalMutationVariables>;

/**
 * __useCustomDuplicateProposalMutation__
 *
 * To run a mutation, you first call `useCustomDuplicateProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomDuplicateProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customDuplicateProposalMutation, { data, loading, error }] = useCustomDuplicateProposalMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isChangeOrder: // value for 'isChangeOrder'
 *      startNewProposal: // value for 'startNewProposal'
 *      createNewVersion: // value for 'createNewVersion'
 *      changeOrderJobId: // value for 'changeOrderJobId'
 *   },
 * });
 */
export function useCustomDuplicateProposalMutation(baseOptions?: Apollo.MutationHookOptions<CustomDuplicateProposalMutation, CustomDuplicateProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomDuplicateProposalMutation, CustomDuplicateProposalMutationVariables>(CustomDuplicateProposalDocument, options);
      }
export type CustomDuplicateProposalMutationHookResult = ReturnType<typeof useCustomDuplicateProposalMutation>;
export type CustomDuplicateProposalMutationResult = Apollo.MutationResult<CustomDuplicateProposalMutation>;
export type CustomDuplicateProposalMutationOptions = Apollo.BaseMutationOptions<CustomDuplicateProposalMutation, CustomDuplicateProposalMutationVariables>;
export const CustomScheduleCustomEventBlockDocument = gql`
    mutation customScheduleCustomEventBlock($input: ScheduleCustomEventBlockInput!) {
  scheduleCustomEventBlock(input: $input) {
    ...CustomEventFragment
  }
}
    ${CustomEventFragmentFragmentDoc}`;
export type CustomScheduleCustomEventBlockMutationFn = Apollo.MutationFunction<CustomScheduleCustomEventBlockMutation, CustomScheduleCustomEventBlockMutationVariables>;

/**
 * __useCustomScheduleCustomEventBlockMutation__
 *
 * To run a mutation, you first call `useCustomScheduleCustomEventBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomScheduleCustomEventBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customScheduleCustomEventBlockMutation, { data, loading, error }] = useCustomScheduleCustomEventBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomScheduleCustomEventBlockMutation(baseOptions?: Apollo.MutationHookOptions<CustomScheduleCustomEventBlockMutation, CustomScheduleCustomEventBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomScheduleCustomEventBlockMutation, CustomScheduleCustomEventBlockMutationVariables>(CustomScheduleCustomEventBlockDocument, options);
      }
export type CustomScheduleCustomEventBlockMutationHookResult = ReturnType<typeof useCustomScheduleCustomEventBlockMutation>;
export type CustomScheduleCustomEventBlockMutationResult = Apollo.MutationResult<CustomScheduleCustomEventBlockMutation>;
export type CustomScheduleCustomEventBlockMutationOptions = Apollo.BaseMutationOptions<CustomScheduleCustomEventBlockMutation, CustomScheduleCustomEventBlockMutationVariables>;
export const CustomScheduleJobPhaseDocument = gql`
    mutation customScheduleJobPhase($blocks: [AddJobPhaseScheduleBlock]!, $crewId: ID, $jobPhaseId: ID!, $travelTimeEstimate: Float, $userIDs: [ID!], $usersColor: String) {
  scheduleJobPhase(
    blocks: $blocks
    crewId: $crewId
    jobPhaseId: $jobPhaseId
    travelTimeEstimate: $travelTimeEstimate
    userIDs: $userIDs
    usersColor: $usersColor
  ) {
    actualCostAdditional
    actualCostDirect
    actualCostEquipment
    actualCostIndirect
    actualCostLabour
    actualCostMaterial
    actualCostOverhead
    actualCostTotal
    actualGrossMargin
    actualGrossMarginPercentage
    actualNetMargin
    actualNetMarginPercentage
    actualOperatingMargin
    actualOperatingMarginPercentage
    actualOverallTotal
    actualProfit
    actualProfitPercentage
    endsAt
    foremanUser {
      id
      organization {
        id
      }
    }
    id
    jobPhases {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualEmployeeHours
      actualGrossMargin
      actualGrossMarginPercentage
      actualMaterialNeeded
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      address
      applicableStatuses
      id
      jobDuration
      jobSize
      notes
      organizationProductTypeName
      productName
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedEmployeeHours
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedMaterialNeeded
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      startsAt
      status
      travelTimeEstimate
    }
    notes
    proposalId
    proposedCostAdditional
    proposedCostDirect
    proposedCostEquipment
    proposedCostIndirect
    proposedCostLabour
    proposedCostMaterial
    proposedCostOverhead
    proposedCostTotal
    proposedGrossMargin
    proposedGrossMarginPercentage
    proposedNetMargin
    proposedNetMarginPercentage
    proposedOperatingMargin
    proposedOperatingMarginPercentage
    proposedOverallTotal
    proposedProfit
    proposedProfitPercentage
    startsAt
    status
    userId
  }
}
    `;
export type CustomScheduleJobPhaseMutationFn = Apollo.MutationFunction<CustomScheduleJobPhaseMutation, CustomScheduleJobPhaseMutationVariables>;

/**
 * __useCustomScheduleJobPhaseMutation__
 *
 * To run a mutation, you first call `useCustomScheduleJobPhaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomScheduleJobPhaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customScheduleJobPhaseMutation, { data, loading, error }] = useCustomScheduleJobPhaseMutation({
 *   variables: {
 *      blocks: // value for 'blocks'
 *      crewId: // value for 'crewId'
 *      jobPhaseId: // value for 'jobPhaseId'
 *      travelTimeEstimate: // value for 'travelTimeEstimate'
 *      userIDs: // value for 'userIDs'
 *      usersColor: // value for 'usersColor'
 *   },
 * });
 */
export function useCustomScheduleJobPhaseMutation(baseOptions?: Apollo.MutationHookOptions<CustomScheduleJobPhaseMutation, CustomScheduleJobPhaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomScheduleJobPhaseMutation, CustomScheduleJobPhaseMutationVariables>(CustomScheduleJobPhaseDocument, options);
      }
export type CustomScheduleJobPhaseMutationHookResult = ReturnType<typeof useCustomScheduleJobPhaseMutation>;
export type CustomScheduleJobPhaseMutationResult = Apollo.MutationResult<CustomScheduleJobPhaseMutation>;
export type CustomScheduleJobPhaseMutationOptions = Apollo.BaseMutationOptions<CustomScheduleJobPhaseMutation, CustomScheduleJobPhaseMutationVariables>;
export const CustomScheduleJobPhaseBlockDocument = gql`
    mutation customScheduleJobPhaseBlock($input: ScheduleJobPhaseBlockInput!) {
  scheduleJobPhaseBlock(input: $input) {
    actualCostAdditional
    actualCostDirect
    actualCostEquipment
    actualCostIndirect
    actualCostLabour
    actualCostMaterial
    actualCostOverhead
    actualCostTotal
    actualGrossMargin
    actualGrossMarginPercentage
    actualNetMargin
    actualNetMarginPercentage
    actualOperatingMargin
    actualOperatingMarginPercentage
    actualOverallTotal
    actualProfit
    actualProfitPercentage
    endsAt
    foremanUser {
      id
      organization {
        id
      }
    }
    id
    jobPhases {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualEmployeeHours
      actualGrossMargin
      actualGrossMarginPercentage
      actualMaterialNeeded
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      address
      applicableStatuses
      id
      jobDuration
      jobSize
      notes
      organizationProductTypeName
      productName
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedEmployeeHours
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedMaterialNeeded
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      startsAt
      status
      travelTimeEstimate
    }
    notes
    proposalId
    proposedCostAdditional
    proposedCostDirect
    proposedCostEquipment
    proposedCostIndirect
    proposedCostLabour
    proposedCostMaterial
    proposedCostOverhead
    proposedCostTotal
    proposedGrossMargin
    proposedGrossMarginPercentage
    proposedNetMargin
    proposedNetMarginPercentage
    proposedOperatingMargin
    proposedOperatingMarginPercentage
    proposedOverallTotal
    proposedProfit
    proposedProfitPercentage
    startsAt
    status
    userId
  }
}
    `;
export type CustomScheduleJobPhaseBlockMutationFn = Apollo.MutationFunction<CustomScheduleJobPhaseBlockMutation, CustomScheduleJobPhaseBlockMutationVariables>;

/**
 * __useCustomScheduleJobPhaseBlockMutation__
 *
 * To run a mutation, you first call `useCustomScheduleJobPhaseBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomScheduleJobPhaseBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customScheduleJobPhaseBlockMutation, { data, loading, error }] = useCustomScheduleJobPhaseBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomScheduleJobPhaseBlockMutation(baseOptions?: Apollo.MutationHookOptions<CustomScheduleJobPhaseBlockMutation, CustomScheduleJobPhaseBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomScheduleJobPhaseBlockMutation, CustomScheduleJobPhaseBlockMutationVariables>(CustomScheduleJobPhaseBlockDocument, options);
      }
export type CustomScheduleJobPhaseBlockMutationHookResult = ReturnType<typeof useCustomScheduleJobPhaseBlockMutation>;
export type CustomScheduleJobPhaseBlockMutationResult = Apollo.MutationResult<CustomScheduleJobPhaseBlockMutation>;
export type CustomScheduleJobPhaseBlockMutationOptions = Apollo.BaseMutationOptions<CustomScheduleJobPhaseBlockMutation, CustomScheduleJobPhaseBlockMutationVariables>;
export const CustomSendProposalToSpecificRecipientsDocument = gql`
    mutation customSendProposalToSpecificRecipients($emails: [String!]!, $proposalId: ID!) {
  sendProposalToSpecificRecipients(emails: $emails, proposalId: $proposalId) {
    contactId
    email
    id
  }
}
    `;
export type CustomSendProposalToSpecificRecipientsMutationFn = Apollo.MutationFunction<CustomSendProposalToSpecificRecipientsMutation, CustomSendProposalToSpecificRecipientsMutationVariables>;

/**
 * __useCustomSendProposalToSpecificRecipientsMutation__
 *
 * To run a mutation, you first call `useCustomSendProposalToSpecificRecipientsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomSendProposalToSpecificRecipientsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customSendProposalToSpecificRecipientsMutation, { data, loading, error }] = useCustomSendProposalToSpecificRecipientsMutation({
 *   variables: {
 *      emails: // value for 'emails'
 *      proposalId: // value for 'proposalId'
 *   },
 * });
 */
export function useCustomSendProposalToSpecificRecipientsMutation(baseOptions?: Apollo.MutationHookOptions<CustomSendProposalToSpecificRecipientsMutation, CustomSendProposalToSpecificRecipientsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomSendProposalToSpecificRecipientsMutation, CustomSendProposalToSpecificRecipientsMutationVariables>(CustomSendProposalToSpecificRecipientsDocument, options);
      }
export type CustomSendProposalToSpecificRecipientsMutationHookResult = ReturnType<typeof useCustomSendProposalToSpecificRecipientsMutation>;
export type CustomSendProposalToSpecificRecipientsMutationResult = Apollo.MutationResult<CustomSendProposalToSpecificRecipientsMutation>;
export type CustomSendProposalToSpecificRecipientsMutationOptions = Apollo.BaseMutationOptions<CustomSendProposalToSpecificRecipientsMutation, CustomSendProposalToSpecificRecipientsMutationVariables>;
export const CustomSetProposalToDraftDocument = gql`
    mutation customSetProposalToDraft($id: ID!) {
  setProposalToDraft(id: $id) {
    ...BitumioProposal
  }
}
    ${BitumioProposalFragmentDoc}`;
export type CustomSetProposalToDraftMutationFn = Apollo.MutationFunction<CustomSetProposalToDraftMutation, CustomSetProposalToDraftMutationVariables>;

/**
 * __useCustomSetProposalToDraftMutation__
 *
 * To run a mutation, you first call `useCustomSetProposalToDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomSetProposalToDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customSetProposalToDraftMutation, { data, loading, error }] = useCustomSetProposalToDraftMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomSetProposalToDraftMutation(baseOptions?: Apollo.MutationHookOptions<CustomSetProposalToDraftMutation, CustomSetProposalToDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomSetProposalToDraftMutation, CustomSetProposalToDraftMutationVariables>(CustomSetProposalToDraftDocument, options);
      }
export type CustomSetProposalToDraftMutationHookResult = ReturnType<typeof useCustomSetProposalToDraftMutation>;
export type CustomSetProposalToDraftMutationResult = Apollo.MutationResult<CustomSetProposalToDraftMutation>;
export type CustomSetProposalToDraftMutationOptions = Apollo.BaseMutationOptions<CustomSetProposalToDraftMutation, CustomSetProposalToDraftMutationVariables>;
export const CustomSetProposalToWonDocument = gql`
    mutation customSetProposalToWon($id: ID!, $forceSend: Boolean) {
  setProposalToWon(id: $id, forceSend: $forceSend) {
    ...BitumioProposal
  }
}
    ${BitumioProposalFragmentDoc}`;
export type CustomSetProposalToWonMutationFn = Apollo.MutationFunction<CustomSetProposalToWonMutation, CustomSetProposalToWonMutationVariables>;

/**
 * __useCustomSetProposalToWonMutation__
 *
 * To run a mutation, you first call `useCustomSetProposalToWonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomSetProposalToWonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customSetProposalToWonMutation, { data, loading, error }] = useCustomSetProposalToWonMutation({
 *   variables: {
 *      id: // value for 'id'
 *      forceSend: // value for 'forceSend'
 *   },
 * });
 */
export function useCustomSetProposalToWonMutation(baseOptions?: Apollo.MutationHookOptions<CustomSetProposalToWonMutation, CustomSetProposalToWonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomSetProposalToWonMutation, CustomSetProposalToWonMutationVariables>(CustomSetProposalToWonDocument, options);
      }
export type CustomSetProposalToWonMutationHookResult = ReturnType<typeof useCustomSetProposalToWonMutation>;
export type CustomSetProposalToWonMutationResult = Apollo.MutationResult<CustomSetProposalToWonMutation>;
export type CustomSetProposalToWonMutationOptions = Apollo.BaseMutationOptions<CustomSetProposalToWonMutation, CustomSetProposalToWonMutationVariables>;
export const CustomUnscheduleCustomEventDocument = gql`
    mutation customUnscheduleCustomEvent($id: ID!) {
  unscheduleCustomEvent(id: $id) {
    ...CustomEventFragment
  }
}
    ${CustomEventFragmentFragmentDoc}`;
export type CustomUnscheduleCustomEventMutationFn = Apollo.MutationFunction<CustomUnscheduleCustomEventMutation, CustomUnscheduleCustomEventMutationVariables>;

/**
 * __useCustomUnscheduleCustomEventMutation__
 *
 * To run a mutation, you first call `useCustomUnscheduleCustomEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomUnscheduleCustomEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customUnscheduleCustomEventMutation, { data, loading, error }] = useCustomUnscheduleCustomEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomUnscheduleCustomEventMutation(baseOptions?: Apollo.MutationHookOptions<CustomUnscheduleCustomEventMutation, CustomUnscheduleCustomEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomUnscheduleCustomEventMutation, CustomUnscheduleCustomEventMutationVariables>(CustomUnscheduleCustomEventDocument, options);
      }
export type CustomUnscheduleCustomEventMutationHookResult = ReturnType<typeof useCustomUnscheduleCustomEventMutation>;
export type CustomUnscheduleCustomEventMutationResult = Apollo.MutationResult<CustomUnscheduleCustomEventMutation>;
export type CustomUnscheduleCustomEventMutationOptions = Apollo.BaseMutationOptions<CustomUnscheduleCustomEventMutation, CustomUnscheduleCustomEventMutationVariables>;
export const CustomUnscheduleJobPhaseDocument = gql`
    mutation customUnscheduleJobPhase($jobPhaseId: ID!) {
  unscheduleJobPhase(jobPhaseId: $jobPhaseId) {
    actualCostAdditional
    actualCostDirect
    actualCostEquipment
    actualCostIndirect
    actualCostLabour
    actualCostMaterial
    actualCostOverhead
    actualCostTotal
    actualGrossMargin
    actualGrossMarginPercentage
    actualNetMargin
    actualNetMarginPercentage
    actualOperatingMargin
    actualOperatingMarginPercentage
    actualOverallTotal
    actualProfit
    actualProfitPercentage
    endsAt
    foremanUser {
      id
      organization {
        id
      }
    }
    id
    jobPhases {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualEmployeeHours
      actualGrossMargin
      actualGrossMarginPercentage
      actualMaterialNeeded
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      address
      applicableStatuses
      id
      jobDuration
      jobSize
      notes
      organizationProductTypeName
      productName
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedEmployeeHours
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedMaterialNeeded
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      startsAt
      status
      travelTimeEstimate
    }
    notes
    proposalId
    proposedCostAdditional
    proposedCostDirect
    proposedCostEquipment
    proposedCostIndirect
    proposedCostLabour
    proposedCostMaterial
    proposedCostOverhead
    proposedCostTotal
    proposedGrossMargin
    proposedGrossMarginPercentage
    proposedNetMargin
    proposedNetMarginPercentage
    proposedOperatingMargin
    proposedOperatingMarginPercentage
    proposedOverallTotal
    proposedProfit
    proposedProfitPercentage
    startsAt
    status
    userId
  }
}
    `;
export type CustomUnscheduleJobPhaseMutationFn = Apollo.MutationFunction<CustomUnscheduleJobPhaseMutation, CustomUnscheduleJobPhaseMutationVariables>;

/**
 * __useCustomUnscheduleJobPhaseMutation__
 *
 * To run a mutation, you first call `useCustomUnscheduleJobPhaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomUnscheduleJobPhaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customUnscheduleJobPhaseMutation, { data, loading, error }] = useCustomUnscheduleJobPhaseMutation({
 *   variables: {
 *      jobPhaseId: // value for 'jobPhaseId'
 *   },
 * });
 */
export function useCustomUnscheduleJobPhaseMutation(baseOptions?: Apollo.MutationHookOptions<CustomUnscheduleJobPhaseMutation, CustomUnscheduleJobPhaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomUnscheduleJobPhaseMutation, CustomUnscheduleJobPhaseMutationVariables>(CustomUnscheduleJobPhaseDocument, options);
      }
export type CustomUnscheduleJobPhaseMutationHookResult = ReturnType<typeof useCustomUnscheduleJobPhaseMutation>;
export type CustomUnscheduleJobPhaseMutationResult = Apollo.MutationResult<CustomUnscheduleJobPhaseMutation>;
export type CustomUnscheduleJobPhaseMutationOptions = Apollo.BaseMutationOptions<CustomUnscheduleJobPhaseMutation, CustomUnscheduleJobPhaseMutationVariables>;
export const CustomUpdateCustomEventDocument = gql`
    mutation customUpdateCustomEvent($input: UpdateCustomEventInput) {
  updateCustomEvent(input: $input) {
    ...CustomEventFragment
  }
}
    ${CustomEventFragmentFragmentDoc}`;
export type CustomUpdateCustomEventMutationFn = Apollo.MutationFunction<CustomUpdateCustomEventMutation, CustomUpdateCustomEventMutationVariables>;

/**
 * __useCustomUpdateCustomEventMutation__
 *
 * To run a mutation, you first call `useCustomUpdateCustomEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomUpdateCustomEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customUpdateCustomEventMutation, { data, loading, error }] = useCustomUpdateCustomEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomUpdateCustomEventMutation(baseOptions?: Apollo.MutationHookOptions<CustomUpdateCustomEventMutation, CustomUpdateCustomEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomUpdateCustomEventMutation, CustomUpdateCustomEventMutationVariables>(CustomUpdateCustomEventDocument, options);
      }
export type CustomUpdateCustomEventMutationHookResult = ReturnType<typeof useCustomUpdateCustomEventMutation>;
export type CustomUpdateCustomEventMutationResult = Apollo.MutationResult<CustomUpdateCustomEventMutation>;
export type CustomUpdateCustomEventMutationOptions = Apollo.BaseMutationOptions<CustomUpdateCustomEventMutation, CustomUpdateCustomEventMutationVariables>;
export const CustomUpdateJobNotesDocument = gql`
    mutation customUpdateJobNotes($id: ID!, $notes: String!) {
  updateJobNotes(id: $id, notes: $notes) {
    id
    notes
  }
}
    `;
export type CustomUpdateJobNotesMutationFn = Apollo.MutationFunction<CustomUpdateJobNotesMutation, CustomUpdateJobNotesMutationVariables>;

/**
 * __useCustomUpdateJobNotesMutation__
 *
 * To run a mutation, you first call `useCustomUpdateJobNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomUpdateJobNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customUpdateJobNotesMutation, { data, loading, error }] = useCustomUpdateJobNotesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useCustomUpdateJobNotesMutation(baseOptions?: Apollo.MutationHookOptions<CustomUpdateJobNotesMutation, CustomUpdateJobNotesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomUpdateJobNotesMutation, CustomUpdateJobNotesMutationVariables>(CustomUpdateJobNotesDocument, options);
      }
export type CustomUpdateJobNotesMutationHookResult = ReturnType<typeof useCustomUpdateJobNotesMutation>;
export type CustomUpdateJobNotesMutationResult = Apollo.MutationResult<CustomUpdateJobNotesMutation>;
export type CustomUpdateJobNotesMutationOptions = Apollo.BaseMutationOptions<CustomUpdateJobNotesMutation, CustomUpdateJobNotesMutationVariables>;
export const CustomUpdateJobPhaseNotesDocument = gql`
    mutation customUpdateJobPhaseNotes($input: UpdateJobPhaseNotesInput!) {
  updateJobPhaseNotes(input: $input) {
    ...JobPhaseFragment
  }
}
    ${JobPhaseFragmentFragmentDoc}`;
export type CustomUpdateJobPhaseNotesMutationFn = Apollo.MutationFunction<CustomUpdateJobPhaseNotesMutation, CustomUpdateJobPhaseNotesMutationVariables>;

/**
 * __useCustomUpdateJobPhaseNotesMutation__
 *
 * To run a mutation, you first call `useCustomUpdateJobPhaseNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomUpdateJobPhaseNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customUpdateJobPhaseNotesMutation, { data, loading, error }] = useCustomUpdateJobPhaseNotesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomUpdateJobPhaseNotesMutation(baseOptions?: Apollo.MutationHookOptions<CustomUpdateJobPhaseNotesMutation, CustomUpdateJobPhaseNotesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomUpdateJobPhaseNotesMutation, CustomUpdateJobPhaseNotesMutationVariables>(CustomUpdateJobPhaseNotesDocument, options);
      }
export type CustomUpdateJobPhaseNotesMutationHookResult = ReturnType<typeof useCustomUpdateJobPhaseNotesMutation>;
export type CustomUpdateJobPhaseNotesMutationResult = Apollo.MutationResult<CustomUpdateJobPhaseNotesMutation>;
export type CustomUpdateJobPhaseNotesMutationOptions = Apollo.BaseMutationOptions<CustomUpdateJobPhaseNotesMutation, CustomUpdateJobPhaseNotesMutationVariables>;
export const CustomUpdateJobProjectManagerDocument = gql`
    mutation customUpdateJobProjectManager($id: ID!, $userId: ID!) {
  updateJobProjectManager(id: $id, userId: $userId) {
    id
    userId
  }
}
    `;
export type CustomUpdateJobProjectManagerMutationFn = Apollo.MutationFunction<CustomUpdateJobProjectManagerMutation, CustomUpdateJobProjectManagerMutationVariables>;

/**
 * __useCustomUpdateJobProjectManagerMutation__
 *
 * To run a mutation, you first call `useCustomUpdateJobProjectManagerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomUpdateJobProjectManagerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customUpdateJobProjectManagerMutation, { data, loading, error }] = useCustomUpdateJobProjectManagerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCustomUpdateJobProjectManagerMutation(baseOptions?: Apollo.MutationHookOptions<CustomUpdateJobProjectManagerMutation, CustomUpdateJobProjectManagerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomUpdateJobProjectManagerMutation, CustomUpdateJobProjectManagerMutationVariables>(CustomUpdateJobProjectManagerDocument, options);
      }
export type CustomUpdateJobProjectManagerMutationHookResult = ReturnType<typeof useCustomUpdateJobProjectManagerMutation>;
export type CustomUpdateJobProjectManagerMutationResult = Apollo.MutationResult<CustomUpdateJobProjectManagerMutation>;
export type CustomUpdateJobProjectManagerMutationOptions = Apollo.BaseMutationOptions<CustomUpdateJobProjectManagerMutation, CustomUpdateJobProjectManagerMutationVariables>;
export const CustomUpdateNotificationTriggerDocument = gql`
    mutation CustomUpdateNotificationTrigger($input: UpdateNotificationTriggerInput!) {
  updateNotificationTrigger(input: $input) {
    ...NotificationTriggerFragment
  }
}
    ${NotificationTriggerFragmentFragmentDoc}`;
export type CustomUpdateNotificationTriggerMutationFn = Apollo.MutationFunction<CustomUpdateNotificationTriggerMutation, CustomUpdateNotificationTriggerMutationVariables>;

/**
 * __useCustomUpdateNotificationTriggerMutation__
 *
 * To run a mutation, you first call `useCustomUpdateNotificationTriggerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomUpdateNotificationTriggerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customUpdateNotificationTriggerMutation, { data, loading, error }] = useCustomUpdateNotificationTriggerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomUpdateNotificationTriggerMutation(baseOptions?: Apollo.MutationHookOptions<CustomUpdateNotificationTriggerMutation, CustomUpdateNotificationTriggerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomUpdateNotificationTriggerMutation, CustomUpdateNotificationTriggerMutationVariables>(CustomUpdateNotificationTriggerDocument, options);
      }
export type CustomUpdateNotificationTriggerMutationHookResult = ReturnType<typeof useCustomUpdateNotificationTriggerMutation>;
export type CustomUpdateNotificationTriggerMutationResult = Apollo.MutationResult<CustomUpdateNotificationTriggerMutation>;
export type CustomUpdateNotificationTriggerMutationOptions = Apollo.BaseMutationOptions<CustomUpdateNotificationTriggerMutation, CustomUpdateNotificationTriggerMutationVariables>;
export const CustomUpdateProposalDocument = gql`
    mutation customUpdateProposal($id: ID!, $companyId: ID!, $contactId: ID!, $source: ProposalSource) {
  updateProposal(
    id: $id
    companyId: $companyId
    contactId: $contactId
    source: $source
  ) {
    ...BitumioProposal
  }
}
    ${BitumioProposalFragmentDoc}`;
export type CustomUpdateProposalMutationFn = Apollo.MutationFunction<CustomUpdateProposalMutation, CustomUpdateProposalMutationVariables>;

/**
 * __useCustomUpdateProposalMutation__
 *
 * To run a mutation, you first call `useCustomUpdateProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomUpdateProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customUpdateProposalMutation, { data, loading, error }] = useCustomUpdateProposalMutation({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *      contactId: // value for 'contactId'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useCustomUpdateProposalMutation(baseOptions?: Apollo.MutationHookOptions<CustomUpdateProposalMutation, CustomUpdateProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomUpdateProposalMutation, CustomUpdateProposalMutationVariables>(CustomUpdateProposalDocument, options);
      }
export type CustomUpdateProposalMutationHookResult = ReturnType<typeof useCustomUpdateProposalMutation>;
export type CustomUpdateProposalMutationResult = Apollo.MutationResult<CustomUpdateProposalMutation>;
export type CustomUpdateProposalMutationOptions = Apollo.BaseMutationOptions<CustomUpdateProposalMutation, CustomUpdateProposalMutationVariables>;
export const CustomUpdateProposalInfoDocument = gql`
    mutation customUpdateProposalInfo($input: UpdateProposalInfoInput) {
  updateProposalInfo(input: $input) {
    ...BitumioProposal
  }
}
    ${BitumioProposalFragmentDoc}`;
export type CustomUpdateProposalInfoMutationFn = Apollo.MutationFunction<CustomUpdateProposalInfoMutation, CustomUpdateProposalInfoMutationVariables>;

/**
 * __useCustomUpdateProposalInfoMutation__
 *
 * To run a mutation, you first call `useCustomUpdateProposalInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomUpdateProposalInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customUpdateProposalInfoMutation, { data, loading, error }] = useCustomUpdateProposalInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomUpdateProposalInfoMutation(baseOptions?: Apollo.MutationHookOptions<CustomUpdateProposalInfoMutation, CustomUpdateProposalInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomUpdateProposalInfoMutation, CustomUpdateProposalInfoMutationVariables>(CustomUpdateProposalInfoDocument, options);
      }
export type CustomUpdateProposalInfoMutationHookResult = ReturnType<typeof useCustomUpdateProposalInfoMutation>;
export type CustomUpdateProposalInfoMutationResult = Apollo.MutationResult<CustomUpdateProposalInfoMutation>;
export type CustomUpdateProposalInfoMutationOptions = Apollo.BaseMutationOptions<CustomUpdateProposalInfoMutation, CustomUpdateProposalInfoMutationVariables>;
export const CustomUpdateProposalPlantProductDocument = gql`
    mutation customUpdateProposalPlantProduct($plantProductId: ID!, $proposalProductId: ID!) {
  updateProposalPlantProduct(
    plantProductId: $plantProductId
    proposalProductId: $proposalProductId
  ) {
    ...BitumioProposal
  }
}
    ${BitumioProposalFragmentDoc}`;
export type CustomUpdateProposalPlantProductMutationFn = Apollo.MutationFunction<CustomUpdateProposalPlantProductMutation, CustomUpdateProposalPlantProductMutationVariables>;

/**
 * __useCustomUpdateProposalPlantProductMutation__
 *
 * To run a mutation, you first call `useCustomUpdateProposalPlantProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomUpdateProposalPlantProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customUpdateProposalPlantProductMutation, { data, loading, error }] = useCustomUpdateProposalPlantProductMutation({
 *   variables: {
 *      plantProductId: // value for 'plantProductId'
 *      proposalProductId: // value for 'proposalProductId'
 *   },
 * });
 */
export function useCustomUpdateProposalPlantProductMutation(baseOptions?: Apollo.MutationHookOptions<CustomUpdateProposalPlantProductMutation, CustomUpdateProposalPlantProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomUpdateProposalPlantProductMutation, CustomUpdateProposalPlantProductMutationVariables>(CustomUpdateProposalPlantProductDocument, options);
      }
export type CustomUpdateProposalPlantProductMutationHookResult = ReturnType<typeof useCustomUpdateProposalPlantProductMutation>;
export type CustomUpdateProposalPlantProductMutationResult = Apollo.MutationResult<CustomUpdateProposalPlantProductMutation>;
export type CustomUpdateProposalPlantProductMutationOptions = Apollo.BaseMutationOptions<CustomUpdateProposalPlantProductMutation, CustomUpdateProposalPlantProductMutationVariables>;
export const CustomUpdateProposalProductDocument = gql`
    mutation customUpdateProposalProduct($input: UpdateProposalProductInput!) {
  updateProposalProduct(input: $input) {
    ...BitumioProposal
  }
}
    ${BitumioProposalFragmentDoc}`;
export type CustomUpdateProposalProductMutationFn = Apollo.MutationFunction<CustomUpdateProposalProductMutation, CustomUpdateProposalProductMutationVariables>;

/**
 * __useCustomUpdateProposalProductMutation__
 *
 * To run a mutation, you first call `useCustomUpdateProposalProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomUpdateProposalProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customUpdateProposalProductMutation, { data, loading, error }] = useCustomUpdateProposalProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomUpdateProposalProductMutation(baseOptions?: Apollo.MutationHookOptions<CustomUpdateProposalProductMutation, CustomUpdateProposalProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomUpdateProposalProductMutation, CustomUpdateProposalProductMutationVariables>(CustomUpdateProposalProductDocument, options);
      }
export type CustomUpdateProposalProductMutationHookResult = ReturnType<typeof useCustomUpdateProposalProductMutation>;
export type CustomUpdateProposalProductMutationResult = Apollo.MutationResult<CustomUpdateProposalProductMutation>;
export type CustomUpdateProposalProductMutationOptions = Apollo.BaseMutationOptions<CustomUpdateProposalProductMutation, CustomUpdateProposalProductMutationVariables>;
export const CustomUpdateProposalStageDocument = gql`
    mutation customUpdateProposalStage($id: ID!, $name: String, $mapData: String, $addressOverride: String) {
  updateProposalStage(
    id: $id
    name: $name
    mapData: $mapData
    addressOverride: $addressOverride
  ) {
    ...BitumioProposalStage
  }
}
    ${BitumioProposalStageFragmentDoc}`;
export type CustomUpdateProposalStageMutationFn = Apollo.MutationFunction<CustomUpdateProposalStageMutation, CustomUpdateProposalStageMutationVariables>;

/**
 * __useCustomUpdateProposalStageMutation__
 *
 * To run a mutation, you first call `useCustomUpdateProposalStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomUpdateProposalStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customUpdateProposalStageMutation, { data, loading, error }] = useCustomUpdateProposalStageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      mapData: // value for 'mapData'
 *      addressOverride: // value for 'addressOverride'
 *   },
 * });
 */
export function useCustomUpdateProposalStageMutation(baseOptions?: Apollo.MutationHookOptions<CustomUpdateProposalStageMutation, CustomUpdateProposalStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomUpdateProposalStageMutation, CustomUpdateProposalStageMutationVariables>(CustomUpdateProposalStageDocument, options);
      }
export type CustomUpdateProposalStageMutationHookResult = ReturnType<typeof useCustomUpdateProposalStageMutation>;
export type CustomUpdateProposalStageMutationResult = Apollo.MutationResult<CustomUpdateProposalStageMutation>;
export type CustomUpdateProposalStageMutationOptions = Apollo.BaseMutationOptions<CustomUpdateProposalStageMutation, CustomUpdateProposalStageMutationVariables>;
export const CustomGetAllCrewsDocument = gql`
    query customGetAllCrews {
  getAllCrews {
    color
    displayName
    employees {
      id
    }
    foremanUser {
      id
      name
    }
    id
    name
    organization {
      id
    }
    rate
  }
}
    `;

/**
 * __useCustomGetAllCrewsQuery__
 *
 * To run a query within a React component, call `useCustomGetAllCrewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetAllCrewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetAllCrewsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomGetAllCrewsQuery(baseOptions?: Apollo.QueryHookOptions<CustomGetAllCrewsQuery, CustomGetAllCrewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetAllCrewsQuery, CustomGetAllCrewsQueryVariables>(CustomGetAllCrewsDocument, options);
      }
export function useCustomGetAllCrewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetAllCrewsQuery, CustomGetAllCrewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetAllCrewsQuery, CustomGetAllCrewsQueryVariables>(CustomGetAllCrewsDocument, options);
        }
export type CustomGetAllCrewsQueryHookResult = ReturnType<typeof useCustomGetAllCrewsQuery>;
export type CustomGetAllCrewsLazyQueryHookResult = ReturnType<typeof useCustomGetAllCrewsLazyQuery>;
export type CustomGetAllCrewsQueryResult = Apollo.QueryResult<CustomGetAllCrewsQuery, CustomGetAllCrewsQueryVariables>;
export const CustomGetCompaniesDocument = gql`
    query customGetCompanies($first: Int!, $page: Int, $search: String, $sort: SortDirection, $sortKey: GetCompaniesSortKey) {
  getCompanies(
    first: $first
    page: $page
    search: $search
    sort: $sort
    sortKey: $sortKey
  ) {
    data {
      ...CompanyFragment
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    ${CompanyFragmentFragmentDoc}`;

/**
 * __useCustomGetCompaniesQuery__
 *
 * To run a query within a React component, call `useCustomGetCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetCompaniesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      sort: // value for 'sort'
 *      sortKey: // value for 'sortKey'
 *   },
 * });
 */
export function useCustomGetCompaniesQuery(baseOptions: Apollo.QueryHookOptions<CustomGetCompaniesQuery, CustomGetCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetCompaniesQuery, CustomGetCompaniesQueryVariables>(CustomGetCompaniesDocument, options);
      }
export function useCustomGetCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetCompaniesQuery, CustomGetCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetCompaniesQuery, CustomGetCompaniesQueryVariables>(CustomGetCompaniesDocument, options);
        }
export type CustomGetCompaniesQueryHookResult = ReturnType<typeof useCustomGetCompaniesQuery>;
export type CustomGetCompaniesLazyQueryHookResult = ReturnType<typeof useCustomGetCompaniesLazyQuery>;
export type CustomGetCompaniesQueryResult = Apollo.QueryResult<CustomGetCompaniesQuery, CustomGetCompaniesQueryVariables>;
export const CustomGetCompaniesForFilterDocument = gql`
    query customGetCompaniesForFilter($first: Int!, $page: Int, $search: String, $sort: SortDirection, $sortKey: GetCompaniesSortKey) {
  getCompanies(
    first: $first
    page: $page
    search: $search
    sort: $sort
    sortKey: $sortKey
  ) {
    data {
      id
      name
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useCustomGetCompaniesForFilterQuery__
 *
 * To run a query within a React component, call `useCustomGetCompaniesForFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetCompaniesForFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetCompaniesForFilterQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      sort: // value for 'sort'
 *      sortKey: // value for 'sortKey'
 *   },
 * });
 */
export function useCustomGetCompaniesForFilterQuery(baseOptions: Apollo.QueryHookOptions<CustomGetCompaniesForFilterQuery, CustomGetCompaniesForFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetCompaniesForFilterQuery, CustomGetCompaniesForFilterQueryVariables>(CustomGetCompaniesForFilterDocument, options);
      }
export function useCustomGetCompaniesForFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetCompaniesForFilterQuery, CustomGetCompaniesForFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetCompaniesForFilterQuery, CustomGetCompaniesForFilterQueryVariables>(CustomGetCompaniesForFilterDocument, options);
        }
export type CustomGetCompaniesForFilterQueryHookResult = ReturnType<typeof useCustomGetCompaniesForFilterQuery>;
export type CustomGetCompaniesForFilterLazyQueryHookResult = ReturnType<typeof useCustomGetCompaniesForFilterLazyQuery>;
export type CustomGetCompaniesForFilterQueryResult = Apollo.QueryResult<CustomGetCompaniesForFilterQuery, CustomGetCompaniesForFilterQueryVariables>;
export const CustomGetCompanyDocument = gql`
    query customGetCompany($id: ID!) {
  getCompany(id: $id) {
    ...CompanyFragment
  }
}
    ${CompanyFragmentFragmentDoc}`;

/**
 * __useCustomGetCompanyQuery__
 *
 * To run a query within a React component, call `useCustomGetCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetCompanyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomGetCompanyQuery(baseOptions: Apollo.QueryHookOptions<CustomGetCompanyQuery, CustomGetCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetCompanyQuery, CustomGetCompanyQueryVariables>(CustomGetCompanyDocument, options);
      }
export function useCustomGetCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetCompanyQuery, CustomGetCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetCompanyQuery, CustomGetCompanyQueryVariables>(CustomGetCompanyDocument, options);
        }
export type CustomGetCompanyQueryHookResult = ReturnType<typeof useCustomGetCompanyQuery>;
export type CustomGetCompanyLazyQueryHookResult = ReturnType<typeof useCustomGetCompanyLazyQuery>;
export type CustomGetCompanyQueryResult = Apollo.QueryResult<CustomGetCompanyQuery, CustomGetCompanyQueryVariables>;
export const CustomGetCustomEventDocument = gql`
    query customGetCustomEvent($id: ID!) {
  getCustomEvent(id: $id) {
    ...CustomEventFragment
  }
}
    ${CustomEventFragmentFragmentDoc}`;

/**
 * __useCustomGetCustomEventQuery__
 *
 * To run a query within a React component, call `useCustomGetCustomEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetCustomEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetCustomEventQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomGetCustomEventQuery(baseOptions: Apollo.QueryHookOptions<CustomGetCustomEventQuery, CustomGetCustomEventQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetCustomEventQuery, CustomGetCustomEventQueryVariables>(CustomGetCustomEventDocument, options);
      }
export function useCustomGetCustomEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetCustomEventQuery, CustomGetCustomEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetCustomEventQuery, CustomGetCustomEventQueryVariables>(CustomGetCustomEventDocument, options);
        }
export type CustomGetCustomEventQueryHookResult = ReturnType<typeof useCustomGetCustomEventQuery>;
export type CustomGetCustomEventLazyQueryHookResult = ReturnType<typeof useCustomGetCustomEventLazyQuery>;
export type CustomGetCustomEventQueryResult = Apollo.QueryResult<CustomGetCustomEventQuery, CustomGetCustomEventQueryVariables>;
export const CustomGetCustomEventBlocksDocument = gql`
    query customGetCustomEventBlocks($dateFrom: DateTime, $dateUntil: DateTime, $crewId: ID, $customEventIds: [ID]) {
  getCustomEventBlocks(
    dateFrom: $dateFrom
    dateUntil: $dateUntil
    crewId: $crewId
    customEventIds: $customEventIds
  ) {
    blockLength
    customEvent {
      color
      crew {
        color
        id
        name
      }
      endsAt
      id
      name
      notes
      startsAt
      customEventsToUsers {
        user {
          id
          firstName
          lastName
        }
      }
    }
    endsAt
    id
    scheduledAt
  }
}
    `;

/**
 * __useCustomGetCustomEventBlocksQuery__
 *
 * To run a query within a React component, call `useCustomGetCustomEventBlocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetCustomEventBlocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetCustomEventBlocksQuery({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateUntil: // value for 'dateUntil'
 *      crewId: // value for 'crewId'
 *      customEventIds: // value for 'customEventIds'
 *   },
 * });
 */
export function useCustomGetCustomEventBlocksQuery(baseOptions?: Apollo.QueryHookOptions<CustomGetCustomEventBlocksQuery, CustomGetCustomEventBlocksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetCustomEventBlocksQuery, CustomGetCustomEventBlocksQueryVariables>(CustomGetCustomEventBlocksDocument, options);
      }
export function useCustomGetCustomEventBlocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetCustomEventBlocksQuery, CustomGetCustomEventBlocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetCustomEventBlocksQuery, CustomGetCustomEventBlocksQueryVariables>(CustomGetCustomEventBlocksDocument, options);
        }
export type CustomGetCustomEventBlocksQueryHookResult = ReturnType<typeof useCustomGetCustomEventBlocksQuery>;
export type CustomGetCustomEventBlocksLazyQueryHookResult = ReturnType<typeof useCustomGetCustomEventBlocksLazyQuery>;
export type CustomGetCustomEventBlocksQueryResult = Apollo.QueryResult<CustomGetCustomEventBlocksQuery, CustomGetCustomEventBlocksQueryVariables>;
export const CustomGetDashboardMapDataDocument = gql`
    query customGetDashboardMapData {
  getDashboardMapData {
    id
    status
    jobPhases {
      id
      status
      startsAt
      productName
    }
    proposalStage {
      id
      name
    }
    address {
      latitude
      longitude
    }
  }
}
    `;

/**
 * __useCustomGetDashboardMapDataQuery__
 *
 * To run a query within a React component, call `useCustomGetDashboardMapDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetDashboardMapDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetDashboardMapDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomGetDashboardMapDataQuery(baseOptions?: Apollo.QueryHookOptions<CustomGetDashboardMapDataQuery, CustomGetDashboardMapDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetDashboardMapDataQuery, CustomGetDashboardMapDataQueryVariables>(CustomGetDashboardMapDataDocument, options);
      }
export function useCustomGetDashboardMapDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetDashboardMapDataQuery, CustomGetDashboardMapDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetDashboardMapDataQuery, CustomGetDashboardMapDataQueryVariables>(CustomGetDashboardMapDataDocument, options);
        }
export type CustomGetDashboardMapDataQueryHookResult = ReturnType<typeof useCustomGetDashboardMapDataQuery>;
export type CustomGetDashboardMapDataLazyQueryHookResult = ReturnType<typeof useCustomGetDashboardMapDataLazyQuery>;
export type CustomGetDashboardMapDataQueryResult = Apollo.QueryResult<CustomGetDashboardMapDataQuery, CustomGetDashboardMapDataQueryVariables>;
export const CustomGetJobDocument = gql`
    query customGetJob($id: ID!) {
  getJob(id: $id) {
    actualCostAdditional
    actualCostDirect
    actualCostEquipment
    actualCostIndirect
    actualCostLabour
    actualCostMaterial
    actualCostOverhead
    actualCostTotal
    actualGrossMargin
    actualGrossMarginPercentage
    actualNetMargin
    actualNetMarginPercentage
    actualOperatingMargin
    actualOperatingMarginPercentage
    actualOverallTotal
    actualProfit
    actualCostTransferTruck
    actualProfitPercentage
    datePushedToQuickbooks
    billingStatus
    projectFilesFolderId
    proposalId
    userId
    address {
      city
      country
      id
      latitude
      line1
      line2
      longitude
      organizationAddressId
      state
      zip
      mapImage
    }
    company {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      email
      id
      name
      notes
      phone
      website
    }
    contact {
      email
      firstName
      id
      lastName
      phone
      primary
      role
      title
    }
    endsAt
    id
    externalId
    jobPhases {
      ...JobPhaseFragment
    }
    proposalStage {
      id
      name
    }
    proposal {
      id
      isChangeOrder
      status
    }
    changeOrders {
      id
      changeOrderJobId
      externalId
      status
      overallTotalAfterTaxes
    }
    proposedCostAdditional
    proposedCostDirect
    proposedCostEquipment
    proposedCostIndirect
    proposedCostLabour
    proposedCostMaterial
    proposedCostOverhead
    proposedCostTotal
    proposedGrossMargin
    proposedGrossMarginPercentage
    proposedNetMargin
    proposedNetMarginPercentage
    proposedOperatingMargin
    proposedOperatingMarginPercentage
    proposedOverallTotal
    proposedProfit
    proposedCostTransferTruck
    proposedProfitPercentage
    startsAt
    shouldPushTaxesToQuickbooks
    mayShowTaxNotification
    status
    notes
  }
}
    ${JobPhaseFragmentFragmentDoc}`;

/**
 * __useCustomGetJobQuery__
 *
 * To run a query within a React component, call `useCustomGetJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetJobQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomGetJobQuery(baseOptions: Apollo.QueryHookOptions<CustomGetJobQuery, CustomGetJobQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetJobQuery, CustomGetJobQueryVariables>(CustomGetJobDocument, options);
      }
export function useCustomGetJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetJobQuery, CustomGetJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetJobQuery, CustomGetJobQueryVariables>(CustomGetJobDocument, options);
        }
export type CustomGetJobQueryHookResult = ReturnType<typeof useCustomGetJobQuery>;
export type CustomGetJobLazyQueryHookResult = ReturnType<typeof useCustomGetJobLazyQuery>;
export type CustomGetJobQueryResult = Apollo.QueryResult<CustomGetJobQuery, CustomGetJobQueryVariables>;
export const CustomGetJobPhaseDocument = gql`
    query customGetJobPhase($id: ID!) {
  getJobPhase(id: $id) {
    ...JobPhaseFragment
  }
}
    ${JobPhaseFragmentFragmentDoc}`;

/**
 * __useCustomGetJobPhaseQuery__
 *
 * To run a query within a React component, call `useCustomGetJobPhaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetJobPhaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetJobPhaseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomGetJobPhaseQuery(baseOptions: Apollo.QueryHookOptions<CustomGetJobPhaseQuery, CustomGetJobPhaseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetJobPhaseQuery, CustomGetJobPhaseQueryVariables>(CustomGetJobPhaseDocument, options);
      }
export function useCustomGetJobPhaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetJobPhaseQuery, CustomGetJobPhaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetJobPhaseQuery, CustomGetJobPhaseQueryVariables>(CustomGetJobPhaseDocument, options);
        }
export type CustomGetJobPhaseQueryHookResult = ReturnType<typeof useCustomGetJobPhaseQuery>;
export type CustomGetJobPhaseLazyQueryHookResult = ReturnType<typeof useCustomGetJobPhaseLazyQuery>;
export type CustomGetJobPhaseQueryResult = Apollo.QueryResult<CustomGetJobPhaseQuery, CustomGetJobPhaseQueryVariables>;
export const CustomGetJobPhaseCostItemDocument = gql`
    query customGetJobPhaseCostItem($date: Date!, $jobPhaseId: ID!) {
  getJobPhaseCostItem(date: $date, jobPhaseId: $jobPhaseId) {
    additionalCosts {
      additionalCostId
      costTotal
      cost
      feeAmount
      feeType
      id
      jobPhaseCostItem {
        user {
          name
        }
        date
        costMaterial
        costEquipment
        costLabour
        costAdditional
        costTransferTruck
        additionalCosts {
          additionalCostId
          cost
          costTotal
          feeAmount
          feeType
          id
          name
        }
        employees {
          employeeId
          id
          name
          rate
          timeOnjob
          timeTravel
        }
        equipmentPieces {
          equipmentPieceId
          id
          name
          quantity
          rate
          timeOnjob
          timeTravel
        }
        id
        jobPhase {
          actualCostAdditional
          actualCostDirect
          actualCostEquipment
          actualCostIndirect
          actualCostLabour
          actualCostMaterial
          actualCostOverhead
          actualCostTotal
          actualEmployeeHours
          actualGrossMargin
          actualGrossMarginPercentage
          actualMaterialNeeded
          actualNetMargin
          actualNetMarginPercentage
          actualOperatingMargin
          actualOperatingMarginPercentage
          actualOverallTotal
          actualProfit
          actualProfitPercentage
          address
          applicableStatuses
          costItems {
            id
            plantId
            plantProductId
          }
          crew {
            color
            displayName
            id
            name
            rate
          }
          crewId
          defaultEmployees {
            firstName
            id
            lastName
            name
            rate
          }
          defaultEquipmentPieces {
            chargeType
            fuelSurcharge
            id
            name
            rate
            usePercentage
          }
          employees {
            employeeId
            id
            name
            rate
            timeOnjob
            timeTravel
          }
          endsAt
          files {
            createdAt
            filename
            id
            thumbnail
          }
          foremanUser {
            addressCity
            addressCountry
            addressLine1
            addressLine2
            addressState
            addressZip
            autoAssign
            avatar
            crewsCount
            email
            firstName
            id
            inviteToken
            invitedAt
            lastName
            name
            phone
            proposalCount
            roles
            status
          }
          id
          job {
            actualCostAdditional
            actualCostDirect
            actualCostEquipment
            actualCostIndirect
            actualCostLabour
            actualCostMaterial
            actualCostOverhead
            actualCostTotal
            actualGrossMargin
            actualGrossMarginPercentage
            actualNetMargin
            actualNetMarginPercentage
            actualOperatingMargin
            actualOperatingMarginPercentage
            actualOverallTotal
            actualProfit
            actualProfitPercentage
            endsAt
            id
            notes
            proposalId
            proposedCostAdditional
            proposedCostDirect
            proposedCostEquipment
            proposedCostIndirect
            proposedCostLabour
            proposedCostMaterial
            proposedCostOverhead
            proposedCostTotal
            proposedGrossMargin
            proposedGrossMarginPercentage
            proposedNetMargin
            proposedNetMarginPercentage
            proposedOperatingMargin
            proposedOperatingMarginPercentage
            proposedOverallTotal
            proposedProfit
            proposedProfitPercentage
            startsAt
            status
            userId
          }
          jobDuration
          jobSize
          notes
          organization {
            email
            emailTemplate
            failingPayment
            id
            logo
            name
            onTrial
            phone
            subscribed
            trialEndsAt
          }
          organizationProductType {
            id
            indirectPercentage
            markupPercentage
            name
            overheadPercentage
            type
          }
          organizationProductTypeName
          productName
          proposal {
            contactId
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            grossMargin
            grossMarginPercentage
            id
            isSendable
            layout
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            profit
            profitPercentage
            signedAt
            signedInitials
            signedName
            source
            status
            userId
            uuid
          }
          proposalProduct {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            grossMargin
            grossMarginPercentage
            id
            jobDuration
            jobSize
            mapData
            mapImage
            mapImageDirty
            measurementMaterial
            netMargin
            netMarginPercentage
            notes
            operatingMargin
            operatingMarginPercentage
            overallTotal
            productName
            profit
            profitPercentage
            transferTruckLoadTimeBuffer
            transferTruckRoundTripTime
            transferTruckRoundTripTimeOverride
            transferTruckUnloadTimeBuffer
            crews {
              cost
            }
          }
          proposalStage {
            costAdditional
            costDirect
            costEquipment
            costIndirect
            costLabour
            costMaterial
            costOverhead
            costTotal
            distanceMeters
            distanceSeconds
            grossMargin
            grossMarginPercentage
            id
            mapData
            mapImage
            mapImageDirty
            name
            netMargin
            netMarginPercentage
            operatingMargin
            operatingMarginPercentage
            overallTotal
            profit
            profitPercentage
          }
          proposedCostAdditional
          proposedCostDirect
          proposedCostEquipment
          proposedCostIndirect
          proposedCostLabour
          proposedCostMaterial
          proposedCostOverhead
          proposedCostTotal
          proposedEmployeeHours
          proposedGrossMargin
          proposedGrossMarginPercentage
          proposedMaterialNeeded
          proposedNetMargin
          proposedNetMarginPercentage
          proposedOperatingMargin
          proposedOperatingMarginPercentage
          proposedOverallTotal
          proposedProfit
          proposedProfitPercentage
          scheduleBlocks {
            blockLength
            endsAt
            id
            scheduledAt
            showTravelFrom
            showTravelTo
            travelTime
          }
          startsAt
          status
          travelTimeEstimate
        }
        material {
          costMaterial
          id
          jobPhaseCostItem {
            id
            plantId
            plantProductId
          }
          materialNeeded
          name
          organizationProductTypeName
          type
        }
        plantId
        plantProductId
        transferTrucks {
          hours
          id
          name
          plantTransferTruckId
          rateHourly
          rateTon
          tonnage
        }
        date
      }
      name
    }
    employees {
      employeeId
      id
      name
      rate
      timeOnjob
      timeTravel
    }
    equipmentPieces {
      equipmentPieceId
      id
      name
      quantity
      rate
      timeOnjob
      timeTravel
    }
    id
    jobPhase {
      actualCostAdditional
      actualCostDirect
      actualCostEquipment
      actualCostIndirect
      actualCostLabour
      actualCostMaterial
      actualCostOverhead
      actualCostTotal
      actualEmployeeHours
      actualGrossMargin
      actualGrossMarginPercentage
      actualMaterialNeeded
      actualNetMargin
      actualNetMarginPercentage
      actualOperatingMargin
      actualOperatingMarginPercentage
      actualOverallTotal
      actualProfit
      actualProfitPercentage
      address
      applicableStatuses
      crewId
      endsAt
      id
      jobDuration
      jobSize
      notes
      organizationProductTypeName
      productName
      proposedCostAdditional
      proposedCostDirect
      proposedCostEquipment
      proposedCostIndirect
      proposedCostLabour
      proposedCostMaterial
      proposedCostOverhead
      proposedCostTotal
      proposedEmployeeHours
      proposedGrossMargin
      proposedGrossMarginPercentage
      proposedMaterialNeeded
      proposedNetMargin
      proposedNetMarginPercentage
      proposedOperatingMargin
      proposedOperatingMarginPercentage
      proposedOverallTotal
      proposedProfit
      proposedProfitPercentage
      startsAt
      status
      travelTimeEstimate
      proposalProduct {
        costEquipment
        costMaterial
        costTransferTruck
        costLabour
        costAdditional
        costTotal
        crews {
          cost
        }
      }
    }
    material {
      costMaterial
      id
      materialNeeded
      name
      organizationProductTypeName
      type
    }
    transferTrucks {
      hours
      id
      name
      transferTruckId
      plantTransferTruckId
      rateHourly
      rateTon
      tonnage
    }
  }
}
    `;

/**
 * __useCustomGetJobPhaseCostItemQuery__
 *
 * To run a query within a React component, call `useCustomGetJobPhaseCostItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetJobPhaseCostItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetJobPhaseCostItemQuery({
 *   variables: {
 *      date: // value for 'date'
 *      jobPhaseId: // value for 'jobPhaseId'
 *   },
 * });
 */
export function useCustomGetJobPhaseCostItemQuery(baseOptions: Apollo.QueryHookOptions<CustomGetJobPhaseCostItemQuery, CustomGetJobPhaseCostItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetJobPhaseCostItemQuery, CustomGetJobPhaseCostItemQueryVariables>(CustomGetJobPhaseCostItemDocument, options);
      }
export function useCustomGetJobPhaseCostItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetJobPhaseCostItemQuery, CustomGetJobPhaseCostItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetJobPhaseCostItemQuery, CustomGetJobPhaseCostItemQueryVariables>(CustomGetJobPhaseCostItemDocument, options);
        }
export type CustomGetJobPhaseCostItemQueryHookResult = ReturnType<typeof useCustomGetJobPhaseCostItemQuery>;
export type CustomGetJobPhaseCostItemLazyQueryHookResult = ReturnType<typeof useCustomGetJobPhaseCostItemLazyQuery>;
export type CustomGetJobPhaseCostItemQueryResult = Apollo.QueryResult<CustomGetJobPhaseCostItemQuery, CustomGetJobPhaseCostItemQueryVariables>;
export const CustomGetJobPhaseForDropdownLazyDocument = gql`
    query CustomGetJobPhaseForDropdownLazy($id: ID!) {
  getJobPhase(id: $id) {
    id
    organizationProductTypeName
    address
    startsAt
    endsAt
    proposalStage {
      id
      name
    }
  }
}
    `;

/**
 * __useCustomGetJobPhaseForDropdownLazyQuery__
 *
 * To run a query within a React component, call `useCustomGetJobPhaseForDropdownLazyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetJobPhaseForDropdownLazyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetJobPhaseForDropdownLazyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomGetJobPhaseForDropdownLazyQuery(baseOptions: Apollo.QueryHookOptions<CustomGetJobPhaseForDropdownLazyQuery, CustomGetJobPhaseForDropdownLazyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetJobPhaseForDropdownLazyQuery, CustomGetJobPhaseForDropdownLazyQueryVariables>(CustomGetJobPhaseForDropdownLazyDocument, options);
      }
export function useCustomGetJobPhaseForDropdownLazyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetJobPhaseForDropdownLazyQuery, CustomGetJobPhaseForDropdownLazyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetJobPhaseForDropdownLazyQuery, CustomGetJobPhaseForDropdownLazyQueryVariables>(CustomGetJobPhaseForDropdownLazyDocument, options);
        }
export type CustomGetJobPhaseForDropdownLazyQueryHookResult = ReturnType<typeof useCustomGetJobPhaseForDropdownLazyQuery>;
export type CustomGetJobPhaseForDropdownLazyLazyQueryHookResult = ReturnType<typeof useCustomGetJobPhaseForDropdownLazyLazyQuery>;
export type CustomGetJobPhaseForDropdownLazyQueryResult = Apollo.QueryResult<CustomGetJobPhaseForDropdownLazyQuery, CustomGetJobPhaseForDropdownLazyQueryVariables>;
export const CustomGetJobPhasesDocument = gql`
    query customGetJobPhases($search: String, $searchByName: Boolean, $companyId: ID, $userId: ID, $foremanUserId: ID, $organizationProductTypeId: ID, $sortDirection: SortDirection, $sortKey: GetJobsSortKey, $first: Int!, $page: Int, $crewId: ID, $date: DateTime, $billingStatuses: [JobBillingStatus!]) {
  getJobPhases(
    search: $search
    searchByName: $searchByName
    companyId: $companyId
    userId: $userId
    foremanUserId: $foremanUserId
    organizationProductTypeId: $organizationProductTypeId
    sortDirection: $sortDirection
    sortKey: $sortKey
    first: $first
    page: $page
    crewId: $crewId
    date: $date
    billingStatuses: $billingStatuses
  ) {
    data {
      id
      externalId
      address
      proposalStage {
        name
        distanceSeconds
      }
      productName
      foremanUser {
        name
      }
      organization {
        name
      }
      jobSize
      travelTimeEstimate
      proposedMaterialNeeded
      organizationProductTypeName
      defaultAdditionalCosts {
        name
        id
      }
      defaultEquipmentPieces {
        name
        id
      }
      crew {
        name
        displayName
      }
      startsAt
      jobDuration
      job {
        id
        externalId
        company {
          name
        }
        contact {
          firstName
          lastName
          phone
        }
        address {
          line1
        }
        billingStatus
      }
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useCustomGetJobPhasesQuery__
 *
 * To run a query within a React component, call `useCustomGetJobPhasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetJobPhasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetJobPhasesQuery({
 *   variables: {
 *      search: // value for 'search'
 *      searchByName: // value for 'searchByName'
 *      companyId: // value for 'companyId'
 *      userId: // value for 'userId'
 *      foremanUserId: // value for 'foremanUserId'
 *      organizationProductTypeId: // value for 'organizationProductTypeId'
 *      sortDirection: // value for 'sortDirection'
 *      sortKey: // value for 'sortKey'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      crewId: // value for 'crewId'
 *      date: // value for 'date'
 *      billingStatuses: // value for 'billingStatuses'
 *   },
 * });
 */
export function useCustomGetJobPhasesQuery(baseOptions: Apollo.QueryHookOptions<CustomGetJobPhasesQuery, CustomGetJobPhasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetJobPhasesQuery, CustomGetJobPhasesQueryVariables>(CustomGetJobPhasesDocument, options);
      }
export function useCustomGetJobPhasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetJobPhasesQuery, CustomGetJobPhasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetJobPhasesQuery, CustomGetJobPhasesQueryVariables>(CustomGetJobPhasesDocument, options);
        }
export type CustomGetJobPhasesQueryHookResult = ReturnType<typeof useCustomGetJobPhasesQuery>;
export type CustomGetJobPhasesLazyQueryHookResult = ReturnType<typeof useCustomGetJobPhasesLazyQuery>;
export type CustomGetJobPhasesQueryResult = Apollo.QueryResult<CustomGetJobPhasesQuery, CustomGetJobPhasesQueryVariables>;
export const CustomGetJobPhasesForDropdownDocument = gql`
    query customGetJobPhasesForDropdown($search: String, $searchByName: Boolean, $companyId: ID, $userId: ID, $foremanUserId: ID, $organizationProductTypeId: ID, $sortDirection: SortDirection, $sortKey: GetJobsSortKey, $first: Int!, $page: Int, $crewId: ID, $date: DateTime, $billingStatuses: [JobBillingStatus!]) {
  getJobPhases(
    search: $search
    searchByName: $searchByName
    companyId: $companyId
    userId: $userId
    foremanUserId: $foremanUserId
    organizationProductTypeId: $organizationProductTypeId
    sortDirection: $sortDirection
    sortKey: $sortKey
    first: $first
    page: $page
    crewId: $crewId
    date: $date
    billingStatuses: $billingStatuses
  ) {
    data {
      id
      externalId
      address
      proposalStage {
        id
        name
        distanceSeconds
      }
      job {
        id
        company {
          id
          name
        }
      }
      productName
      organizationProductTypeName
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useCustomGetJobPhasesForDropdownQuery__
 *
 * To run a query within a React component, call `useCustomGetJobPhasesForDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetJobPhasesForDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetJobPhasesForDropdownQuery({
 *   variables: {
 *      search: // value for 'search'
 *      searchByName: // value for 'searchByName'
 *      companyId: // value for 'companyId'
 *      userId: // value for 'userId'
 *      foremanUserId: // value for 'foremanUserId'
 *      organizationProductTypeId: // value for 'organizationProductTypeId'
 *      sortDirection: // value for 'sortDirection'
 *      sortKey: // value for 'sortKey'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      crewId: // value for 'crewId'
 *      date: // value for 'date'
 *      billingStatuses: // value for 'billingStatuses'
 *   },
 * });
 */
export function useCustomGetJobPhasesForDropdownQuery(baseOptions: Apollo.QueryHookOptions<CustomGetJobPhasesForDropdownQuery, CustomGetJobPhasesForDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetJobPhasesForDropdownQuery, CustomGetJobPhasesForDropdownQueryVariables>(CustomGetJobPhasesForDropdownDocument, options);
      }
export function useCustomGetJobPhasesForDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetJobPhasesForDropdownQuery, CustomGetJobPhasesForDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetJobPhasesForDropdownQuery, CustomGetJobPhasesForDropdownQueryVariables>(CustomGetJobPhasesForDropdownDocument, options);
        }
export type CustomGetJobPhasesForDropdownQueryHookResult = ReturnType<typeof useCustomGetJobPhasesForDropdownQuery>;
export type CustomGetJobPhasesForDropdownLazyQueryHookResult = ReturnType<typeof useCustomGetJobPhasesForDropdownLazyQuery>;
export type CustomGetJobPhasesForDropdownQueryResult = Apollo.QueryResult<CustomGetJobPhasesForDropdownQuery, CustomGetJobPhasesForDropdownQueryVariables>;
export const CustomGetJobPhasesScheduleBlocksDocument = gql`
    query customGetJobPhasesScheduleBlocks($search: String, $companyId: ID, $userId: ID, $foremanUserId: ID, $organizationProductTypeId: ID, $sortDirection: SortDirection, $sortKey: GetJobsSortKey, $first: Int!, $page: Int, $crewId: ID, $date: DateTime!) {
  getJobPhases(
    search: $search
    companyId: $companyId
    userId: $userId
    foremanUserId: $foremanUserId
    organizationProductTypeId: $organizationProductTypeId
    sortDirection: $sortDirection
    sortKey: $sortKey
    first: $first
    page: $page
    crewId: $crewId
    date: $date
  ) {
    data {
      id
      externalId
      proposalStage {
        name
        distanceSeconds
      }
      productName
      foremanUser {
        name
      }
      organization {
        name
      }
      jobSize
      travelTimeEstimate
      proposedMaterialNeeded
      organizationProductTypeName
      defaultEquipmentPieces {
        name
        id
      }
      crew {
        name
        displayName
      }
      startsAt
      jobDuration
      job {
        id
        externalId
        company {
          name
        }
        contact {
          firstName
          lastName
          phone
        }
        address {
          line1
        }
      }
      scheduledBlockForDate {
        scheduledAt
        blockLength
      }
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useCustomGetJobPhasesScheduleBlocksQuery__
 *
 * To run a query within a React component, call `useCustomGetJobPhasesScheduleBlocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetJobPhasesScheduleBlocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetJobPhasesScheduleBlocksQuery({
 *   variables: {
 *      search: // value for 'search'
 *      companyId: // value for 'companyId'
 *      userId: // value for 'userId'
 *      foremanUserId: // value for 'foremanUserId'
 *      organizationProductTypeId: // value for 'organizationProductTypeId'
 *      sortDirection: // value for 'sortDirection'
 *      sortKey: // value for 'sortKey'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      crewId: // value for 'crewId'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useCustomGetJobPhasesScheduleBlocksQuery(baseOptions: Apollo.QueryHookOptions<CustomGetJobPhasesScheduleBlocksQuery, CustomGetJobPhasesScheduleBlocksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetJobPhasesScheduleBlocksQuery, CustomGetJobPhasesScheduleBlocksQueryVariables>(CustomGetJobPhasesScheduleBlocksDocument, options);
      }
export function useCustomGetJobPhasesScheduleBlocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetJobPhasesScheduleBlocksQuery, CustomGetJobPhasesScheduleBlocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetJobPhasesScheduleBlocksQuery, CustomGetJobPhasesScheduleBlocksQueryVariables>(CustomGetJobPhasesScheduleBlocksDocument, options);
        }
export type CustomGetJobPhasesScheduleBlocksQueryHookResult = ReturnType<typeof useCustomGetJobPhasesScheduleBlocksQuery>;
export type CustomGetJobPhasesScheduleBlocksLazyQueryHookResult = ReturnType<typeof useCustomGetJobPhasesScheduleBlocksLazyQuery>;
export type CustomGetJobPhasesScheduleBlocksQueryResult = Apollo.QueryResult<CustomGetJobPhasesScheduleBlocksQuery, CustomGetJobPhasesScheduleBlocksQueryVariables>;
export const CustomGetJobSchedulesDocument = gql`
    query customGetJobSchedules($crewId: ID, $dateFrom: DateTime, $dateUntil: DateTime, $jobIds: [ID!], $jobPhaseId: ID) {
  getJobSchedules(
    crewId: $crewId
    dateFrom: $dateFrom
    dateUntil: $dateUntil
    jobIds: $jobIds
    jobPhaseId: $jobPhaseId
  ) {
    blockLength
    crew {
      color
      displayName
      id
      name
      rate
    }
    endsAt
    id
    job {
      id
      datePushedToQuickbooks
      status
      company {
        name
      }
    }
    jobPhase {
      id
      productName
      status
      proposalProduct {
        material {
          id
          name
          productId
        }
      }
      organizationProductType {
        name
      }
      proposalStage {
        name
      }
      foremanUser {
        name
      }
      usersColor
    }
    scheduledAt
    showTravelFrom
    showTravelTo
    travelTime
  }
}
    `;

/**
 * __useCustomGetJobSchedulesQuery__
 *
 * To run a query within a React component, call `useCustomGetJobSchedulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetJobSchedulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetJobSchedulesQuery({
 *   variables: {
 *      crewId: // value for 'crewId'
 *      dateFrom: // value for 'dateFrom'
 *      dateUntil: // value for 'dateUntil'
 *      jobIds: // value for 'jobIds'
 *      jobPhaseId: // value for 'jobPhaseId'
 *   },
 * });
 */
export function useCustomGetJobSchedulesQuery(baseOptions?: Apollo.QueryHookOptions<CustomGetJobSchedulesQuery, CustomGetJobSchedulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetJobSchedulesQuery, CustomGetJobSchedulesQueryVariables>(CustomGetJobSchedulesDocument, options);
      }
export function useCustomGetJobSchedulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetJobSchedulesQuery, CustomGetJobSchedulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetJobSchedulesQuery, CustomGetJobSchedulesQueryVariables>(CustomGetJobSchedulesDocument, options);
        }
export type CustomGetJobSchedulesQueryHookResult = ReturnType<typeof useCustomGetJobSchedulesQuery>;
export type CustomGetJobSchedulesLazyQueryHookResult = ReturnType<typeof useCustomGetJobSchedulesLazyQuery>;
export type CustomGetJobSchedulesQueryResult = Apollo.QueryResult<CustomGetJobSchedulesQuery, CustomGetJobSchedulesQueryVariables>;
export const CustomGetJobsDocument = gql`
    query customGetJobs($companyId: ID, $multipleCompanyIDs: [ID!], $first: Int!, $jobIds: [ID!], $organizationProductTypeIds: [ID!], $page: Int, $search: String, $sortDirection: SortDirection, $sortKey: GetJobsSortKey, $statuses: [JobStatus!], $userId: ID, $billingStatuses: [JobBillingStatus!]) {
  getJobs(
    companyId: $companyId
    multipleCompanyIDs: $multipleCompanyIDs
    first: $first
    jobIds: $jobIds
    organizationProductTypeIds: $organizationProductTypeIds
    page: $page
    search: $search
    sortDirection: $sortDirection
    sortKey: $sortKey
    statuses: $statuses
    userId: $userId
    billingStatuses: $billingStatuses
  ) {
    data {
      jobPhases {
        id
        externalId
        applicableStatuses
        endsAt
        productName
        startsAt
        status
        organizationProductTypeName
        jobDuration
        foremanUser {
          id
          name
          firstName
          lastName
        }
        proposedOverallTotal
        actualOverallTotal
        scheduleBlocks {
          id
          scheduledAt
          endsAt
          blockLength
          showTravelTo
          showTravelFrom
          travelTime
        }
      }
      user {
        id
        firstName
        lastName
        name
      }
      actualOverallTotal
      foremanUser {
        id
        name
        firstName
        lastName
      }
      address {
        id
        line1
      }
      company {
        id
        name
      }
      contact {
        firstName
        id
        lastName
        phone
      }
      endsAt
      foremanUser {
        firstName
        id
        lastName
      }
      id
      externalId
      proposedOverallTotal
      startsAt
      endsAt
      status
      billingStatus
      proposal {
        wonAt
      }
      proposalStage {
        id
        name
      }
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useCustomGetJobsQuery__
 *
 * To run a query within a React component, call `useCustomGetJobsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetJobsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetJobsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      multipleCompanyIDs: // value for 'multipleCompanyIDs'
 *      first: // value for 'first'
 *      jobIds: // value for 'jobIds'
 *      organizationProductTypeIds: // value for 'organizationProductTypeIds'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      sortDirection: // value for 'sortDirection'
 *      sortKey: // value for 'sortKey'
 *      statuses: // value for 'statuses'
 *      userId: // value for 'userId'
 *      billingStatuses: // value for 'billingStatuses'
 *   },
 * });
 */
export function useCustomGetJobsQuery(baseOptions: Apollo.QueryHookOptions<CustomGetJobsQuery, CustomGetJobsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetJobsQuery, CustomGetJobsQueryVariables>(CustomGetJobsDocument, options);
      }
export function useCustomGetJobsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetJobsQuery, CustomGetJobsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetJobsQuery, CustomGetJobsQueryVariables>(CustomGetJobsDocument, options);
        }
export type CustomGetJobsQueryHookResult = ReturnType<typeof useCustomGetJobsQuery>;
export type CustomGetJobsLazyQueryHookResult = ReturnType<typeof useCustomGetJobsLazyQuery>;
export type CustomGetJobsQueryResult = Apollo.QueryResult<CustomGetJobsQuery, CustomGetJobsQueryVariables>;
export const CustomGetNotificationTriggerDocument = gql`
    query CustomGetNotificationTrigger($id: ID!) {
  getNotificationTrigger(id: $id) {
    ...NotificationTriggerFragment
  }
}
    ${NotificationTriggerFragmentFragmentDoc}`;

/**
 * __useCustomGetNotificationTriggerQuery__
 *
 * To run a query within a React component, call `useCustomGetNotificationTriggerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetNotificationTriggerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetNotificationTriggerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomGetNotificationTriggerQuery(baseOptions: Apollo.QueryHookOptions<CustomGetNotificationTriggerQuery, CustomGetNotificationTriggerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetNotificationTriggerQuery, CustomGetNotificationTriggerQueryVariables>(CustomGetNotificationTriggerDocument, options);
      }
export function useCustomGetNotificationTriggerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetNotificationTriggerQuery, CustomGetNotificationTriggerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetNotificationTriggerQuery, CustomGetNotificationTriggerQueryVariables>(CustomGetNotificationTriggerDocument, options);
        }
export type CustomGetNotificationTriggerQueryHookResult = ReturnType<typeof useCustomGetNotificationTriggerQuery>;
export type CustomGetNotificationTriggerLazyQueryHookResult = ReturnType<typeof useCustomGetNotificationTriggerLazyQuery>;
export type CustomGetNotificationTriggerQueryResult = Apollo.QueryResult<CustomGetNotificationTriggerQuery, CustomGetNotificationTriggerQueryVariables>;
export const CustomGetNotificationTriggersDocument = gql`
    query CustomGetNotificationTriggers {
  getNotificationTriggers {
    ...NotificationTriggerFragment
  }
}
    ${NotificationTriggerFragmentFragmentDoc}`;

/**
 * __useCustomGetNotificationTriggersQuery__
 *
 * To run a query within a React component, call `useCustomGetNotificationTriggersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetNotificationTriggersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetNotificationTriggersQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomGetNotificationTriggersQuery(baseOptions?: Apollo.QueryHookOptions<CustomGetNotificationTriggersQuery, CustomGetNotificationTriggersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetNotificationTriggersQuery, CustomGetNotificationTriggersQueryVariables>(CustomGetNotificationTriggersDocument, options);
      }
export function useCustomGetNotificationTriggersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetNotificationTriggersQuery, CustomGetNotificationTriggersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetNotificationTriggersQuery, CustomGetNotificationTriggersQueryVariables>(CustomGetNotificationTriggersDocument, options);
        }
export type CustomGetNotificationTriggersQueryHookResult = ReturnType<typeof useCustomGetNotificationTriggersQuery>;
export type CustomGetNotificationTriggersLazyQueryHookResult = ReturnType<typeof useCustomGetNotificationTriggersLazyQuery>;
export type CustomGetNotificationTriggersQueryResult = Apollo.QueryResult<CustomGetNotificationTriggersQuery, CustomGetNotificationTriggersQueryVariables>;
export const CustomGetOpportunityDocument = gql`
    query customGetOpportunity($id: ID!) {
  getOpportunity(id: $id) {
    addressCity
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZip
    companyId
    estimatedOpportunityValue
    projectFilesFolderId
    company {
      id
      name
      contacts {
        firstName
        id
        lastName
      }
    }
    contactId
    dueAt
    id
    externalId
    name
    notes
    products {
      id
    }
    source
    status
    statusId
    userId
  }
}
    `;

/**
 * __useCustomGetOpportunityQuery__
 *
 * To run a query within a React component, call `useCustomGetOpportunityQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetOpportunityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetOpportunityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomGetOpportunityQuery(baseOptions: Apollo.QueryHookOptions<CustomGetOpportunityQuery, CustomGetOpportunityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetOpportunityQuery, CustomGetOpportunityQueryVariables>(CustomGetOpportunityDocument, options);
      }
export function useCustomGetOpportunityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetOpportunityQuery, CustomGetOpportunityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetOpportunityQuery, CustomGetOpportunityQueryVariables>(CustomGetOpportunityDocument, options);
        }
export type CustomGetOpportunityQueryHookResult = ReturnType<typeof useCustomGetOpportunityQuery>;
export type CustomGetOpportunityLazyQueryHookResult = ReturnType<typeof useCustomGetOpportunityLazyQuery>;
export type CustomGetOpportunityQueryResult = Apollo.QueryResult<CustomGetOpportunityQuery, CustomGetOpportunityQueryVariables>;
export const CustomGetOrganizationEmailTemplateDocument = gql`
    query customGetOrganizationEmailTemplate($type: OrganizationEmailTemplateType!) {
  getOrganizationEmailTemplate(type: $type) {
    ...BitumioOrganizationEmailTemplate
  }
}
    ${BitumioOrganizationEmailTemplateFragmentDoc}`;

/**
 * __useCustomGetOrganizationEmailTemplateQuery__
 *
 * To run a query within a React component, call `useCustomGetOrganizationEmailTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetOrganizationEmailTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetOrganizationEmailTemplateQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCustomGetOrganizationEmailTemplateQuery(baseOptions: Apollo.QueryHookOptions<CustomGetOrganizationEmailTemplateQuery, CustomGetOrganizationEmailTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetOrganizationEmailTemplateQuery, CustomGetOrganizationEmailTemplateQueryVariables>(CustomGetOrganizationEmailTemplateDocument, options);
      }
export function useCustomGetOrganizationEmailTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetOrganizationEmailTemplateQuery, CustomGetOrganizationEmailTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetOrganizationEmailTemplateQuery, CustomGetOrganizationEmailTemplateQueryVariables>(CustomGetOrganizationEmailTemplateDocument, options);
        }
export type CustomGetOrganizationEmailTemplateQueryHookResult = ReturnType<typeof useCustomGetOrganizationEmailTemplateQuery>;
export type CustomGetOrganizationEmailTemplateLazyQueryHookResult = ReturnType<typeof useCustomGetOrganizationEmailTemplateLazyQuery>;
export type CustomGetOrganizationEmailTemplateQueryResult = Apollo.QueryResult<CustomGetOrganizationEmailTemplateQuery, CustomGetOrganizationEmailTemplateQueryVariables>;
export const CustomGetOrganizationEmailTemplatesDocument = gql`
    query customGetOrganizationEmailTemplates {
  getOrganizationEmailTemplates {
    ...BitumioOrganizationEmailTemplate
  }
}
    ${BitumioOrganizationEmailTemplateFragmentDoc}`;

/**
 * __useCustomGetOrganizationEmailTemplatesQuery__
 *
 * To run a query within a React component, call `useCustomGetOrganizationEmailTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetOrganizationEmailTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetOrganizationEmailTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomGetOrganizationEmailTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<CustomGetOrganizationEmailTemplatesQuery, CustomGetOrganizationEmailTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetOrganizationEmailTemplatesQuery, CustomGetOrganizationEmailTemplatesQueryVariables>(CustomGetOrganizationEmailTemplatesDocument, options);
      }
export function useCustomGetOrganizationEmailTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetOrganizationEmailTemplatesQuery, CustomGetOrganizationEmailTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetOrganizationEmailTemplatesQuery, CustomGetOrganizationEmailTemplatesQueryVariables>(CustomGetOrganizationEmailTemplatesDocument, options);
        }
export type CustomGetOrganizationEmailTemplatesQueryHookResult = ReturnType<typeof useCustomGetOrganizationEmailTemplatesQuery>;
export type CustomGetOrganizationEmailTemplatesLazyQueryHookResult = ReturnType<typeof useCustomGetOrganizationEmailTemplatesLazyQuery>;
export type CustomGetOrganizationEmailTemplatesQueryResult = Apollo.QueryResult<CustomGetOrganizationEmailTemplatesQuery, CustomGetOrganizationEmailTemplatesQueryVariables>;
export const CustomGetProductsDocument = gql`
    query customGetProducts($first: Int!, $orderBy: [QueryGetProductsOrderByOrderByClause!], $organizationProductTypeId: ID, $page: Int, $search: String, $type: ProductType) {
  getProducts(
    first: $first
    orderBy: $orderBy
    organizationProductTypeId: $organizationProductTypeId
    page: $page
    search: $search
    type: $type
  ) {
    data {
      dailyUnitsComplete
      id
      indirectPercentage
      labourCostType
      markupPercentage
      measurementJob
      measurementMaterial
      organizationProductType {
        name
      }
      name
      overheadPercentage
      statementOfWork
      type
      subcontracted
      unitPriceProduct
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useCustomGetProductsQuery__
 *
 * To run a query within a React component, call `useCustomGetProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetProductsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      orderBy: // value for 'orderBy'
 *      organizationProductTypeId: // value for 'organizationProductTypeId'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCustomGetProductsQuery(baseOptions: Apollo.QueryHookOptions<CustomGetProductsQuery, CustomGetProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetProductsQuery, CustomGetProductsQueryVariables>(CustomGetProductsDocument, options);
      }
export function useCustomGetProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetProductsQuery, CustomGetProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetProductsQuery, CustomGetProductsQueryVariables>(CustomGetProductsDocument, options);
        }
export type CustomGetProductsQueryHookResult = ReturnType<typeof useCustomGetProductsQuery>;
export type CustomGetProductsLazyQueryHookResult = ReturnType<typeof useCustomGetProductsLazyQuery>;
export type CustomGetProductsQueryResult = Apollo.QueryResult<CustomGetProductsQuery, CustomGetProductsQueryVariables>;
export const CustomGetProposalDocument = gql`
    query customGetProposal($id: ID!) {
  getProposal(id: $id) {
    ...BitumioProposal
  }
}
    ${BitumioProposalFragmentDoc}`;

/**
 * __useCustomGetProposalQuery__
 *
 * To run a query within a React component, call `useCustomGetProposalQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetProposalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetProposalQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomGetProposalQuery(baseOptions: Apollo.QueryHookOptions<CustomGetProposalQuery, CustomGetProposalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetProposalQuery, CustomGetProposalQueryVariables>(CustomGetProposalDocument, options);
      }
export function useCustomGetProposalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetProposalQuery, CustomGetProposalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetProposalQuery, CustomGetProposalQueryVariables>(CustomGetProposalDocument, options);
        }
export type CustomGetProposalQueryHookResult = ReturnType<typeof useCustomGetProposalQuery>;
export type CustomGetProposalLazyQueryHookResult = ReturnType<typeof useCustomGetProposalLazyQuery>;
export type CustomGetProposalQueryResult = Apollo.QueryResult<CustomGetProposalQuery, CustomGetProposalQueryVariables>;
export const CustomGetProposalsDocument = gql`
    query customGetProposals($companyId: ID, $multipleCompanyIDs: [ID!], $first: Int!, $organizationProductTypeIds: [ID!], $page: Int, $search: String, $sortDirection: SortDirection, $sortKey: GetProposalsSortKey, $statuses: [ProposalStatus!], $userId: ID, $multipleUserIDs: [ID!]) {
  getProposals(
    companyId: $companyId
    multipleCompanyIDs: $multipleCompanyIDs
    first: $first
    organizationProductTypeIds: $organizationProductTypeIds
    page: $page
    search: $search
    sortDirection: $sortDirection
    sortKey: $sortKey
    statuses: $statuses
    userId: $userId
    multipleUserIDs: $multipleUserIDs
  ) {
    data {
      company {
        email
        id
        name
      }
      contact {
        firstName
        id
        lastName
        phone
      }
      user {
        firstName
        id
        lastName
        name
      }
      stages {
        address {
          city
          country
          id
          latitude
          line1
          line2
          longitude
          mapImage
          organizationAddressId
          state
          zip
        }
        id
        name
        overallTotal
        proposalProducts {
          id
          productName
        }
      }
      id
      externalId
      status
      overallTotal
      userId
      uuid
      createdAt
      sentAt
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useCustomGetProposalsQuery__
 *
 * To run a query within a React component, call `useCustomGetProposalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetProposalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetProposalsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      multipleCompanyIDs: // value for 'multipleCompanyIDs'
 *      first: // value for 'first'
 *      organizationProductTypeIds: // value for 'organizationProductTypeIds'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      sortDirection: // value for 'sortDirection'
 *      sortKey: // value for 'sortKey'
 *      statuses: // value for 'statuses'
 *      userId: // value for 'userId'
 *      multipleUserIDs: // value for 'multipleUserIDs'
 *   },
 * });
 */
export function useCustomGetProposalsQuery(baseOptions: Apollo.QueryHookOptions<CustomGetProposalsQuery, CustomGetProposalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetProposalsQuery, CustomGetProposalsQueryVariables>(CustomGetProposalsDocument, options);
      }
export function useCustomGetProposalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetProposalsQuery, CustomGetProposalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetProposalsQuery, CustomGetProposalsQueryVariables>(CustomGetProposalsDocument, options);
        }
export type CustomGetProposalsQueryHookResult = ReturnType<typeof useCustomGetProposalsQuery>;
export type CustomGetProposalsLazyQueryHookResult = ReturnType<typeof useCustomGetProposalsLazyQuery>;
export type CustomGetProposalsQueryResult = Apollo.QueryResult<CustomGetProposalsQuery, CustomGetProposalsQueryVariables>;
export const CustomGetTimeEntriesDocument = gql`
    query customGetTimeEntries($first: Int!, $forDate: Date, $jobPhaseId: ID, $page: Int, $sortDirection: SortDirection, $sortKey: GetTimeEntriesSortKey, $userId: ID, $forDateStart: Date, $forDateEnd: Date) {
  getTimeEntries(
    first: $first
    forDate: $forDate
    jobPhaseId: $jobPhaseId
    page: $page
    sortDirection: $sortDirection
    sortKey: $sortKey
    userId: $userId
    forDateStart: $forDateStart
    forDateEnd: $forDateEnd
  ) {
    data {
      endTime
      forDate
      id
      jobPhase {
        id
        externalId
        address
        proposalStage {
          id
          name
        }
        job {
          id
          externalId
        }
      }
      clockInLatitude
      clockInLongitude
      clockOutLatitude
      clockOutLongitude
      notes
      organizationId
      startTime
      timeBucket {
        id
        name
        organizationId
      }
      timeTrackedSeconds
      timeTrackedSecondsOverride
      user {
        firstName
        id
        lastName
        name
      }
      uuid
    }
    paginatorInfo {
      count
      currentPage
      firstItem
      hasMorePages
      lastItem
      lastPage
      perPage
      total
    }
  }
}
    `;

/**
 * __useCustomGetTimeEntriesQuery__
 *
 * To run a query within a React component, call `useCustomGetTimeEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomGetTimeEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomGetTimeEntriesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      forDate: // value for 'forDate'
 *      jobPhaseId: // value for 'jobPhaseId'
 *      page: // value for 'page'
 *      sortDirection: // value for 'sortDirection'
 *      sortKey: // value for 'sortKey'
 *      userId: // value for 'userId'
 *      forDateStart: // value for 'forDateStart'
 *      forDateEnd: // value for 'forDateEnd'
 *   },
 * });
 */
export function useCustomGetTimeEntriesQuery(baseOptions: Apollo.QueryHookOptions<CustomGetTimeEntriesQuery, CustomGetTimeEntriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomGetTimeEntriesQuery, CustomGetTimeEntriesQueryVariables>(CustomGetTimeEntriesDocument, options);
      }
export function useCustomGetTimeEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomGetTimeEntriesQuery, CustomGetTimeEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomGetTimeEntriesQuery, CustomGetTimeEntriesQueryVariables>(CustomGetTimeEntriesDocument, options);
        }
export type CustomGetTimeEntriesQueryHookResult = ReturnType<typeof useCustomGetTimeEntriesQuery>;
export type CustomGetTimeEntriesLazyQueryHookResult = ReturnType<typeof useCustomGetTimeEntriesLazyQuery>;
export type CustomGetTimeEntriesQueryResult = Apollo.QueryResult<CustomGetTimeEntriesQuery, CustomGetTimeEntriesQueryVariables>;
export const CustomMeDocument = gql`
    query CustomMe {
  me {
    addressCity
    addressCountry
    addressLine1
    addressLine2
    addressState
    addressZip
    autoAssign
    avatar
    crewsCount
    email
    firstName
    id
    inviteToken
    invitedAt
    invitedBy {
      addressCity
      addressCountry
      addressLine1
      addressLine2
      addressState
      addressZip
      autoAssign
      avatar
      crewsCount
      email
      firstName
      id
      inviteToken
      invitedAt
      invitedBy {
        addressCity
        addressCountry
        addressLine1
        addressLine2
        addressState
        addressZip
        autoAssign
        avatar
        crewsCount
        email
        firstName
        id
        inviteToken
        invitedAt
        lastName
        name
        organization {
          documents {
            id
            name
            path
          }
          email
          emailTemplate
          failingPayment
          id
          linkedServices {
            active
            expired
            id
            service
            type
          }
          logo
          name
          onTrial
          phone
          subscribed
          subscription {
            endsAt
            id
            name
            quantity
            renewsAt
            stripeId
            stripePrice
            stripeStatus
            trialEndsAt
          }
          trialEndsAt
        }
        phone
        proposalCount
        roles
        status
      }
      lastName
      name
      phone
      proposalCount
      roles
      status
    }
    lastName
    name
    organization {
      email
      emailTemplate
      failingPayment
      id
      logo
      name
      onTrial
      phone
      subscribed
      trialEndsAt
      subscription {
        id
      }
      timezone
    }
    phone
    proposalCount
    roles
    permissions
    status
  }
}
    `;

/**
 * __useCustomMeQuery__
 *
 * To run a query within a React component, call `useCustomMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomMeQuery(baseOptions?: Apollo.QueryHookOptions<CustomMeQuery, CustomMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomMeQuery, CustomMeQueryVariables>(CustomMeDocument, options);
      }
export function useCustomMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomMeQuery, CustomMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomMeQuery, CustomMeQueryVariables>(CustomMeDocument, options);
        }
export type CustomMeQueryHookResult = ReturnType<typeof useCustomMeQuery>;
export type CustomMeLazyQueryHookResult = ReturnType<typeof useCustomMeLazyQuery>;
export type CustomMeQueryResult = Apollo.QueryResult<CustomMeQuery, CustomMeQueryVariables>;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "ProductAttributes": [
      "ProductAttributeAsphalt",
      "ProductAttributeConcreteColumn",
      "ProductAttributeConcreteCurbOrGutter",
      "ProductAttributeConcreteFlatwork",
      "ProductAttributeConcreteFooting",
      "ProductAttributeConcreteWall",
      "ProductAttributeConcreteWaterway",
      "ProductAttributeCrackSeal",
      "ProductAttributeCurbWall",
      "ProductAttributeExcavateOut",
      "ProductAttributeGrading",
      "ProductAttributeMastic",
      "ProductAttributeMicrosurfacing",
      "ProductAttributeSealCoat",
      "ProductAttributeSlurrySeal",
      "ProductAttributeStriping"
    ],
    "PublicProposalResponse": [
      "PublicProposal",
      "PublicProposalOrganization"
    ]
  }
};
      export default result;
    